import g, { useState as Y, useContext as O, useRef as T, useCallback as X, useEffect as ee, useMemo as K, forwardRef as te, createContext as G, useReducer as Hv, cloneElement as cu, isValidElement as Uv, version as jv } from "react";
import fu, { createPortal as zd, flushSync as lt } from "react-dom";
function st(...e) {
  return (...t) => {
    for (let n of e) typeof n == "function" && n(...t);
  };
}
const ue = typeof document < "u" ? g.useLayoutEffect : () => {
}, _a = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, Od = /* @__PURE__ */ g.createContext(_a), _v = /* @__PURE__ */ g.createContext(!1);
let Wv = !!(typeof window < "u" && window.document && window.document.createElement), zl = /* @__PURE__ */ new WeakMap();
function Gv(e = !1) {
  let t = O(Od), n = T(null);
  if (n.current === null && !e) {
    let r = (
      // @ts-ignore
      g.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED?.ReactCurrentOwner?.current
    );
    if (r) {
      let a = zl.get(r);
      a == null ? zl.set(r, {
        id: t.current,
        state: r.memoizedState
      }) : r.memoizedState !== a.state && (t.current = a.id, zl.delete(r));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function qv(e) {
  let t = O(Od);
  t === _a && !Wv && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = Gv(!!e), r = t === _a && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function Yv(e) {
  let t = g.useId(), [n] = Y(Ct()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${_a.prefix}`;
  return e || `${r}-${t}`;
}
const Zv = typeof g.useId == "function" ? Yv : qv;
function Xv() {
  return !1;
}
function Jv() {
  return !0;
}
function Qv(e) {
  return () => {
  };
}
function Ct() {
  return typeof g.useSyncExternalStore == "function" ? g.useSyncExternalStore(Qv, Xv, Jv) : O(_v);
}
function e5(e) {
  let [t, n] = Y(e), r = T(t), a = T(null), l = T(() => {
    if (!a.current) return;
    let u = a.current.next();
    if (u.done) {
      a.current = null;
      return;
    }
    r.current === u.value ? l.current() : n(u.value);
  });
  ue(() => {
    r.current = t, a.current && l.current();
  });
  let i = X((u) => {
    a.current = u(r.current), l.current();
  }, [
    l
  ]);
  return [
    t,
    i
  ];
}
let t5 = !!(typeof window < "u" && window.document && window.document.createElement), sr = /* @__PURE__ */ new Map(), Lr;
typeof FinalizationRegistry < "u" && (Lr = new FinalizationRegistry((e) => {
  sr.delete(e);
}));
function ce(e) {
  let [t, n] = Y(e), r = T(null), a = Zv(t), l = T(null);
  if (Lr && Lr.register(l, a), t5) {
    const i = sr.get(a);
    i && !i.includes(r) ? i.push(r) : sr.set(a, [
      r
    ]);
  }
  return ue(() => {
    let i = a;
    return () => {
      Lr && Lr.unregister(l), sr.delete(i);
    };
  }, [
    a
  ]), ee(() => {
    let i = r.current;
    return i && n(i), () => {
      i && (r.current = null);
    };
  }), a;
}
function n5(e, t) {
  if (e === t) return e;
  let n = sr.get(e);
  if (n)
    return n.forEach((a) => a.current = t), t;
  let r = sr.get(t);
  return r ? (r.forEach((a) => a.current = e), e) : t;
}
function yt(e = []) {
  let t = ce(), [n, r] = e5(t), a = X(() => {
    r(function* () {
      yield t, yield document.getElementById(t) ? t : void 0;
    });
  }, [
    t,
    r
  ]);
  return ue(a, [
    t,
    a,
    ...e
  ]), n;
}
function Pt(...e) {
  return e.length === 1 && e[0] ? e[0] : (t) => {
    let n = !1;
    const r = e.map((a) => {
      const l = _o(a, t);
      return n ||= typeof l == "function", l;
    });
    if (n) return () => {
      r.forEach((a, l) => {
        typeof a == "function" ? a() : _o(e[l], null);
      });
    };
  };
}
function _o(e, t) {
  if (typeof e == "function") return e(t);
  e != null && (e.current = t);
}
function Hd(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = Hd(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function r5() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = Hd(e)) && (r && (r += " "), r += t);
  return r;
}
function z(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let a in r) {
      let l = t[a], i = r[a];
      typeof l == "function" && typeof i == "function" && // This is a lot faster than a regex.
      a[0] === "o" && a[1] === "n" && a.charCodeAt(2) >= /* 'A' */
      65 && a.charCodeAt(2) <= /* 'Z' */
      90 ? t[a] = st(l, i) : (a === "className" || a === "UNSAFE_className") && typeof l == "string" && typeof i == "string" ? t[a] = r5(l, i) : a === "id" && l && i ? t.id = n5(l, i) : a === "ref" && l && i ? t.ref = Pt(l, i) : t[a] = i !== void 0 ? i : l;
    }
  }
  return t;
}
function $e(e) {
  const t = T(null), n = T(void 0), r = X((a) => {
    if (typeof e == "function") {
      const l = e, i = l(a);
      return () => {
        typeof i == "function" ? i() : l(null);
      };
    } else if (e)
      return e.current = a, () => {
        e.current = null;
      };
  }, [
    e
  ]);
  return K(() => ({
    get current() {
      return t.current;
    },
    set current(a) {
      t.current = a, n.current && (n.current(), n.current = void 0), a != null && (n.current = r(a));
    }
  }), [
    r
  ]);
}
const $t = /* @__PURE__ */ Symbol("default");
function me({ values: e, children: t }) {
  for (let [n, r] of e)
    t = /* @__PURE__ */ g.createElement(n.Provider, {
      value: r
    }, t);
  return t;
}
function le(e) {
  let { className: t, style: n, children: r, defaultClassName: a, defaultChildren: l, defaultStyle: i, values: u, render: o } = e;
  return K(() => {
    let d, s, c;
    return typeof t == "function" ? d = t({
      ...u,
      defaultClassName: a
    }) : d = t, typeof n == "function" ? s = n({
      ...u,
      defaultStyle: i || {}
    }) : s = n, typeof r == "function" ? c = r({
      ...u,
      defaultChildren: l
    }) : r == null ? c = l : c = r, {
      className: d ?? a,
      style: s || i ? {
        ...i,
        ...s
      } : void 0,
      children: c ?? l,
      "data-rac": "",
      render: o ? (f) => o(f, u) : void 0
    };
  }, [
    t,
    n,
    r,
    a,
    l,
    i,
    u,
    o
  ]);
}
function a5(e, t) {
  return (n) => t(typeof e == "function" ? e(n) : e, n);
}
function He(e, t) {
  let n = O(e);
  if (t === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = t || $t;
    if (!n.slots[r]) {
      let a = new Intl.ListFormat().format(Object.keys(n.slots).map((i) => `"${i}"`)), l = t ? `Invalid slot "${t}".` : "A slot prop is required.";
      throw new Error(`${l} Valid slot names are ${a}.`);
    }
    return n.slots[r];
  }
  return n;
}
function oe(e, t, n) {
  let r = He(n, e.slot) || {}, { ref: a, ...l } = r, i = $e(K(() => Pt(t, a), [
    t,
    a
  ])), u = z(l, e);
  return "style" in l && l.style && "style" in e && e.style && (typeof l.style == "function" || typeof e.style == "function" ? u.style = (o) => {
    let d = typeof l.style == "function" ? l.style(o) : l.style, s = {
      ...o.defaultStyle,
      ...d
    }, c = typeof e.style == "function" ? e.style({
      ...o,
      defaultStyle: s
    }) : e.style;
    return {
      ...s,
      ...c
    };
  } : u.style = {
    ...l.style,
    ...e.style
  }), [
    u,
    i
  ];
}
function Qe(e = !0) {
  let [t, n] = Y(e), r = T(!1), a = X((l) => {
    r.current = !0, n(!!l);
  }, []);
  return ue(() => {
    r.current || n(!1);
  }, []), [
    a,
    t
  ];
}
function wt(e) {
  const t = /^(data-.*)$/;
  let n = {};
  for (const r in e) t.test(r) || (n[r] = e[r]);
  return n;
}
function l5(e, t, n) {
  let { render: r, ...a } = t, l = T(null), i = K(() => Pt(n, l), [
    n,
    l
  ]);
  ue(() => {
    process.env.NODE_ENV !== "production" && r && (l.current ? l.current.localName !== e && console.warn(`Unexpected DOM element returned by custom \`render\` function. Expected <${e}>, got <${l.current.localName}>. This may break the component behavior and accessibility.`) : console.warn("Ref was not connected to DOM element returned by custom `render` function. Did you forget to pass through or merge the `ref`?"));
  }, [
    e,
    r
  ]);
  let u = {
    ...a,
    ref: i
  };
  return r ? r(u, void 0) : /* @__PURE__ */ g.createElement(e, u);
}
const Wo = {}, Q = new Proxy({}, {
  get(e, t) {
    if (typeof t != "string") return;
    let n = Wo[t];
    return n || (n = /* @__PURE__ */ te(l5.bind(null, t)), Wo[t] = n), n;
  }
}), Ud = "react-aria-clear-focus", $i = "react-aria-focus", he = (e) => e?.ownerDocument ?? document, Be = (e) => e && "window" in e && e.window === e ? e : he(e).defaultView || window;
function i5(e) {
  return e !== null && typeof e == "object" && "nodeType" in e && typeof e.nodeType == "number";
}
function u5(e) {
  return i5(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
}
let o5 = !1;
function _t() {
  return o5;
}
function ae(e, t) {
  if (!_t()) return t && e ? e.contains(t) : !1;
  if (!e || !t) return !1;
  let n = t;
  for (; n !== null; ) {
    if (n === e) return !0;
    n.tagName === "SLOT" && n.assignedSlot ? n = n.assignedSlot.parentNode : u5(n) ? n = n.host : n = n.parentNode;
  }
  return !1;
}
const se = (e = document) => {
  if (!_t()) return e.activeElement;
  let t = e.activeElement;
  for (; t && "shadowRoot" in t && t.shadowRoot?.activeElement; ) t = t.shadowRoot.activeElement;
  return t;
};
function W(e) {
  if (_t() && e.target instanceof Element && e.target.shadowRoot) {
    if ("composedPath" in e) return e.composedPath()[0] ?? null;
    if ("composedPath" in e.nativeEvent) return e.nativeEvent.composedPath()[0] ?? null;
  }
  return e.target;
}
function Yt(e) {
  if (!e) return !1;
  let t = e.getRootNode(), n = Be(e);
  if (!(t instanceof n.Document || t instanceof n.ShadowRoot)) return !1;
  let r = t.activeElement;
  return r != null && e.contains(r);
}
function hu(e) {
  let t = jd(he(e));
  t !== e && (t && vi(t, e), e && Wa(e, t));
}
function vi(e, t) {
  e.dispatchEvent(new FocusEvent("blur", {
    relatedTarget: t
  })), e.dispatchEvent(new FocusEvent("focusout", {
    bubbles: !0,
    relatedTarget: t
  }));
}
function Wa(e, t) {
  e.dispatchEvent(new FocusEvent("focus", {
    relatedTarget: t
  })), e.dispatchEvent(new FocusEvent("focusin", {
    bubbles: !0,
    relatedTarget: t
  }));
}
function jd(e) {
  let t = se(e), n = t?.getAttribute("aria-activedescendant");
  return n && e.getElementById(n) || t;
}
function Ae(e) {
  if (s5()) e.focus({
    preventScroll: !0
  });
  else {
    let t = d5(e);
    e.focus(), c5(t);
  }
}
let Ca = null;
function s5() {
  if (Ca == null) {
    Ca = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return Ca = !0, !0;
        }
      });
    } catch {
    }
  }
  return Ca;
}
function d5(e) {
  let t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function c5(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
const f5 = typeof Element < "u" && "checkVisibility" in Element.prototype;
function h5(e) {
  const t = Be(e);
  if (!(e instanceof t.HTMLElement) && !(e instanceof t.SVGElement)) return !1;
  let { display: n, visibility: r } = e.style, a = n !== "none" && r !== "hidden" && r !== "collapse";
  if (a) {
    const { getComputedStyle: l } = Be(e);
    let { display: i, visibility: u } = l(e);
    a = i !== "none" && u !== "hidden" && u !== "collapse";
  }
  return a;
}
function m5(e, t) {
  return !e.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !e.hasAttribute("data-react-aria-prevent-focus") && (e.nodeName === "DETAILS" && t && t.nodeName !== "SUMMARY" ? e.hasAttribute("open") : !0);
}
function mu(e, t) {
  return f5 ? e.checkVisibility({
    visibilityProperty: !0
  }) && !e.closest("[data-react-aria-prevent-focus]") : e.nodeName !== "#comment" && h5(e) && m5(e, t) && (!e.parentElement || mu(e.parentElement, e));
}
const bu = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])',
  "permission"
], b5 = bu.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
bu.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const p5 = bu.join(':not([hidden]):not([tabindex="-1"]),');
function pu(e, t) {
  return e.matches(b5) && !_d(e) && (t?.skipVisibilityCheck || mu(e));
}
function Ga(e) {
  return e.matches(p5) && mu(e) && !_d(e);
}
function _d(e) {
  let t = e;
  for (; t != null; ) {
    if (t instanceof Be(t).HTMLElement && t.inert) return !0;
    t = t.parentElement;
  }
  return !1;
}
function gu(e) {
  let t = e;
  return t.nativeEvent = e, t.isDefaultPrevented = () => t.defaultPrevented, t.isPropagationStopped = () => t.cancelBubble, t.persist = () => {
  }, t;
}
function Wd(e, t) {
  Object.defineProperty(e, "target", {
    value: t
  }), Object.defineProperty(e, "currentTarget", {
    value: t
  });
}
function Gd(e) {
  let t = T({
    isFocused: !1,
    observer: null
  });
  return ue(() => {
    const n = t.current;
    return () => {
      n.observer && (n.observer.disconnect(), n.observer = null);
    };
  }, []), X((n) => {
    let r = W(n);
    if (r instanceof HTMLButtonElement || r instanceof HTMLInputElement || r instanceof HTMLTextAreaElement || r instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let a = r, l = (i) => {
        if (t.current.isFocused = !1, a.disabled) {
          let u = gu(i);
          e?.(u);
        }
        t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      a.addEventListener("focusout", l, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && a.disabled) {
          t.current.observer?.disconnect();
          let i = a === se() ? null : se();
          a.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: i
          })), a.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: i
          }));
        }
      }), t.current.observer.observe(a, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    e
  ]);
}
let qa = !1;
function Go(e) {
  for (; e && !pu(e, {
    skipVisibilityCheck: !0
  }); ) e = e.parentElement;
  let t = Be(e), n = t.document.activeElement;
  if (!n || n === e) return;
  qa = !0;
  let r = !1, a = (s) => {
    (W(s) === n || r) && s.stopImmediatePropagation();
  }, l = (s) => {
    (W(s) === n || r) && (s.stopImmediatePropagation(), !e && !r && (r = !0, Ae(n), o()));
  }, i = (s) => {
    (W(s) === e || r) && s.stopImmediatePropagation();
  }, u = (s) => {
    (W(s) === e || r) && (s.stopImmediatePropagation(), r || (r = !0, Ae(n), o()));
  };
  t.addEventListener("blur", a, !0), t.addEventListener("focusout", l, !0), t.addEventListener("focusin", u, !0), t.addEventListener("focus", i, !0);
  let o = () => {
    cancelAnimationFrame(d), t.removeEventListener("blur", a, !0), t.removeEventListener("focusout", l, !0), t.removeEventListener("focusin", u, !0), t.removeEventListener("focus", i, !0), qa = !1, r = !1;
  }, d = requestAnimationFrame(o);
  return o;
}
function yl(e) {
  if (typeof window > "u" || window.navigator == null) return !1;
  let t = window.navigator.userAgentData?.brands;
  return Array.isArray(t) && t.some((n) => e.test(n.brand)) || e.test(window.navigator.userAgent);
}
function yu(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.userAgentData?.platform || window.navigator.platform) : !1;
}
function Xt(e) {
  if (process.env.NODE_ENV === "test") return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const mn = Xt(function() {
  return yu(/^Mac/i);
}), qd = Xt(function() {
  return yu(/^iPhone/i);
}), Yd = Xt(function() {
  return yu(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  mn() && navigator.maxTouchPoints > 1;
}), xt = Xt(function() {
  return qd() || Yd();
}), g5 = Xt(function() {
  return mn() || xt();
}), Zd = Xt(function() {
  return yl(/AppleWebKit/i) && !Xd();
}), Xd = Xt(function() {
  return yl(/Chrome/i);
}), bn = Xt(function() {
  return yl(/Android/i);
}), y5 = Xt(function() {
  return yl(/Firefox/i);
});
function Di(e) {
  return e.pointerType === "" && e.isTrusted ? !0 : bn() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function $5(e) {
  return !bn() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
const Jd = /* @__PURE__ */ G({
  isNative: !0,
  open: v5,
  useHref: (e) => e
});
function _9(e) {
  let { children: t, navigate: n, useHref: r } = e, a = K(() => ({
    isNative: !1,
    open: (l, i, u, o) => {
      ec(l, (d) => {
        Qd(d, i) ? n(u, o) : Nt(d, i);
      });
    },
    useHref: r || ((l) => l)
  }), [
    n,
    r
  ]);
  return /* @__PURE__ */ g.createElement(Jd.Provider, {
    value: a
  }, t);
}
function xr() {
  return O(Jd);
}
function Qd(e, t) {
  let n = e.getAttribute("target");
  return (!n || n === "_self") && e.origin === location.origin && !e.hasAttribute("download") && !t.metaKey && // open in new tab (mac)
  !t.ctrlKey && // open in new tab (windows)
  !t.altKey && // download
  !t.shiftKey;
}
function Nt(e, t, n = !0) {
  let { metaKey: r, ctrlKey: a, altKey: l, shiftKey: i } = t;
  y5() && window.event?.type?.startsWith("key") && e.target === "_blank" && (mn() ? r = !0 : a = !0);
  let u = Zd() && mn() && !Yd() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: r,
    ctrlKey: a,
    altKey: l,
    shiftKey: i
  }) : new MouseEvent("click", {
    metaKey: r,
    ctrlKey: a,
    altKey: l,
    shiftKey: i,
    detail: 1,
    bubbles: !0,
    cancelable: !0
  });
  Nt.isOpening = n, Ae(e), e.dispatchEvent(u), Nt.isOpening = !1;
}
Nt.isOpening = !1;
function ec(e, t) {
  if (e instanceof HTMLAnchorElement) t(e);
  else if (e.hasAttribute("data-href")) {
    let n = document.createElement("a");
    n.href = e.getAttribute("data-href"), e.hasAttribute("data-target") && (n.target = e.getAttribute("data-target")), e.hasAttribute("data-rel") && (n.rel = e.getAttribute("data-rel")), e.hasAttribute("data-download") && (n.download = e.getAttribute("data-download")), e.hasAttribute("data-ping") && (n.ping = e.getAttribute("data-ping")), e.hasAttribute("data-referrer-policy") && (n.referrerPolicy = e.getAttribute("data-referrer-policy")), e.appendChild(n), t(n), e.removeChild(n);
  }
}
function v5(e, t) {
  ec(e, (n) => Nt(n, t));
}
function $u(e) {
  const n = xr().useHref(e.href ?? "");
  return {
    "data-href": e.href ? n : void 0,
    "data-target": e.target,
    "data-rel": e.rel,
    "data-download": e.download,
    "data-ping": e.ping,
    "data-referrer-policy": e.referrerPolicy
  };
}
function $l(e) {
  const n = xr().useHref(e?.href ?? "");
  let r = {};
  if (e)
    for (let a of [
      "href",
      "target",
      "rel",
      "download",
      "ping",
      "referrerPolicy"
    ]) a in e && (r[a] = a === "href" ? n : e[a]);
  return r;
}
function tc(e, t, n, r) {
  !t.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
  !e.isDefaultPrevented() && Qd(e.currentTarget, e) && n && (e.preventDefault(), t.open(e.currentTarget, e, n, r));
}
let Zt = null, Er = "keyboard";
const qr = /* @__PURE__ */ new Set();
let jr = /* @__PURE__ */ new Map(), Nn = !1, xi = !1;
const D5 = {
  Tab: !0,
  Escape: !0
};
function vl(e, t) {
  for (let n of qr) n(e, t);
}
function x5(e) {
  return !(e.metaKey || !mn() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Ya(e) {
  Nn = !0, !Nt.isOpening && x5(e) && (Zt = "keyboard", Er = "keyboard", vl("keyboard", e));
}
function rt(e) {
  Zt = "pointer", Er = "pointerType" in e ? e.pointerType : "mouse", (e.type === "mousedown" || e.type === "pointerdown") && (Nn = !0, vl("pointer", e));
}
function nc(e) {
  !Nt.isOpening && Di(e) && (Nn = !0, Zt = "virtual", Er = "virtual");
}
function rc(e) {
  let t = Be(W(e)), n = he(W(e));
  W(e) === t || W(e) === n || qa || !e.isTrusted || (!Nn && !xi && (Zt = "virtual", Er = "virtual", vl("virtual", e)), Nn = !1, xi = !1);
}
function ac() {
  qa || (Nn = !1, xi = !0);
}
function Za(e) {
  if (typeof window > "u" || typeof document > "u") return;
  const t = Be(e), n = he(e);
  if (jr.get(t)) return;
  let r = t.HTMLElement.prototype.focus;
  Reflect.defineProperty(t.HTMLElement.prototype, "focus", {
    configurable: !0,
    writable: !0,
    value: function() {
      Nn = !0, r.apply(this, arguments);
    }
  }), n.addEventListener("keydown", Ya, !0), n.addEventListener("keyup", Ya, !0), n.addEventListener("click", nc, !0), t.addEventListener("focus", rc, !0), t.addEventListener("blur", ac, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", rt, !0), n.addEventListener("pointermove", rt, !0), n.addEventListener("pointerup", rt, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", rt, !0), n.addEventListener("mousemove", rt, !0), n.addEventListener("mouseup", rt, !0)), t.addEventListener("beforeunload", () => {
    lc(e);
  }, {
    once: !0
  }), jr.set(t, {
    focus: r
  });
}
const lc = (e, t) => {
  const n = Be(e), r = he(e);
  t && r.removeEventListener("DOMContentLoaded", t), jr.has(n) && (Reflect.defineProperty(n.HTMLElement.prototype, "focus", {
    configurable: !0,
    writable: !0,
    value: jr.get(n).focus
  }), r.removeEventListener("keydown", Ya, !0), r.removeEventListener("keyup", Ya, !0), r.removeEventListener("click", nc, !0), n.removeEventListener("focus", rc, !0), n.removeEventListener("blur", ac, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", rt, !0), r.removeEventListener("pointermove", rt, !0), r.removeEventListener("pointerup", rt, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", rt, !0), r.removeEventListener("mousemove", rt, !0), r.removeEventListener("mouseup", rt, !0)), jr.delete(n));
};
function E5(e) {
  const t = he(e);
  let n;
  return t.readyState !== "loading" ? Za(e) : (n = () => {
    Za(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => lc(e, n);
}
typeof document < "u" && E5();
function Vt() {
  return Zt !== "pointer";
}
function vt() {
  return Zt;
}
function Yr(e) {
  Zt = e, Er = e === "pointer" ? "mouse" : e, vl(e, null);
}
function C5() {
  return Er;
}
function Dl() {
  Za();
  let [e, t] = Y(Zt);
  return ee(() => {
    let n = () => {
      t(Zt);
    };
    return qr.add(n), () => {
      qr.delete(n);
    };
  }, []), Ct() ? null : e;
}
const P5 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function w5(e, t, n) {
  let r = n ? W(n) : void 0, a = he(r), l = Be(r);
  const i = typeof l < "u" ? l.HTMLInputElement : HTMLInputElement, u = typeof l < "u" ? l.HTMLTextAreaElement : HTMLTextAreaElement, o = typeof l < "u" ? l.HTMLElement : HTMLElement, d = typeof l < "u" ? l.KeyboardEvent : KeyboardEvent;
  let s = se(a);
  return e = e || s instanceof i && !P5.has(s.type) || s instanceof u || s instanceof o && s.isContentEditable, !(e && t === "keyboard" && n instanceof d && !D5[n.key]);
}
function S5(e, t, n) {
  Za(), ee(() => {
    if (n?.enabled === !1) return;
    let r = (a, l) => {
      w5(!!n?.isTextInput, a, l) && e(Vt());
    };
    return qr.add(r), () => {
      qr.delete(r);
    };
  }, t);
}
var ic = {};
ic = {
  collectionLabel: "مقترحات"
};
var uc = {};
uc = {
  collectionLabel: "Предложения"
};
var oc = {};
oc = {
  collectionLabel: "Návrhy"
};
var sc = {};
sc = {
  collectionLabel: "Forslag"
};
var dc = {};
dc = {
  collectionLabel: "Empfehlungen"
};
var cc = {};
cc = {
  collectionLabel: "Προτάσεις"
};
var fc = {};
fc = {
  collectionLabel: "Suggestions"
};
var hc = {};
hc = {
  collectionLabel: "Sugerencias"
};
var mc = {};
mc = {
  collectionLabel: "Soovitused"
};
var bc = {};
bc = {
  collectionLabel: "Ehdotukset"
};
var pc = {};
pc = {
  collectionLabel: "Suggestions"
};
var gc = {};
gc = {
  collectionLabel: "הצעות"
};
var yc = {};
yc = {
  collectionLabel: "Prijedlozi"
};
var $c = {};
$c = {
  collectionLabel: "Javaslatok"
};
var vc = {};
vc = {
  collectionLabel: "Suggerimenti"
};
var Dc = {};
Dc = {
  collectionLabel: "候補"
};
var xc = {};
xc = {
  collectionLabel: "제안"
};
var Ec = {};
Ec = {
  collectionLabel: "Pasiūlymai"
};
var Cc = {};
Cc = {
  collectionLabel: "Ieteikumi"
};
var Pc = {};
Pc = {
  collectionLabel: "Forslag"
};
var wc = {};
wc = {
  collectionLabel: "Suggesties"
};
var Sc = {};
Sc = {
  collectionLabel: "Sugestie"
};
var kc = {};
kc = {
  collectionLabel: "Sugestões"
};
var Bc = {};
Bc = {
  collectionLabel: "Sugestões"
};
var Fc = {};
Fc = {
  collectionLabel: "Sugestii"
};
var Ac = {};
Ac = {
  collectionLabel: "Предложения"
};
var Rc = {};
Rc = {
  collectionLabel: "Návrhy"
};
var Tc = {};
Tc = {
  collectionLabel: "Predlogi"
};
var Ic = {};
Ic = {
  collectionLabel: "Predlozi"
};
var Mc = {};
Mc = {
  collectionLabel: "Förslag"
};
var Kc = {};
Kc = {
  collectionLabel: "Öneriler"
};
var Nc = {};
Nc = {
  collectionLabel: "Пропозиції"
};
var Vc = {};
Vc = {
  collectionLabel: "建议"
};
var Lc = {};
Lc = {
  collectionLabel: "建議"
};
var zc = {};
zc = {
  "ar-AE": ic,
  "bg-BG": uc,
  "cs-CZ": oc,
  "da-DK": sc,
  "de-DE": dc,
  "el-GR": cc,
  "en-US": fc,
  "es-ES": hc,
  "et-EE": mc,
  "fi-FI": bc,
  "fr-FR": pc,
  "he-IL": gc,
  "hr-HR": yc,
  "hu-HU": $c,
  "it-IT": vc,
  "ja-JP": Dc,
  "ko-KR": xc,
  "lt-LT": Ec,
  "lv-LV": Cc,
  "nb-NO": Pc,
  "nl-NL": wc,
  "pl-PL": Sc,
  "pt-BR": kc,
  "pt-PT": Bc,
  "ro-RO": Fc,
  "ru-RU": Ac,
  "sk-SK": Rc,
  "sl-SI": Tc,
  "sr-SP": Ic,
  "sv-SE": Mc,
  "tr-TR": Kc,
  "uk-UA": Nc,
  "zh-CN": Vc,
  "zh-TW": Lc
};
function Fn(e) {
  return mn() ? e.metaKey : e.ctrlKey;
}
const k5 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function _r(e) {
  return e instanceof HTMLInputElement && !k5.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
const B5 = g.useInsertionEffect ?? ue;
function xe(e) {
  const t = T(null);
  return B5(() => {
    t.current = e;
  }, [
    e
  ]), X((...n) => {
    const r = t.current;
    return r?.(...n);
  }, []);
}
function bt(e, t, n, r) {
  let a = xe(n), l = n == null;
  ee(() => {
    if (l || !e.current) return;
    let i = e.current;
    return i.addEventListener(t, a, r), () => {
      i.removeEventListener(t, a, r);
    };
  }, [
    e,
    t,
    r,
    l
  ]);
}
function ut(e, t) {
  let { id: n, "aria-label": r, "aria-labelledby": a } = e;
  return n = ce(n), a && r ? a = [
    .../* @__PURE__ */ new Set([
      n,
      ...a.trim().split(/\s+/)
    ])
  ].join(" ") : a && (a = a.trim().split(/\s+/).join(" ")), !r && !a && t && (r = t), {
    id: n,
    "aria-label": r,
    "aria-labelledby": a
  };
}
const F5 = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), A5 = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function R5(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = (
      // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
      typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo
    );
    if (r) return r.direction === "rtl";
    if (n.script) return F5.has(n.script);
  }
  let t = e.split("-")[0];
  return A5.has(t);
}
const Oc = /* @__PURE__ */ Symbol.for("react-aria.i18n.locale");
function Hc() {
  let e = typeof window < "u" && window[Oc] || // @ts-ignore
  typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: R5(e) ? "rtl" : "ltr"
  };
}
let Ei = Hc(), zr = /* @__PURE__ */ new Set();
function qo() {
  Ei = Hc();
  for (let e of zr) e(Ei);
}
function T5() {
  let e = Ct(), [t, n] = Y(Ei);
  return ee(() => (zr.size === 0 && window.addEventListener("languagechange", qo), zr.add(n), () => {
    zr.delete(n), zr.size === 0 && window.removeEventListener("languagechange", qo);
  }), []), e ? {
    locale: typeof window < "u" && window[Oc] || "en-US",
    direction: "ltr"
  } : t;
}
const I5 = /* @__PURE__ */ g.createContext(null);
function de() {
  let e = T5();
  return O(I5) || e;
}
const M5 = /* @__PURE__ */ Symbol.for("react-aria.i18n.locale"), K5 = /* @__PURE__ */ Symbol.for("react-aria.i18n.strings");
let Pa;
class Dt {
  constructor(t, n = "en-US") {
    this.strings = Object.fromEntries(Object.entries(t).filter(([, r]) => r)), this.defaultLocale = n;
  }
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(t, n) {
    let a = this.getStringsForLocale(n)[t];
    if (!a) throw new Error(`Could not find intl message ${t} in ${n} locale`);
    return a;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(t) {
    let n = this.strings[t];
    return n || (n = N5(t, this.strings, this.defaultLocale), this.strings[t] = n), n;
  }
  static getGlobalDictionaryForPackage(t) {
    if (typeof window > "u") return null;
    let n = window[M5];
    if (Pa === void 0) {
      let a = window[K5];
      if (!a) return null;
      Pa = {};
      for (let l in a) Pa[l] = new Dt({
        [n]: a[l]
      }, n);
    }
    let r = Pa?.[t];
    if (!r) throw new Error(`Strings for package "${t}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return r;
  }
}
function N5(e, t, n = "en-US") {
  if (t[e]) return t[e];
  let r = V5(e);
  if (t[r]) return t[r];
  for (let a in t)
    if (a.startsWith(r + "-")) return t[a];
  return t[n];
}
function V5(e) {
  return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
const Yo = /* @__PURE__ */ new Map(), Zo = /* @__PURE__ */ new Map();
class vu {
  constructor(t, n) {
    this.locale = t, this.strings = n;
  }
  /** Formats a localized string for the given key with the provided variables. */
  format(t, n) {
    let r = this.strings.getStringForLocale(t, this.locale);
    return typeof r == "function" ? r(n, this) : r;
  }
  plural(t, n, r = "cardinal") {
    let a = n["=" + t];
    if (a) return typeof a == "function" ? a() : a;
    let l = this.locale + ":" + r, i = Yo.get(l);
    i || (i = new Intl.PluralRules(this.locale, {
      type: r
    }), Yo.set(l, i));
    let u = i.select(t);
    return a = n[u] || n.other, typeof a == "function" ? a() : a;
  }
  number(t) {
    let n = Zo.get(this.locale);
    return n || (n = new Intl.NumberFormat(this.locale), Zo.set(this.locale, n)), n.format(t);
  }
  select(t, n) {
    let r = t[n] || t.other;
    return typeof r == "function" ? r() : r;
  }
}
const Xo = /* @__PURE__ */ new WeakMap();
function L5(e) {
  let t = Xo.get(e);
  return t || (t = new Dt(e), Xo.set(e, t)), t;
}
function Uc(e, t) {
  return t && Dt.getGlobalDictionaryForPackage(t) || L5(e);
}
function Ee(e, t) {
  let { locale: n } = de(), r = Uc(e, t);
  return K(() => new vu(n, r), [
    n,
    r
  ]);
}
function z5(e) {
  return e && e.__esModule ? e.default : e;
}
function O5(e, t) {
  let { inputRef: n, collectionRef: r, filter: a, disableAutoFocusFirst: l = !1, disableVirtualFocus: i = !1 } = e, u = ce(), o = T(void 0), d = T(!1), s = T(null), c = vt() === "virtual" && (xt() || bn()), [f, h] = Y(!c && !i), [m, b] = Y(!1), [p, y] = Y(!1);
  ee(() => () => clearTimeout(o.current), []);
  let $ = xe((_) => {
    !_.isTrusted && f && n.current && se(he(n.current)) !== n.current && C5() !== "touch" && n.current.focus();
    let B = W(_);
    _.isTrusted || !B || s.current === B.id || (clearTimeout(o.current), B !== r.current ? d.current ? (s.current = B.id, o.current = setTimeout(() => {
      t.setFocusedNodeId(B.id);
    }, 500)) : (s.current = B.id, t.setFocusedNodeId(B.id)) : s.current && !document.getElementById(s.current) && (s.current = null, t.setFocusedNodeId(null)), d.current = !1);
  }), [v, x] = Y(null), E = X((_) => {
    x(_), _ != null ? (_.getAttribute("tabindex") != null && h(!1), b(!0)) : b(!1);
  }, []);
  ue(() => (v?.addEventListener("focusin", $), () => {
    v?.removeEventListener("focusin", $);
  }), [
    v
  ]);
  let P = $e(K(() => Pt(r, E), [
    r,
    E
  ])), C = X(() => {
    if (!r.current) {
      y(!0);
      return;
    }
    d.current = !0, r.current?.dispatchEvent(new CustomEvent($i, {
      cancelable: !0,
      bubbles: !0,
      detail: {
        focusStrategy: "first"
      }
    }));
  }, [
    r
  ]), M = X((_) => {
    y(!1), hu(se()), s.current = null, t.setFocusedNodeId(null);
    let B = new CustomEvent(Ud, {
      cancelable: !0,
      bubbles: !0,
      detail: {
        clearFocusKey: _
      }
    });
    clearTimeout(o.current), d.current = !1, r.current?.dispatchEvent(B);
  }, [
    r,
    t
  ]), F = T("");
  bt(n, "beforeinput", (_) => {
    let { inputType: B } = _;
    F.current = B;
  });
  let V = (_) => {
    (F.current === "insertText" || // IME composition (e.g. CJK input) reports 'insertCompositionText'/'insertFromComposition'
    // instead of 'insertText'. Treat these as forward typing so the first item gets virtual focus.
    F.current === "insertCompositionText" || F.current === "insertFromComposition") && !l ? C() : F.current && (F.current.includes("insert") || F.current.includes("delete") || F.current.includes("history")) && (M(!0), jd(document) === n.current && Wa(n.current, null)), t.setInputValue(_);
  }, I = T(null), A = (_) => {
    if (I.current = W(_), _.nativeEvent.isComposing) return;
    let B = s.current;
    switch (B !== null && he(n.current).getElementById(B) == null && (s.current = null, B = null), _.key) {
      case "a":
        if (Fn(_)) return;
        break;
      case "Escape":
        if (_.isDefaultPrevented()) return;
        break;
      case " ":
        return;
      case "Tab":
        "continuePropagation" in _ && _.continuePropagation();
        return;
      case "Home":
      case "End":
      case "PageDown":
      case "PageUp":
      case "ArrowUp":
      case "ArrowDown":
      case "ArrowRight":
      case "ArrowLeft": {
        if ((_.key === "Home" || _.key === "End") && B == null && _.shiftKey) return;
        if (_.key === "ArrowRight" || _.key === "ArrowLeft") {
          if (B == null) {
            _.isPropagationStopped() || _.stopPropagation();
            return;
          }
          break;
        }
        _.preventDefault();
        let Z = new CustomEvent($i, {
          cancelable: !0,
          bubbles: !0
        });
        r.current?.dispatchEvent(Z);
        break;
      }
    }
    _.isPropagationStopped() || _.stopPropagation();
    let L = !0;
    if (r.current !== null)
      if (B == null) L = r.current?.dispatchEvent(new KeyboardEvent(_.nativeEvent.type, _.nativeEvent)) || !1;
      else {
        let Z = document.getElementById(B);
        Z && (L = Z?.dispatchEvent(new KeyboardEvent(_.nativeEvent.type, _.nativeEvent)) || !1);
      }
    if (L) switch (_.key) {
      case "ArrowLeft":
      case "ArrowRight":
        M();
        break;
      case "Enter":
        B != null && document.getElementById(B)?.dispatchEvent(new PointerEvent("click", _.nativeEvent));
        break;
    }
    else
      _.preventDefault();
  }, U = xe((_) => {
    if (W(_) === I.current) {
      _.stopImmediatePropagation();
      let B = s.current;
      B == null ? r.current?.dispatchEvent(new KeyboardEvent(_.type, _)) : document.getElementById(B)?.dispatchEvent(new KeyboardEvent(_.type, _));
    }
  });
  ee(() => (document.addEventListener("keyup", U, !0), () => {
    document.removeEventListener("keyup", U, !0);
  }), []);
  let D = Ee(z5(zc), "@react-aria/autocomplete"), N = ut({
    id: u,
    "aria-label": D.format("collectionLabel")
  }), w = X((_, B) => a ? a(_, t.inputValue, B) : !0, [
    t.inputValue,
    a
  ]), R = (_) => {
    if (!_.isTrusted) return;
    let B = s.current ? document.getElementById(s.current) : null;
    B && vi(B, _.relatedTarget);
  }, H = (_) => {
    if (!_.isTrusted) return;
    if (s.current ? document.getElementById(s.current) : null) {
      let L = W(_);
      queueMicrotask(() => {
        vi(L, r.current), Wa(r.current, L);
      });
    }
  }, k = (_) => {
    _.button !== 0 || _.pointerType === "touch" || s.current == null || n.current == null || W(_) === n.current && M();
  }, S = {
    value: t.inputValue,
    onChange: V
  }, j = {
    onKeyDown: A,
    "aria-activedescendant": t.focusedNodeId ?? void 0,
    onBlur: R,
    onFocus: H,
    onPointerDown: k
  };
  return S = {
    ...S,
    ...f && m && j,
    enterKeyHint: "go",
    "aria-controls": m ? u : void 0,
    // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
    "aria-autocomplete": "list",
    // This disable's iOS's autocorrect suggestions, since the autocomplete provides its own suggestions.
    autoCorrect: "off",
    // This disable's the macOS Safari spell check auto corrections.
    spellCheck: "false",
    autoComplete: "off"
  }, {
    inputProps: S,
    collectionProps: z(N, {
      shouldUseVirtualFocus: f,
      disallowTypeAhead: f,
      autoFocus: p ? "first" : !1
    }),
    collectionRef: P,
    filter: a != null ? w : void 0
  };
}
const H5 = typeof document < "u" ? g.useInsertionEffect ?? g.useLayoutEffect : () => {
};
function we(e, t, n) {
  let [r, a] = Y(e || t), l = T(r), i = T(e !== void 0), u = e !== void 0;
  ee(() => {
    let c = i.current;
    c !== u && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${c ? "controlled" : "uncontrolled"} to ${u ? "controlled" : "uncontrolled"}.`), i.current = u;
  }, [
    u
  ]);
  let o = u ? e : r;
  H5(() => {
    l.current = o;
  });
  let [, d] = Hv(() => ({}), {}), s = X((c, ...f) => {
    let h = typeof c == "function" ? c(l.current) : c;
    Object.is(l.current, h) || (l.current = h, a(h), d(), n?.(h, ...f));
  }, [
    n
  ]);
  return [
    o,
    s
  ];
}
function U5(e) {
  let { onInputChange: t, inputValue: n, defaultInputValue: r = "" } = e, a = (d) => {
    t && t(d);
  }, [l, i] = Y(null), [u, o] = we(n, r, a);
  return {
    inputValue: u,
    setInputValue: o,
    focusedNodeId: l,
    setFocusedNodeId: i
  };
}
const j5 = /* @__PURE__ */ G(null), _5 = /* @__PURE__ */ G(null), Vn = /* @__PURE__ */ G(null), fa = /* @__PURE__ */ G(null);
function W9(e) {
  let t = He(j5, e.slot);
  e = z(t, e);
  let { filter: n, disableAutoFocusFirst: r } = e, a = U5(e), l = T(null), i = T(null), { inputProps: u, collectionProps: o, collectionRef: d, filter: s } = O5({
    ...wt(e),
    filter: n,
    disableAutoFocusFirst: r,
    inputRef: l,
    collectionRef: i
  }, a);
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        _5,
        a
      ],
      [
        fa,
        {
          ...u,
          ref: l
        }
      ],
      [
        Vn,
        {
          ...o,
          filter: s,
          ref: d
        }
      ]
    ]
  }, e.children);
}
class dt {
  constructor(t) {
    this.value = null, this.level = 0, this.hasChildNodes = !1, this.rendered = null, this.textValue = "", this["aria-label"] = void 0, this.index = 0, this.parentKey = null, this.prevKey = null, this.nextKey = null, this.firstChildKey = null, this.lastChildKey = null, this.props = {}, this.colSpan = null, this.colIndex = null, this.type = this.constructor.type, this.key = t;
  }
  get childNodes() {
    throw new Error("childNodes is not supported");
  }
  clone() {
    let t = new this.constructor(this.key);
    return t.value = this.value, t.level = this.level, t.hasChildNodes = this.hasChildNodes, t.rendered = this.rendered, t.textValue = this.textValue, t["aria-label"] = this["aria-label"], t.index = this.index, t.parentKey = this.parentKey, t.prevKey = this.prevKey, t.nextKey = this.nextKey, t.firstChildKey = this.firstChildKey, t.lastChildKey = this.lastChildKey, t.props = this.props, t.render = this.render, t.colSpan = this.colSpan, t.colIndex = this.colIndex, t;
  }
  filter(t, n, r) {
    let a = this.clone();
    return n.addDescendants(a, t), a;
  }
}
class xl extends dt {
  filter(t, n, r) {
    let [a, l] = _c(t, n, this.firstChildKey, r), i = this.clone();
    return i.firstChildKey = a, i.lastChildKey = l, i;
  }
}
const ko = class ko extends dt {
};
ko.type = "header";
let Ci = ko;
const Bo = class Bo extends dt {
};
Bo.type = "loader";
let Xa = Bo;
const Fo = class Fo extends xl {
  filter(t, n, r) {
    if (r(this.textValue, this)) {
      let a = this.clone();
      return n.addDescendants(a, t), a;
    }
    return null;
  }
};
Fo.type = "item";
let Zr = Fo;
const Ao = class Ao extends xl {
  filter(t, n, r) {
    let a = super.filter(t, n, r);
    if (a && a.lastChildKey !== null) {
      let l = t.getItem(a.lastChildKey);
      if (l && l.type !== "header") return a;
    }
    return null;
  }
};
Ao.type = "section";
let Pi = Ao;
class jc {
  get size() {
    return this.itemCount;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  *[Symbol.iterator]() {
    let t = this.firstKey != null ? this.keyMap.get(this.firstKey) : void 0;
    for (; t; )
      yield t, t = t.nextKey != null ? this.keyMap.get(t.nextKey) : void 0;
  }
  getChildren(t) {
    let n = this.keyMap;
    return {
      *[Symbol.iterator]() {
        let r = n.get(t), a = r?.firstChildKey != null ? n.get(r.firstChildKey) : null;
        for (; a; )
          yield a, a = a.nextKey != null ? n.get(a.nextKey) : void 0;
      }
    };
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    if (!n) return null;
    if (n.prevKey != null) {
      for (n = this.keyMap.get(n.prevKey); n && n.type !== "item" && n.lastChildKey != null; ) n = this.keyMap.get(n.lastChildKey);
      return n?.key ?? null;
    }
    return n.parentKey;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    if (!n) return null;
    if (n.type !== "item" && n.firstChildKey != null) return n.firstChildKey;
    for (; n; ) {
      if (n.nextKey != null) return n.nextKey;
      if (n.parentKey != null) n = this.keyMap.get(n.parentKey);
      else return null;
    }
    return null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    let t = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
    for (; t?.lastChildKey != null; ) t = this.keyMap.get(t.lastChildKey);
    return t?.key ?? null;
  }
  getItem(t) {
    return this.keyMap.get(t) ?? null;
  }
  at() {
    throw new Error("Not implemented");
  }
  clone() {
    let t = this.constructor, n = new t();
    return n.keyMap = new Map(this.keyMap), n.firstKey = this.firstKey, n.lastKey = this.lastKey, n.itemCount = this.itemCount, n;
  }
  addNode(t) {
    if (this.frozen) throw new Error("Cannot add a node to a frozen collection");
    t.type === "item" && this.keyMap.get(t.key) == null && this.itemCount++, this.keyMap.set(t.key, t);
  }
  // Deeply add a node and its children to the collection from another collection, primarily used when filtering a collection
  addDescendants(t, n) {
    this.addNode(t);
    let r = n.getChildren(t.key);
    for (let a of r) this.addDescendants(a, n);
  }
  removeNode(t) {
    if (this.frozen) throw new Error("Cannot remove a node to a frozen collection");
    let n = this.keyMap.get(t);
    n != null && n.type === "item" && this.itemCount--, this.keyMap.delete(t);
  }
  commit(t, n, r = !1) {
    if (this.frozen) throw new Error("Cannot commit a frozen collection");
    this.firstKey = t, this.lastKey = n, this.frozen = !r;
  }
  filter(t) {
    let n = new this.constructor(), [r, a] = _c(this, n, this.firstKey, t);
    return n?.commit(r, a), n;
  }
  constructor() {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.frozen = !1, this.itemCount = 0;
  }
}
function _c(e, t, n, r) {
  if (n == null) return [
    null,
    null
  ];
  let a = null, l = null, i = e.getItem(n);
  for (; i != null; ) {
    let u = i.filter(e, t, r);
    u != null && (u.nextKey = null, l && (u.prevKey = l.key, l.nextKey = u.key), a == null && (a = u), t.addNode(u), l = u), i = i.nextKey != null ? e.getItem(i.nextKey) : null;
  }
  if (l && l.type === "separator") {
    let u = l.prevKey;
    t.removeNode(l.key), u != null ? (l = t.getItem(u), l.nextKey = null) : l = null;
  }
  return [
    a?.key ?? null,
    l?.key ?? null
  ];
}
class Wc {
  constructor(t) {
    this._firstChild = null, this._lastChild = null, this._previousSibling = null, this._nextSibling = null, this._parentNode = null, this._minInvalidChildIndex = null, this.ownerDocument = t;
  }
  *[Symbol.iterator]() {
    let t = this.firstChild;
    for (; t; )
      yield t, t = t.nextSibling;
  }
  get firstChild() {
    return this._firstChild;
  }
  set firstChild(t) {
    this._firstChild = t, this.ownerDocument.markDirty(this);
  }
  get lastChild() {
    return this._lastChild;
  }
  set lastChild(t) {
    this._lastChild = t, this.ownerDocument.markDirty(this);
  }
  get previousSibling() {
    return this._previousSibling;
  }
  set previousSibling(t) {
    this._previousSibling = t, this.ownerDocument.markDirty(this);
  }
  get nextSibling() {
    return this._nextSibling;
  }
  set nextSibling(t) {
    this._nextSibling = t, this.ownerDocument.markDirty(this);
  }
  get parentNode() {
    return this._parentNode;
  }
  set parentNode(t) {
    this._parentNode = t, this.ownerDocument.markDirty(this);
  }
  get isConnected() {
    return this.parentNode?.isConnected || !1;
  }
  invalidateChildIndices(t) {
    (this._minInvalidChildIndex == null || !this._minInvalidChildIndex.isConnected || t.index < this._minInvalidChildIndex.index) && (this._minInvalidChildIndex = t, this.ownerDocument.markDirty(this));
  }
  updateChildIndices() {
    let t = this._minInvalidChildIndex;
    for (; t; )
      t.index = t.previousSibling ? t.previousSibling.index + 1 : 0, t = t.nextSibling;
    this._minInvalidChildIndex = null;
  }
  appendChild(t) {
    t.parentNode && t.parentNode.removeChild(t), this.firstChild == null && (this.firstChild = t), this.lastChild ? (this.lastChild.nextSibling = t, t.index = this.lastChild.index + 1, t.previousSibling = this.lastChild) : (t.previousSibling = null, t.index = 0), t.parentNode = this, t.nextSibling = null, this.lastChild = t, this.ownerDocument.markDirty(this), this.isConnected && this.ownerDocument.queueUpdate();
  }
  insertBefore(t, n) {
    if (n == null) return this.appendChild(t);
    t.parentNode && t.parentNode.removeChild(t), t.nextSibling = n, t.previousSibling = n.previousSibling, t.index = n.index - 1, this.firstChild === n ? this.firstChild = t : n.previousSibling && (n.previousSibling.nextSibling = t), n.previousSibling = t, t.parentNode = n.parentNode, this.invalidateChildIndices(t), this.isConnected && this.ownerDocument.queueUpdate();
  }
  removeChild(t) {
    t.parentNode === this && (this._minInvalidChildIndex === t && (this._minInvalidChildIndex = null), t.nextSibling && (this.invalidateChildIndices(t.nextSibling), t.nextSibling.previousSibling = t.previousSibling), t.previousSibling && (t.previousSibling.nextSibling = t.nextSibling), this.firstChild === t && (this.firstChild = t.nextSibling), this.lastChild === t && (this.lastChild = t.previousSibling), t.parentNode = null, t.nextSibling = null, t.previousSibling = null, t.index = 0, this.ownerDocument.markDirty(t), this.isConnected && this.ownerDocument.queueUpdate());
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  get previousVisibleSibling() {
    let t = this.previousSibling;
    for (; t && t.isHidden; ) t = t.previousSibling;
    return t;
  }
  get nextVisibleSibling() {
    let t = this.nextSibling;
    for (; t && t.isHidden; ) t = t.nextSibling;
    return t;
  }
  get firstVisibleChild() {
    let t = this.firstChild;
    for (; t && t.isHidden; ) t = t.nextSibling;
    return t;
  }
  get lastVisibleChild() {
    let t = this.lastChild;
    for (; t && t.isHidden; ) t = t.previousSibling;
    return t;
  }
}
class dr extends Wc {
  constructor(t, n) {
    super(n), this.nodeType = 8, this.isMutated = !0, this._index = 0, this.isHidden = !1, this.node = null;
  }
  get index() {
    return this._index;
  }
  set index(t) {
    this._index = t, this.ownerDocument.markDirty(this);
  }
  get level() {
    return this.parentNode instanceof dr ? this.parentNode.level + (this.parentNode.node?.type === "item" ? 1 : 0) : 0;
  }
  /**
  * Lazily gets a mutable instance of a Node. If the node has already
  * been cloned during this update cycle, it just returns the existing one.
  */
  getMutableNode() {
    return this.node == null ? null : (this.isMutated || (this.node = this.node.clone(), this.isMutated = !0), this.ownerDocument.markDirty(this), this.node);
  }
  updateNode() {
    let t = this.nextVisibleSibling, n = this.getMutableNode();
    if (n != null && (n.index = this.index, n.level = this.level, n.parentKey = this.parentNode instanceof dr ? this.parentNode.node?.key ?? null : null, n.prevKey = this.previousVisibleSibling?.node?.key ?? null, n.nextKey = t?.node?.key ?? null, n.hasChildNodes = !!this.firstChild, n.firstChildKey = this.firstVisibleChild?.node?.key ?? null, n.lastChildKey = this.lastVisibleChild?.node?.key ?? null, (n.colSpan != null || n.colIndex != null) && t)) {
      let r = (n.colIndex ?? n.index) + (n.colSpan ?? 1);
      if (t.node != null && r !== t.node.colIndex) {
        let a = t.getMutableNode();
        a.colIndex = r;
      }
    }
  }
  setProps(t, n, r, a, l) {
    let i, { value: u, textValue: o, id: d, ...s } = t;
    if (this.node == null ? (i = new r(d ?? `react-aria-${++this.ownerDocument.nodeId}`), this.node = i) : i = this.getMutableNode(), s.ref = n, i.props = s, i.rendered = a, i.render = l, i.value = u, t["aria-label"] && (i["aria-label"] = t["aria-label"]), i.textValue = o || (typeof s.children == "string" ? s.children : "") || t["aria-label"] || "", d != null && d !== i.key) throw new Error("Cannot change the id of an item");
    s.colSpan != null && (i.colSpan = s.colSpan), this.isConnected && this.ownerDocument.queueUpdate();
  }
  get style() {
    let t = this;
    return {
      get display() {
        return t.isHidden ? "none" : "";
      },
      set display(n) {
        let r = n === "none";
        if (t.isHidden !== r) {
          (t.parentNode?.firstVisibleChild === t || t.parentNode?.lastVisibleChild === t) && t.ownerDocument.markDirty(t.parentNode);
          let a = t.previousVisibleSibling, l = t.nextVisibleSibling;
          a && t.ownerDocument.markDirty(a), l && t.ownerDocument.markDirty(l), t.isHidden = r, t.ownerDocument.markDirty(t);
        }
      }
    };
  }
  hasAttribute() {
  }
  setAttribute() {
  }
  setAttributeNS() {
  }
  removeAttribute() {
  }
}
class W5 extends Wc {
  constructor(t) {
    super(null), this.nodeType = 11, this.ownerDocument = this, this.dirtyNodes = /* @__PURE__ */ new Set(), this.isSSR = !1, this.nodeId = 0, this.nodesByProps = /* @__PURE__ */ new WeakMap(), this.nextCollection = null, this.subscriptions = /* @__PURE__ */ new Set(), this.queuedRender = !1, this.inSubscription = !1, this.collection = t, this.nextCollection = t;
  }
  get isConnected() {
    return !0;
  }
  createElement(t) {
    return new dr(t, this);
  }
  getMutableCollection() {
    return this.nextCollection || (this.nextCollection = this.collection.clone()), this.nextCollection;
  }
  markDirty(t) {
    this.dirtyNodes.add(t);
  }
  addNode(t) {
    if (t.isHidden || t.node == null) return;
    let n = this.getMutableCollection();
    if (!n.getItem(t.node.key)) for (let r of t) this.addNode(r);
    n.addNode(t.node);
  }
  removeNode(t) {
    for (let n of t) this.removeNode(n);
    t.node && this.getMutableCollection().removeNode(t.node.key);
  }
  /** Finalizes the collection update, updating all nodes and freezing the collection. */
  getCollection() {
    return this.inSubscription ? this.collection : (this.queuedRender = !1, this.updateCollection(), this.collection);
  }
  updateCollection() {
    for (let t of this.dirtyNodes) t instanceof dr && (!t.isConnected || t.isHidden) ? this.removeNode(t) : t.updateChildIndices();
    for (let t of this.dirtyNodes) t instanceof dr ? (t.isConnected && !t.isHidden && (t.updateNode(), this.addNode(t)), t.node && this.dirtyNodes.delete(t), t.isMutated = !1) : this.dirtyNodes.delete(t);
    this.nextCollection && (this.nextCollection.commit(this.firstVisibleChild?.node?.key ?? null, this.lastVisibleChild?.node?.key ?? null, this.isSSR), this.isSSR || (this.collection = this.nextCollection, this.nextCollection = null));
  }
  queueUpdate() {
    if (!(this.dirtyNodes.size === 0 || this.queuedRender)) {
      this.queuedRender = !0, this.inSubscription = !0, this.isSSR || (this.collection = this.collection.clone());
      for (let t of this.subscriptions) t();
      this.inSubscription = !1;
    }
  }
  subscribe(t) {
    return this.subscriptions.add(t), () => this.subscriptions.delete(t);
  }
  resetAfterSSR() {
    this.isSSR && (this.isSSR = !1, this.firstChild = null, this.lastChild = null, this.nodeId = 0);
  }
}
function Du(e) {
  let { children: t, items: n, idScope: r, addIdAndValue: a, dependencies: l = [] } = e, i = K(() => process.env.NODE_ENV !== "production" && typeof t == "function" ? t.toString() : void 0, [
    t
  ]), u = K(() => /* @__PURE__ */ new WeakMap(), [
    ...l,
    i
  ]);
  return K(() => {
    if (n && typeof t == "function") {
      let o = [];
      for (let d of n) {
        let s = G5(d) ? d : null, c = s ? u.get(s) : null;
        if (!c) {
          c = t(d);
          let f = c.props.id ?? d?.key ?? d?.id;
          r != null && c.props.id == null && f != null && (f = r + ":" + f);
          let h = f ?? o.length;
          c = cu(c, a ? {
            key: h,
            id: f,
            value: d
          } : {
            key: h
          }), s && u.set(s, c);
        }
        o.push(c);
      }
      return o;
    } else if (typeof t != "function") return t;
  }, [
    t,
    n,
    u,
    r,
    a
  ]);
}
function G5(e) {
  switch (typeof e) {
    case "object":
      return e != null;
    case "function":
    case "symbol":
      return !0;
    default:
      return !1;
  }
}
let cn = /* @__PURE__ */ new Map(), wi = /* @__PURE__ */ new Set();
function Jo() {
  if (typeof window > "u") return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    let a = W(r);
    if (!e(r) || !a) return;
    let l = cn.get(a);
    l || (l = /* @__PURE__ */ new Set(), cn.set(a, l), a.addEventListener("transitioncancel", n, {
      once: !0
    })), l.add(r.propertyName);
  }, n = (r) => {
    let a = W(r);
    if (!e(r) || !a) return;
    let l = cn.get(a);
    if (l && (l.delete(r.propertyName), l.size === 0 && (a.removeEventListener("transitioncancel", n), cn.delete(a)), cn.size === 0)) {
      for (let i of wi) i();
      wi.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? Jo() : document.addEventListener("DOMContentLoaded", Jo));
function q5() {
  for (const [e] of cn)
    "isConnected" in e && !e.isConnected && cn.delete(e);
}
function Gc(e) {
  requestAnimationFrame(() => {
    q5(), cn.size === 0 ? e() : wi.add(e);
  });
}
function Se(e) {
  if (!e.isConnected) return;
  const t = he(e);
  if (vt() === "virtual") {
    let n = se(t);
    Gc(() => {
      const r = se(t);
      (r === n || r === t.body) && e.isConnected && Ae(e);
    });
  } else Ae(e);
}
function pr(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: a } = e;
  const l = X((o) => {
    if (W(o) === o.currentTarget)
      return r && r(o), a && a(!1), !0;
  }, [
    r,
    a
  ]), i = Gd(l), u = X((o) => {
    let d = W(o);
    const s = he(d), c = s ? se(s) : se();
    d === o.currentTarget && d === c && (n && n(o), a && a(!0), i(o));
  }, [
    a,
    n,
    i
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || a || r) ? u : void 0,
      onBlur: !t && (r || a) ? l : void 0
    }
  };
}
function Qo(e) {
  if (!e) return;
  let t = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        t && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : t = !0;
      },
      continuePropagation() {
        t = !1, typeof n.continuePropagation == "function" && n.continuePropagation();
      },
      isPropagationStopped() {
        return t;
      }
    };
    e(r), t && n.stopPropagation();
  };
}
function Cr(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: Qo(e.onKeyDown),
      onKeyUp: Qo(e.onKeyUp)
    }
  };
}
function xu(e, t) {
  ue(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
let Ja = /* @__PURE__ */ g.createContext(null);
function Y5(e) {
  let t = O(Ja) || {};
  xu(t, e);
  let { ref: n, ...r } = t;
  return r;
}
const Z5 = /* @__PURE__ */ g.forwardRef(function(t, n) {
  let { children: r, ...a } = t, l = $e(n), i = {
    ...a,
    ref: l
  };
  return /* @__PURE__ */ g.createElement(Ja.Provider, {
    value: i
  }, r);
});
function ct(e, t) {
  let { focusProps: n } = pr(e), { keyboardProps: r } = Cr(e), a = z(n, r), l = Y5(t), i = e.isDisabled ? {} : l, u = T(e.autoFocus);
  ee(() => {
    u.current && t.current && Se(t.current), u.current = !1;
  }, [
    t
  ]);
  let o = e.excludeFromTabOrder ? -1 : 0;
  return e.isDisabled && (o = void 0), {
    focusableProps: z({
      ...a,
      tabIndex: o
    }, i)
  };
}
const G9 = /* @__PURE__ */ te(({ children: e, ...t }, n) => {
  n = $e(n);
  let { focusableProps: r } = ct(t, n), a = g.Children.only(e);
  ee(() => {
    if (process.env.NODE_ENV === "production") return;
    let i = n.current;
    if (!i || !(i instanceof Be(i).Element)) {
      console.error("<Focusable> child must forward its ref to a DOM element.");
      return;
    }
    if (!t.isDisabled && !pu(i)) {
      console.warn("<Focusable> child must be focusable. Please ensure the tabIndex prop is passed through.");
      return;
    }
    if (i.localName !== "button" && i.localName !== "input" && i.localName !== "select" && i.localName !== "textarea" && i.localName !== "a" && i.localName !== "area" && i.localName !== "summary" && i.localName !== "img" && i.localName !== "svg") {
      let u = i.getAttribute("role");
      u ? (
        // https://w3c.github.io/aria/#widget_roles
        u !== "application" && u !== "button" && u !== "checkbox" && u !== "combobox" && u !== "gridcell" && u !== "link" && u !== "menuitem" && u !== "menuitemcheckbox" && u !== "menuitemradio" && u !== "option" && u !== "radio" && u !== "searchbox" && u !== "separator" && u !== "slider" && u !== "spinbutton" && u !== "switch" && u !== "tab" && u !== "tabpanel" && u !== "textbox" && u !== "treeitem" && // aria-describedby is also announced on these roles
        u !== "img" && u !== "meter" && u !== "progressbar" && console.warn(`<Focusable> child must have an interactive ARIA role. Got "${u}".`)
      ) : console.warn("<Focusable> child must have an interactive ARIA role.");
    }
  }, [
    n,
    t.isDisabled
  ]);
  let l = parseInt(g.version, 10) < 19 ? a.ref : a.props.ref;
  return /* @__PURE__ */ g.cloneElement(a, {
    ...z(r, a.props),
    // @ts-ignore
    ref: Pt(l, n)
  });
});
typeof HTMLTemplateElement < "u" && (Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
  configurable: !0,
  enumerable: !0,
  get: function() {
    return this.content.firstChild;
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "appendChild", {
  configurable: !0,
  enumerable: !0,
  value: function(e) {
    return this.content.appendChild(e);
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "removeChild", {
  configurable: !0,
  enumerable: !0,
  value: function(e) {
    return this.content.removeChild(e);
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "insertBefore", {
  configurable: !0,
  enumerable: !0,
  value: function(e, t) {
    return this.content.insertBefore(e, t);
  }
}));
const Qa = /* @__PURE__ */ G(!1);
function X5(e) {
  if (O(Qa))
    return /* @__PURE__ */ g.createElement(g.Fragment, null, e.children);
  let n = /* @__PURE__ */ g.createElement(Qa.Provider, {
    value: !0
  }, e.children);
  return /* @__PURE__ */ g.createElement("template", null, n);
}
function vn(e) {
  let t = (n, r) => O(Qa) ? null : e(n, r);
  return t.displayName = e.displayName || e.name, te(t);
}
function qc() {
  return O(Qa);
}
var wa = { exports: {} }, Ol = {};
var es;
function J5() {
  if (es) return Ol;
  es = 1;
  var e = g;
  function t(c, f) {
    return c === f && (c !== 0 || 1 / c === 1 / f) || c !== c && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, a = e.useEffect, l = e.useLayoutEffect, i = e.useDebugValue;
  function u(c, f) {
    var h = f(), m = r({ inst: { value: h, getSnapshot: f } }), b = m[0].inst, p = m[1];
    return l(
      function() {
        b.value = h, b.getSnapshot = f, o(b) && p({ inst: b });
      },
      [c, h, f]
    ), a(
      function() {
        return o(b) && p({ inst: b }), c(function() {
          o(b) && p({ inst: b });
        });
      },
      [c]
    ), i(h), h;
  }
  function o(c) {
    var f = c.getSnapshot;
    c = c.value;
    try {
      var h = f();
      return !n(c, h);
    } catch {
      return !0;
    }
  }
  function d(c, f) {
    return f();
  }
  var s = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? d : u;
  return Ol.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : s, Ol;
}
var Hl = {};
var ts;
function Q5() {
  return ts || (ts = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(h, m) {
      return h === m && (h !== 0 || 1 / h === 1 / m) || h !== h && m !== m;
    }
    function t(h, m) {
      s || a.startTransition === void 0 || (s = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var b = m();
      if (!c) {
        var p = m();
        l(b, p) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), c = !0);
      }
      p = i({
        inst: { value: b, getSnapshot: m }
      });
      var y = p[0].inst, $ = p[1];
      return o(
        function() {
          y.value = b, y.getSnapshot = m, n(y) && $({ inst: y });
        },
        [h, b, m]
      ), u(
        function() {
          return n(y) && $({ inst: y }), h(function() {
            n(y) && $({ inst: y });
          });
        },
        [h]
      ), d(b), b;
    }
    function n(h) {
      var m = h.getSnapshot;
      h = h.value;
      try {
        var b = m();
        return !l(h, b);
      } catch {
        return !0;
      }
    }
    function r(h, m) {
      return m();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var a = g, l = typeof Object.is == "function" ? Object.is : e, i = a.useState, u = a.useEffect, o = a.useLayoutEffect, d = a.useDebugValue, s = !1, c = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    Hl.useSyncExternalStore = a.useSyncExternalStore !== void 0 ? a.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), Hl;
}
var ns;
function e2() {
  return ns || (ns = 1, process.env.NODE_ENV === "production" ? wa.exports = J5() : wa.exports = Q5()), wa.exports;
}
var Eu = e2();
const Yc = /* @__PURE__ */ G(!1), Xr = /* @__PURE__ */ G(null);
function jn(e) {
  if (O(Xr))
    return e.content;
  let { collection: n, document: r } = a2(e.createCollection);
  return /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(X5, null, /* @__PURE__ */ g.createElement(Xr.Provider, {
    value: r
  }, e.content)), /* @__PURE__ */ g.createElement(t2, {
    render: e.children,
    collection: n
  }));
}
function t2({ collection: e, render: t }) {
  return t(e);
}
function n2(e, t, n) {
  let r = Ct(), a = T(r);
  a.current = r;
  let l = X(() => a.current ? n() : t(), [
    t,
    n
  ]);
  return Eu.useSyncExternalStore(e, l);
}
const r2 = typeof g.useSyncExternalStore == "function" ? g.useSyncExternalStore : n2;
function a2(e) {
  let [t] = Y(() => new W5(e?.() || new jc())), n = X((i) => t.subscribe(i), [
    t
  ]), r = X(() => {
    let i = t.getCollection();
    return t.isSSR && t.resetAfterSSR(), i;
  }, [
    t
  ]), a = X(() => (t.isSSR = !0, t.getCollection()), [
    t
  ]);
  return {
    collection: r2(n, r, a),
    document: t
  };
}
const Si = /* @__PURE__ */ G(null);
function l2(e) {
  var n;
  return n = class extends dt {
  }, n.type = e, n;
}
function Zc(e, t, n, r, a, l) {
  typeof e == "string" && (e = l2(e));
  let i = X((o) => {
    o?.setProps(t, n, e, r, l);
  }, [
    t,
    n,
    r,
    l,
    e
  ]), u = O(Si);
  if (u) {
    let o = u.ownerDocument.nodesByProps.get(t);
    return o || (o = u.ownerDocument.createElement(e.type), o.setProps(t, n, e, r, l), u.appendChild(o), u.ownerDocument.updateCollection(), u.ownerDocument.nodesByProps.set(t, o)), a ? /* @__PURE__ */ g.createElement(Si.Provider, {
      value: o
    }, a) : null;
  }
  return /* @__PURE__ */ g.createElement(e.type, {
    ref: i
  }, a);
}
function St(e, t) {
  let n = ({ node: a }) => t(a.props, a.props.ref, a), r = te((a, l) => {
    let i = O(Ja);
    if (!O(Yc)) {
      if (t.length >= 3) throw new Error(t.name + " cannot be rendered outside a collection.");
      return t(a, l);
    }
    return Zc(e, a, l, "children" in a ? a.children : null, null, (o) => (
      // Forward FocusableContext to real DOM tree so tooltips work.
      /* @__PURE__ */ g.createElement(Ja.Provider, {
        value: i
      }, /* @__PURE__ */ g.createElement(n, {
        node: o
      }))
    ));
  });
  return r.displayName = t.name, r;
}
function ha(e, t, n = Xc) {
  let r = ({ node: l }) => t(l.props, l.props.ref, l), a = te((l, i) => {
    let u = n(l);
    return Zc(e, l, i, null, u, (o) => /* @__PURE__ */ g.createElement(r, {
      node: o
    })) ?? /* @__PURE__ */ g.createElement(g.Fragment, null);
  });
  return a.displayName = t.name, a;
}
function Xc(e) {
  return Du({
    ...e,
    addIdAndValue: !0
  });
}
const rs = /* @__PURE__ */ G(null);
function Jt(e) {
  let t = O(rs), n = (t?.dependencies || []).concat(e.dependencies), r = e.idScope ?? t?.idScope, a = Xc({
    ...e,
    idScope: r,
    dependencies: n
  });
  return O(Xr) && (a = /* @__PURE__ */ g.createElement(i2, null, a)), t = K(
    () => ({
      dependencies: n,
      idScope: r
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      ...n
    ]
  ), /* @__PURE__ */ g.createElement(rs.Provider, {
    value: t
  }, a);
}
function i2({ children: e }) {
  let t = O(Xr), n = K(() => /* @__PURE__ */ g.createElement(Xr.Provider, {
    value: null
  }, /* @__PURE__ */ g.createElement(Yc.Provider, {
    value: !0
  }, e)), [
    e
  ]);
  return Ct() ? /* @__PURE__ */ g.createElement(Si.Provider, {
    value: t
  }, n) : /* @__PURE__ */ zd(n, t);
}
const Jc = /* @__PURE__ */ G(null), ma = {
  CollectionRoot({ collection: e, renderDropIndicator: t }) {
    return as(e, null, t);
  },
  CollectionBranch({ collection: e, parent: t, renderDropIndicator: n }) {
    return as(e, t, n);
  }
};
function as(e, t, n) {
  return Du({
    items: t ? e.getChildren(t.key) : e,
    dependencies: [
      n
    ],
    children(r) {
      if (r.type === "content") return /* @__PURE__ */ g.createElement(g.Fragment, null);
      let a = r.render(r);
      return !n || r.type !== "item" ? a : /* @__PURE__ */ g.createElement(g.Fragment, null, n({
        type: "item",
        key: r.key,
        dropPosition: "before"
      }), a, Qc(e, r, n));
    }
  });
}
function Qc(e, t, n) {
  let r = t.key, a = e.getKeyAfter(r), l = a != null ? e.getItem(a) : null;
  for (; l != null && l.type !== "item"; )
    a = e.getKeyAfter(l.key), l = a != null ? e.getItem(a) : null;
  let i = t.nextKey != null ? e.getItem(t.nextKey) : null;
  for (; i != null && i.type !== "item"; ) i = i.nextKey != null ? e.getItem(i.nextKey) : null;
  let u = [];
  if (i == null) {
    let o = t;
    for (; o?.type === "item" && (!l || o.parentKey !== l.parentKey && l.level < o.level); ) {
      let d = n({
        type: "item",
        key: o.key,
        dropPosition: "after"
      });
      /* @__PURE__ */ Uv(d) && u.push(/* @__PURE__ */ cu(d, {
        key: `${o.key}-after`
      })), o = o.parentKey != null ? e.getItem(o.parentKey) : null;
    }
  }
  return u;
}
const ge = /* @__PURE__ */ G(ma);
function Cu(e) {
  return K(() => e != null ? /* @__PURE__ */ new Set([
    e
  ]) : null, [
    e
  ]);
}
const u2 = /* @__PURE__ */ new Set([
  "id"
]), o2 = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), s2 = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), d2 = /* @__PURE__ */ new Set([
  "dir",
  "lang",
  "hidden",
  "inert",
  "translate"
]), ls = /* @__PURE__ */ new Set([
  "onClick",
  "onAuxClick",
  "onContextMenu",
  "onDoubleClick",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onPointerDown",
  "onPointerMove",
  "onPointerUp",
  "onPointerCancel",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerOver",
  "onPointerOut",
  "onGotPointerCapture",
  "onLostPointerCapture",
  "onScroll",
  "onWheel",
  "onAnimationStart",
  "onAnimationEnd",
  "onAnimationIteration",
  "onTransitionCancel",
  "onTransitionEnd",
  "onTransitionRun",
  "onTransitionStart"
]), c2 = /^(data-.*)$/;
function J(e, t = {}) {
  let { labelable: n, isLink: r, global: a, events: l = a, propNames: i } = t, u = {};
  for (const o in e) Object.prototype.hasOwnProperty.call(e, o) && (u2.has(o) || n && o2.has(o) || r && s2.has(o) || a && d2.has(o) || l && (ls.has(o) || o.endsWith("Capture") && ls.has(o.slice(0, -7))) || i?.has(o) || c2.test(o)) && (u[o] = e[o]);
  return u;
}
let ar = "default", ki = "", Na = /* @__PURE__ */ new WeakMap();
function Bi(e) {
  if (xt()) {
    if (ar === "default") {
      const t = he(e);
      ki = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    ar = "disabled";
  } else if (e instanceof HTMLElement || e instanceof SVGElement) {
    let t = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    Na.set(e, e.style[t]), e.style[t] = "none";
  }
}
function Va(e) {
  if (xt()) {
    if (ar !== "disabled") return;
    ar = "restoring", setTimeout(() => {
      Gc(() => {
        if (ar === "restoring") {
          const t = he(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = ki || ""), ki = "", ar = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && Na.has(e)) {
    let t = Na.get(e), n = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    e.style[n] === "none" && (e.style[n] = t), e.getAttribute("style") === "" && e.removeAttribute("style"), Na.delete(e);
  }
}
function is(e) {
  return e?.defaultView?.__webpack_nonce__ || globalThis.__webpack_nonce__ || void 0;
}
let Ul = /* @__PURE__ */ new WeakMap();
function ef(e) {
  let t = e ?? (typeof document < "u" ? document : void 0);
  if (!t) return is(t);
  if (Ul.has(t)) return Ul.get(t);
  let n = t.querySelector('meta[property="csp-nonce"]'), r = n && n instanceof Be(n).HTMLMetaElement && (n.nonce || n.content) || is(t) || void 0;
  return r !== void 0 && Ul.set(t, r), r;
}
const Jr = g.createContext({
  register: () => {
  }
});
Jr.displayName = "PressResponderContext";
function Qt() {
  let e = T(/* @__PURE__ */ new Map()), t = X((a, l, i, u) => {
    let o = u?.once ? (...d) => {
      e.current.delete(i), i(...d);
    } : i;
    e.current.set(i, {
      type: l,
      eventTarget: a,
      fn: o,
      options: u
    }), a.addEventListener(l, o, u);
  }, []), n = X((a, l, i, u) => {
    let o = e.current.get(i)?.fn || i;
    a.removeEventListener(l, o, u), e.current.delete(i);
  }, []), r = X(() => {
    e.current.forEach((a, l) => {
      n(a.eventTarget, a.type, l, a.options);
    });
  }, [
    n
  ]);
  return ee(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function f2(e) {
  let t = O(Jr);
  if (t) {
    let { register: n, ref: r, ...a } = t;
    e = z(a, e), n();
  }
  return xu(t, e.ref), e;
}
class Sa {
  #e;
  constructor(t, n, r, a) {
    this.#e = !0;
    const i = (a?.target ?? r.currentTarget)?.getBoundingClientRect();
    let u, o = 0, d, s = null;
    r.clientX != null && r.clientY != null && (d = r.clientX, s = r.clientY), i && (d != null && s != null ? (u = d - i.left, o = s - i.top) : (u = i.width / 2, o = i.height / 2)), this.type = t, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey, this.x = u, this.y = o, this.key = r.key;
  }
  continuePropagation() {
    this.#e = !1;
  }
  get shouldStopPropagation() {
    return this.#e;
  }
}
const us = /* @__PURE__ */ Symbol("linkClicked"), os = "react-aria-pressable-style", ss = "data-react-aria-pressable";
function Je(e) {
  let { onPress: t, onPressChange: n, onPressStart: r, onPressEnd: a, onPressUp: l, onClick: i, isDisabled: u, isPressed: o, preventFocusOnPress: d, shouldCancelOnPointerExit: s, allowTextSelectionOnPress: c, ref: f, ...h } = f2(e), [m, b] = Y(!1), p = T({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null,
    disposables: []
  }), { addGlobalListener: y, removeAllGlobalListeners: $ } = Qt(), v = X((D, N) => {
    let w = p.current;
    if (u || w.didFirePressStart) return !1;
    let R = !0;
    if (w.isTriggeringEvent = !0, r) {
      let H = new Sa("pressstart", N, D);
      r(H), R = H.shouldStopPropagation;
    }
    return n && n(!0), w.isTriggeringEvent = !1, w.didFirePressStart = !0, b(!0), R;
  }, [
    u,
    r,
    n
  ]), x = X((D, N, w = !0) => {
    let R = p.current;
    if (!R.didFirePressStart) return !1;
    R.didFirePressStart = !1, R.isTriggeringEvent = !0;
    let H = !0;
    if (a) {
      let k = new Sa("pressend", N, D);
      a(k), H = k.shouldStopPropagation;
    }
    if (n && n(!1), b(!1), t && w && !u) {
      let k = new Sa("press", N, D);
      t(k), H &&= k.shouldStopPropagation;
    }
    return R.isTriggeringEvent = !1, H;
  }, [
    u,
    a,
    n,
    t
  ]), E = xe(x), P = X((D, N) => {
    let w = p.current;
    if (u) return !1;
    if (l) {
      w.isTriggeringEvent = !0;
      let R = new Sa("pressup", N, D);
      return l(R), w.isTriggeringEvent = !1, R.shouldStopPropagation;
    }
    return !0;
  }, [
    u,
    l
  ]), C = xe(P), M = X((D) => {
    let N = p.current;
    if (N.isPressed && N.target) {
      N.didFirePressStart && N.pointerType != null && x(Cn(N.target, D), N.pointerType, !1), N.isPressed = !1, N.isOverTarget = !1, N.activePointerId = null, N.pointerType = null, $(), c || Va(N.target);
      for (let w of N.disposables) w();
      N.disposables = [];
    }
  }, [
    c,
    $,
    x
  ]), F = xe(M);
  ee(() => {
    u && p.current.isPressed && F({
      currentTarget: p.current.target,
      shiftKey: !1,
      ctrlKey: !1,
      metaKey: !1,
      altKey: !1
    });
  }, [
    u
  ]);
  let V = X((D) => {
    s && M(D);
  }, [
    s,
    M
  ]), I = X((D) => {
    u || i?.(D);
  }, [
    u,
    i
  ]), A = X((D, N) => {
    if (!u && i) {
      let w = new MouseEvent("click", D);
      Wd(w, N), i(gu(w));
    }
  }, [
    u,
    i
  ]), U = K(() => {
    let D = p.current, N = {
      onKeyDown(R) {
        if (jl(R.nativeEvent, R.currentTarget) && ae(R.currentTarget, W(R))) {
          fs(W(R), R.key) && R.preventDefault();
          let H = !0;
          !D.isPressed && !R.repeat && (D.target = R.currentTarget, D.isPressed = !0, D.pointerType = "keyboard", H = v(R, "keyboard"));
          let k = R.currentTarget, S = (j) => {
            jl(j, k) && !j.repeat && ae(k, W(j)) && D.target && C(Cn(D.target, j), "keyboard");
          };
          y(he(R.currentTarget), "keyup", st(S, w), !0), H && R.stopPropagation(), R.metaKey && mn() && D.metaKeyEvents?.set(R.key, R.nativeEvent);
        } else R.key === "Meta" && (D.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(R) {
        if (!(R && !ae(R.currentTarget, W(R))) && R && R.button === 0 && !D.isTriggeringEvent && !Nt.isOpening) {
          let H = !0;
          if (u && R.preventDefault(), !D.ignoreEmulatedMouseEvents && !D.isPressed && (D.pointerType === "virtual" || Di(R.nativeEvent))) {
            let k = v(R, "virtual"), S = C(R, "virtual"), j = E(R, "virtual");
            I(R), H = k && S && j;
          } else if (D.isPressed && D.pointerType !== "keyboard") {
            let k = D.pointerType || R.nativeEvent.pointerType || "virtual", S = C(Cn(R.currentTarget, R), k), j = E(Cn(R.currentTarget, R), k, !0);
            H = S && j, D.isOverTarget = !1, I(R), F(R);
          }
          D.ignoreEmulatedMouseEvents = !1, H && R.stopPropagation();
        }
      }
    }, w = (R) => {
      if (D.isPressed && D.target && jl(R, D.target)) {
        fs(W(R), R.key) && R.preventDefault();
        let H = W(R), k = ae(D.target, H);
        E(Cn(D.target, R), "keyboard", k), k && A(R, D.target), $(), R.key !== "Enter" && Pu(D.target) && ae(D.target, H) && !R[us] && (R[us] = !0, Nt(D.target, R, !1)), D.isPressed = !1, D.metaKeyEvents?.delete(R.key);
      } else if (R.key === "Meta" && D.metaKeyEvents?.size) {
        let H = D.metaKeyEvents;
        D.metaKeyEvents = void 0;
        for (let k of H.values()) D.target?.dispatchEvent(new KeyboardEvent("keyup", k));
      }
    };
    if (typeof PointerEvent < "u") {
      N.onPointerDown = (k) => {
        if (k.button !== 0 || !ae(k.currentTarget, W(k))) return;
        if ($5(k.nativeEvent)) {
          D.pointerType = "virtual";
          return;
        }
        D.pointerType = k.pointerType;
        let S = !0;
        if (!D.isPressed) {
          D.isPressed = !0, D.isOverTarget = !0, D.activePointerId = k.pointerId, D.target = k.currentTarget, c || Bi(D.target), S = v(k, D.pointerType);
          let j = W(k);
          "releasePointerCapture" in j && ("hasPointerCapture" in j ? j.hasPointerCapture(k.pointerId) && j.releasePointerCapture(k.pointerId) : j.releasePointerCapture(k.pointerId)), y(he(k.currentTarget), "pointerup", R, !1), y(he(k.currentTarget), "pointercancel", H, !1);
        }
        S && k.stopPropagation();
      }, N.onMouseDown = (k) => {
        if (ae(k.currentTarget, W(k)) && k.button === 0) {
          if (d) {
            let S = Go(k.target);
            S && D.disposables.push(S);
          }
          k.stopPropagation();
        }
      }, N.onPointerUp = (k) => {
        !ae(k.currentTarget, W(k)) || D.pointerType === "virtual" || k.button === 0 && !D.isPressed && C(k, D.pointerType || k.pointerType);
      }, N.onPointerEnter = (k) => {
        k.pointerId === D.activePointerId && D.target && !D.isOverTarget && D.pointerType != null && (D.isOverTarget = !0, v(Cn(D.target, k), D.pointerType));
      }, N.onPointerLeave = (k) => {
        k.pointerId === D.activePointerId && D.target && D.isOverTarget && D.pointerType != null && (D.isOverTarget = !1, E(Cn(D.target, k), D.pointerType, !1), V(k));
      };
      let R = (k) => {
        if (k.pointerId === D.activePointerId && D.isPressed && k.button === 0 && D.target) {
          if (ae(D.target, W(k)) && D.pointerType != null) {
            let S = !1, j = setTimeout(() => {
              D.isPressed && D.target instanceof HTMLElement && (S ? F(k) : (Ae(D.target), D.target.click()));
            }, 80);
            y(k.currentTarget, "click", () => S = !0, !0), D.disposables.push(() => clearTimeout(j));
          } else
            F(k);
          D.isOverTarget = !1;
        }
      }, H = (k) => {
        F(k);
      };
      N.onDragStart = (k) => {
        ae(k.currentTarget, W(k)) && F(k);
      };
    } else if (process.env.NODE_ENV === "test") {
      N.onMouseDown = (k) => {
        if (k.button !== 0 || !ae(k.currentTarget, W(k))) return;
        if (D.ignoreEmulatedMouseEvents) {
          k.stopPropagation();
          return;
        }
        if (D.isPressed = !0, D.isOverTarget = !0, D.target = k.currentTarget, D.pointerType = Di(k.nativeEvent) ? "virtual" : "mouse", lt(() => v(k, D.pointerType)) && k.stopPropagation(), d) {
          let j = Go(k.target);
          j && D.disposables.push(j);
        }
        y(he(k.currentTarget), "mouseup", R, !1);
      }, N.onMouseEnter = (k) => {
        if (!ae(k.currentTarget, W(k))) return;
        let S = !0;
        D.isPressed && !D.ignoreEmulatedMouseEvents && D.pointerType != null && (D.isOverTarget = !0, S = v(k, D.pointerType)), S && k.stopPropagation();
      }, N.onMouseLeave = (k) => {
        if (!ae(k.currentTarget, W(k))) return;
        let S = !0;
        D.isPressed && !D.ignoreEmulatedMouseEvents && D.pointerType != null && (D.isOverTarget = !1, S = E(k, D.pointerType, !1), V(k)), S && k.stopPropagation();
      }, N.onMouseUp = (k) => {
        ae(k.currentTarget, W(k)) && !D.ignoreEmulatedMouseEvents && k.button === 0 && !D.isPressed && C(k, D.pointerType || "mouse");
      };
      let R = (k) => {
        if (k.button === 0) {
          if (D.ignoreEmulatedMouseEvents) {
            D.ignoreEmulatedMouseEvents = !1;
            return;
          }
          D.target && ae(D.target, W(k)) && D.pointerType != null || F(k), D.isOverTarget = !1;
        }
      };
      N.onTouchStart = (k) => {
        if (!ae(k.currentTarget, W(k))) return;
        let S = h2(k.nativeEvent);
        if (!S) return;
        D.activePointerId = S.identifier, D.ignoreEmulatedMouseEvents = !0, D.isOverTarget = !0, D.isPressed = !0, D.target = k.currentTarget, D.pointerType = "touch", c || Bi(D.target), v(un(D.target, k), D.pointerType) && k.stopPropagation(), y(Be(k.currentTarget), "scroll", H, !0);
      }, N.onTouchMove = (k) => {
        if (!ae(k.currentTarget, W(k))) return;
        if (!D.isPressed) {
          k.stopPropagation();
          return;
        }
        let S = ds(k.nativeEvent, D.activePointerId), j = !0;
        S && cs(S, k.currentTarget) ? !D.isOverTarget && D.pointerType != null && (D.isOverTarget = !0, j = v(un(D.target, k), D.pointerType)) : D.isOverTarget && D.pointerType != null && (D.isOverTarget = !1, j = E(un(D.target, k), D.pointerType, !1), V(un(D.target, k))), j && k.stopPropagation();
      }, N.onTouchEnd = (k) => {
        if (!ae(k.currentTarget, W(k))) return;
        if (!D.isPressed) {
          k.stopPropagation();
          return;
        }
        let S = ds(k.nativeEvent, D.activePointerId), j = !0;
        S && cs(S, k.currentTarget) && D.pointerType != null ? (C(un(D.target, k), D.pointerType), j = E(un(D.target, k), D.pointerType), A(k.nativeEvent, D.target)) : D.isOverTarget && D.pointerType != null && (j = E(un(D.target, k), D.pointerType, !1)), j && k.stopPropagation(), D.isPressed = !1, D.activePointerId = null, D.isOverTarget = !1, D.ignoreEmulatedMouseEvents = !0, D.target && !c && Va(D.target), $();
      }, N.onTouchCancel = (k) => {
        ae(k.currentTarget, W(k)) && (k.stopPropagation(), D.isPressed && F(un(D.target, k)));
      };
      let H = (k) => {
        D.isPressed && ae(W(k), D.target) && F({
          currentTarget: D.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      N.onDragStart = (k) => {
        ae(k.currentTarget, W(k)) && F(k);
      };
    }
    return N;
  }, [
    y,
    u,
    d,
    $,
    c,
    V,
    v,
    I,
    A
  ]);
  return ee(() => {
    if (!f || process.env.NODE_ENV === "test") return;
    const D = he(f.current);
    if (!D || !D.head || D.getElementById(os)) return;
    const N = D.createElement("style");
    N.id = os;
    let w = ef(D);
    w && (N.nonce = w), N.textContent = `
@layer {
  [${ss}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim(), D.head.prepend(N);
  }, [
    f
  ]), ee(() => {
    let D = p.current;
    return () => {
      c || Va(D.target ?? void 0);
      for (let N of D.disposables) N();
      D.disposables = [];
    };
  }, [
    c
  ]), {
    isPressed: o || m,
    pressProps: z(h, U, {
      [ss]: !0
    })
  };
}
function Pu(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function jl(e, t) {
  const { key: n, code: r } = e, a = t, l = a.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(a instanceof Be(a).HTMLInputElement && !tf(a, n) || a instanceof Be(a).HTMLTextAreaElement || a.isContentEditable) && // Links should only trigger with Enter key
  !((l === "link" || !l && Pu(a)) && n !== "Enter");
}
function h2(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function ds(e, t) {
  const n = e.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const a = n[r];
    if (a.identifier === t) return a;
  }
  return null;
}
function un(e, t) {
  let n = 0, r = 0;
  return t.targetTouches && t.targetTouches.length === 1 && (n = t.targetTouches[0].clientX, r = t.targetTouches[0].clientY), {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function Cn(e, t) {
  let n = t.clientX, r = t.clientY;
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r,
    key: t.key
  };
}
function m2(e) {
  let t = 0, n = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? n = e.height / 2 : e.radiusY !== void 0 && (n = e.radiusY), {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function b2(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function cs(e, t) {
  let n = t.getBoundingClientRect(), r = m2(e);
  return b2(n, r);
}
function p2(e) {
  return e instanceof HTMLInputElement ? !1 : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !Pu(e);
}
function fs(e, t) {
  return e instanceof HTMLInputElement ? !tf(e, t) : p2(e);
}
const g2 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function tf(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : g2.has(e.type);
}
function y2(e, t) {
  let { elementType: n = "a", onPress: r, onPressStart: a, onPressEnd: l, onClick: i, isDisabled: u, ...o } = e, d = {};
  n !== "a" && (d = {
    role: "link",
    tabIndex: u ? void 0 : 0
  });
  let { focusableProps: s } = ct(e, t), { pressProps: c, isPressed: f } = Je({
    onPress: r,
    onPressStart: a,
    onPressEnd: l,
    onClick: i,
    isDisabled: u,
    ref: t
  }), h = J(o, {
    labelable: !0
  }), m = z(s, c), b = xr(), p = $l(e);
  return {
    isPressed: f,
    linkProps: z(h, p, {
      ...m,
      ...d,
      "aria-disabled": u || void 0,
      "aria-current": e["aria-current"],
      onClick: (y) => {
        c.onClick?.(y), tc(y, b, e.href, e.routerOptions);
      }
    })
  };
}
function ft(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: a } = e, l = T({
    isFocusWithin: !1
  }), { addGlobalListener: i, removeAllGlobalListeners: u } = Qt(), o = X((c) => {
    ae(c.currentTarget, W(c)) && l.current.isFocusWithin && !ae(c.currentTarget, c.relatedTarget) && (l.current.isFocusWithin = !1, u(), n && n(c), a && a(!1));
  }, [
    n,
    a,
    l,
    u
  ]), d = Gd(o), s = X((c) => {
    if (!ae(c.currentTarget, W(c))) return;
    let f = W(c);
    const h = he(f), m = se(h);
    if (!l.current.isFocusWithin && m === f) {
      r && r(c), a && a(!0), l.current.isFocusWithin = !0, d(c);
      let b = c.currentTarget;
      i(h, "focus", (p) => {
        let y = W(p);
        if (l.current.isFocusWithin && !ae(b, y)) {
          let $ = new h.defaultView.FocusEvent("blur", {
            relatedTarget: y
          });
          Wd($, b);
          let v = gu($);
          o(v);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    a,
    d,
    i,
    o
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: s,
      onBlur: o
    }
  };
}
function ye(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, a = T({
    isFocused: !1,
    isFocusVisible: t || Vt()
  }), [l, i] = Y(!1), [u, o] = Y(() => a.current.isFocused && a.current.isFocusVisible), d = X(() => o(a.current.isFocused && a.current.isFocusVisible), []), s = X((h) => {
    a.current.isFocused = h, a.current.isFocusVisible = Vt(), i(h), d();
  }, [
    d
  ]);
  S5((h) => {
    a.current.isFocusVisible = h, d();
  }, [
    n,
    l
  ], {
    enabled: l,
    isTextInput: n
  });
  let { focusProps: c } = pr({
    isDisabled: r,
    onFocusChange: s
  }), { focusWithinProps: f } = ft({
    isDisabled: !r,
    onFocusWithinChange: s
  });
  return {
    isFocused: l,
    isFocusVisible: u,
    focusProps: r ? f : c
  };
}
let el = !1, ka = 0;
function Fi() {
  el = !0, setTimeout(() => {
    el = !1;
  }, 500);
}
function hs(e) {
  e.pointerType === "touch" && Fi();
}
function $2() {
  let e = he(null);
  if (!(typeof e > "u"))
    return ka === 0 && (typeof PointerEvent < "u" ? e.addEventListener("pointerup", hs) : process.env.NODE_ENV === "test" && e.addEventListener("touchend", Fi)), ka++, () => {
      ka--, !(ka > 0) && (typeof PointerEvent < "u" ? e.removeEventListener("pointerup", hs) : process.env.NODE_ENV === "test" && e.removeEventListener("touchend", Fi));
    };
}
function De(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: a } = e, [l, i] = Y(!1), u = T({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  ee($2, []);
  let { addGlobalListener: o, removeAllGlobalListeners: d } = Qt(), { hoverProps: s, triggerHoverEnd: c } = K(() => {
    let f = (b, p) => {
      if (u.pointerType = p, a || p === "touch" || u.isHovered || !ae(b.currentTarget, W(b))) return;
      u.isHovered = !0;
      let y = b.currentTarget;
      u.target = y, o(he(W(b)), "pointerover", ($) => {
        u.isHovered && u.target && !ae(u.target, W($)) && h($, $.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: y,
        pointerType: p
      }), n && n(!0), i(!0);
    }, h = (b, p) => {
      let y = u.target;
      u.pointerType = "", u.target = null, !(p === "touch" || !u.isHovered || !y) && (u.isHovered = !1, d(), r && r({
        type: "hoverend",
        target: y,
        pointerType: p
      }), n && n(!1), i(!1));
    }, m = {};
    return typeof PointerEvent < "u" ? (m.onPointerEnter = (b) => {
      el && b.pointerType === "mouse" || f(b, b.pointerType);
    }, m.onPointerLeave = (b) => {
      !a && ae(b.currentTarget, W(b)) && h(b, b.pointerType);
    }) : process.env.NODE_ENV === "test" && (m.onTouchStart = () => {
      u.ignoreEmulatedMouseEvents = !0;
    }, m.onMouseEnter = (b) => {
      !u.ignoreEmulatedMouseEvents && !el && f(b, "mouse"), u.ignoreEmulatedMouseEvents = !1;
    }, m.onMouseLeave = (b) => {
      !a && ae(b.currentTarget, W(b)) && h(b, "mouse");
    }), {
      hoverProps: m,
      triggerHoverEnd: h
    };
  }, [
    t,
    n,
    r,
    a,
    u,
    o,
    d
  ]);
  return ee(() => {
    a && c({
      currentTarget: u.target
    }, u.pointerType);
  }, [
    a
  ]), {
    hoverProps: s,
    isHovered: l
  };
}
const nf = /* @__PURE__ */ G(null), q9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, nf);
  let r = t.href && !t.isDisabled ? "a" : "span", { linkProps: a, isPressed: l } = y2({
    ...t,
    elementType: r
  }, n), i = Q[r], { hoverProps: u, isHovered: o } = De(t), { focusProps: d, isFocused: s, isFocusVisible: c } = ye(), f = le({
    ...t,
    defaultClassName: "react-aria-Link",
    values: {
      isCurrent: !!t["aria-current"],
      isDisabled: t.isDisabled || !1,
      isPressed: l,
      isHovered: o,
      isFocused: s,
      isFocusVisible: c
    }
  }), h = J(t, {
    global: !0
  });
  return delete h.onClick, /* @__PURE__ */ g.createElement(i, {
    ref: n,
    slot: t.slot || void 0,
    ...z(h, f, a, u, d),
    "data-focused": s || void 0,
    "data-hovered": o || void 0,
    "data-pressed": l || void 0,
    "data-focus-visible": c || void 0,
    "data-current": !!t["aria-current"] || void 0,
    "data-disabled": t.isDisabled || void 0
  }, f.children);
});
var rf = {};
rf = {
  breadcrumbs: "عناصر الواجهة"
};
var af = {};
af = {
  breadcrumbs: "Трохи хляб"
};
var lf = {};
lf = {
  breadcrumbs: "Popis cesty"
};
var uf = {};
uf = {
  breadcrumbs: "Brødkrummer"
};
var of = {};
of = {
  breadcrumbs: "Breadcrumbs"
};
var sf = {};
sf = {
  breadcrumbs: "Πλοηγήσεις breadcrumb"
};
var df = {};
df = {
  breadcrumbs: "Breadcrumbs"
};
var cf = {};
cf = {
  breadcrumbs: "Migas de pan"
};
var ff = {};
ff = {
  breadcrumbs: "Lingiread"
};
var hf = {};
hf = {
  breadcrumbs: "Navigointilinkit"
};
var mf = {};
mf = {
  breadcrumbs: "Chemin de navigation"
};
var bf = {};
bf = {
  breadcrumbs: "שבילי ניווט"
};
var pf = {};
pf = {
  breadcrumbs: "Navigacijski putovi"
};
var gf = {};
gf = {
  breadcrumbs: "Morzsamenü"
};
var yf = {};
yf = {
  breadcrumbs: "Breadcrumb"
};
var $f = {};
$f = {
  breadcrumbs: "パンくずリスト"
};
var vf = {};
vf = {
  breadcrumbs: "탐색 표시"
};
var Df = {};
Df = {
  breadcrumbs: "Naršymo kelias"
};
var xf = {};
xf = {
  breadcrumbs: "Atpakaļceļi"
};
var Ef = {};
Ef = {
  breadcrumbs: "Navigasjonsstier"
};
var Cf = {};
Cf = {
  breadcrumbs: "Broodkruimels"
};
var Pf = {};
Pf = {
  breadcrumbs: "Struktura nawigacyjna"
};
var wf = {};
wf = {
  breadcrumbs: "Caminho detalhado"
};
var Sf = {};
Sf = {
  breadcrumbs: "Categorias"
};
var kf = {};
kf = {
  breadcrumbs: "Miez de pâine"
};
var Bf = {};
Bf = {
  breadcrumbs: "Навигация"
};
var Ff = {};
Ff = {
  breadcrumbs: "Navigačné prvky Breadcrumbs"
};
var Af = {};
Af = {
  breadcrumbs: "Drobtine"
};
var Rf = {};
Rf = {
  breadcrumbs: "Putanje navigacije"
};
var Tf = {};
Tf = {
  breadcrumbs: "Sökvägar"
};
var If = {};
If = {
  breadcrumbs: "İçerik haritaları"
};
var Mf = {};
Mf = {
  breadcrumbs: "Навігаційна стежка"
};
var Kf = {};
Kf = {
  breadcrumbs: "导航栏"
};
var Nf = {};
Nf = {
  breadcrumbs: "導覽列"
};
var Vf = {};
Vf = {
  "ar-AE": rf,
  "bg-BG": af,
  "cs-CZ": lf,
  "da-DK": uf,
  "de-DE": of,
  "el-GR": sf,
  "en-US": df,
  "es-ES": cf,
  "et-EE": ff,
  "fi-FI": hf,
  "fr-FR": mf,
  "he-IL": bf,
  "hr-HR": pf,
  "hu-HU": gf,
  "it-IT": yf,
  "ja-JP": $f,
  "ko-KR": vf,
  "lt-LT": Df,
  "lv-LV": xf,
  "nb-NO": Ef,
  "nl-NL": Cf,
  "pl-PL": Pf,
  "pt-BR": wf,
  "pt-PT": Sf,
  "ro-RO": kf,
  "ru-RU": Bf,
  "sk-SK": Ff,
  "sl-SI": Af,
  "sr-SP": Rf,
  "sv-SE": Tf,
  "tr-TR": If,
  "uk-UA": Mf,
  "zh-CN": Kf,
  "zh-TW": Nf
};
function v2(e) {
  return e && e.__esModule ? e.default : e;
}
function D2(e) {
  let { "aria-label": t, ...n } = e, r = Ee(v2(Vf), "@react-aria/breadcrumbs");
  return {
    navProps: {
      ...J(n, {
        labelable: !0
      }),
      "aria-label": t || r.format("breadcrumbs")
    }
  };
}
const Ai = /* @__PURE__ */ G(null), Y9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Ai);
  let { CollectionRoot: r } = O(ge), { navProps: a } = D2(t), l = J(t, {
    global: !0,
    labelable: !0
  });
  return /* @__PURE__ */ g.createElement(jn, {
    content: /* @__PURE__ */ g.createElement(Jt, t)
  }, (i) => /* @__PURE__ */ g.createElement(Q.ol, {
    render: t.render,
    ref: n,
    ...z(l, a),
    slot: t.slot || void 0,
    style: t.style,
    className: t.className ?? "react-aria-Breadcrumbs"
  }, /* @__PURE__ */ g.createElement(Ai.Provider, {
    value: t
  }, /* @__PURE__ */ g.createElement(r, {
    collection: i
  }))));
}), Ro = class Ro extends dt {
};
Ro.type = "item";
let Ri = Ro;
const Z9 = /* @__PURE__ */ St(Ri, function(t, n, r) {
  let a = r.nextKey == null, { isDisabled: l, onAction: i } = He(Ai), u = {
    "aria-current": a ? "page" : null,
    isDisabled: l || a,
    onPress: () => i?.(r.key)
  }, o = le({
    ...r.props,
    children: r.rendered,
    values: {
      isDisabled: l || a,
      isCurrent: a
    },
    defaultClassName: "react-aria-Breadcrumb"
  }), d = J(t, {
    global: !0,
    labelable: !0
  });
  return delete d.id, /* @__PURE__ */ g.createElement(Q.li, {
    ...d,
    ...o,
    ref: n,
    "data-disabled": l || a || void 0,
    "data-current": a || void 0
  }, /* @__PURE__ */ g.createElement(nf.Provider, {
    value: u
  }, o.children));
}), et = /* @__PURE__ */ G({}), X9 = /* @__PURE__ */ vn(function(t, n) {
  [t, n] = oe(t, n, et);
  let { elementType: r = "label", ...a } = t, l = Q[r];
  return /* @__PURE__ */ g.createElement(l, {
    className: "react-aria-Label",
    ...a,
    ref: n
  });
});
function ba(e) {
  let { id: t, label: n, "aria-labelledby": r, "aria-label": a, labelElementType: l = "label" } = e;
  t = ce(t);
  let i = ce(), u = {};
  n ? (r = r ? `${i} ${r}` : i, u = {
    id: i,
    htmlFor: l === "label" ? t : void 0
  }) : !r && !a && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let o = ut({
    id: t,
    "aria-label": a,
    "aria-labelledby": r
  });
  return {
    labelProps: u,
    fieldProps: o
  };
}
let _l = /* @__PURE__ */ new Map(), Ti = !1;
try {
  Ti = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let tl = !1;
try {
  tl = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const Lf = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class Lt {
  constructor(t, n = {}) {
    this.numberFormatter = x2(t, n), this.options = n;
  }
  /**
  * Formats a number value as a string, according to the locale and options provided to the
  * constructor.
  */
  format(t) {
    let n = "";
    if (!Ti && this.options.signDisplay != null ? n = E2(this.numberFormatter, this.options.signDisplay, t) : n = this.numberFormatter.format(t), this.options.style === "unit" && !tl) {
      let { unit: r, unitDisplay: a = "short", locale: l } = this.resolvedOptions();
      if (!r) return n;
      let i = Lf[r]?.[a];
      n += i[l] || i.default;
    }
    return n;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(t) {
    return this.numberFormatter.formatToParts(t);
  }
  /** Formats a number range as a string. */
  formatRange(t, n) {
    if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    return `${this.format(t)} – ${this.format(n)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(t, n) {
    if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    let r = this.numberFormatter.formatToParts(t), a = this.numberFormatter.formatToParts(n);
    return [
      ...r.map((l) => ({
        ...l,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...a.map((l) => ({
        ...l,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.numberFormatter.resolvedOptions();
    return !Ti && this.options.signDisplay != null && (t = {
      ...t,
      signDisplay: this.options.signDisplay
    }), !tl && this.options.style === "unit" && (t = {
      ...t,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), t;
  }
}
function x2(e, t = {}) {
  let { numberingSystem: n } = t;
  if (n && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${n}`), t.style === "unit" && !tl) {
    let { unit: l, unitDisplay: i = "short" } = t;
    if (!l) throw new Error('unit option must be provided with style: "unit"');
    if (!Lf[l]?.[i]) throw new Error(`Unsupported unit ${l} with unitDisplay = ${i}`);
    t = {
      ...t,
      style: "decimal"
    };
  }
  let r = e + (t ? Object.entries(t).sort((l, i) => l[0] < i[0] ? -1 : 1).join() : "");
  if (_l.has(r)) return _l.get(r);
  let a = new Intl.NumberFormat(e, t);
  return _l.set(r, a), a;
}
function E2(e, t, n) {
  if (t === "auto") return e.format(n);
  if (t === "never") return e.format(Math.abs(n));
  {
    let r = !1;
    if (t === "always" ? r = n > 0 || Object.is(n, 0) : t === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
      let a = e.format(-n), l = e.format(n), i = a.replace(l, "").replace(/\u200e|\u061C/, "");
      return [
        ...i
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), a.replace(l, "!!!").replace(i, "+").replace("!!!", l);
    } else return e.format(n);
  }
}
const C2 = new RegExp("^.*\\(.*\\).*$"), P2 = [
  "latn",
  "arab",
  "hanidec",
  "deva",
  "beng",
  "fullwide"
];
class wu {
  constructor(t, n = {}) {
    this.locale = t, this.options = n;
  }
  /**
  * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
  */
  parse(t) {
    return Wl(this.locale, this.options, t).parse(t);
  }
  /**
  * Returns whether the given string could potentially be a valid number. This should be used to
  * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
  * of the minus/plus sign characters can be checked.
  */
  isValidPartialNumber(t, n, r) {
    return Wl(this.locale, this.options, t).isValidPartialNumber(t, n, r);
  }
  /**
  * Returns a numbering system for which the given string is valid in the current locale.
  * If no numbering system could be detected, the default numbering system for the current
  * locale is returned.
  */
  getNumberingSystem(t) {
    return Wl(this.locale, this.options, t).options.numberingSystem;
  }
}
const ms = /* @__PURE__ */ new Map();
function Wl(e, t, n) {
  let r = bs(e, t);
  if (!e.includes("-nu-") && !r.isValidPartialNumber(n)) {
    for (let a of P2) if (a !== r.options.numberingSystem) {
      let l = bs(e + (e.includes("-u-") ? "-nu-" : "-u-nu-") + a, t);
      if (l.isValidPartialNumber(n)) return l;
    }
  }
  return r;
}
function bs(e, t) {
  let n = e + (t ? Object.entries(t).sort((a, l) => a[0] < l[0] ? -1 : 1).join() : ""), r = ms.get(n);
  return r || (r = new w2(e, t), ms.set(n, r)), r;
}
class w2 {
  constructor(t, n = {}) {
    this.locale = t, n.roundingIncrement !== 1 && n.roundingIncrement != null && (n.maximumFractionDigits == null && n.minimumFractionDigits == null ? (n.maximumFractionDigits = 0, n.minimumFractionDigits = 0) : n.maximumFractionDigits == null ? n.maximumFractionDigits = n.minimumFractionDigits : n.minimumFractionDigits == null && (n.minimumFractionDigits = n.maximumFractionDigits)), this.formatter = new Intl.NumberFormat(t, n), this.options = this.formatter.resolvedOptions(), this.symbols = S2(t, this.formatter, this.options, n), this.options.style === "percent" && ((this.options.minimumFractionDigits ?? 0) > 18 || (this.options.maximumFractionDigits ?? 0) > 18) && console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
  }
  parse(t) {
    let n = this.formatter.resolvedOptions().useGrouping, r = this.sanitize(t);
    if (!n && this.symbols.group && r.includes(this.symbols.group)) return NaN;
    if (this.symbols.group && (r = r.replaceAll(this.symbols.group, "")), this.symbols.decimal && (r = r.replace(this.symbols.decimal, ".")), this.symbols.minusSign && (r = r.replace(this.symbols.minusSign, "-")), r = r.replace(this.symbols.numeral, this.symbols.index), this.options.style === "percent") {
      let l = r.indexOf("-");
      r = r.replace("-", ""), r = r.replace("+", "");
      let i = r.indexOf(".");
      i === -1 && (i = r.length), r = r.replace(".", ""), i - 2 === 0 ? r = `0.${r}` : i - 2 === -1 ? r = `0.0${r}` : i - 2 === -2 ? r = "0.00" : r = `${r.slice(0, i - 2)}.${r.slice(i - 2)}`, l > -1 && (r = `-${r}`);
    }
    let a = r ? +r : NaN;
    if (isNaN(a)) return NaN;
    if (this.options.style === "percent") {
      let l = {
        ...this.options,
        style: "decimal",
        minimumFractionDigits: Math.min((this.options.minimumFractionDigits ?? 0) + 2, 20),
        maximumFractionDigits: Math.min((this.options.maximumFractionDigits ?? 0) + 2, 20)
      };
      return new wu(this.locale, l).parse(new Lt(this.locale, l).format(a));
    }
    return this.options.currencySign === "accounting" && C2.test(t) && (a = -1 * a), a;
  }
  sanitize(t) {
    let n = this.formatter.resolvedOptions().useGrouping;
    return this.symbols.noNumeralUnits.length > 0 && this.symbols.noNumeralUnits.find((r) => r.unit === t) ? this.symbols.noNumeralUnits.find((r) => r.unit === t).value.toString() : (t = t.replace(this.symbols.literals, ""), this.symbols.minusSign && (t = t.replace("-", this.symbols.minusSign)), this.options.numberingSystem === "arab" && (this.symbols.decimal && (t = on(t, ",", this.symbols.decimal), t = on(t, "،", this.symbols.decimal)), this.symbols.group && n && (t = on(t, ".", this.symbols.group))), this.symbols.group === "’" && t.includes("'") && n && (t = on(t, "'", this.symbols.group)), this.symbols.group === "'" && t.includes("’") && n && (t = on(t, "’", this.symbols.group)), this.options.locale === "fr-FR" && this.symbols.group && n && (t = on(t, " ", this.symbols.group), t = on(t, /\u00A0/g, this.symbols.group)), t);
  }
  isValidPartialNumber(t, n = -1 / 0, r = 1 / 0) {
    let a = this.formatter.resolvedOptions().useGrouping;
    return t = this.sanitize(t), this.symbols.minusSign && t.startsWith(this.symbols.minusSign) && n < 0 ? t = t.slice(this.symbols.minusSign.length) : this.symbols.plusSign && t.startsWith(this.symbols.plusSign) && r > 0 && (t = t.slice(this.symbols.plusSign.length)), this.symbols.decimal && t.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0 ? !1 : (this.symbols.group && a && (t = on(t, this.symbols.group, "")), t = t.replace(this.symbols.numeral, ""), this.symbols.decimal && (t = t.replace(this.symbols.decimal, "")), t.length === 0);
  }
}
const ps = /* @__PURE__ */ new Set([
  "decimal",
  "fraction",
  "integer",
  "minusSign",
  "plusSign",
  "group"
]), gs = [
  0,
  4,
  2,
  1,
  11,
  20,
  3,
  7,
  100,
  21,
  0.1,
  1.1
];
function S2(e, t, n, r) {
  let a = new Intl.NumberFormat(e, {
    ...n,
    // Resets so we get the full range of symbols
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 21,
    roundingIncrement: 1,
    roundingPriority: "auto",
    roundingMode: "halfExpand",
    useGrouping: !0
  }), l = a.formatToParts(-10000.111), i = a.formatToParts(10000.111), u = gs.map((P) => a.formatToParts(P)), o = u.map((P, C) => {
    let M = P.find((F) => F.type === "unit");
    return M && !P.some((F) => F.type === "integer" || F.type === "fraction") ? {
      unit: M.value,
      value: gs[C]
    } : null;
  }).filter((P) => !!P), d = l.find((P) => P.type === "minusSign")?.value ?? "-", s = i.find((P) => P.type === "plusSign")?.value;
  !s && (r?.signDisplay === "exceptZero" || r?.signDisplay === "always") && (s = "+");
  let f = new Intl.NumberFormat(e, {
    ...n,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).formatToParts(1e-3).find((P) => P.type === "decimal")?.value, h = l.find((P) => P.type === "group")?.value, m = l.filter((P) => !ps.has(P.type)).map((P) => ys(P.value)), b = u.flatMap((P) => P.filter((C) => !ps.has(C.type)).map((C) => ys(C.value))), p = [
    .../* @__PURE__ */ new Set([
      ...m,
      ...b
    ])
  ].sort((P, C) => C.length - P.length), y = p.length === 0 ? new RegExp("\\p{White_Space}|\\p{Cf}", "gu") : new RegExp(`${p.join("|")}|\\p{White_Space}|\\p{Cf}`, "gu"), $ = [
    ...new Intl.NumberFormat(n.locale, {
      useGrouping: !1
    }).format(9876543210)
  ].reverse(), v = new Map($.map((P, C) => [
    P,
    C
  ])), x = new RegExp(`[${$.join("")}]`, "g");
  return {
    minusSign: d,
    plusSign: s,
    decimal: f,
    group: h,
    literals: y,
    numeral: x,
    numerals: $,
    index: (P) => String(v.get(P)),
    noNumeralUnits: o
  };
}
function on(e, t, n) {
  return e.replaceAll ? e.replaceAll(t, n) : e.split(t).join(n);
}
function ys(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Ii(e = {}) {
  let { locale: t } = de();
  return K(() => new Lt(t, e), [
    t,
    e
  ]);
}
function Le(e, t = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(e, t), n);
}
function Ba(e, t) {
  let n = e, r = 0, a = t.toString(), l = a.toLowerCase().indexOf("e-");
  if (l > 0) r = Math.abs(Math.floor(Math.log10(Math.abs(t)))) + l;
  else {
    let i = a.indexOf(".");
    i >= 0 && (r = a.length - i);
  }
  if (r > 0) {
    let i = Math.pow(10, r);
    n = Math.round(n * i) / i;
  }
  return n;
}
function Ve(e, t, n, r) {
  t = Number(t), n = Number(n);
  let a = (e - (isNaN(t) ? 0 : t)) % r, l = Ba(Math.abs(a) * 2 >= r ? e + Math.sign(a) * (r - Math.abs(a)) : e - a, r);
  return isNaN(t) ? !isNaN(n) && l > n && (l = Math.floor(Ba(n / r, r)) * r) : l < t ? l = t : !isNaN(n) && l > n && (l = t + Math.floor(Ba((n - t) / r, r)) * r), l = Ba(l, r), l;
}
function Ne(e, t, n = 10) {
  const r = Math.pow(n, t);
  return Math.round(e * r) / r;
}
function k2(e) {
  let { value: t = 0, minValue: n = 0, maxValue: r = 100, valueLabel: a, isIndeterminate: l, formatOptions: i = {
    style: "percent"
  } } = e, u = J(e, {
    labelable: !0
  }), { labelProps: o, fieldProps: d } = ba({
    ...e,
    // Progress bar is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  t = Le(t, n, r);
  let s = (t - n) / (r - n), c = Ii(i);
  if (!l && !a) {
    let f = i.style === "percent" ? s : t;
    a = c.format(f);
  }
  return {
    progressBarProps: z(u, {
      ...d,
      "aria-valuenow": l ? void 0 : t,
      "aria-valuemin": n,
      "aria-valuemax": r,
      "aria-valuetext": l ? void 0 : a,
      role: "progressbar"
    }),
    labelProps: o
  };
}
const zf = /* @__PURE__ */ G(null), J9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, zf);
  let { value: r = 0, minValue: a = 0, maxValue: l = 100, isIndeterminate: i = !1 } = t;
  r = Le(r, a, l);
  let [u, o] = Qe(!t["aria-label"] && !t["aria-labelledby"]), { progressBarProps: d, labelProps: s } = k2({
    ...t,
    label: o
  }), c = i ? void 0 : (r - a) / (l - a) * 100, f = le({
    ...t,
    defaultClassName: "react-aria-ProgressBar",
    values: {
      percentage: c,
      valueText: d["aria-valuetext"],
      isIndeterminate: i
    }
  }), h = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(h, f, d),
    ref: n,
    slot: t.slot || void 0
  }, /* @__PURE__ */ g.createElement(et.Provider, {
    value: {
      ...s,
      ref: u,
      elementType: "span"
    }
  }, f.children));
}), Of = 7e3;
let sn = null;
function pn(e, t = "assertive", n = Of) {
  sn ? sn.announce(e, t, n) : (sn = new F2(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? sn.announce(e, t, n) : setTimeout(() => {
    sn?.isAttached() && sn?.announce(e, t, n);
  }, 100));
}
function B2(e) {
  sn && sn.clear(e);
}
class F2 {
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
  isAttached() {
    return this.node?.isConnected;
  }
  createLog(t) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", t), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, n = "assertive", r = Of) {
    if (!this.node) return;
    let a = document.createElement("div");
    typeof t == "object" ? (a.setAttribute("role", "img"), a.setAttribute("aria-labelledby", t["aria-labelledby"])) : a.textContent = t, n === "assertive" ? this.assertiveLog?.appendChild(a) : this.politeLog?.appendChild(a), t !== "" && setTimeout(() => {
      a.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
}
function Hf(e, t) {
  let { elementType: n = "button", isDisabled: r, onPress: a, onPressStart: l, onPressEnd: i, onPressUp: u, onPressChange: o, preventFocusOnPress: d, allowFocusWhenDisabled: s, onClick: c, href: f, target: h, rel: m, type: b = "button" } = e, p;
  n === "button" ? p = {
    type: b,
    disabled: r,
    form: e.form,
    formAction: e.formAction,
    formEncType: e.formEncType,
    formMethod: e.formMethod,
    formNoValidate: e.formNoValidate,
    formTarget: e.formTarget,
    name: e.name,
    value: e.value
  } : p = {
    role: "button",
    href: n === "a" && !r ? f : void 0,
    target: n === "a" ? h : void 0,
    type: n === "input" ? b : void 0,
    disabled: n === "input" ? r : void 0,
    "aria-disabled": !r || n === "input" ? void 0 : r,
    rel: n === "a" ? m : void 0
  };
  let { pressProps: y, isPressed: $ } = Je({
    onPressStart: l,
    onPressEnd: i,
    onPressChange: o,
    onPress: a,
    onPressUp: u,
    onClick: c,
    isDisabled: r,
    preventFocusOnPress: d,
    ref: t
  }), { focusableProps: v } = ct(e, t);
  s && (v.tabIndex = r ? -1 : v.tabIndex);
  let x = z(v, y, J(e, {
    labelable: !0
  }));
  return {
    isPressed: $,
    buttonProps: z(p, x, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      "aria-current": e["aria-current"],
      "aria-disabled": e["aria-disabled"]
    })
  };
}
const Xe = /* @__PURE__ */ G({}), Q9 = /* @__PURE__ */ vn(function(t, n) {
  [t, n] = oe(t, n, Xe);
  let r = t, { isPending: a } = r, { buttonProps: l, isPressed: i } = Hf(t, n);
  l = R2(l, a);
  let { focusProps: u, isFocused: o, isFocusVisible: d } = ye(t), { hoverProps: s, isHovered: c } = De({
    ...t,
    isDisabled: t.isDisabled || a
  }), f = {
    isHovered: c,
    isPressed: (r.isPressed || i) && !a,
    isFocused: o,
    isFocusVisible: d,
    isDisabled: t.isDisabled || !1,
    isPending: a ?? !1
  }, h = le({
    ...t,
    values: f,
    defaultClassName: "react-aria-Button"
  }), m = ce(l.id), b = ce(), p = l["aria-labelledby"];
  a && (p ? p = `${p} ${b}` : l["aria-label"] && (p = `${m} ${b}`));
  let y = T(a);
  ee(() => {
    let v = {
      "aria-labelledby": p || m
    };
    (!y.current && o && a || y.current && o && !a) && pn(v, "assertive"), y.current = a;
  }, [
    a,
    o,
    p,
    m
  ]);
  let $ = J(t, {
    global: !0
  });
  return delete $.onClick, /* @__PURE__ */ g.createElement(Q.button, {
    ...z($, h, l, u, s),
    // When the button is in a pending state, we want to stop implicit form submission (ie. when the user presses enter on a text input).
    // We do this by changing the button's type to button.
    type: l.type === "submit" && a ? "button" : l.type,
    id: m,
    ref: n,
    "aria-labelledby": p,
    slot: t.slot || void 0,
    "aria-disabled": a ? "true" : l["aria-disabled"],
    "data-disabled": t.isDisabled || void 0,
    "data-pressed": f.isPressed || void 0,
    "data-hovered": c || void 0,
    "data-focused": o || void 0,
    "data-pending": a || void 0,
    "data-focus-visible": d || void 0
  }, /* @__PURE__ */ g.createElement(zf.Provider, {
    value: {
      id: b
    }
  }, h.children));
}), A2 = /Focus|Blur|Hover|Pointer(Enter|Leave|Over|Out)|Mouse(Enter|Leave|Over|Out)/;
function R2(e, t) {
  if (t) {
    for (const n in e) n.startsWith("on") && !A2.test(n) && (e[n] = void 0);
    e.href = void 0, e.target = void 0;
  }
  return e;
}
const Su = /* @__PURE__ */ G({}), eC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Su);
  let { children: r, level: a = 3, className: l, ...i } = t, u = Q[`h${a}`];
  return /* @__PURE__ */ g.createElement(u, {
    ...i,
    ref: n,
    className: l ?? "react-aria-Heading"
  }, r);
}), We = /* @__PURE__ */ G({}), T2 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, We);
  let { elementType: r = "span", ...a } = t, l = Q[r];
  return /* @__PURE__ */ g.createElement(l, {
    className: "react-aria-Text",
    ...a,
    ref: n
  });
});
var Uf = {};
Uf = {
  dateRange: (e) => `${e.startDate} إلى ${e.endDate}`,
  dateSelected: (e) => `${e.date} المحدد`,
  finishRangeSelectionPrompt: "انقر لإنهاء عملية تحديد نطاق التاريخ",
  maximumDate: "آخر تاريخ متاح",
  minimumDate: "أول تاريخ متاح",
  next: "التالي",
  previous: "السابق",
  selectedDateDescription: (e) => `تاريخ محدد: ${e.date}`,
  selectedRangeDescription: (e) => `المدى الزمني المحدد: ${e.dateRange}`,
  startRangeSelectionPrompt: "انقر لبدء عملية تحديد نطاق التاريخ",
  todayDate: (e) => `اليوم، ${e.date}`,
  todayDateSelected: (e) => `اليوم، ${e.date} محدد`
};
var jf = {};
jf = {
  dateRange: (e) => `${e.startDate} до ${e.endDate}`,
  dateSelected: (e) => `Избрано е ${e.date}`,
  finishRangeSelectionPrompt: "Натиснете, за да довършите избора на времеви интервал",
  maximumDate: "Последна налична дата",
  minimumDate: "Първа налична дата",
  next: "Напред",
  previous: "Назад",
  selectedDateDescription: (e) => `Избрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Избран диапазон: ${e.dateRange}`,
  startRangeSelectionPrompt: "Натиснете, за да пристъпите към избора на времеви интервал",
  todayDate: (e) => `Днес, ${e.date}`,
  todayDateSelected: (e) => `Днес, ${e.date} са избрани`
};
var _f = {};
_f = {
  dateRange: (e) => `${e.startDate} až ${e.endDate}`,
  dateSelected: (e) => `Vybráno ${e.date}`,
  finishRangeSelectionPrompt: "Kliknutím dokončíte výběr rozsahu dat",
  maximumDate: "Poslední dostupné datum",
  minimumDate: "První dostupné datum",
  next: "Další",
  previous: "Předchozí",
  selectedDateDescription: (e) => `Vybrané datum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybrané období: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknutím zahájíte výběr rozsahu dat",
  todayDate: (e) => `Dnes, ${e.date}`,
  todayDateSelected: (e) => `Dnes, vybráno ${e.date}`
};
var Wf = {};
Wf = {
  dateRange: (e) => `${e.startDate} til ${e.endDate}`,
  dateSelected: (e) => `${e.date} valgt`,
  finishRangeSelectionPrompt: "Klik for at fuldføre valg af datoområde",
  maximumDate: "Sidste ledige dato",
  minimumDate: "Første ledige dato",
  next: "Næste",
  previous: "Forrige",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt interval: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klik for at starte valg af datoområde",
  todayDate: (e) => `I dag, ${e.date}`,
  todayDateSelected: (e) => `I dag, ${e.date} valgt`
};
var Gf = {};
Gf = {
  dateRange: (e) => `${e.startDate} bis ${e.endDate}`,
  dateSelected: (e) => `${e.date} ausgewählt`,
  finishRangeSelectionPrompt: "Klicken, um die Auswahl des Datumsbereichs zu beenden",
  maximumDate: "Letztes verfügbares Datum",
  minimumDate: "Erstes verfügbares Datum",
  next: "Weiter",
  previous: "Zurück",
  selectedDateDescription: (e) => `Ausgewähltes Datum: ${e.date}`,
  selectedRangeDescription: (e) => `Ausgewählter Bereich: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klicken, um die Auswahl des Datumsbereichs zu beginnen",
  todayDate: (e) => `Heute, ${e.date}`,
  todayDateSelected: (e) => `Heute, ${e.date} ausgewählt`
};
var qf = {};
qf = {
  dateRange: (e) => `${e.startDate} έως ${e.endDate}`,
  dateSelected: (e) => `Επιλέχθηκε ${e.date}`,
  finishRangeSelectionPrompt: "Κάντε κλικ για να ολοκληρώσετε την επιλογή εύρους ημερομηνιών",
  maximumDate: "Τελευταία διαθέσιμη ημερομηνία",
  minimumDate: "Πρώτη διαθέσιμη ημερομηνία",
  next: "Επόμενο",
  previous: "Προηγούμενο",
  selectedDateDescription: (e) => `Επιλεγμένη ημερομηνία: ${e.date}`,
  selectedRangeDescription: (e) => `Επιλεγμένο εύρος: ${e.dateRange}`,
  startRangeSelectionPrompt: "Κάντε κλικ για να ξεκινήσετε την επιλογή εύρους ημερομηνιών",
  todayDate: (e) => `Σήμερα, ${e.date}`,
  todayDateSelected: (e) => `Σήμερα, επιλέχτηκε ${e.date}`
};
var Yf = {};
Yf = {
  previous: "Previous",
  next: "Next",
  selectedDateDescription: (e) => `Selected Date: ${e.date}`,
  selectedRangeDescription: (e) => `Selected Range: ${e.dateRange}`,
  todayDate: (e) => `Today, ${e.date}`,
  todayDateSelected: (e) => `Today, ${e.date} selected`,
  dateSelected: (e) => `${e.date} selected`,
  startRangeSelectionPrompt: "Click to start selecting date range",
  finishRangeSelectionPrompt: "Click to finish selecting date range",
  minimumDate: "First available date",
  maximumDate: "Last available date",
  dateRange: (e) => `${e.startDate} to ${e.endDate}`
};
var Zf = {};
Zf = {
  dateRange: (e) => `${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} seleccionado`,
  finishRangeSelectionPrompt: "Haga clic para terminar de seleccionar rango de fechas",
  maximumDate: "Última fecha disponible",
  minimumDate: "Primera fecha disponible",
  next: "Siguiente",
  previous: "Anterior",
  selectedDateDescription: (e) => `Fecha seleccionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo seleccionado: ${e.dateRange}`,
  startRangeSelectionPrompt: "Haga clic para comenzar a seleccionar un rango de fechas",
  todayDate: (e) => `Hoy, ${e.date}`,
  todayDateSelected: (e) => `Hoy, ${e.date} seleccionado`
};
var Xf = {};
Xf = {
  dateRange: (e) => `${e.startDate} kuni ${e.endDate}`,
  dateSelected: (e) => `${e.date} valitud`,
  finishRangeSelectionPrompt: "Klõpsake kuupäevavahemiku valimise lõpetamiseks",
  maximumDate: "Viimane saadaolev kuupäev",
  minimumDate: "Esimene saadaolev kuupäev",
  next: "Järgmine",
  previous: "Eelmine",
  selectedDateDescription: (e) => `Valitud kuupäev: ${e.date}`,
  selectedRangeDescription: (e) => `Valitud vahemik: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klõpsake kuupäevavahemiku valimiseks",
  todayDate: (e) => `Täna, ${e.date}`,
  todayDateSelected: (e) => `Täna, ${e.date} valitud`
};
var Jf = {};
Jf = {
  dateRange: (e) => `${e.startDate} – ${e.endDate}`,
  dateSelected: (e) => `${e.date} valittu`,
  finishRangeSelectionPrompt: "Lopeta päivämääräalueen valinta napsauttamalla tätä.",
  maximumDate: "Viimeinen varattavissa oleva päivämäärä",
  minimumDate: "Ensimmäinen varattavissa oleva päivämäärä",
  next: "Seuraava",
  previous: "Edellinen",
  selectedDateDescription: (e) => `Valittu päivämäärä: ${e.date}`,
  selectedRangeDescription: (e) => `Valittu aikaväli: ${e.dateRange}`,
  startRangeSelectionPrompt: "Aloita päivämääräalueen valinta napsauttamalla tätä.",
  todayDate: (e) => `Tänään, ${e.date}`,
  todayDateSelected: (e) => `Tänään, ${e.date} valittu`
};
var Qf = {};
Qf = {
  dateRange: (e) => `${e.startDate} à ${e.endDate}`,
  dateSelected: (e) => `${e.date} sélectionné`,
  finishRangeSelectionPrompt: "Cliquer pour finir de sélectionner la plage de dates",
  maximumDate: "Dernière date disponible",
  minimumDate: "Première date disponible",
  next: "Suivant",
  previous: "Précédent",
  selectedDateDescription: (e) => `Date sélectionnée : ${e.date}`,
  selectedRangeDescription: (e) => `Plage sélectionnée : ${e.dateRange}`,
  startRangeSelectionPrompt: "Cliquer pour commencer à sélectionner la plage de dates",
  todayDate: (e) => `Aujourd'hui, ${e.date}`,
  todayDateSelected: (e) => `Aujourd’hui, ${e.date} sélectionné`
};
var e4 = {};
e4 = {
  dateRange: (e) => `${e.startDate} עד ${e.endDate}`,
  dateSelected: (e) => `${e.date} נבחר`,
  finishRangeSelectionPrompt: "חץ כדי לסיים את בחירת טווח התאריכים",
  maximumDate: "תאריך פנוי אחרון",
  minimumDate: "תאריך פנוי ראשון",
  next: "הבא",
  previous: "הקודם",
  selectedDateDescription: (e) => `תאריך נבחר: ${e.date}`,
  selectedRangeDescription: (e) => `טווח נבחר: ${e.dateRange}`,
  startRangeSelectionPrompt: "לחץ כדי להתחיל בבחירת טווח התאריכים",
  todayDate: (e) => `היום, ${e.date}`,
  todayDateSelected: (e) => `היום, ${e.date} נבחר`
};
var t4 = {};
t4 = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `${e.date} odabran`,
  finishRangeSelectionPrompt: "Kliknite da dovršite raspon odabranih datuma",
  maximumDate: "Posljednji raspoloživi datum",
  minimumDate: "Prvi raspoloživi datum",
  next: "Sljedeći",
  previous: "Prethodni",
  selectedDateDescription: (e) => `Odabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Odabrani raspon: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknite da započnete raspon odabranih datuma",
  todayDate: (e) => `Danas, ${e.date}`,
  todayDateSelected: (e) => `Danas, odabran ${e.date}`
};
var n4 = {};
n4 = {
  dateRange: (e) => `${e.startDate}–${e.endDate}`,
  dateSelected: (e) => `${e.date} kiválasztva`,
  finishRangeSelectionPrompt: "Kattintson a dátumtartomány kijelölésének befejezéséhez",
  maximumDate: "Utolsó elérhető dátum",
  minimumDate: "Az első elérhető dátum",
  next: "Következő",
  previous: "Előző",
  selectedDateDescription: (e) => `Kijelölt dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Kijelölt tartomány: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kattintson a dátumtartomány kijelölésének indításához",
  todayDate: (e) => `Ma, ${e.date}`,
  todayDateSelected: (e) => `Ma, ${e.date} kijelölve`
};
var r4 = {};
r4 = {
  dateRange: (e) => `Da ${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} selezionata`,
  finishRangeSelectionPrompt: "Fai clic per completare la selezione dell’intervallo di date",
  maximumDate: "Ultima data disponibile",
  minimumDate: "Prima data disponibile",
  next: "Successivo",
  previous: "Precedente",
  selectedDateDescription: (e) => `Data selezionata: ${e.date}`,
  selectedRangeDescription: (e) => `Intervallo selezionato: ${e.dateRange}`,
  startRangeSelectionPrompt: "Fai clic per selezionare l’intervallo di date",
  todayDate: (e) => `Oggi, ${e.date}`,
  todayDateSelected: (e) => `Oggi, ${e.date} selezionata`
};
var a4 = {};
a4 = {
  dateRange: (e) => `${e.startDate} から ${e.endDate}`,
  dateSelected: (e) => `${e.date} を選択`,
  finishRangeSelectionPrompt: "クリックして日付範囲の選択を終了",
  maximumDate: "最終利用可能日",
  minimumDate: "最初の利用可能日",
  next: "次へ",
  previous: "前へ",
  selectedDateDescription: (e) => `選択した日付 : ${e.date}`,
  selectedRangeDescription: (e) => `選択範囲 : ${e.dateRange}`,
  startRangeSelectionPrompt: "クリックして日付範囲の選択を開始",
  todayDate: (e) => `本日、${e.date}`,
  todayDateSelected: (e) => `本日、${e.date} を選択`
};
var l4 = {};
l4 = {
  dateRange: (e) => `${e.startDate} ~ ${e.endDate}`,
  dateSelected: (e) => `${e.date} 선택됨`,
  finishRangeSelectionPrompt: "날짜 범위 선택을 완료하려면 클릭하십시오.",
  maximumDate: "마지막으로 사용 가능한 일자",
  minimumDate: "처음으로 사용 가능한 일자",
  next: "다음",
  previous: "이전",
  selectedDateDescription: (e) => `선택 일자: ${e.date}`,
  selectedRangeDescription: (e) => `선택 범위: ${e.dateRange}`,
  startRangeSelectionPrompt: "날짜 범위 선택을 시작하려면 클릭하십시오.",
  todayDate: (e) => `오늘, ${e.date}`,
  todayDateSelected: (e) => `오늘, ${e.date} 선택됨`
};
var i4 = {};
i4 = {
  dateRange: (e) => `Nuo ${e.startDate} iki ${e.endDate}`,
  dateSelected: (e) => `Pasirinkta ${e.date}`,
  finishRangeSelectionPrompt: "Spustelėkite, kad baigtumėte pasirinkti datų intervalą",
  maximumDate: "Paskutinė galima data",
  minimumDate: "Pirmoji galima data",
  next: "Paskesnis",
  previous: "Ankstesnis",
  selectedDateDescription: (e) => `Pasirinkta data: ${e.date}`,
  selectedRangeDescription: (e) => `Pasirinktas intervalas: ${e.dateRange}`,
  startRangeSelectionPrompt: "Spustelėkite, kad pradėtumėte pasirinkti datų intervalą",
  todayDate: (e) => `Šiandien, ${e.date}`,
  todayDateSelected: (e) => `Šiandien, pasirinkta ${e.date}`
};
var u4 = {};
u4 = {
  dateRange: (e) => `No ${e.startDate} līdz ${e.endDate}`,
  dateSelected: (e) => `Atlasīts: ${e.date}`,
  finishRangeSelectionPrompt: "Noklikšķiniet, lai pabeigtu datumu diapazona atlasi",
  maximumDate: "Pēdējais pieejamais datums",
  minimumDate: "Pirmais pieejamais datums",
  next: "Tālāk",
  previous: "Atpakaļ",
  selectedDateDescription: (e) => `Atlasītais datums: ${e.date}`,
  selectedRangeDescription: (e) => `Atlasītais diapazons: ${e.dateRange}`,
  startRangeSelectionPrompt: "Noklikšķiniet, lai sāktu datumu diapazona atlasi",
  todayDate: (e) => `Šodien, ${e.date}`,
  todayDateSelected: (e) => `Atlasīta šodiena, ${e.date}`
};
var o4 = {};
o4 = {
  dateRange: (e) => `${e.startDate} til ${e.endDate}`,
  dateSelected: (e) => `${e.date} valgt`,
  finishRangeSelectionPrompt: "Klikk for å fullføre valg av datoområde",
  maximumDate: "Siste tilgjengelige dato",
  minimumDate: "Første tilgjengelige dato",
  next: "Neste",
  previous: "Forrige",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt område: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klikk for å starte valg av datoområde",
  todayDate: (e) => `I dag, ${e.date}`,
  todayDateSelected: (e) => `I dag, ${e.date} valgt`
};
var s4 = {};
s4 = {
  dateRange: (e) => `${e.startDate} tot ${e.endDate}`,
  dateSelected: (e) => `${e.date} geselecteerd`,
  finishRangeSelectionPrompt: "Klik om de selectie van het datumbereik te voltooien",
  maximumDate: "Laatste beschikbare datum",
  minimumDate: "Eerste beschikbare datum",
  next: "Volgende",
  previous: "Vorige",
  selectedDateDescription: (e) => `Geselecteerde datum: ${e.date}`,
  selectedRangeDescription: (e) => `Geselecteerd bereik: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klik om het datumbereik te selecteren",
  todayDate: (e) => `Vandaag, ${e.date}`,
  todayDateSelected: (e) => `Vandaag, ${e.date} geselecteerd`
};
var d4 = {};
d4 = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `Wybrano ${e.date}`,
  finishRangeSelectionPrompt: "Kliknij, aby zakończyć wybór zakresu dat",
  maximumDate: "Ostatnia dostępna data",
  minimumDate: "Pierwsza dostępna data",
  next: "Dalej",
  previous: "Wstecz",
  selectedDateDescription: (e) => `Wybrana data: ${e.date}`,
  selectedRangeDescription: (e) => `Wybrany zakres: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknij, aby rozpocząć wybór zakresu dat",
  todayDate: (e) => `Dzisiaj, ${e.date}`,
  todayDateSelected: (e) => `Dzisiaj wybrano ${e.date}`
};
var c4 = {};
c4 = {
  dateRange: (e) => `${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} selecionado`,
  finishRangeSelectionPrompt: "Clique para concluir a seleção do intervalo de datas",
  maximumDate: "Última data disponível",
  minimumDate: "Primeira data disponível",
  next: "Próximo",
  previous: "Anterior",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.dateRange}`,
  startRangeSelectionPrompt: "Clique para iniciar a seleção do intervalo de datas",
  todayDate: (e) => `Hoje, ${e.date}`,
  todayDateSelected: (e) => `Hoje, ${e.date} selecionado`
};
var f4 = {};
f4 = {
  dateRange: (e) => `${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} selecionado`,
  finishRangeSelectionPrompt: "Clique para terminar de selecionar o intervalo de datas",
  maximumDate: "Última data disponível",
  minimumDate: "Primeira data disponível",
  next: "Próximo",
  previous: "Anterior",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.dateRange}`,
  startRangeSelectionPrompt: "Clique para começar a selecionar o intervalo de datas",
  todayDate: (e) => `Hoje, ${e.date}`,
  todayDateSelected: (e) => `Hoje, ${e.date} selecionado`
};
var h4 = {};
h4 = {
  dateRange: (e) => `De la ${e.startDate} până la ${e.endDate}`,
  dateSelected: (e) => `${e.date} selectată`,
  finishRangeSelectionPrompt: "Apăsaţi pentru a finaliza selecţia razei pentru dată",
  maximumDate: "Ultima dată disponibilă",
  minimumDate: "Prima dată disponibilă",
  next: "Următorul",
  previous: "Înainte",
  selectedDateDescription: (e) => `Dată selectată: ${e.date}`,
  selectedRangeDescription: (e) => `Interval selectat: ${e.dateRange}`,
  startRangeSelectionPrompt: "Apăsaţi pentru a începe selecţia razei pentru dată",
  todayDate: (e) => `Astăzi, ${e.date}`,
  todayDateSelected: (e) => `Azi, ${e.date} selectată`
};
var m4 = {};
m4 = {
  dateRange: (e) => `С ${e.startDate} по ${e.endDate}`,
  dateSelected: (e) => `Выбрано ${e.date}`,
  finishRangeSelectionPrompt: "Щелкните, чтобы завершить выбор диапазона дат",
  maximumDate: "Последняя доступная дата",
  minimumDate: "Первая доступная дата",
  next: "Далее",
  previous: "Назад",
  selectedDateDescription: (e) => `Выбранная дата: ${e.date}`,
  selectedRangeDescription: (e) => `Выбранный диапазон: ${e.dateRange}`,
  startRangeSelectionPrompt: "Щелкните, чтобы начать выбор диапазона дат",
  todayDate: (e) => `Сегодня, ${e.date}`,
  todayDateSelected: (e) => `Сегодня, выбрано ${e.date}`
};
var b4 = {};
b4 = {
  dateRange: (e) => `Od ${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `Vybratý dátum ${e.date}`,
  finishRangeSelectionPrompt: "Kliknutím dokončíte výber rozsahu dátumov",
  maximumDate: "Posledný dostupný dátum",
  minimumDate: "Prvý dostupný dátum",
  next: "Nasledujúce",
  previous: "Predchádzajúce",
  selectedDateDescription: (e) => `Vybratý dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybratý rozsah: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknutím spustíte výber rozsahu dátumov",
  todayDate: (e) => `Dnes ${e.date}`,
  todayDateSelected: (e) => `Vybratý dnešný dátum ${e.date}`
};
var p4 = {};
p4 = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `${e.date} izbrano`,
  finishRangeSelectionPrompt: "Kliknite za dokončanje izbire datumskega obsega",
  maximumDate: "Zadnji razpoložljivi datum",
  minimumDate: "Prvi razpoložljivi datum",
  next: "Naprej",
  previous: "Nazaj",
  selectedDateDescription: (e) => `Izbrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izbrano območje: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknite za začetek izbire datumskega obsega",
  todayDate: (e) => `Danes, ${e.date}`,
  todayDateSelected: (e) => `Danes, ${e.date} izbrano`
};
var g4 = {};
g4 = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `${e.date} izabran`,
  finishRangeSelectionPrompt: "Kliknite da dovršite opseg izabranih datuma",
  maximumDate: "Zadnji raspoloživi datum",
  minimumDate: "Prvi raspoloživi datum",
  next: "Sledeći",
  previous: "Prethodni",
  selectedDateDescription: (e) => `Izabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izabrani period: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknite da započnete opseg izabranih datuma",
  todayDate: (e) => `Danas, ${e.date}`,
  todayDateSelected: (e) => `Danas, izabran ${e.date}`
};
var y4 = {};
y4 = {
  dateRange: (e) => `${e.startDate} till ${e.endDate}`,
  dateSelected: (e) => `${e.date} har valts`,
  finishRangeSelectionPrompt: "Klicka för att avsluta val av datumintervall",
  maximumDate: "Sista tillgängliga datum",
  minimumDate: "Första tillgängliga datum",
  next: "Nästa",
  previous: "Föregående",
  selectedDateDescription: (e) => `Valt datum: ${e.date}`,
  selectedRangeDescription: (e) => `Valt intervall: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klicka för att välja datumintervall",
  todayDate: (e) => `Idag, ${e.date}`,
  todayDateSelected: (e) => `Idag, ${e.date} har valts`
};
var $4 = {};
$4 = {
  dateRange: (e) => `${e.startDate} - ${e.endDate}`,
  dateSelected: (e) => `${e.date} seçildi`,
  finishRangeSelectionPrompt: "Tarih aralığı seçimini tamamlamak için tıklayın",
  maximumDate: "Son müsait tarih",
  minimumDate: "İlk müsait tarih",
  next: "Sonraki",
  previous: "Önceki",
  selectedDateDescription: (e) => `Seçilen Tarih: ${e.date}`,
  selectedRangeDescription: (e) => `Seçilen Aralık: ${e.dateRange}`,
  startRangeSelectionPrompt: "Tarih aralığı seçimini başlatmak için tıklayın",
  todayDate: (e) => `Bugün, ${e.date}`,
  todayDateSelected: (e) => `Bugün, ${e.date} seçildi`
};
var v4 = {};
v4 = {
  dateRange: (e) => `${e.startDate} — ${e.endDate}`,
  dateSelected: (e) => `Вибрано ${e.date}`,
  finishRangeSelectionPrompt: "Натисніть, щоб завершити вибір діапазону дат",
  maximumDate: "Остання доступна дата",
  minimumDate: "Перша доступна дата",
  next: "Наступний",
  previous: "Попередній",
  selectedDateDescription: (e) => `Вибрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Вибраний діапазон: ${e.dateRange}`,
  startRangeSelectionPrompt: "Натисніть, щоб почати вибір діапазону дат",
  todayDate: (e) => `Сьогодні, ${e.date}`,
  todayDateSelected: (e) => `Сьогодні, вибрано ${e.date}`
};
var D4 = {};
D4 = {
  dateRange: (e) => `${e.startDate} 至 ${e.endDate}`,
  dateSelected: (e) => `已选择 ${e.date}`,
  finishRangeSelectionPrompt: "单击以完成选择日期范围",
  maximumDate: "最后一个可用日期",
  minimumDate: "第一个可用日期",
  next: "下一页",
  previous: "上一页",
  selectedDateDescription: (e) => `选定的日期：${e.date}`,
  selectedRangeDescription: (e) => `选定的范围：${e.dateRange}`,
  startRangeSelectionPrompt: "单击以开始选择日期范围",
  todayDate: (e) => `今天，即 ${e.date}`,
  todayDateSelected: (e) => `已选择今天，即 ${e.date}`
};
var x4 = {};
x4 = {
  dateRange: (e) => `${e.startDate} 至 ${e.endDate}`,
  dateSelected: (e) => `已選取 ${e.date}`,
  finishRangeSelectionPrompt: "按一下以完成選取日期範圍",
  maximumDate: "最後一個可用日期",
  minimumDate: "第一個可用日期",
  next: "下一頁",
  previous: "上一頁",
  selectedDateDescription: (e) => `選定的日期：${e.date}`,
  selectedRangeDescription: (e) => `選定的範圍：${e.dateRange}`,
  startRangeSelectionPrompt: "按一下以開始選取日期範圍",
  todayDate: (e) => `今天，${e.date}`,
  todayDateSelected: (e) => `已選取今天，${e.date}`
};
var pa = {};
pa = {
  "ar-AE": Uf,
  "bg-BG": jf,
  "cs-CZ": _f,
  "da-DK": Wf,
  "de-DE": Gf,
  "el-GR": qf,
  "en-US": Yf,
  "es-ES": Zf,
  "et-EE": Xf,
  "fi-FI": Jf,
  "fr-FR": Qf,
  "he-IL": e4,
  "hr-HR": t4,
  "hu-HU": n4,
  "it-IT": r4,
  "ja-JP": a4,
  "ko-KR": l4,
  "lt-LT": i4,
  "lv-LV": u4,
  "nb-NO": o4,
  "nl-NL": s4,
  "pl-PL": d4,
  "pt-BR": c4,
  "pt-PT": f4,
  "ro-RO": h4,
  "ru-RU": m4,
  "sk-SK": b4,
  "sl-SI": p4,
  "sr-SP": g4,
  "sv-SE": y4,
  "tr-TR": $4,
  "uk-UA": v4,
  "zh-CN": D4,
  "zh-TW": x4
};
function E4(e, t) {
  let n = T(null);
  return e && n.current && t(e, n.current) && (e = n.current), n.current = e, e;
}
function cr(e, t) {
  return e - t * Math.floor(e / t);
}
const C4 = 1721426;
function Tn(e, t, n, r) {
  t = ga(e, t);
  let a = t - 1, l = -2;
  return n <= 2 ? l = 0 : fn(t) && (l = -1), C4 - 1 + 365 * a + Math.floor(a / 4) - Math.floor(a / 100) + Math.floor(a / 400) + Math.floor((367 * n - 362) / 12 + l + r);
}
function fn(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function ga(e, t) {
  return e === "BC" ? 1 - t : t;
}
function El(e) {
  let t = "AD";
  return e <= 0 && (t = "BC", e = 1 - e), [
    t,
    e
  ];
}
const I2 = {
  standard: [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ],
  leapyear: [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
};
class _e {
  fromJulianDay(t) {
    let n = t, r = n - C4, a = Math.floor(r / 146097), l = cr(r, 146097), i = Math.floor(l / 36524), u = cr(l, 36524), o = Math.floor(u / 1461), d = cr(u, 1461), s = Math.floor(d / 365), c = a * 400 + i * 100 + o * 4 + s + (i !== 4 && s !== 4 ? 1 : 0), [f, h] = El(c), m = n - Tn(f, h, 1, 1), b = 2;
    n < Tn(f, h, 3, 1) ? b = 0 : fn(h) && (b = 1);
    let p = Math.floor(((m + b) * 12 + 373) / 367), y = n - Tn(f, h, p, 1) + 1;
    return new Te(f, h, p, y);
  }
  toJulianDay(t) {
    return Tn(t.era, t.year, t.month, t.day);
  }
  getDaysInMonth(t) {
    return I2[fn(t.year) ? "leapyear" : "standard"][t.month - 1];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMonthsInYear(t) {
    return 12;
  }
  getDaysInYear(t) {
    return fn(t.year) ? 366 : 365;
  }
  getMaximumMonthsInYear() {
    return 12;
  }
  getMaximumDaysInMonth() {
    return 31;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getYearsInEra(t) {
    return 9999;
  }
  getEras() {
    return [
      "BC",
      "AD"
    ];
  }
  isInverseEra(t) {
    return t.era === "BC";
  }
  balanceDate(t) {
    t.year <= 0 && (t.era = t.era === "BC" ? "AD" : "BC", t.year = 1 - t.year);
  }
  constructor() {
    this.identifier = "gregory";
  }
}
const M2 = {
  "001": 1,
  AD: 1,
  AE: 6,
  AF: 6,
  AI: 1,
  AL: 1,
  AM: 1,
  AN: 1,
  AR: 1,
  AT: 1,
  AU: 1,
  AX: 1,
  AZ: 1,
  BA: 1,
  BE: 1,
  BG: 1,
  BH: 6,
  BM: 1,
  BN: 1,
  BY: 1,
  CH: 1,
  CL: 1,
  CM: 1,
  CN: 1,
  CR: 1,
  CY: 1,
  CZ: 1,
  DE: 1,
  DJ: 6,
  DK: 1,
  DZ: 6,
  EC: 1,
  EE: 1,
  EG: 6,
  ES: 1,
  FI: 1,
  FJ: 1,
  FO: 1,
  FR: 1,
  GB: 1,
  GE: 1,
  GF: 1,
  GP: 1,
  GR: 1,
  HR: 1,
  HU: 1,
  IE: 1,
  IQ: 6,
  IR: 6,
  IS: 1,
  IT: 1,
  JO: 6,
  KG: 1,
  KW: 6,
  KZ: 1,
  LB: 1,
  LI: 1,
  LK: 1,
  LT: 1,
  LU: 1,
  LV: 1,
  LY: 6,
  MC: 1,
  MD: 1,
  ME: 1,
  MK: 1,
  MN: 1,
  MQ: 1,
  MV: 5,
  MY: 1,
  NL: 1,
  NO: 1,
  NZ: 1,
  OM: 6,
  PL: 1,
  QA: 6,
  RE: 1,
  RO: 1,
  RS: 1,
  RU: 1,
  SD: 6,
  SE: 1,
  SI: 1,
  SK: 1,
  SM: 1,
  SY: 6,
  TJ: 1,
  TM: 1,
  TR: 1,
  UA: 1,
  UY: 1,
  UZ: 1,
  VA: 1,
  VN: 1,
  XK: 1
};
function Fe(e, t) {
  return t = ke(t, e.calendar), e.era === t.era && e.year === t.year && e.month === t.month && e.day === t.day;
}
function K2(e, t) {
  return t = ke(t, e.calendar), e = Ln(e), t = Ln(t), e.era === t.era && e.year === t.year && e.month === t.month;
}
function N2(e, t) {
  return Cl(e.calendar, t.calendar) && Fe(e, t);
}
function Cl(e, t) {
  return e.isEqual?.(t) ?? t.isEqual?.(e) ?? e.identifier === t.identifier;
}
function P4(e, t) {
  return Fe(e, Bu(t));
}
const V2 = {
  sun: 0,
  mon: 1,
  tue: 2,
  wed: 3,
  thu: 4,
  fri: 5,
  sat: 6
};
function ku(e, t, n) {
  let r = e.calendar.toJulianDay(e), a = n ? V2[n] : U2(t), l = Math.ceil(r + 1 - a) % 7;
  return l < 0 && (l += 7), l;
}
function w4(e) {
  return pt(Date.now(), e);
}
function Bu(e) {
  return it(w4(e));
}
function S4(e, t) {
  return e.calendar.toJulianDay(e) - t.calendar.toJulianDay(t);
}
function k4(e, t) {
  return $s(e) - $s(t);
}
function $s(e) {
  return e.hour * 36e5 + e.minute * 6e4 + e.second * 1e3 + e.millisecond;
}
let Gl = null, L2 = !1;
function ya() {
  return Gl == null && (Gl = new Intl.DateTimeFormat().resolvedOptions().timeZone), Gl;
}
function B4() {
  return L2;
}
function Ln(e) {
  return e.subtract({
    days: e.day - 1
  });
}
function nl(e) {
  return e.add({
    days: e.calendar.getDaysInMonth(e) - e.day
  });
}
function z2(e) {
  return Ln(e.subtract({
    months: e.month - 1
  }));
}
function Qr(e, t, n) {
  let r = ku(e, t, n);
  return e.subtract({
    days: r
  });
}
function O2(e, t, n) {
  return Qr(e, t, n).add({
    days: 6
  });
}
const vs = /* @__PURE__ */ new Map(), ql = /* @__PURE__ */ new Map();
function H2(e) {
  if (Intl.Locale) {
    let n = vs.get(e);
    return n || (n = new Intl.Locale(e).maximize().region, n && vs.set(e, n)), n;
  }
  let t = e.split("-")[1];
  return t === "u" ? void 0 : t;
}
function U2(e) {
  let t = ql.get(e);
  if (!t) {
    if (Intl.Locale) {
      let r = new Intl.Locale(e);
      if ("getWeekInfo" in r && (t = r.getWeekInfo(), t))
        return ql.set(e, t), t.firstDay;
    }
    let n = H2(e);
    if (e.includes("-fw-")) {
      let r = e.split("-fw-")[1].split("-")[0];
      r === "mon" ? t = {
        firstDay: 1
      } : r === "tue" ? t = {
        firstDay: 2
      } : r === "wed" ? t = {
        firstDay: 3
      } : r === "thu" ? t = {
        firstDay: 4
      } : r === "fri" ? t = {
        firstDay: 5
      } : r === "sat" ? t = {
        firstDay: 6
      } : t = {
        firstDay: 0
      };
    } else e.includes("-ca-iso8601") ? t = {
      firstDay: 1
    } : t = {
      firstDay: n && M2[n] || 0
    };
    ql.set(e, t);
  }
  return t.firstDay;
}
function j2(e, t, n) {
  let r = e.calendar.getDaysInMonth(e);
  return Math.ceil((ku(Ln(e), t, n) + r) / 7);
}
function F4(e, t) {
  return e && t ? e.compare(t) <= 0 ? e : t : e || t;
}
function A4(e, t) {
  return e && t ? e.compare(t) >= 0 ? e : t : e || t;
}
function gn(e) {
  e = ke(e, new _e());
  let t = ga(e.era, e.year);
  return R4(t, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
}
function R4(e, t, n, r, a, l, i) {
  let u = /* @__PURE__ */ new Date();
  return u.setUTCHours(r, a, l, i), u.setUTCFullYear(e, t - 1, n), u.getTime();
}
function ea(e, t) {
  if (t === "UTC") return 0;
  if (e > 0 && t === ya() && !B4()) return new Date(e).getTimezoneOffset() * -6e4;
  let { year: n, month: r, day: a, hour: l, minute: i, second: u } = T4(e, t);
  return R4(n, r, a, l, i, u, 0) - Math.floor(e / 1e3) * 1e3;
}
const Ds = /* @__PURE__ */ new Map();
function T4(e, t) {
  let n = Ds.get(t);
  n || (n = new Intl.DateTimeFormat("en-US", {
    timeZone: t,
    hour12: !1,
    era: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), Ds.set(t, n));
  let r = n.formatToParts(new Date(e)), a = {};
  for (let l of r) l.type !== "literal" && (a[l.type] = l.value);
  return {
    // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
    year: a.era === "BC" || a.era === "B" ? -a.year + 1 : +a.year,
    month: +a.month,
    day: +a.day,
    hour: a.hour === "24" ? 0 : +a.hour,
    minute: +a.minute,
    second: +a.second
  };
}
const rl = 864e5;
function _2(e, t) {
  let n = gn(e), r = n - ea(n - rl, t), a = n - ea(n + rl, t);
  return I4(e, t, r, a);
}
function I4(e, t, n, r) {
  return (n === r ? [
    n
  ] : [
    n,
    r
  ]).filter((l) => W2(e, t, l));
}
function W2(e, t, n) {
  let r = T4(n, t);
  return e.year === r.year && e.month === r.month && e.day === r.day && e.hour === r.hour && e.minute === r.minute && e.second === r.second;
}
function Mt(e, t, n = "compatible") {
  let r = Et(e);
  if (t === "UTC") return gn(r);
  if (t === ya() && n === "compatible" && !B4()) {
    r = ke(r, new _e());
    let o = /* @__PURE__ */ new Date(), d = ga(r.era, r.year);
    return o.setFullYear(d, r.month - 1, r.day), o.setHours(r.hour, r.minute, r.second, r.millisecond), o.getTime();
  }
  let a = gn(r), l = ea(a - rl, t), i = ea(a + rl, t), u = I4(r, t, a - l, a - i);
  if (u.length === 1) return u[0];
  if (u.length > 1) switch (n) {
    // 'compatible' means 'earlier' for "fall back" transitions
    case "compatible":
    case "earlier":
      return u[0];
    case "later":
      return u[u.length - 1];
    case "reject":
      throw new RangeError("Multiple possible absolute times found");
  }
  switch (n) {
    case "earlier":
      return Math.min(a - l, a - i);
    // 'compatible' means 'later' for "spring forward" transitions
    case "compatible":
    case "later":
      return Math.max(a - l, a - i);
    case "reject":
      throw new RangeError("No such absolute time found");
  }
}
function M4(e, t, n = "compatible") {
  return new Date(Mt(e, t, n));
}
function pt(e, t) {
  let n = ea(e, t), r = new Date(e + n), a = r.getUTCFullYear(), l = r.getUTCMonth() + 1, i = r.getUTCDate(), u = r.getUTCHours(), o = r.getUTCMinutes(), d = r.getUTCSeconds(), s = r.getUTCMilliseconds();
  return new On(a < 1 ? "BC" : "AD", a < 1 ? -a + 1 : a, l, i, t, n, u, o, d, s);
}
function tC(e, t) {
  return pt(e.getTime(), t);
}
function it(e) {
  return new Te(e.calendar, e.era, e.year, e.month, e.day);
}
function Et(e, t) {
  let n = 0, r = 0, a = 0, l = 0;
  if ("timeZone" in e) ({ hour: n, minute: r, second: a, millisecond: l } = e);
  else if ("hour" in e && !t) return e;
  return t && ({ hour: n, minute: r, second: a, millisecond: l } = t), new na(e.calendar, e.era, e.year, e.month, e.day, n, r, a, l);
}
function ke(e, t) {
  if (Cl(e.calendar, t)) return e;
  let n = t.fromJulianDay(e.calendar.toJulianDay(e)), r = e.copy();
  return r.calendar = t, r.era = n.era, r.year = n.year, r.month = n.month, r.day = n.day, zn(r), r;
}
function G2(e, t, n) {
  if (e instanceof On)
    return e.timeZone === t ? e : Fu(e, t);
  let r = Mt(e, t, n);
  return pt(r, t);
}
function q2(e) {
  let t = gn(e) - e.offset;
  return new Date(t);
}
function Fu(e, t) {
  let n = gn(e) - e.offset;
  return ke(pt(n, t), e.calendar);
}
function Y2(e) {
  return Fu(e, ya());
}
const Kr = 36e5;
function Pl(e, t) {
  let n = e.copy(), r = "hour" in n ? L4(n, t) : 0;
  Mi(n, t.years || 0), n.calendar.balanceYearMonth && n.calendar.balanceYearMonth(n, e), n.month += t.months || 0, Ki(n), K4(n), n.day += (t.weeks || 0) * 7, n.day += t.days || 0, n.day += r, Z2(n), n.calendar.balanceDate && n.calendar.balanceDate(n), n.year < 1 && (n.year = 1, n.month = 1, n.day = 1);
  let a = n.calendar.getYearsInEra(n);
  if (n.year > a) {
    let i = n.calendar.isInverseEra?.(n);
    n.year = a, n.month = i ? 1 : n.calendar.getMonthsInYear(n), n.day = i ? 1 : n.calendar.getDaysInMonth(n);
  }
  n.month < 1 && (n.month = 1, n.day = 1);
  let l = n.calendar.getMonthsInYear(n);
  return n.month > l && (n.month = l, n.day = n.calendar.getDaysInMonth(n)), n.day = Math.max(1, Math.min(n.calendar.getDaysInMonth(n), n.day)), n;
}
function Mi(e, t) {
  e.calendar.isInverseEra?.(e) && (t = -t), e.year += t;
}
function Ki(e) {
  for (; e.month < 1; )
    Mi(e, -1), e.month += e.calendar.getMonthsInYear(e);
  let t = 0;
  for (; e.month > (t = e.calendar.getMonthsInYear(e)); )
    e.month -= t, Mi(e, 1);
}
function Z2(e) {
  for (; e.day < 1; )
    e.month--, Ki(e), e.day += e.calendar.getDaysInMonth(e);
  for (; e.day > e.calendar.getDaysInMonth(e); )
    e.day -= e.calendar.getDaysInMonth(e), e.month++, Ki(e);
}
function K4(e) {
  e.month = Math.max(1, Math.min(e.calendar.getMonthsInYear(e), e.month)), e.day = Math.max(1, Math.min(e.calendar.getDaysInMonth(e), e.day));
}
function zn(e) {
  e.calendar.constrainDate && e.calendar.constrainDate(e), e.year = Math.max(1, Math.min(e.calendar.getYearsInEra(e), e.year)), K4(e);
}
function Au(e) {
  let t = {};
  for (let n in e) typeof e[n] == "number" && (t[n] = -e[n]);
  return t;
}
function N4(e, t) {
  return Pl(e, Au(t));
}
function Ru(e, t) {
  let n = e.copy();
  return t.era != null && (n.era = t.era), t.year != null && (n.year = t.year), t.month != null && (n.month = t.month), t.day != null && (n.day = t.day), zn(n), n;
}
function ta(e, t) {
  let n = e.copy();
  return t.hour != null && (n.hour = t.hour), t.minute != null && (n.minute = t.minute), t.second != null && (n.second = t.second), t.millisecond != null && (n.millisecond = t.millisecond), V4(n), n;
}
function X2(e) {
  e.second += Math.floor(e.millisecond / 1e3), e.millisecond = Fa(e.millisecond, 1e3), e.minute += Math.floor(e.second / 60), e.second = Fa(e.second, 60), e.hour += Math.floor(e.minute / 60), e.minute = Fa(e.minute, 60);
  let t = Math.floor(e.hour / 24);
  return e.hour = Fa(e.hour, 24), t;
}
function V4(e) {
  e.millisecond = Math.max(0, Math.min(e.millisecond, 1e3)), e.second = Math.max(0, Math.min(e.second, 59)), e.minute = Math.max(0, Math.min(e.minute, 59)), e.hour = Math.max(0, Math.min(e.hour, 23));
}
function Fa(e, t) {
  let n = e % t;
  return n < 0 && (n += t), n;
}
function L4(e, t) {
  return e.hour += t.hours || 0, e.minute += t.minutes || 0, e.second += t.seconds || 0, e.millisecond += t.milliseconds || 0, X2(e);
}
function z4(e, t) {
  let n = e.copy();
  return L4(n, t), n;
}
function J2(e, t) {
  return z4(e, Au(t));
}
function Tu(e, t, n, r) {
  let a = e.copy();
  switch (t) {
    case "era": {
      let l = e.calendar.getEras(), i = l.indexOf(e.era);
      if (i < 0) throw new Error("Invalid era: " + e.era);
      i = Gt(i, n, 0, l.length - 1, r?.round), a.era = l[i], zn(a);
      break;
    }
    case "year":
      a.calendar.isInverseEra?.(a) && (n = -n), a.year = Gt(e.year, n, -1 / 0, 9999, r?.round), a.year === -1 / 0 && (a.year = 1), a.calendar.balanceYearMonth && a.calendar.balanceYearMonth(a, e);
      break;
    case "month":
      a.month = Gt(e.month, n, 1, e.calendar.getMonthsInYear(e), r?.round);
      break;
    case "day":
      a.day = Gt(e.day, n, 1, e.calendar.getDaysInMonth(e), r?.round);
      break;
    default:
      throw new Error("Unsupported field " + t);
  }
  return e.calendar.balanceDate && e.calendar.balanceDate(a), zn(a), a;
}
function Iu(e, t, n, r) {
  let a = e.copy();
  switch (t) {
    case "hour": {
      let l = e.hour, i = 0, u = 23;
      if (r?.hourCycle === 12) {
        let o = l >= 12;
        i = o ? 12 : 0, u = o ? 23 : 11;
      }
      a.hour = Gt(l, n, i, u, r?.round);
      break;
    }
    case "minute":
      a.minute = Gt(e.minute, n, 0, 59, r?.round);
      break;
    case "second":
      a.second = Gt(e.second, n, 0, 59, r?.round);
      break;
    case "millisecond":
      a.millisecond = Gt(e.millisecond, n, 0, 999, r?.round);
      break;
    default:
      throw new Error("Unsupported field " + t);
  }
  return a;
}
function Gt(e, t, n, r, a = !1) {
  if (a) {
    e += Math.sign(t), e < n && (e = r);
    let l = Math.abs(t);
    t > 0 ? e = Math.ceil(e / l) * l : e = Math.floor(e / l) * l, e > r && (e = n);
  } else
    e += t, e < n ? e = r - (n - e - 1) : e > r && (e = n + (e - r - 1));
  return e;
}
function O4(e, t) {
  let n;
  if (t.years != null && t.years !== 0 || t.months != null && t.months !== 0 || t.weeks != null && t.weeks !== 0 || t.days != null && t.days !== 0) {
    let a = Pl(Et(e), {
      years: t.years,
      months: t.months,
      weeks: t.weeks,
      days: t.days
    });
    n = Mt(a, e.timeZone);
  } else
    n = gn(e) - e.offset;
  n += t.milliseconds || 0, n += (t.seconds || 0) * 1e3, n += (t.minutes || 0) * 6e4, n += (t.hours || 0) * 36e5;
  let r = pt(n, e.timeZone);
  return ke(r, e.calendar);
}
function Q2(e, t) {
  return O4(e, Au(t));
}
function e6(e, t, n, r) {
  switch (t) {
    case "hour": {
      let a = 0, l = 23;
      if (r?.hourCycle === 12) {
        let m = e.hour >= 12;
        a = m ? 12 : 0, l = m ? 23 : 11;
      }
      let i = Et(e), u = ke(ta(i, {
        hour: a
      }), new _e()), o = [
        Mt(u, e.timeZone, "earlier"),
        Mt(u, e.timeZone, "later")
      ].filter((m) => pt(m, e.timeZone).day === u.day)[0], d = ke(ta(i, {
        hour: l
      }), new _e()), s = [
        Mt(d, e.timeZone, "earlier"),
        Mt(d, e.timeZone, "later")
      ].filter((m) => pt(m, e.timeZone).day === d.day).pop(), c = gn(e) - e.offset, f = Math.floor(c / Kr), h = c % Kr;
      return c = Gt(f, n, Math.floor(o / Kr), Math.floor(s / Kr), r?.round) * Kr + h, ke(pt(c, e.timeZone), e.calendar);
    }
    case "minute":
    case "second":
    case "millisecond":
      return Iu(e, t, n, r);
    case "era":
    case "year":
    case "month":
    case "day": {
      let a = Tu(Et(e), t, n, r), l = Mt(a, e.timeZone);
      return ke(pt(l, e.timeZone), e.calendar);
    }
    default:
      throw new Error("Unsupported field " + t);
  }
}
function t6(e, t, n) {
  let r = Et(e), a = ta(Ru(r, t), t);
  if (a.compare(r) === 0) return e;
  let l = Mt(a, e.timeZone, n);
  return ke(pt(l, e.timeZone), e.calendar);
}
const n6 = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})$/, r6 = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/, a6 = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:([+-]\d{2})(?::?(\d{2}))?(?::?(\d{2}))?)?\[(.*?)\]$/, Mu = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:(?:([+-]\d{2})(?::?(\d{2}))?)|Z)$/;
function l6(e) {
  let t = e.match(n6);
  if (!t)
    throw Mu.test(e) ? new Error(`Invalid ISO 8601 date string: ${e}. Use parseAbsolute() instead.`) : new Error("Invalid ISO 8601 date string: " + e);
  let n = new Te(ve(t[1], 0, 9999), ve(t[2], 1, 12), 1);
  return n.day = ve(t[3], 1, n.calendar.getDaysInMonth(n)), n;
}
function i6(e) {
  let t = e.match(r6);
  if (!t)
    throw Mu.test(e) ? new Error(`Invalid ISO 8601 date time string: ${e}. Use parseAbsolute() instead.`) : new Error("Invalid ISO 8601 date time string: " + e);
  let n = ve(t[1], -9999, 9999), r = n < 1 ? "BC" : "AD", a = new na(r, n < 1 ? -n + 1 : n, ve(t[2], 1, 12), 1, t[4] ? ve(t[4], 0, 23) : 0, t[5] ? ve(t[5], 0, 59) : 0, t[6] ? ve(t[6], 0, 59) : 0, t[7] ? ve(t[7], 0, 1 / 0) * 1e3 : 0);
  return a.day = ve(t[3], 0, a.calendar.getDaysInMonth(a)), a;
}
function nC(e, t) {
  let n = e.match(a6);
  if (!n) throw new Error("Invalid ISO 8601 date time string: " + e);
  let r = ve(n[1], -9999, 9999), a = r < 1 ? "BC" : "AD", l = new On(a, r < 1 ? -r + 1 : r, ve(n[2], 1, 12), 1, n[11], 0, n[4] ? ve(n[4], 0, 23) : 0, n[5] ? ve(n[5], 0, 59) : 0, n[6] ? ve(n[6], 0, 59) : 0, n[7] ? ve(n[7], 0, 1 / 0) * 1e3 : 0);
  l.day = ve(n[3], 0, l.calendar.getDaysInMonth(l));
  let i = Et(l), u;
  if (n[8]) {
    let o = ve(n[8], -23, 23);
    if (l.offset = Math.sign(o) * (Math.abs(o) * 36e5 + ve(n[9] ?? "0", 0, 59) * 6e4 + ve(n[10] ?? "0", 0, 59) * 1e3), u = gn(l) - l.offset, !_2(i, l.timeZone).includes(u)) throw new Error(`Offset ${j4(l.offset)} is invalid for ${Ku(l)} in ${l.timeZone}`);
  } else
    u = Mt(Et(i), l.timeZone, t);
  return pt(u, l.timeZone);
}
function u6(e, t) {
  let n = e.match(Mu);
  if (!n) throw new Error("Invalid ISO 8601 date time string: " + e);
  let r = ve(n[1], -9999, 9999), a = r < 1 ? "BC" : "AD", l = new On(a, r < 1 ? -r + 1 : r, ve(n[2], 1, 12), 1, t, 0, n[4] ? ve(n[4], 0, 23) : 0, n[5] ? ve(n[5], 0, 59) : 0, n[6] ? ve(n[6], 0, 59) : 0, n[7] ? ve(n[7], 0, 1 / 0) * 1e3 : 0);
  return l.day = ve(n[3], 0, l.calendar.getDaysInMonth(l)), n[8] && (l.offset = ve(n[8], -23, 23) * 36e5 + ve(n[9] ?? "0", 0, 59) * 6e4), Fu(l, t);
}
function rC(e) {
  return u6(e, ya());
}
function ve(e, t, n) {
  let r = Number(e);
  if (r < t || r > n) throw new RangeError(`Value out of range: ${t} <= ${r} <= ${n}`);
  return r;
}
function H4(e) {
  return `${String(e.hour).padStart(2, "0")}:${String(e.minute).padStart(2, "0")}:${String(e.second).padStart(2, "0")}${e.millisecond ? String(e.millisecond / 1e3).slice(1) : ""}`;
}
function U4(e) {
  let t = ke(e, new _e()), n;
  return t.era === "BC" ? n = t.year === 1 ? "0000" : "-" + String(Math.abs(1 - t.year)).padStart(6, "00") : n = String(t.year).padStart(4, "0"), `${n}-${String(t.month).padStart(2, "0")}-${String(t.day).padStart(2, "0")}`;
}
function Ku(e) {
  return `${U4(e)}T${H4(e)}`;
}
function j4(e) {
  let t = Math.sign(e) < 0 ? "-" : "+";
  e = Math.abs(e);
  let n = Math.floor(e / 36e5), r = Math.floor(e % 36e5 / 6e4), a = Math.floor(e % 36e5 % 6e4 / 1e3), l = `${t}${String(n).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
  return a !== 0 && (l += `:${String(a).padStart(2, "0")}`), l;
}
function o6(e) {
  return `${Ku(e)}${j4(e.offset)}[${e.timeZone}]`;
}
function Nu(e) {
  let t = typeof e[0] == "object" ? e.shift() : new _e(), n;
  if (typeof e[0] == "string") n = e.shift();
  else {
    let i = t.getEras();
    n = i[i.length - 1];
  }
  let r = e.shift(), a = e.shift(), l = e.shift();
  return [
    t,
    n,
    r,
    a,
    l
  ];
}
class Te {
  // This prevents TypeScript from allowing other types with the same fields to match.
  // i.e. a ZonedDateTime should not be be passable to a parameter that expects CalendarDate.
  // If that behavior is desired, use the AnyCalendarDate interface instead.
  // @ts-ignore
  #e;
  constructor(...t) {
    let [n, r, a, l, i] = Nu(t);
    this.calendar = n, this.era = r, this.year = a, this.month = l, this.day = i, zn(this);
  }
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Te(this.calendar, this.era, this.year, this.month, this.day) : new Te(this.calendar, this.year, this.month, this.day);
  }
  /** Returns a new `CalendarDate` with the given duration added to it. */
  add(t) {
    return Pl(this, t);
  }
  /** Returns a new `CalendarDate` with the given duration subtracted from it. */
  subtract(t) {
    return N4(this, t);
  }
  /**
  * Returns a new `CalendarDate` with the given fields set to the provided values. Other fields
  * will be constrained accordingly.
  */
  set(t) {
    return Ru(this, t);
  }
  /**
  * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    return Tu(this, t, n, r);
  }
  /**
  * Converts the date to a native JavaScript Date object, with the time set to midnight in the
  * given time zone.
  */
  toDate(t) {
    return M4(this, t);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return U4(this);
  }
  /**
  * Compares this date with another. A negative result indicates that this date is before the given
  * one, and a positive date indicates that it is after.
  */
  compare(t) {
    return S4(this, t);
  }
}
class Vu {
  // This prevents TypeScript from allowing other types with the same fields to match.
  // @ts-ignore
  #e;
  constructor(t = 0, n = 0, r = 0, a = 0) {
    this.hour = t, this.minute = n, this.second = r, this.millisecond = a, V4(this);
  }
  /** Returns a copy of this time. */
  copy() {
    return new Vu(this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `Time` with the given duration added to it. */
  add(t) {
    return z4(this, t);
  }
  /** Returns a new `Time` with the given duration subtracted from it. */
  subtract(t) {
    return J2(this, t);
  }
  /**
  * Returns a new `Time` with the given fields set to the provided values. Other fields will be
  * constrained accordingly.
  */
  set(t) {
    return ta(this, t);
  }
  /**
  * Returns a new `Time` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    return Iu(this, t, n, r);
  }
  /** Converts the time to an ISO 8601 formatted string. */
  toString() {
    return H4(this);
  }
  /**
  * Compares this time with another. A negative result indicates that this time is before the given
  * one, and a positive time indicates that it is after.
  */
  compare(t) {
    return k4(this, t);
  }
}
class na {
  // This prevents TypeScript from allowing other types with the same fields to match.
  // @ts-ignore
  #e;
  constructor(...t) {
    let [n, r, a, l, i] = Nu(t);
    this.calendar = n, this.era = r, this.year = a, this.month = l, this.day = i, this.hour = t.shift() || 0, this.minute = t.shift() || 0, this.second = t.shift() || 0, this.millisecond = t.shift() || 0, zn(this);
  }
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new na(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new na(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `CalendarDateTime` with the given duration added to it. */
  add(t) {
    return Pl(this, t);
  }
  /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */
  subtract(t) {
    return N4(this, t);
  }
  /**
  * Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields
  * will be constrained accordingly.
  */
  set(t) {
    return Ru(ta(this, t), t);
  }
  /**
  * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    switch (t) {
      case "era":
      case "year":
      case "month":
      case "day":
        return Tu(this, t, n, r);
      default:
        return Iu(this, t, n, r);
    }
  }
  /** Converts the date to a native JavaScript Date object in the given time zone. */
  toDate(t, n) {
    return M4(this, t, n);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return Ku(this);
  }
  /**
  * Compares this date with another. A negative result indicates that this date is before the given
  * one, and a positive date indicates that it is after.
  */
  compare(t) {
    let n = S4(this, t);
    return n === 0 ? k4(this, Et(t)) : n;
  }
}
class On {
  // This prevents TypeScript from allowing other types with the same fields to match.
  // @ts-ignore
  #e;
  constructor(...t) {
    let [n, r, a, l, i] = Nu(t), u = t.shift(), o = t.shift();
    this.calendar = n, this.era = r, this.year = a, this.month = l, this.day = i, this.timeZone = u, this.offset = o, this.hour = t.shift() || 0, this.minute = t.shift() || 0, this.second = t.shift() || 0, this.millisecond = t.shift() || 0, zn(this);
  }
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new On(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond) : new On(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `ZonedDateTime` with the given duration added to it. */
  add(t) {
    return O4(this, t);
  }
  /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */
  subtract(t) {
    return Q2(this, t);
  }
  /**
  * Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields
  * will be constrained accordingly.
  */
  set(t, n) {
    return t6(this, t, n);
  }
  /**
  * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    return e6(this, t, n, r);
  }
  /** Converts the date to a native JavaScript Date object. */
  toDate() {
    return q2(this);
  }
  /**
  * Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone
  * identifier.
  */
  toString() {
    return o6(this);
  }
  /** Converts the date to an ISO 8601 formatted string in UTC. */
  toAbsoluteString() {
    return this.toDate().toISOString();
  }
  /**
  * Compares this date with another. A negative result indicates that this date is before the given
  * one, and a positive date indicates that it is after.
  */
  compare(t) {
    return this.toDate().getTime() - G2(t, this.timeZone).toDate().getTime();
  }
}
const fr = [
  [
    1868,
    9,
    8
  ],
  [
    1912,
    7,
    30
  ],
  [
    1926,
    12,
    25
  ],
  [
    1989,
    1,
    8
  ],
  [
    2019,
    5,
    1
  ]
], s6 = [
  [
    1912,
    7,
    29
  ],
  [
    1926,
    12,
    24
  ],
  [
    1989,
    1,
    7
  ],
  [
    2019,
    4,
    30
  ]
], La = [
  1867,
  1911,
  1925,
  1988,
  2018
], dn = [
  "meiji",
  "taisho",
  "showa",
  "heisei",
  "reiwa"
];
function xs(e) {
  const t = fr.findIndex(([n, r, a]) => e.year < n || e.year === n && e.month < r || e.year === n && e.month === r && e.day < a);
  return t === -1 ? fr.length - 1 : t === 0 ? 0 : t - 1;
}
function Yl(e) {
  let t = La[dn.indexOf(e.era)];
  if (!t) throw new Error("Unknown era: " + e.era);
  return new Te(e.year + t, e.month, e.day);
}
class d6 extends _e {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = xs(n);
    return new Te(this, dn[r], n.year - La[r], n.month, n.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(Yl(t));
  }
  balanceDate(t) {
    let n = Yl(t), r = xs(n);
    dn[r] !== t.era && (t.era = dn[r], t.year = n.year - La[r]), this.constrainDate(t);
  }
  constrainDate(t) {
    let n = dn.indexOf(t.era), r = s6[n];
    if (r != null) {
      let [a, l, i] = r, u = a - La[n];
      t.year = Math.max(1, Math.min(u, t.year)), t.year === u && (t.month = Math.min(l, t.month), t.month === l && (t.day = Math.min(i, t.day)));
    }
    if (t.year === 1 && n >= 0) {
      let [, a, l] = fr[n];
      t.month = Math.max(a, t.month), t.month === a && (t.day = Math.max(l, t.day));
    }
  }
  getEras() {
    return dn;
  }
  getYearsInEra(t) {
    let n = dn.indexOf(t.era), r = fr[n], a = fr[n + 1];
    if (a == null)
      return 9999 - r[0] + 1;
    let l = a[0] - r[0];
    return (t.month < a[1] || t.month === a[1] && t.day < a[2]) && l++, l;
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(Yl(t));
  }
  getMinimumMonthInYear(t) {
    let n = Es(t);
    return n ? n[1] : 1;
  }
  getMinimumDayInMonth(t) {
    let n = Es(t);
    return n && t.month === n[1] ? n[2] : 1;
  }
  constructor(...t) {
    super(...t), this.identifier = "japanese";
  }
}
function Es(e) {
  if (e.year === 1) {
    let t = dn.indexOf(e.era);
    return fr[t];
  }
}
const _4 = -543;
class c6 extends _e {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = ga(n.era, n.year);
    return new Te(this, r - _4, n.month, n.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(Cs(t));
  }
  getEras() {
    return [
      "BE"
    ];
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(Cs(t));
  }
  balanceDate() {
  }
  constructor(...t) {
    super(...t), this.identifier = "buddhist";
  }
}
function Cs(e) {
  let [t, n] = El(e.year + _4);
  return new Te(t, n, e.month, e.day);
}
const al = 1911;
function W4(e) {
  return e.era === "minguo" ? e.year + al : 1 - e.year + al;
}
function Ps(e) {
  let t = e - al;
  return t > 0 ? [
    "minguo",
    t
  ] : [
    "before_minguo",
    1 - t
  ];
}
class f6 extends _e {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = ga(n.era, n.year), [a, l] = Ps(r);
    return new Te(this, a, l, n.month, n.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(ws(t));
  }
  getEras() {
    return [
      "before_minguo",
      "minguo"
    ];
  }
  balanceDate(t) {
    let [n, r] = Ps(W4(t));
    t.era = n, t.year = r;
  }
  isInverseEra(t) {
    return t.era === "before_minguo";
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(ws(t));
  }
  getYearsInEra(t) {
    return t.era === "before_minguo" ? 9999 : 9999 - al;
  }
  constructor(...t) {
    super(...t), this.identifier = "roc";
  }
}
function ws(e) {
  let [t, n] = El(W4(e));
  return new Te(t, n, e.month, e.day);
}
const Ss = 1948320, ks = [
  0,
  31,
  62,
  93,
  124,
  155,
  186,
  216,
  246,
  276,
  306,
  336
  // Esfand
];
class h6 {
  fromJulianDay(t) {
    let n = t - Ss, r = 1 + Math.floor((33 * n + 3) / 12053), a = 365 * (r - 1) + Math.floor((8 * r + 21) / 33), l = n - a, i = l < 216 ? Math.floor(l / 31) : Math.floor((l - 6) / 30), u = l - ks[i] + 1;
    return new Te(this, r, i + 1, u);
  }
  toJulianDay(t) {
    let n = Ss - 1 + 365 * (t.year - 1) + Math.floor((8 * t.year + 21) / 33);
    return n += ks[t.month - 1], n += t.day, n;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInMonth(t) {
    return t.month <= 6 ? 31 : t.month <= 11 || cr(25 * t.year + 11, 33) < 8 ? 30 : 29;
  }
  getMaximumMonthsInYear() {
    return 12;
  }
  getMaximumDaysInMonth() {
    return 31;
  }
  getEras() {
    return [
      "AP"
    ];
  }
  getYearsInEra() {
    return 9377;
  }
  constructor() {
    this.identifier = "persian";
  }
}
const Zl = 78, Bs = 80;
class m6 extends _e {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = n.year - Zl, a = t - Tn(n.era, n.year, 1, 1), l;
    a < Bs ? (r--, l = fn(n.year - 1) ? 31 : 30, a += l + 155 + 90 + 10) : (l = fn(n.year) ? 31 : 30, a -= Bs);
    let i, u;
    if (a < l)
      i = 1, u = a + 1;
    else {
      let o = a - l;
      o < 155 ? (i = Math.floor(o / 31) + 2, u = o % 31 + 1) : (o -= 155, i = Math.floor(o / 30) + 7, u = o % 30 + 1);
    }
    return new Te(this, r, i, u);
  }
  toJulianDay(t) {
    let n = t.year + Zl, [r, a] = El(n), l, i;
    return fn(a) ? (l = 31, i = Tn(r, a, 3, 21)) : (l = 30, i = Tn(r, a, 3, 22)), t.month === 1 ? i + t.day - 1 : (i += l + Math.min(t.month - 2, 5) * 31, t.month >= 8 && (i += (t.month - 7) * 30), i += t.day - 1, i);
  }
  getDaysInMonth(t) {
    return t.month === 1 && fn(t.year + Zl) || t.month >= 2 && t.month <= 6 ? 31 : 30;
  }
  getYearsInEra() {
    return 9919;
  }
  getEras() {
    return [
      "saka"
    ];
  }
  balanceDate() {
  }
  constructor(...t) {
    super(...t), this.identifier = "indian";
  }
}
const ll = 1948440, Fs = 1948439, nt = 1300, er = 1600, b6 = 460322;
function il(e, t, n, r) {
  return r + Math.ceil(29.5 * (n - 1)) + (t - 1) * 354 + Math.floor((3 + 11 * t) / 30) + e - 1;
}
function G4(e, t, n) {
  let r = Math.floor((30 * (n - t) + 10646) / 10631), a = Math.min(12, Math.ceil((n - (29 + il(t, r, 1, 1))) / 29.5) + 1), l = n - il(t, r, a, 1) + 1;
  return new Te(e, r, a, l);
}
function As(e) {
  return (14 + 11 * e) % 30 < 11;
}
class Lu {
  fromJulianDay(t) {
    return G4(this, ll, t);
  }
  toJulianDay(t) {
    return il(ll, t.year, t.month, t.day);
  }
  getDaysInMonth(t) {
    let n = 29 + t.month % 2;
    return t.month === 12 && As(t.year) && n++, n;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInYear(t) {
    return As(t.year) ? 355 : 354;
  }
  getMaximumMonthsInYear() {
    return 12;
  }
  getMaximumDaysInMonth() {
    return 30;
  }
  getYearsInEra() {
    return 9665;
  }
  getEras() {
    return [
      "AH"
    ];
  }
  constructor() {
    this.identifier = "islamic-civil";
  }
}
class p6 extends Lu {
  fromJulianDay(t) {
    return G4(this, Fs, t);
  }
  toJulianDay(t) {
    return il(Fs, t.year, t.month, t.day);
  }
  constructor(...t) {
    super(...t), this.identifier = "islamic-tbla";
  }
}
const g6 = "qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=";
let Ni, hr;
function za(e) {
  return b6 + hr[e - nt];
}
function Or(e, t) {
  let n = e - nt, r = 1 << 11 - (t - 1);
  return (Ni[n] & r) === 0 ? 29 : 30;
}
function Rs(e, t) {
  let n = za(e);
  for (let r = 1; r < t; r++) n += Or(e, r);
  return n;
}
function Ts(e) {
  return hr[e + 1 - nt] - hr[e - nt];
}
class y6 extends Lu {
  constructor() {
    if (super(), this.identifier = "islamic-umalqura", Ni || (Ni = new Uint16Array(Uint8Array.from(atob(g6), (t) => t.charCodeAt(0)).buffer)), !hr) {
      hr = new Uint32Array(er - nt + 1);
      let t = 0;
      for (let n = nt; n <= er; n++) {
        hr[n - nt] = t;
        for (let r = 1; r <= 12; r++) t += Or(n, r);
      }
    }
  }
  fromJulianDay(t) {
    let n = t - ll, r = za(nt), a = za(er);
    if (n < r || n > a) return super.fromJulianDay(t);
    {
      let l = nt - 1, i = 1, u = 1;
      for (; u > 0; ) {
        l++, u = n - za(l) + 1;
        let o = Ts(l);
        if (u === o) {
          i = 12;
          break;
        } else if (u < o) {
          let d = Or(l, i);
          for (i = 1; u > d; )
            u -= d, i++, d = Or(l, i);
          break;
        }
      }
      return new Te(this, l, i, n - Rs(l, i) + 1);
    }
  }
  toJulianDay(t) {
    return t.year < nt || t.year > er ? super.toJulianDay(t) : ll + Rs(t.year, t.month) + (t.day - 1);
  }
  getDaysInMonth(t) {
    return t.year < nt || t.year > er ? super.getDaysInMonth(t) : Or(t.year, t.month);
  }
  getDaysInYear(t) {
    return t.year < nt || t.year > er ? super.getDaysInYear(t) : Ts(t.year);
  }
}
const Is = 347997, q4 = 1080, Y4 = 24 * q4, $6 = 29, v6 = 12 * q4 + 793, D6 = $6 * Y4 + v6;
function An(e) {
  return cr(e * 7 + 1, 19) < 7;
}
function Oa(e) {
  let t = Math.floor((235 * e - 234) / 19), n = 12084 + 13753 * t, r = t * 29 + Math.floor(n / 25920);
  return cr(3 * (r + 1), 7) < 3 && (r += 1), r;
}
function x6(e) {
  let t = Oa(e - 1), n = Oa(e);
  return Oa(e + 1) - n === 356 ? 2 : n - t === 382 ? 1 : 0;
}
function Wr(e) {
  return Oa(e) + x6(e);
}
function Z4(e) {
  return Wr(e + 1) - Wr(e);
}
function E6(e) {
  let t = Z4(e);
  switch (t > 380 && (t -= 30), t) {
    case 353:
      return 0;
    // deficient
    case 354:
      return 1;
    // normal
    case 355:
      return 2;
  }
}
function Aa(e, t) {
  if (t >= 6 && !An(e) && t++, t === 4 || t === 7 || t === 9 || t === 11 || t === 13) return 29;
  let n = E6(e);
  return t === 2 ? n === 2 ? 30 : 29 : t === 3 ? n === 0 ? 29 : 30 : t === 6 ? An(e) ? 30 : 0 : 30;
}
class C6 {
  fromJulianDay(t) {
    let n = t - Is, r = n * Y4 / D6, a = Math.floor((19 * r + 234) / 235) + 1, l = Wr(a), i = Math.floor(n - l);
    for (; i < 1; )
      a--, l = Wr(a), i = Math.floor(n - l);
    let u = 1, o = 0;
    for (; o < i; )
      o += Aa(a, u), u++;
    u--, o -= Aa(a, u);
    let d = i - o;
    return new Te(this, a, u, d);
  }
  toJulianDay(t) {
    let n = Wr(t.year);
    for (let r = 1; r < t.month; r++) n += Aa(t.year, r);
    return n + t.day + Is;
  }
  getDaysInMonth(t) {
    return Aa(t.year, t.month);
  }
  getMonthsInYear(t) {
    return An(t.year) ? 13 : 12;
  }
  getDaysInYear(t) {
    return Z4(t.year);
  }
  getMaximumMonthsInYear() {
    return 13;
  }
  getMaximumDaysInMonth() {
    return 30;
  }
  getYearsInEra() {
    return 9999;
  }
  getEras() {
    return [
      "AM"
    ];
  }
  balanceYearMonth(t, n) {
    n.year !== t.year && (An(n.year) && !An(t.year) && n.month > 6 ? t.month-- : !An(n.year) && An(t.year) && n.month > 6 && t.month++);
  }
  constructor() {
    this.identifier = "hebrew";
  }
}
const Vi = 1723856, Ms = 1824665, Li = 5500;
function ul(e, t, n, r) {
  return e + // difference from Julian epoch to 1,1,1
  365 * t + // number of days from years
  Math.floor(t / 4) + // extra day of leap year
  30 * (n - 1) + // number of days from months (1 based)
  r - 1;
}
function zu(e, t) {
  let n = Math.floor(4 * (t - e) / 1461), r = 1 + Math.floor((t - ul(e, n, 1, 1)) / 30), a = t + 1 - ul(e, n, r, 1);
  return [
    n,
    r,
    a
  ];
}
function X4(e) {
  return Math.floor(e % 4 / 3);
}
function J4(e, t) {
  return t % 13 !== 0 ? 30 : X4(e) + 5;
}
class Ou {
  fromJulianDay(t) {
    let [n, r, a] = zu(Vi, t), l = "AM";
    return n <= 0 && (l = "AA", n += Li), new Te(this, l, n, r, a);
  }
  toJulianDay(t) {
    let n = t.year;
    return t.era === "AA" && (n -= Li), ul(Vi, n, t.month, t.day);
  }
  getDaysInMonth(t) {
    return J4(t.year, t.month);
  }
  getMonthsInYear() {
    return 13;
  }
  getDaysInYear(t) {
    return 365 + X4(t.year);
  }
  getMaximumMonthsInYear() {
    return 13;
  }
  getMaximumDaysInMonth() {
    return 30;
  }
  getYearsInEra(t) {
    return t.era === "AA" ? 9999 : 9991;
  }
  getEras() {
    return [
      "AA",
      "AM"
    ];
  }
  constructor() {
    this.identifier = "ethiopic";
  }
}
class P6 extends Ou {
  fromJulianDay(t) {
    let [n, r, a] = zu(Vi, t);
    return n += Li, new Te(this, "AA", n, r, a);
  }
  getEras() {
    return [
      "AA"
    ];
  }
  getYearsInEra() {
    return 9999;
  }
  constructor(...t) {
    super(...t), this.identifier = "ethioaa";
  }
}
class w6 extends Ou {
  fromJulianDay(t) {
    let [n, r, a] = zu(Ms, t), l = "CE";
    return n <= 0 && (l = "BCE", n = 1 - n), new Te(this, l, n, r, a);
  }
  toJulianDay(t) {
    let n = t.year;
    return t.era === "BCE" && (n = 1 - n), ul(Ms, n, t.month, t.day);
  }
  getDaysInMonth(t) {
    let n = t.year;
    return t.era === "BCE" && (n = 1 - n), J4(n, t.month);
  }
  isInverseEra(t) {
    return t.era === "BCE";
  }
  balanceDate(t) {
    t.year <= 0 && (t.era = t.era === "BCE" ? "CE" : "BCE", t.year = 1 - t.year);
  }
  getEras() {
    return [
      "BCE",
      "CE"
    ];
  }
  getYearsInEra(t) {
    return t.era === "BCE" ? 9999 : 9715;
  }
  constructor(...t) {
    super(...t), this.identifier = "coptic";
  }
}
function Q4(e) {
  switch (e) {
    case "buddhist":
      return new c6();
    case "ethiopic":
      return new Ou();
    case "ethioaa":
      return new P6();
    case "coptic":
      return new w6();
    case "hebrew":
      return new C6();
    case "indian":
      return new m6();
    case "islamic-civil":
      return new Lu();
    case "islamic-tbla":
      return new p6();
    case "islamic-umalqura":
      return new y6();
    case "japanese":
      return new d6();
    case "persian":
      return new h6();
    case "roc":
      return new f6();
    default:
      return new _e();
  }
}
let Xl = /* @__PURE__ */ new Map();
class qt {
  constructor(t, n = {}) {
    this.formatter = eh(t, n), this.options = n;
  }
  /**
  * Formats a date as a string according to the locale and format options passed to the
  * constructor.
  */
  format(t) {
    return this.formatter.format(t);
  }
  /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */
  formatToParts(t) {
    return this.formatter.formatToParts(t);
  }
  /** Formats a date range as a string. */
  formatRange(t, n) {
    if (typeof this.formatter.formatRange == "function")
      return this.formatter.formatRange(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    return `${this.formatter.format(t)} – ${this.formatter.format(n)}`;
  }
  /** Formats a date range as an array of parts. */
  formatRangeToParts(t, n) {
    if (typeof this.formatter.formatRangeToParts == "function")
      return this.formatter.formatRangeToParts(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    let r = this.formatter.formatToParts(t), a = this.formatter.formatToParts(n);
    return [
      ...r.map((l) => ({
        ...l,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...a.map((l) => ({
        ...l,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.formatter.resolvedOptions();
    return B6() && (this.resolvedHourCycle || (this.resolvedHourCycle = F6(t.locale, this.options)), t.hourCycle = this.resolvedHourCycle, t.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12"), t.calendar === "ethiopic-amete-alem" && (t.calendar = "ethioaa"), t;
  }
}
const S6 = {
  true: {
    // Only Japanese uses the h11 style for 12 hour time. All others use h12.
    ja: "h11"
  },
  false: {}
};
function eh(e, t = {}) {
  if (typeof t.hour12 == "boolean" && k6()) {
    t = {
      ...t
    };
    let a = S6[String(t.hour12)][e.split("-")[0]], l = t.hour12 ? "h12" : "h23";
    t.hourCycle = a ?? l, delete t.hour12;
  }
  let n = e + (t ? Object.entries(t).sort((a, l) => a[0] < l[0] ? -1 : 1).join() : "");
  if (Xl.has(n)) return Xl.get(n);
  let r = new Intl.DateTimeFormat(e, t);
  return Xl.set(n, r), r;
}
let Jl = null;
function k6() {
  return Jl == null && (Jl = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hour12: !1
  }).format(new Date(2020, 2, 3, 0)) === "24"), Jl;
}
let Ql = null;
function B6() {
  return Ql == null && (Ql = new Intl.DateTimeFormat("fr", {
    hour: "numeric",
    hour12: !1
  }).resolvedOptions().hourCycle === "h12"), Ql;
}
function F6(e, t) {
  if (!t.timeStyle && !t.hour) return;
  e = e.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, ""), e += (e.includes("-u-") ? "" : "-u") + "-nu-latn";
  let n = eh(e, {
    ...t,
    timeZone: void 0
    // use local timezone
  }), r = parseInt(n.formatToParts(new Date(2020, 2, 3, 0)).find((l) => l.type === "hour").value, 10), a = parseInt(n.formatToParts(new Date(2020, 2, 3, 23)).find((l) => l.type === "hour").value, 10);
  if (r === 0 && a === 23) return "h23";
  if (r === 24 && a === 23) return "h24";
  if (r === 0 && a === 11) return "h11";
  if (r === 12 && a === 11) return "h12";
  throw new Error("Unexpected hour cycle result");
}
function Kt(e) {
  e = E4(e ?? {}, A6);
  let { locale: t } = de();
  return K(() => new qt(t, e), [
    t,
    e
  ]);
}
function A6(e, t) {
  if (e === t) return !0;
  let n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (let a of n)
    if (t[a] !== e[a]) return !1;
  return !0;
}
function th(e) {
  return e && e.__esModule ? e.default : e;
}
const Hu = /* @__PURE__ */ new WeakMap();
function ra(e) {
  return e?.calendar.identifier === "gregory" && e.era === "BC" ? "short" : void 0;
}
function R6(e) {
  let t = Ee(th(pa), "@react-aria/calendar"), n, r;
  "highlightedRange" in e ? { start: n, end: r } = e.highlightedRange || {} : (n = Array.isArray(e.value) ? e.value[0] : e.value ?? void 0, r = Array.isArray(e.value) ? e.value.at(-1) : e.value ?? void 0);
  let a = Kt({
    weekday: "long",
    month: "long",
    year: "numeric",
    day: "numeric",
    era: ra(n) || ra(r),
    timeZone: e.timeZone
  }), { locale: l } = de(), i = K(() => new Intl.ListFormat(l), [
    l
  ]), u = "anchorDate" in e ? e.anchorDate : null;
  return K(() => {
    if (!u && n && r) {
      if (Fe(n, r)) {
        let o = a.format(n.toDate(e.timeZone));
        return t.format("selectedDateDescription", {
          date: o
        });
      } else if ("highlightedRange" in e) {
        let o = Oi(a, t, n, r, e.timeZone);
        return t.format("selectedRangeDescription", {
          dateRange: o
        });
      } else if (Array.isArray(e.value)) {
        let o = e.value.map((s) => a.format(s.toDate(e.timeZone))), d = i.format(o);
        return t.format("selectedDateDescription", {
          date: d
        });
      }
    }
    return "";
  }, [
    n,
    r,
    u,
    e,
    t,
    a,
    i
  ]);
}
function zi(e, t, n, r) {
  let a = Ee(th(pa), "@react-aria/calendar"), l = ra(e) || ra(t), i = Kt({
    month: "long",
    year: "numeric",
    era: l,
    calendar: e.calendar.identifier,
    timeZone: n
  }), u = Kt({
    month: "long",
    year: "numeric",
    day: "numeric",
    era: l,
    calendar: e.calendar.identifier,
    timeZone: n
  });
  return K(() => {
    if (Fe(e, Ln(e))) {
      let o = e, d = t;
      if (e.calendar.getFormattableMonth && (o = e.calendar.getFormattableMonth(e)), t.calendar.getFormattableMonth && (d = t.calendar.getFormattableMonth(t)), Fe(t, nl(e))) return i.format(o.toDate(n));
      if (Fe(t, nl(t))) return r ? Oi(i, a, o, d, n) : i.formatRange(o.toDate(n), d.toDate(n));
    }
    return r ? Oi(u, a, e, t, n) : u.formatRange(e.toDate(n), t.toDate(n));
  }, [
    e,
    t,
    i,
    u,
    a,
    n,
    r
  ]);
}
function Oi(e, t, n, r, a) {
  let l = e.formatRangeToParts(n.toDate(a), r.toDate(a)), i = -1;
  for (let d = 0; d < l.length; d++) {
    let s = l[d];
    if (s.source === "shared" && s.type === "literal") i = d;
    else if (s.source === "endRange") break;
  }
  let u = "", o = "";
  for (let d = 0; d < l.length; d++)
    d < i ? u += l[d].value : d > i && (o += l[d].value);
  return t.format("dateRange", {
    startDate: u,
    endDate: o
  });
}
function ol(e, t) {
  const n = T(!0), r = T(null);
  let a = xe(e);
  ee(() => (n.current = !0, () => {
    n.current = !1;
  }), []), ee(() => {
    let l = r.current;
    n.current ? n.current = !1 : (!l || t.some((i, u) => !Object.is(i, l[u]))) && a(), r.current = t;
  }, t);
}
function T6(e) {
  return e && e.__esModule ? e.default : e;
}
function I6(e, t) {
  let n = Ee(T6(pa), "@react-aria/calendar"), r = J(e), a = zi(t.visibleRange.start, t.visibleRange.end, t.timeZone, !1), l = zi(t.visibleRange.start, t.visibleRange.end, t.timeZone, !0);
  ol(() => {
    t.isFocused || pn(l);
  }, [
    l
  ]);
  let i = R6(t);
  ol(() => {
    i && pn(i, "polite", 4e3);
  }, [
    i
  ]);
  let u = yt([
    !!e.errorMessage,
    e.isInvalid,
    e.validationState
  ]);
  Hu.set(t, {
    ariaLabel: e["aria-label"],
    ariaLabelledBy: e["aria-labelledby"],
    errorMessageId: u,
    selectedDateDescription: i
  });
  let [o, d] = Y(!1), s = e.isDisabled || t.isNextVisibleRangeInvalid();
  s && o && (d(!1), t.setFocused(!0));
  let [c, f] = Y(!1), h = e.isDisabled || t.isPreviousVisibleRangeInvalid();
  h && c && (f(!1), t.setFocused(!0));
  let m = ut({
    id: e.id,
    "aria-label": [
      e["aria-label"],
      l
    ].filter(Boolean).join(", "),
    "aria-labelledby": e["aria-labelledby"]
  });
  return {
    calendarProps: z(r, m, {
      role: "application",
      "aria-details": e["aria-details"] || void 0,
      "aria-describedby": e["aria-describedby"] || void 0
    }),
    nextButtonProps: {
      onPress: () => t.focusNextPage(),
      "aria-label": n.format("next"),
      isDisabled: s,
      onFocusChange: d
    },
    prevButtonProps: {
      onPress: () => t.focusPreviousPage(),
      "aria-label": n.format("previous"),
      isDisabled: h,
      onFocusChange: f
    },
    errorMessageProps: {
      id: u
    },
    title: a
  };
}
function M6(e, t) {
  return I6(e, t);
}
function K6(e, t) {
  let { startDate: n = t.visibleRange.start, endDate: r = t.visibleRange.end, firstDayOfWeek: a } = e, { direction: l } = de(), i = (b) => {
    switch (b.key) {
      case "Enter":
      case " ":
        b.preventDefault(), t.selectFocusedDate();
        break;
      case "PageUp":
        b.preventDefault(), b.stopPropagation(), t.focusPreviousSection(b.shiftKey);
        break;
      case "PageDown":
        b.preventDefault(), b.stopPropagation(), t.focusNextSection(b.shiftKey);
        break;
      case "End":
        b.preventDefault(), b.stopPropagation(), t.focusSectionEnd();
        break;
      case "Home":
        b.preventDefault(), b.stopPropagation(), t.focusSectionStart();
        break;
      case "ArrowLeft":
        b.preventDefault(), b.stopPropagation(), l === "rtl" ? t.focusNextDay() : t.focusPreviousDay();
        break;
      case "ArrowUp":
        b.preventDefault(), b.stopPropagation(), t.focusPreviousRow();
        break;
      case "ArrowRight":
        b.preventDefault(), b.stopPropagation(), l === "rtl" ? t.focusPreviousDay() : t.focusNextDay();
        break;
      case "ArrowDown":
        b.preventDefault(), b.stopPropagation(), t.focusNextRow();
        break;
      case "Escape":
        "setAnchorDate" in t && (b.preventDefault(), t.setAnchorDate(null));
        break;
    }
  }, u = zi(n, r, t.timeZone, !0), { ariaLabel: o, ariaLabelledBy: d } = Hu.get(t), s = ut({
    "aria-label": [
      o,
      u
    ].filter(Boolean).join(", "),
    "aria-labelledby": d
  }), c = Kt({
    weekday: e.weekdayStyle || "narrow",
    timeZone: t.timeZone
  }), { locale: f } = de(), h = K(() => {
    let b = t.visibleDuration.days && t.visibleDuration.days < 7, p = b ? n : Qr(Bu(t.timeZone), f, a), y = b ? t.visibleDuration.days : 7;
    return [
      ...new Array(y).keys()
    ].map(($) => {
      let x = p.add({
        days: $
      }).toDate(t.timeZone);
      return c.format(x);
    });
  }, [
    f,
    t.timeZone,
    c,
    a,
    n,
    t.visibleDuration.days
  ]), m = t.getWeeksInMonth(n);
  return {
    gridProps: z(s, {
      role: "grid",
      "aria-readonly": t.isReadOnly || void 0,
      "aria-disabled": t.isDisabled || void 0,
      "aria-multiselectable": "highlightedRange" in t || t.selectionMode === "multiple" || void 0,
      onKeyDown: i,
      onFocus: () => t.setFocused(!0),
      onBlur: () => t.setFocused(!1)
    }),
    headerProps: {
      // Column headers are hidden to screen readers to make navigating with a touch screen reader easier.
      // The day names are already included in the label of each cell, so there's no need to announce them twice.
      "aria-hidden": !0
    },
    weekDays: h,
    weeksInMonth: m
  };
}
function yn(e, t) {
  if (!e) return !1;
  let n = window.getComputedStyle(e), r = document.scrollingElement || document.documentElement, a = /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
  return e === r && n.overflow !== "hidden" && (a = !0), a && t && (a = e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth), a;
}
function ze(e, t) {
  let n = e;
  for (yn(n, t) && (n = n.parentElement); n && !yn(n, t); ) n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
function ei(e, t) {
  let n = [], r = document.scrollingElement || document.documentElement;
  for (; e && (yn(e, t) && n.push(e), e !== r); )
    e = e.parentElement;
  return n;
}
function Ha(e, t, n = {}) {
  let { block: r = "nearest", inline: a = "nearest" } = n;
  if (e === t) return;
  let l = e.scrollTop, i = e.scrollLeft, u = t.getBoundingClientRect(), o = e.getBoundingClientRect(), d = window.getComputedStyle(t), s = window.getComputedStyle(e), c = document.scrollingElement || document.documentElement, f = e === c, h = e === c ? 0 : o.top, m = e === c ? e.clientHeight : o.bottom, b = e === c ? 0 : o.left, p = e === c ? e.clientWidth : o.right, y = parseFloat(d.scrollMarginTop) || 0, $ = parseFloat(d.scrollMarginBottom) || 0, v = parseFloat(d.scrollMarginLeft) || 0, x = parseFloat(d.scrollMarginRight) || 0, E = parseFloat(s.scrollPaddingTop) || 0, P = parseFloat(s.scrollPaddingBottom) || 0, C = parseFloat(s.scrollPaddingLeft) || 0, M = parseFloat(s.scrollPaddingRight) || 0, F = parseFloat(s.borderTopWidth) || 0, V = parseFloat(s.borderBottomWidth) || 0, I = parseFloat(s.borderLeftWidth) || 0, A = parseFloat(s.borderRightWidth) || 0, U = u.top - y, D = u.bottom + $, N = u.left - v, w = u.right + x, R = e === c ? 0 : I + A, H = e === c ? 0 : F + V, k = e === c ? 0 : e.offsetWidth - e.clientWidth - R, S = e === c ? 0 : e.offsetHeight - e.clientHeight - H, j = h + (f ? 0 : F) + E, _ = m - (f ? 0 : V) - P - S, B = b + (f ? 0 : I) + C, L = p - (f ? 0 : A) - M;
  s.direction === "rtl" && !xt() ? B += k : L -= k;
  let Z = U < j || D > _, ie = N < B || w > L;
  if (Z && r === "start") l += U - j;
  else if (Z && r === "center") l += (U + D) / 2 - (j + _) / 2;
  else if (Z && r === "end") l += D - _;
  else if (Z && r === "nearest") {
    let q = U - j, re = D - _;
    l += Math.abs(q) <= Math.abs(re) ? q : re;
  }
  if (ie && a === "start") i += N - B;
  else if (ie && a === "center") i += (N + w) / 2 - (B + L) / 2;
  else if (ie && a === "end") i += w - L;
  else if (ie && a === "nearest") {
    let q = N - B, re = w - L;
    i += Math.abs(q) <= Math.abs(re) ? q : re;
  }
  if (process.env.NODE_ENV === "test") {
    e.scrollLeft = i, e.scrollTop = l;
    return;
  }
  e.scrollTo({
    left: i,
    top: l
  });
}
function Oe(e, t = {}) {
  let { containingElement: n } = t;
  if (e && e.isConnected) {
    let r = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(r).overflow === "hidden") {
      let { left: l, top: i } = e.getBoundingClientRect(), u = ei(e, !0);
      for (let s of u) Ha(s, e);
      let { left: o, top: d } = e.getBoundingClientRect();
      if (Math.abs(l - o) > 1 || Math.abs(i - d) > 1) {
        u = n ? ei(n, !0) : [];
        for (let s of u) Ha(s, n, {
          block: "center",
          inline: "center"
        });
        for (let s of ei(e, !0)) Ha(s, e);
      }
    } else {
      let { left: l, top: i } = e.getBoundingClientRect();
      e?.scrollIntoView?.({
        block: "nearest"
      });
      let { left: u, top: o } = e.getBoundingClientRect();
      (Math.abs(l - u) > 1 || Math.abs(i - o) > 1) && (n?.scrollIntoView?.({
        block: "center",
        inline: "center"
      }), e.scrollIntoView?.({
        block: "nearest"
      }));
    }
  }
}
let N6 = 0;
const ti = /* @__PURE__ */ new Map();
function en(e) {
  let [t, n] = Y();
  return ue(() => {
    if (!e) return;
    let r = ti.get(e);
    if (r)
      n(r.element.id);
    else {
      let a = `react-aria-description-${N6++}`;
      n(a);
      let l = document.createElement("div");
      l.id = a, l.style.display = "none", l.textContent = e, document.body.appendChild(l), r = {
        refCount: 0,
        element: l
      }, ti.set(e, r);
    }
    return r.refCount++, () => {
      r && --r.refCount === 0 && (r.element.remove(), ti.delete(e));
    };
  }, [
    e
  ]), {
    "aria-describedby": e ? t : void 0
  };
}
function V6(e) {
  return e && e.__esModule ? e.default : e;
}
function L6(e, t, n) {
  let { date: r, isDisabled: a } = e, { errorMessageId: l, selectedDateDescription: i } = Hu.get(t), u = Ee(V6(pa), "@react-aria/calendar"), o = Kt({
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    era: ra(r),
    timeZone: t.timeZone
  }), d = t.isCellFocused(r) && !e.isOutsideMonth;
  a = a || t.isCellDisabled(r) || !!e.isOutsideMonth;
  let s = t.isCellUnavailable(r), c = !a && !s, f = t.isSelected(r) && c, h = !1;
  t.isValueInvalid && ("highlightedRange" in t ? h = !t.anchorDate && t.highlightedRange != null && r.compare(t.highlightedRange.start) >= 0 && r.compare(t.highlightedRange.end) <= 0 : Array.isArray(t.value) ? h = t.value.some((I) => Fe(I, r)) : t.value && (h = Fe(t.value, r))), h && !a && (f = !0), r = E4(r, N2);
  let m = K(() => r.toDate(t.timeZone), [
    r,
    t.timeZone
  ]), b = P4(r, t.timeZone), p = K(() => {
    let I = "";
    return "highlightedRange" in t && t.value && !t.anchorDate && (Fe(r, t.value.start) || Fe(r, t.value.end)) && (I = i + ", "), I += o.format(m), b ? I = u.format(f ? "todayDateSelected" : "todayDate", {
      date: I
    }) : f && (I = u.format("dateSelected", {
      date: I
    })), t.minValue && Fe(r, t.minValue) ? I += ", " + u.format("minimumDate") : t.maxValue && Fe(r, t.maxValue) && (I += ", " + u.format("maximumDate")), I;
  }, [
    o,
    m,
    u,
    f,
    b,
    r,
    t,
    i
  ]), y = "";
  "anchorDate" in t && d && !t.isReadOnly && c && (t.anchorDate ? y = u.format("finishRangeSelectionPrompt") : y = u.format("startRangeSelectionPrompt"));
  let $ = en(y), v = T(!1), x = T(!1), E = T(void 0), { pressProps: P, isPressed: C } = Je({
    // When dragging to select a range, we don't want dragging over the original anchor
    // again to trigger onPressStart. Cancel presses immediately when the pointer exits.
    shouldCancelOnPointerExit: "anchorDate" in t && !!t.anchorDate,
    preventFocusOnPress: !0,
    isDisabled: !c || t.isReadOnly,
    onPressStart(I) {
      if (t.isReadOnly) {
        t.setFocusedDate(r), t.setFocused(!0);
        return;
      }
      if ("highlightedRange" in t && !t.anchorDate && (I.pointerType === "mouse" || I.pointerType === "touch")) {
        if (t.highlightedRange && !h) {
          if (Fe(r, t.highlightedRange.start)) {
            t.setAnchorDate(t.highlightedRange.end), t.setFocusedDate(r), t.setFocused(!0), t.setDragging(!0), x.current = !0;
            return;
          } else if (Fe(r, t.highlightedRange.end)) {
            t.setAnchorDate(t.highlightedRange.start), t.setFocusedDate(r), t.setFocused(!0), t.setDragging(!0), x.current = !0;
            return;
          }
        }
        let A = () => {
          t.setDragging(!0), E.current = void 0, t.selectDate(r), t.setFocusedDate(r), t.setFocused(!0), v.current = !0;
        };
        I.pointerType === "touch" ? E.current = setTimeout(A, 200) : A();
      }
    },
    onPressEnd() {
      x.current = !1, v.current = !1, clearTimeout(E.current), E.current = void 0;
    },
    onPress() {
      !("anchorDate" in t) && !t.isReadOnly && (t.selectDate(r), t.setFocusedDate(r), t.setFocused(!0));
    },
    onPressUp(I) {
      t.isReadOnly || ("anchorDate" in t && E.current && (t.selectDate(r), t.setFocusedDate(r), t.setFocused(!0)), "anchorDate" in t && (x.current ? t.setAnchorDate(r) : t.anchorDate && !v.current ? (t.selectDate(r), t.setFocusedDate(r), t.setFocused(!0)) : I.pointerType === "keyboard" && !t.anchorDate ? (t.selectDate(r), t.focusNearestAvailableDate(r)) : I.pointerType === "virtual" && (t.selectDate(r), t.setFocusedDate(r), t.setFocused(!0))));
    }
  }), M;
  a || (M = Fe(r, t.focusedDate) ? 0 : -1), ee(() => {
    d && n.current && (Ae(n.current), vt() !== "pointer" && se() === n.current && Oe(n.current, {
      containingElement: ze(n.current)
    }));
  }, [
    d,
    n
  ]);
  let F = Kt({
    day: "numeric",
    timeZone: t.timeZone,
    calendar: r.calendar.identifier
  }), V = K(() => F.formatToParts(m).find((I) => I.type === "day").value, [
    F,
    m
  ]);
  return {
    cellProps: {
      role: "gridcell",
      "aria-disabled": !c || void 0,
      "aria-selected": f || void 0,
      "aria-invalid": h || void 0
    },
    buttonProps: z(P, {
      onFocus() {
        a || (t.setFocusedDate(r), t.setFocused(!0));
      },
      tabIndex: M,
      role: "button",
      "aria-disabled": !c || void 0,
      "aria-label": p,
      "aria-invalid": h || void 0,
      "aria-describedby": [
        h ? l : void 0,
        $["aria-describedby"]
      ].filter(Boolean).join(" ") || void 0,
      onPointerEnter(I) {
        "highlightDate" in t && (I.pointerType !== "touch" || t.isDragging) && c && t.highlightDate(r);
      },
      onPointerDown(I) {
        let A = W(I);
        A instanceof HTMLElement && "releasePointerCapture" in A && ("hasPointerCapture" in A ? A.hasPointerCapture(I.pointerId) && A.releasePointerCapture(I.pointerId) : A.releasePointerCapture(I.pointerId));
      },
      onContextMenu(I) {
        I.preventDefault();
      }
    }),
    isPressed: C,
    isFocused: d,
    isSelected: f,
    isDisabled: a,
    isUnavailable: s,
    isOutsideVisibleRange: r.compare(t.visibleRange.start) < 0 || r.compare(t.visibleRange.end) > 0,
    isInvalid: h,
    formattedDate: V
  };
}
function Ra(e, t, n) {
  return t != null && e.compare(t) < 0 || n != null && e.compare(n) > 0;
}
function Ks(e, t, n, r, a) {
  let l = {};
  for (let u in t)
    l[u] = Math.floor(t[u] / 2), l[u] > 0 && t[u] % 2 === 0 && l[u]--;
  let i = In(e, t, n).subtract(l);
  return aa(e, i, t, n, r, a);
}
function In(e, t, n, r, a) {
  let l = e;
  return t.years ? l = z2(e) : t.months ? l = Ln(e) : (t.weeks || t.days && t.days > 7) && (l = Qr(e, n)), aa(e, l, t, n, r, a);
}
function Hi(e, t, n, r, a) {
  let l = {
    ...t
  };
  l.days ? l.days-- : l.weeks ? l.weeks-- : l.months ? l.months-- : l.years && l.years--;
  let i = In(e, t, n).subtract(l);
  return aa(e, i, t, n, r, a);
}
function aa(e, t, n, r, a, l) {
  if (a && e.compare(a) >= 0) {
    let i = A4(t, In(it(a), n, r));
    i && (t = i);
  }
  if (l && e.compare(l) <= 0) {
    let i = F4(t, Hi(it(l), n, r));
    i && (t = i);
  }
  return t;
}
function jt(e, t, n) {
  if (t) {
    let r = A4(e, it(t));
    r && (e = r);
  }
  if (n) {
    let r = F4(e, it(n));
    r && (e = r);
  }
  return e;
}
function z6(e, t, n) {
  if (!n) return e;
  for (; e.compare(t) >= 0 && n(e); ) e = e.subtract({
    days: 1
  });
  return e.compare(t) >= 0 ? e : null;
}
function O6(e, t) {
  return e === t ? !0 : e.days === t.days && e.weeks === t.weeks && e.months === t.months && e.years === t.years;
}
function H6(e) {
  let t = K(() => new qt(e.locale), [
    e.locale
  ]), n = K(() => t.resolvedOptions(), [
    t
  ]), { locale: r, createCalendar: a, visibleDuration: l = {
    months: 1
  }, minValue: i, maxValue: u, selectionAlignment: o, isDateUnavailable: d, pageBehavior: s = "visible", selectionMode: c = "single", firstDayOfWeek: f, weeksInMonth: h } = e, m = K(() => a(n.calendar), [
    a,
    n.calendar
  ]), [b, p] = we(e.value, e.defaultValue ?? null, e.onChange), y = K(() => Array.isArray(b) ? b.map((L) => ke(it(L), m)) : b ? ke(it(b), m) : null, [
    b,
    m
  ]), $ = K(() => {
    let L = Array.isArray(b) ? b[0] : b;
    return L && "timeZone" in L ? L.timeZone : n.timeZone;
  }, [
    b,
    n.timeZone
  ]), v = K(() => e.focusedValue ? jt(ke(it(e.focusedValue), m), i, u) : void 0, [
    e.focusedValue,
    m,
    i,
    u
  ]), x = K(() => e.defaultFocusedValue ? jt(ke(it(e.defaultFocusedValue), m), i, u) : jt(y ? Array.isArray(y) ? y[0] : y : ke(Bu($), m), i, u), [
    e.defaultFocusedValue,
    y,
    $,
    m,
    i,
    u
  ]), [E, P] = we(v, x, e.onFocusChange), C = () => {
    switch (o) {
      case "start":
        return In(E, l, r, i, u);
      case "end":
        return Hi(E, l, r, i, u);
      default:
        return Ks(E, l, r, i, u);
    }
  }, [M, F] = Y(C), [V, I] = Y(e.autoFocus || !1), [A, U] = Y(l);
  O6(l, A) || (U(l), F(C()));
  let D = K(() => {
    let L = {
      ...l
    };
    return L.days ? L.days-- : L.days = -1, M.add(L);
  }, [
    M,
    l
  ]), [N, w] = Y(m);
  if (!Cl(m, N)) {
    let L = ke(E, m);
    F(Ks(L, l, r, i, u)), P(L), w(m);
  }
  Ra(E, i, u) ? P(jt(E, i, u)) : E.compare(M) < 0 ? F(Hi(E, l, r, i, u)) : E.compare(D) > 0 && F(In(E, l, r, i, u));
  function R(L) {
    L = jt(L, i, u), P(L);
  }
  function H(L) {
    let Z = jt(L, i, u), ie = z6(Z, M, d);
    if (!ie) return null;
    let q = Array.isArray(b) ? b[0] : b, re = ke(ie, q?.calendar || new _e());
    return q && "hour" in q ? q.set(re) : re;
  }
  function k(L) {
    if (!e.isDisabled && !e.isReadOnly) {
      if (L === null) {
        p(c === "multiple" ? [] : null);
        return;
      }
      if (Array.isArray(L)) p(L.map(H).filter(Boolean));
      else {
        let Z = H(L);
        Z && p(Z);
      }
    }
  }
  let S = K(() => y ? Array.isArray(y) ? y.some((L) => d?.(L) || Ra(L, i, u)) : d?.(y) || Ra(y, i, u) : !1, [
    y,
    d,
    i,
    u
  ]), j = e.isInvalid || e.validationState === "invalid" || S, _ = j ? "invalid" : null, B = K(() => s === "visible" ? l : ni(l), [
    s,
    l
  ]);
  return {
    isDisabled: e.isDisabled ?? !1,
    isReadOnly: e.isReadOnly ?? !1,
    value: y,
    setValue: k,
    selectionMode: c,
    visibleDuration: l,
    visibleRange: {
      start: M,
      end: D
    },
    minValue: i,
    maxValue: u,
    focusedDate: E,
    timeZone: $,
    validationState: _,
    isValueInvalid: j,
    setFocusedDate(L) {
      R(L);
    },
    focusNextDay() {
      R(E.add({
        days: 1
      }));
    },
    focusPreviousDay() {
      R(E.subtract({
        days: 1
      }));
    },
    focusNextRow() {
      l.days ? this.focusNextPage() : (l.weeks || l.months || l.years) && R(E.add({
        weeks: 1
      }));
    },
    focusPreviousRow() {
      l.days ? this.focusPreviousPage() : (l.weeks || l.months || l.years) && R(E.subtract({
        weeks: 1
      }));
    },
    focusNextPage() {
      let L = M.add(B);
      P(jt(E.add(B), i, u)), F(In(aa(E, L, B, r, i, u), B, r));
    },
    focusPreviousPage() {
      let L = M.subtract(B);
      P(jt(E.subtract(B), i, u)), F(In(aa(E, L, B, r, i, u), B, r));
    },
    focusSectionStart() {
      l.days ? R(M) : l.weeks ? R(Qr(E, r)) : (l.months || l.years) && R(Ln(E));
    },
    focusSectionEnd() {
      l.days ? R(D) : l.weeks ? R(O2(E, r)) : (l.months || l.years) && R(nl(E));
    },
    focusNextSection(L) {
      if (!L && !l.days) {
        R(E.add(ni(l)));
        return;
      }
      l.days ? this.focusNextPage() : l.weeks ? R(E.add({
        months: 1
      })) : (l.months || l.years) && R(E.add({
        years: 1
      }));
    },
    focusPreviousSection(L) {
      if (!L && !l.days) {
        R(E.subtract(ni(l)));
        return;
      }
      l.days ? this.focusPreviousPage() : l.weeks ? R(E.subtract({
        months: 1
      })) : (l.months || l.years) && R(E.subtract({
        years: 1
      }));
    },
    selectFocusedDate() {
      d && d(E) || this.selectDate(E);
    },
    selectDate(L) {
      if (!(e.isDisabled || e.isReadOnly))
        if (c === "multiple" && L != null) {
          let Z = H(L);
          if (!Z) return;
          let ie = [];
          Array.isArray(b) ? ie = b : b != null && (ie = [
            b
          ]);
          let q = ie.findIndex((fe) => Fe(fe, Z)), re = q >= 0 ? ie.slice(0, q).concat(ie.slice(q + 1)) : [
            ...ie,
            Z
          ];
          p(re);
        } else k(L);
    },
    isFocused: V,
    setFocused: I,
    isInvalid(L) {
      return Ra(L, i, u);
    },
    isSelected(L) {
      return !y || this.isCellDisabled(L) || this.isCellUnavailable(L) ? !1 : Array.isArray(y) ? y.some((Z) => Fe(Z, L)) : Fe(L, y);
    },
    isCellFocused(L) {
      return V && E && Fe(L, E);
    },
    isCellDisabled(L) {
      return e.isDisabled || L.compare(M) < 0 || L.compare(D) > 0 || this.isInvalid(L);
    },
    isCellUnavailable(L) {
      return e.isDateUnavailable ? e.isDateUnavailable(L) : !1;
    },
    isPreviousVisibleRangeInvalid() {
      let L = M.subtract({
        days: 1
      });
      return Fe(L, M) || this.isInvalid(L);
    },
    isNextVisibleRangeInvalid() {
      let L = D.add({
        days: 1
      });
      return Fe(L, D) || this.isInvalid(L);
    },
    getDatesInWeek(L, Z = M) {
      let ie = Z.add({
        weeks: L
      }), q = [], re = l.days && l.days < 7 ? l.days : 7;
      if (re === 7) {
        ie = Qr(ie, r, f);
        let fe = ku(ie, r, f);
        for (let tt = 0; tt < fe; tt++) q.push(null);
      }
      for (; q.length < re; ) {
        q.push(ie);
        let fe = ie.add({
          days: 1
        });
        if (Fe(ie, fe)) break;
        ie = fe;
      }
      for (; q.length < re; ) q.push(null);
      return q;
    },
    getWeeksInMonth(L = M) {
      let Z = h || j2(L, r, f);
      return (l.weeks || l.days) && (Z = l.weeks ?? 0, l.days && (Z += Math.ceil(l.days / 7))), Z;
    }
  };
}
function ni(e) {
  let t = {
    ...e
  };
  for (let n in e) t[n] = 1;
  return t;
}
const Ns = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function tn(e = {}) {
  let { style: t, isFocusable: n } = e, [r, a] = Y(!1), { focusWithinProps: l } = ft({
    isDisabled: !n,
    onFocusWithinChange: (u) => a(u)
  }), i = K(() => r ? t : t ? {
    ...Ns,
    ...t
  } : Ns, [
    r
  ]);
  return {
    visuallyHiddenProps: {
      ...l,
      style: i
    }
  };
}
function gr(e) {
  let { children: t, elementType: n = "div", isFocusable: r, style: a, ...l } = e, { visuallyHiddenProps: i } = tn(e);
  return /* @__PURE__ */ g.createElement(n, z(l, i), t);
}
const sl = /* @__PURE__ */ G(null), U6 = /* @__PURE__ */ G(null), wl = /* @__PURE__ */ G(null), Uu = /* @__PURE__ */ G(null), aC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, sl);
  let { locale: r } = de(), a = H6({
    ...t,
    locale: r,
    createCalendar: t.createCalendar || Q4
  }), { calendarProps: l, prevButtonProps: i, nextButtonProps: u, errorMessageProps: o, title: d } = M6(t, a), s = le({
    ...t,
    values: {
      state: a,
      isDisabled: t.isDisabled || !1,
      isInvalid: a.isValueInvalid
    },
    defaultClassName: "react-aria-Calendar"
  }), c = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(c, s, l),
    ref: n,
    slot: t.slot || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-invalid": a.isValueInvalid || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Xe,
        {
          slots: {
            previous: i,
            next: u
          }
        }
      ],
      [
        Su,
        {
          "aria-hidden": !0,
          level: 2,
          children: d
        }
      ],
      [
        wl,
        a
      ],
      [
        sl,
        t
      ],
      [
        We,
        {
          slots: {
            errorMessage: o
          }
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(gr, null, /* @__PURE__ */ g.createElement("h2", null, l["aria-label"])), s.children, /* @__PURE__ */ g.createElement(gr, null, /* @__PURE__ */ g.createElement("button", {
    "aria-label": u["aria-label"],
    disabled: u.isDisabled,
    onClick: () => a.focusNextPage(),
    tabIndex: -1
  }))));
}), Sl = /* @__PURE__ */ G(null), lC = /* @__PURE__ */ te(function(t, n) {
  let r = O(wl), a = O(Uu), l = He(sl), i = He(U6), u = r ?? a, o = u.visibleRange.start;
  t.offset && (o = o.add(t.offset));
  let d = l?.firstDayOfWeek ?? i?.firstDayOfWeek, { gridProps: s, headerProps: c, weekDays: f, weeksInMonth: h } = K6({
    startDate: o,
    endDate: nl(o),
    weekdayStyle: t.weekdayStyle,
    firstDayOfWeek: d
  }, u), m = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Sl.Provider, {
    value: {
      headerProps: c,
      weekDays: f,
      startDate: o,
      weeksInMonth: h
    }
  }, /* @__PURE__ */ g.createElement(Q.table, {
    render: t.render,
    ...z(m, s),
    ref: n,
    style: t.style,
    cellPadding: 0,
    className: t.className ?? "react-aria-CalendarGrid"
  }, typeof t.children != "function" ? t.children : /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(_6, null, (b) => /* @__PURE__ */ g.createElement(G6, null, b)), /* @__PURE__ */ g.createElement(Y6, null, t.children))));
});
function j6(e, t) {
  let { children: n, style: r, className: a } = e, { headerProps: l, weekDays: i } = O(Sl), u = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.thead, {
    render: e.render,
    ...z(u, l),
    ref: t,
    style: r,
    className: a ?? "react-aria-CalendarGridHeader"
  }, /* @__PURE__ */ g.createElement("tr", null, i.map((o, d) => /* @__PURE__ */ g.cloneElement(n(o), {
    key: d
  }))));
}
const _6 = /* @__PURE__ */ te(j6);
function W6(e, t) {
  let { children: n, style: r, className: a } = e, l = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.th, {
    render: e.render,
    ...l,
    ref: t,
    style: r,
    className: a || "react-aria-CalendarHeaderCell"
  }, n);
}
const G6 = /* @__PURE__ */ te(W6);
function q6(e, t) {
  let { children: n, style: r, className: a } = e, l = O(wl), i = O(Uu), u = l ?? i, { startDate: o, weeksInMonth: d } = O(Sl), s = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.tbody, {
    render: e.render,
    ...s,
    ref: t,
    style: r,
    className: a ?? "react-aria-CalendarGridBody"
  }, [
    ...new Array(d).keys()
  ].map((c) => /* @__PURE__ */ g.createElement("tr", {
    key: c
  }, u.getDatesInWeek(c, o).map((f, h) => f ? /* @__PURE__ */ g.cloneElement(n(f), {
    key: h
  }) : /* @__PURE__ */ g.createElement("td", {
    key: h
  })))));
}
const Y6 = /* @__PURE__ */ te(q6), iC = /* @__PURE__ */ te(function({ date: t, ...n }, r) {
  let a = O(wl), l = O(Uu), i = a ?? l, { startDate: u } = O(Sl) ?? {
    startDate: i.visibleRange.start
  }, o = i.visibleDuration.days || i.visibleDuration.weeks ? !1 : !K2(u, t), d = P4(t, i.timeZone), s = T(null), { cellProps: c, buttonProps: f, ...h } = L6({
    date: t,
    isOutsideMonth: o
  }, i, s), { hoverProps: m, isHovered: b } = De({
    ...n,
    isDisabled: h.isDisabled || h.isUnavailable
  }), { focusProps: p, isFocusVisible: y } = ye();
  y &&= h.isFocused;
  let $ = !1, v = !1;
  "highlightedRange" in i && i.highlightedRange && ($ = Fe(t, i.highlightedRange.start), v = Fe(t, i.highlightedRange.end));
  let x = le({
    ...n,
    defaultChildren: h.formattedDate,
    defaultClassName: "react-aria-CalendarCell",
    values: {
      date: t,
      isHovered: b,
      isOutsideMonth: o,
      isFocusVisible: y,
      isSelectionStart: $,
      isSelectionEnd: v,
      isToday: d,
      ...h
    }
  }), E = {
    "data-focused": h.isFocused || void 0,
    "data-hovered": b || void 0,
    "data-pressed": h.isPressed || void 0,
    "data-unavailable": h.isUnavailable || void 0,
    "data-disabled": h.isDisabled || void 0,
    "data-focus-visible": y || void 0,
    "data-outside-visible-range": h.isOutsideVisibleRange || void 0,
    "data-outside-month": o || void 0,
    "data-selected": h.isSelected || void 0,
    "data-selection-start": $ || void 0,
    "data-selection-end": v || void 0,
    "data-invalid": h.isInvalid || void 0,
    "data-today": d || void 0
  }, P = J(n, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement("td", {
    ...c,
    ref: r
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(P, f, p, m, E, x),
    ref: s
  }));
}), nn = /* @__PURE__ */ G(null), uC = /* @__PURE__ */ te(function(t, n) {
  return O(nn)?.isInvalid ? /* @__PURE__ */ g.createElement(Z6, {
    ...t,
    ref: n
  }) : null;
}), Z6 = /* @__PURE__ */ te((e, t) => {
  let n = O(nn), { elementType: r, ...a } = e, l = J(a, {
    global: !0
  }), i = le({
    ...a,
    defaultClassName: "react-aria-FieldError",
    defaultChildren: n.validationErrors.length === 0 ? void 0 : n.validationErrors.join(" "),
    values: n
  });
  return i.children == null ? null : /* @__PURE__ */ g.createElement(T2, {
    slot: "errorMessage",
    elementType: r,
    ...l,
    ...i,
    ref: t
  });
}), nh = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, rh = {
  ...nh,
  customError: !0,
  valid: !1
}, rr = {
  isInvalid: !1,
  validationDetails: nh,
  validationErrors: []
}, X6 = G({}), Hn = "__reactAriaFormValidationState";
function rn(e) {
  if (e[Hn]) {
    let { realtimeValidation: t, displayValidation: n, updateValidation: r, resetValidation: a, commitValidation: l } = e[Hn];
    return {
      realtimeValidation: t,
      displayValidation: n,
      updateValidation: r,
      resetValidation: a,
      commitValidation: l
    };
  }
  return J6(e);
}
function J6(e) {
  let { isInvalid: t, validationState: n, name: r, value: a, builtinValidation: l, validate: i, validationBehavior: u = "aria" } = e;
  n && (t ||= n === "invalid");
  let o = t !== void 0 ? {
    isInvalid: t,
    validationErrors: [],
    validationDetails: rh
  } : null, d = K(() => {
    if (!i || a == null) return null;
    let V = Q6(i, a);
    return Vs(V);
  }, [
    i,
    a
  ]);
  l?.validationDetails.valid && (l = void 0);
  let s = O(X6), c = K(() => r ? Array.isArray(r) ? r.flatMap((V) => Ui(s[V])) : Ui(s[r]) : [], [
    s,
    r
  ]), [f, h] = Y(s), [m, b] = Y(!1);
  s !== f && (h(s), b(!1));
  let p = K(() => Vs(m ? [] : c), [
    m,
    c
  ]), y = T(rr), [$, v] = Y(rr), x = T(rr), E = () => {
    if (!P) return;
    C(!1);
    let V = d || l || y.current;
    ri(V, x.current) || (x.current = V, v(V));
  }, [P, C] = Y(!1);
  return ee(E), {
    realtimeValidation: o || p || d || l || rr,
    displayValidation: u === "native" ? o || p || $ : o || p || d || l || $,
    updateValidation(V) {
      u === "aria" && !ri($, V) ? v(V) : y.current = V;
    },
    resetValidation() {
      let V = rr;
      ri(V, x.current) || (x.current = V, v(V)), u === "native" && C(!1), b(!0);
    },
    commitValidation() {
      u === "native" && C(!0), b(!0);
    }
  };
}
function Ui(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function Q6(e, t) {
  if (typeof e == "function") {
    let n = e(t);
    if (n && typeof n != "boolean") return Ui(n);
  }
  return [];
}
function Vs(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: rh
  } : null;
}
function ri(e, t) {
  return e === t ? !0 : !!e && !!t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((n, r) => n === t.validationErrors[r]) && Object.entries(e.validationDetails).every(([n, r]) => t.validationDetails[n] === r);
}
const _n = /* @__PURE__ */ G(null), eD = /* @__PURE__ */ new WeakMap();
function Pr(e) {
  let { description: t, errorMessage: n, isInvalid: r, validationState: a } = e, { labelProps: l, fieldProps: i } = ba(e), u = yt([
    !!t,
    !!n,
    r,
    a
  ]), o = yt([
    !!t,
    !!n,
    r,
    a
  ]);
  return i = z(i, {
    "aria-describedby": [
      u,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      o,
      e["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: l,
    fieldProps: i,
    descriptionProps: {
      id: u
    },
    errorMessageProps: {
      id: o
    }
  };
}
function an(e, t, n) {
  let r = xe((a) => {
    n && !a.defaultPrevented && n(t);
  });
  ee(() => {
    let a = e?.current?.form;
    return a?.addEventListener("reset", r), () => {
      a?.removeEventListener("reset", r);
    };
  }, [
    e
  ]);
}
function $a(e, t, n) {
  let { validationBehavior: r, focus: a } = e;
  ue(() => {
    if (r === "native" && n?.current && "setCustomValidity" in n.current && !n.current.disabled) {
      let d = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      n.current.setCustomValidity(d), n.current.hasAttribute("title") || (n.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation(nD(n.current));
    }
  });
  let l = T(!1), i = xe(() => {
    l.current || t.resetValidation();
  }), u = xe((d) => {
    t.displayValidation.isInvalid || t.commitValidation();
    let s = n?.current?.form;
    !d.defaultPrevented && n && s && rD(s) === n.current && (a ? a() : n.current?.focus(), Yr("keyboard")), d.preventDefault();
  }), o = xe(() => {
    t.commitValidation();
  });
  ee(() => {
    let d = n?.current;
    if (!d) return;
    let s = d.form, c = s?.reset;
    return s && (s.reset = () => {
      l.current = !window.event || window.event.type === "message" && W(window.event) instanceof MessagePort, c?.call(s), l.current = !1;
    }), d.addEventListener("invalid", u), d.addEventListener("change", o), s?.addEventListener("reset", i), () => {
      d.removeEventListener("invalid", u), d.removeEventListener("change", o), s?.removeEventListener("reset", i), s && (s.reset = c);
    };
  }, [
    n,
    r
  ]);
}
function tD(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function nD(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: tD(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function rD(e) {
  for (let t = 0; t < e.elements.length; t++) {
    let n = e.elements[t];
    if (n.validity?.valid === !1) return n;
  }
  return null;
}
function aD(e = !0) {
  let [t, n] = Y(e), r = T(!1), a = X((l) => {
    r.current = !0, n(!!l);
  }, []);
  return ue(() => {
    r.current || n(!1);
  }, []), [
    a,
    t
  ];
}
function ji(e = !0) {
  let t = ce(), [n, r] = aD(e);
  return {
    id: r ? t : void 0,
    ref: n
  };
}
function ah(e, t, n) {
  let { isDisabled: r = !1, isReadOnly: a = !1, value: l, name: i, form: u, children: o, isRequired: d, validationBehavior: s = "aria", "aria-label": c, "aria-labelledby": f, "aria-describedby": h, onPressStart: m, onPressEnd: b, onPressChange: p, onPress: y, onPressUp: $, onClick: v } = e, x = rn({
    ...e,
    value: t.isSelected
  }), { isInvalid: E, validationErrors: P, validationDetails: C } = x.displayValidation;
  $a(e, x, n);
  let M = (j) => {
    j.stopPropagation(), t.setSelected(W(j).checked);
  }, F = o != null, V = c != null || f != null;
  !F && !V && process.env.NODE_ENV !== "production" && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let { pressProps: I, isPressed: A } = Je({
    onPressStart: m,
    onPressEnd: b,
    onPressChange: p,
    onPress: y,
    onPressUp: $,
    onClick: v,
    isDisabled: r
  }), [U, D] = Y(!1), { pressProps: N } = Je({
    onPressStart(j) {
      if (j.pointerType === "keyboard" || j.pointerType === "virtual") {
        j.continuePropagation();
        return;
      }
      m?.(j), p?.(!0), D(!0);
    },
    onPressEnd(j) {
      if (j.pointerType === "keyboard" || j.pointerType === "virtual") {
        j.continuePropagation();
        return;
      }
      b?.(j), p?.(!1), D(!1);
    },
    onPressUp(j) {
      if (j.pointerType === "keyboard" || j.pointerType === "virtual") {
        j.continuePropagation();
        return;
      }
      $?.(j);
    },
    onClick: v,
    onPress(j) {
      if (j.pointerType === "keyboard" || j.pointerType === "virtual") {
        j.continuePropagation();
        return;
      }
      y?.(j), t.toggle(), n.current?.focus();
      let { [Hn]: _ } = e, { commitValidation: B } = _ || x;
      B();
    },
    isDisabled: r || a
  }), { focusableProps: w } = ct(e, n), R = z(I, w), H = J(e, {
    labelable: !0
  });
  an(n, t.defaultSelected, t.setSelected);
  let k = ji(), S = ji();
  return {
    labelProps: z(N, {
      onClick: (j) => j.preventDefault()
    }),
    inputProps: z(H, {
      checked: t.isSelected,
      "aria-required": d && s === "aria" || void 0,
      required: d && s === "native",
      "aria-invalid": E || e.validationState === "invalid" || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-controls": e["aria-controls"],
      "aria-readonly": a || void 0,
      "aria-describedby": [
        k.id,
        S.id,
        h
      ].filter(Boolean).join(" ") || void 0,
      onChange: M,
      disabled: r,
      ...l == null ? {} : {
        value: l
      },
      name: i,
      form: u,
      type: "checkbox",
      ...R
    }),
    descriptionProps: k,
    errorMessageProps: S,
    isSelected: t.isSelected,
    isPressed: A || U,
    isDisabled: r,
    isReadOnly: a,
    isInvalid: E || e.validationState === "invalid",
    validationErrors: P,
    validationDetails: C
  };
}
function lh(e, t, n) {
  let { labelProps: r, inputProps: a, descriptionProps: l, errorMessageProps: i, isSelected: u, isPressed: o, isDisabled: d, isReadOnly: s, isInvalid: c, validationErrors: f, validationDetails: h } = ah(e, t, n), { isIndeterminate: m } = e;
  return ee(() => {
    n.current && (n.current.indeterminate = !!m);
  }), {
    labelProps: z(r, K(() => ({
      // Prevent label from being focused when mouse down on it.
      // Note, this does not prevent the input from being focused in the `click` event.
      onMouseDown: (b) => b.preventDefault()
    }), [])),
    inputProps: a,
    descriptionProps: l,
    errorMessageProps: i,
    isSelected: u,
    isPressed: o,
    isDisabled: d,
    isReadOnly: s,
    isInvalid: c,
    validationErrors: f,
    validationDetails: h
  };
}
function kl(e = {}) {
  let { isReadOnly: t } = e, [n, r] = we(e.isSelected, e.defaultSelected || !1, e.onChange), [a] = Y(n);
  function l(u) {
    t || r(u);
  }
  function i() {
    t || r(!n);
  }
  return {
    isSelected: n,
    defaultSelected: e.defaultSelected ?? a,
    setSelected: l,
    toggle: i
  };
}
function lD(e, t, n) {
  const r = kl({
    isReadOnly: e.isReadOnly || t.isReadOnly,
    isSelected: t.isSelected(e.value),
    defaultSelected: t.defaultValue.includes(e.value),
    onChange(b) {
      b ? t.addValue(e.value) : t.removeValue(e.value), e.onChange && e.onChange(b);
    }
  });
  let { name: a, form: l, descriptionId: i, errorMessageId: u, validationBehavior: o } = eD.get(t);
  o = e.validationBehavior ?? o;
  let { realtimeValidation: d } = rn({
    ...e,
    value: r.isSelected,
    // Server validation is handled at the group level.
    name: void 0,
    validationBehavior: "aria"
  }), s = T(rr), c = () => {
    t.setInvalid(e.value, d.isInvalid ? d : s.current);
  };
  ee(c);
  let f = t.realtimeValidation.isInvalid ? t.realtimeValidation : d, h = o === "native" ? t.displayValidation : f, m = lh({
    ...e,
    isReadOnly: e.isReadOnly || t.isReadOnly,
    isDisabled: e.isDisabled || t.isDisabled,
    name: e.name || a,
    form: e.form || l,
    isRequired: e.isRequired ?? t.isRequired,
    validationBehavior: o,
    [Hn]: {
      realtimeValidation: f,
      displayValidation: h,
      resetValidation: t.resetValidation,
      commitValidation: t.commitValidation,
      updateValidation(b) {
        s.current = b, c();
      }
    }
  }, r, n);
  return {
    ...m,
    inputProps: {
      ...m.inputProps,
      "aria-describedby": [
        m.inputProps["aria-describedby"],
        t.isInvalid ? u : null,
        i
      ].filter(Boolean).join(" ") || void 0
    }
  };
}
const ju = /* @__PURE__ */ G(null), ih = /* @__PURE__ */ G(null), iD = /* @__PURE__ */ G(null), uh = /* @__PURE__ */ G(null);
function uD(e, t) {
  let { validationBehavior: n } = He(_n) || {}, r = e.validationBehavior ?? n ?? "native", a = O(iD), l = $e(K(() => Pt(t, e.inputRef !== void 0 ? e.inputRef : null), [
    t,
    e.inputRef
  ])), i = {
    ...wt(e),
    children: typeof e.children == "function" ? !0 : e.children,
    value: e.value,
    validationBehavior: r
  };
  return [
    a ? lD(i, a, l) : lh(i, kl(e), l),
    l
  ];
}
const oC = /* @__PURE__ */ te(function(t, n) {
  let { inputRef: r = null, ...a } = t;
  [t, n] = oe(a, n, ju);
  let [l, i] = uD(t, r);
  return /* @__PURE__ */ g.createElement(uh.Provider, {
    value: {
      ...l,
      inputRef: i,
      defaultClassName: "react-aria-Checkbox",
      isIndeterminate: t.isIndeterminate,
      isRequired: t.isRequired
    }
  }, /* @__PURE__ */ g.createElement(oD, {
    ...t,
    ref: n
  }));
}), oD = /* @__PURE__ */ te(function(t, n) {
  let { labelProps: r, inputProps: a, isSelected: l, isDisabled: i, isReadOnly: u, isPressed: o, isInvalid: d, inputRef: s, defaultClassName: c, isIndeterminate: f, isRequired: h } = O(uh), { isFocused: m, isFocusVisible: b, focusProps: p } = ye(), y = i || u, { hoverProps: $, isHovered: v } = De({
    ...t,
    isDisabled: y
  }), x = le({
    ...t,
    defaultClassName: c,
    values: {
      isSelected: l,
      isIndeterminate: f || !1,
      isPressed: o,
      isHovered: v,
      isFocused: m,
      isFocusVisible: b,
      isDisabled: i,
      isReadOnly: u,
      isInvalid: d,
      isRequired: h || !1
    }
  }), E = J(t, {
    global: !0
  });
  return delete E.id, delete E.onClick, /* @__PURE__ */ g.createElement(Q.label, {
    ...z(E, r, $, x),
    ref: n,
    slot: t.slot || void 0,
    "data-selected": l || void 0,
    "data-indeterminate": f || void 0,
    "data-pressed": o || void 0,
    "data-hovered": v || void 0,
    "data-focused": m || void 0,
    "data-focus-visible": b || void 0,
    "data-disabled": i || void 0,
    "data-readonly": u || void 0,
    "data-invalid": d || void 0,
    "data-required": h || void 0
  }, /* @__PURE__ */ g.createElement(gr, {
    elementType: "span"
  }, /* @__PURE__ */ g.createElement("input", {
    ...z(a, p),
    ref: s
  })), x.children);
}), _u = /* @__PURE__ */ G(null), sC = /* @__PURE__ */ te(function(t, n) {
  let { state: r, thumbProps: a, inputXRef: l, inputYRef: i, xInputProps: u, yInputProps: o, isDisabled: d = !1 } = O(_u), { focusProps: s, isFocused: c, isFocusVisible: f } = ye(), { hoverProps: h, isHovered: m } = De(t), b = le({
    ...t,
    defaultClassName: "react-aria-ColorThumb",
    defaultStyle: {
      ...a.style,
      backgroundColor: r.getDisplayColor().toString()
    },
    values: {
      color: r.getDisplayColor(),
      isHovered: m,
      isDragging: r.isDragging,
      isFocused: c,
      isFocusVisible: f,
      isDisabled: d
    }
  }), p = J(t, {
    global: !0
  });
  return delete p.id, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(a, h, p),
    ...b,
    ref: n,
    "data-hovered": m || void 0,
    "data-dragging": r.isDragging || void 0,
    "data-focused": c || void 0,
    "data-focus-visible": f || void 0,
    "data-disabled": d || void 0
  }, /* @__PURE__ */ g.createElement("input", {
    ref: l,
    ...u,
    ...s
  }), o && /* @__PURE__ */ g.createElement("input", {
    ref: i,
    ...o,
    ...s
  }), b.children);
});
var oh = {};
oh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "أداة انتقاء اللون",
  colorSwatch: "تغيير الألوان",
  transparent: "شفاف",
  twoDimensionalSlider: "مُنزلق 2D"
};
var sh = {};
sh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Средство за избиране на цвят",
  colorSwatch: "цветна мостра",
  transparent: "прозрачен",
  twoDimensionalSlider: "2D плъзгач"
};
var dh = {};
dh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Výběr barvy",
  colorSwatch: "barevný vzorek",
  transparent: "průhledný",
  twoDimensionalSlider: "2D posuvník"
};
var ch = {};
ch = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Farvevælger",
  colorSwatch: "farveprøve",
  transparent: "gennemsigtig",
  twoDimensionalSlider: "2D-skyder"
};
var fh = {};
fh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Farbwähler",
  colorSwatch: "Farbfeld",
  transparent: "transparent",
  twoDimensionalSlider: "2D-Schieberegler"
};
var hh = {};
hh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Επιλογέας χρωμάτων",
  colorSwatch: "χρωματικό δείγμα",
  transparent: "διαφανές",
  twoDimensionalSlider: "Ρυθμιστικό 2D"
};
var mh = {};
mh = {
  colorPicker: "Color picker",
  twoDimensionalSlider: "2D slider",
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorSwatch: "color swatch",
  transparent: "transparent"
};
var bh = {};
bh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Selector de color",
  colorSwatch: "muestra de color",
  transparent: "transparente",
  twoDimensionalSlider: "Regulador 2D"
};
var ph = {};
ph = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Värvivalija",
  colorSwatch: "värvinäidis",
  transparent: "läbipaistev",
  twoDimensionalSlider: "2D-liugur"
};
var gh = {};
gh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Värimuokkain",
  colorSwatch: "värimalli",
  transparent: "läpinäkyvä",
  twoDimensionalSlider: "2D-liukusäädin"
};
var yh = {};
yh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name} : ${e.value}`,
  colorPicker: "Sélecteur de couleurs",
  colorSwatch: "Échantillon de couleurs",
  transparent: "Transparent",
  twoDimensionalSlider: "Curseur 2D"
};
var $h = {};
$h = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "בוחר הצבעים",
  colorSwatch: "דוגמית צבע",
  transparent: "שקוף",
  twoDimensionalSlider: "מחוון דו מימדי"
};
var vh = {};
vh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Odabir boje",
  colorSwatch: "uzorak boje",
  transparent: "transparentno",
  twoDimensionalSlider: "2D klizač"
};
var Dh = {};
Dh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Színválasztó",
  colorSwatch: "színtár",
  transparent: "átlátszó",
  twoDimensionalSlider: "2D-csúszka"
};
var xh = {};
xh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Selettore colore",
  colorSwatch: "campione di colore",
  transparent: "trasparente",
  twoDimensionalSlider: "Cursore 2D"
};
var Eh = {};
Eh = {
  colorInputLabel: (e) => `${e.label}、${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name} : ${e.value}`,
  colorPicker: "カラーピッカー",
  colorSwatch: "カラースウォッチ",
  transparent: "透明",
  twoDimensionalSlider: "2D スライダー"
};
var Ch = {};
Ch = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "색상 피커",
  colorSwatch: "색상 견본",
  transparent: "투명도",
  twoDimensionalSlider: "2D 슬라이더"
};
var Ph = {};
Ph = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Spalvų parinkiklis",
  colorSwatch: "spalvų pavyzdys",
  transparent: "skaidrus",
  twoDimensionalSlider: "2D slankiklis"
};
var wh = {};
wh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Krāsu atlasītājs",
  colorSwatch: "krāsu paraugs",
  transparent: "caurspīdīgs",
  twoDimensionalSlider: "2D slīdnis"
};
var Sh = {};
Sh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Fargevelger",
  colorSwatch: "fargekart",
  transparent: "gjennomsiktig",
  twoDimensionalSlider: "2D-glidebryter"
};
var kh = {};
kh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Kleurkiezer",
  colorSwatch: "kleurstaal",
  transparent: "transparant",
  twoDimensionalSlider: "2D-schuifregelaar"
};
var Bh = {};
Bh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Próbnik kolorów",
  colorSwatch: "próbka koloru",
  transparent: "przezroczysty",
  twoDimensionalSlider: "Suwak 2D"
};
var Fh = {};
Fh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Seletor de cores",
  colorSwatch: "amostra de cores",
  transparent: "transparente",
  twoDimensionalSlider: "Controle deslizante 2D"
};
var Ah = {};
Ah = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Seletor de cores",
  colorSwatch: "amostra de cor",
  transparent: "transparente",
  twoDimensionalSlider: "Controle deslizante 2D"
};
var Rh = {};
Rh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Selector de culori",
  colorSwatch: "specimen de culoare",
  transparent: "transparent",
  twoDimensionalSlider: "Glisor 2D"
};
var Th = {};
Th = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Палитра цветов",
  colorSwatch: "цветовой образец",
  transparent: "прозрачный",
  twoDimensionalSlider: "Ползунок 2D"
};
var Ih = {};
Ih = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Výber farieb",
  colorSwatch: "vzorkovník farieb",
  transparent: "transparentný",
  twoDimensionalSlider: "2D jazdec"
};
var Mh = {};
Mh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Izbirnik barv",
  colorSwatch: "barvna paleta",
  transparent: "prozorno",
  twoDimensionalSlider: "2D drsnik"
};
var Kh = {};
Kh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Birač boja",
  colorSwatch: "Uzorak boje",
  transparent: "providno",
  twoDimensionalSlider: "2D klizač"
};
var Nh = {};
Nh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Färgväljaren",
  colorSwatch: "färgruta",
  transparent: "genomskinlig",
  twoDimensionalSlider: "2D-reglage"
};
var Vh = {};
Vh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Renk Seçici",
  colorSwatch: "renk örneği",
  transparent: "saydam",
  twoDimensionalSlider: "2D sürgü"
};
var Lh = {};
Lh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Палітра кольорів",
  colorSwatch: "зразок кольору",
  transparent: "прозорий",
  twoDimensionalSlider: "Повзунок 2D"
};
var zh = {};
zh = {
  colorInputLabel: (e) => `${e.label}、${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}：${e.value}`,
  colorPicker: "拾色器",
  colorSwatch: "颜色色板",
  transparent: "透明",
  twoDimensionalSlider: "2D 滑块"
};
var Oh = {};
Oh = {
  colorInputLabel: (e) => `${e.label}，${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}：${e.value}`,
  colorPicker: "檢色器",
  colorSwatch: "色票",
  transparent: "透明",
  twoDimensionalSlider: "2D 滑桿"
};
var Wu = {};
Wu = {
  "ar-AE": oh,
  "bg-BG": sh,
  "cs-CZ": dh,
  "da-DK": ch,
  "de-DE": fh,
  "el-GR": hh,
  "en-US": mh,
  "es-ES": bh,
  "et-EE": ph,
  "fi-FI": gh,
  "fr-FR": yh,
  "he-IL": $h,
  "hr-HR": vh,
  "hu-HU": Dh,
  "it-IT": xh,
  "ja-JP": Eh,
  "ko-KR": Ch,
  "lt-LT": Ph,
  "lv-LV": wh,
  "nb-NO": Sh,
  "nl-NL": kh,
  "pl-PL": Bh,
  "pt-BR": Fh,
  "pt-PT": Ah,
  "ro-RO": Rh,
  "ru-RU": Th,
  "sk-SK": Ih,
  "sl-SI": Mh,
  "sr-SP": Kh,
  "sv-SE": Nh,
  "tr-TR": Vh,
  "uk-UA": Lh,
  "zh-CN": zh,
  "zh-TW": Oh
};
var Hh = {};
Hh = {
  alpha: "ألفا",
  black: "أسود",
  blue: "أزرق",
  "blue purple": "أرجواني مزرق",
  brightness: "السطوع",
  brown: "بني",
  "brown yellow": "أصفر بني",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "سماوي",
  "cyan blue": "أزرق سماوي",
  dark: "داكن",
  gray: "رمادي",
  grayish: "مائل للرمادي",
  green: "أخضر",
  "green cyan": "سماوي مخضر",
  hue: "درجة اللون",
  light: "فاتح",
  lightness: "الإضاءة",
  magenta: "أرجواني",
  "magenta pink": "أرجواني وردي",
  orange: "برتقالي",
  "orange yellow": "أصفر برتقالي",
  pale: "باهت",
  pink: "وردي",
  "pink red": "أحمر وردي",
  purple: "أرجواني",
  "purple magenta": "بنفسجي",
  red: "أحمر",
  "red orange": "برتقالي محمر",
  saturation: "التشبع",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} شفاف`,
  "very dark": "داكن جدًا",
  "very light": "فاتح جدًا",
  vibrant: "ساطع",
  white: "أبيض",
  yellow: "أصفر",
  "yellow green": "أخضر مصفر"
};
var Uh = {};
Uh = {
  alpha: "Алфа",
  black: "черно",
  blue: "Синьо",
  "blue purple": "синьо лилаво",
  brightness: "Яркост",
  brown: "кафяво",
  "brown yellow": "кафяво жълто",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "циан",
  "cyan blue": "циан синьо",
  dark: "тъмно",
  gray: "сиво",
  grayish: "сивкав",
  green: "Зелено",
  "green cyan": "зелен циан",
  hue: "Оттенък",
  light: "светло",
  lightness: "Лекота",
  magenta: "магента",
  "magenta pink": "магента розово",
  orange: "оранжево",
  "orange yellow": "оранжево жълто",
  pale: "бледо",
  pink: "розово",
  "pink red": "розово червено",
  purple: "лилаво",
  "purple magenta": "лилаво магента",
  red: "Червено",
  "red orange": "червен портокал",
  saturation: "Наситеност",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} прозрачен`,
  "very dark": "много тъмно",
  "very light": "много светло",
  vibrant: " ярко",
  white: "бяло",
  yellow: "жълто",
  "yellow green": "жълто зелен"
};
var jh = {};
jh = {
  alpha: "Alfa",
  black: "černá",
  blue: "Modrá",
  "blue purple": "modrofialová",
  brightness: "Jas",
  brown: "hnědá",
  "brown yellow": "hnědožlutá",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "tyrkysová",
  "cyan blue": "tyrkysovomodrá",
  dark: "tmavá",
  gray: "šedá",
  grayish: "našedlá",
  green: "Zelená",
  "green cyan": "zelenotyrkysová",
  hue: "Odstín",
  light: "světlá",
  lightness: "Světlost",
  magenta: "purpurová",
  "magenta pink": "purpurově růžová",
  orange: "oranžová",
  "orange yellow": "oranžovožlutá",
  pale: "bledá",
  pink: "růžová",
  "pink red": "růžovočervená",
  purple: "fialová",
  "purple magenta": "fialově purpurová",
  red: "Červená",
  "red orange": "červenooranžová",
  saturation: "Sytost",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} průhledné`,
  "very dark": "velmi tmavá",
  "very light": "velmi světlá",
  vibrant: "zářivá",
  white: "bílá",
  yellow: "žlutá",
  "yellow green": "žlutozelená"
};
var _h = {};
_h = {
  alpha: "Alfa",
  black: "sort",
  blue: "Blå",
  "blue purple": "blålilla",
  brightness: "Lysstyrke",
  brown: "brun",
  "brown yellow": "brungul",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cyan",
  "cyan blue": "cyan blå",
  dark: "mørk",
  gray: "grå",
  grayish: "grålig",
  green: "Grøn",
  "green cyan": "grøn cyan",
  hue: "Tone",
  light: "lys",
  lightness: "Lyshed",
  magenta: "magenta",
  "magenta pink": "magenta pink",
  orange: "orange",
  "orange yellow": "orangegul",
  pale: "bleg",
  pink: "lyserød",
  "pink red": "lyserødlig rød",
  purple: "lilla",
  "purple magenta": "lilla magenta",
  red: "Rød",
  "red orange": "rødorange",
  saturation: "Farvemætning",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} gennemsigtig`,
  "very dark": "meget mørk",
  "very light": "meget lys",
  vibrant: "klar",
  white: "hvid",
  yellow: "gul",
  "yellow green": "gulgrøn"
};
var Wh = {};
Wh = {
  alpha: "Alpha",
  black: "Schwarz",
  blue: "Blau",
  "blue purple": "Blaulila",
  brightness: "Helligkeit",
  brown: "Braun",
  "brown yellow": "Braungelb",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "Cyan",
  "cyan blue": "Cyanblau",
  dark: "dunkles",
  gray: "Grau",
  grayish: "gräuliches",
  green: "Grün",
  "green cyan": "Grüncyan",
  hue: "Farbton",
  light: "helles",
  lightness: "Leuchtkraft",
  magenta: "Magenta",
  "magenta pink": "Magentarosa",
  orange: "Orange",
  "orange yellow": "Orangegelb",
  pale: "blasses",
  pink: "Rosa",
  "pink red": "Rosarot",
  purple: "Lila",
  "purple magenta": "Lilamagenta",
  red: "Rot",
  "red orange": "Rotorange",
  saturation: "Sättigung",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, zu ${e.percentTransparent} transparent`,
  "very dark": "sehr dunkles",
  "very light": "sehr helles",
  vibrant: "lebhaftes",
  white: "Weiß",
  yellow: "Gelb",
  "yellow green": "Gelbgrün"
};
var Gh = {};
Gh = {
  alpha: "Άλφα",
  black: "μαύρο",
  blue: "Μπλε",
  "blue purple": "μπλε μωβ",
  brightness: "Φωτεινότητα",
  brown: "καφέ",
  "brown yellow": "καφέ κίτρινο",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "κυανό",
  "cyan blue": "κυανό μπλε",
  dark: "σκούρο",
  gray: "γκρι",
  grayish: "γκριζωπό",
  green: "Πράσινο",
  "green cyan": "πράσινο κυανό",
  hue: "Τόνος",
  light: "ανοιχτό",
  lightness: "Φωτεινότητα",
  magenta: "ματζέντα",
  "magenta pink": "ματζέντα ροζ",
  orange: "πορτοκαλί",
  "orange yellow": "πορτοκαλί κίτρινο",
  pale: "ανοιχτό",
  pink: "ροζ",
  "pink red": "ροζ κόκκινο",
  purple: "μωβ",
  "purple magenta": "μωβ ματζέντα",
  red: "Κόκκινο",
  "red orange": "κόκκινο πορτοκαλί",
  saturation: "Κορεσμός",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} διαφανές`,
  "very dark": "πολύ σκούρο",
  "very light": "πολύ ανοιχτό",
  vibrant: "έντονο",
  white: "λευκό",
  yellow: "κίτρινο",
  "yellow green": "κίτρινο πράσινο"
};
var qh = {};
qh = {
  hue: "Hue",
  saturation: "Saturation",
  lightness: "Lightness",
  brightness: "Brightness",
  red: "Red",
  green: "Green",
  blue: "Blue",
  alpha: "Alpha",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparent`,
  "very dark": "very dark",
  dark: "dark",
  light: "light",
  "very light": "very light",
  pale: "pale",
  grayish: "grayish",
  vibrant: "vibrant",
  black: "black",
  white: "white",
  gray: "gray",
  pink: "pink",
  "pink red": "pink red",
  "red orange": "red orange",
  brown: "brown",
  orange: "orange",
  "orange yellow": "orange yellow",
  "brown yellow": "brown yellow",
  yellow: "yellow",
  "yellow green": "yellow green",
  "green cyan": "green cyan",
  cyan: "cyan",
  "cyan blue": "cyan blue",
  "blue purple": "blue purple",
  purple: "purple",
  "purple magenta": "purple magenta",
  magenta: "magenta",
  "magenta pink": "magenta pink"
};
var Yh = {};
Yh = {
  alpha: "Alpha",
  black: "negro",
  blue: "Azul",
  "blue purple": "púrpura azulado",
  brightness: "Brillo",
  brown: "marrón",
  "brown yellow": "amarillo amarronado",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cian",
  "cyan blue": "azul cian",
  dark: "oscuro",
  gray: "gris",
  grayish: "grisáceo",
  green: "Verde",
  "green cyan": "cian verdoso",
  hue: "Tono",
  light: "claro",
  lightness: "Luminosidad",
  magenta: "magenta",
  "magenta pink": "rosa magenta",
  orange: "naranja",
  "orange yellow": "amarillo anaranjado",
  pale: "pálido",
  pink: "rosa",
  "pink red": "rojo rosado",
  purple: "morado",
  "purple magenta": "magenta violáceo",
  red: "Rojo",
  "red orange": "naranja rojizo",
  saturation: "Saturación",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparente`,
  "very dark": "muy oscuro",
  "very light": "muy claro",
  vibrant: "intenso",
  white: "blanco",
  yellow: "amarillo",
  "yellow green": "verde amarillento"
};
var Zh = {};
Zh = {
  alpha: "Alfa",
  black: "must",
  blue: "Sinine",
  "blue purple": "sinakaslilla",
  brightness: "Heledus",
  brown: "pruun",
  "brown yellow": "pruunikaskollane",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "tsüaan",
  "cyan blue": "tsüaansinine",
  dark: "tume",
  gray: "hall",
  grayish: "hallikas",
  green: "Roheline",
  "green cyan": "tsüaanroheline",
  hue: "Värv",
  light: "valgus",
  lightness: "Valgus",
  magenta: "magentapunane",
  "magenta pink": "magentaroosa",
  orange: "oranž",
  "orange yellow": "oranžikaskollane",
  pale: "kahvatu",
  pink: "roosa",
  "pink red": "vaarikapunane",
  purple: "lilla",
  "purple magenta": "purpurne magenta",
  red: "Punane",
  "red orange": "punakasoranž",
  saturation: "Küllastus",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} läbipaistev`,
  "very dark": "väga tume",
  "very light": "väga hele",
  vibrant: "ere",
  white: "valge",
  yellow: "kollane",
  "yellow green": "kollakasroheline"
};
var Xh = {};
Xh = {
  alpha: "Alpha",
  black: "musta",
  blue: "Sininen",
  "blue purple": "sinivioletti",
  brightness: "Kirkkaus",
  brown: "ruskea",
  "brown yellow": "ruskeankeltainen",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "syaani",
  "cyan blue": "syaaninsininen",
  dark: "tumma",
  gray: "harmaa",
  grayish: "harmahtava",
  green: "Vihreä",
  "green cyan": "vihreänsyaani",
  hue: "Sävy",
  light: "vaalea",
  lightness: "Valomäärä",
  magenta: "magenta",
  "magenta pink": "magentapinkki",
  orange: "oranssi",
  "orange yellow": "oranssinkeltainen",
  pale: "vaalea",
  pink: "pinkki",
  "pink red": "vaaleanpunainen",
  purple: "violetti",
  "purple magenta": "violettimagenta",
  red: "Punainen",
  "red orange": "punaoranssi",
  saturation: "Värikylläisyys",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} läpinäkyvä`,
  "very dark": "hyvin tumma",
  "very light": "erittäin vaalea",
  vibrant: "eloisa",
  white: "valkea",
  yellow: "keltainen",
  "yellow green": "keltavihreä"
};
var Jh = {};
Jh = {
  alpha: "Alpha",
  black: "Noir",
  blue: "Bleu",
  "blue purple": "Violet bleu",
  brightness: "Luminosité",
  brown: "Brun",
  "brown yellow": "Jaune brun",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "Cyan",
  "cyan blue": "Bleu cyan",
  dark: "Sombre",
  gray: "Gris",
  grayish: "Grisâtre",
  green: "Vert",
  "green cyan": "Cyan vert",
  hue: "Teinte",
  light: "Clair",
  lightness: "Luminosité",
  magenta: "Magenta",
  "magenta pink": "Rose magenta",
  orange: "Orange",
  "orange yellow": "Jaune orangé",
  pale: "Pâle",
  pink: "Rose",
  "pink red": "Rouge rosé",
  purple: "Violet",
  "purple magenta": "Magenta violet",
  red: "Rouge",
  "red orange": "Orange rouge",
  saturation: "Saturation",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparent`,
  "very dark": "Très sombre",
  "very light": "Très clair",
  vibrant: "Vif",
  white: "Blanc",
  yellow: "Jaune",
  "yellow green": "Vert jaune"
};
var Qh = {};
Qh = {
  alpha: "אלפא",
  black: "שחור",
  blue: "כחול",
  "blue purple": "כחול סגול",
  brightness: "בהירות",
  brown: "חום",
  "brown yellow": "חום צהוב",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "טורקיז",
  "cyan blue": "כחול ציאן",
  dark: "כהה",
  gray: "אפור",
  grayish: "אפרפר",
  green: "ירוק",
  "green cyan": "ציאן ירוק",
  hue: "גוון",
  light: "אור",
  lightness: "כמות אור",
  magenta: "מג'נטה",
  "magenta pink": "ורוד מג'נטה",
  orange: "כתום",
  "orange yellow": "כתום צהוב",
  pale: "חיוור",
  pink: "ורוד",
  "pink red": "ורוד אדום",
  purple: "סגול",
  "purple magenta": "מג'נטה סגול",
  red: "אדום",
  "red orange": "כתום אדום",
  saturation: "רוויה",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} שקוף`,
  "very dark": "כהה מאוד",
  "very light": "בהיר מאוד",
  vibrant: "תוסס",
  white: "לבן",
  yellow: "צהוב",
  "yellow green": "צהוב ירוק"
};
var e3 = {};
e3 = {
  alpha: "Alfa",
  black: "crno",
  blue: "Plava",
  "blue purple": "plavo ljubičasta",
  brightness: "Svjetlina",
  brown: "smeđa",
  "brown yellow": "smeđe žuta",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cijan",
  "cyan blue": "cijan plava",
  dark: "tamno",
  gray: "siva",
  grayish: "sivkasto",
  green: "Zelena",
  "green cyan": "zelena cijan",
  hue: "Nijansa",
  light: "svjetlo",
  lightness: "Osvijetljenost",
  magenta: "magenta",
  "magenta pink": "magentno ružičasta",
  orange: "narančasta",
  "orange yellow": "narančasto žuta",
  pale: "blijeda",
  pink: "ružičasta",
  "pink red": "ružičasto crvena",
  purple: "ljubičasta",
  "purple magenta": "ljubičasta magenta",
  red: "Crvena",
  "red orange": "crveno narančasta",
  saturation: "Zasićenost",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} prozirnosti`,
  "very dark": "jako tamna",
  "very light": "vrlo svijetlo",
  vibrant: "vibrantna",
  white: "bijela",
  yellow: "žuto",
  "yellow green": "žuto zelena"
};
var t3 = {};
t3 = {
  alpha: "Alfa",
  black: "fekete",
  blue: "Kék",
  "blue purple": "kék lila",
  brightness: "Fényesség",
  brown: "barna",
  "brown yellow": "barna sárga",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "ciánkék",
  "cyan blue": "ciánkék",
  dark: "sötét",
  gray: "szürke",
  grayish: "szürkés",
  green: "Zöld",
  "green cyan": "zöld ciánkék",
  hue: "Színárnyalat",
  light: "világos",
  lightness: "Világosság",
  magenta: "bíbor",
  "magenta pink": "bíbor rózsaszín",
  orange: "narancs",
  "orange yellow": "narancssárga",
  pale: "halvány",
  pink: "rózsaszín",
  "pink red": "rózsaszín piros",
  purple: "lila",
  "purple magenta": "lila bíbor",
  red: "Piros",
  "red orange": "piros narancs",
  saturation: "Telítettség",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} átlátszó`,
  "very dark": "nagyon sötét",
  "very light": "nagyon világos",
  vibrant: "élénk",
  white: "fehér",
  yellow: "sárga",
  "yellow green": "sárga zöld"
};
var n3 = {};
n3 = {
  alpha: "Alfa",
  black: "nero",
  blue: "Blu",
  "blue purple": "blu viola",
  brightness: "Luminosità",
  brown: "marrone",
  "brown yellow": "giallo bruno",
  colorName: (e) => `${e.hue} ${e.chroma} ${e.lightness}`,
  cyan: "ciano",
  "cyan blue": "blu ciano",
  dark: "scuro",
  gray: "grigio",
  grayish: "grigiastro",
  green: "Verde",
  "green cyan": "verde ciano",
  hue: "Tonalità",
  light: "chiaro",
  lightness: "Luminosità",
  magenta: "magenta",
  "magenta pink": "rosa magenta",
  orange: "arancio",
  "orange yellow": "giallo arancio",
  pale: "tenue",
  pink: "rosa",
  "pink red": "rosa rosso",
  purple: "viola",
  "purple magenta": "viola magenta",
  red: "Rosso",
  "red orange": "rosso arancio",
  saturation: "Saturazione",
  transparentColorName: (e) => `${e.hue} ${e.chroma} ${e.lightness}, trasparenza ${e.percentTransparent}`,
  "very dark": "molto scuro",
  "very light": "molto chiaro",
  vibrant: "vivace",
  white: "bianco",
  yellow: "giallo",
  "yellow green": "giallo verde"
};
var r3 = {};
r3 = {
  alpha: "アルファ",
  black: "ブラック",
  blue: "青",
  "blue purple": "ブルーパープル",
  brightness: "明るさ",
  brown: "ブラウン",
  "brown yellow": "ブラウンイエロー",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "シアン",
  "cyan blue": "シアンブルー",
  dark: "ダーク",
  gray: "グレー",
  grayish: "グレイッシュ",
  green: "緑",
  "green cyan": "グリーンシアン",
  hue: "色相",
  light: "ライト",
  lightness: "明度",
  magenta: "マゼンタ",
  "magenta pink": "マゼンタピンク",
  orange: "オレンジ",
  "orange yellow": "オレンジイエロー",
  pale: "ペール",
  pink: "ピンク",
  "pink red": "ピンクレッド",
  purple: "パープル",
  "purple magenta": "パープルマゼンタ",
  red: "赤",
  "red orange": "レッドオレンジ",
  saturation: "彩度",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} 透明`,
  "very dark": "最も暗い",
  "very light": "ベリーライト",
  vibrant: "鮮やか",
  white: "ホワイト",
  yellow: "イエロー",
  "yellow green": "イエローグリーン"
};
var a3 = {};
a3 = {
  alpha: "알파",
  black: "검은색",
  blue: "파랑",
  "blue purple": "청자색",
  brightness: "명도",
  brown: "갈색",
  "brown yellow": "황갈색",
  colorName: (e) => `${e.lightness}, ${e.chroma}, ${e.hue}`,
  cyan: "청록색",
  "cyan blue": "청록색",
  dark: "다크",
  gray: "회색",
  grayish: "회갈색",
  green: "초록",
  "green cyan": "청록색",
  hue: "색조",
  light: "라이트",
  lightness: "밝기",
  magenta: "자홍색",
  "magenta pink": "마젠타 핑크",
  orange: "주황색",
  "orange yellow": "불그스름한 노랑",
  pale: "흙색",
  pink: "분홍색",
  "pink red": "핑크 레드",
  purple: "자주색",
  "purple magenta": "보라빛 자홍색",
  red: "빨강",
  "red orange": "붉은 주황색",
  saturation: "채도",
  transparentColorName: (e) => `${e.lightness}, ${e.chroma}, ${e.hue}, ${e.percentTransparent} 투명도`,
  "very dark": "매우 어두운",
  "very light": "매우 연함",
  vibrant: "강렬한",
  white: "흰색",
  yellow: "노란색",
  "yellow green": "연두색"
};
var l3 = {};
l3 = {
  alpha: "Alfa",
  black: "juoda",
  blue: "Mėlyna",
  "blue purple": "melsvai violetinė",
  brightness: "Ryškumas",
  brown: "ruda",
  "brown yellow": "rusvai geltona",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "žalsvai mėlyna",
  "cyan blue": "žalsvai mėlyna",
  dark: "tamsi",
  gray: "pilka",
  grayish: "pilkšva",
  green: "Žalia",
  "green cyan": "žalsvai mėlyna",
  hue: "Atspalvis",
  light: "šviesi",
  lightness: "Šviesumas",
  magenta: "rausvai raudona",
  "magenta pink": "purpurinė",
  orange: "oranžinė",
  "orange yellow": "oranžinio atspalvio geltona",
  pale: "blyški",
  pink: "rožinė",
  "pink red": "rožinė raudona",
  purple: "violetinė",
  "purple magenta": "purpurinė rausvai raudona",
  red: "Raudona",
  "red orange": "rausvai oranžinė",
  saturation: "Įsotinimas",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} skaidri`,
  "very dark": "labai tamsi",
  "very light": "labai šviesi",
  vibrant: "ryški",
  white: "balta",
  yellow: "geltona",
  "yellow green": "gelsvai žalia"
};
var i3 = {};
i3 = {
  alpha: "Alfa",
  black: "melns",
  blue: "Zila",
  "blue purple": "zili violets",
  brightness: "Spilgtums",
  brown: "brūns",
  "brown yellow": "brūni dzeltens",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "ciāns",
  "cyan blue": "ciāna zils",
  dark: "tumšs",
  gray: "pelēks",
  grayish: "pelēcīgs",
  green: "Zaļa",
  "green cyan": "zaļš ciāns",
  hue: "Nokrāsa",
  light: "gaišs",
  lightness: "Gaišums",
  magenta: "fuksiju",
  "magenta pink": "fuksiju rozā",
  orange: "oranžs",
  "orange yellow": "oranži dzeltens",
  pale: "bāls",
  pink: "rozā",
  "pink red": "rozīgi sarkans",
  purple: "violets",
  "purple magenta": "violets fuksiju",
  red: "Sarkana",
  "red orange": "sarkanīgi oranžs",
  saturation: "Piesātinājums",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} caurspīdīgs`,
  "very dark": "ļoti tumšs",
  "very light": "ļoti gaišs",
  vibrant: "košs",
  white: "balts",
  yellow: "dzeltens",
  "yellow green": "dzelteni zaļš"
};
var u3 = {};
u3 = {
  alpha: "Alfa",
  black: "svart",
  blue: "Blå",
  "blue purple": "blålilla",
  brightness: "Lysstyrke",
  brown: "brun",
  "brown yellow": "brungul",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cyan",
  "cyan blue": "cyanblå",
  dark: "mørk",
  gray: "grå",
  grayish: "gråaktig",
  green: "Grønn",
  "green cyan": "grønncyan",
  hue: "Fargetone",
  light: "lys",
  lightness: "Lyshet",
  magenta: "magenta",
  "magenta pink": "magentarosa",
  orange: "oransje",
  "orange yellow": "oransjegul",
  pale: "blek",
  pink: "rosa",
  "pink red": "rosarød",
  purple: "lilla",
  "purple magenta": "lillamagenta",
  red: "Rød",
  "red orange": "rødoransje",
  saturation: "Metning",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} gjennomsiktig`,
  "very dark": "svært mørk",
  "very light": "svært lys",
  vibrant: "levende",
  white: "hvit",
  yellow: "gul",
  "yellow green": "gulgrønn"
};
var o3 = {};
o3 = {
  alpha: "Alfa",
  black: "zwart",
  blue: "Blauw",
  "blue purple": "paarsblauw",
  brightness: "Helderheid",
  brown: "bruin",
  "brown yellow": "bruingeel",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cyaan",
  "cyan blue": "cyaanblauw",
  dark: "donker",
  gray: "grijs",
  grayish: "grijsachtig",
  green: "Groen",
  "green cyan": "cyaangroen",
  hue: "Kleurtoon",
  light: "licht",
  lightness: "Lichtsterkte",
  magenta: "magenta",
  "magenta pink": "magentaroze",
  orange: "oranje",
  "orange yellow": "oranjegeel",
  pale: "bleek",
  pink: "roze",
  "pink red": "rozerood",
  purple: "paars",
  "purple magenta": "magentapaars",
  red: "Rood",
  "red orange": "roodoranje",
  saturation: "Verzadiging",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparant`,
  "very dark": "heel donker",
  "very light": "heel licht",
  vibrant: "levendig",
  white: "wit",
  yellow: "geel",
  "yellow green": "geelgroen"
};
var s3 = {};
s3 = {
  alpha: "Alfa",
  black: "czarny",
  blue: "Niebieski",
  "blue purple": "niebiesko-fioletowy",
  brightness: "Jasność",
  brown: "brązowy",
  "brown yellow": "brązowo-żółty",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cyjanowy",
  "cyan blue": "cyjanowo-niebieski",
  dark: "ciemny",
  gray: "szary",
  grayish: "szarawy",
  green: "Zielony",
  "green cyan": "zielono-cyjanowy",
  hue: "Odcień",
  light: "jasny",
  lightness: "Jaskrawość",
  magenta: "purpurowy",
  "magenta pink": "purpurowo-różowy",
  orange: "pomarańczowy",
  "orange yellow": "pomarańczowo-żółty",
  pale: "blady",
  pink: "różowy",
  "pink red": "różowo-czerwony",
  purple: "fioletowy",
  "purple magenta": "fioletowo-purpurowy",
  red: "Czerwony",
  "red orange": "czerwono-pomarańczowy",
  saturation: "Nasycenie",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} przezroczystości`,
  "very dark": "bardzo ciemny",
  "very light": "bardzo jasny",
  vibrant: "intensywny",
  white: "biały",
  yellow: "żółty",
  "yellow green": "żółto-zielony"
};
var d3 = {};
d3 = {
  alpha: "Alfa",
  black: "preto",
  blue: "Azul",
  "blue purple": "roxo azulado",
  brightness: "Brilho",
  brown: "marrom",
  "brown yellow": "marrom amarelado",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "ciano",
  "cyan blue": "azul-ciano",
  dark: "escuro",
  gray: "cinza",
  grayish: "acinzentado",
  green: "Verde",
  "green cyan": "verde-ciano",
  hue: "Matiz",
  light: "claro",
  lightness: "Luminosidade",
  magenta: "magenta",
  "magenta pink": "rosa-magenta",
  orange: "laranja",
  "orange yellow": "amarelo alaranjado",
  pale: "pálido",
  pink: "rosa",
  "pink red": "rosa avermelhado",
  purple: "roxo",
  "purple magenta": "roxo-magenta",
  red: "Vermelho",
  "red orange": "laranja avermelhado",
  saturation: "Saturação",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparente`,
  "very dark": "muito escuro",
  "very light": "muito claro",
  vibrant: "vibrante",
  white: "branco",
  yellow: "amarelo",
  "yellow green": "verde amarelado"
};
var c3 = {};
c3 = {
  alpha: "Alfa",
  black: "preto",
  blue: "Azul",
  "blue purple": "azul-púrpura",
  brightness: "Luminosidade",
  brown: "castanho",
  "brown yellow": "amarelo-castanho",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "ciano",
  "cyan blue": "azul-ciano",
  dark: "escuro",
  gray: "cinzento",
  grayish: "acinzentado",
  green: "Verde",
  "green cyan": "verde-ciano",
  hue: "Tonalidade",
  light: "claro",
  lightness: "Claridade",
  magenta: "magenta",
  "magenta pink": "rosa-magenta",
  orange: "laranja",
  "orange yellow": "amarelo-laranja",
  pale: "pálido",
  pink: "cor-de-rosa",
  "pink red": "vermelho-rosa",
  purple: "púrpura",
  "purple magenta": "púrpura-magenta",
  red: "Vermelho",
  "red orange": "laranja-vermelho",
  saturation: "Saturação",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparente`,
  "very dark": "muito escuro",
  "very light": "muito claro",
  vibrant: "vibrante",
  white: "branco",
  yellow: "amarelo",
  "yellow green": "verde-amarelo"
};
var f3 = {};
f3 = {
  alpha: "Alfa",
  black: "negru",
  blue: "Albastru",
  "blue purple": "albastru-violet",
  brightness: "Luminozitate",
  brown: "maro",
  "brown yellow": "galben maro",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "bleu",
  "cyan blue": "albastru-bleu",
  dark: "închis",
  gray: "gri",
  grayish: "cenușiu",
  green: "Verde",
  "green cyan": "verde bleu",
  hue: "Nuanță",
  light: "deschis",
  lightness: "Luminozitate",
  magenta: "fucsia",
  "magenta pink": "roz-fucsia",
  orange: "portocaliu",
  "orange yellow": "galben-portocaliu",
  pale: "pal",
  pink: "roz",
  "pink red": "roz-roșu",
  purple: "violet",
  "purple magenta": "violet-fucsia",
  red: "Roșu",
  "red orange": "portocaliu-roșu",
  saturation: "Saturație",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparent`,
  "very dark": "foarte închis",
  "very light": "foarte deschis",
  vibrant: "plin de viață",
  white: "alb",
  yellow: "galben",
  "yellow green": "galben-verde"
};
var h3 = {};
h3 = {
  alpha: "Альфа",
  black: "черный",
  blue: "Синий",
  "blue purple": "сине-фиолетовый",
  brightness: "Яркость",
  brown: "коричневый",
  "brown yellow": "коричнево-желтый",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "голубой",
  "cyan blue": "цвет морской волны",
  dark: "темный",
  gray: "серый",
  grayish: "сероватый",
  green: "Зеленый",
  "green cyan": "сине-зеленый",
  hue: "Оттенок",
  light: "светлый",
  lightness: "Освещенность",
  magenta: "пурпурный",
  "magenta pink": "пурпурно-розовый",
  orange: "оранжевый",
  "orange yellow": "оранжево-желтый",
  pale: "бледный",
  pink: "розовый",
  "pink red": "розово-красный",
  purple: "фиолетовый",
  "purple magenta": "фиолетово-пурпурный",
  red: "Красный",
  "red orange": "красно-оранжевый",
  saturation: "Насыщенность",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, прозрачный на ${e.percentTransparent}`,
  "very dark": "очень темный",
  "very light": "очень светлый",
  vibrant: "яркий",
  white: "белый",
  yellow: "желтый",
  "yellow green": "желто-зеленый"
};
var m3 = {};
m3 = {
  alpha: "Alfa",
  black: "čierna",
  blue: "Modrá",
  "blue purple": "modrofialová",
  brightness: "Jas",
  brown: "hnedá",
  "brown yellow": "hnedožltá",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "azúrová",
  "cyan blue": "azúrová modrá",
  dark: "tmavá",
  gray: "sivá",
  grayish: "sivastá",
  green: "Zelená",
  "green cyan": "zelená azúrová",
  hue: "Odtieň",
  light: "svetlá",
  lightness: "Svetlosť",
  magenta: "purpurová",
  "magenta pink": "ružová purpurová",
  orange: "oranžová",
  "orange yellow": "oranžovožltá",
  pale: "bledá",
  pink: "ružová",
  "pink red": "ružovočervená",
  purple: "fialová",
  "purple magenta": "fialová purpurová",
  red: "Červená",
  "red orange": "červenooranžová",
  saturation: "Sýtosť",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} priehľadná`,
  "very dark": "veľmi tmavá",
  "very light": "veľmi svetlá",
  vibrant: "energická",
  white: "biela",
  yellow: "žltá",
  "yellow green": "žltozelená"
};
var b3 = {};
b3 = {
  alpha: "Alfa",
  black: "črna",
  blue: "Modra",
  "blue purple": "modro vijolična",
  brightness: "Svetlost",
  brown: "rjava",
  "brown yellow": "rjavo rumena",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cian",
  "cyan blue": "cian modra",
  dark: "temna",
  gray: "siva",
  grayish: "sivkasta",
  green: "Zelena",
  "green cyan": "zelena cian",
  hue: "Barva",
  light: "svetla",
  lightness: "Lahkost",
  magenta: "škrlatna",
  "magenta pink": "škrlatno roza",
  orange: "oranžna",
  "orange yellow": "oranžno rumena",
  pale: "bleda",
  pink: "roza",
  "pink red": "roza rdeča",
  purple: "vijolična",
  "purple magenta": "vijolično škrlatna",
  red: "Rdeča",
  "red orange": "rdeče oranžna",
  saturation: "Nasičenost",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} prozorna`,
  "very dark": "zelo temna",
  "very light": "zelo svetla",
  vibrant: "živahna",
  white: "bela",
  yellow: "rumena",
  "yellow green": "rumeno zelena"
};
var p3 = {};
p3 = {
  alpha: "Alfa",
  black: "crno",
  blue: "Plava",
  "blue purple": "plavoljubičasta",
  brightness: "Osvetljenost",
  brown: "smeđa",
  "brown yellow": "smeđežuta",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cijan",
  "cyan blue": "cijan plava",
  dark: "tamno",
  gray: "siva",
  grayish: "sivkasta",
  green: "Zelena",
  "green cyan": "zeleno cijan",
  hue: "Nijansa",
  light: "svetla",
  lightness: "Osvetljenje",
  magenta: "purpurnocrvena",
  "magenta pink": "magenta ružičasta",
  orange: "narandžasta",
  "orange yellow": "narandžastožuta",
  pale: "bledo",
  pink: "ružičasta",
  "pink red": "ružičastocrvena",
  purple: "ljubičasta",
  "purple magenta": "ljubičasta magenta",
  red: "Crvena",
  "red orange": "crvenonarandžasta",
  saturation: "Zasićenje",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} prozirna`,
  "very dark": "veoma tamno",
  "very light": "vrlo svetlo",
  vibrant: "živopisna",
  white: "bela",
  yellow: "žuto",
  "yellow green": "žutozelena"
};
var g3 = {};
g3 = {
  alpha: "Alfa",
  black: "svart",
  blue: "Blått",
  "blue purple": "blålila",
  brightness: "Ljusstyrka",
  brown: "brun",
  "brown yellow": "brungul",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cyan",
  "cyan blue": "cyanblå",
  dark: "mörk",
  gray: "grå",
  grayish: "gråaktig",
  green: "Grönt",
  "green cyan": "grön cyan",
  hue: "Nyans",
  light: "ljus",
  lightness: "Ljushet",
  magenta: "magenta",
  "magenta pink": "magentarosa",
  orange: "orange",
  "orange yellow": "orangegul",
  pale: "blek",
  pink: "rosa",
  "pink red": "rosaröd",
  purple: "lila",
  "purple magenta": "lila magenta",
  red: "Rött",
  "red orange": "rödorange",
  saturation: "Mättnad",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} genomskinlig`,
  "very dark": "mycket mörk",
  "very light": "mycket ljus",
  vibrant: "livfull",
  white: "vit",
  yellow: "gul",
  "yellow green": "gulgrön"
};
var y3 = {};
y3 = {
  alpha: "Alfa",
  black: "siyah",
  blue: "Mavi",
  "blue purple": "mavi mor",
  brightness: "Parlaklık",
  brown: "kahverengi",
  "brown yellow": "kahverengi sarı",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "camgöbeği",
  "cyan blue": "camgöbeği mavi",
  dark: "koyu",
  gray: "gri",
  grayish: "grimsi",
  green: "Yeşil",
  "green cyan": "yeşil camgöbeği",
  hue: "Ton",
  light: "açık",
  lightness: "Canlılık",
  magenta: "eflatun",
  "magenta pink": "eflatun pembe",
  orange: "turuncu",
  "orange yellow": "turuncu sarı",
  pale: "solgun",
  pink: "pembe",
  "pink red": "pembe kırmızı",
  purple: "mor",
  "purple magenta": "mor eflatun",
  red: "Kırmızı",
  "red orange": "kırmızı portakal",
  saturation: "Doygunluk",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} saydam`,
  "very dark": "çok koyu",
  "very light": "çok açık",
  vibrant: "canlı",
  white: "beyaz",
  yellow: "sarı",
  "yellow green": "sarı yeşil"
};
var $3 = {};
$3 = {
  alpha: "Альфа",
  black: "чорний",
  blue: "Синій",
  "blue purple": "синьо-фіолетовий",
  brightness: "Яскравість",
  brown: "коричневий",
  "brown yellow": "коричнево-жовтий",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "блакитний",
  "cyan blue": "синьо-блакитний",
  dark: "темний",
  gray: "сірий",
  grayish: "сіруватий",
  green: "Зелений",
  "green cyan": "зелено-блакитний",
  hue: "Тон",
  light: "світлий",
  lightness: "Освітленість",
  magenta: "пурпуровий",
  "magenta pink": "пурпурово-рожевий",
  orange: "помаранчевий",
  "orange yellow": "помаранчево-жовтий",
  pale: "блідий",
  pink: "рожевий",
  "pink red": "рожево-червоний",
  purple: "фіолетовий",
  "purple magenta": "фіолетово-пурпуровий",
  red: "Червоний",
  "red orange": "червоно-помаранчевий",
  saturation: "Насиченість",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, прозорий на ${e.percentTransparent}`,
  "very dark": "дуже темний",
  "very light": "дуже світлий",
  vibrant: "яскравий",
  white: "білий",
  yellow: "жовтий",
  "yellow green": "жовто-зелений"
};
var v3 = {};
v3 = {
  alpha: "Alpha",
  black: "黑色",
  blue: "蓝色",
  "blue purple": "蓝紫色",
  brightness: "亮度",
  brown: "棕色的",
  "brown yellow": "棕黄色",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "蓝绿色",
  "cyan blue": "青蓝色",
  dark: "深色",
  gray: "灰色",
  grayish: "浅灰色的",
  green: "绿色",
  "green cyan": "绿青色",
  hue: "色相",
  light: "浅色",
  lightness: "明亮度",
  magenta: "紫红色",
  "magenta pink": "紫粉色",
  orange: "橙色",
  "orange yellow": "橙黄色",
  pale: "苍白的",
  pink: "粉色",
  "pink red": "粉红色",
  purple: "紫色",
  "purple magenta": "紫洋红色",
  red: "红色",
  "red orange": "红橙色",
  saturation: "饱和度",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} 透明`,
  "very dark": "很暗",
  "very light": "很浅",
  vibrant: "生机勃勃",
  white: "白色",
  yellow: "黄色",
  "yellow green": "黄色/绿色"
};
var D3 = {};
D3 = {
  alpha: "Alpha",
  black: "黑",
  blue: "藍色",
  "blue purple": "藍紫",
  brightness: "亮度",
  brown: "棕",
  "brown yellow": "棕黃",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "青",
  "cyan blue": "青藍",
  dark: "暗",
  gray: "灰",
  grayish: "偏灰",
  green: "綠色",
  "green cyan": "青綠",
  hue: "色相",
  light: "淺",
  lightness: "明亮",
  magenta: "洋紅",
  "magenta pink": "淺洋紅",
  orange: "橙",
  "orange yellow": "橙黃",
  pale: "淡",
  pink: "粉紅",
  "pink red": "粉紅",
  purple: "紫",
  "purple magenta": "紫洋紅",
  red: "紅色",
  "red orange": "橙紅",
  saturation: "飽和度",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} 透明`,
  "very dark": "很暗",
  "very light": "很淺",
  vibrant: "鮮豔",
  white: "白",
  yellow: "黃",
  "yellow green": "黃綠"
};
var x3 = {};
x3 = {
  "ar-AE": Hh,
  "bg-BG": Uh,
  "cs-CZ": jh,
  "da-DK": _h,
  "de-DE": Wh,
  "el-GR": Gh,
  "en-US": qh,
  "es-ES": Yh,
  "et-EE": Zh,
  "fi-FI": Xh,
  "fr-FR": Jh,
  "he-IL": Qh,
  "hr-HR": e3,
  "hu-HU": t3,
  "it-IT": n3,
  "ja-JP": r3,
  "ko-KR": a3,
  "lt-LT": l3,
  "lv-LV": i3,
  "nb-NO": u3,
  "nl-NL": o3,
  "pl-PL": s3,
  "pt-BR": d3,
  "pt-PT": c3,
  "ro-RO": f3,
  "ru-RU": h3,
  "sk-SK": m3,
  "sl-SI": b3,
  "sr-SP": p3,
  "sv-SE": g3,
  "tr-TR": y3,
  "uk-UA": $3,
  "zh-CN": v3,
  "zh-TW": D3
};
function sD(e) {
  return e && e.__esModule ? e.default : e;
}
let ai = new Dt(sD(x3));
function Ze(e) {
  let t = la.parse(e) || ia.parse(e) || ua.parse(e);
  if (t) return t;
  throw new Error("Invalid color value: " + e);
}
function mr(e) {
  return typeof e == "string" ? Ze(e) : e;
}
function E3(e) {
  return e === 360 ? e : (e % 360 + 360) % 360;
}
const Ls = 0.68, dD = 0.85, zs = 0.55, Os = 1e-3, li = [
  [
    0,
    "pink"
  ],
  [
    15,
    "red"
  ],
  [
    48,
    "orange"
  ],
  [
    94,
    "yellow"
  ],
  [
    135,
    "green"
  ],
  [
    175,
    "cyan"
  ],
  [
    264,
    "blue"
  ],
  [
    284,
    "purple"
  ],
  [
    320,
    "magenta"
  ],
  [
    349,
    "pink"
  ]
];
class Gu {
  toHexInt() {
    return this.toFormat("rgb").toHexInt();
  }
  getChannelValue(t) {
    if (t in this) return this[t];
    throw new Error("Unsupported color channel: " + t);
  }
  withChannelValue(t, n) {
    if (t in this) {
      let r = this.clone();
      return r[t] = n, r;
    }
    throw new Error("Unsupported color channel: " + t);
  }
  getChannelName(t, n) {
    return (Dt.getGlobalDictionaryForPackage("@react-stately/color") || ai).getStringForLocale(t, n);
  }
  getColorSpaceAxes(t) {
    let { xChannel: n, yChannel: r } = t, a = n || this.getColorChannels().find((u) => u !== r), l = r || this.getColorChannels().find((u) => u !== a), i = this.getColorChannels().find((u) => u !== a && u !== l);
    return {
      xChannel: a,
      yChannel: l,
      zChannel: i
    };
  }
  getColorName(t) {
    let [n, r, a] = Hs(this), l = Dt.getGlobalDictionaryForPackage("@react-stately/color") || ai;
    if (n > 0.999) return l.getStringForLocale("white", t);
    if (n < 1e-3) return l.getStringForLocale("black", t);
    let i;
    [i, n] = this.getOklchHue(n, r, a, t);
    let u = "", o = "";
    r <= 0.1 && r >= Os ? n >= 0.7 ? o = "pale" : o = "grayish" : r >= 0.15 && (o = "vibrant"), n < 0.3 ? u = "very dark" : n < zs ? u = "dark" : n < 0.7 || (n < 0.85 ? u = "light" : u = "very light"), o && (o = l.getStringForLocale(o, t)), u && (u = l.getStringForLocale(u, t));
    let d = this.getChannelValue("alpha"), s = new vu(t, l);
    if (d < 1) {
      let c = new Lt(t, {
        style: "percent"
      }).format(1 - d);
      return s.format("transparentColorName", {
        lightness: u,
        chroma: o,
        hue: i,
        percentTransparent: c
      }).replace(/\s+/g, " ").trim();
    } else return s.format("colorName", {
      lightness: u,
      chroma: o,
      hue: i
    }).replace(/\s+/g, " ").trim();
  }
  getOklchHue(t, n, r, a) {
    let l = Dt.getGlobalDictionaryForPackage("@react-stately/color") || ai;
    if (n < Os) return [
      l.getStringForLocale("gray", a),
      t
    ];
    for (let i = 0; i < li.length; i++) {
      let [u, o] = li[i], [d, s] = li[i + 1] || [
        360,
        "pink"
      ];
      if (r >= u && r < d)
        return o === "orange" && (t < Ls ? o = "brown" : t = t - Ls + zs), r > u + (d - u) / 2 && o !== s ? o = `${o} ${s}` : o === "yellow" && t < dD && (o = "yellow green"), [
          l.getStringForLocale(o, a).toLocaleLowerCase(a),
          t
        ];
    }
    throw new Error("Unexpected hue");
  }
  getHueName(t) {
    let [n, r, a] = Hs(this), [l] = this.getOklchHue(n, r, a, t);
    return l;
  }
}
const ir = class ir extends Gu {
  constructor(t, n, r, a) {
    super(), this.red = t, this.green = n, this.blue = r, this.alpha = a;
  }
  static parse(t) {
    let n = [];
    if (/^#[\da-f]+$/i.test(t) && [
      4,
      5,
      7,
      9
    ].includes(t.length)) {
      const a = (t.length < 6 ? t.replace(/[^#]/gi, "$&$&") : t).slice(1).split("");
      for (; a.length > 0; ) n.push(parseInt(a.splice(0, 2).join(""), 16));
      n[3] = n[3] !== void 0 ? n[3] / 255 : void 0;
    }
    const r = t.match(/^rgba?\((.*)\)$/);
    if (r?.[1] && (n = r[1].split(",").map((a) => Number(a.trim())), n = n.map((a, l) => Le(a ?? 0, 0, l < 3 ? 255 : 1))), !(n[0] === void 0 || n[1] === void 0 || n[2] === void 0))
      return n.length < 3 ? void 0 : new ir(n[0], n[1], n[2], n[3] ?? 1);
  }
  toString(t = "css") {
    switch (t) {
      case "hex":
        return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0")).toUpperCase();
      case "hexa":
        return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0") + Math.round(this.alpha * 255).toString(16).padStart(2, "0")).toUpperCase();
      case "rgb":
        return `rgb(${this.red}, ${this.green}, ${this.blue})`;
      case "css":
      case "rgba":
        return `rgba(${this.red}, ${this.green}, ${this.blue}, ${this.alpha})`;
      default:
        return this.toFormat(t).toString(t);
    }
  }
  toFormat(t) {
    switch (t) {
      case "hex":
      case "hexa":
      case "rgb":
      case "rgba":
        return this;
      case "hsb":
      case "hsba":
        return this.toHSB();
      case "hsl":
      case "hsla":
        return this.toHSL();
      default:
        throw new Error("Unsupported color conversion: rgb -> " + t);
    }
  }
  toHexInt() {
    return this.red << 16 | this.green << 8 | this.blue;
  }
  /**
  * Converts an RGB color value to HSB.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
  *
  * @returns An HSBColor object.
  */
  toHSB() {
    const t = this.red / 255, n = this.green / 255, r = this.blue / 255, a = Math.min(t, n, r), l = Math.max(t, n, r), i = l - a, u = l === 0 ? 0 : i / l;
    let o = 0;
    if (i !== 0) {
      switch (l) {
        case t:
          o = (n - r) / i + (n < r ? 6 : 0);
          break;
        case n:
          o = (r - t) / i + 2;
          break;
        case r:
          o = (t - n) / i + 4;
          break;
      }
      o /= 6;
    }
    return new ia(Ne(o * 360, 2), Ne(u * 100, 2), Ne(l * 100, 2), this.alpha);
  }
  /**
  * Converts an RGB color value to HSL.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
  *
  * @returns An HSLColor object.
  */
  toHSL() {
    const t = this.red / 255, n = this.green / 255, r = this.blue / 255, a = Math.min(t, n, r), l = Math.max(t, n, r), i = (l + a) / 2, u = l - a;
    let o, d;
    if (u === 0) o = d = 0;
    else {
      switch (d = u / (i < 0.5 ? l + a : 2 - l - a), l) {
        case t:
          o = (n - r) / u + (n < r ? 6 : 0);
          break;
        case n:
          o = (r - t) / u + 2;
          break;
        case r:
        default:
          o = (t - n) / u + 4;
          break;
      }
      o /= 6;
    }
    return new ua(Ne(o * 360, 2), Ne(d * 100, 2), Ne(i * 100, 2), this.alpha);
  }
  clone() {
    return new ir(this.red, this.green, this.blue, this.alpha);
  }
  getChannelRange(t) {
    switch (t) {
      case "red":
      case "green":
      case "blue":
        return {
          minValue: 0,
          maxValue: 255,
          step: 1,
          pageSize: 17
        };
      case "alpha":
        return {
          minValue: 0,
          maxValue: 1,
          step: 0.01,
          pageSize: 0.1
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  getChannelFormatOptions(t) {
    switch (t) {
      case "red":
      case "green":
      case "blue":
        return {
          style: "decimal"
        };
      case "alpha":
        return {
          style: "percent"
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  formatChannelValue(t, n) {
    let r = this.getChannelFormatOptions(t), a = this.getChannelValue(t);
    return new Lt(n, r).format(a);
  }
  getColorSpace() {
    return "rgb";
  }
  getColorChannels() {
    return ir.colorChannels;
  }
};
ir.colorChannels = [
  "red",
  "green",
  "blue"
];
let la = ir;
const cD = /hsb\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsba\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/, ur = class ur extends Gu {
  constructor(t, n, r, a) {
    super(), this.hue = t, this.saturation = n, this.brightness = r, this.alpha = a;
  }
  static parse(t) {
    let n;
    if (n = t.match(cD)) {
      const [r, a, l, i] = (n[1] ?? n[2]).split(",").map((u) => Number(u.trim().replace("%", "")));
      return new ur(E3(r), Le(a, 0, 100), Le(l, 0, 100), Le(i ?? 1, 0, 1));
    }
  }
  toString(t = "css") {
    switch (t) {
      case "css":
        return this.toHSL().toString("css");
      case "hex":
        return this.toRGB().toString("hex");
      case "hexa":
        return this.toRGB().toString("hexa");
      case "hsb":
        return `hsb(${this.hue}, ${Ne(this.saturation, 2)}%, ${Ne(this.brightness, 2)}%)`;
      case "hsba":
        return `hsba(${this.hue}, ${Ne(this.saturation, 2)}%, ${Ne(this.brightness, 2)}%, ${this.alpha})`;
      default:
        return this.toFormat(t).toString(t);
    }
  }
  toFormat(t) {
    switch (t) {
      case "hsb":
      case "hsba":
        return this;
      case "hsl":
      case "hsla":
        return this.toHSL();
      case "rgb":
      case "rgba":
        return this.toRGB();
      default:
        throw new Error("Unsupported color conversion: hsb -> " + t);
    }
  }
  /**
  * Converts a HSB color to HSL.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_HSL.
  *
  * @returns An HSLColor object.
  */
  toHSL() {
    let t = this.saturation / 100, n = this.brightness / 100, r = n * (1 - t / 2);
    return t = r === 0 || r === 1 ? 0 : (n - r) / Math.min(r, 1 - r), new ua(Ne(this.hue, 2), Ne(t * 100, 2), Ne(r * 100, 2), this.alpha);
  }
  /**
  * Converts a HSV color value to RGB. Conversion formula adapted from
  * https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_RGB_alternative.
  *
  * @returns An RGBColor object.
  */
  toRGB() {
    let t = this.hue, n = this.saturation / 100, r = this.brightness / 100, a = (l, i = (l + t / 60) % 6) => r - n * r * Math.max(Math.min(i, 4 - i, 1), 0);
    return new la(Math.round(a(5) * 255), Math.round(a(3) * 255), Math.round(a(1) * 255), this.alpha);
  }
  clone() {
    return new ur(this.hue, this.saturation, this.brightness, this.alpha);
  }
  getChannelRange(t) {
    switch (t) {
      case "hue":
        return {
          minValue: 0,
          maxValue: 360,
          step: 1,
          pageSize: 15
        };
      case "saturation":
      case "brightness":
        return {
          minValue: 0,
          maxValue: 100,
          step: 1,
          pageSize: 10
        };
      case "alpha":
        return {
          minValue: 0,
          maxValue: 1,
          step: 0.01,
          pageSize: 0.1
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  getChannelFormatOptions(t) {
    switch (t) {
      case "hue":
        return {
          style: "unit",
          unit: "degree",
          unitDisplay: "narrow"
        };
      case "saturation":
      case "brightness":
      case "alpha":
        return {
          style: "percent"
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  formatChannelValue(t, n) {
    let r = this.getChannelFormatOptions(t), a = this.getChannelValue(t);
    return (t === "saturation" || t === "brightness") && (a /= 100), new Lt(n, r).format(a);
  }
  getColorSpace() {
    return "hsb";
  }
  getColorChannels() {
    return ur.colorChannels;
  }
};
ur.colorChannels = [
  "hue",
  "saturation",
  "brightness"
];
let ia = ur;
const fD = /hsl\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsla\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/, or = class or extends Gu {
  constructor(t, n, r, a) {
    super(), this.hue = t, this.saturation = n, this.lightness = r, this.alpha = a;
  }
  static parse(t) {
    let n;
    if (n = t.match(fD)) {
      const [r, a, l, i] = (n[1] ?? n[2]).split(",").map((u) => Number(u.trim().replace("%", "")));
      return new or(E3(r), Le(a, 0, 100), Le(l, 0, 100), Le(i ?? 1, 0, 1));
    }
  }
  toString(t = "css") {
    switch (t) {
      case "hex":
        return this.toRGB().toString("hex");
      case "hexa":
        return this.toRGB().toString("hexa");
      case "hsl":
        return `hsl(${this.hue}, ${Ne(this.saturation, 2)}%, ${Ne(this.lightness, 2)}%)`;
      case "css":
      case "hsla":
        return `hsla(${this.hue}, ${Ne(this.saturation, 2)}%, ${Ne(this.lightness, 2)}%, ${this.alpha})`;
      default:
        return this.toFormat(t).toString(t);
    }
  }
  toFormat(t) {
    switch (t) {
      case "hsl":
      case "hsla":
        return this;
      case "hsb":
      case "hsba":
        return this.toHSB();
      case "rgb":
      case "rgba":
        return this.toRGB();
      default:
        throw new Error("Unsupported color conversion: hsl -> " + t);
    }
  }
  /**
  * Converts a HSL color to HSB.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_HSV.
  *
  * @returns An HSBColor object.
  */
  toHSB() {
    let t = this.saturation / 100, n = this.lightness / 100, r = n + t * Math.min(n, 1 - n);
    return t = r === 0 ? 0 : 2 * (1 - n / r), new ia(Ne(this.hue, 2), Ne(t * 100, 2), Ne(r * 100, 2), this.alpha);
  }
  /**
  * Converts a HSL color to RGB. Conversion formula adapted from
  * https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative.
  *
  * @returns An RGBColor object.
  */
  toRGB() {
    let t = this.hue, n = this.saturation / 100, r = this.lightness / 100, a = n * Math.min(r, 1 - r), l = (i, u = (i + t / 30) % 12) => r - a * Math.max(Math.min(u - 3, 9 - u, 1), -1);
    return new la(Math.round(l(0) * 255), Math.round(l(8) * 255), Math.round(l(4) * 255), this.alpha);
  }
  clone() {
    return new or(this.hue, this.saturation, this.lightness, this.alpha);
  }
  getChannelRange(t) {
    switch (t) {
      case "hue":
        return {
          minValue: 0,
          maxValue: 360,
          step: 1,
          pageSize: 15
        };
      case "saturation":
      case "lightness":
        return {
          minValue: 0,
          maxValue: 100,
          step: 1,
          pageSize: 10
        };
      case "alpha":
        return {
          minValue: 0,
          maxValue: 1,
          step: 0.01,
          pageSize: 0.1
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  getChannelFormatOptions(t) {
    switch (t) {
      case "hue":
        return {
          style: "unit",
          unit: "degree",
          unitDisplay: "narrow"
        };
      case "saturation":
      case "lightness":
      case "alpha":
        return {
          style: "percent"
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  formatChannelValue(t, n) {
    let r = this.getChannelFormatOptions(t), a = this.getChannelValue(t);
    return (t === "saturation" || t === "lightness") && (a /= 100), new Lt(n, r).format(a);
  }
  getColorSpace() {
    return "hsl";
  }
  getColorChannels() {
    return or.colorChannels;
  }
};
or.colorChannels = [
  "hue",
  "saturation",
  "lightness"
];
let ua = or;
function Hs(e) {
  let t = e.toFormat("rgb"), n = t.getChannelValue("red") / 255, r = t.getChannelValue("green") / 255, a = t.getChannelValue("blue") / 255;
  [n, r, a] = mD(n, r, a);
  let [l, i, u] = bD(n, r, a), [o, d, s] = pD(l, i, u);
  return hD(o, d, s);
}
function hD(e, t, n) {
  var r = Math.atan2(n, t) * 180 / Math.PI;
  return [
    e,
    Math.sqrt(t ** 2 + n ** 2),
    r >= 0 ? r : r + 360
    // Hue, in degrees [0 to 360)
  ];
}
function mD(e, t, n) {
  return [
    ii(e),
    ii(t),
    ii(n)
  ];
}
function ii(e) {
  let t = e < 0 ? -1 : 1, n = Math.abs(e);
  return n <= 0.04045 ? e / 12.92 : t * Math.pow((n + 0.055) / 1.055, 2.4);
}
function bD(e, t, n) {
  return _i([
    0.4123907992659595,
    0.35758433938387796,
    0.1804807884018343,
    0.21263900587151036,
    0.7151686787677559,
    0.07219231536073371,
    0.01933081871559185,
    0.11919477979462599,
    0.9505321522496606
  ], e, t, n);
}
function pD(e, t, n) {
  const r = [
    0.819022437996703,
    0.3619062600528904,
    -0.1288737815209879,
    0.0329836539323885,
    0.9292868615863434,
    0.0361446663506424,
    0.0481771893596242,
    0.2642395317527308,
    0.6335478284694309
  ], a = [
    0.210454268309314,
    0.7936177747023054,
    -0.0040720430116193,
    1.9779985324311684,
    -2.42859224204858,
    0.450593709617411,
    0.0259040424655478,
    0.7827717124575296,
    -0.8086757549230774
  ];
  let [l, i, u] = _i(r, e, t, n);
  return _i(a, Math.cbrt(l), Math.cbrt(i), Math.cbrt(u));
}
function _i(e, t, n, r) {
  let a = e[0] * t + e[1] * n + e[2] * r, l = e[3] * t + e[4] * n + e[5] * r, i = e[6] * t + e[7] * n + e[8] * r;
  return [
    a,
    l,
    i
  ];
}
const C3 = (e) => [
  0,
  60,
  120,
  180,
  240,
  300,
  360
].map((t) => e.withChannelValue("hue", t).toString("css")).join(", "), P3 = (e) => `${e.withChannelValue("saturation", 0)}, transparent`, gD = {
  hue: C3,
  saturation: P3,
  lightness: () => "black, transparent, white"
}, yD = {
  hue: C3,
  saturation: P3,
  brightness: () => "black, transparent"
};
function $D({ direction: e, state: t, zChannel: n, xChannel: r, yChannel: a }) {
  return K(() => {
    let i = e === "rtl" ? "left" : "right", u = {}, o = t.value.getChannelValue(n);
    switch (t.value.getColorSpace()) {
      case "rgb": {
        let f = Ze("rgb(0, 0, 0)");
        u = {
          background: [
            // The screen blend mode multiplies the inverse of each channel, e.g. 1 - (1 - a) * (1 - b).
            // Create a layer for each channel, with the other channels as 0. After blending, this should
            // result in the gradients being combined channel by channel.
            `linear-gradient(to ${i}, ${f.withChannelValue(r, 0)}, ${f.withChannelValue(r, 255)})`,
            `linear-gradient(to top, ${f.withChannelValue(a, 0)}, ${f.withChannelValue(a, 255)})`,
            f.withChannelValue(n, o)
          ].join(","),
          backgroundBlendMode: "screen"
        };
        break;
      }
      case "hsl": {
        let f = t.value.getColorChannels(), h = Ze("hsl(0, 100%, 50%)").withChannelValue(n, o), m = f.filter((b) => b !== n).map((b) => `linear-gradient(to ${b === r ? i : "top"}, ${gD[b](h)})`).reverse();
        n === "hue" && m.push(h.toString("css")), u = {
          background: m.join(", ")
        };
        break;
      }
      case "hsb": {
        let f = t.value.getColorChannels(), h = Ze("hsb(0, 100%, 100%)").withChannelValue(n, o), m = f.filter((b) => b !== n).map((b) => `linear-gradient(to ${b === r ? i : "top"}, ${yD[b](h)})`).reverse();
        n === "hue" && m.push(h.toString("css")), u = {
          background: m.join(", ")
        };
        break;
      }
    }
    let { x: d, y: s } = t.getThumbPosition();
    e === "rtl" && (d = 1 - d);
    let c = {
      forcedColorAdjust: "none"
    };
    return {
      colorAreaStyleProps: {
        style: {
          position: "relative",
          touchAction: "none",
          ...c,
          ...u
        }
      },
      thumbStyleProps: {
        style: {
          position: "absolute",
          left: `${d * 100}%`,
          top: `${s * 100}%`,
          transform: "translate(-50%, -50%)",
          touchAction: "none",
          ...c
        }
      }
    };
  }, [
    e,
    t,
    n,
    r,
    a
  ]);
}
function oa(e) {
  let { onMoveStart: t, onMove: n, onMoveEnd: r } = e, a = T({
    didMove: !1,
    lastPosition: null,
    id: null
  }), { addGlobalListener: l, removeGlobalListener: i } = Qt(), u = X((f, h, m, b) => {
    m === 0 && b === 0 || (a.current.didMove || (a.current.didMove = !0, t?.({
      type: "movestart",
      pointerType: h,
      shiftKey: f.shiftKey,
      metaKey: f.metaKey,
      ctrlKey: f.ctrlKey,
      altKey: f.altKey
    })), n?.({
      type: "move",
      pointerType: h,
      deltaX: m,
      deltaY: b,
      shiftKey: f.shiftKey,
      metaKey: f.metaKey,
      ctrlKey: f.ctrlKey,
      altKey: f.altKey
    }));
  }, [
    t,
    n,
    a
  ]), o = xe(u), d = X((f, h) => {
    Va(), a.current.didMove && r?.({
      type: "moveend",
      pointerType: h,
      shiftKey: f.shiftKey,
      metaKey: f.metaKey,
      ctrlKey: f.ctrlKey,
      altKey: f.altKey
    });
  }, [
    r,
    a
  ]), s = xe(d);
  return {
    moveProps: K(() => {
      let f = {}, h = () => {
        Bi(), a.current.didMove = !1;
      };
      if (typeof PointerEvent > "u" && process.env.NODE_ENV === "test") {
        let b = (v) => {
          v.button === 0 && (o(v, "mouse", v.pageX - (a.current.lastPosition?.pageX ?? 0), v.pageY - (a.current.lastPosition?.pageY ?? 0)), a.current.lastPosition = {
            pageX: v.pageX,
            pageY: v.pageY
          });
        }, p = (v) => {
          if (v.button === 0) {
            s(v, "mouse");
            let x = Be(W(v));
            i(x, "mousemove", b, !1), i(x, "mouseup", p, !1);
          }
        };
        f.onMouseDown = (v) => {
          if (v.button === 0) {
            h(), v.stopPropagation(), v.preventDefault(), a.current.lastPosition = {
              pageX: v.pageX,
              pageY: v.pageY
            };
            let x = Be(W(v));
            l(x, "mousemove", b, !1), l(x, "mouseup", p, !1);
          }
        };
        let y = (v) => {
          let x = [
            ...v.changedTouches
          ].findIndex(({ identifier: E }) => E === a.current.id);
          if (x >= 0) {
            let { pageX: E, pageY: P } = v.changedTouches[x];
            o(v, "touch", E - (a.current.lastPosition?.pageX ?? 0), P - (a.current.lastPosition?.pageY ?? 0)), a.current.lastPosition = {
              pageX: E,
              pageY: P
            };
          }
        }, $ = (v) => {
          if ([
            ...v.changedTouches
          ].findIndex(({ identifier: E }) => E === a.current.id) >= 0) {
            s(v, "touch"), a.current.id = null;
            let E = Be(W(v));
            i(E, "touchmove", y), i(E, "touchend", $), i(E, "touchcancel", $);
          }
        };
        f.onTouchStart = (v) => {
          if (v.changedTouches.length === 0 || a.current.id != null) return;
          let { pageX: x, pageY: E, identifier: P } = v.changedTouches[0];
          h(), v.stopPropagation(), v.preventDefault(), a.current.lastPosition = {
            pageX: x,
            pageY: E
          }, a.current.id = P;
          let C = Be(W(v));
          l(C, "touchmove", y, !1), l(C, "touchend", $, !1), l(C, "touchcancel", $, !1);
        };
      } else {
        let b = (y) => {
          if (y.pointerId === a.current.id) {
            let $ = y.pointerType || "mouse";
            o(y, $, y.pageX - (a.current.lastPosition?.pageX ?? 0), y.pageY - (a.current.lastPosition?.pageY ?? 0)), a.current.lastPosition = {
              pageX: y.pageX,
              pageY: y.pageY
            };
          }
        }, p = (y) => {
          if (y.pointerId === a.current.id) {
            let $ = y.pointerType || "mouse";
            s(y, $), a.current.id = null;
            let v = Be(W(y));
            i(v, "pointermove", b, !1), i(v, "pointerup", p, !1), i(v, "pointercancel", p, !1);
          }
        };
        f.onPointerDown = (y) => {
          if (y.button === 0 && a.current.id == null) {
            h(), y.stopPropagation(), y.preventDefault(), a.current.lastPosition = {
              pageX: y.pageX,
              pageY: y.pageY
            }, a.current.id = y.pointerId;
            let $ = Be(W(y));
            l($, "pointermove", b, !1), l($, "pointerup", p, !1), l($, "pointercancel", p, !1);
          }
        };
      }
      let m = (b, p, y) => {
        h(), o(b, "keyboard", p, y), s(b, "keyboard");
      };
      return f.onKeyDown = (b) => {
        switch (b.key) {
          case "Left":
          case "ArrowLeft":
            b.preventDefault(), b.stopPropagation(), m(b, -1, 0);
            break;
          case "Right":
          case "ArrowRight":
            b.preventDefault(), b.stopPropagation(), m(b, 1, 0);
            break;
          case "Up":
          case "ArrowUp":
            b.preventDefault(), b.stopPropagation(), m(b, 0, -1);
            break;
          case "Down":
          case "ArrowDown":
            b.preventDefault(), b.stopPropagation(), m(b, 0, 1);
            break;
        }
      }, f;
    }, [
      l,
      i,
      a
    ])
  };
}
function vD(e) {
  return e && e.__esModule ? e.default : e;
}
function DD(e, t) {
  let { isDisabled: n, inputXRef: r, inputYRef: a, containerRef: l, "aria-label": i, xName: u, yName: o, form: d } = e, s = Ee(vD(Wu), "@react-aria/color"), { addGlobalListener: c, removeGlobalListener: f } = Qt(), { direction: h, locale: m } = de(), [b, p] = Y(null), y = X((ne = r) => {
    ne.current && Ae(ne.current);
  }, [
    r
  ]);
  an(r, t.defaultValue, t.setValue);
  let [$, v] = Y(!1), [x, E] = Y(!1), { xChannel: P, yChannel: C, zChannel: M } = t.channels, F = t.xChannelStep, V = t.yChannelStep, I = T(null), { keyboardProps: A } = Cr({
    onKeyDown(ne) {
      if (!/^(PageUp|PageDown|Home|End)$/.test(ne.key)) {
        ne.continuePropagation();
        return;
      }
      ne.preventDefault(), t.setDragging(!0), v(!0);
      let Ce;
      switch (ne.key) {
        case "PageUp":
          t.incrementY(t.yChannelPageStep), Ce = "y";
          break;
        case "PageDown":
          t.decrementY(t.yChannelPageStep), Ce = "y";
          break;
        case "Home":
          h === "rtl" ? t.incrementX(t.xChannelPageStep) : t.decrementX(t.xChannelPageStep), Ce = "x";
          break;
        case "End":
          h === "rtl" ? t.decrementX(t.xChannelPageStep) : t.incrementX(t.xChannelPageStep), Ce = "x";
          break;
      }
      t.setDragging(!1), Ce && (y(Ce === "x" ? r : a), p(Ce));
    }
  }), U = {
    onMoveStart() {
      I.current = null, t.setDragging(!0);
    },
    onMove({ deltaX: ne, deltaY: Ce, pointerType: xn, shiftKey: Xn }) {
      let { incrementX: En, decrementX: Tr, incrementY: Jn, decrementY: Bt, xChannelPageStep: Ft, xChannelStep: At, yChannelPageStep: Ir, yChannelStep: Mr, getThumbPosition: Vl, setColorFromPoint: Ll } = t;
      I.current == null && (I.current = Vl());
      let { width: Re, height: Qn } = l.current?.getBoundingClientRect() || {
        width: 0,
        height: 0
      }, Ho = ne !== 0 || Ce !== 0;
      if (xn === "keyboard") {
        let Uo = Xn && Ft > At ? Ft : At, jo = Xn && Ir > Mr ? Ir : Mr;
        ne > 0 && h === "ltr" || ne < 0 && h === "rtl" ? En(Uo) : ne < 0 && h === "ltr" || ne > 0 && h === "rtl" ? Tr(Uo) : Ce > 0 ? Bt(jo) : Ce < 0 && Jn(jo), v(Ho), b = Ho && Math.abs(Ce) > Math.abs(ne) ? "y" : "x", p(b);
      } else
        I.current.x += (h === "rtl" ? -1 : 1) * ne / Re, I.current.y += Ce / Qn, Ll(I.current.x, I.current.y);
    },
    onMoveEnd() {
      R.current = !1, t.setDragging(!1), y(b === "x" ? r : a);
    }
  }, { moveProps: D } = oa(U), { focusWithinProps: N } = ft({
    onFocusWithinChange: (ne) => {
      ne || (v(!1), E(!1));
    }
  }), w = T(void 0), R = T(!1), { moveProps: H } = oa({
    onMoveStart() {
      R.current && U.onMoveStart();
    },
    onMove(ne) {
      R.current && U.onMove(ne);
    },
    onMoveEnd() {
      R.current && U.onMoveEnd();
    }
  }), k = (ne) => {
    t.isDragging || (w.current = ne, v(!1), y(), t.setDragging(!0), typeof PointerEvent < "u" ? c(window, "pointerup", S, !1) : (c(window, "mouseup", S, !1), c(window, "touchend", S, !1)));
  }, S = (ne) => {
    (ne.pointerId ?? ne.changedTouches?.[0].identifier) === w.current && (v(!1), y(), t.setDragging(!1), w.current = void 0, R.current = !1, typeof PointerEvent < "u" ? f(window, "pointerup", S, !1) : (f(window, "mouseup", S, !1), f(window, "touchend", S, !1)));
  }, j = (ne, Ce, xn, Xn) => {
    let En = ne.getBoundingClientRect(), { width: Tr, height: Jn } = En, Bt = (xn - En.x) / Tr, Ft = (Xn - En.y) / Jn;
    h === "rtl" && (Bt = 1 - Bt), Bt >= 0 && Bt <= 1 && Ft >= 0 && Ft <= 1 && !t.isDragging && w.current === void 0 && (R.current = !0, v(!1), w.current = Ce, t.setColorFromPoint(Bt, Ft), y(), t.setDragging(!0), typeof PointerEvent < "u" ? c(window, "pointerup", _, !1) : (c(window, "mouseup", _, !1), c(window, "touchend", _, !1)));
  }, _ = (ne) => {
    let Ce = ne.pointerId ?? ne.changedTouches?.[0].identifier;
    R.current && Ce === w.current && (R.current = !1, v(!1), w.current = void 0, t.setDragging(!1), y(), typeof PointerEvent < "u" ? f(window, "pointerup", _, !1) : (f(window, "mouseup", _, !1), f(window, "touchend", _, !1)));
  }, B = n ? {} : z({
    ...typeof PointerEvent < "u" ? {
      onPointerDown: (ne) => {
        ne.pointerType === "mouse" && (ne.button !== 0 || ne.altKey || ne.ctrlKey || ne.metaKey) || j(ne.currentTarget, ne.pointerId, ne.clientX, ne.clientY);
      }
    } : {
      onMouseDown: (ne) => {
        ne.button !== 0 || ne.altKey || ne.ctrlKey || ne.metaKey || j(ne.currentTarget, void 0, ne.clientX, ne.clientY);
      },
      onTouchStart: (ne) => {
        j(ne.currentTarget, ne.changedTouches[0].identifier, ne.changedTouches[0].clientX, ne.changedTouches[0].clientY);
      }
    }
  }, H), L = n ? {} : z({
    ...typeof PointerEvent < "u" ? {
      onPointerDown: (ne) => {
        ne.pointerType === "mouse" && (ne.button !== 0 || ne.altKey || ne.ctrlKey || ne.metaKey) || k(ne.pointerId);
      }
    } : {
      onMouseDown: (ne) => {
        ne.button !== 0 || ne.altKey || ne.ctrlKey || ne.metaKey || k(void 0);
      },
      onTouchStart: (ne) => {
        k(ne.changedTouches[0].identifier);
      }
    }
  }, N, A, D), { focusProps: Z } = pr({
    onFocus: () => {
      p("x");
    }
  }), { focusProps: ie } = pr({
    onFocus: () => {
      p("y");
    }
  });
  const q = (ne) => {
    const { target: Ce } = ne;
    E(!0), Ce === r.current ? t.setXValue(parseFloat(Ce.value)) : Ce === a.current && t.setYValue(parseFloat(Ce.value));
  };
  let re = xt() || bn(), fe = t.getDisplayColor();
  const tt = X((ne) => `${x || $ ? s.format("colorNameAndValue", {
    name: fe.getChannelName(ne, m),
    value: fe.formatChannelValue(ne, m)
  }) : [
    s.format("colorNameAndValue", {
      name: fe.getChannelName(ne, m),
      value: fe.formatChannelValue(ne, m)
    }),
    s.format("colorNameAndValue", {
      name: fe.getChannelName(ne === C ? P : C, m),
      value: fe.formatChannelValue(ne === C ? P : C, m)
    }),
    s.format("colorNameAndValue", {
      name: fe.getChannelName(M, m),
      value: fe.formatChannelValue(M, m)
    })
  ].join(", ")}, ${fe.getColorName(m)}`, [
    m,
    fe,
    s,
    x,
    $,
    P,
    C,
    M
  ]);
  let ht = s.format("colorPicker"), qn = ut({
    ...e,
    "aria-label": i ? s.format("colorInputLabel", {
      label: i,
      channelLabel: ht
    }) : ht
  }), Ut = ut({
    ...e,
    "aria-label": i ? s.format("colorInputLabel", {
      label: i,
      channelLabel: ht
    }) : ht
  }), Yn = ut({
    ...e,
    "aria-label": i ? `${i}, ${ht}` : void 0
  }, re ? ht : void 0), Zn = s.format("twoDimensionalSlider"), { visuallyHiddenProps: be } = tn({
    style: {
      opacity: "0.0001",
      width: "100%",
      height: "100%",
      pointerEvents: "none"
    }
  }), { colorAreaStyleProps: ln, thumbStyleProps: Ea } = $D({
    direction: h,
    state: t,
    xChannel: P,
    yChannel: C,
    zChannel: M
  });
  return {
    colorAreaProps: {
      ...Yn,
      ...B,
      ...ln,
      role: "group"
    },
    thumbProps: {
      ...L,
      ...Ea,
      role: "presentation"
    },
    xInputProps: {
      ...qn,
      ...be,
      ...Z,
      type: "range",
      min: t.value.getChannelRange(P).minValue,
      max: t.value.getChannelRange(P).maxValue,
      step: F,
      "aria-roledescription": Zn,
      "aria-valuetext": tt(P),
      "aria-orientation": "horizontal",
      "aria-describedby": e["aria-describedby"],
      "aria-details": e["aria-details"],
      disabled: n,
      value: t.value.getChannelValue(P),
      name: u,
      form: d,
      tabIndex: re || !b || b === "x" ? void 0 : -1,
      /*
        So that only a single "2d slider" control shows up when listing form elements for screen readers,
        add aria-hidden="true" to the unfocused control when the value has not changed via the keyboard,
        but remove aria-hidden to reveal the input for each channel when the value has changed with the keyboard.
      */
      "aria-hidden": re || !b || b === "x" || $ ? void 0 : "true",
      onChange: q
    },
    yInputProps: {
      ...Ut,
      ...be,
      ...ie,
      type: "range",
      min: t.value.getChannelRange(C).minValue,
      max: t.value.getChannelRange(C).maxValue,
      step: V,
      "aria-roledescription": Zn,
      "aria-valuetext": tt(C),
      "aria-orientation": "vertical",
      "aria-describedby": e["aria-describedby"],
      "aria-details": e["aria-details"],
      disabled: n,
      value: t.value.getChannelValue(C),
      name: o,
      form: d,
      tabIndex: re || b === "y" ? void 0 : -1,
      /*
        So that only a single "2d slider" control shows up when listing form elements for screen readers,
        add aria-hidden="true" to the unfocused input when the value has not changed via the keyboard,
        but remove aria-hidden to reveal the input for each channel when the value has changed with the keyboard.
      */
      "aria-hidden": re || b === "y" || $ ? void 0 : "true",
      onChange: q
    }
  };
}
const xD = Ze("#ffffff");
function ED(e) {
  let { value: t, defaultValue: n, colorSpace: r, xChannel: a, yChannel: l, onChange: i, onChangeEnd: u } = e;
  !t && !n && (n = xD), t && (t = mr(t)), n && (n = mr(n));
  let [o, d] = we(t, n, i), [s] = Y(o), c = K(() => r && o ? o.toFormat(r) : o, [
    o,
    r
  ]), f = T(c), h = (w) => {
    f.current = w, d(w);
  }, m = K(() => c.getColorSpaceAxes({
    xChannel: a,
    yChannel: l
  }), [
    c,
    a,
    l
  ]), b = c.getChannelRange(m.xChannel), p = c.getChannelRange(m.yChannel), { minValue: y, maxValue: $, step: v, pageSize: x } = b, { minValue: E, maxValue: P, step: C, pageSize: M } = p, [F, V] = Y(!1), I = T(!1), A = c.getChannelValue(m.xChannel), U = c.getChannelValue(m.yChannel), D = (w) => {
    if (w === A) return;
    let R = c.withChannelValue(m.xChannel, w);
    h(R);
  }, N = (w) => {
    if (w === U) return;
    let R = c.withChannelValue(m.yChannel, w);
    h(R);
  };
  return {
    channels: m,
    xChannelStep: v,
    yChannelStep: C,
    xChannelPageStep: x,
    yChannelPageStep: M,
    value: c,
    defaultValue: t !== void 0 ? s : n,
    setValue(w) {
      h(mr(w));
    },
    xValue: A,
    setXValue: D,
    yValue: U,
    setYValue: N,
    setColorFromPoint(w, R) {
      let H = y + Le(w, 0, 1) * ($ - y), k = E + (1 - Le(R, 0, 1)) * (P - E), S;
      H !== A && (H = Ve(H, y, $, v), S = c.withChannelValue(m.xChannel, H)), k !== U && (k = Ve(k, E, P, C), S = (S || c).withChannelValue(m.yChannel, k)), S && h(S);
    },
    getThumbPosition() {
      let w = (A - y) / ($ - y), R = 1 - (U - E) / (P - E);
      return {
        x: w,
        y: R
      };
    },
    incrementX(w = 1) {
      D(A + w > $ ? $ : Ve(A + w, y, $, v));
    },
    incrementY(w = 1) {
      N(U + w > P ? P : Ve(U + w, E, P, C));
    },
    decrementX(w = 1) {
      D(Ve(A - w, y, $, v));
    },
    decrementY(w = 1) {
      N(Ve(U - w, E, P, C));
    },
    setDragging(w) {
      let R = I.current;
      I.current = w, u && !w && R && u(f.current), V(w);
    },
    isDragging: F,
    getDisplayColor() {
      return c.withChannelValue("alpha", 1);
    }
  };
}
const w3 = /* @__PURE__ */ G(null), CD = /* @__PURE__ */ G(null), dC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, w3);
  let r = T(null), a = T(null), l = ED(t), { colorAreaProps: i, xInputProps: u, yInputProps: o, thumbProps: d } = DD({
    ...t,
    inputXRef: r,
    inputYRef: a,
    containerRef: n
  }, l), s = le({
    ...t,
    defaultClassName: "react-aria-ColorArea",
    defaultStyle: i.style,
    values: {
      state: l,
      isDisabled: t.isDisabled || !1
    }
  }), c = J(t, {
    global: !0
  });
  return delete c.id, /* @__PURE__ */ g.createElement(Q.div, {
    ref: n,
    ...z(c, i, s),
    slot: t.slot || void 0,
    "data-disabled": t.isDisabled || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        CD,
        l
      ],
      [
        _u,
        {
          state: l,
          thumbProps: d,
          inputXRef: r,
          xInputProps: u,
          inputYRef: a,
          yInputProps: o,
          isDisabled: t.isDisabled
        }
      ]
    ]
  }, s.children));
}), Dn = /* @__PURE__ */ G({}), PD = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Dn);
  let { isDisabled: r, isInvalid: a, isReadOnly: l, onHoverStart: i, onHoverChange: u, onHoverEnd: o, ...d } = t;
  r ??= !!t["aria-disabled"] && t["aria-disabled"] !== "false", a ??= !!t["aria-invalid"] && t["aria-invalid"] !== "false";
  let { hoverProps: s, isHovered: c } = De({
    onHoverStart: i,
    onHoverChange: u,
    onHoverEnd: o,
    isDisabled: r
  }), { isFocused: f, isFocusVisible: h, focusProps: m } = ye({
    within: !0
  }), b = le({
    ...t,
    values: {
      isHovered: c,
      isFocusWithin: f,
      isFocusVisible: h,
      isDisabled: r,
      isInvalid: a
    },
    defaultClassName: "react-aria-Group"
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(d, m, s),
    ...b,
    ref: n,
    role: t.role ?? "group",
    slot: t.slot ?? void 0,
    "data-focus-within": f || void 0,
    "data-hovered": c || void 0,
    "data-focus-visible": h || void 0,
    "data-disabled": r || void 0,
    "data-invalid": a || void 0,
    "data-readonly": l || void 0
  }, b.children);
}), wr = /* @__PURE__ */ G({});
let wD = (e) => {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, ...a } = e;
  return a;
};
const SD = /* @__PURE__ */ vn(function(t, n) {
  [t, n] = oe(t, n, wr);
  let { hoverProps: r, isHovered: a } = De({
    ...t,
    isDisabled: t.disabled
  }), { isFocused: l, isFocusVisible: i, focusProps: u } = ye({
    isTextInput: !0,
    autoFocus: t.autoFocus
  }), o = !!t["aria-invalid"] && t["aria-invalid"] !== "false", d = le({
    ...t,
    values: {
      isHovered: a,
      isFocused: l,
      isFocusVisible: i,
      isDisabled: t.disabled || !1,
      isInvalid: o
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ g.createElement(Q.input, {
    ...z(wD(t), u, r),
    ...d,
    ref: n,
    "data-focused": l || void 0,
    "data-disabled": t.disabled || void 0,
    "data-hovered": a || void 0,
    "data-focus-visible": i || void 0,
    "data-invalid": o || void 0
  });
});
function qu(e, t) {
  let { inputElementType: n = "input", isDisabled: r = !1, isRequired: a = !1, isReadOnly: l = !1, type: i = "text", validationBehavior: u = "aria" } = e, [o, d] = we(e.value, e.defaultValue || "", e.onChange), { focusableProps: s } = ct(e, t), c = rn({
    ...e,
    value: o
  }), { isInvalid: f, validationErrors: h, validationDetails: m } = c.displayValidation, { labelProps: b, fieldProps: p, descriptionProps: y, errorMessageProps: $ } = Pr({
    ...e,
    isInvalid: f,
    errorMessage: e.errorMessage || h
  }), v = J(e, {
    labelable: !0
  });
  const x = {
    type: i,
    pattern: e.pattern
  };
  let [E] = Y(o);
  return an(t, e.defaultValue ?? E, d), $a(e, c, t), {
    labelProps: b,
    inputProps: z(v, n === "input" ? x : void 0, {
      disabled: r,
      readOnly: l,
      required: a && u === "native",
      "aria-required": a && u === "aria" || void 0,
      "aria-invalid": f || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-activedescendant": e["aria-activedescendant"],
      "aria-autocomplete": e["aria-autocomplete"],
      "aria-haspopup": e["aria-haspopup"],
      "aria-controls": e["aria-controls"],
      value: o,
      onChange: (P) => d(W(P).value),
      autoComplete: e.autoComplete,
      autoCapitalize: e.autoCapitalize,
      maxLength: e.maxLength,
      minLength: e.minLength,
      name: e.name,
      form: e.form,
      placeholder: e.placeholder,
      inputMode: e.inputMode,
      autoCorrect: e.autoCorrect,
      spellCheck: e.spellCheck,
      [parseInt(g.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: e.enterKeyHint,
      // Clipboard events
      onCopy: e.onCopy,
      onCut: e.onCut,
      onPaste: e.onPaste,
      // Composition events
      onCompositionEnd: e.onCompositionEnd,
      onCompositionStart: e.onCompositionStart,
      onCompositionUpdate: e.onCompositionUpdate,
      // Selection events
      onSelect: e.onSelect,
      // Input events
      onBeforeInput: e.onBeforeInput,
      onInput: e.onInput,
      ...s,
      ...p
    }),
    descriptionProps: y,
    errorMessageProps: $,
    isInvalid: f,
    validationErrors: h,
    validationDetails: m
  };
}
function Us() {
  return typeof window < "u" && window.InputEvent && typeof InputEvent.prototype.getTargetRanges == "function";
}
function S3(e, t, n) {
  let r = xe((c) => {
    let f = n.current;
    if (!f) return;
    let h = null;
    switch (c.inputType) {
      case "historyUndo":
      case "historyRedo":
        return;
      case "insertLineBreak":
        return;
      case "deleteContent":
      case "deleteByCut":
      case "deleteByDrag":
        h = f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd);
        break;
      case "deleteContentForward":
        h = f.selectionEnd === f.selectionStart ? f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd + 1) : f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd);
        break;
      case "deleteContentBackward":
        h = f.selectionEnd === f.selectionStart ? f.value.slice(0, f.selectionStart - 1) + f.value.slice(f.selectionStart) : f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd);
        break;
      case "deleteSoftLineBackward":
      case "deleteHardLineBackward":
        h = f.value.slice(f.selectionStart);
        break;
      default:
        c.data != null && (h = f.value.slice(0, f.selectionStart) + c.data + f.value.slice(f.selectionEnd));
        break;
    }
    (h == null || !t.validate(h)) && c.preventDefault();
  });
  ee(() => {
    if (!Us() || !n.current) return;
    let c = n.current;
    return c.addEventListener("beforeinput", r, !1), () => {
      c.removeEventListener("beforeinput", r, !1);
    };
  }, [
    n
  ]);
  let a = Us() ? null : (c) => {
    let f = W(c).value.slice(0, W(c).selectionStart) + c.data + W(c).value.slice(W(c).selectionEnd);
    t.validate(f) || c.preventDefault();
  }, { labelProps: l, inputProps: i, descriptionProps: u, errorMessageProps: o, ...d } = qu(e, n), s = T(null);
  return {
    inputProps: z(i, {
      onBeforeInput: a,
      onCompositionStart() {
        let { value: c, selectionStart: f, selectionEnd: h } = n.current;
        s.current = {
          value: c,
          selectionStart: f,
          selectionEnd: h
        };
      },
      onCompositionEnd() {
        if (n.current && !t.validate(n.current.value)) {
          let { value: c, selectionStart: f, selectionEnd: h } = s.current;
          n.current.value = c, n.current.setSelectionRange(f, h), t.setInputValue(c);
        }
      }
    }),
    labelProps: l,
    descriptionProps: u,
    errorMessageProps: o,
    ...d
  };
}
function k3(e, t) {
  let { onScroll: n, isDisabled: r } = e, a = X((l) => {
    l.ctrlKey || (l.preventDefault(), l.stopPropagation(), n && n({
      deltaX: l.deltaX,
      deltaY: l.deltaY
    }));
  }, [
    n
  ]);
  bt(t, "wheel", r ? void 0 : a);
}
var B3 = {};
B3 = {
  Empty: "فارغ"
};
var F3 = {};
F3 = {
  Empty: "Изпразни"
};
var A3 = {};
A3 = {
  Empty: "Prázdné"
};
var R3 = {};
R3 = {
  Empty: "Tom"
};
var T3 = {};
T3 = {
  Empty: "Leer"
};
var I3 = {};
I3 = {
  Empty: "Άδειο"
};
var M3 = {};
M3 = {
  Empty: "Empty"
};
var K3 = {};
K3 = {
  Empty: "Vacío"
};
var N3 = {};
N3 = {
  Empty: "Tühjenda"
};
var V3 = {};
V3 = {
  Empty: "Tyhjä"
};
var L3 = {};
L3 = {
  Empty: "Vide"
};
var z3 = {};
z3 = {
  Empty: "ריק"
};
var O3 = {};
O3 = {
  Empty: "Prazno"
};
var H3 = {};
H3 = {
  Empty: "Üres"
};
var U3 = {};
U3 = {
  Empty: "Vuoto"
};
var j3 = {};
j3 = {
  Empty: "空"
};
var _3 = {};
_3 = {
  Empty: "비어 있음"
};
var W3 = {};
W3 = {
  Empty: "Tuščias"
};
var G3 = {};
G3 = {
  Empty: "Tukšs"
};
var q3 = {};
q3 = {
  Empty: "Tom"
};
var Y3 = {};
Y3 = {
  Empty: "Leeg"
};
var Z3 = {};
Z3 = {
  Empty: "Pusty"
};
var X3 = {};
X3 = {
  Empty: "Vazio"
};
var J3 = {};
J3 = {
  Empty: "Vazio"
};
var Q3 = {};
Q3 = {
  Empty: "Gol"
};
var em = {};
em = {
  Empty: "Не заполнено"
};
var tm = {};
tm = {
  Empty: "Prázdne"
};
var nm = {};
nm = {
  Empty: "Prazen"
};
var rm = {};
rm = {
  Empty: "Prazno"
};
var am = {};
am = {
  Empty: "Tomt"
};
var lm = {};
lm = {
  Empty: "Boş"
};
var im = {};
im = {
  Empty: "Пусто"
};
var um = {};
um = {
  Empty: "空"
};
var om = {};
om = {
  Empty: "空白"
};
var sm = {};
sm = {
  "ar-AE": B3,
  "bg-BG": F3,
  "cs-CZ": A3,
  "da-DK": R3,
  "de-DE": T3,
  "el-GR": I3,
  "en-US": M3,
  "es-ES": K3,
  "et-EE": N3,
  "fi-FI": V3,
  "fr-FR": L3,
  "he-IL": z3,
  "hr-HR": O3,
  "hu-HU": H3,
  "it-IT": U3,
  "ja-JP": j3,
  "ko-KR": _3,
  "lt-LT": W3,
  "lv-LV": G3,
  "nb-NO": q3,
  "nl-NL": Y3,
  "pl-PL": Z3,
  "pt-BR": X3,
  "pt-PT": J3,
  "ro-RO": Q3,
  "ru-RU": em,
  "sk-SK": tm,
  "sl-SI": nm,
  "sr-SP": rm,
  "sv-SE": am,
  "tr-TR": lm,
  "uk-UA": im,
  "zh-CN": um,
  "zh-TW": om
};
function kD(e) {
  return e && e.__esModule ? e.default : e;
}
const js = () => {
};
function Yu(e) {
  const t = T(void 0);
  let { value: n, textValue: r, minValue: a, maxValue: l, isDisabled: i, isReadOnly: u, isRequired: o, onIncrement: d, onIncrementPage: s, onDecrement: c, onDecrementPage: f, onDecrementToMin: h, onIncrementToMax: m } = e;
  const b = Ee(kD(sm), "@react-aria/spinbutton");
  let p = T(!1);
  const y = X(() => {
    clearTimeout(t.current), p.current = !1;
  }, []), $ = xe(() => {
    y();
  });
  ee(() => () => $(), []);
  let v = (B) => {
    if (!(B.ctrlKey || B.metaKey || B.shiftKey || B.altKey || u || B.nativeEvent.isComposing))
      switch (B.key) {
        case "PageUp":
          if (s) {
            B.preventDefault(), s?.();
            break;
          }
        // fallthrough!
        case "ArrowUp":
        case "Up":
          d && (B.preventDefault(), d?.());
          break;
        case "PageDown":
          if (f) {
            B.preventDefault(), f?.();
            break;
          }
        // fallthrough
        case "ArrowDown":
        case "Down":
          c && (B.preventDefault(), c?.());
          break;
        case "Home":
          h && (B.preventDefault(), h?.());
          break;
        case "End":
          m && (B.preventDefault(), m?.());
          break;
      }
  }, x = T(!1), E = () => {
    x.current = !0;
  }, P = () => {
    x.current = !1;
  }, C = r === "" ? b.format("Empty") : (r || `${n}`).replace("-", "−");
  ee(() => {
    x.current && (B2("assertive"), pn(C, "assertive"));
  }, [
    C
  ]);
  let M = X(() => {
    y();
  }, [
    y
  ]);
  const F = xe(d ?? js), V = xe(c ?? js), I = xe(() => {
    (l === void 0 || isNaN(l) || n === void 0 || isNaN(n) || n < l) && (F(), A(60));
  }), A = xe((B) => {
    $(), p.current = !0, t.current = window.setTimeout(I, B);
  }), U = xe(() => {
    (a === void 0 || isNaN(a) || n === void 0 || isNaN(n) || n > a) && (V(), D(60));
  }), D = xe((B) => {
    $(), p.current = !0, t.current = window.setTimeout(U, B);
  });
  let N = (B) => {
    B.preventDefault();
  }, { addGlobalListener: w, removeAllGlobalListeners: R } = Qt(), H = T(!1), [k, S] = Y(null);
  ee(() => {
    k === "touch" ? A(600) : k ? A(400) : k || $();
  }, [
    k
  ]);
  let [j, _] = Y(null);
  return ee(() => {
    j === "touch" ? D(600) : j ? D(400) : j || $();
  }, [
    j
  ]), {
    spinButtonProps: {
      role: "spinbutton",
      "aria-valuenow": n !== void 0 && !isNaN(n) ? n : void 0,
      "aria-valuetext": C,
      "aria-valuemin": a,
      "aria-valuemax": l,
      "aria-disabled": i || void 0,
      "aria-readonly": u || void 0,
      "aria-required": o || void 0,
      onKeyDown: v,
      onFocus: E,
      onBlur: P
    },
    incrementButtonProps: {
      onPressStart: (B) => {
        y(), B.pointerType !== "touch" ? (d?.(), S("mouse")) : (w(window, "pointercancel", M, {
          capture: !0
        }), H.current = !1, S("touch")), w(window, "contextmenu", N);
      },
      onPressUp: (B) => {
        y(), B.pointerType === "touch" && (H.current = !0), R(), S(null);
      },
      onPressEnd: (B) => {
        y(), B.pointerType === "touch" && !p.current && H.current && d?.(), H.current = !1, S(null);
      },
      onFocus: E,
      onBlur: P
    },
    decrementButtonProps: {
      onPressStart: (B) => {
        y(), B.pointerType !== "touch" ? (c?.(), _("mouse")) : (w(window, "pointercancel", M, {
          capture: !0
        }), H.current = !1, _("touch"));
      },
      onPressUp: (B) => {
        y(), B.pointerType === "touch" && (H.current = !0), R(), _(null);
      },
      onPressEnd: (B) => {
        y(), B.pointerType === "touch" && !p.current && H.current && c?.(), H.current = !1, _(null);
      },
      onFocus: E,
      onBlur: P
    }
  };
}
function BD(e, t, n) {
  let { isDisabled: r, isReadOnly: a, isRequired: l, isWheelDisabled: i, validationBehavior: u = "aria" } = e, { colorValue: o, inputValue: d, increment: s, decrement: c, incrementToMax: f, decrementToMin: h, commit: m } = t, b = ce(), { spinButtonProps: p } = Yu({
    isDisabled: r,
    isReadOnly: a,
    isRequired: l,
    maxValue: 16777215,
    minValue: 0,
    onIncrement: s,
    onIncrementToMax: f,
    onDecrement: c,
    onDecrementToMin: h,
    value: o ? o.toHexInt() : void 0,
    textValue: o ? o.toString("hex") : void 0
  }), [y, $] = Y(!1), { focusWithinProps: v } = ft({
    isDisabled: r,
    onFocusWithinChange: $
  }), x = X((F) => {
    Math.abs(F.deltaY) <= Math.abs(F.deltaX) || (F.deltaY > 0 ? s() : F.deltaY < 0 && c());
  }, [
    c,
    s
  ]);
  k3({
    onScroll: x,
    isDisabled: i || r || a || !y
  }, n);
  let P = (F) => {
    t.validate(F) && t.setInputValue(F);
  }, { inputProps: C, ...M } = S3({
    ...e,
    id: b,
    value: d,
    // Intentionally invalid value that will be ignored by onChange during form reset
    // This is handled separately below.
    defaultValue: "!",
    validate: void 0,
    [Hn]: t,
    type: "text",
    autoComplete: "off",
    onChange: P
  }, t, n);
  return an(n, t.defaultColorValue, t.setColorValue), C = z(C, p, v, {
    role: "textbox",
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null,
    autoCorrect: "off",
    spellCheck: "false",
    onBlur: m
  }), u === "native" && (C["aria-required"] = void 0), {
    inputProps: C,
    ...M
  };
}
var dm = {};
dm = {
  decrease: (e) => `خفض ${e.fieldLabel}`,
  increase: (e) => `زيادة ${e.fieldLabel}`,
  numberField: "حقل رقمي"
};
var cm = {};
cm = {
  decrease: (e) => `Намаляване ${e.fieldLabel}`,
  increase: (e) => `Усилване ${e.fieldLabel}`,
  numberField: "Номер на полето"
};
var fm = {};
fm = {
  decrease: (e) => `Snížit ${e.fieldLabel}`,
  increase: (e) => `Zvýšit ${e.fieldLabel}`,
  numberField: "Číselné pole"
};
var hm = {};
hm = {
  decrease: (e) => `Reducer ${e.fieldLabel}`,
  increase: (e) => `Øg ${e.fieldLabel}`,
  numberField: "Talfelt"
};
var mm = {};
mm = {
  decrease: (e) => `${e.fieldLabel} verringern`,
  increase: (e) => `${e.fieldLabel} erhöhen`,
  numberField: "Nummernfeld"
};
var bm = {};
bm = {
  decrease: (e) => `Μείωση ${e.fieldLabel}`,
  increase: (e) => `Αύξηση ${e.fieldLabel}`,
  numberField: "Πεδίο αριθμού"
};
var pm = {};
pm = {
  decrease: (e) => `Decrease ${e.fieldLabel}`,
  increase: (e) => `Increase ${e.fieldLabel}`,
  numberField: "Number field"
};
var gm = {};
gm = {
  decrease: (e) => `Reducir ${e.fieldLabel}`,
  increase: (e) => `Aumentar ${e.fieldLabel}`,
  numberField: "Campo de número"
};
var ym = {};
ym = {
  decrease: (e) => `Vähenda ${e.fieldLabel}`,
  increase: (e) => `Suurenda ${e.fieldLabel}`,
  numberField: "Numbri väli"
};
var $m = {};
$m = {
  decrease: (e) => `Vähennä ${e.fieldLabel}`,
  increase: (e) => `Lisää ${e.fieldLabel}`,
  numberField: "Numerokenttä"
};
var vm = {};
vm = {
  decrease: (e) => `Diminuer ${e.fieldLabel}`,
  increase: (e) => `Augmenter ${e.fieldLabel}`,
  numberField: "Champ de nombre"
};
var Dm = {};
Dm = {
  decrease: (e) => `הקטן ${e.fieldLabel}`,
  increase: (e) => `הגדל ${e.fieldLabel}`,
  numberField: "שדה מספר"
};
var xm = {};
xm = {
  decrease: (e) => `Smanji ${e.fieldLabel}`,
  increase: (e) => `Povećaj ${e.fieldLabel}`,
  numberField: "Polje broja"
};
var Em = {};
Em = {
  decrease: (e) => `${e.fieldLabel} csökkentése`,
  increase: (e) => `${e.fieldLabel} növelése`,
  numberField: "Számmező"
};
var Cm = {};
Cm = {
  decrease: (e) => `Riduci ${e.fieldLabel}`,
  increase: (e) => `Aumenta ${e.fieldLabel}`,
  numberField: "Campo numero"
};
var Pm = {};
Pm = {
  decrease: (e) => `${e.fieldLabel}を縮小`,
  increase: (e) => `${e.fieldLabel}を拡大`,
  numberField: "数値フィールド"
};
var wm = {};
wm = {
  decrease: (e) => `${e.fieldLabel} 감소`,
  increase: (e) => `${e.fieldLabel} 증가`,
  numberField: "번호 필드"
};
var Sm = {};
Sm = {
  decrease: (e) => `Sumažinti ${e.fieldLabel}`,
  increase: (e) => `Padidinti ${e.fieldLabel}`,
  numberField: "Numerio laukas"
};
var km = {};
km = {
  decrease: (e) => `Samazināšana ${e.fieldLabel}`,
  increase: (e) => `Palielināšana ${e.fieldLabel}`,
  numberField: "Skaitļu lauks"
};
var Bm = {};
Bm = {
  decrease: (e) => `Reduser ${e.fieldLabel}`,
  increase: (e) => `Øk ${e.fieldLabel}`,
  numberField: "Tallfelt"
};
var Fm = {};
Fm = {
  decrease: (e) => `${e.fieldLabel} verlagen`,
  increase: (e) => `${e.fieldLabel} verhogen`,
  numberField: "Getalveld"
};
var Am = {};
Am = {
  decrease: (e) => `Zmniejsz ${e.fieldLabel}`,
  increase: (e) => `Zwiększ ${e.fieldLabel}`,
  numberField: "Pole numeru"
};
var Rm = {};
Rm = {
  decrease: (e) => `Diminuir ${e.fieldLabel}`,
  increase: (e) => `Aumentar ${e.fieldLabel}`,
  numberField: "Campo de número"
};
var Tm = {};
Tm = {
  decrease: (e) => `Diminuir ${e.fieldLabel}`,
  increase: (e) => `Aumentar ${e.fieldLabel}`,
  numberField: "Campo numérico"
};
var Im = {};
Im = {
  decrease: (e) => `Scădere ${e.fieldLabel}`,
  increase: (e) => `Creștere ${e.fieldLabel}`,
  numberField: "Câmp numeric"
};
var Mm = {};
Mm = {
  decrease: (e) => `Уменьшение ${e.fieldLabel}`,
  increase: (e) => `Увеличение ${e.fieldLabel}`,
  numberField: "Числовое поле"
};
var Km = {};
Km = {
  decrease: (e) => `Znížiť ${e.fieldLabel}`,
  increase: (e) => `Zvýšiť ${e.fieldLabel}`,
  numberField: "Číselné pole"
};
var Nm = {};
Nm = {
  decrease: (e) => `Upadati ${e.fieldLabel}`,
  increase: (e) => `Povečajte ${e.fieldLabel}`,
  numberField: "Številčno polje"
};
var Vm = {};
Vm = {
  decrease: (e) => `Smanji ${e.fieldLabel}`,
  increase: (e) => `Povećaj ${e.fieldLabel}`,
  numberField: "Polje broja"
};
var Lm = {};
Lm = {
  decrease: (e) => `Minska ${e.fieldLabel}`,
  increase: (e) => `Öka ${e.fieldLabel}`,
  numberField: "Nummerfält"
};
var zm = {};
zm = {
  decrease: (e) => `${e.fieldLabel} azalt`,
  increase: (e) => `${e.fieldLabel} arttır`,
  numberField: "Sayı alanı"
};
var Om = {};
Om = {
  decrease: (e) => `Зменшити ${e.fieldLabel}`,
  increase: (e) => `Збільшити ${e.fieldLabel}`,
  numberField: "Поле номера"
};
var Hm = {};
Hm = {
  decrease: (e) => `降低 ${e.fieldLabel}`,
  increase: (e) => `提高 ${e.fieldLabel}`,
  numberField: "数字字段"
};
var Um = {};
Um = {
  decrease: (e) => `縮小 ${e.fieldLabel}`,
  increase: (e) => `放大 ${e.fieldLabel}`,
  numberField: "數字欄位"
};
var jm = {};
jm = {
  "ar-AE": dm,
  "bg-BG": cm,
  "cs-CZ": fm,
  "da-DK": hm,
  "de-DE": mm,
  "el-GR": bm,
  "en-US": pm,
  "es-ES": gm,
  "et-EE": ym,
  "fi-FI": $m,
  "fr-FR": vm,
  "he-IL": Dm,
  "hr-HR": xm,
  "hu-HU": Em,
  "it-IT": Cm,
  "ja-JP": Pm,
  "ko-KR": wm,
  "lt-LT": Sm,
  "lv-LV": km,
  "nb-NO": Bm,
  "nl-NL": Fm,
  "pl-PL": Am,
  "pt-BR": Rm,
  "pt-PT": Tm,
  "ro-RO": Im,
  "ru-RU": Mm,
  "sk-SK": Km,
  "sl-SI": Nm,
  "sr-SP": Vm,
  "sv-SE": Lm,
  "tr-TR": zm,
  "uk-UA": Om,
  "zh-CN": Hm,
  "zh-TW": Um
};
function FD(e) {
  return e && e.__esModule ? e.default : e;
}
function _m(e, t, n) {
  let { id: r, decrementAriaLabel: a, incrementAriaLabel: l, isDisabled: i, isReadOnly: u, isRequired: o, minValue: d, maxValue: s, autoFocus: c, label: f, formatOptions: h, onBlur: m = () => {
  }, onFocus: b, onFocusChange: p, onKeyDown: y, onKeyUp: $, description: v, errorMessage: x, isWheelDisabled: E, ...P } = e, { increment: C, incrementToMax: M, decrement: F, decrementToMin: V, numberValue: I, inputValue: A, commit: U, commitValidation: D } = t;
  const N = Ee(FD(jm), "@react-aria/numberfield");
  let w = X(() => {
    let Re = n.current?.value ?? "";
    lt(() => {
      U();
    }), n.current?.value !== Re && pn(n.current?.value ?? "", "assertive");
  }, [
    U,
    n
  ]), R = ce(r), { focusProps: H } = pr({
    onBlur() {
      w();
    }
  }), k = Ii(h), S = K(() => k.resolvedOptions(), [
    k
  ]), j = Ii({
    ...h,
    currencySign: void 0
  }), _ = K(() => isNaN(I) ? "" : j.format(I), [
    j,
    I
  ]), { spinButtonProps: B, incrementButtonProps: L, decrementButtonProps: Z } = Yu({
    isDisabled: i,
    isReadOnly: u,
    isRequired: o,
    maxValue: s,
    minValue: d,
    onIncrement: C,
    onIncrementToMax: M,
    onDecrement: F,
    onDecrementToMin: V,
    value: I,
    textValue: _
  }), [ie, q] = Y(!1), { focusWithinProps: re } = ft({
    isDisabled: i,
    onFocusWithinChange: q
  }), fe = X((Re) => {
    Math.abs(Re.deltaY) <= Math.abs(Re.deltaX) || (Re.deltaY > 0 ? C() : Re.deltaY < 0 && F());
  }, [
    F,
    C
  ]);
  k3({
    onScroll: fe,
    isDisabled: E || i || u || !ie
  }, n);
  let ht = (S.maximumFractionDigits ?? 0) > 0, qn = t.minValue === void 0 || isNaN(t.minValue) || t.minValue < 0, Ut = "numeric";
  qd() ? qn ? Ut = "text" : ht && (Ut = "decimal") : bn() && (qn ? Ut = "numeric" : ht && (Ut = "decimal"));
  let Yn = (Re) => {
    t.validate(Re) && t.setInputValue(Re);
  }, Zn = (Re) => {
    e.onPaste?.(Re);
    let Qn = W(Re);
    Qn && (Qn.selectionEnd ?? -1) - (Qn.selectionStart ?? 0) === Qn.value.length && (Re.preventDefault(), U(Re.clipboardData?.getData?.("text/plain")?.trim() ?? ""));
  }, be = J(e), ln = X((Re) => {
    Re.nativeEvent.isComposing || (Re.key === "Enter" ? (lt(() => {
      U();
    }), D()) : Re.continuePropagation());
  }, [
    U,
    D
  ]), { isInvalid: Ea, validationErrors: ne, validationDetails: Ce } = t.displayValidation, { labelProps: xn, inputProps: Xn, descriptionProps: En, errorMessageProps: Tr } = S3({
    ...P,
    ...be,
    // These props are added to a hidden input rather than the formatted textfield.
    name: void 0,
    form: void 0,
    label: f,
    autoFocus: c,
    isDisabled: i,
    isReadOnly: u,
    isRequired: o,
    validate: void 0,
    [Hn]: t,
    value: A,
    defaultValue: "!",
    autoComplete: "off",
    "aria-label": e["aria-label"] || void 0,
    "aria-labelledby": e["aria-labelledby"] || void 0,
    id: R,
    type: "text",
    inputMode: Ut,
    onChange: Yn,
    onBlur: m,
    onFocus: b,
    onFocusChange: p,
    onKeyDown: K(() => st(ln, y), [
      ln,
      y
    ]),
    onKeyUp: $,
    onPaste: Zn,
    description: v,
    errorMessage: x
  }, t, n);
  an(n, t.defaultNumberValue, t.setNumberValue), AD(t, e.validationBehavior, e.commitBehavior, n, t.minValue, t.maxValue, e.step, t.numberValue);
  let Jn = z(B, H, Xn, {
    // override the spinbutton role, we can't focus a spin button with VO
    role: null,
    // ignore aria-roledescription on iOS so that required state will announce when it is present
    "aria-roledescription": xt() ? null : N.format("numberField"),
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null,
    autoCorrect: "off",
    spellCheck: "false"
  });
  e.validationBehavior === "native" && (Jn["aria-required"] = void 0);
  let Bt = (Re) => {
    se() !== n.current && (Re.pointerType === "mouse" ? n.current?.focus() : Re.target.focus());
  }, Ft = e["aria-label"] || (typeof e.label == "string" ? e.label : ""), At;
  Ft || (At = e.label != null ? xn.id : e["aria-labelledby"]);
  let Ir = ce(), Mr = ce(), Vl = z(L, {
    "aria-label": l || N.format("increase", {
      fieldLabel: Ft
    }).trim(),
    id: At && !l ? Ir : null,
    "aria-labelledby": At && !l ? `${Ir} ${At}` : null,
    "aria-controls": R,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !t.canIncrement,
    onPressStart: Bt
  }), Ll = z(Z, {
    "aria-label": a || N.format("decrease", {
      fieldLabel: Ft
    }).trim(),
    id: At && !a ? Mr : null,
    "aria-labelledby": At && !a ? `${Mr} ${At}` : null,
    "aria-controls": R,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !t.canDecrement,
    onPressStart: Bt
  });
  return {
    groupProps: {
      ...re,
      role: "group",
      "aria-disabled": i,
      "aria-invalid": Ea ? "true" : void 0
    },
    labelProps: xn,
    inputProps: Jn,
    incrementButtonProps: Vl,
    decrementButtonProps: Ll,
    errorMessageProps: Tr,
    descriptionProps: En,
    isInvalid: Ea,
    validationErrors: ne,
    validationDetails: Ce
  };
}
let Ue = null;
function AD(e, t, n, r, a, l, i, u) {
  ue(() => {
    let o = r.current;
    if (n !== "validate" || e.realtimeValidation.isInvalid || !o || o.disabled || (!Ue && typeof document < "u" && (Ue = document.createElement("input"), Ue.type = "number"), !Ue))
      return;
    Ue.min = a != null && !isNaN(a) ? String(a) : "", Ue.max = l != null && !isNaN(l) ? String(l) : "", Ue.step = i != null && !isNaN(i) ? String(i) : "", Ue.value = u != null && !isNaN(u) ? String(u) : "";
    let d = o.validity.valid && Ue.validity.valid, s = o.validationMessage || Ue.validationMessage, c = {
      isInvalid: !d,
      validationErrors: s ? [
        s
      ] : [],
      validationDetails: {
        badInput: o.validity.badInput,
        customError: o.validity.customError,
        patternMismatch: o.validity.patternMismatch,
        rangeOverflow: Ue.validity.rangeOverflow,
        rangeUnderflow: Ue.validity.rangeUnderflow,
        stepMismatch: Ue.validity.stepMismatch,
        tooLong: o.validity.tooLong,
        tooShort: o.validity.tooShort,
        typeMismatch: o.validity.typeMismatch,
        valueMissing: o.validity.valueMissing,
        valid: d
      }
    };
    e.updateValidation(c), t === "native" && !Ue.validity.valid && o.setCustomValidity(Ue.validationMessage);
  });
}
function RD(e, t, n) {
  let { locale: r } = de();
  return _m({
    ...e,
    value: void 0,
    defaultValue: void 0,
    onChange: void 0,
    validate: void 0,
    // Provide a default aria-label if no other label is provided.
    "aria-label": e["aria-label"] || (e.label || e["aria-labelledby"] ? void 0 : t.colorValue.getChannelName(e.channel, r))
  }, t, n);
}
function Un(e) {
  return K(() => {
    if (typeof e == "string") try {
      return Ze(e);
    } catch {
      return;
    }
    return e;
  }, [
    e
  ]);
}
const dl = Ze("#000000"), Wm = Ze("#FFFFFF"), TD = dl.toHexInt(), ID = Wm.toHexInt();
function MD(e) {
  let { value: t, defaultValue: n, onChange: r } = e, { step: a } = dl.getChannelRange("red"), l = Un(n), [i, u] = we(Un(t), l, r), [o] = Y(i), [d, s] = Y(() => (t || n) && i ? i.toString("hex") : ""), c = rn({
    ...e,
    value: i
  }), f = (P) => {
    if (!i || !P) {
      u(P);
      return;
    }
    if (P.toHexInt() !== i.toHexInt()) {
      u(P);
      return;
    }
  }, [h, m] = Y(i);
  h !== i && (s(i ? i.toString("hex") : ""), m(i));
  let b = K(() => {
    let P;
    try {
      P = Ze(d.startsWith("#") ? d : `#${d}`);
    } catch {
      P = null;
    }
    return P;
  }, [
    d
  ]);
  return {
    ...c,
    validate: (P) => P === "" || !!P.match(/^#?[0-9a-f]{0,6}$/i)?.[0],
    colorValue: i,
    defaultColorValue: l ?? o,
    setColorValue: u,
    inputValue: d,
    setInputValue: s,
    commit: () => {
      if (!d.length) {
        f(null), s(t === void 0 || i === null ? "" : i.toString("hex"));
        return;
      }
      if (b == null) {
        s(i ? i.toString("hex") : "");
        return;
      }
      f(b);
      let P = "";
      i && (P = i.toString("hex")), s(P), c.commitValidation();
    },
    increment: () => {
      let P = _s(b, a);
      P === i && s(P.toString("hex")), f(P), c.commitValidation();
    },
    incrementToMax: () => f(Wm),
    decrement: () => {
      let P = _s(b, -a);
      P === i && s(P.toString("hex")), f(P), c.commitValidation();
    },
    decrementToMin: () => f(dl)
  };
}
function _s(e, t) {
  let n = e || dl, r = n.toHexInt(), a = Math.min(Math.max(r + t, TD), ID);
  if (a !== r) {
    let l = `#${a.toString(16).padStart(6, "0").toUpperCase()}`;
    n = Ze(l);
  }
  return n;
}
function Gm(e) {
  let { minValue: t, maxValue: n, step: r, formatOptions: a, value: l, defaultValue: i = NaN, onChange: u, locale: o, isDisabled: d, isReadOnly: s, commitBehavior: c = "snap" } = e;
  l === null && (l = NaN);
  let f = X((Z) => r === void 0 || isNaN(r) ? Le(Z, t, n) : Ve(Z, t, n, r), [
    r,
    t,
    n
  ]);
  l !== void 0 && !isNaN(l) && c === "snap" && (l = f(l)), !isNaN(i) && c === "snap" && (i = f(i));
  let [h, m] = we(l, isNaN(i) ? NaN : i, u), [b] = Y(h), [p, y] = Y(() => isNaN(h) ? "" : new Lt(o, a).format(h)), $ = K(() => new wu(o, a), [
    o,
    a
  ]), v = K(() => $.getNumberingSystem(p), [
    $,
    p
  ]), x = K(() => new Lt(o, {
    ...a,
    numberingSystem: v
  }), [
    o,
    a,
    v
  ]), E = K(() => x.resolvedOptions(), [
    x
  ]), P = X((Z) => isNaN(Z) || Z === null ? "" : x.format(Z), [
    x
  ]), C = rn({
    ...e,
    value: h
  }), M = r !== void 0 && !isNaN(r) ? r : 1;
  E.style === "percent" && (r === void 0 || isNaN(r)) && (M = 0.01);
  let [F, V] = Y(h), [I, A] = Y(o), [U, D] = Y(a);
  (!Object.is(h, F) || o !== I || !KD(a, U)) && (y(P(h)), V(h), A(o), D(a));
  let N = K(() => $.parse(p), [
    $,
    p
  ]), w = (Z) => {
    let ie = Z === void 0 ? p : Z, q = N;
    if (Z !== void 0 && (q = $.parse(ie)), !ie.length) {
      m(NaN), y(l === void 0 ? "" : P(h));
      return;
    }
    if (isNaN(q)) {
      y(P(h));
      return;
    }
    let re = c === "snap" ? f(q) : q;
    re = $.parse(P(re));
    let fe = re !== h;
    m(re), y(P(l === void 0 ? re : h)), fe && C.commitValidation();
  }, R = (Z, ie = 0) => {
    let q = N;
    if (isNaN(q)) {
      let re = isNaN(ie) ? 0 : ie;
      return Ve(re, t, n, M);
    } else {
      let re = Ve(q, t, n, M);
      return Z === "+" && re > q || Z === "-" && re < q ? re : Ve(ui(Z, q, M), t, n, M);
    }
  }, H = () => {
    let Z = R("+", t);
    Z === h && y(P(Z)), m(Z), C.commitValidation();
  }, k = () => {
    let Z = R("-", n);
    Z === h && y(P(Z)), m(Z), C.commitValidation();
  }, S = () => {
    n != null && (m(Ve(n, t, n, M)), C.commitValidation());
  }, j = () => {
    t != null && (m(t), C.commitValidation());
  }, _ = K(() => !d && !s && (isNaN(N) || n === void 0 || isNaN(n) || Ve(N, t, n, M) > N || ui("+", N, M) <= n), [
    d,
    s,
    t,
    n,
    M,
    N
  ]), B = K(() => !d && !s && (isNaN(N) || t === void 0 || isNaN(t) || Ve(N, t, n, M) < N || ui("-", N, M) >= t), [
    d,
    s,
    t,
    n,
    M,
    N
  ]);
  return {
    ...C,
    validate: (Z) => $.isValidPartialNumber(Z, t, n),
    increment: H,
    incrementToMax: S,
    decrement: k,
    decrementToMin: j,
    canIncrement: _,
    canDecrement: B,
    minValue: t,
    maxValue: n,
    numberValue: N,
    defaultNumberValue: isNaN(i) ? b : i,
    setNumberValue: m,
    setInputValue: y,
    inputValue: p,
    commit: w
  };
}
function KD(e, t) {
  if (e === t) return !0;
  if (!e || !t) return !1;
  let n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (let a of n)
    if (t[a] !== e[a]) return !1;
  return !0;
}
function ui(e, t, n) {
  let r = e === "+" ? t + n : t - n;
  if (t % 1 !== 0 || n % 1 !== 0) {
    const a = t.toString().split("."), l = n.toString().split("."), i = a[1] && a[1].length || 0, u = l[1] && l[1].length || 0, o = Math.pow(10, Math.max(i, u));
    t = Math.round(t * o), n = Math.round(n * o), r = e === "+" ? t + n : t - n, r /= o;
  }
  return r;
}
function ND(e) {
  let { channel: t, colorSpace: n, locale: r } = e, a = Un(e.value), l = Un(e.defaultValue), [i, u] = we(a, l ?? null, e.onChange), o = Ws(i, n), [d] = Y(i), s = l ?? d, c = Ws(s, n), f = o.getChannelValue(t), h = o.getChannelRange(t), m = K(() => o.getChannelFormatOptions(t), [
    o,
    t
  ]), b = m.style === "percent" && h.maxValue === 100 ? 100 : 1;
  return {
    ...Gm({
      locale: r,
      value: i === null ? NaN : f / b,
      defaultValue: s === null ? NaN : c.getChannelValue(t) / b,
      onChange: (y) => {
        Number.isNaN(y) ? u(null) : u(o.withChannelValue(t, y * b));
      },
      minValue: h.minValue / b,
      maxValue: h.maxValue / b,
      step: h.step / b,
      formatOptions: m
    }),
    colorValue: o,
    defaultColorValue: s,
    setColorValue: u
  };
}
function Ws(e, t) {
  let n = Un("#000");
  return K(() => {
    let r = e || n;
    return t && r ? r.toFormat(t) : r;
  }, [
    n,
    e,
    t
  ]);
}
const qm = /* @__PURE__ */ G(null), VD = /* @__PURE__ */ G(null), cC = /* @__PURE__ */ te(function(t, n) {
  return [t, n] = oe(t, n, qm), t.channel ? /* @__PURE__ */ g.createElement(LD, {
    ...t,
    channel: t.channel,
    forwardedRef: n
  }) : /* @__PURE__ */ g.createElement(zD, {
    ...t,
    forwardedRef: n
  });
});
function LD(e) {
  let { locale: t } = de(), n = ND({
    ...e,
    locale: t
  }), r = T(null), [a, l] = Qe(!e["aria-label"] && !e["aria-labelledby"]), { labelProps: i, inputProps: u, descriptionProps: o, errorMessageProps: d, ...s } = RD({
    ...wt(e),
    label: l,
    validationBehavior: e.validationBehavior ?? "native"
  }, n, r);
  return /* @__PURE__ */ g.createElement(g.Fragment, null, Ym(e, n, e.forwardedRef, u, r, i, a, o, d, s), e.name && /* @__PURE__ */ g.createElement("input", {
    type: "hidden",
    name: e.name,
    form: e.form,
    value: isNaN(n.numberValue) ? "" : n.numberValue
  }));
}
function zD(e) {
  let t = MD({
    ...e,
    validationBehavior: e.validationBehavior ?? "native"
  }), n = T(null), [r, a] = Qe(!e["aria-label"] && !e["aria-labelledby"]), { labelProps: l, inputProps: i, descriptionProps: u, errorMessageProps: o, ...d } = BD({
    ...wt(e),
    label: a,
    validationBehavior: e.validationBehavior ?? "native"
  }, t, n);
  return Ym(e, t, e.forwardedRef, i, n, l, r, u, o, d);
}
function Ym(e, t, n, r, a, l, i, u, o, d) {
  let s = le({
    ...e,
    values: {
      state: t,
      channel: e.channel || "hex",
      isDisabled: e.isDisabled || !1,
      isInvalid: d.isInvalid || !1,
      isReadOnly: e.isReadOnly || !1,
      isRequired: e.isRequired || !1
    },
    defaultClassName: "react-aria-ColorField"
  }), c = J(e, {
    global: !0
  });
  return delete c.id, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        VD,
        t
      ],
      [
        wr,
        {
          ...r,
          ref: a
        }
      ],
      [
        et,
        {
          ...l,
          ref: i
        }
      ],
      [
        Dn,
        {
          role: "presentation",
          isInvalid: d.isInvalid,
          isDisabled: e.isDisabled || !1
        }
      ],
      [
        We,
        {
          slots: {
            description: u,
            errorMessage: o
          }
        }
      ],
      [
        nn,
        d
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...c,
    ...s,
    ref: n,
    slot: e.slot || void 0,
    "data-channel": e.channel || "hex",
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": d.isInvalid || void 0,
    "data-readonly": e.isReadOnly || void 0,
    "data-required": e.isRequired || void 0
  }));
}
const Zu = /* @__PURE__ */ new WeakMap();
function Wi(e, t) {
  let n = Zu.get(e);
  if (!n) throw new Error("Unknown slider state");
  return `${n.id}-${t}`;
}
function OD(e, t, n) {
  let { labelProps: r, fieldProps: a } = ba(e), l = e.orientation === "vertical";
  Zu.set(t, {
    id: r.id ?? a.id,
    "aria-describedby": e["aria-describedby"],
    "aria-details": e["aria-details"]
  });
  let { direction: i } = de(), { addGlobalListener: u, removeGlobalListener: o } = Qt();
  const d = T(null), s = i === "rtl", c = T(null), { moveProps: f } = oa({
    onMoveStart() {
      c.current = null;
    },
    onMove({ deltaX: p, deltaY: y }) {
      if (!n.current) return;
      let { height: $, width: v } = n.current.getBoundingClientRect(), x = l ? $ : v;
      c.current == null && d.current != null && (c.current = t.getThumbPercent(d.current) * x);
      let E = l ? y : p;
      if ((l || s) && (E = -E), c.current += E, d.current != null && n.current) {
        const P = Le(c.current / x, 0, 1);
        t.setThumbPercent(d.current, P);
      }
    },
    onMoveEnd() {
      d.current != null && (t.setThumbDragging(d.current, !1), d.current = null);
    }
  });
  let h = T(void 0), m = (p, y, $, v) => {
    if (n.current && !e.isDisabled && t.values.every((x, E) => !t.isThumbDragging(E))) {
      let { height: x, width: E, top: P, left: C } = n.current.getBoundingClientRect(), M = l ? x : E, A = ((l ? v : $) - (l ? P : C)) / M;
      (i === "rtl" || l) && (A = 1 - A);
      let U = t.getPercentValue(A), D, N = t.values.findIndex((w) => U - w < 0);
      if (N === 0)
        D = N;
      else if (N === -1)
        D = t.values.length - 1;
      else {
        let w = t.values[N - 1], R = t.values[N];
        Math.abs(w - U) < Math.abs(R - U) ? D = N - 1 : D = N;
      }
      D >= 0 && t.isThumbEditable(D) ? (p.preventDefault(), d.current = D, t.setFocusedThumb(D), h.current = y, t.setThumbDragging(d.current, !0), t.setThumbValue(D, U), u(window, "mouseup", b, !1), u(window, "touchend", b, !1), u(window, "pointerup", b, !1)) : d.current = null;
    }
  }, b = (p) => {
    (p.pointerId ?? p.changedTouches?.[0].identifier) === h.current && (d.current != null && (t.setThumbDragging(d.current, !1), d.current = null), o(window, "mouseup", b, !1), o(window, "touchend", b, !1), o(window, "pointerup", b, !1));
  };
  return "htmlFor" in r && r.htmlFor && (delete r.htmlFor, r.onClick = () => {
    document.getElementById(Wi(t, 0))?.focus(), Yr("keyboard");
  }), {
    labelProps: r,
    // The root element of the Slider will have role="group" to group together
    // all the thumb inputs in the Slider.  The label of the Slider will
    // be used to label the group.
    groupProps: {
      role: "group",
      ...a
    },
    trackProps: z({
      onMouseDown(p) {
        p.button !== 0 || p.altKey || p.ctrlKey || p.metaKey || m(p, void 0, p.clientX, p.clientY);
      },
      onPointerDown(p) {
        p.pointerType === "mouse" && (p.button !== 0 || p.altKey || p.ctrlKey || p.metaKey) || m(p, p.pointerId, p.clientX, p.clientY);
      },
      onTouchStart(p) {
        m(p, p.changedTouches[0].identifier, p.changedTouches[0].clientX, p.changedTouches[0].clientY);
      },
      style: {
        position: "relative",
        touchAction: "none"
      }
    }, f),
    outputProps: {
      htmlFor: t.values.map((p, y) => Wi(t, y)).join(" "),
      "aria-live": "off"
    }
  };
}
function HD(e, t) {
  let { index: n = 0, isRequired: r, validationState: a, isInvalid: l, trackRef: i, inputRef: u, orientation: o = t.orientation, name: d, form: s } = e, c = e.isDisabled || t.isDisabled, f = o === "vertical", { direction: h } = de(), { addGlobalListener: m, removeGlobalListener: b } = Qt(), p = Zu.get(t);
  const { labelProps: y, fieldProps: $ } = ba({
    ...e,
    id: Wi(t, n),
    "aria-labelledby": `${p.id} ${e["aria-labelledby"] ?? ""}`.trim()
  }), v = t.values[n], x = X(() => {
    u.current && Ae(u.current);
  }, [
    u
  ]), E = t.focusedThumb === n;
  ee(() => {
    E && x();
  }, [
    E,
    x
  ]);
  let P = h === "rtl", C = T(null), { keyboardProps: M } = Cr({
    onKeyDown(w) {
      let { getThumbMaxValue: R, getThumbMinValue: H, decrementThumb: k, incrementThumb: S, setThumbValue: j, setThumbDragging: _, pageSize: B } = t;
      if (!/^(PageUp|PageDown|Home|End)$/.test(w.key)) {
        w.continuePropagation();
        return;
      }
      switch (w.preventDefault(), _(n, !0), w.key) {
        case "PageUp":
          S(n, B);
          break;
        case "PageDown":
          k(n, B);
          break;
        case "Home":
          j(n, H(n));
          break;
        case "End":
          j(n, R(n));
          break;
      }
      _(n, !1);
    }
  }), { moveProps: F } = oa({
    onMoveStart() {
      C.current = null, t.setThumbDragging(n, !0);
    },
    onMove({ deltaX: w, deltaY: R, pointerType: H, shiftKey: k }) {
      const { getThumbPercent: S, setThumbPercent: j, decrementThumb: _, incrementThumb: B, step: L, pageSize: Z } = t;
      if (!i.current) return;
      let { width: ie, height: q } = i.current.getBoundingClientRect(), re = f ? q : ie;
      if (C.current == null && (C.current = S(n) * re), H === "keyboard")
        w > 0 && P || w < 0 && !P || R > 0 ? _(n, k ? Z : L) : B(n, k ? Z : L);
      else {
        let fe = f ? R : w;
        (f || P) && (fe = -fe), C.current += fe, j(n, Le(C.current / re, 0, 1));
      }
    },
    onMoveEnd() {
      t.setThumbDragging(n, !1);
    }
  });
  t.setThumbEditable(n, !c);
  const { focusableProps: V } = ct(z(e, {
    onFocus: () => t.setFocusedThumb(n),
    onBlur: () => t.setFocusedThumb(void 0)
  }), u);
  let I = T(void 0), A = (w) => {
    x(), I.current = w, t.setThumbDragging(n, !0), m(window, "mouseup", U, !1), m(window, "touchend", U, !1), m(window, "pointerup", U, !1);
  }, U = (w) => {
    (w.pointerId ?? w.changedTouches?.[0].identifier) === I.current && (x(), t.setThumbDragging(n, !1), b(window, "mouseup", U, !1), b(window, "touchend", U, !1), b(window, "pointerup", U, !1));
  }, D = t.getThumbPercent(n);
  (f || h === "rtl") && (D = 1 - D);
  let N = c ? {} : z(M, F, {
    onMouseDown: (w) => {
      w.button !== 0 || w.altKey || w.ctrlKey || w.metaKey || A();
    },
    onPointerDown: (w) => {
      w.button !== 0 || w.altKey || w.ctrlKey || w.metaKey || A(w.pointerId);
    },
    onTouchStart: (w) => {
      A(w.changedTouches[0].identifier);
    }
  });
  return an(u, t.defaultValues[n], (w) => {
    t.setThumbValue(n, w);
  }), {
    inputProps: z(V, $, {
      type: "range",
      tabIndex: c ? void 0 : 0,
      min: t.getThumbMinValue(n),
      max: t.getThumbMaxValue(n),
      step: t.step,
      value: v,
      name: d,
      form: s,
      disabled: c,
      "aria-orientation": o,
      "aria-valuetext": t.getThumbValueLabel(n),
      "aria-required": r || void 0,
      "aria-invalid": l || a === "invalid" || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-describedby": [
        p["aria-describedby"],
        e["aria-describedby"]
      ].filter(Boolean).join(" "),
      "aria-details": [
        p["aria-details"],
        e["aria-details"]
      ].filter(Boolean).join(" "),
      onChange: (w) => {
        t.setThumbValue(n, parseFloat(W(w).value));
      }
    }),
    thumbProps: {
      ...N,
      style: {
        position: "absolute",
        [f ? "top" : "left"]: `${D * 100}%`,
        transform: "translate(-50%, -50%)",
        touchAction: "none"
      }
    },
    labelProps: y,
    isDragging: t.isThumbDragging(n),
    isDisabled: c,
    isFocused: E
  };
}
const UD = 0, jD = 100, _D = 1;
function WD(e) {
  const { isDisabled: t = !1, minValue: n = UD, maxValue: r = jD, numberFormatter: a, step: l = _D, orientation: i = "horizontal" } = e;
  let u = K(() => {
    let B = (r - n) / 10;
    return B = Ve(B, 0, B + l, l), Math.max(B, l);
  }, [
    l,
    r,
    n
  ]), o = X((B) => B?.map((L, Z) => {
    let ie = Z === 0 ? n : B[Z - 1], q = Z === B.length - 1 ? r : B[Z + 1];
    return Ve(L, ie, q, l);
  }), [
    n,
    r,
    l
  ]), d = K(() => o(qs(e.value)), [
    e.value,
    o
  ]), s = K(() => o(qs(e.defaultValue) ?? [
    n
  ]), [
    e.defaultValue,
    n,
    o
  ]), c = Ys(e.value, e.defaultValue, e.onChange), f = Ys(e.value, e.defaultValue, e.onChangeEnd);
  const [h, m] = we(d, s, c);
  let [b] = Y(h);
  const [p, y] = Y(new Array(h.length).fill(!1)), $ = T(new Array(h.length).fill(!0)), [v, x] = Y(void 0), E = T(h), P = T(p);
  let C = (B) => {
    E.current = B, m(B);
  }, M = (B) => {
    P.current = B, y(B);
  };
  function F(B) {
    return (B - n) / (r - n);
  }
  function V(B) {
    return B === 0 ? n : h[B - 1];
  }
  function I(B) {
    return B === h.length - 1 ? r : h[B + 1];
  }
  function A(B) {
    return $.current[B];
  }
  function U(B, L) {
    $.current[B] = L;
  }
  function D(B, L) {
    if (t || !A(B)) return;
    const Z = V(B), ie = I(B);
    L = Ve(L, Z, ie, l);
    let q = Gs(E.current, B, L);
    C(q);
  }
  function N(B, L) {
    if (t || !A(B)) return;
    L && (E.current = h);
    const Z = P.current[B];
    P.current = Gs(P.current, B, L), M(P.current), f && Z && !P.current.some(Boolean) && f(E.current);
  }
  let w = T(null);
  function R(B = h) {
    switch (typeof B == "number" && (B = [
      B
    ]), B.length) {
      case 0:
        return "";
      case 1:
        return a.format(B[0]);
      case 2:
        return a.formatRange(B[0], B[1]);
      default: {
        let L = B.map((ie) => a.format(ie)), Z = w.current;
        return (!Z || Z.resolvedOptions().locale !== a.resolvedOptions().locale) && (Z = w.current = new Intl.ListFormat(a.resolvedOptions().locale, {
          type: "unit"
        })), Z.format(L);
      }
    }
  }
  function H(B, L) {
    D(B, S(L));
  }
  function k(B) {
    return Math.round((B - n) / l) * l + n;
  }
  function S(B) {
    const L = B * (r - n) + n;
    return Le(k(L), n, r);
  }
  function j(B, L = 1) {
    let Z = Math.max(L, l);
    D(B, Ve(h[B] + Z, n, r, l));
  }
  function _(B, L = 1) {
    let Z = Math.max(L, l);
    D(B, Ve(h[B] - Z, n, r, l));
  }
  return {
    values: h,
    defaultValues: e.defaultValue !== void 0 ? s : b,
    getThumbValue: (B) => h[B],
    setThumbValue: D,
    setThumbPercent: H,
    isThumbDragging: (B) => p[B],
    setThumbDragging: N,
    focusedThumb: v,
    setFocusedThumb: x,
    getThumbPercent: (B) => F(h[B]),
    getValuePercent: F,
    getThumbValueLabel: (B) => R(h[B]),
    getFormattedValue: R,
    getThumbMinValue: V,
    getThumbMaxValue: I,
    getPercentValue: S,
    isThumbEditable: A,
    setThumbEditable: U,
    incrementThumb: j,
    decrementThumb: _,
    step: l,
    pageSize: u,
    orientation: i,
    isDisabled: t
  };
}
function Gs(e, t, n) {
  return e[t] === n ? e : [
    ...e.slice(0, t),
    n,
    ...e.slice(t + 1)
  ];
}
function qs(e) {
  if (e != null)
    return Array.isArray(e) ? e : [
      e
    ];
}
function Ys(e, t, n) {
  return (r) => {
    n?.(typeof e == "number" || typeof t == "number" ? r[0] : r);
  };
}
const Zm = /* @__PURE__ */ G(null), Xm = /* @__PURE__ */ G(null), GD = /* @__PURE__ */ G(null), fC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Xm);
  let r = O(Zm), { onHoverStart: a, onHoverEnd: l, onHoverChange: i, ...u } = t, { hoverProps: o, isHovered: d } = De({
    onHoverStart: a,
    onHoverEnd: l,
    onHoverChange: i
  }), s = le({
    ...t,
    defaultClassName: "react-aria-SliderTrack",
    values: {
      orientation: r.orientation,
      isDisabled: r.isDisabled,
      isHovered: d,
      state: r
    }
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(u, o),
    ...s,
    ref: n,
    "data-hovered": d || void 0,
    "data-orientation": r.orientation || void 0,
    "data-disabled": r.isDisabled || void 0
  });
});
function qD(e, t) {
  let { trackRef: n, inputRef: r, orientation: a, channel: l, "aria-label": i, name: u, form: o } = e, { locale: d, direction: s } = de();
  !e.label && !i && !e["aria-labelledby"] && (i = t.value.getChannelName(l, d));
  let { groupProps: c, trackProps: f, labelProps: h, outputProps: m } = OD(
    // @ts-ignore - ignore unused incompatible props
    {
      ...e,
      "aria-label": i
    },
    t,
    n
  ), { inputProps: b, thumbProps: p } = HD({
    index: 0,
    orientation: a,
    isDisabled: e.isDisabled,
    name: u,
    form: o,
    trackRef: n,
    inputRef: r
  }, t), y = t.getDisplayColor(), $ = () => {
    let E;
    switch (a === "vertical" ? E = "top" : s === "ltr" ? E = "right" : E = "left", l) {
      case "hue": {
        let P = [
          0,
          60,
          120,
          180,
          240,
          300,
          360
        ].map((C) => y.withChannelValue("hue", C).toString("css")).join(", ");
        return `linear-gradient(to ${E}, ${P})`;
      }
      case "lightness": {
        let P = t.getThumbMinValue(0), C = t.getThumbMaxValue(0), M = y.withChannelValue(l, P).toString("css"), F = y.withChannelValue(l, (C - P) / 2).toString("css"), V = y.withChannelValue(l, C).toString("css");
        return `linear-gradient(to ${E}, ${M}, ${F}, ${V})`;
      }
      case "saturation":
      case "brightness":
      case "red":
      case "green":
      case "blue":
      case "alpha": {
        let P = y.withChannelValue(l, t.getThumbMinValue(0)).toString("css"), C = y.withChannelValue(l, t.getThumbMaxValue(0)).toString("css");
        return `linear-gradient(to ${E}, ${P}, ${C})`;
      }
      default:
        throw new Error("Unknown color channel: " + l);
    }
  }, v = {
    forcedColorAdjust: "none"
  };
  l === "hue" ? b["aria-valuetext"] += `, ${y.getHueName(d)}` : l !== "alpha" && (b["aria-valuetext"] += `, ${y.getColorName(d)}`);
  let { visuallyHiddenProps: x } = tn({
    style: {
      opacity: "0.0001",
      width: "100%",
      height: "100%",
      pointerEvents: "none"
    }
  });
  return {
    trackProps: {
      ...z(c, f),
      style: {
        ...f.style,
        ...v,
        background: $()
      }
    },
    inputProps: {
      ...b,
      style: {
        ...b.style,
        ...x.style
      }
    },
    thumbProps: {
      ...p,
      style: {
        ...p.style,
        ...v
      }
    },
    labelProps: h,
    outputProps: m
  };
}
function YD(e) {
  let { channel: t, colorSpace: n, value: r, defaultValue: a, onChange: l, locale: i, ...u } = e;
  if (r == null && a == null) throw new Error("useColorSliderState requires a value or defaultValue");
  r && (r = mr(r)), a && (a = mr(a));
  let [o, d] = we(r, a, l), s = K(() => n && o ? o.toFormat(n) : o, [
    o,
    n
  ]), [c] = Y(o), f = a ?? c, h = K(() => n && f ? f.toFormat(n) : f, [
    f,
    n
  ]), m = K(() => new Intl.NumberFormat(), []), b = WD({
    ...s.getChannelRange(t),
    ...u,
    numberFormatter: m,
    value: s.getChannelValue(t),
    defaultValue: h.getChannelValue(t),
    onChange($) {
      d(s.withChannelValue(t, $));
    },
    onChangeEnd($) {
      e.onChangeEnd && e.onChangeEnd(s.withChannelValue(t, $));
    }
  }), { step: p, pageSize: y } = s.getChannelRange(t);
  return {
    ...b,
    value: s,
    setValue($) {
      d(mr($));
    },
    getDisplayColor() {
      switch (t) {
        case "hue":
          return Ze(`hsl(${s.getChannelValue("hue")}, 100%, 50%)`);
        case "lightness":
        case "brightness":
        case "saturation":
        case "red":
        case "green":
        case "blue":
          return s.withChannelValue("alpha", 1);
        case "alpha":
          return s;
        default:
          throw new Error("Unknown color channel: " + t);
      }
    },
    getThumbValueLabel() {
      return s.formatChannelValue(t, i);
    },
    getFormattedValue() {
      return s.formatChannelValue(t, i);
    },
    step: p,
    pageSize: y,
    isDragging: b.isThumbDragging(0)
  };
}
const Jm = /* @__PURE__ */ G(null), ZD = /* @__PURE__ */ G(null), hC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Jm);
  let { locale: r } = de(), a = YD({
    ...t,
    locale: r
  }), l = g.useRef(null), i = g.useRef(null), [u, o] = Qe(!t["aria-label"] && !t["aria-labelledby"]), { trackProps: d, thumbProps: s, inputProps: c, labelProps: f, outputProps: h } = qD({
    ...t,
    label: o,
    trackRef: l,
    inputRef: i
  }, a), m = le({
    ...t,
    values: {
      orientation: a.orientation,
      isDisabled: a.isDisabled,
      state: a
    },
    defaultClassName: "react-aria-ColorSlider"
  }), b = J(t, {
    global: !0
  });
  return delete b.id, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        ZD,
        a
      ],
      [
        Zm,
        a
      ],
      [
        Xm,
        {
          ...d,
          ref: l
        }
      ],
      [
        GD,
        h
      ],
      [
        et,
        {
          ...f,
          ref: u,
          children: a.value.getChannelName(t.channel, r)
        }
      ],
      [
        _u,
        {
          state: a,
          thumbProps: s,
          inputXRef: i,
          xInputProps: c,
          isDisabled: t.isDisabled
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...b,
    ...m,
    ref: n,
    slot: t.slot || void 0,
    "data-orientation": a.orientation,
    "data-disabled": a.isDisabled || void 0
  }));
});
function XD(e) {
  return e && e.__esModule ? e.default : e;
}
function JD(e) {
  let { color: t, colorName: n } = e, r = t || "#fff0", a = K(() => typeof r == "string" ? Ze(r) : r, [
    r
  ]), { locale: l } = de(), i = J(e, {
    labelable: !0
  }), u = Ee(XD(Wu), "@react-aria/color"), o = ce(e.id);
  return n || (n = a.getChannelValue("alpha") === 0 ? u.format("transparent") : a.getColorName(l)), {
    colorSwatchProps: {
      ...i,
      role: "img",
      "aria-roledescription": u.format("colorSwatch"),
      "aria-label": [
        n,
        e["aria-label"] || ""
      ].filter(Boolean).join(", "),
      "aria-labelledby": e["aria-labelledby"] ? `${o} ${e["aria-labelledby"]}` : void 0,
      id: o,
      style: {
        backgroundColor: a.toString("css"),
        // @ts-ignore
        forcedColorAdjust: "none"
      }
    },
    color: a || null
  };
}
const Xu = /* @__PURE__ */ G(null), mC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Xu);
  let { colorSwatchProps: r, color: a } = JD(t), l = le({
    ...t,
    defaultClassName: "react-aria-ColorSwatch",
    defaultStyle: r.style,
    values: {
      color: a
    }
  }), i = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(i, r, l),
    slot: t.slot || void 0,
    ref: n
  });
});
var Qm = {};
Qm = {
  colorSwatchPicker: "تغييرات الألوان",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "حدد عنصرًا",
  tableResizer: "أداة تغيير الحجم"
};
var eb = {};
eb = {
  colorSwatchPicker: "Цветови мостри",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Изберете предмет",
  tableResizer: "Преоразмерител"
};
var tb = {};
tb = {
  colorSwatchPicker: "Vzorky barev",
  dropzoneLabel: "Místo pro přetažení",
  selectPlaceholder: "Vyberte položku",
  tableResizer: "Změna velikosti"
};
var nb = {};
nb = {
  colorSwatchPicker: "Farveprøver",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Vælg et element",
  tableResizer: "Størrelsesændring"
};
var rb = {};
rb = {
  colorSwatchPicker: "Farbfelder",
  dropzoneLabel: "Ablegebereich",
  selectPlaceholder: "Element wählen",
  tableResizer: "Größenanpassung"
};
var ab = {};
ab = {
  colorSwatchPicker: "Χρωματικά δείγματα",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Επιλέξτε ένα αντικείμενο",
  tableResizer: "Αλλαγή μεγέθους"
};
var lb = {};
lb = {
  selectPlaceholder: "Select an item",
  tableResizer: "Resizer",
  dropzoneLabel: "DropZone",
  colorSwatchPicker: "Color swatches"
};
var ib = {};
ib = {
  colorSwatchPicker: "Muestras de colores",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Seleccionar un artículo",
  tableResizer: "Cambiador de tamaño"
};
var ub = {};
ub = {
  colorSwatchPicker: "Värvinäidised",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Valige üksus",
  tableResizer: "Suuruse muutja"
};
var ob = {};
ob = {
  colorSwatchPicker: "Värimallit",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Valitse kohde",
  tableResizer: "Koon muuttaja"
};
var sb = {};
sb = {
  colorSwatchPicker: "Échantillons de couleurs",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Sélectionner un élément",
  tableResizer: "Redimensionneur"
};
var db = {};
db = {
  colorSwatchPicker: "דוגמיות צבע",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "בחר פריט",
  tableResizer: "שינוי גודל"
};
var cb = {};
cb = {
  colorSwatchPicker: "Uzorci boja",
  dropzoneLabel: "Zona spuštanja",
  selectPlaceholder: "Odaberite stavku",
  tableResizer: "Promjena veličine"
};
var fb = {};
fb = {
  colorSwatchPicker: "Színtárak",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Válasszon ki egy elemet",
  tableResizer: "Átméretező"
};
var hb = {};
hb = {
  colorSwatchPicker: "Campioni di colore",
  dropzoneLabel: "Zona di rilascio",
  selectPlaceholder: "Seleziona un elemento",
  tableResizer: "Ridimensionamento"
};
var mb = {};
mb = {
  colorSwatchPicker: "カラースウォッチ",
  dropzoneLabel: "ドロップゾーン",
  selectPlaceholder: "項目を選択",
  tableResizer: "サイズ変更ツール"
};
var bb = {};
bb = {
  colorSwatchPicker: "색상 견본",
  dropzoneLabel: "드롭 영역",
  selectPlaceholder: "항목 선택",
  tableResizer: "크기 조정기"
};
var pb = {};
pb = {
  colorSwatchPicker: "Spalvų pavyzdžiai",
  dropzoneLabel: "„DropZone“",
  selectPlaceholder: "Pasirinkite elementą",
  tableResizer: "Dydžio keitiklis"
};
var gb = {};
gb = {
  colorSwatchPicker: "Krāsu paraugi",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izvēlēties vienumu",
  tableResizer: "Izmēra mainītājs"
};
var yb = {};
yb = {
  colorSwatchPicker: "Fargekart",
  dropzoneLabel: "Droppsone",
  selectPlaceholder: "Velg et element",
  tableResizer: "Størrelsesendrer"
};
var $b = {};
$b = {
  colorSwatchPicker: "kleurstalen",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecteer een item",
  tableResizer: "Resizer"
};
var vb = {};
vb = {
  colorSwatchPicker: "Próbki kolorów",
  dropzoneLabel: "Strefa upuszczania",
  selectPlaceholder: "Wybierz element",
  tableResizer: "Zmiana rozmiaru"
};
var Db = {};
Db = {
  colorSwatchPicker: "Amostras de cores",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecione um item",
  tableResizer: "Redimensionador"
};
var xb = {};
xb = {
  colorSwatchPicker: "Amostras de cores",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecione um item",
  tableResizer: "Redimensionador"
};
var Eb = {};
Eb = {
  colorSwatchPicker: "Specimene de culoare",
  dropzoneLabel: "Zonă de plasare",
  selectPlaceholder: "Selectați un element",
  tableResizer: "Instrument de redimensionare"
};
var Cb = {};
Cb = {
  colorSwatchPicker: "Цветовые образцы",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Выберите элемент",
  tableResizer: "Средство изменения размера"
};
var Pb = {};
Pb = {
  colorSwatchPicker: "Vzorkovníky farieb",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Vyberte položku",
  tableResizer: "Nástroj na zmenu veľkosti"
};
var wb = {};
wb = {
  colorSwatchPicker: "Barvne palete",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izberite element",
  tableResizer: "Spreminjanje velikosti"
};
var Sb = {};
Sb = {
  colorSwatchPicker: "Uzorci boje",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izaberite stavku",
  tableResizer: "Promena veličine"
};
var kb = {};
kb = {
  colorSwatchPicker: "Färgrutor",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Välj en artikel",
  tableResizer: "Storleksändrare"
};
var Bb = {};
Bb = {
  colorSwatchPicker: "Renk örnekleri",
  dropzoneLabel: "Bırakma Bölgesi",
  selectPlaceholder: "Bir öğe seçin",
  tableResizer: "Yeniden boyutlandırıcı"
};
var Fb = {};
Fb = {
  colorSwatchPicker: "Зразки кольорів",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Виберіть елемент",
  tableResizer: "Засіб змінення розміру"
};
var Ab = {};
Ab = {
  colorSwatchPicker: "颜色色板",
  dropzoneLabel: "放置区域",
  selectPlaceholder: "选择一个项目",
  tableResizer: "尺寸调整器"
};
var Rb = {};
Rb = {
  colorSwatchPicker: "色票",
  dropzoneLabel: "放置區",
  selectPlaceholder: "選取項目",
  tableResizer: "大小調整器"
};
var Ju = {};
Ju = {
  "ar-AE": Qm,
  "bg-BG": eb,
  "cs-CZ": tb,
  "da-DK": nb,
  "de-DE": rb,
  "el-GR": ab,
  "en-US": lb,
  "es-ES": ib,
  "et-EE": ub,
  "fi-FI": ob,
  "fr-FR": sb,
  "he-IL": db,
  "hr-HR": cb,
  "hu-HU": fb,
  "it-IT": hb,
  "ja-JP": mb,
  "ko-KR": bb,
  "lt-LT": pb,
  "lv-LV": gb,
  "nb-NO": yb,
  "nl-NL": $b,
  "pl-PL": vb,
  "pt-BR": Db,
  "pt-PT": xb,
  "ro-RO": Eb,
  "ru-RU": Cb,
  "sk-SK": Pb,
  "sl-SI": wb,
  "sr-SP": Sb,
  "sv-SE": kb,
  "tr-TR": Bb,
  "uk-UA": Fb,
  "zh-CN": Ab,
  "zh-TW": Rb
};
const zt = /* @__PURE__ */ G({}), Qu = /* @__PURE__ */ G(null), QD = /* @__PURE__ */ te(function(t, n) {
  let { render: r } = O(Qu);
  return /* @__PURE__ */ g.createElement(g.Fragment, null, r(t, n));
});
function eo(e, t) {
  let n = e?.renderDropIndicator, r = e?.isVirtualDragging?.(), a = X(
    (l) => {
      if (r || t?.isDropTarget(l)) return n ? n(l) : /* @__PURE__ */ g.createElement(QD, {
        target: l
      });
    },
    // We invalidate whenever the target changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t?.target,
      r,
      n
    ]
  );
  return e?.useDropIndicator ? a : void 0;
}
function Tb(e, t, n) {
  let r = e.focusedKey, a = null;
  if (t?.isVirtualDragging?.() && n?.target?.type === "item" && (a = n.target.key, n.target.dropPosition === "after")) {
    let l = n.collection.getKeyAfter(a), i = null;
    if (l != null) {
      let u = n.collection.getItem(a)?.level ?? 0;
      for (; l != null; ) {
        let o = n.collection.getItem(l);
        if (!o) break;
        if (o.type !== "item") {
          l = n.collection.getKeyAfter(l);
          continue;
        }
        if ((o.level ?? 0) <= u) break;
        i = l, l = n.collection.getKeyAfter(l);
      }
    }
    a = l ?? i ?? a;
  }
  return K(() => new Set([
    r,
    a
  ].filter((l) => l != null)), [
    r,
    a
  ]);
}
const to = /* @__PURE__ */ G({}), bC = /* @__PURE__ */ St(Ci, function(t, n) {
  return [t, n] = oe(t, n, to), /* @__PURE__ */ g.createElement(Q.header, {
    className: "react-aria-Header",
    ...t,
    ref: n
  }, t.children);
}), Ib = /* @__PURE__ */ G(null);
function Wn(e) {
  let t = T({});
  return /* @__PURE__ */ g.createElement(Ib.Provider, {
    value: t
  }, e.children);
}
const ex = /* @__PURE__ */ te(function(t, n) {
  let { name: r, isVisible: a = !0, children: l, className: i, style: u, render: o, ...d } = t, [s, c] = Y(a ? "visible" : "hidden"), f = O(Ib);
  if (!f) throw new Error("<SharedElement> must be rendered inside a <SharedElementTransition>");
  a && s === "hidden" && c("visible"), n = $e(n), ue(() => {
    let m = n.current, b = f.current, p = b[r], y = null;
    if (m && a && p) {
      c("visible");
      let $ = m.getAnimations(), v = p.style.map(([x, E]) => {
        let P = m.style[x];
        if (x === "translate") {
          let C = p.rect, M = m.getBoundingClientRect(), F = C.left - M?.left, V = C.top - M?.top;
          m.style.translate = `${F}px ${V}px`;
        } else m.style[x] = E;
        return [
          x,
          P
        ];
      });
      for (let x of m.getAnimations()) $.includes(x) || x.cancel();
      y = requestAnimationFrame(() => {
        y = null;
        for (let [x, E] of v) m.style[x] = E;
      }), delete b[r];
    } else m && a && !p ? (queueMicrotask(() => lt(() => c("entering"))), y = requestAnimationFrame(() => {
      y = null, c("visible");
    })) : m && !a && queueMicrotask(() => {
      b[r] ? (delete b[r], lt(() => c("exiting")), Promise.all(m.getAnimations().map(($) => $.finished)).then(() => c("hidden")).catch(() => {
      })) : c("hidden");
    });
    return () => {
      if (y != null && cancelAnimationFrame(y), m && m.isConnected && !m.hasAttribute("data-exiting")) {
        let $ = window.getComputedStyle(m);
        if ($.transitionProperty !== "none") {
          let v = $.transitionProperty.split(/\s*,\s*/);
          b[r] = {
            rect: m.getBoundingClientRect(),
            style: v.map((x) => [
              x,
              $[x]
            ])
          };
        }
      }
    };
  }, [
    n,
    f,
    r,
    a
  ]);
  let h = le({
    children: l,
    className: i,
    style: u,
    render: o,
    values: {
      isEntering: s === "entering",
      isExiting: s === "exiting"
    }
  });
  return s === "hidden" ? null : /* @__PURE__ */ g.createElement(Q.div, {
    ...d,
    ...h,
    ref: n,
    "data-entering": s === "entering" || void 0,
    "data-exiting": s === "exiting" || void 0
  });
}), Gn = /* @__PURE__ */ G({
  isSelected: !1
}), pC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Gn);
  let { isSelected: r, ...a } = t;
  return /* @__PURE__ */ g.createElement(ex, {
    ...a,
    ref: n,
    className: t.className || "react-aria-SelectionIndicator",
    name: "SelectionIndicator",
    isVisible: r
  });
});
function tx(e) {
  let t = J(e, {
    labelable: !0
  }), n;
  return e.orientation === "vertical" && (n = "vertical"), e.elementType !== "hr" ? {
    separatorProps: {
      ...t,
      role: "separator",
      "aria-orientation": n
    }
  } : {
    separatorProps: t
  };
}
const no = /* @__PURE__ */ G({}), To = class To extends dt {
  filter(t, n) {
    let r = n.getItem(this.prevKey);
    if (r && r.type !== "separator") {
      let a = this.clone();
      return n.addDescendants(a, t), a;
    }
    return null;
  }
};
To.type = "separator";
let Gi = To;
const gC = /* @__PURE__ */ St(Gi, function(t, n) {
  [t, n] = oe(t, n, no);
  let { elementType: r, orientation: a, style: l, className: i, slot: u, ...o } = t, d = r || "hr";
  d === "hr" && a === "vertical" && (d = "div");
  let s = Q[d], { separatorProps: c } = tx({
    ...o,
    elementType: r,
    orientation: a
  }), f = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(s, {
    render: t.render,
    ...z(f, c),
    style: l,
    className: i ?? "react-aria-Separator",
    ref: n,
    slot: u || void 0
  });
}), ro = /* @__PURE__ */ new WeakMap();
function nx(e) {
  return typeof e == "string" ? e.replace(/\s*/g, "") : "" + e;
}
function rx(e, t) {
  let n = ro.get(e);
  if (!n) throw new Error("Unknown list");
  return `${n.id}-option-${nx(t)}`;
}
class ax {
  constructor(t, n, r, a) {
    this._walkerStack = [], this._currentSetFor = /* @__PURE__ */ new Set(), this._acceptNode = (i) => {
      if (i.nodeType === Node.ELEMENT_NODE) {
        const u = i.shadowRoot;
        if (u) {
          const o = this._doc.createTreeWalker(u, this.whatToShow, {
            acceptNode: this._acceptNode
          });
          return this._walkerStack.unshift(o), NodeFilter.FILTER_ACCEPT;
        } else {
          if (typeof this.filter == "function") return this.filter(i);
          if (this.filter?.acceptNode) return this.filter.acceptNode(i);
          if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
        }
      }
      return NodeFilter.FILTER_SKIP;
    }, this._doc = t, this.root = n, this.filter = a ?? null, this.whatToShow = r ?? NodeFilter.SHOW_ALL, this._currentNode = n, this._walkerStack.unshift(t.createTreeWalker(n, r, this._acceptNode));
    const l = n.shadowRoot;
    if (l) {
      const i = this._doc.createTreeWalker(l, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      this._walkerStack.unshift(i);
    }
  }
  get currentNode() {
    return this._currentNode;
  }
  set currentNode(t) {
    if (!ae(this.root, t)) throw new Error("Cannot set currentNode to a node that is not contained by the root node.");
    const n = [];
    let r = t, a = t;
    for (this._currentNode = t; r && r !== this.root; ) if (r.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      const i = r, u = this._doc.createTreeWalker(i, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      n.push(u), u.currentNode = a, this._currentSetFor.add(u), r = a = i.host;
    } else r = r.parentNode;
    const l = this._doc.createTreeWalker(this.root, this.whatToShow, {
      acceptNode: this._acceptNode
    });
    n.push(l), l.currentNode = a, this._currentSetFor.add(l), this._walkerStack = n;
  }
  get doc() {
    return this._doc;
  }
  firstChild() {
    let t = this.currentNode, n = this.nextNode();
    return ae(t, n) ? (n && (this.currentNode = n), n) : (this.currentNode = t, null);
  }
  lastChild() {
    let n = this._walkerStack[0].lastChild();
    return n && (this.currentNode = n), n;
  }
  nextNode() {
    const t = this._walkerStack[0].nextNode();
    if (t) {
      if (t.shadowRoot) {
        let r;
        if (typeof this.filter == "function" ? r = this.filter(t) : this.filter?.acceptNode && (r = this.filter.acceptNode(t)), r === NodeFilter.FILTER_ACCEPT)
          return this.currentNode = t, t;
        let a = this.nextNode();
        return a && (this.currentNode = a), a;
      }
      return t && (this.currentNode = t), t;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let n = this.nextNode();
      return n && (this.currentNode = n), n;
    } else return null;
  }
  previousNode() {
    const t = this._walkerStack[0];
    if (t.currentNode === t.root) {
      if (this._currentSetFor.has(t))
        if (this._currentSetFor.delete(t), this._walkerStack.length > 1) {
          this._walkerStack.shift();
          let r = this.previousNode();
          return r && (this.currentNode = r), r;
        } else return null;
      return null;
    }
    const n = t.previousNode();
    if (n) {
      if (n.shadowRoot) {
        let a;
        if (typeof this.filter == "function" ? a = this.filter(n) : this.filter?.acceptNode && (a = this.filter.acceptNode(n)), a === NodeFilter.FILTER_ACCEPT)
          return n && (this.currentNode = n), n;
        let l = this.lastChild();
        return l && (this.currentNode = l), l;
      }
      return n && (this.currentNode = n), n;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let r = this.previousNode();
      return r && (this.currentNode = r), r;
    } else return null;
  }
  /**
  * @deprecated
  */
  nextSibling() {
    return null;
  }
  /**
  * @deprecated
  */
  previousSibling() {
    return null;
  }
  /**
  * @deprecated
  */
  parentNode() {
    return null;
  }
}
function Mb(e, t, n, r) {
  return _t() ? new ax(e, t, n, r) : e.createTreeWalker(t, n, r);
}
const Zs = /* @__PURE__ */ g.createContext(null), qi = "react-aria-focus-scope-restore";
let Pe = null;
function Bl(e) {
  let { children: t, contain: n, restoreFocus: r, autoFocus: a } = e, l = T(null), i = T(null), u = T([]), { parentNode: o } = O(Zs) || {}, d = K(() => new Zi({
    scopeRef: u
  }), [
    u
  ]);
  ue(() => {
    let f = o || Me.root;
    if (Me.getTreeNode(f.scopeRef) && Pe && !cl(Pe, f.scopeRef)) {
      let h = Me.getTreeNode(Pe);
      h && (f = h);
    }
    f.addChild(d), Me.addNode(d);
  }, [
    d,
    o
  ]), ue(() => {
    let f = Me.getTreeNode(u);
    f && (f.contain = !!n);
  }, [
    n
  ]), ue(() => {
    let f = l.current?.nextSibling, h = [], m = (b) => b.stopPropagation();
    for (; f && f !== i.current; )
      h.push(f), f.addEventListener(qi, m), f = f.nextSibling;
    return u.current = h, () => {
      for (let b of h) b.removeEventListener(qi, m);
    };
  }, [
    t
  ]), cx(u, r, n), ox(u, n), fx(u, r, n), dx(u, a), ee(() => {
    const f = se(he(u.current ? u.current[0] : void 0));
    let h = null;
    if (ot(f, u.current)) {
      for (let m of Me.traverse()) m.scopeRef && ot(f, m.scopeRef.current) && (h = m);
      h === Me.getTreeNode(u) && (Pe = h.scopeRef);
    }
  }, [
    u
  ]), ue(() => () => {
    let f = Me.getTreeNode(u)?.parent?.scopeRef ?? null;
    (u === Pe || cl(u, Pe)) && (!f || Me.getTreeNode(f)) && (Pe = f), Me.removeTreeNode(u);
  }, [
    u
  ]);
  let s = K(() => lx(u), []), c = K(() => ({
    focusManager: s,
    parentNode: d
  }), [
    d,
    s
  ]);
  return /* @__PURE__ */ g.createElement(Zs.Provider, {
    value: c
  }, /* @__PURE__ */ g.createElement("span", {
    "data-focus-scope-start": !0,
    hidden: !0,
    ref: l
  }), t, /* @__PURE__ */ g.createElement("span", {
    "data-focus-scope-end": !0,
    hidden: !0,
    ref: i
  }));
}
function lx(e) {
  return {
    focusNext(t = {}) {
      let n = e.current, { from: r, tabbable: a, wrap: l, accept: i } = t, u = r || se(he(n[0] ?? void 0)), o = n[0].previousElementSibling, d = Mn(n), s = Ie(d, {
        tabbable: a,
        accept: i
      }, n);
      s.currentNode = ot(u, n) ? u : o;
      let c = s.nextNode();
      return !c && l && (s.currentNode = o, c = s.nextNode()), c && Ye(c, !0), c;
    },
    focusPrevious(t = {}) {
      let n = e.current, { from: r, tabbable: a, wrap: l, accept: i } = t, u = r || se(he(n[0] ?? void 0)), o = n[n.length - 1].nextElementSibling, d = Mn(n), s = Ie(d, {
        tabbable: a,
        accept: i
      }, n);
      s.currentNode = ot(u, n) ? u : o;
      let c = s.previousNode();
      return !c && l && (s.currentNode = o, c = s.previousNode()), c && Ye(c, !0), c;
    },
    focusFirst(t = {}) {
      let n = e.current, { tabbable: r, accept: a } = t, l = Mn(n), i = Ie(l, {
        tabbable: r,
        accept: a
      }, n);
      i.currentNode = n[0].previousElementSibling;
      let u = i.nextNode();
      return u && Ye(u, !0), u;
    },
    focusLast(t = {}) {
      let n = e.current, { tabbable: r, accept: a } = t, l = Mn(n), i = Ie(l, {
        tabbable: r,
        accept: a
      }, n);
      i.currentNode = n[n.length - 1].nextElementSibling;
      let u = i.previousNode();
      return u && Ye(u, !0), u;
    }
  };
}
function Mn(e) {
  return e[0].parentElement;
}
function Hr(e) {
  let t = Me.getTreeNode(Pe);
  for (; t && t.scopeRef !== e; ) {
    if (t.contain) return !1;
    t = t.parent;
  }
  return !0;
}
function ix(e) {
  if (!e.form)
    return Array.from(he(e).querySelectorAll(`input[type="radio"][name="${CSS.escape(e.name)}"]`)).filter((r) => !r.form);
  const t = e.form.elements.namedItem(e.name);
  let n = Be(e);
  return t instanceof n.RadioNodeList ? Array.from(t).filter((r) => r instanceof n.HTMLInputElement) : t instanceof n.HTMLInputElement ? [
    t
  ] : [];
}
function ux(e) {
  if (e.checked) return !0;
  const t = ix(e);
  return t.length > 0 && !t.some((n) => n.checked);
}
function ox(e, t) {
  let n = T(void 0), r = T(void 0);
  ue(() => {
    let a = e.current;
    if (!t) {
      r.current && (cancelAnimationFrame(r.current), r.current = void 0);
      return;
    }
    const l = he(a ? a[0] : void 0);
    let i = (d) => {
      if (d.key !== "Tab" || d.altKey || d.ctrlKey || d.metaKey || !Hr(e) || d.isComposing) return;
      let s = se(l), c = e.current;
      if (!c || !ot(s, c)) return;
      let f = Mn(c), h = Ie(f, {
        tabbable: !0
      }, c);
      if (!s) return;
      h.currentNode = s;
      let m = d.shiftKey ? h.previousNode() : h.nextNode();
      m || (h.currentNode = d.shiftKey ? c[c.length - 1].nextElementSibling : c[0].previousElementSibling, m = d.shiftKey ? h.previousNode() : h.nextNode()), d.preventDefault(), m && (Ye(m, !0), m instanceof Be(m).HTMLInputElement && m.select());
    }, u = (d) => {
      (!Pe || cl(Pe, e)) && ot(W(d), e.current) ? (Pe = e, n.current = W(d)) : Hr(e) && !hn(W(d), e) ? n.current ? n.current.focus() : Pe && Pe.current && Yi(Pe.current) : Hr(e) && (n.current = W(d));
    }, o = (d) => {
      r.current && cancelAnimationFrame(r.current), r.current = requestAnimationFrame(() => {
        let s = vt(), c = (s === "virtual" || s === null) && bn() && Xd(), f = se(l);
        if (!c && f && Hr(e) && !hn(f, e)) {
          Pe = e;
          let h = W(d);
          h && h.isConnected ? (n.current = h, n.current?.focus()) : Pe.current && Yi(Pe.current);
        }
      });
    };
    return l.addEventListener("keydown", i, !1), l.addEventListener("focusin", u, !1), a?.forEach((d) => d.addEventListener("focusin", u, !1)), a?.forEach((d) => d.addEventListener("focusout", o, !1)), () => {
      l.removeEventListener("keydown", i, !1), l.removeEventListener("focusin", u, !1), a?.forEach((d) => d.removeEventListener("focusin", u, !1)), a?.forEach((d) => d.removeEventListener("focusout", o, !1));
    };
  }, [
    e,
    t
  ]), ue(() => () => {
    r.current && cancelAnimationFrame(r.current);
  }, [
    r
  ]);
}
function Kb(e) {
  return hn(e);
}
function ot(e, t) {
  return !e || !t ? !1 : t.some((n) => ae(n, e));
}
function hn(e, t = null) {
  if (e instanceof Element && e.closest("[data-react-aria-top-layer]")) return !0;
  for (let { scopeRef: n } of Me.traverse(Me.getTreeNode(t)))
    if (n && ot(e, n.current)) return !0;
  return !1;
}
function sx(e) {
  return hn(e, Pe);
}
function cl(e, t) {
  let n = Me.getTreeNode(t)?.parent;
  for (; n; ) {
    if (n.scopeRef === e) return !0;
    n = n.parent;
  }
  return !1;
}
function Ye(e, t = !1) {
  if (e != null && !t) try {
    Se(e);
  } catch {
  }
  else if (e != null) try {
    e.focus();
  } catch {
  }
}
function Nb(e, t = !0) {
  let n = e[0].previousElementSibling, r = Mn(e), a = Ie(r, {
    tabbable: t
  }, e);
  a.currentNode = n;
  let l = a.nextNode();
  return t && !l && (r = Mn(e), a = Ie(r, {
    tabbable: !1
  }, e), a.currentNode = n, l = a.nextNode()), l;
}
function Yi(e, t = !0) {
  Ye(Nb(e, t));
}
function dx(e, t) {
  const n = g.useRef(t);
  ee(() => {
    if (n.current) {
      Pe = e;
      const r = he(e.current ? e.current[0] : void 0);
      !ot(se(r), Pe.current) && e.current && Yi(e.current);
    }
    n.current = !1;
  }, [
    e
  ]);
}
function cx(e, t, n) {
  ue(() => {
    if (t || n) return;
    let r = e.current;
    const a = he(r ? r[0] : void 0);
    let l = (i) => {
      let u = W(i);
      ot(u, e.current) ? Pe = e : Kb(u) || (Pe = null);
    };
    return a.addEventListener("focusin", l, !1), r?.forEach((i) => i.addEventListener("focusin", l, !1)), () => {
      a.removeEventListener("focusin", l, !1), r?.forEach((i) => i.removeEventListener("focusin", l, !1));
    };
  }, [
    e,
    t,
    n
  ]);
}
function Xs(e) {
  let t = Me.getTreeNode(Pe);
  for (; t && t.scopeRef !== e; ) {
    if (t.nodeToRestore) return !1;
    t = t.parent;
  }
  return t?.scopeRef === e;
}
function fx(e, t, n) {
  const r = T(typeof document < "u" ? se(he(e.current ? e.current[0] : void 0)) : null);
  ue(() => {
    let a = e.current;
    const l = he(a ? a[0] : void 0);
    if (!t || n) return;
    let i = () => {
      (!Pe || cl(Pe, e)) && ot(se(l), e.current) && (Pe = e);
    };
    return l.addEventListener("focusin", i, !1), a?.forEach((u) => u.addEventListener("focusin", i, !1)), () => {
      l.removeEventListener("focusin", i, !1), a?.forEach((u) => u.removeEventListener("focusin", i, !1));
    };
  }, [
    e,
    n
  ]), ue(() => {
    const a = he(e.current ? e.current[0] : void 0);
    if (!t) return;
    let l = (i) => {
      if (i.key !== "Tab" || i.altKey || i.ctrlKey || i.metaKey || !Hr(e) || i.isComposing) return;
      let u = a.activeElement;
      if (!hn(u, e) || !Xs(e)) return;
      let o = Me.getTreeNode(e);
      if (!o) return;
      let d = o.nodeToRestore, s = Ie(a.body, {
        tabbable: !0
      });
      s.currentNode = u;
      let c = i.shiftKey ? s.previousNode() : s.nextNode();
      if ((!d || !d.isConnected || d === a.body) && (d = void 0, o.nodeToRestore = void 0), (!c || !hn(c, e)) && d) {
        s.currentNode = d;
        do
          c = i.shiftKey ? s.previousNode() : s.nextNode();
        while (hn(c, e));
        i.preventDefault(), i.stopPropagation(), c ? Ye(c, !0) : Kb(d) ? Ye(d, !0) : u.blur();
      }
    };
    return n || a.addEventListener("keydown", l, !0), () => {
      n || a.removeEventListener("keydown", l, !0);
    };
  }, [
    e,
    t,
    n
  ]), ue(() => {
    const a = he(e.current ? e.current[0] : void 0);
    if (!t) return;
    let l = Me.getTreeNode(e);
    if (l)
      return l.nodeToRestore = r.current ?? void 0, () => {
        let i = Me.getTreeNode(e);
        if (!i) return;
        let u = i.nodeToRestore, o = se(a);
        if (t && u && (o && hn(o, e) || o === a.body && Xs(e))) {
          let d = Me.clone();
          requestAnimationFrame(() => {
            if (a.activeElement === a.body) {
              let s = d.getTreeNode(e);
              for (; s; ) {
                if (s.nodeToRestore && s.nodeToRestore.isConnected) {
                  Js(s.nodeToRestore);
                  return;
                }
                s = s.parent;
              }
              for (s = d.getTreeNode(e); s; ) {
                if (s.scopeRef && // TODO: this is probably a false positive based on naming, it's not a real ref, rename.
                // oxlint-disable-next-line react-hooks/exhaustive-deps
                s.scopeRef.current && Me.getTreeNode(s.scopeRef)) {
                  let c = Nb(s.scopeRef.current, !0);
                  Js(c);
                  return;
                }
                s = s.parent;
              }
            }
          });
        }
      };
  }, [
    e,
    t
  ]);
}
function Js(e) {
  e.dispatchEvent(new CustomEvent(qi, {
    bubbles: !0,
    cancelable: !0
  })) && Ye(e);
}
function Ie(e, t, n) {
  let r = t?.tabbable ? Ga : pu, a = e?.nodeType === Node.ELEMENT_NODE ? e : null, l = he(a), i = Mb(l, e || l, NodeFilter.SHOW_ELEMENT, {
    acceptNode(u) {
      return ae(t?.from, u) || t?.tabbable && u.tagName === "INPUT" && u.getAttribute("type") === "radio" && (!ux(u) || i.currentNode.tagName === "INPUT" && i.currentNode.type === "radio" && i.currentNode.name === u.name) ? NodeFilter.FILTER_REJECT : r(u) && (!n || ot(u, n)) && (!t?.accept || t.accept(u)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return t?.from && (i.currentNode = t.from), i;
}
function Fl(e, t = {}) {
  return {
    focusNext(n = {}) {
      let r = e.current;
      if (!r) return null;
      let { from: a, tabbable: l = t.tabbable, wrap: i = t.wrap, accept: u = t.accept } = n, o = a || se(he(r)), d = Ie(r, {
        tabbable: l,
        accept: u
      });
      ae(r, o) && (d.currentNode = o);
      let s = d.nextNode();
      return !s && i && (d.currentNode = r, s = d.nextNode()), s && Ye(s, !0), s;
    },
    focusPrevious(n = t) {
      let r = e.current;
      if (!r) return null;
      let { from: a, tabbable: l = t.tabbable, wrap: i = t.wrap, accept: u = t.accept } = n, o = a || se(he(r)), d = Ie(r, {
        tabbable: l,
        accept: u
      });
      if (ae(r, o)) d.currentNode = o;
      else {
        let c = oi(d);
        return c && Ye(c, !0), c ?? null;
      }
      let s = d.previousNode();
      if (!s && i) {
        d.currentNode = r;
        let c = oi(d);
        if (!c)
          return null;
        s = c;
      }
      return s && Ye(s, !0), s ?? null;
    },
    focusFirst(n = t) {
      let r = e.current;
      if (!r) return null;
      let { tabbable: a = t.tabbable, accept: l = t.accept } = n, u = Ie(r, {
        tabbable: a,
        accept: l
      }).nextNode();
      return u && Ye(u, !0), u;
    },
    focusLast(n = t) {
      let r = e.current;
      if (!r) return null;
      let { tabbable: a = t.tabbable, accept: l = t.accept } = n, i = Ie(r, {
        tabbable: a,
        accept: l
      }), u = oi(i);
      return u && Ye(u, !0), u ?? null;
    }
  };
}
function oi(e) {
  let t, n;
  do
    n = e.lastChild(), n && (t = n);
  while (n);
  return t;
}
class ao {
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new Zi({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(t) {
    return this.fastMap.get(t);
  }
  addTreeNode(t, n, r) {
    let a = this.fastMap.get(n ?? null);
    if (!a) return;
    let l = new Zi({
      scopeRef: t
    });
    a.addChild(l), l.parent = a, this.fastMap.set(t, l), r && (l.nodeToRestore = r);
  }
  addNode(t) {
    this.fastMap.set(t.scopeRef, t);
  }
  removeTreeNode(t) {
    if (t === null) return;
    let n = this.fastMap.get(t);
    if (!n) return;
    let r = n.parent;
    for (let l of this.traverse()) l !== n && n.nodeToRestore && l.nodeToRestore && n.scopeRef && n.scopeRef.current && ot(l.nodeToRestore, n.scopeRef.current) && (l.nodeToRestore = n.nodeToRestore);
    let a = n.children;
    r && (r.removeChild(n), a.size > 0 && a.forEach((l) => r && r.addChild(l))), this.fastMap.delete(n.scopeRef);
  }
  // Pre Order Depth First
  *traverse(t = this.root) {
    if (t.scopeRef != null && (yield t), t.children.size > 0) for (let n of t.children) yield* this.traverse(n);
  }
  clone() {
    let t = new ao();
    for (let n of this.traverse()) t.addTreeNode(n.scopeRef, n.parent?.scopeRef ?? null, n.nodeToRestore);
    return t;
  }
}
class Zi {
  constructor(t) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = t.scopeRef;
  }
  addChild(t) {
    this.children.add(t), t.parent = this;
  }
  removeChild(t) {
    this.children.delete(t), t.parent = void 0;
  }
}
let Me = new ao();
function Xi(e) {
  return g5() ? e.altKey : e.ctrlKey;
}
function Kn(e, t) {
  let n = `[data-key="${CSS.escape(String(t))}"]`, r = e.current?.dataset.collection;
  return r && (n = `[data-collection="${CSS.escape(r)}"]${n}`), e.current?.querySelector(n);
}
const Vb = /* @__PURE__ */ new WeakMap();
function hx(e) {
  let t = ce();
  return Vb.set(e, t), t;
}
function mx(e) {
  return Vb.get(e);
}
const Qs = 1e3;
function Lb(e) {
  let { keyboardDelegate: t, selectionManager: n, onTypeSelect: r } = e, a = T({
    search: "",
    timeout: void 0
  }), l = (u) => {
    if (a.current.search.length > 0 && u.key === " ") {
      if (u.preventDefault(), (!("continuePropagation" in u) || "continuePropagation" in u && !u.isPropagationStopped()) && u.stopPropagation(), a.current.search += " ", t.getKeyForSearch != null) {
        let o = t.getKeyForSearch(a.current.search, n.focusedKey);
        o == null && (o = t.getKeyForSearch(a.current.search)), o != null && (n.setFocusedKey(o), r && r(o));
      }
      clearTimeout(a.current.timeout), a.current.timeout = setTimeout(() => {
        a.current.search = "";
      }, Qs);
    }
  }, i = (u) => {
    let o = bx(u.key);
    if (!(!o || u.ctrlKey || u.metaKey || u.altKey || !ae(u.currentTarget, W(u)) || a.current.search.length === 0 && o === " ")) {
      if (a.current.search += o, t.getKeyForSearch != null) {
        let d = t.getKeyForSearch(a.current.search, n.focusedKey);
        if (d == null && (d = t.getKeyForSearch(a.current.search)), d != null)
          n.setFocusedKey(d), r && r(d), u.preventDefault(), "continuePropagation" in u || u.stopPropagation();
        else {
          a.current.search = "", clearTimeout(a.current.timeout), a.current.timeout = void 0;
          return;
        }
      }
      clearTimeout(a.current.timeout), a.current.timeout = setTimeout(() => {
        a.current.search = "";
      }, Qs);
    }
  };
  return ee(() => {
    let u = a.current.timeout;
    return () => {
      clearTimeout(u);
    };
  }, [
    a
  ]), {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: t.getKeyForSearch ? l : void 0,
      onKeyDown: t.getKeyForSearch ? i : void 0
    }
  };
}
function bx(e) {
  return e.length === 1 || !/^[A-Z]/i.test(e) ? e : "";
}
function ed(e, t) {
  const n = T(!0), r = T(null);
  ue(() => (n.current = !0, () => {
    n.current = !1;
  }), []), ue(() => {
    n.current ? n.current = !1 : (!r.current || t.some((a, l) => !Object.is(a, r[l]))) && e(), r.current = t;
  }, t);
}
function lo(e) {
  let { selectionManager: t, keyboardDelegate: n, ref: r, autoFocus: a = !1, shouldFocusWrap: l = !1, disallowEmptySelection: i = !1, disallowSelectAll: u = !1, escapeKeyBehavior: o = "clearSelection", selectOnFocus: d = t.selectionBehavior === "replace", disallowTypeAhead: s = !1, shouldUseVirtualFocus: c, allowsTabNavigation: f = !1, scrollRef: h = r, linkBehavior: m = "action", UNSTABLE_focusOnEntry: b } = e, { direction: p } = de(), y = xr(), $ = (w) => {
    if (w.altKey && w.key === "Tab" && w.preventDefault(), !r.current || !ae(r.current, W(w))) return;
    const R = (H, k) => {
      if (H != null) {
        if (t.isLink(H) && m === "selection" && d && !Xi(w)) {
          lt(() => {
            t.setFocusedKey(H, k);
          });
          let S = Kn(r, H), j = t.getItemProps(H);
          S && y.open(S, w, j.href, j.routerOptions);
          return;
        }
        if (t.setFocusedKey(H, k), t.isLink(H) && m === "override") return;
        w.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(H) : d && !Xi(w) && t.replaceSelection(H);
      }
    };
    switch (w.key) {
      case "ArrowDown":
        if (n.getKeyBelow) {
          let H = t.focusedKey != null ? n.getKeyBelow?.(t.focusedKey) : n.getFirstKey?.();
          H == null && l && (H = n.getFirstKey?.(t.focusedKey)), H != null && (w.preventDefault(), R(H));
        }
        break;
      case "ArrowUp":
        if (n.getKeyAbove) {
          let H = t.focusedKey != null ? n.getKeyAbove?.(t.focusedKey) : n.getLastKey?.();
          H == null && l && (H = n.getLastKey?.(t.focusedKey)), H != null && (w.preventDefault(), R(H));
        }
        break;
      case "ArrowLeft":
        if (n.getKeyLeftOf) {
          let H = t.focusedKey != null ? n.getKeyLeftOf?.(t.focusedKey) : n.getFirstKey?.();
          H == null && l && (H = p === "rtl" ? n.getFirstKey?.(t.focusedKey) : n.getLastKey?.(t.focusedKey)), H != null && (w.preventDefault(), R(H, p === "rtl" ? "first" : "last"));
        }
        break;
      case "ArrowRight":
        if (n.getKeyRightOf) {
          let H = t.focusedKey != null ? n.getKeyRightOf?.(t.focusedKey) : n.getFirstKey?.();
          H == null && l && (H = p === "rtl" ? n.getLastKey?.(t.focusedKey) : n.getFirstKey?.(t.focusedKey)), H != null && (w.preventDefault(), R(H, p === "rtl" ? "last" : "first"));
        }
        break;
      case "Home":
        if (n.getFirstKey) {
          if (t.focusedKey === null && w.shiftKey) return;
          w.preventDefault();
          let H = n.getFirstKey(t.focusedKey, Fn(w));
          t.setFocusedKey(H), H != null && (Fn(w) && w.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(H) : d && t.replaceSelection(H));
        }
        break;
      case "End":
        if (n.getLastKey) {
          if (t.focusedKey === null && w.shiftKey) return;
          w.preventDefault();
          let H = n.getLastKey(t.focusedKey, Fn(w));
          t.setFocusedKey(H), H != null && (Fn(w) && w.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(H) : d && t.replaceSelection(H));
        }
        break;
      case "PageDown":
        if (n.getKeyPageBelow && t.focusedKey != null) {
          let H = n.getKeyPageBelow(t.focusedKey);
          H != null && (w.preventDefault(), R(H));
        }
        break;
      case "PageUp":
        if (n.getKeyPageAbove && t.focusedKey != null) {
          let H = n.getKeyPageAbove(t.focusedKey);
          H != null && (w.preventDefault(), R(H));
        }
        break;
      case "a":
        Fn(w) && t.selectionMode === "multiple" && u !== !0 && (w.preventDefault(), t.selectAll());
        break;
      case "Escape":
        o === "clearSelection" && !i && t.selectedKeys.size !== 0 && (w.stopPropagation(), w.preventDefault(), t.clearSelection());
        break;
      case "Tab":
        if (!f) {
          if (w.shiftKey) r.current.focus();
          else {
            let H = Ie(r.current, {
              tabbable: !0
            }), k, S;
            do
              S = H.lastChild(), S && (k = S);
            while (S);
            let j = se();
            k && (!Yt(k) || j && !Ga(j)) && Ae(k);
          }
          break;
        }
    }
  }, v = T({
    top: 0,
    left: 0
  });
  bt(h, "scroll", () => {
    v.current = {
      top: h.current?.scrollTop ?? 0,
      left: h.current?.scrollLeft ?? 0
    };
  });
  let x = (w) => {
    if (t.isFocused) {
      ae(w.currentTarget, W(w)) || t.setFocused(!1);
      return;
    }
    if (!ae(w.currentTarget, W(w))) return;
    let R = vt();
    t.setFocused(!0);
    let H = (k) => {
      k != null && (t.setFocusedKey(k), d && !t.isSelected(k) && t.replaceSelection(k));
    };
    if (b && (R === "keyboard" || R === "virtual"))
      H(b === "first" ? n.getFirstKey?.() : n.getLastKey?.());
    else if (t.focusedKey == null) {
      let k = w.relatedTarget;
      k && w.currentTarget.compareDocumentPosition(k) & Node.DOCUMENT_POSITION_FOLLOWING ? H(t.lastSelectedKey ?? n.getLastKey?.()) : H(t.firstSelectedKey ?? n.getFirstKey?.());
    } else h.current && (h.current.scrollTop = v.current.top, h.current.scrollLeft = v.current.left);
    if (t.focusedKey != null && h.current) {
      let k = Kn(r, t.focusedKey);
      k instanceof HTMLElement && (!Yt(k) && !c && Ae(k), (R === "keyboard" || b && R === "virtual") && Oe(k, {
        containingElement: r.current
      }));
    }
  }, E = (w) => {
    ae(w.currentTarget, w.relatedTarget) || t.setFocused(!1);
  }, P = T(!1);
  bt(r, $i, c ? (w) => {
    let { detail: R } = w;
    w.stopPropagation(), t.setFocused(!0), R?.focusStrategy === "first" && (P.current = !0);
  } : void 0);
  let C = n.getFirstKey?.() ?? null;
  ed(() => {
    if (P.current)
      if (C == null) {
        let w = se();
        hu(r.current), Wa(w, null), t.collection.size > 0 && (P.current = !1);
      } else
        t.setFocusedKey(C), P.current = !1;
  }, [
    C,
    t.collection.size
  ]), ed(() => {
    t.collection.size > 0 && (P.current = !1);
  }, [
    t.focusedKey
  ]), bt(r, Ud, c ? (w) => {
    w.stopPropagation(), t.setFocused(!1), w.detail?.clearFocusKey && t.setFocusedKey(null);
  } : void 0);
  const M = T(a), F = T(!1);
  ee(() => {
    if (M.current) {
      let w = null;
      a === "first" && (w = n.getFirstKey?.() ?? null), a === "last" && (w = n.getLastKey?.() ?? null);
      let R = t.selectedKeys;
      if (R.size) {
        for (let H of R) if (t.canSelectItem(H)) {
          w = H;
          break;
        }
      }
      t.setFocused(!0), t.setFocusedKey(w), w == null && !c && r.current && Se(r.current), t.collection.size > 0 && (M.current = !1, F.current = !0);
    }
  });
  let V = T(t.focusedKey), I = T(null);
  ee(() => {
    if (t.isFocused && t.focusedKey != null && (t.focusedKey !== V.current || F.current) && h.current && r.current) {
      let w = vt(), R = Kn(r, t.focusedKey);
      if (!(R instanceof HTMLElement))
        return;
      (w === "keyboard" || F.current) && (I.current && cancelAnimationFrame(I.current), I.current = requestAnimationFrame(() => {
        h.current && (Ha(h.current, R), w !== "virtual" && Oe(R, {
          containingElement: r.current
        }));
      }));
    }
    !c && t.isFocused && t.focusedKey == null && V.current != null && r.current && Se(r.current), V.current = t.focusedKey, F.current = !1;
  }), ee(() => () => {
    I.current && cancelAnimationFrame(I.current);
  }, []), bt(r, "react-aria-focus-scope-restore", (w) => {
    w.preventDefault(), t.setFocused(!0);
  });
  let A = {
    onKeyDown: $,
    onFocus: x,
    onBlur: E,
    onMouseDown(w) {
      h.current === W(w) && w.preventDefault();
    }
  }, { typeSelectProps: U } = Lb({
    keyboardDelegate: n,
    selectionManager: t
  });
  s || (A = z(U, A));
  let D;
  c || (D = t.focusedKey == null ? 0 : -1);
  let N = hx(t.collection);
  return {
    collectionProps: z(A, {
      tabIndex: D,
      "data-collection": N
    })
  };
}
class Ji {
  constructor(t) {
    this.ref = t;
  }
  getItemRect(t) {
    let n = this.ref.current;
    if (!n) return null;
    let r = t != null ? Kn(this.ref, t) : null;
    if (!r) return null;
    let a = n.getBoundingClientRect(), l = r.getBoundingClientRect();
    return {
      x: l.left - a.left - n.clientLeft + n.scrollLeft,
      y: l.top - a.top - n.clientTop + n.scrollTop,
      width: l.width,
      height: l.height
    };
  }
  getContentSize() {
    let t = this.ref.current;
    return {
      width: t?.scrollWidth ?? 0,
      height: t?.scrollHeight ?? 0
    };
  }
  getVisibleRect() {
    let t = this.ref.current;
    return {
      x: t?.scrollLeft ?? 0,
      y: t?.scrollTop ?? 0,
      width: t?.clientWidth ?? 0,
      height: t?.clientHeight ?? 0
    };
  }
}
class va {
  constructor(...t) {
    if (t.length === 1) {
      let n = t[0];
      this.collection = n.collection, this.ref = n.ref, this.collator = n.collator, this.disabledKeys = n.disabledKeys || /* @__PURE__ */ new Set(), this.disabledBehavior = n.disabledBehavior || "all", this.orientation = n.orientation || "vertical", this.direction = n.direction, this.layout = n.layout || "stack", this.layoutDelegate = n.layoutDelegate || new Ji(n.ref);
    } else
      this.collection = t[0], this.disabledKeys = t[1], this.ref = t[2], this.collator = t[3], this.layout = "stack", this.orientation = "vertical", this.disabledBehavior = "all", this.layoutDelegate = new Ji(this.ref);
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
  isDisabled(t) {
    return this.disabledBehavior === "all" && (t.props?.isDisabled || this.disabledKeys.has(t.key)) && t.props?.disabledBehavior !== "selection";
  }
  findNextNonDisabled(t, n, r = !1) {
    let a = t;
    for (; a != null; ) {
      let l = this.collection.getItem(a);
      if (l?.type === "item" && (r || !this.isDisabled(l))) return a;
      a = n(a);
    }
    return null;
  }
  getNextKey(t, n) {
    let r = t;
    return r = this.collection.getKeyAfter(r), this.findNextNonDisabled(r, (a) => this.collection.getKeyAfter(a), n?.includeDisabled);
  }
  getPreviousKey(t, n) {
    let r = t;
    return r = this.collection.getKeyBefore(r), this.findNextNonDisabled(r, (a) => this.collection.getKeyBefore(a), n?.includeDisabled);
  }
  findKey(t, n, r) {
    let a = t, l = this.layoutDelegate.getItemRect(a);
    if (!l || a == null) return null;
    let i = l;
    do {
      if (a = n(a), a == null) break;
      l = this.layoutDelegate.getItemRect(a);
    } while (l && r(i, l) && a != null);
    return a;
  }
  isSameRow(t, n) {
    return t.y === n.y || t.x !== n.x;
  }
  isSameColumn(t, n) {
    return t.x === n.x || t.y !== n.y;
  }
  // checks to see if the next/prev key is spatially above/below the current key. If not, that means we are in
  // a reversed column layout and need to adjust appropriately
  // TODO: still need to see how this works with virtualizer once there is handling for the reverse layout
  // this felt like a simpler approach then changing getKeyAbove/Below to be purely spatial calculations
  isReversed(t) {
    let n = this.getNextKey(t), r = Kn(this.ref, t);
    if (n != null) {
      let l = Kn(this.ref, n);
      return !r || !l ? !1 : r.getBoundingClientRect().top > l.getBoundingClientRect().top;
    }
    let a = this.getPreviousKey(t);
    if (a != null) {
      let l = Kn(this.ref, a);
      return !r || !l ? !1 : l.getBoundingClientRect().top > r.getBoundingClientRect().top;
    }
    return !1;
  }
  getKeyBelow(t, n) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (r) => this.getNextKey(r, n), this.isSameRow) : this.orientation === "vertical" ? this.isReversed(t) ? this.getPreviousKey(t, n) : this.getNextKey(t, n) : this.getNextKey(t, n);
  }
  getKeyAbove(t, n) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (r) => this.getPreviousKey(r, n), this.isSameRow) : this.orientation === "vertical" ? this.isReversed(t) ? this.getNextKey(t, n) : this.getPreviousKey(t, n) : this.getPreviousKey(t, n);
  }
  getNextColumn(t, n, r) {
    return n ? this.getPreviousKey(t, r) : this.getNextKey(t, r);
  }
  getKeyRightOf(t, n) {
    let r = this.direction === "ltr" ? "getKeyRightOf" : "getKeyLeftOf";
    return this.layoutDelegate[r] ? (t = this.layoutDelegate[r](t), this.findNextNonDisabled(t, (a) => this.layoutDelegate[r](a), n?.includeDisabled)) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "rtl", n) : this.findKey(t, (a) => this.getNextColumn(a, this.direction === "rtl", n), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "rtl", n) : null;
  }
  getKeyLeftOf(t, n) {
    let r = this.direction === "ltr" ? "getKeyLeftOf" : "getKeyRightOf";
    return this.layoutDelegate[r] ? (t = this.layoutDelegate[r](t), this.findNextNonDisabled(t, (a) => this.layoutDelegate[r](a), n?.includeDisabled)) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "ltr", n) : this.findKey(t, (a) => this.getNextColumn(a, this.direction === "ltr", n), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "ltr", n) : null;
  }
  getFirstKey() {
    let t = this.collection.getFirstKey();
    return this.findNextNonDisabled(t, (n) => this.collection.getKeyAfter(n));
  }
  getLastKey() {
    let t = this.collection.getLastKey();
    return this.findNextNonDisabled(t, (n) => this.collection.getKeyBefore(n));
  }
  getKeyPageAbove(t) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(t);
    if (!r) return null;
    let a = this.isReversed(t);
    if (n && !yn(n)) return this.getFirstKey();
    let l = t;
    if (this.orientation === "horizontal") {
      let i = Math.max(0, r.x + r.width - this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x > i && l != null; )
        l = this.getKeyAbove(l), r = l == null ? null : this.layoutDelegate.getItemRect(l);
    } else {
      let i = this.layoutDelegate.getVisibleRect(), u = a ? r.y - i.height : Math.max(0, r.y + r.height - i.height);
      for (; r && r.y > u && l != null; )
        l = this.getKeyAbove(l), r = l == null ? null : this.layoutDelegate.getItemRect(l);
    }
    return l ?? (a ? this.getLastKey() : this.getFirstKey());
  }
  getKeyPageBelow(t) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(t);
    if (!r) return null;
    let a = this.isReversed(t);
    if (n && !yn(n)) return this.getLastKey();
    let l = t;
    if (this.orientation === "horizontal") {
      let i = Math.min(this.layoutDelegate.getContentSize().width, r.x - r.width + this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x < i && l != null; )
        l = this.getKeyBelow(l), r = l == null ? null : this.layoutDelegate.getItemRect(l);
    } else {
      let i = Math.min(this.layoutDelegate.getContentSize().height, r.y - r.height + this.layoutDelegate.getVisibleRect().height);
      for (; r && r.y < i && l != null; )
        l = this.getKeyBelow(l), r = l == null ? null : this.layoutDelegate.getItemRect(l);
    }
    return l ?? (a ? this.getFirstKey() : this.getLastKey());
  }
  getKeyForSearch(t, n) {
    if (!this.collator) return null;
    let r = this.collection, a = n || this.getFirstKey();
    for (; a != null; ) {
      let l = r.getItem(a);
      if (!l) return null;
      let i = l.textValue.slice(0, t.length);
      if (l.textValue && this.collator.compare(i, t) === 0) return a;
      a = this.getNextKey(a);
    }
    return null;
  }
}
let si = /* @__PURE__ */ new Map();
function Sr(e) {
  let { locale: t } = de(), n = t + (e ? Object.entries(e).sort((a, l) => a[0] < l[0] ? -1 : 1).join() : "");
  if (si.has(n)) return si.get(n);
  let r = new Intl.Collator(t, e);
  return si.set(n, r), r;
}
function io(e) {
  let { selectionManager: t, collection: n, disabledKeys: r, ref: a, keyboardDelegate: l, layoutDelegate: i, orientation: u } = e, o = Sr({
    usage: "search",
    sensitivity: "base"
  }), d = t.disabledBehavior, s = K(() => l || new va({
    collection: n,
    disabledKeys: r,
    disabledBehavior: d,
    ref: a,
    collator: o,
    layoutDelegate: i,
    orientation: u
  }), [
    l,
    i,
    n,
    r,
    a,
    o,
    d,
    u
  ]), { collectionProps: c } = lo({
    ...e,
    ref: a,
    selectionManager: t,
    keyboardDelegate: s
  });
  return {
    listProps: c
  };
}
function px(e, t, n) {
  let r = J(e, {
    labelable: !0
  }), a = e.selectionBehavior || "toggle", l = e.orientation || "vertical", i = e.linkBehavior || (a === "replace" ? "action" : "override");
  a === "toggle" && i === "action" && (i = "override");
  let { listProps: u } = io({
    ...e,
    ref: n,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    linkBehavior: i
  }), { focusWithinProps: o } = ft({
    onFocusWithin: e.onFocus,
    onBlurWithin: e.onBlur,
    onFocusWithinChange: e.onFocusChange
  }), d = ce(e.id);
  ro.set(t, {
    id: d,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus,
    shouldSelectOnPressUp: e.shouldSelectOnPressUp,
    shouldFocusOnHover: e.shouldFocusOnHover,
    isVirtualized: e.isVirtualized,
    onAction: e.onAction,
    linkBehavior: i,
    // @ts-ignore
    UNSTABLE_itemBehavior: e.UNSTABLE_itemBehavior
  });
  let { labelProps: s, fieldProps: c } = ba({
    ...e,
    id: d,
    // listbox is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  return {
    labelProps: s,
    listBoxProps: z(r, o, t.selectionManager.selectionMode === "multiple" ? {
      "aria-multiselectable": "true"
    } : {}, {
      role: "listbox",
      "aria-orientation": l,
      ...z(c, u)
    })
  };
}
const gx = 500;
function zb(e) {
  let { isDisabled: t, onLongPressStart: n, onLongPressEnd: r, onLongPress: a, threshold: l = gx, accessibilityDescription: i } = e;
  const u = T(void 0);
  let { addGlobalListener: o, removeGlobalListener: d } = Qt(), { pressProps: s } = Je({
    isDisabled: t,
    onPressStart(f) {
      if (f.continuePropagation(), (f.pointerType === "mouse" || f.pointerType === "touch") && (n && n({
        ...f,
        type: "longpressstart"
      }), u.current = setTimeout(() => {
        f.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), he(f.target).activeElement !== f.target && Ae(f.target), a && a({
          ...f,
          type: "longpress"
        }), u.current = void 0;
      }, l), f.pointerType === "touch")) {
        let h = (b) => {
          b.preventDefault();
        }, m = Be(f.target);
        o(f.target, "contextmenu", h, {
          once: !0
        }), o(m, "pointerup", () => {
          setTimeout(() => {
            d(f.target, "contextmenu", h);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(f) {
      u.current && clearTimeout(u.current), r && (f.pointerType === "mouse" || f.pointerType === "touch") && r({
        ...f,
        type: "longpressend"
      });
    }
  }), c = en(a && !t ? i : void 0);
  return {
    longPressProps: z(s, c)
  };
}
function kr(e) {
  let { id: t, selectionManager: n, key: r, ref: a, shouldSelectOnPressUp: l, shouldUseVirtualFocus: i, focus: u, isDisabled: o, onAction: d, allowsDifferentPressOrigin: s, linkBehavior: c = "action" } = e, f = xr();
  t = ce(t);
  let h = (S) => {
    if (S.pointerType === "keyboard" && Xi(S)) n.toggleSelection(r);
    else {
      if (n.selectionMode === "none") return;
      if (n.isLink(r)) {
        if (c === "selection" && a.current) {
          let j = n.getItemProps(r);
          f.open(a.current, S, j.href, j.routerOptions), n.setSelectedKeys(n.selectedKeys);
          return;
        } else if (c === "override" || c === "none") return;
      }
      n.selectionMode === "single" ? n.isSelected(r) && !n.disallowEmptySelection ? n.toggleSelection(r) : n.replaceSelection(r) : S && S.shiftKey ? n.extendSelection(r) : n.selectionBehavior === "toggle" || S && (Fn(S) || S.pointerType === "touch" || S.pointerType === "virtual") ? n.toggleSelection(r) : n.replaceSelection(r);
    }
  };
  ee(() => {
    r === n.focusedKey && n.isFocused && (i ? hu(a.current) : u ? u() : se() !== a.current && a.current && Se(a.current));
  }, [
    a,
    r,
    n.focusedKey,
    n.childFocusStrategy,
    n.isFocused,
    i
  ]), o = o || n.isDisabled(r);
  let m = {};
  !i && !o ? m = {
    tabIndex: r === n.focusedKey ? 0 : -1,
    onFocus(S) {
      W(S) === a.current && n.setFocusedKey(r);
    }
  } : o && (m.onMouseDown = (S) => {
    S.preventDefault();
  }), ee(() => {
    o && n.focusedKey === r && n.setFocusedKey(null);
  }, [
    n,
    o,
    r
  ]);
  let b = n.isLink(r) && c === "override", p = d && e.UNSTABLE_itemBehavior === "action", y = n.isLink(r) && c !== "selection" && c !== "none", $ = !o && n.canSelectItem(r) && !b && !p, v = (d || y) && !o, x = v && (n.selectionBehavior === "replace" ? !$ : !$ || n.isEmpty), E = v && $ && n.selectionBehavior === "replace", P = x || E, C = T(null), M = P && $, F = T(!1), V = T(!1), I = n.getItemProps(r), A = (S) => {
    d && (d(), a.current?.dispatchEvent(new CustomEvent("react-aria-item-action", {
      bubbles: !0
    }))), y && a.current && f.open(a.current, S, I.href, I.routerOptions);
  }, U = {
    ref: a
  };
  if (l ? (U.onPressStart = (S) => {
    C.current = S.pointerType, F.current = M, S.pointerType === "keyboard" && (!P || nd(S.key)) && h(S);
  }, s ? (U.onPressUp = x ? void 0 : (S) => {
    S.pointerType === "mouse" && $ && h(S);
  }, U.onPress = x ? A : (S) => {
    S.pointerType !== "keyboard" && S.pointerType !== "mouse" && $ && h(S);
  }) : U.onPress = (S) => {
    if (x || E && S.pointerType !== "mouse") {
      if (S.pointerType === "keyboard" && !td(S.key)) return;
      A(S);
    } else S.pointerType !== "keyboard" && $ && h(S);
  }) : (U.onPressStart = (S) => {
    C.current = S.pointerType, F.current = M, V.current = x, $ && (S.pointerType === "mouse" && !x || S.pointerType === "keyboard" && (!v || nd(S.key))) && h(S);
  }, U.onPress = (S) => {
    (S.pointerType === "touch" || S.pointerType === "pen" || S.pointerType === "virtual" || S.pointerType === "keyboard" && P && td(S.key) || S.pointerType === "mouse" && V.current) && (P ? A(S) : $ && h(S));
  }), m["data-collection"] = mx(n.collection), m["data-key"] = r, U.preventFocusOnPress = i, i && (U = z(U, {
    onPressStart(S) {
      S.pointerType !== "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    },
    onPress(S) {
      S.pointerType === "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    }
  })), I)
    for (let S of [
      "onPressStart",
      "onPressEnd",
      "onPressChange",
      "onPress",
      "onPressUp",
      "onClick"
    ]) I[S] && (U[S] = st(U[S], I[S]));
  let { pressProps: D, isPressed: N } = Je(U), w = E ? (S) => {
    C.current === "mouse" && (S.stopPropagation(), S.preventDefault(), A(S));
  } : void 0, { longPressProps: R } = zb({
    isDisabled: !M,
    onLongPress(S) {
      S.pointerType === "touch" && (h(S), n.setSelectionBehavior("toggle"));
    }
  }), H = (S) => {
    C.current === "touch" && F.current && S.preventDefault();
  }, k = c !== "none" && n.isLink(r) ? (S) => {
    Nt.isOpening || S.preventDefault();
  } : void 0;
  return {
    itemProps: z(
      m,
      $ || x || i && !o ? D : {},
      M ? R : {},
      {
        onDoubleClick: w,
        onDragStartCapture: H,
        onClick: k,
        id: t
      },
      // Prevent DOM focus from moving on mouse down when using virtual focus
      i ? {
        onMouseDown: (S) => S.preventDefault()
      } : void 0
    ),
    isPressed: N,
    isSelected: n.isSelected(r),
    isFocused: n.isFocused && n.focusedKey === r,
    isDisabled: o,
    allowsSelection: $,
    hasAction: P
  };
}
function td(e) {
  return e === "Enter";
}
function nd(e) {
  return e === " ";
}
function Ke(e, t) {
  return typeof t.getChildren == "function" ? t.getChildren(e.key) : e.childNodes;
}
function Wt(e) {
  return Ur(e, 0);
}
function Ur(e, t) {
  if (t < 0) return;
  let n = 0;
  for (let r of e) {
    if (n === t) return r;
    n++;
  }
}
function lr(e) {
  let t;
  for (let n of e) t = n;
  return t;
}
function di(e, t, n) {
  if (t.parentKey === n.parentKey) return t.index - n.index;
  let r = [
    ...rd(e, t),
    t
  ], a = [
    ...rd(e, n),
    n
  ], l = r.slice(0, a.length).findIndex((i, u) => i !== a[u]);
  return l !== -1 ? (t = r[l], n = a[l], t.index - n.index) : r.findIndex((i) => i === n) >= 0 ? 1 : (a.findIndex((i) => i === t) >= 0, -1);
}
function rd(e, t) {
  let n = [], r = t;
  for (; r?.parentKey != null; )
    r = e.getItem(r.parentKey), r && n.unshift(r);
  return n;
}
const ad = /* @__PURE__ */ new WeakMap();
function Ob(e) {
  let t = ad.get(e);
  if (t != null) return t;
  let n = 0, r = (a) => {
    for (let l of a)
      l.type === "section" ? r(Ke(l, e)) : l.type === "item" && n++;
  };
  return r(e), ad.set(e, n), n;
}
function yx(e, t, n) {
  let { key: r } = e, a = ro.get(t), l = e.isDisabled ?? t.selectionManager.isDisabled(r), i = e.isSelected ?? t.selectionManager.isSelected(r), u = e.shouldSelectOnPressUp ?? a?.shouldSelectOnPressUp, o = e.shouldFocusOnHover ?? a?.shouldFocusOnHover, d = e.shouldUseVirtualFocus ?? a?.shouldUseVirtualFocus, s = e.isVirtualized ?? a?.isVirtualized, c = yt(), f = yt(), h = {
    role: "option",
    "aria-disabled": l || void 0,
    "aria-selected": t.selectionManager.selectionMode !== "none" ? i : void 0,
    "aria-label": e["aria-label"],
    "aria-labelledby": c,
    "aria-describedby": f
  }, m = t.collection.getItem(r);
  if (s) {
    let F = Number(m?.index);
    h["aria-posinset"] = Number.isNaN(F) ? void 0 : F + 1, h["aria-setsize"] = Ob(t.collection);
  }
  let b = a?.onAction ? () => a?.onAction?.(r) : void 0, p = rx(t, r), { itemProps: y, isPressed: $, isFocused: v, hasAction: x, allowsSelection: E } = kr({
    selectionManager: t.selectionManager,
    key: r,
    ref: n,
    shouldSelectOnPressUp: u,
    allowsDifferentPressOrigin: u && o,
    isVirtualized: s,
    shouldUseVirtualFocus: d,
    isDisabled: l,
    onAction: b || m?.props?.onAction ? st(m?.props?.onAction, b) : void 0,
    linkBehavior: a?.linkBehavior,
    // @ts-ignore
    UNSTABLE_itemBehavior: a?.UNSTABLE_itemBehavior,
    id: p
  }), { hoverProps: P } = De({
    isDisabled: l || !o,
    onHoverStart() {
      Vt() || (t.selectionManager.setFocused(!0), t.selectionManager.setFocusedKey(r));
    }
  }), C = J(m?.props);
  delete C.id;
  let M = $l(m?.props);
  return {
    optionProps: {
      ...h,
      ...z(C, y, P, M),
      id: p
    },
    labelProps: {
      id: c
    },
    descriptionProps: {
      id: f
    },
    isFocused: v,
    isFocusVisible: v && t.selectionManager.isFocused && Vt(),
    isSelected: i,
    isDisabled: l,
    isPressed: $,
    allowsSelection: E,
    hasAction: x
  };
}
function $x(e) {
  let { heading: t, "aria-label": n } = e, r = ce();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: t ? {
      // Technically, listbox cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a visual label for the nested group.
      id: r,
      role: "presentation",
      onMouseDown: (a) => {
        a.preventDefault();
      }
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": t ? r : void 0
    }
  };
}
function fl(e) {
  const t = jv.split(".");
  return parseInt(t[0], 10) >= 19 ? e : e ? "true" : void 0;
}
class ld {
  constructor(t) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = t;
    let n = (i) => {
      if (this.keyMap.set(i.key, i), i.childNodes && i.type === "section") for (let u of i.childNodes) n(u);
    };
    for (let i of t) n(i);
    let r = null, a = 0, l = 0;
    for (let [i, u] of this.keyMap)
      r ? (r.nextKey = i, u.prevKey = r.key) : (this.firstKey = i, u.prevKey = void 0), u.type === "item" && (u.index = a++), (u.type === "section" || u.type === "item") && l++, r = u, r.nextKey = void 0;
    this._size = l, this.lastKey = r?.key ?? null;
  }
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this._size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    return n ? n.prevKey ?? null : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    return n ? n.nextKey ?? null : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    return this.keyMap.get(t) ?? null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  getChildren(t) {
    return this.keyMap.get(t)?.childNodes || [];
  }
}
class mt extends Set {
  constructor(t, n, r) {
    super(t), t instanceof mt ? (this.anchorKey = n ?? t.anchorKey, this.currentKey = r ?? t.currentKey) : (this.anchorKey = n ?? null, this.currentKey = r ?? null);
  }
}
function vx(e, t) {
  if (e.size !== t.size) return !1;
  for (let n of e)
    if (!t.has(n)) return !1;
  return !0;
}
function Da(e) {
  let { selectionMode: t = "none", disallowEmptySelection: n = !1, allowDuplicateSelectionEvents: r, selectionBehavior: a = "toggle", disabledBehavior: l = "all" } = e, i = T(!1), [, u] = Y(!1), o = T(null), d = T(null), [, s] = Y(null), c = K(() => id(e.selectedKeys), [
    e.selectedKeys
  ]), f = K(() => id(e.defaultSelectedKeys, new mt()), [
    e.defaultSelectedKeys
  ]), [h, m] = we(c, f, e.onSelectionChange), b = K(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), [p, y] = Y(a);
  a === "replace" && p === "toggle" && typeof h == "object" && h.size === 0 && y("replace");
  let $ = T(a);
  return ee(() => {
    a !== $.current && (y(a), $.current = a);
  }, [
    a
  ]), {
    selectionMode: t,
    disallowEmptySelection: n,
    selectionBehavior: p,
    setSelectionBehavior: y,
    get isFocused() {
      return i.current;
    },
    setFocused(v) {
      i.current = v, u(v);
    },
    get focusedKey() {
      return o.current;
    },
    get childFocusStrategy() {
      return d.current;
    },
    setFocusedKey(v, x = "first") {
      o.current = v, d.current = x, s(v);
    },
    selectedKeys: h,
    setSelectedKeys(v) {
      (r || !vx(v, h)) && m(v);
    },
    disabledKeys: b,
    disabledBehavior: l
  };
}
function id(e, t) {
  return e ? e === "all" ? "all" : new mt(e) : t;
}
class Br {
  constructor(t, n, r) {
    this.collection = t, this.state = n, this.allowsCellSelection = r?.allowsCellSelection ?? !1, this._isSelectAll = null, this.layoutDelegate = r?.layoutDelegate || null, this.fullCollection = r?.fullCollection || null;
  }
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(t) {
    this.state.setSelectionBehavior(t);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(t) {
    this.state.setFocused(t);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(t, n) {
    (t == null || this.collection.getItem(t)) && this.state.setFocusedKey(t, n);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(t) {
    if (this.state.selectionMode === "none") return !1;
    let n = this.getKey(t);
    return n == null ? !1 : this.state.selectedKeys === "all" ? this.canSelectItem(n) : this.state.selectedKeys.has(n);
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty) return !1;
    if (this.state.selectedKeys === "all") return !0;
    if (this._isSelectAll != null) return this._isSelectAll;
    let t = this.getSelectAllKeys(), n = this.state.selectedKeys;
    return this._isSelectAll = t.every((r) => n.has(r)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let t = null;
    for (let n of this.state.selectedKeys) {
      let r = this.collection.getItem(n);
      (!t || r && di(this.collection, r, t) < 0) && (t = r);
    }
    return t?.key ?? null;
  }
  get lastSelectedKey() {
    let t = null;
    for (let n of this.state.selectedKeys) {
      let r = this.collection.getItem(n);
      (!t || r && di(this.collection, r, t) > 0) && (t = r);
    }
    return t?.key ?? null;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(t) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single") {
      this.replaceSelection(t);
      return;
    }
    let n = this.getKey(t);
    if (n == null) return;
    let r;
    if (this.state.selectedKeys === "all") r = new mt([
      n
    ], n, n);
    else {
      let a = this.state.selectedKeys, l = a.anchorKey ?? n;
      r = new mt(a, l, n);
      for (let i of this.getKeyRange(l, a.currentKey ?? n)) r.delete(i);
      for (let i of this.getKeyRange(n, l)) this.canSelectItem(i) && r.add(i);
    }
    this.state.setSelectedKeys(r);
  }
  getKeyRange(t, n) {
    let r = this.collection.getItem(t), a = this.collection.getItem(n);
    return r && a ? di(this.collection, r, a) <= 0 ? this.getKeyRangeInternal(t, n) : this.getKeyRangeInternal(n, t) : [];
  }
  getKeyRangeInternal(t, n) {
    if (this.layoutDelegate?.getKeyRange) return this.layoutDelegate.getKeyRange(t, n);
    let r = [], a = t;
    for (; a != null; ) {
      let l = this.collection.getItem(a);
      if (l && (l.type === "item" || l.type === "cell" && this.allowsCellSelection) && r.push(a), a === n) return r;
      a = this.collection.getKeyAfter(a);
    }
    return [];
  }
  getKey(t) {
    let n = this.collection.getItem(t);
    if (!n || n.type === "cell" && this.allowsCellSelection) return t;
    for (; n && n.type !== "item" && n.parentKey != null; ) n = this.collection.getItem(n.parentKey);
    return !n || n.type !== "item" ? null : n.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(t) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single" && !this.isSelected(t)) {
      this.replaceSelection(t);
      return;
    }
    let n = this.getKey(t);
    if (n == null) return;
    let r = new mt(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    r.has(n) ? r.delete(n) : this.canSelectItem(n) && (r.add(n), r.anchorKey = n, r.currentKey = n), !(this.disallowEmptySelection && r.size === 0) && this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(t) {
    if (this.selectionMode === "none") return;
    let n = this.getKey(t);
    if (n == null) return;
    let r = this.canSelectItem(n) ? new mt([
      n
    ], n, n) : new mt();
    this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(t) {
    if (this.selectionMode === "none") return;
    let n = new mt();
    for (let r of t) {
      let a = this.getKey(r);
      if (a != null && (n.add(a), this.selectionMode === "single"))
        break;
    }
    this.state.setSelectedKeys(n);
  }
  getSelectAllKeys() {
    let t = this.fullCollection ?? this.collection, n = [], r = (a) => {
      for (; a != null; ) {
        if (this.canSelectItemIn(a, t)) {
          let l = t.getItem(a);
          l?.type === "item" && n.push(a), l?.hasChildNodes && (this.allowsCellSelection || l.type !== "item") && r(Wt(Ke(l, t))?.key ?? null);
        }
        a = t.getKeyAfter(a);
      }
    };
    return r(t.getFirstKey()), n;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new mt());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(t, n) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(t) && !this.disallowEmptySelection ? this.toggleSelection(t) : this.replaceSelection(t) : this.selectionBehavior === "toggle" || n && (n.pointerType === "touch" || n.pointerType === "virtual") ? this.toggleSelection(t) : this.replaceSelection(t));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(t) {
    if (t === this.state.selectedKeys) return !0;
    let n = this.selectedKeys;
    if (t.size !== n.size) return !1;
    for (let r of t)
      if (!n.has(r)) return !1;
    for (let r of n)
      if (!t.has(r)) return !1;
    return !0;
  }
  canSelectItem(t) {
    return this.canSelectItemIn(t, this.collection);
  }
  canSelectItemIn(t, n) {
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(t)) return !1;
    let r = n.getItem(t);
    return !(!r || r?.props?.isDisabled || r.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(t) {
    let n = this.collection.getItem(t);
    return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(t) || !!n?.props?.isDisabled) && n?.props?.disabledBehavior !== "selection";
  }
  isLink(t) {
    return !!this.collection.getItem(t)?.props?.href;
  }
  getItemProps(t) {
    return this.collection.getItem(t)?.props;
  }
  withCollection(t) {
    return new Br(t, this.state, {
      allowsCellSelection: this.allowsCellSelection,
      layoutDelegate: this.layoutDelegate || void 0,
      fullCollection: this.fullCollection ?? this.collection
    });
  }
}
class Dx {
  build(t, n) {
    return this.context = n, ud(() => this.iterateCollection(t));
  }
  *iterateCollection(t) {
    let { children: n, items: r } = t;
    if (g.isValidElement(n) && n.type === g.Fragment) yield* this.iterateCollection({
      children: n.props.children,
      items: r
    });
    else if (typeof n == "function") {
      if (!r) throw new Error("props.children was a function but props.items is missing");
      let a = 0;
      for (let l of r)
        yield* this.getFullNode({
          value: l,
          index: a
        }, {
          renderer: n
        }), a++;
    } else {
      let a = [];
      g.Children.forEach(n, (i) => {
        i && a.push(i);
      });
      let l = 0;
      for (let i of a) {
        let u = this.getFullNode({
          element: i,
          index: l
        }, {});
        for (let o of u)
          l++, yield o;
      }
    }
  }
  getKey(t, n, r, a) {
    if (t.key != null) return t.key;
    if (n.type === "cell" && n.key != null) return `${a}${n.key}`;
    let l = n.value;
    if (l != null) {
      let i = l.key ?? l.id;
      if (i == null) throw new Error("No key found for item");
      return i;
    }
    return a ? `${a}.${n.index}` : `$.${n.index}`;
  }
  getChildState(t, n) {
    return {
      renderer: n.renderer || t.renderer
    };
  }
  *getFullNode(t, n, r, a) {
    if (g.isValidElement(t.element) && t.element.type === g.Fragment) {
      let o = [];
      g.Children.forEach(t.element.props.children, (s) => {
        o.push(s);
      });
      let d = t.index ?? 0;
      for (const s of o) yield* this.getFullNode({
        element: s,
        index: d++
      }, n, r, a);
      return;
    }
    let l = t.element;
    if (!l && t.value && n && n.renderer) {
      let o = this.cache.get(t.value);
      if (o && (!o.shouldInvalidate || !o.shouldInvalidate(this.context))) {
        o.index = t.index, o.parentKey = a ? a.key : null, yield o;
        return;
      }
      l = n.renderer(t.value);
    }
    if (g.isValidElement(l)) {
      let o = l.type;
      if (typeof o != "function" && typeof o.getCollectionNode != "function") {
        let f = l.type;
        throw new Error(`Unknown element <${f}> in collection.`);
      }
      let d = o.getCollectionNode(l.props, this.context), s = t.index ?? 0, c = d.next();
      for (; !c.done && c.value; ) {
        let f = c.value;
        t.index = s;
        let h = f.key ?? null;
        h == null && (h = f.element ? null : this.getKey(l, t, n, r));
        let b = [
          ...this.getFullNode({
            ...f,
            key: h,
            index: s,
            wrapper: xx(t.wrapper, f.wrapper)
          }, this.getChildState(n, f), r ? `${r}${l.key}` : l.key, a)
        ];
        for (let p of b) {
          if (p.value = f.value ?? t.value ?? null, p.value && this.cache.set(p.value, p), t.type && p.type !== t.type) throw new Error(`Unsupported type <${ci(p.type)}> in <${ci(a?.type ?? "unknown parent type")}>. Only <${ci(t.type)}> is supported.`);
          s++, yield p;
        }
        c = d.next(b);
      }
      return;
    }
    if (t.key == null || t.type == null) return;
    let i = this, u = {
      type: t.type,
      props: t.props,
      key: t.key,
      parentKey: a ? a.key : null,
      value: t.value ?? null,
      level: (a?.level ?? 0) + (a?.type === "item" ? 1 : 0),
      index: t.index,
      rendered: t.rendered,
      textValue: t.textValue ?? "",
      "aria-label": t["aria-label"],
      wrapper: t.wrapper,
      shouldInvalidate: t.shouldInvalidate,
      hasChildNodes: t.hasChildNodes || !1,
      childNodes: ud(function* () {
        if (!t.hasChildNodes || !t.childNodes) return;
        let o = 0;
        for (let d of t.childNodes()) {
          d.key != null && (d.key = `${u.key}${d.key}`);
          let s = i.getFullNode({
            ...d,
            index: o
          }, i.getChildState(n, d), u.key, u);
          for (let c of s)
            o++, yield c;
        }
      })
    };
    yield u;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function ud(e) {
  let t = [], n = null;
  return {
    *[Symbol.iterator]() {
      for (let r of t) yield r;
      n || (n = e());
      for (let r of n)
        t.push(r), yield r;
    }
  };
}
function xx(e, t) {
  if (e && t) return (n) => e(t(n));
  if (e) return e;
  if (t) return t;
}
function ci(e) {
  return e[0].toUpperCase() + e.slice(1);
}
function uo(e, t, n) {
  let r = K(() => new Dx(), []), { children: a, items: l, collection: i } = e;
  return K(() => {
    if (i) return i;
    let o = r.build({
      children: a,
      items: l
    }, n);
    return t(o);
  }, [
    r,
    a,
    l,
    i,
    n,
    t
  ]);
}
function Al(e) {
  let { filter: t, layoutDelegate: n } = e, r = Da(e), a = K(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), l = X((d) => t ? new ld(t(d)) : new ld(d), [
    t
  ]), i = K(() => ({
    suppressTextValueWarning: e.suppressTextValueWarning
  }), [
    e.suppressTextValueWarning
  ]), u = uo(e, l, i), o = K(() => new Br(u, r, {
    layoutDelegate: n
  }), [
    u,
    r,
    n
  ]);
  return Ub(u, o), {
    collection: u,
    disabledKeys: a,
    selectionManager: o
  };
}
function Hb(e, t) {
  let n = K(() => t ? e.collection.filter(t) : e.collection, [
    e.collection,
    t
  ]), r = e.selectionManager.withCollection(n);
  return Ub(n, r), {
    collection: n,
    selectionManager: r,
    disabledKeys: e.disabledKeys
  };
}
function Ub(e, t) {
  const n = T(null);
  ee(() => {
    if (t.focusedKey != null && !e.getItem(t.focusedKey) && n.current) {
      let r = n.current.getKeyAfter(t.focusedKey), a = null;
      for (; r != null; ) {
        let l = e.getItem(r);
        if (l && l.type === "item" && !t.isDisabled(r)) {
          a = r;
          break;
        }
        r = n.current.getKeyAfter(r);
      }
      if (a == null)
        for (r = n.current.getKeyBefore(t.focusedKey); r != null; ) {
          let l = e.getItem(r);
          if (l && l.type === "item" && !t.isDisabled(r)) {
            a = r;
            break;
          }
          r = n.current.getKeyBefore(r);
        }
      t.setFocusedKey(a);
    }
    n.current = e;
  }, [
    e,
    t
  ]);
}
function jb(e, t) {
  let { collection: n, onLoadMore: r, scrollOffset: a = 1 } = e, l = T(null), i = xe((u) => {
    for (let o of u)
      o.isIntersecting && r && r();
  });
  ue(() => (t.current && (l.current = new IntersectionObserver(i, {
    root: ze(t?.current),
    rootMargin: `0px ${100 * a}% ${100 * a}% ${100 * a}%`
  }), l.current.observe(t.current)), () => {
    l.current && l.current.disconnect();
  }), [
    n,
    t,
    a
  ]);
}
const oo = /* @__PURE__ */ G(null), kt = /* @__PURE__ */ G(null), Ex = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, oo);
  let r = O(kt);
  return r ? /* @__PURE__ */ g.createElement(_b, {
    state: r,
    props: t,
    listBoxRef: n
  }) : /* @__PURE__ */ g.createElement(jn, {
    content: /* @__PURE__ */ g.createElement(Jt, t)
  }, (a) => /* @__PURE__ */ g.createElement(Cx, {
    props: t,
    listBoxRef: n,
    collection: a
  }));
});
function Cx({ props: e, listBoxRef: t, collection: n }) {
  e = {
    ...e,
    collection: n,
    children: null,
    items: null
  };
  let { layoutDelegate: r } = O(ge), a = Al({
    ...e,
    layoutDelegate: r
  });
  return /* @__PURE__ */ g.createElement(_b, {
    state: a,
    props: e,
    listBoxRef: t
  });
}
function _b({ state: e, props: t, listBoxRef: n }) {
  [t, n] = oe(t, n, Vn);
  let { dragAndDropHooks: r, layout: a = "stack", orientation: l = "vertical", filter: i } = t, u = Hb(e, i), { collection: o, selectionManager: d } = u, s = !!r?.useDraggableCollectionState, c = !!r?.useDroppableCollectionState, { direction: f } = de(), { disabledBehavior: h, disabledKeys: m } = d, b = Sr({
    usage: "search",
    sensitivity: "base"
  }), { isVirtualized: p, layoutDelegate: y, dropTargetDelegate: $, CollectionRoot: v } = O(ge), x = K(() => t.keyboardDelegate || new va({
    collection: o,
    collator: b,
    ref: n,
    disabledKeys: m,
    disabledBehavior: h,
    layout: a,
    orientation: l,
    direction: f,
    layoutDelegate: y
  }), [
    o,
    b,
    n,
    h,
    m,
    l,
    f,
    t.keyboardDelegate,
    a,
    y
  ]), { listBoxProps: E } = px({
    ...t,
    shouldSelectOnPressUp: s || t.shouldSelectOnPressUp,
    keyboardDelegate: x,
    isVirtualized: p
  }, u, n), P = T(s), C = T(c);
  ee(() => {
    process.env.NODE_ENV !== "production" && (P.current !== s && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), C.current !== c && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."));
  }, [
    s,
    c
  ]);
  let M, F, V, I = !1, A = null, U = T(null);
  if (s && r) {
    M = r.useDraggableCollectionState({
      collection: o,
      selectionManager: d,
      preview: r.renderDragPreview ? U : void 0
    }), r.useDraggableCollection({}, M, n);
    let _ = r.DragPreview;
    A = r.renderDragPreview ? /* @__PURE__ */ g.createElement(_, {
      ref: U
    }, r.renderDragPreview) : null;
  }
  if (c && r) {
    F = r.useDroppableCollectionState({
      collection: o,
      selectionManager: d
    });
    let _ = r.dropTargetDelegate || $ || new r.ListDropTargetDelegate(o, n, {
      orientation: l,
      layout: a,
      direction: f
    });
    V = r.useDroppableCollection({
      keyboardDelegate: x,
      dropTargetDelegate: _
    }, F, n), I = F.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: D, isFocused: N, isFocusVisible: w } = ye(), R = u.collection.size === 0, H = {
    isDropTarget: I,
    isEmpty: R,
    isFocused: N,
    isFocusVisible: w,
    layout: t.layout || "stack",
    orientation: l,
    state: u
  }, k = le({
    ...t,
    children: void 0,
    defaultClassName: "react-aria-ListBox",
    values: H
  }), S = null;
  R && t.renderEmptyState && (S = /* @__PURE__ */ g.createElement("div", {
    // eslint-disable-next-line
    role: "option",
    style: {
      display: "contents"
    }
  }, t.renderEmptyState(H)));
  let j = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Bl, null, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(j, k, E, D, V?.collectionProps),
    ref: n,
    slot: t.slot || void 0,
    onScroll: t.onScroll,
    "data-drop-target": I || void 0,
    "data-empty": R || void 0,
    "data-focused": N || void 0,
    "data-focus-visible": w || void 0,
    "data-layout": t.layout || "stack",
    "data-orientation": l
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        oo,
        t
      ],
      [
        kt,
        u
      ],
      [
        zt,
        {
          dragAndDropHooks: r,
          dragState: M,
          dropState: F
        }
      ],
      [
        no,
        {
          elementType: "div"
        }
      ],
      [
        Qu,
        {
          render: Sx
        }
      ],
      [
        Jc,
        {
          name: "ListBoxSection",
          render: Px
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Wn, null, /* @__PURE__ */ g.createElement(v, {
    collection: o,
    scrollRef: n,
    persistedKeys: Tb(d, r, F),
    renderDropIndicator: eo(r, F)
  }))), S, A));
}
function Px(e, t, n, r = "react-aria-ListBoxSection") {
  let a = O(kt), { dragAndDropHooks: l, dropState: i } = O(zt), { CollectionBranch: u } = O(ge), [o, d] = Qe(), { headingProps: s, groupProps: c } = $x({
    heading: d,
    "aria-label": e["aria-label"] ?? void 0
  }), f = le({
    ...e,
    id: void 0,
    children: void 0,
    defaultClassName: r,
    values: void 0
  }), h = J(e, {
    global: !0
  });
  return delete h.id, /* @__PURE__ */ g.createElement(Q.section, {
    ...z(h, f, c),
    ref: t
  }, /* @__PURE__ */ g.createElement(to.Provider, {
    value: {
      ...s,
      ref: o
    }
  }, /* @__PURE__ */ g.createElement(u, {
    collection: a.collection,
    parent: n,
    renderDropIndicator: eo(l, i)
  })));
}
const wx = /* @__PURE__ */ St(Zr, function(t, n, r) {
  let a = $e(n), l = O(kt), { dragAndDropHooks: i, dragState: u, dropState: o } = O(zt), d = u && !(u.isDisabled || u.selectionManager.isDisabled(r.key)), { optionProps: s, labelProps: c, descriptionProps: f, ...h } = yx({
    key: r.key,
    "aria-label": t?.["aria-label"]
  }, l, a), { hoverProps: m, isHovered: b } = De({
    isDisabled: !h.allowsSelection && !h.hasAction && !d,
    onHoverStart: r.props.onHoverStart,
    onHoverChange: r.props.onHoverChange,
    onHoverEnd: r.props.onHoverEnd
  }), { keyboardProps: p } = Cr(t), { focusProps: y } = pr(t), $ = null;
  u && i && ($ = i.useDraggableItem({
    key: r.key,
    hasAction: h.hasAction
  }, u));
  let v = null;
  o && i && (v = i.useDroppableItem({
    target: {
      type: "item",
      key: r.key,
      dropPosition: "on"
    }
  }, o, a));
  let x = u && u.isDragging(r.key), E = le({
    ...t,
    id: void 0,
    children: t.children,
    defaultClassName: "react-aria-ListBoxItem",
    values: {
      ...h,
      isHovered: b,
      selectionMode: l.selectionManager.selectionMode,
      selectionBehavior: l.selectionManager.selectionBehavior,
      allowsDragging: !!u,
      isDragging: x,
      isDropTarget: v?.isDropTarget
    }
  });
  ee(() => {
    !r.textValue && process.env.NODE_ENV !== "production" && console.warn("A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.");
  }, [
    r.textValue
  ]);
  let P = t.href ? Q.a : Q.div, C = J(t, {
    global: !0
  });
  return delete C.id, delete C.onClick, t.href && s.tabIndex == null && (s.tabIndex = -1), /* @__PURE__ */ g.createElement(P, {
    ...z(C, E, s, m, p, y, $?.dragProps, v?.dropProps),
    ref: a,
    "data-allows-dragging": !!u || void 0,
    "data-selected": h.isSelected || void 0,
    "data-disabled": h.isDisabled || void 0,
    "data-hovered": b || void 0,
    "data-focused": h.isFocused || void 0,
    "data-focus-visible": h.isFocusVisible || void 0,
    "data-pressed": h.isPressed || void 0,
    "data-dragging": x || void 0,
    "data-drop-target": v?.isDropTarget || void 0,
    "data-selection-mode": l.selectionManager.selectionMode === "none" ? void 0 : l.selectionManager.selectionMode
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        We,
        {
          slots: {
            [$t]: c,
            label: c,
            description: f
          }
        }
      ],
      [
        Gn,
        {
          isSelected: h.isSelected
        }
      ]
    ]
  }, E.children));
});
function Sx(e, t) {
  t = $e(t);
  let { dragAndDropHooks: n, dropState: r } = O(zt), { dropIndicatorProps: a, isHidden: l, isDropTarget: i } = n.useDropIndicator(e, r, t);
  return l ? null : /* @__PURE__ */ g.createElement(Bx, {
    ...e,
    dropIndicatorProps: a,
    isDropTarget: i,
    ref: t
  });
}
function kx(e, t) {
  let { dropIndicatorProps: n, isDropTarget: r, ...a } = e, l = le({
    ...a,
    defaultClassName: "react-aria-DropIndicator",
    values: {
      isDropTarget: r
    }
  });
  return /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(Q.div, {
    ...n,
    ...l,
    role: "option",
    ref: t,
    "data-drop-target": r || void 0
  }));
}
const Bx = /* @__PURE__ */ te(kx), yC = St(Xa, function(t, n, r) {
  let a = O(kt), { isLoading: l, onLoadMore: i, scrollOffset: u, ...o } = t, d = T(null), s = K(() => ({
    onLoadMore: i,
    collection: a?.collection,
    sentinelRef: d,
    scrollOffset: u
  }), [
    i,
    u,
    a?.collection
  ]);
  jb(s, d);
  let c = le({
    ...o,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-ListBoxLoadingIndicator",
    values: void 0
  }), f = {
    // For Android talkback
    tabIndex: -1
  };
  return /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement("div", {
    style: {
      position: "relative",
      width: 0,
      height: 0
    },
    inert: fl(!0)
  }, /* @__PURE__ */ g.createElement("div", {
    "data-testid": "loadMoreSentinel",
    ref: d,
    style: {
      position: "absolute",
      height: 1,
      width: 1
    }
  })), l && c.children && /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(J(t, {
      global: !0
    }), f),
    ...c,
    // aria-selected isn't needed here since this option is not selectable.
    role: "option",
    ref: n
  }, c.children)));
});
function Wb(e) {
  let t = Un(e.value), n = Un(e.defaultValue || "#000000"), [r, a] = we(t || void 0, n, e.onChange);
  return {
    color: r,
    setColor(l) {
      l != null && a(l || Ze("#000000"));
    }
  };
}
function Fx(e) {
  return e && e.__esModule ? e.default : e;
}
const Gb = /* @__PURE__ */ G(null), qb = /* @__PURE__ */ G(null), $C = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Gb);
  let r = Wb(t), a = K(() => /* @__PURE__ */ new Map(), []), l = Ee(Fx(Ju), "react-aria-components");
  return /* @__PURE__ */ g.createElement(Ex, {
    ...J(t, {
      labelable: !0
    }),
    ref: n,
    className: t.className || "react-aria-ColorSwatchPicker",
    style: t.style,
    "aria-label": t["aria-label"] || (t["aria-labelledby"] ? void 0 : l.format("colorSwatchPicker")),
    layout: t.layout || "grid",
    selectionMode: "single",
    selectedKeys: [
      r.color.toString("hexa")
    ],
    onSelectionChange: (i) => {
      i !== "all" && r.setColor(a.get([
        ...i
      ][0]));
    },
    disallowEmptySelection: !0
  }, /* @__PURE__ */ g.createElement(qb.Provider, {
    value: a
  }, t.children));
}), vC = /* @__PURE__ */ te(function(t, n) {
  let r = t.color || "#0000", a = K(() => typeof r == "string" ? Ze(r) : r, [
    r
  ]), { locale: l } = de(), i = O(qb);
  ee(() => {
    let o = a.toString("hexa");
    return i.set(o, a), () => {
      i.delete(o);
    };
  }, [
    a,
    i
  ]);
  let u = (o) => typeof o == "function" ? (d) => o({
    ...d,
    color: a
  }) : o;
  return /* @__PURE__ */ g.createElement(wx, {
    ...t,
    // ColorSwatchPickerItem is never a link.
    render: t.render,
    ref: n,
    id: a.toString("hexa"),
    textValue: a.getColorName(l),
    className: u(t.className || "react-aria-ColorSwatchPickerItem"),
    style: u(t.style)
  }, a5(u(t.children), (o) => /* @__PURE__ */ g.createElement(Xu.Provider, {
    value: {
      color: a
    }
  }, o)));
}), Ax = /* @__PURE__ */ G(null), Rx = /* @__PURE__ */ G(null), Tx = /* @__PURE__ */ G(null);
function DC(e) {
  let t = He(Rx, e.slot);
  e = z(t, e);
  let n = Wb(e), r = le({
    ...e,
    values: {
      color: n.color
    }
  });
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Tx,
        n
      ],
      [
        Jm,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        w3,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        Ax,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        qm,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        Xu,
        {
          color: n.color
        }
      ],
      [
        Gb,
        {
          value: n.color,
          onChange: n.setColor
        }
      ]
    ]
  }, r.children);
}
const Yb = /* @__PURE__ */ G({
  placement: "bottom"
}), Ix = typeof HTMLElement < "u" && "inert" in HTMLElement.prototype;
function od(e) {
  return e.dataset.liveAnnouncer === "true" || e.dataset.reactAriaTopLayer !== void 0;
}
let Nr = /* @__PURE__ */ new WeakMap(), Ge = [];
function Zb(e, t) {
  let n = Be(e?.[0]), r = t instanceof n.Element ? {
    root: t
  } : t, a = r?.root ?? document.body, l = r?.shouldUseInert && Ix, i = new Set(e), u = /* @__PURE__ */ new Set(), o = (p) => l && p instanceof n.HTMLElement ? p.inert : p.getAttribute("aria-hidden") === "true", d = (p, y) => {
    l && p instanceof n.HTMLElement ? p.inert = y : y ? p.setAttribute("aria-hidden", "true") : (p.removeAttribute("aria-hidden"), p instanceof n.HTMLElement && (p.inert = !1));
  }, s = /* @__PURE__ */ new Set();
  if (_t())
    for (let p of e) {
      let y = p;
      for (; y && y !== a; ) {
        let $ = y.getRootNode();
        "shadowRoot" in $ && s.add($.shadowRoot), y = $.parentNode;
      }
    }
  let c = (p) => {
    for (let x of p.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]")) i.add(x);
    let y = (x) => {
      if (u.has(x) || i.has(x) || x.parentElement && u.has(x.parentElement) && x.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
      for (let E of i)
        if (ae(x, E)) return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, $ = Mb(he(p), p, NodeFilter.SHOW_ELEMENT, {
      acceptNode: y
    }), v = y(p);
    if (v === NodeFilter.FILTER_ACCEPT && f(p), v !== NodeFilter.FILTER_REJECT) {
      let x = $.nextNode();
      for (; x != null; )
        f(x), x = $.nextNode();
    }
  }, f = (p) => {
    let y = Nr.get(p) ?? 0;
    o(p) && y === 0 || (y === 0 && d(p, !0), u.add(p), Nr.set(p, y + 1));
  };
  Ge.length && Ge[Ge.length - 1].disconnect(), c(a);
  let h = new MutationObserver((p) => {
    for (let y of p)
      if (y.type === "childList") {
        if (y.target.isConnected && ![
          ...i,
          ...u
        ].some(($) => ae($, y.target))) for (let $ of y.addedNodes)
          ($ instanceof HTMLElement || $ instanceof SVGElement) && od($) ? i.add($) : $ instanceof Element && c($);
        if (_t()) {
          for (let $ of s) if (!$.isConnected) {
            h.disconnect();
            break;
          }
        }
      }
  });
  h.observe(a, {
    childList: !0,
    subtree: !0
  });
  let m = /* @__PURE__ */ new Set();
  if (_t()) for (let p of s) {
    let y = new MutationObserver(($) => {
      for (let v of $)
        if (v.type === "childList") {
          if (v.target.isConnected && ![
            ...i,
            ...u
          ].some((x) => ae(x, v.target))) for (let x of v.addedNodes)
            (x instanceof HTMLElement || x instanceof SVGElement) && od(x) ? i.add(x) : x instanceof Element && c(x);
          if (_t()) {
            for (let x of s) if (!x.isConnected) {
              h.disconnect();
              break;
            }
          }
        }
    });
    y.observe(p, {
      childList: !0,
      subtree: !0
    }), m.add(y);
  }
  let b = {
    visibleNodes: i,
    hiddenNodes: u,
    observe() {
      h.observe(a, {
        childList: !0,
        subtree: !0
      });
    },
    disconnect() {
      h.disconnect();
    }
  };
  return Ge.push(b), () => {
    if (h.disconnect(), _t()) for (let p of m) p.disconnect();
    for (let p of u) {
      let y = Nr.get(p);
      y != null && (y === 1 ? (d(p, !1), Nr.delete(p)) : Nr.set(p, y - 1));
    }
    b === Ge[Ge.length - 1] ? (Ge.pop(), Ge.length && Ge[Ge.length - 1].observe()) : Ge.splice(Ge.indexOf(b), 1);
  };
}
function Mx(e) {
  let t = Ge[Ge.length - 1];
  if (t && !t.visibleNodes.has(e))
    return t.visibleNodes.add(e), () => {
      t.visibleNodes.delete(e);
    };
}
const at = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, hl = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, Kx = {
  top: "left",
  left: "top"
}, Qi = {
  top: "height",
  left: "width"
}, Xb = {
  width: "totalWidth",
  height: "totalHeight"
}, Ta = {};
let Nx = () => typeof document < "u" ? window.visualViewport : null;
function sd(e, t) {
  let n = 0, r = 0, a = 0, l = 0, i = 0, u = 0, o = {}, d = (t?.scale ?? 1) > 1;
  if (e.tagName === "BODY" || e.tagName === "HTML") {
    let s = document.documentElement;
    a = s.clientWidth, l = s.clientHeight, n = t?.width ?? a, r = t?.height ?? l, o.top = s.scrollTop || e.scrollTop, o.left = s.scrollLeft || e.scrollLeft, t && (i = t.offsetTop, u = t.offsetLeft);
  } else
    ({ width: n, height: r, top: i, left: u } = sa(e, !1)), o.top = e.scrollTop, o.left = e.scrollLeft, a = n, l = r;
  return Zd() && (e.tagName === "BODY" || e.tagName === "HTML") && d && (o.top = 0, o.left = 0, i = t?.pageTop ?? 0, u = t?.pageLeft ?? 0), {
    width: n,
    height: r,
    totalWidth: a,
    totalHeight: l,
    scroll: o,
    top: i,
    left: u
  };
}
function Vx(e) {
  return {
    top: e.scrollTop,
    left: e.scrollLeft,
    width: e.scrollWidth,
    height: e.scrollHeight
  };
}
function dd(e, t, n, r, a, l, i) {
  let u = a.scroll[e] ?? 0, o = r[Qi[e]], d = i[e] + r.scroll[at[e]] + l, s = i[e] + r.scroll[at[e]] + o - l, c = t - u + r.scroll[at[e]] + i[e] - r[at[e]], f = t - u + n + r.scroll[at[e]] + i[e] - r[at[e]];
  return c < d ? d - c : f > s ? Math.max(s - f, d - c) : 0;
}
function Lx(e) {
  let t = window.getComputedStyle(e);
  return {
    top: parseInt(t.marginTop, 10) || 0,
    bottom: parseInt(t.marginBottom, 10) || 0,
    left: parseInt(t.marginLeft, 10) || 0,
    right: parseInt(t.marginRight, 10) || 0
  };
}
function cd(e) {
  if (Ta[e]) return Ta[e];
  let [t, n] = e.split(" "), r = at[t] || "right", a = Kx[r];
  at[n] || (n = "center");
  let l = Qi[r], i = Qi[a];
  return Ta[e] = {
    placement: t,
    crossPlacement: n,
    axis: r,
    crossAxis: a,
    size: l,
    crossSize: i
  }, Ta[e];
}
function fi(e, t, n, r, a, l, i, u, o, d, s) {
  let { placement: c, crossPlacement: f, axis: h, crossAxis: m, size: b, crossSize: p } = r, y = {};
  y[m] = e[m] ?? 0, f === "center" ? y[m] += ((e[p] ?? 0) - (n[p] ?? 0)) / 2 : f !== m && (y[m] += (e[p] ?? 0) - (n[p] ?? 0)), y[m] += l;
  const $ = e[m] - n[p] + o + d, v = e[m] + e[p] - o - d;
  if (y[m] = Le(y[m], $, v), c === h) {
    let x = u ? s[b] : s[Xb[b]];
    y[hl[h]] = Math.floor(x - e[h] + a);
  } else y[h] = Math.floor(e[h] + e[b] + a);
  return y;
}
function zx(e, t, n, r, a, l, i, u, o, d, s) {
  let c = (e.top != null ? e.top : o[Xb.height] - (e.bottom ?? 0) - i) - (o.scroll.top ?? 0), f = d ? n.top : 0, h = {
    // This should be boundary top in container coord system vs viewport top in container coord system
    // For the viewport top, there are several cases
    // 1. pinchzoom case where we want the viewports offset top as top here
    // 2. case where container is offset from the boundary and is contained by the boundary. In this case the top we want here is NOT 0, we want to take boundary's top even though is is a negative number OR the visual viewport, whichever is more restrictive
    top: Math.max(t.top + f, (s?.offsetTop ?? t.top) + f),
    bottom: Math.min(t.top + t.height + f, (s?.offsetTop ?? 0) + (s?.height ?? 0))
  };
  return u !== "top" ? Math.max(0, h.bottom - // this is the bottom of the boundary
  c - // this is the top of the overlay
  ((a.top ?? 0) + (a.bottom ?? 0) + l)) : Math.max(0, c + i - // this is the bottom of the overlay
  h.top - // this is the top of the boundary
  ((a.top ?? 0) + (a.bottom ?? 0) + l));
}
function fd(e, t, n, r, a, l, i, u) {
  let { placement: o, axis: d, size: s } = l;
  return o === d ? Math.max(0, n[d] - // trigger start
  (i.scroll[d] ?? 0) - // transform trigger position to be with respect to viewport 0,0
  (e[d] + (u ? t[d] : 0)) - // boundary start
  (r[d] ?? 0) - // margins usually for arrows or other decorations
  r[hl[d]] - a) : Math.max(0, e[s] + e[d] + (u ? t[d] : 0) - n[d] - n[s] + (i.scroll[d] ?? 0) - (r[d] ?? 0) - r[hl[d]] - a);
}
function Ox(e, t, n, r, a, l, i, u, o, d, s, c, f, h, m, b, p, y) {
  let $ = cd(e), { size: v, crossAxis: x, crossSize: E, placement: P, crossPlacement: C } = $, M = fi(t, u, n, $, s, c, d, f, m, b, o), F = s, V = fd(u, d, t, a, l + s, $, o, p);
  if (i && n[v] > V) {
    let Z = cd(`${hl[P]} ${C}`), ie = fi(t, u, n, Z, s, c, d, f, m, b, o);
    fd(u, d, t, a, l + s, Z, o, p) > V && ($ = Z, M = ie, F = s);
  }
  let I = "bottom";
  $.axis === "top" ? $.placement === "top" ? I = "top" : $.placement === "bottom" && (I = "bottom") : $.crossAxis === "top" && ($.crossPlacement === "top" ? I = "bottom" : $.crossPlacement === "bottom" && (I = "top"));
  let A = dd(x, M[x], n[E], u, o, l, d);
  M[x] += A;
  let U = zx(M, u, d, f, a, l, n.height, I, o, p, y);
  h && h < U && (U = h), n.height = Math.min(n.height, U), M = fi(t, u, n, $, F, c, d, f, m, b, o), A = dd(x, M[x], n[E], u, o, l, d), M[x] += A;
  let D = {}, N = t[x] - M[x] - a[at[x]], w = N + 0.5 * t[E];
  const R = m / 2 + b, H = at[x] === "left" ? (a.left ?? 0) + (a.right ?? 0) : (a.top ?? 0) + (a.bottom ?? 0), k = n[E] - H - m / 2 - b, S = t[x] + m / 2 - (M[x] + a[at[x]]), j = t[x] + t[E] - m / 2 - (M[x] + a[at[x]]), _ = Le(w, S, j);
  D[x] = Le(_, R, k), { placement: P, crossPlacement: C } = $, m ? N = D[x] : C === "right" ? N += t[E] : C === "center" && (N += t[E] / 2);
  let B = P === "left" || P === "top" ? n[v] : 0, L = {
    x: P === "top" || P === "bottom" ? N : B,
    y: P === "left" || P === "right" ? N : B
  };
  return {
    position: M,
    maxHeight: U,
    arrowOffsetLeft: D.left,
    arrowOffsetTop: D.top,
    placement: P,
    triggerAnchorPoint: L
  };
}
function Hx(e) {
  let { placement: t, targetNode: n, overlayNode: r, scrollNode: a, padding: l, shouldFlip: i, boundaryElement: u, offset: o, crossOffset: d, maxHeight: s, arrowSize: c = 0, arrowBoundaryOffset: f = 0, targetRect: h } = e, m = Nx(), b = r instanceof HTMLElement ? Ux(r) : document.documentElement, p = b === document.documentElement;
  const y = window.getComputedStyle(b).position;
  let $ = !!y && y !== "static", v = p ? sa(n, !1, h) : hd(n, b, !1, h);
  if (!p) {
    let { marginTop: I, marginLeft: A } = window.getComputedStyle(n);
    v.top += parseInt(I, 10) || 0, v.left += parseInt(A, 10) || 0;
  }
  let x = sa(r, !0), E = Lx(r);
  x.width += (E.left ?? 0) + (E.right ?? 0), x.height += (E.top ?? 0) + (E.bottom ?? 0);
  let P = Vx(a), C = sd(u, m), M = sd(b, m), F;
  if ((u.tagName === "BODY" || u.tagName === "HTML") && !p) {
    let I = Rl(b, !1);
    F = {
      top: -(I.top - C.top),
      left: -(I.left - C.left),
      width: 0,
      height: 0
    };
  } else (u.tagName === "BODY" || u.tagName === "HTML") && p ? F = {
    top: 0,
    left: 0,
    width: 0,
    height: 0
  } : F = hd(u, b, !1);
  let V = ae(u, b);
  return Ox(t, v, x, P, E, l, i, C, M, F, o, d, $, s, c, f, V, m);
}
function Rl(e, t) {
  let { top: n, left: r, width: a, height: l } = e.getBoundingClientRect();
  return t && e instanceof e.ownerDocument.defaultView.HTMLElement && (a = e.offsetWidth, l = e.offsetHeight), {
    top: n,
    left: r,
    width: a,
    height: l
  };
}
function sa(e, t, n) {
  let { top: r, left: a, width: l, height: i } = n || Rl(e, t), { scrollTop: u, scrollLeft: o, clientTop: d, clientLeft: s } = document.documentElement;
  return {
    top: r + u - d,
    left: a + o - s,
    width: l,
    height: i
  };
}
function hd(e, t, n, r) {
  let a = window.getComputedStyle(e), l;
  if (a.position === "fixed") l = r || Rl(e, n);
  else {
    l = sa(e, n, r);
    let i = sa(t, n), u = window.getComputedStyle(t);
    i.top += (parseInt(u.borderTopWidth, 10) || 0) - t.scrollTop, i.left += (parseInt(u.borderLeftWidth, 10) || 0) - t.scrollLeft, l.top -= i.top, l.left -= i.left;
  }
  return l.top -= parseInt(a.marginTop, 10) || 0, l.left -= parseInt(a.marginLeft, 10) || 0, l;
}
function Ux(e) {
  let t = e.offsetParent;
  if (t && t === document.body && window.getComputedStyle(t).position === "static" && !md(t) && (t = document.documentElement), t == null)
    for (t = e.parentElement; t && !md(t); ) t = t.parentElement;
  return t || document.documentElement;
}
function md(e) {
  let t = window.getComputedStyle(e);
  return t.transform !== "none" || /transform|perspective/.test(t.willChange) || t.filter !== "none" || t.contain === "paint" || "backdropFilter" in t && t.backdropFilter !== "none" || "WebkitBackdropFilter" in t && t.WebkitBackdropFilter !== "none";
}
const Jb = /* @__PURE__ */ new WeakMap();
function jx(e) {
  let { triggerRef: t, isOpen: n, onClose: r } = e;
  ee(() => {
    if (!n || r === null) return;
    let a = (l) => {
      let i = W(l);
      if (!t.current || i instanceof Node && !ae(i, t.current) || i instanceof HTMLInputElement || i instanceof HTMLTextAreaElement) return;
      let u = r || Jb.get(t.current);
      u && u();
    };
    return window.addEventListener("scroll", a, !0), () => {
      window.removeEventListener("scroll", a, !0);
    };
  }, [
    n,
    r,
    t
  ]);
}
function _x() {
  return typeof window.ResizeObserver < "u";
}
function yr(e) {
  const { ref: t, box: n, onResize: r } = e;
  let a = xe(r);
  ee(() => {
    let l = t?.current;
    if (l)
      if (_x()) {
        const i = new window.ResizeObserver((u) => {
          u.length && a();
        });
        return i.observe(l, {
          box: n
        }), () => {
          l && i.unobserve(l);
        };
      } else
        return window.addEventListener("resize", a, !1), () => {
          window.removeEventListener("resize", a, !1);
        };
  }, [
    t,
    n
  ]);
}
let Pn = typeof document < "u" ? window.visualViewport : null;
function Qb(e) {
  let { direction: t } = de(), { arrowSize: n, targetRef: r, overlayRef: a, arrowRef: l, scrollRef: i = a, placement: u = "bottom", containerPadding: o = 12, shouldFlip: d = !0, boundaryElement: s = typeof document < "u" ? document.body : null, offset: c = 0, crossOffset: f = 0, shouldUpdatePosition: h = !0, isOpen: m = !0, onClose: b, maxHeight: p, arrowBoundaryOffset: y = 0, getTargetRect: $ } = e, [v, x] = Y(null), E = [
    h,
    u,
    a.current,
    r.current,
    l?.current,
    i.current,
    o,
    d,
    s,
    c,
    f,
    m,
    t,
    p,
    y,
    n
  ], P = T(Pn?.scale);
  ee(() => {
    m && (P.current = Pn?.scale);
  }, [
    m
  ]);
  let C = X(() => {
    if (h === !1 || !m || !a.current || !r.current || !s || Pn?.scale !== P.current) return;
    let V = null;
    if (i.current && Yt(i.current)) {
      let D = se()?.getBoundingClientRect(), N = i.current.getBoundingClientRect();
      V = {
        type: "top",
        offset: (D?.top ?? 0) - N.top
      }, V.offset > N.height / 2 && (V.type = "bottom", V.offset = (D?.bottom ?? 0) - N.bottom);
    }
    let I = a.current;
    !p && a.current && (I.style.top = "0px", I.style.bottom = "", I.style.maxHeight = (window.visualViewport?.height ?? window.innerHeight) + "px");
    let A = Hx({
      placement: Gx(u, t),
      overlayNode: a.current,
      targetNode: r.current,
      scrollNode: i.current || a.current,
      padding: o,
      shouldFlip: d,
      boundaryElement: s,
      offset: c,
      crossOffset: f,
      maxHeight: p,
      arrowSize: n ?? (l?.current ? Rl(l.current, !0).width : 0),
      arrowBoundaryOffset: y,
      targetRect: $?.(r.current)
    });
    if (!A.position) return;
    I.style.top = "", I.style.bottom = "", I.style.left = "", I.style.right = "", Object.keys(A.position).forEach((D) => I.style[D] = A.position[D] + "px"), I.style.maxHeight = A.maxHeight != null ? A.maxHeight + "px" : "";
    let U = se();
    if (V && U && i.current) {
      let D = U.getBoundingClientRect(), N = i.current.getBoundingClientRect(), w = D[V.type] - N[V.type];
      i.current.scrollTop += w - V.offset;
    }
    x(A);
  }, E);
  ue(C, E), Wx(C), yr({
    ref: a,
    onResize: C
  }), yr({
    ref: r,
    onResize: C
  });
  let M = T(!1);
  ue(() => {
    let V, I = () => {
      M.current = !0, clearTimeout(V), V = setTimeout(() => {
        M.current = !1;
      }, 500), C();
    }, A = () => {
      M.current && I();
    };
    return Pn?.addEventListener("resize", I), Pn?.addEventListener("scroll", A), () => {
      Pn?.removeEventListener("resize", I), Pn?.removeEventListener("scroll", A);
    };
  }, [
    C
  ]);
  let F = X(() => {
    M.current || b?.();
  }, [
    b,
    M
  ]);
  return jx({
    triggerRef: r,
    isOpen: m,
    onClose: b && F
  }), {
    overlayProps: {
      style: {
        position: v ? "absolute" : "fixed",
        top: v ? void 0 : 0,
        left: v ? void 0 : 0,
        zIndex: 1e5,
        ...v?.position,
        maxHeight: v?.maxHeight ?? "100vh"
      }
    },
    placement: v?.placement ?? null,
    triggerAnchorPoint: v?.triggerAnchorPoint ?? null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: v?.arrowOffsetLeft,
        top: v?.arrowOffsetTop
      }
    },
    updatePosition: C
  };
}
function Wx(e) {
  ue(() => (window.addEventListener("resize", e, !1), () => {
    window.removeEventListener("resize", e, !1);
  }), [
    e
  ]);
}
function Gx(e, t) {
  return t === "rtl" ? e.replace("start", "right").replace("end", "left") : e.replace("start", "left").replace("end", "right");
}
function qx(e) {
  let { ref: t, onInteractOutside: n, isDisabled: r, onInteractOutsideStart: a } = e, l = T({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }), i = xe((o) => {
    n && Ia(o, t) && (a && a(o), l.current.isPointerDown = !0);
  }), u = xe((o) => {
    n && n(o);
  });
  ee(() => {
    let o = l.current;
    if (r) return;
    const d = t.current, s = he(d);
    if (typeof PointerEvent < "u") {
      let c = (f) => {
        o.isPointerDown && Ia(f, t) && u(f), o.isPointerDown = !1;
      };
      return s.addEventListener("pointerdown", i, !0), s.addEventListener("click", c, !0), () => {
        s.removeEventListener("pointerdown", i, !0), s.removeEventListener("click", c, !0);
      };
    } else if (process.env.NODE_ENV === "test") {
      let c = (h) => {
        o.ignoreEmulatedMouseEvents ? o.ignoreEmulatedMouseEvents = !1 : o.isPointerDown && Ia(h, t) && u(h), o.isPointerDown = !1;
      }, f = (h) => {
        o.ignoreEmulatedMouseEvents = !0, o.isPointerDown && Ia(h, t) && u(h), o.isPointerDown = !1;
      };
      return s.addEventListener("mousedown", i, !0), s.addEventListener("mouseup", c, !0), s.addEventListener("touchstart", i, !0), s.addEventListener("touchend", f, !0), () => {
        s.removeEventListener("mousedown", i, !0), s.removeEventListener("mouseup", c, !0), s.removeEventListener("touchstart", i, !0), s.removeEventListener("touchend", f, !0);
      };
    }
  }, [
    t,
    r
  ]);
}
function Ia(e, t) {
  if (e.button > 0) return !1;
  let n = W(e);
  if (n) {
    const r = n.ownerDocument;
    if (!r || !ae(r.documentElement, n) || n.closest("[data-react-aria-top-layer]")) return !1;
  }
  return t.current ? !e.composedPath().includes(t.current) : !1;
}
const Rt = [];
function ep(e, t) {
  let { onClose: n, shouldCloseOnBlur: r, isOpen: a, isDismissable: l = !1, isKeyboardDismissDisabled: i = !1, shouldCloseOnInteractOutside: u } = e, o = T(void 0);
  ee(() => {
    if (a && !Rt.includes(t))
      return Rt.push(t), () => {
        let m = Rt.indexOf(t);
        m >= 0 && Rt.splice(m, 1);
      };
  }, [
    a,
    t
  ]);
  let d = () => {
    Rt[Rt.length - 1] === t && n && n();
  }, s = (m) => {
    const b = Rt[Rt.length - 1];
    o.current = b, (!u || u(W(m))) && b === t && m.stopPropagation();
  }, c = (m) => {
    (!u || u(W(m))) && (Rt[Rt.length - 1] === t && m.stopPropagation(), o.current === t && d()), o.current = void 0;
  }, f = (m) => {
    m.key === "Escape" && !i && !m.nativeEvent.isComposing && (m.stopPropagation(), m.preventDefault(), d());
  };
  qx({
    ref: t,
    onInteractOutside: l && a ? c : void 0,
    onInteractOutsideStart: s
  });
  let { focusWithinProps: h } = ft({
    isDisabled: !r,
    onBlurWithin: (m) => {
      !m.relatedTarget || sx(m.relatedTarget) || (!u || u(m.relatedTarget)) && n?.();
    }
  });
  return {
    overlayProps: {
      onKeyDown: f,
      ...h
    },
    underlayProps: {}
  };
}
const Gr = typeof document < "u" && window.visualViewport;
let Ma = 0, hi;
function tp(e = {}) {
  let { isDisabled: t } = e;
  ue(() => {
    if (!t)
      return Ma++, Ma === 1 && (xt() ? hi = Zx() : hi = Yx()), () => {
        Ma--, Ma === 0 && hi();
      };
  }, [
    t
  ]);
}
function Yx() {
  let e = window.innerWidth - document.documentElement.clientWidth;
  return st(e > 0 && // Use scrollbar-gutter when supported because it also works for fixed positioned elements.
  ("scrollbarGutter" in document.documentElement.style ? Ua(document.documentElement, "scrollbarGutter", "stable") : Ua(document.documentElement, "paddingRight", `${e}px`)), Ua(document.documentElement, "overflow", "hidden"));
}
function Zx() {
  let e = Ua(document.documentElement, "overflow", "hidden"), t, n = !1, r = (s) => {
    let c = W(s);
    t = yn(c) ? c : ze(c, !0), n = !1;
    let f = c.ownerDocument.defaultView.getSelection();
    f && !f.isCollapsed && f.containsNode(c, !0) && (n = !0), s.composedPath().some((h) => h instanceof HTMLInputElement && h.type === "range") && (n = !0), "selectionStart" in c && "selectionEnd" in c && c.selectionStart < c.selectionEnd && c.ownerDocument.activeElement === c && (n = !0);
  }, a = document.createElement("style"), l = ef();
  l && (a.nonce = l), a.textContent = `
@layer {
  * {
    overscroll-behavior: contain;
  }
}`.trim(), document.head.prepend(a);
  let i = (s) => {
    if (!(s.touches.length === 2 || n)) {
      if (!t || t === document.documentElement || t === document.body) {
        s.preventDefault();
        return;
      }
      t.scrollHeight === t.clientHeight && t.scrollWidth === t.clientWidth && s.preventDefault();
    }
  }, u = (s) => {
    let c = W(s), f = s.relatedTarget;
    f && _r(f) ? (f.focus({
      preventScroll: !0
    }), bd(f, _r(c))) : f || c.parentElement?.closest("[tabindex]")?.focus({
      preventScroll: !0
    });
  }, o = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function(s) {
    let c = se(), f = c != null && _r(c);
    o.call(this, {
      ...s,
      preventScroll: !0
    }), (!s || !s.preventScroll) && bd(this, f);
  };
  let d = st(mi(document, "touchstart", r, {
    passive: !1,
    capture: !0
  }), mi(document, "touchmove", i, {
    passive: !1,
    capture: !0
  }), mi(document, "blur", u, !0));
  return () => {
    e(), d(), a.remove(), HTMLElement.prototype.focus = o;
  };
}
function Ua(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function mi(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function bd(e, t) {
  t || !Gr ? pd(e) : Gr.addEventListener("resize", () => pd(e), {
    once: !0
  });
}
function pd(e) {
  let t = document.scrollingElement || document.documentElement, n = e;
  for (; n && n !== t; ) {
    let r = ze(n);
    if (r !== document.documentElement && r !== document.body && r !== n) {
      let a = r.getBoundingClientRect(), l = n.getBoundingClientRect();
      if (l.top < a.top || l.bottom > a.top + n.clientHeight) {
        let i = a.bottom;
        Gr && (i = Math.min(i, Gr.offsetTop + Gr.height));
        let u = l.top - a.top - ((i - a.top) / 2 - l.height / 2);
        r.scrollTo({
          // Clamp to the valid range to prevent over-scrolling.
          top: Math.max(0, Math.min(r.scrollHeight - r.clientHeight, r.scrollTop + u)),
          behavior: "smooth"
        });
      }
    }
    n = r.parentElement;
  }
}
function Xx(e, t) {
  let { triggerRef: n, popoverRef: r, groupRef: a, isNonModal: l, isKeyboardDismissDisabled: i, shouldCloseOnInteractOutside: u, ...o } = e, d = o.trigger === "SubmenuTrigger", { overlayProps: s, underlayProps: c } = ep({
    isOpen: t.isOpen,
    onClose: t.close,
    shouldCloseOnBlur: !0,
    isDismissable: !l || d,
    isKeyboardDismissDisabled: i,
    shouldCloseOnInteractOutside: u
  }, a ?? r), { overlayProps: f, arrowProps: h, placement: m, triggerAnchorPoint: b } = Qb({
    ...o,
    targetRef: n,
    overlayRef: r,
    isOpen: t.isOpen,
    onClose: l && !d ? t.close : null
  });
  return tp({
    isDisabled: l || !t.isOpen
  }), ee(() => {
    if (t.isOpen && r.current)
      return l ? Mx(a?.current ?? r.current) : Zb([
        a?.current ?? r.current
      ], {
        shouldUseInert: !0
      });
  }, [
    l,
    t.isOpen,
    r,
    a
  ]), {
    popoverProps: z(s, f),
    arrowProps: h,
    underlayProps: c,
    placement: m,
    triggerAnchorPoint: b
  };
}
var np = {};
np = {
  dismiss: "تجاهل"
};
var rp = {};
rp = {
  dismiss: "Отхвърляне"
};
var ap = {};
ap = {
  dismiss: "Odstranit"
};
var lp = {};
lp = {
  dismiss: "Luk"
};
var ip = {};
ip = {
  dismiss: "Schließen"
};
var up = {};
up = {
  dismiss: "Απόρριψη"
};
var op = {};
op = {
  dismiss: "Dismiss"
};
var sp = {};
sp = {
  dismiss: "Descartar"
};
var dp = {};
dp = {
  dismiss: "Lõpeta"
};
var cp = {};
cp = {
  dismiss: "Hylkää"
};
var fp = {};
fp = {
  dismiss: "Rejeter"
};
var hp = {};
hp = {
  dismiss: "התעלם"
};
var mp = {};
mp = {
  dismiss: "Odbaci"
};
var bp = {};
bp = {
  dismiss: "Elutasítás"
};
var pp = {};
pp = {
  dismiss: "Ignora"
};
var gp = {};
gp = {
  dismiss: "閉じる"
};
var yp = {};
yp = {
  dismiss: "무시"
};
var $p = {};
$p = {
  dismiss: "Atmesti"
};
var vp = {};
vp = {
  dismiss: "Nerādīt"
};
var Dp = {};
Dp = {
  dismiss: "Lukk"
};
var xp = {};
xp = {
  dismiss: "Negeren"
};
var Ep = {};
Ep = {
  dismiss: "Zignoruj"
};
var Cp = {};
Cp = {
  dismiss: "Descartar"
};
var Pp = {};
Pp = {
  dismiss: "Dispensar"
};
var wp = {};
wp = {
  dismiss: "Revocare"
};
var Sp = {};
Sp = {
  dismiss: "Пропустить"
};
var kp = {};
kp = {
  dismiss: "Zrušiť"
};
var Bp = {};
Bp = {
  dismiss: "Opusti"
};
var Fp = {};
Fp = {
  dismiss: "Odbaci"
};
var Ap = {};
Ap = {
  dismiss: "Avvisa"
};
var Rp = {};
Rp = {
  dismiss: "Kapat"
};
var Tp = {};
Tp = {
  dismiss: "Скасувати"
};
var Ip = {};
Ip = {
  dismiss: "取消"
};
var Mp = {};
Mp = {
  dismiss: "關閉"
};
var Kp = {};
Kp = {
  "ar-AE": np,
  "bg-BG": rp,
  "cs-CZ": ap,
  "da-DK": lp,
  "de-DE": ip,
  "el-GR": up,
  "en-US": op,
  "es-ES": sp,
  "et-EE": dp,
  "fi-FI": cp,
  "fr-FR": fp,
  "he-IL": hp,
  "hr-HR": mp,
  "hu-HU": bp,
  "it-IT": pp,
  "ja-JP": gp,
  "ko-KR": yp,
  "lt-LT": $p,
  "lv-LV": vp,
  "nb-NO": Dp,
  "nl-NL": xp,
  "pl-PL": Ep,
  "pt-BR": Cp,
  "pt-PT": Pp,
  "ro-RO": wp,
  "ru-RU": Sp,
  "sk-SK": kp,
  "sl-SI": Bp,
  "sr-SP": Fp,
  "sv-SE": Ap,
  "tr-TR": Rp,
  "uk-UA": Tp,
  "zh-CN": Ip,
  "zh-TW": Mp
};
function Jx(e) {
  return e && e.__esModule ? e.default : e;
}
function eu(e) {
  let { onDismiss: t, ...n } = e, r = Ee(Jx(Kp), "@react-aria/overlays"), a = ut(n, r.format("dismiss")), l = () => {
    t && t();
  };
  return /* @__PURE__ */ g.createElement(gr, null, /* @__PURE__ */ g.createElement("button", {
    ...a,
    tabIndex: -1,
    onClick: l,
    style: {
      width: 1,
      height: 1
    }
  }));
}
const Np = /* @__PURE__ */ g.forwardRef(({ children: e, ...t }, n) => {
  let r = T(!1), a = O(Jr), l = z(a || {}, {
    ...t,
    register() {
      r.current = !0, a && a.register();
    }
  });
  return l.ref = $e(n || a?.ref), xu(a, l.ref), ee(() => {
    r.current || (process.env.NODE_ENV !== "production" && console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component."), r.current = !0);
  }, []), /* @__PURE__ */ g.createElement(Jr.Provider, {
    value: l
  }, e);
});
function Qx({ children: e }) {
  let t = K(() => ({
    register: () => {
    }
  }), []);
  return /* @__PURE__ */ g.createElement(Jr.Provider, {
    value: t
  }, e);
}
const e7 = /* @__PURE__ */ G({});
function so() {
  return O(e7) ?? {};
}
const Vp = /* @__PURE__ */ g.createContext(null);
function tu(e) {
  let t = Ct(), { portalContainer: n = t ? null : document.body, isExiting: r } = e, [a, l] = Y(!1), i = K(() => ({
    contain: a,
    setContain: l
  }), [
    a,
    l
  ]), { getContainer: u } = so();
  if (!e.portalContainer && u && (n = u()), !n) return null;
  let o = e.children;
  return e.disableFocusManagement || (o = /* @__PURE__ */ g.createElement(Bl, {
    restoreFocus: !0,
    contain: (e.shouldContainFocus || a) && !r
  }, o)), o = /* @__PURE__ */ g.createElement(Vp.Provider, {
    value: i
  }, /* @__PURE__ */ g.createElement(Qx, null, o)), /* @__PURE__ */ fu.createPortal(o, n);
}
function Lp() {
  let t = O(Vp)?.setContain;
  ue(() => {
    t?.(!0);
  }, [
    t
  ]);
}
function Fr(e) {
  let [t, n] = we(e.isOpen, e.defaultOpen || !1, e.onOpenChange);
  const r = X(() => {
    n(!0);
  }, [
    n
  ]), a = X(() => {
    n(!1);
  }, [
    n
  ]), l = X(() => {
    n(!t);
  }, [
    n,
    t
  ]);
  return {
    isOpen: t,
    setOpen: n,
    open: r,
    close: a,
    toggle: l
  };
}
function xa(e, t = !0) {
  let [n, r] = Y(!0), a = n && t;
  return ue(() => {
    if (a && e.current && "getAnimations" in e.current)
      for (let l of e.current.getAnimations()) l instanceof CSSTransition && l.cancel();
  }, [
    e,
    a
  ]), zp(e, a, X(() => r(!1), [])), a;
}
function da(e, t) {
  let [n, r] = Y(t ? "open" : "closed");
  switch (n) {
    case "open":
      t || r("exiting");
      break;
    case "closed":
    case "exiting":
      t && r("open");
      break;
  }
  let a = n === "exiting";
  return zp(e, a, X(() => {
    r((l) => l === "exiting" ? "closed" : l);
  }, [])), a;
}
function zp(e, t, n) {
  ue(() => {
    if (t && e.current) {
      if (!("getAnimations" in e.current)) {
        n();
        return;
      }
      let r = e.current.getAnimations();
      if (r.length === 0) {
        n();
        return;
      }
      let a = !1;
      return Promise.allSettled(r.map((l) => l.finished)).then(() => {
        a || lt(() => {
          n();
        });
      }), () => {
        a = !0;
      };
    }
  }, [
    e,
    t,
    n
  ]);
}
const Ar = /* @__PURE__ */ G(null), gd = /* @__PURE__ */ G(null), xC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Ar);
  let r = O(Ot), a = Fr(t), l = t.isOpen != null || t.defaultOpen != null || !r ? a : r, i = da(n, l.isOpen) || t.isExiting || !1, u = qc(), { direction: o } = de();
  if (u) {
    let d = t.children;
    return typeof d == "function" && (d = d({
      trigger: t.trigger || null,
      placement: "bottom",
      isEntering: !1,
      isExiting: !1,
      defaultChildren: null
    })), /* @__PURE__ */ g.createElement(g.Fragment, null, d);
  }
  return l && !l.isOpen && !i ? null : /* @__PURE__ */ g.createElement(t7, {
    ...t,
    triggerRef: t.triggerRef,
    state: l,
    popoverRef: n,
    isExiting: i,
    dir: o
  });
});
function t7({ state: e, isExiting: t, UNSTABLE_portalContainer: n, clearContexts: r, ...a }) {
  let l = T(null), i = T(null), u = O(gd), o = u && a.trigger === "SubmenuTrigger", { popoverProps: d, underlayProps: s, arrowProps: c, placement: f, triggerAnchorPoint: h } = Xx({
    ...a,
    offset: a.offset ?? 8,
    arrowRef: l,
    // If this is a submenu/subdialog, use the root popover's container
    // to detect outside interaction and add aria-hidden.
    groupRef: o ? u : i
  }, e), m = a.popoverRef, b = xa(m, !!f) || a.isEntering || !1, p = le({
    ...a,
    defaultClassName: "react-aria-Popover",
    values: {
      trigger: a.trigger || null,
      placement: f,
      isEntering: b,
      isExiting: t
    }
  }), y = !a.isNonModal || a.trigger === "SubmenuTrigger", [$, v] = Y(!1);
  ue(() => {
    m.current && v(y && !m.current.querySelector("[role=dialog]"));
  }, [
    m,
    y
  ]), ee(() => {
    $ && (a.trigger !== "SubmenuTrigger" || vt() !== "pointer") && m.current && !Yt(m.current) && Se(m.current);
  }, [
    $,
    m,
    a.trigger
  ]);
  let x = K(() => {
    let V = p.children;
    if (r) for (let I of r) V = /* @__PURE__ */ g.createElement(I.Provider, {
      value: null
    }, V);
    return V;
  }, [
    p.children,
    r
  ]), [E, P] = Y(null), C = X(() => {
    a.triggerRef.current && P(a.triggerRef.current.getBoundingClientRect().width + "px");
  }, [
    a.triggerRef
  ]);
  ue(C, [
    C
  ]), yr({
    ref: p.style?.["--trigger-width"] ? void 0 : a.triggerRef,
    onResize: C
  });
  let M = {
    ...d.style,
    "--trigger-anchor-point": h ? `${h.x}px ${h.y}px` : void 0,
    ...p.style,
    "--trigger-width": p.style?.["--trigger-width"] || E
  }, F = /* @__PURE__ */ g.createElement(Q.div, {
    ...z(J(a, {
      global: !0
    }), d),
    ...p,
    role: $ ? "dialog" : void 0,
    tabIndex: $ ? -1 : void 0,
    "aria-label": a["aria-label"],
    "aria-labelledby": a["aria-labelledby"],
    ref: m,
    slot: a.slot || void 0,
    style: M,
    dir: a.dir,
    "data-trigger": a.trigger,
    "data-placement": f,
    "data-entering": b || void 0,
    "data-exiting": t || void 0
  }, !a.isNonModal && /* @__PURE__ */ g.createElement(eu, {
    onDismiss: e.close
  }), /* @__PURE__ */ g.createElement(Yb.Provider, {
    value: {
      ...c,
      placement: f,
      ref: l
    }
  }, x), /* @__PURE__ */ g.createElement(eu, {
    onDismiss: e.close
  }));
  return o ? /* @__PURE__ */ g.createElement(tu, {
    ...a,
    shouldContainFocus: $,
    isExiting: t,
    portalContainer: n ?? u?.current ?? void 0
  }, F) : /* @__PURE__ */ g.createElement(tu, {
    ...a,
    shouldContainFocus: $,
    isExiting: t,
    portalContainer: n
  }, !a.isNonModal && e.isOpen && /* @__PURE__ */ g.createElement("div", {
    "data-testid": "underlay",
    ...s,
    style: {
      position: "fixed",
      inset: 0
    }
  }), /* @__PURE__ */ g.createElement("div", {
    ref: i,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ g.createElement(gd.Provider, {
    value: i
  }, F)));
}
const n7 = /* @__PURE__ */ G({});
var Op = {};
Op = {
  longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
};
var Hp = {};
Hp = {
  longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
};
var Up = {};
Up = {
  longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
};
var jp = {};
jp = {
  longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
};
var _p = {};
_p = {
  longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
};
var Wp = {};
Wp = {
  longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
};
var Gp = {};
Gp = {
  longPressMessage: "Long press or press Alt + ArrowDown to open menu"
};
var qp = {};
qp = {
  longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
};
var Yp = {};
Yp = {
  longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
};
var Zp = {};
Zp = {
  longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
};
var Xp = {};
Xp = {
  longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
};
var Jp = {};
Jp = {
  longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
};
var Qp = {};
Qp = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var eg = {};
eg = {
  longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
};
var tg = {};
tg = {
  longPressMessage: "Premi a lungo o premi Alt + Freccia giù per aprire il menu"
};
var ng = {};
ng = {
  longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
};
var rg = {};
rg = {
  longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
};
var ag = {};
ag = {
  longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
};
var lg = {};
lg = {
  longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
};
var ig = {};
ig = {
  longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
};
var ug = {};
ug = {
  longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var og = {};
og = {
  longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
};
var sg = {};
sg = {
  longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var dg = {};
dg = {
  longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var cg = {};
cg = {
  longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
};
var fg = {};
fg = {
  longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
};
var hg = {};
hg = {
  longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
};
var mg = {};
mg = {
  longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
};
var bg = {};
bg = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var pg = {};
pg = {
  longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
};
var gg = {};
gg = {
  longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
};
var yg = {};
yg = {
  longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
};
var $g = {};
$g = {
  longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
};
var vg = {};
vg = {
  longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
};
var Dg = {};
Dg = {
  "ar-AE": Op,
  "bg-BG": Hp,
  "cs-CZ": Up,
  "da-DK": jp,
  "de-DE": _p,
  "el-GR": Wp,
  "en-US": Gp,
  "es-ES": qp,
  "et-EE": Yp,
  "fi-FI": Zp,
  "fr-FR": Xp,
  "he-IL": Jp,
  "hr-HR": Qp,
  "hu-HU": eg,
  "it-IT": tg,
  "ja-JP": ng,
  "ko-KR": rg,
  "lt-LT": ag,
  "lv-LV": lg,
  "nb-NO": ig,
  "nl-NL": ug,
  "pl-PL": og,
  "pt-BR": sg,
  "pt-PT": dg,
  "ro-RO": cg,
  "ru-RU": fg,
  "sk-SK": hg,
  "sl-SI": mg,
  "sr-SP": bg,
  "sv-SE": pg,
  "tr-TR": gg,
  "uk-UA": yg,
  "zh-CN": $g,
  "zh-TW": vg
};
function xg(e, t, n) {
  let { type: r } = e, { isOpen: a } = t;
  ee(() => {
    n && n.current && Jb.set(n.current, t.close);
  });
  let l;
  r === "menu" ? l = !0 : r === "listbox" && (l = "listbox");
  let i = ce();
  return {
    triggerProps: {
      "aria-haspopup": l,
      "aria-expanded": a,
      "aria-controls": a ? i : void 0,
      onPress: t.toggle
    },
    overlayProps: {
      id: i
    }
  };
}
function r7(e) {
  return e && e.__esModule ? e.default : e;
}
function Eg(e, t, n) {
  let { type: r = "menu", isDisabled: a, trigger: l = "press" } = e, i = ce(), { triggerProps: u, overlayProps: o } = xg({
    type: r
  }, t, n), d = (h) => {
    if (!a && !(l === "longPress" && !h.altKey) && n && n.current)
      switch (h.key) {
        case "Enter":
        case " ":
          if (l === "longPress" || h.isDefaultPrevented()) return;
        // fallthrough
        case "ArrowDown":
          "continuePropagation" in h || h.stopPropagation(), h.preventDefault(), t.toggle("first");
          break;
        case "ArrowUp":
          "continuePropagation" in h || h.stopPropagation(), h.preventDefault(), t.toggle("last");
          break;
        default:
          "continuePropagation" in h && h.continuePropagation();
      }
  }, s = Ee(r7(Dg), "@react-aria/menu"), { longPressProps: c } = zb({
    isDisabled: a || l !== "longPress",
    accessibilityDescription: s.format("longPressMessage"),
    onLongPressStart() {
      t.close();
    },
    onLongPress() {
      t.open("first");
    }
  }), f = {
    preventFocusOnPress: !0,
    onPressStart(h) {
      h.pointerType !== "touch" && h.pointerType !== "keyboard" && !a && (Ae(h.target), t.open(h.pointerType === "virtual" ? "first" : null));
    },
    onPress(h) {
      h.pointerType === "touch" && !a && (Ae(h.target), t.toggle());
    }
  };
  return delete u.onPress, {
    // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
    menuTriggerProps: {
      ...u,
      ...l === "press" ? f : c,
      id: i,
      onKeyDown: d
    },
    menuProps: {
      ...o,
      "aria-labelledby": i,
      autoFocus: t.focusStrategy || !0,
      onClose: t.close
    }
  };
}
const Cg = /* @__PURE__ */ new WeakMap();
function a7(e, t, n) {
  let { shouldFocusWrap: r = !0, onKeyDown: a, onKeyUp: l, ...i } = e;
  !e["aria-label"] && !e["aria-labelledby"] && process.env.NODE_ENV !== "production" && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let u = J(e, {
    labelable: !0
  }), { listProps: o } = io({
    ...i,
    ref: n,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    shouldFocusWrap: r,
    linkBehavior: "override"
  });
  return Cg.set(t, {
    onClose: e.onClose,
    onAction: e.onAction,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus
  }), {
    menuProps: z(u, {
      onKeyDown: a,
      onKeyUp: l
    }, {
      role: "menu",
      ...o,
      onKeyDown: (d) => {
        (d.key !== "Escape" || e.shouldUseVirtualFocus) && o.onKeyDown?.(d);
      }
    })
  };
}
function l7(e, t, n) {
  let { id: r, key: a, closeOnSelect: l, shouldCloseOnSelect: i, isVirtualized: u, "aria-haspopup": o, onPressStart: d, onPressUp: s, onPress: c, onPressChange: f, onPressEnd: h, onClick: m, onHoverStart: b, onHoverChange: p, onHoverEnd: y, onKeyDown: $, onKeyUp: v, onFocus: x, onFocusChange: E, onBlur: P, selectionManager: C = t.selectionManager } = e, M = !!o, F = M && e["aria-expanded"] === "true", V = e.isDisabled ?? C.isDisabled(a), I = e.isSelected ?? C.isSelected(a), A = Cg.get(t), U = t.collection.getItem(a), D = e.onClose || A.onClose, N = xr(), w = () => {
    if (!M && (U?.props?.onAction ? U.props.onAction() : e.onAction && e.onAction(a), A.onAction)) {
      let be = A.onAction;
      be(a, U?.value);
    }
  }, R = "menuitem";
  M || (C.selectionMode === "single" ? R = "menuitemradio" : C.selectionMode === "multiple" && (R = "menuitemcheckbox"));
  let H = yt(), k = yt(), S = yt(), j = {
    id: r,
    "aria-disabled": V || void 0,
    role: R,
    "aria-label": e["aria-label"],
    "aria-labelledby": H,
    "aria-describedby": [
      e["aria-describedby"],
      k,
      S
    ].filter(Boolean).join(" ") || void 0,
    "aria-controls": e["aria-controls"],
    "aria-haspopup": o,
    "aria-expanded": e["aria-expanded"]
  };
  if (C.selectionMode !== "none" && !M && (j["aria-checked"] = I), u) {
    let be = Number(U?.index);
    j["aria-posinset"] = Number.isNaN(be) ? void 0 : be + 1, j["aria-setsize"] = Ob(t.collection);
  }
  let _ = T(!1), B = (be) => {
    f?.(be), _.current = be;
  }, L = T(null), Z = (be) => {
    be.pointerType !== "keyboard" && (L.current = {
      pointerType: be.pointerType
    }), be.pointerType === "mouse" && (_.current || be.target.click()), s?.(be);
  }, ie = (be) => {
    m?.(be), w(), tc(be, N, U.props.href, U?.props.routerOptions);
    let ln = L.current?.pointerType === "keyboard" ? L.current?.key === "Enter" || C.selectionMode === "none" || C.isLink(a) : C.selectionMode !== "multiple" || C.isLink(a);
    ln = i ?? l ?? ln, D && !M && ln && D(), L.current = null;
  }, { itemProps: q, isFocused: re } = kr({
    id: r,
    selectionManager: C,
    key: a,
    ref: n,
    shouldSelectOnPressUp: !0,
    allowsDifferentPressOrigin: !0,
    // Disable all handling of links in useSelectable item
    // because we handle it ourselves. The behavior of menus
    // is slightly different from other collections because
    // actions are performed on key down rather than key up.
    linkBehavior: "none",
    shouldUseVirtualFocus: A.shouldUseVirtualFocus
  }), { pressProps: fe, isPressed: tt } = Je({
    onPressStart: d,
    onPress: c,
    onPressUp: Z,
    onPressChange: B,
    onPressEnd: h,
    isDisabled: V
  }), { hoverProps: ht } = De({
    isDisabled: V,
    onHoverStart(be) {
      !Vt() && !(F && o) && (C.setFocused(!0), C.setFocusedKey(a)), b?.(be);
    },
    onHoverChange: p,
    onHoverEnd: y
  }), { keyboardProps: qn } = Cr({
    onKeyDown: (be) => {
      if (be.repeat) {
        be.continuePropagation();
        return;
      }
      switch (be.key) {
        case " ":
          L.current = {
            pointerType: "keyboard",
            key: " "
          }, W(be).click(), Yr("keyboard");
          break;
        case "Enter":
          L.current = {
            pointerType: "keyboard",
            key: "Enter"
          }, W(be).tagName !== "A" && W(be).click(), Yr("keyboard");
          break;
        default:
          M || be.continuePropagation(), $?.(be);
          break;
      }
    },
    onKeyUp: v
  }), { focusableProps: Ut } = ct({
    onBlur: P,
    onFocus: x,
    onFocusChange: E
  }, n), Yn = J(U?.props);
  delete Yn.id;
  let Zn = $l(U?.props);
  return {
    menuItemProps: {
      ...j,
      ...z(
        Yn,
        Zn,
        M ? {
          onFocus: q.onFocus,
          "data-collection": q["data-collection"],
          "data-key": q["data-key"]
        } : q,
        fe,
        ht,
        qn,
        Ut,
        // Prevent DOM focus from moving on mouse down when using virtual focus or this is a submenu/subdialog trigger.
        A.shouldUseVirtualFocus || M ? {
          onMouseDown: (be) => be.preventDefault()
        } : void 0,
        V ? void 0 : {
          onClick: ie
        }
      ),
      // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
      tabIndex: q.tabIndex != null && F && !A.shouldUseVirtualFocus ? -1 : q.tabIndex
    },
    labelProps: {
      id: H
    },
    descriptionProps: {
      id: k
    },
    keyboardShortcutProps: {
      id: S
    },
    isFocused: re,
    isFocusVisible: re && C.isFocused && Vt() && !F,
    isSelected: I,
    isPressed: tt,
    isDisabled: V
  };
}
function i7(e) {
  let { heading: t, "aria-label": n } = e, r = ce();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: t ? {
      // Techincally, menus cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a label for the nested group.
      id: r,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": t ? r : void 0
    }
  };
}
const Ka = 2, u7 = 50, o7 = 1e3, yd = Math.PI / 12;
function s7(e) {
  let { menuRef: t, submenuRef: n, isOpen: r, isDisabled: a } = e, l = T(void 0), i = T(void 0), u = T(0), o = T(void 0), d = T(void 0), s = T(void 0), c = T(2), [f, h] = Y(!1);
  yr({
    ref: r ? n : void 0,
    onResize: () => {
      n.current && (i.current = n.current.getBoundingClientRect(), s.current = void 0);
    }
  });
  let b = () => {
    h(!1), c.current = Ka, l.current = void 0;
  }, p = Dl(), y = xe(($) => {
    f && $.preventDefault();
  });
  ee(() => {
    f && t.current ? t.current.style.pointerEvents = "none" : t.current.style.pointerEvents = "";
  }, [
    t,
    f
  ]), ue(() => {
    let $ = n.current, v = t.current;
    if (a || !$ || !r || p !== "pointer" || !v) {
      b();
      return;
    }
    i.current = $.getBoundingClientRect();
    let x = (E) => {
      if (E.pointerType === "touch" || E.pointerType === "pen") return;
      let P = Date.now();
      if (P - u.current < u7) return;
      clearTimeout(o.current), clearTimeout(d.current);
      let { clientX: C, clientY: M } = E;
      if (!l.current) {
        l.current = {
          x: C,
          y: M
        };
        return;
      }
      if (!i.current) return;
      if (s.current || (s.current = C > i.current.right ? "left" : "right"), C < v.getBoundingClientRect().left || C > v.getBoundingClientRect().right || M < v.getBoundingClientRect().top || M > v.getBoundingClientRect().bottom) {
        b();
        return;
      }
      let F = l.current.x, V = l.current.y, I = s.current === "right" ? i.current.left - F : F - i.current.right, A = Math.atan2(V - i.current.top, I) + yd, U = Math.atan2(V - i.current.bottom, I) - yd, D = Math.atan2(V - M, s.current === "left" ? -(C - F) : C - F), N = D < A && D > U;
      c.current = N ? Math.min(c.current + 1, Ka) : Math.max(c.current - 1, 0), c.current >= Ka ? h(!0) : h(!1), u.current = P, l.current = {
        x: C,
        y: M
      }, N && (o.current = setTimeout(() => {
        b(), d.current = setTimeout(() => {
          let w = document.elementFromPoint(C, M);
          w && ae(v, w) && w.dispatchEvent(new PointerEvent("pointerover", {
            bubbles: !0,
            cancelable: !0
          }));
        }, 100);
      }, o7));
    };
    return window.addEventListener("pointermove", x), process.env.NODE_ENV !== "test" && window.addEventListener("pointerdown", y, !0), () => {
      window.removeEventListener("pointermove", x), process.env.NODE_ENV !== "test" && window.removeEventListener("pointerdown", y, !0), clearTimeout(o.current), clearTimeout(d.current), c.current = Ka;
    };
  }, [
    a,
    r,
    t,
    p,
    h,
    n
  ]);
}
function d7(e, t, n) {
  let { parentMenuRef: r, submenuRef: a, type: l = "menu", isDisabled: i, delay: u = 200, shouldUseVirtualFocus: o } = e, d = ce(), s = ce(), { direction: c } = de(), f = T(void 0), h = X(() => {
    f.current && (clearTimeout(f.current), f.current = void 0);
  }, [
    f
  ]), m = X((C) => {
    h(), t.open(C);
  }, [
    t,
    h
  ]), b = X(() => {
    h(), t.close();
  }, [
    t,
    h
  ]);
  ue(() => () => {
    h();
  }, [
    h
  ]);
  let p = (C) => {
    if (Yt(C.currentTarget))
      switch (C.key) {
        case "ArrowLeft":
          c === "ltr" && ae(C.currentTarget, W(C)) && (C.preventDefault(), C.stopPropagation(), b(), !o && n.current && Ae(n.current));
          break;
        case "ArrowRight":
          c === "rtl" && ae(C.currentTarget, W(C)) && (C.preventDefault(), C.stopPropagation(), b(), !o && n.current && Ae(n.current));
          break;
        case "Escape":
          ae(a.current, W(C)) && (C.stopPropagation(), b(), !o && n.current && Ae(n.current));
          break;
      }
  }, y = {
    id: s,
    "aria-labelledby": d,
    submenuLevel: t.submenuLevel,
    ...l === "menu" && {
      onClose: t.closeAll,
      autoFocus: t.focusStrategy ?? void 0,
      onKeyDown: p
    }
  }, $ = (C) => {
    switch (C.key) {
      case "ArrowRight":
        i || (c === "ltr" ? (C.preventDefault(), t.isOpen || m("first"), l === "menu" && a?.current && se() === n?.current && Ae(a.current)) : t.isOpen ? b() : C.continuePropagation());
        break;
      case "ArrowLeft":
        i || (c === "rtl" ? (C.preventDefault(), t.isOpen || m("first"), l === "menu" && a?.current && se() === n?.current && Ae(a.current)) : t.isOpen ? b() : C.continuePropagation());
        break;
      default:
        C.continuePropagation();
        break;
    }
  }, v = (C) => {
    !i && (C.pointerType === "virtual" || C.pointerType === "keyboard") && m("first");
  }, x = (C) => {
    !i && (C.pointerType === "touch" || C.pointerType === "mouse") && m();
  }, E = (C) => {
    i || (C && !t.isOpen ? f.current || (f.current = setTimeout(() => {
      m();
    }, u)) : C || h());
  };
  bt(r, "focusin", (C) => {
    t.isOpen && ae(r.current, W(C)) && W(C) !== n.current && b();
  });
  let P = (C) => C !== n.current;
  return s7({
    menuRef: r,
    submenuRef: a,
    isOpen: t.isOpen,
    isDisabled: i
  }), {
    submenuTriggerProps: {
      id: d,
      "aria-controls": t.isOpen ? s : void 0,
      "aria-haspopup": i ? void 0 : l,
      "aria-expanded": t.isOpen ? "true" : "false",
      onPressStart: v,
      onPress: x,
      onHoverChange: E,
      onKeyDown: $,
      isOpen: t.isOpen
    },
    submenuProps: y,
    popoverProps: {
      isNonModal: !0,
      shouldCloseOnInteractOutside: P
    }
  };
}
function co(e) {
  let t = Fr(e), [n, r] = Y(null), [a, l] = Y([]), i = () => {
    l([]), t.close();
  };
  return {
    focusStrategy: n,
    ...t,
    open(d = null) {
      r(d), t.open();
    },
    toggle(d = null) {
      r(d), t.toggle();
    },
    close() {
      i();
    },
    expandedKeysStack: a,
    openSubmenu: (d, s) => {
      l((c) => s > c.length ? c : [
        ...c.slice(0, s),
        d
      ]);
    },
    closeSubmenu: (d, s) => {
      l((c) => c[s] === d ? c.slice(0, s) : c);
    }
  };
}
function c7(e, t) {
  let { triggerKey: n } = e, { expandedKeysStack: r, openSubmenu: a, closeSubmenu: l, close: i } = t, [u] = Y(r?.length), o = K(() => r[u] === n, [
    r,
    n,
    u
  ]), [d, s] = Y(null), c = X((m) => {
    s(m ?? null), a(n, u);
  }, [
    a,
    u,
    n
  ]), f = X(() => {
    s(null), l(n, u);
  }, [
    l,
    u,
    n
  ]), h = X((m) => {
    s(m ?? null), o ? f() : c(m);
  }, [
    f,
    c,
    o
  ]);
  return K(() => ({
    focusStrategy: d,
    isOpen: o,
    open: c,
    close: f,
    closeAll: i,
    submenuLevel: u,
    // TODO: Placeholders that aren't used but give us parity with OverlayTriggerState so we can use this in Popover. Refactor if we update Popover via
    // https://github.com/adobe/react-spectrum/pull/4976#discussion_r1336472863
    setOpen: () => {
    },
    toggle: h
  }), [
    o,
    c,
    f,
    i,
    d,
    h,
    u
  ]);
}
class f7 {
  constructor(t, { expandedKeys: n } = {}) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = t, n = n || /* @__PURE__ */ new Set();
    let r = (i) => {
      if (this.keyMap.set(i.key, i), i.childNodes && (i.type === "section" || n.has(i.key))) for (let u of i.childNodes) r(u);
    };
    for (let i of t) r(i);
    let a = null, l = 0;
    for (let [i, u] of this.keyMap)
      a ? (a.nextKey = i, u.prevKey = a.key) : (this.firstKey = i, u.prevKey = void 0), u.type === "item" && (u.index = l++), a = u, a.nextKey = void 0;
    this.lastKey = a?.key ?? null;
  }
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    return n ? n.prevKey ?? null : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    return n ? n.nextKey ?? null : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    return this.keyMap.get(t) ?? null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
}
function h7(e) {
  let { onExpandedChange: t } = e, [n, r] = we(e.expandedKeys ? new Set(e.expandedKeys) : void 0, e.defaultExpandedKeys ? new Set(e.defaultExpandedKeys) : /* @__PURE__ */ new Set(), t), a = Da(e), l = K(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), i = uo(e, X((o) => new f7(o, {
    expandedKeys: n
  }), [
    n
  ]), null);
  return ee(() => {
    a.focusedKey != null && !i.getItem(a.focusedKey) && a.setFocusedKey(null);
  }, [
    i,
    a.focusedKey
  ]), {
    collection: i,
    expandedKeys: n,
    disabledKeys: l,
    toggleKey: (o) => {
      r(m7(n, o));
    },
    setExpandedKeys: r,
    selectionManager: new Br(i, a)
  };
}
function m7(e, t) {
  let n = new Set(e);
  return n.has(t) ? n.delete(t) : n.add(t), n;
}
const fo = /* @__PURE__ */ G(null), Tl = /* @__PURE__ */ G(null), ca = /* @__PURE__ */ G(null), ml = /* @__PURE__ */ G(null);
function EC(e) {
  let t = co(e), n = T(null), { menuTriggerProps: r, menuProps: a } = Eg({
    ...e,
    type: "menu"
  }, t, n), l = T(null);
  return qc() ? null : /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        fo,
        {
          ...a,
          ref: l
        }
      ],
      [
        Ot,
        t
      ],
      [
        ca,
        t
      ],
      [
        Ar,
        {
          trigger: "MenuTrigger",
          triggerRef: n,
          scrollRef: l,
          placement: "bottom start",
          "aria-labelledby": a["aria-labelledby"]
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Np, {
    ...r,
    ref: n,
    isPressed: t.isOpen
  }, e.children));
}
const Pg = /* @__PURE__ */ G(null), Io = class Io extends dt {
  filter(t, n, r) {
    let a = t.getItem(this.firstChildKey);
    if (a && r(a.textValue, this)) {
      let l = this.clone();
      return n.addDescendants(l, t), l;
    }
    return null;
  }
};
Io.type = "submenutrigger";
let nu = Io;
const CC = /* @__PURE__ */ ha(nu, (e, t, n) => {
  let { CollectionBranch: r } = O(ge), a = O(Tl), l = O(ca), i = c7({
    triggerKey: n.key
  }, l), u = T(null), o = $e(t), { parentMenuRef: d, shouldUseVirtualFocus: s } = O(Pg), { submenuTriggerProps: c, submenuProps: f, popoverProps: h } = d7({
    parentMenuRef: d,
    submenuRef: u,
    delay: e.delay,
    shouldUseVirtualFocus: s
  }, i, o);
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        $r,
        {
          ...c,
          onAction: void 0,
          ref: o
        }
      ],
      [
        fo,
        {
          ref: u,
          ...f
        }
      ],
      [
        Ot,
        i
      ],
      [
        Ar,
        {
          trigger: "SubmenuTrigger",
          triggerRef: o,
          placement: "end top",
          "aria-labelledby": f["aria-labelledby"],
          ...h
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(r, {
    collection: a.collection,
    parent: n
  }), e.children[1]);
}, (e) => e.children[0]), PC = /* @__PURE__ */ te(function(t, n) {
  return [t, n] = oe(t, n, fo), /* @__PURE__ */ g.createElement(jn, {
    content: /* @__PURE__ */ g.createElement(Jt, t)
  }, (r) => /* @__PURE__ */ g.createElement(b7, {
    props: t,
    collection: r,
    menuRef: n
  }));
});
function b7({ props: e, collection: t, menuRef: n }) {
  [e, n] = oe(e, n, Vn);
  let { filter: r, ...a } = e, l = K(() => r ? t.filter(r) : t, [
    t,
    r
  ]), i = h7({
    ...e,
    collection: l,
    children: void 0
  }), u = O(ca), { isVirtualized: o, CollectionRoot: d } = O(ge), { menuProps: s } = a7({
    ...e,
    isVirtualized: o,
    onClose: e.onClose || u?.close
  }, i, n), c = le({
    ...e,
    children: void 0,
    defaultClassName: "react-aria-Menu",
    values: {
      isEmpty: i.collection.size === 0
    }
  }), f = null;
  i.collection.size === 0 && e.renderEmptyState && (f = /* @__PURE__ */ g.createElement("div", {
    role: "menuitem",
    style: {
      display: "contents"
    }
  }, e.renderEmptyState()));
  let h = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Bl, null, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(h, c, s),
    ref: n,
    slot: e.slot || void 0,
    "data-empty": i.collection.size === 0 || void 0,
    onScroll: e.onScroll
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Tl,
        i
      ],
      [
        no,
        {
          elementType: "div"
        }
      ],
      [
        Jc,
        {
          name: "MenuSection",
          render: wg
        }
      ],
      [
        Pg,
        {
          parentMenuRef: n,
          shouldUseVirtualFocus: a?.shouldUseVirtualFocus
        }
      ],
      [
        $r,
        {
          shouldCloseOnSelect: e.shouldCloseOnSelect
        }
      ],
      [
        Vn,
        null
      ],
      [
        fa,
        null
      ],
      [
        ml,
        i.selectionManager
      ],
      /* Ensure root MenuTriggerState is defined, in case Menu is rendered outside a MenuTrigger. */
      /* We assume the context can never change between defined and undefined. */
      /* eslint-disable-next-line react-hooks/rules-of-hooks */
      [
        ca,
        u ?? co({})
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Wn, null, /* @__PURE__ */ g.createElement(d, {
    collection: i.collection,
    persistedKeys: Cu(i.selectionManager.focusedKey),
    scrollRef: n
  }))), f));
}
class p7 extends Br {
  constructor(t, n) {
    super(t.collection, n), this.parent = t;
  }
  get focusedKey() {
    return this.parent.focusedKey;
  }
  get isFocused() {
    return this.parent.isFocused;
  }
  setFocusedKey(t, n) {
    return this.parent.setFocusedKey(t, n);
  }
  setFocused(t) {
    this.parent.setFocused(t);
  }
  get childFocusStrategy() {
    return this.parent.childFocusStrategy;
  }
}
function wg(e, t, n, r = "react-aria-MenuSection") {
  let a = O(Tl), { CollectionBranch: l } = O(ge), [i, u] = Qe(), { headingProps: o, groupProps: d } = i7({
    heading: u,
    "aria-label": n.props["aria-label"] ?? void 0
  }), s = le({
    ...e,
    id: void 0,
    children: void 0,
    defaultClassName: r,
    className: n.props?.className,
    style: n.props?.style,
    values: void 0
  }), c = O(ml), f = Da(e), h = e.selectionMode != null ? new p7(c, f) : c, m = He($r)?.shouldCloseOnSelect, b = J(e, {
    global: !0
  });
  return delete b.id, /* @__PURE__ */ g.createElement(Q.section, {
    ...z(b, s, d),
    ref: t
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        to,
        {
          ...o,
          ref: i
        }
      ],
      [
        ml,
        h
      ],
      [
        $r,
        {
          shouldCloseOnSelect: e.shouldCloseOnSelect ?? m
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(l, {
    collection: a.collection,
    parent: n
  })));
}
const wC = /* @__PURE__ */ ha(Pi, wg), $r = /* @__PURE__ */ G(null), SC = /* @__PURE__ */ St(Zr, function(t, n, r) {
  [t, n] = oe(t, n, $r);
  let a = He($r)?.id, l = O(Tl), i = $e(n), u = O(ml), { isVirtualized: o } = O(ge), { menuItemProps: d, labelProps: s, descriptionProps: c, keyboardShortcutProps: f, ...h } = l7({
    ...t,
    id: a,
    key: r.key,
    selectionManager: u,
    isVirtualized: o
  }, l, i), { hoverProps: m, isHovered: b } = De({
    isDisabled: h.isDisabled
  }), p = le({
    ...t,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-MenuItem",
    values: {
      ...h,
      isHovered: b,
      isFocusVisible: h.isFocusVisible,
      selectionMode: u.selectionMode,
      selectionBehavior: u.selectionBehavior,
      hasSubmenu: !!t["aria-haspopup"],
      isOpen: t["aria-expanded"] === "true"
    }
  }), y = t.href ? Q.a : Q.div, $ = J(t, {
    global: !0
  });
  return delete $.id, delete $.onClick, /* @__PURE__ */ g.createElement(y, {
    ...z($, p, d, m),
    ref: i,
    "data-disabled": h.isDisabled || void 0,
    "data-hovered": b || void 0,
    "data-focused": h.isFocused || void 0,
    "data-focus-visible": h.isFocusVisible || void 0,
    "data-pressed": h.isPressed || void 0,
    "data-selected": h.isSelected || void 0,
    "data-selection-mode": u.selectionMode === "none" ? void 0 : u.selectionMode,
    "data-has-submenu": !!t["aria-haspopup"] || void 0,
    "data-open": t["aria-expanded"] === "true" || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        We,
        {
          slots: {
            [$t]: s,
            label: s,
            description: c
          }
        }
      ],
      [
        n7,
        f
      ],
      [
        Gn,
        {
          isSelected: h.isSelected
        }
      ]
    ]
  }, p.children));
});
function g7(e, t) {
  let { role: n = "dialog" } = e, r = yt();
  r = e["aria-label"] ? void 0 : r;
  let a = T(!1);
  ee(() => {
    if (t.current && !Yt(t.current)) {
      Se(t.current);
      let i = setTimeout(() => {
        (se() === t.current || se() === document.body) && (a.current = !0, t.current && (t.current.blur(), Se(t.current)), a.current = !1);
      }, 500);
      return () => {
        clearTimeout(i);
      };
    }
  }, [
    t
  ]), Lp();
  let l = T(!1);
  return ee(() => {
    if (process.env.NODE_ENV !== "production" && !l.current && t.current) {
      let i = t.current, u = i.hasAttribute("aria-label"), o = i.hasAttribute("aria-labelledby");
      !u && !o && (console.warn("A dialog must have a title for accessibility. Either provide an aria-label or aria-labelledby prop, or render a heading element inside the dialog."), l.current = !0);
    }
  }), {
    dialogProps: {
      ...J(e, {
        labelable: !0
      }),
      role: n,
      tabIndex: -1,
      "aria-labelledby": e["aria-labelledby"] || r,
      // Prevent blur events from reaching useOverlay, which may cause
      // popovers to close. Since focus is contained within the dialog,
      // we don't want this to occur due to the above useEffect.
      onBlur: (i) => {
        a.current && i.stopPropagation();
      }
    },
    titleProps: {
      id: r
    }
  };
}
const ho = /* @__PURE__ */ G(null), Ot = /* @__PURE__ */ G(null);
function kC(e) {
  let t = co(e), n = T(null), { triggerProps: r, overlayProps: a } = xg({
    type: "dialog"
  }, t, n);
  return r.id = ce(), a["aria-labelledby"] = r.id, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Ot,
        t
      ],
      [
        ca,
        t
      ],
      [
        ho,
        a
      ],
      [
        Ar,
        {
          trigger: "DialogTrigger",
          triggerRef: n,
          "aria-labelledby": a["aria-labelledby"]
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Np, {
    ...r,
    ref: n,
    isPressed: t.isOpen
  }, e.children));
}
const BC = /* @__PURE__ */ te(function(t, n) {
  let r = t["aria-labelledby"];
  [t, n] = oe(t, n, ho);
  let { dialogProps: a, titleProps: l } = g7({
    ...t,
    // Only pass aria-labelledby from props, not context.
    // Context is used as a fallback below.
    "aria-labelledby": r
  }, n), i = O(Ot);
  !a["aria-label"] && !a["aria-labelledby"] && (t["aria-labelledby"] ? a["aria-labelledby"] = t["aria-labelledby"] : process.env.NODE_ENV !== "production" && console.warn('If a Dialog does not contain a <Heading slot="title">, it must have an aria-label or aria-labelledby attribute for accessibility.'));
  let u = le({
    defaultClassName: "react-aria-Dialog",
    className: t.className,
    style: t.style,
    children: t.children,
    values: {
      close: i?.close || (() => {
      })
    }
  }), o = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.section, {
    ...z(o, u, a),
    render: t.render,
    ref: n,
    slot: t.slot || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Su,
        {
          slots: {
            [$t]: {},
            title: {
              ...l,
              level: 2
            }
          }
        }
      ],
      [
        Xe,
        {
          slots: {
            [$t]: {},
            close: {
              onPress: () => i?.close()
            }
          }
        }
      ]
    ]
  }, u.children));
});
function y7(e) {
  let t = Sr({
    usage: "search",
    ...e
  }), n = X((l, i) => i.length === 0 ? !0 : (l = l.normalize("NFC"), i = i.normalize("NFC"), t.compare(l.slice(0, i.length), i) === 0), [
    t
  ]), r = X((l, i) => i.length === 0 ? !0 : (l = l.normalize("NFC"), i = i.normalize("NFC"), t.compare(l.slice(-i.length), i) === 0), [
    t
  ]), a = X((l, i) => {
    if (i.length === 0) return !0;
    l = l.normalize("NFC"), i = i.normalize("NFC");
    let u = 0, o = i.length;
    for (; u + o <= l.length; u++) {
      let d = l.slice(u, u + o);
      if (t.compare(i, d) === 0) return !0;
    }
    return !1;
  }, [
    t
  ]);
  return K(() => ({
    startsWith: n,
    endsWith: r,
    contains: a
  }), [
    n,
    r,
    a
  ]);
}
const $7 = [
  "day",
  "month",
  "year"
], v7 = {
  hour: 1,
  minute: 2,
  second: 3
};
function D7(e, t) {
  let { autoComplete: n, isDisabled: r, name: a } = e, { visuallyHiddenProps: l } = tn({
    style: {
      // Prevent page scrolling.
      position: "fixed",
      top: 0,
      left: 0
    }
  }), i = 60;
  t.granularity === "second" ? i = 1 : t.granularity === "hour" && (i = 3600);
  let u = "";
  t.value && (t.granularity === "day" ? u = it(t.value).toString() : u = Et("timeZone" in t.value ? Y2(t.value) : t.value).toString());
  let o = t.granularity === "day" ? "date" : "datetime-local", d = [
    "hour",
    "minute",
    "second"
  ], s = 0;
  return d.includes(t.granularity) && (s = v7[t.granularity], d = d.slice(0, s)), {
    containerProps: {
      ...l,
      "aria-hidden": !0,
      // @ts-ignore
      "data-react-aria-prevent-focus": !0,
      // @ts-ignore
      "data-a11y-ignore": "aria-hidden-focus"
    },
    inputProps: {
      tabIndex: -1,
      autoComplete: n,
      disabled: r,
      type: o,
      // We set the form prop to an empty string to prevent the hidden date input's value from being submitted
      form: "",
      name: a,
      step: i,
      value: u,
      onChange: (c) => {
        let f = W(c).value.toString();
        if (f) try {
          let h = i6(f);
          if (t.granularity === "day" && (h = l6(f)), "setSegment" in t) for (let m in h)
            $7.includes(m) && t.setSegment(m, h[m]), d.includes(m) && t.setSegment(m, h[m]);
          t.setValue(h);
        } catch {
        }
      }
    }
  };
}
function x7(e) {
  let { state: t } = e, { containerProps: n, inputProps: r } = D7({
    ...e
  }, t);
  return /* @__PURE__ */ g.createElement("div", {
    ...n,
    "data-testid": "hidden-dateinput-container"
  }, /* @__PURE__ */ g.createElement("input", r));
}
var Sg = {};
Sg = {
  calendar: "التقويم",
  day: "يوم",
  dayPeriod: "ص/م",
  endDate: "تاريخ الانتهاء",
  era: "العصر",
  hour: "الساعات",
  minute: "الدقائق",
  month: "الشهر",
  second: "الثواني",
  selectedDateDescription: (e) => `تاريخ محدد: ${e.date}`,
  selectedRangeDescription: (e) => `المدى الزمني المحدد: ${e.startDate} إلى ${e.endDate}`,
  selectedTimeDescription: (e) => `الوقت المحدد: ${e.time}`,
  startDate: "تاريخ البدء",
  timeZoneName: "التوقيت",
  weekday: "اليوم",
  year: "السنة"
};
var kg = {};
kg = {
  calendar: "Календар",
  day: "ден",
  dayPeriod: "пр.об./сл.об.",
  endDate: "Крайна дата",
  era: "ера",
  hour: "час",
  minute: "минута",
  month: "месец",
  second: "секунда",
  selectedDateDescription: (e) => `Избрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Избран диапазон: ${e.startDate} до ${e.endDate}`,
  selectedTimeDescription: (e) => `Избрано време: ${e.time}`,
  startDate: "Начална дата",
  timeZoneName: "часова зона",
  weekday: "ден от седмицата",
  year: "година"
};
var Bg = {};
Bg = {
  calendar: "Kalendář",
  day: "den",
  dayPeriod: "část dne",
  endDate: "Konečné datum",
  era: "letopočet",
  hour: "hodina",
  minute: "minuta",
  month: "měsíc",
  second: "sekunda",
  selectedDateDescription: (e) => `Vybrané datum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybrané období: ${e.startDate} až ${e.endDate}`,
  selectedTimeDescription: (e) => `Vybraný čas: ${e.time}`,
  startDate: "Počáteční datum",
  timeZoneName: "časové pásmo",
  weekday: "den v týdnu",
  year: "rok"
};
var Fg = {};
Fg = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "AM/PM",
  endDate: "Slutdato",
  era: "æra",
  hour: "time",
  minute: "minut",
  month: "måned",
  second: "sekund",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt interval: ${e.startDate} til ${e.endDate}`,
  selectedTimeDescription: (e) => `Valgt tidspunkt: ${e.time}`,
  startDate: "Startdato",
  timeZoneName: "tidszone",
  weekday: "ugedag",
  year: "år"
};
var Ag = {};
Ag = {
  calendar: "Kalender",
  day: "Tag",
  dayPeriod: "Tageshälfte",
  endDate: "Enddatum",
  era: "Epoche",
  hour: "Stunde",
  minute: "Minute",
  month: "Monat",
  second: "Sekunde",
  selectedDateDescription: (e) => `Ausgewähltes Datum: ${e.date}`,
  selectedRangeDescription: (e) => `Ausgewählter Bereich: ${e.startDate} bis ${e.endDate}`,
  selectedTimeDescription: (e) => `Ausgewählte Zeit: ${e.time}`,
  startDate: "Startdatum",
  timeZoneName: "Zeitzone",
  weekday: "Wochentag",
  year: "Jahr"
};
var Rg = {};
Rg = {
  calendar: "Ημερολόγιο",
  day: "ημέρα",
  dayPeriod: "π.μ./μ.μ.",
  endDate: "Ημερομηνία λήξης",
  era: "περίοδος",
  hour: "ώρα",
  minute: "λεπτό",
  month: "μήνας",
  second: "δευτερόλεπτο",
  selectedDateDescription: (e) => `Επιλεγμένη ημερομηνία: ${e.date}`,
  selectedRangeDescription: (e) => `Επιλεγμένο εύρος: ${e.startDate} έως ${e.endDate}`,
  selectedTimeDescription: (e) => `Επιλεγμένη ώρα: ${e.time}`,
  startDate: "Ημερομηνία έναρξης",
  timeZoneName: "ζώνη ώρας",
  weekday: "καθημερινή",
  year: "έτος"
};
var Tg = {};
Tg = {
  era: "era",
  year: "year",
  month: "month",
  day: "day",
  hour: "hour",
  minute: "minute",
  second: "second",
  dayPeriod: "AM/PM",
  calendar: "Calendar",
  startDate: "Start Date",
  endDate: "End Date",
  weekday: "day of the week",
  timeZoneName: "time zone",
  selectedDateDescription: (e) => `Selected Date: ${e.date}`,
  selectedRangeDescription: (e) => `Selected Range: ${e.startDate} to ${e.endDate}`,
  selectedTimeDescription: (e) => `Selected Time: ${e.time}`
};
var Ig = {};
Ig = {
  calendar: "Calendario",
  day: "día",
  dayPeriod: "a. m./p. m.",
  endDate: "Fecha final",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mes",
  second: "segundo",
  selectedDateDescription: (e) => `Fecha seleccionada: ${e.date}`,
  selectedRangeDescription: (e) => `Rango seleccionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora seleccionada: ${e.time}`,
  startDate: "Fecha de inicio",
  timeZoneName: "zona horaria",
  weekday: "día de la semana",
  year: "año"
};
var Mg = {};
Mg = {
  calendar: "Kalender",
  day: "päev",
  dayPeriod: "enne/pärast lõunat",
  endDate: "Lõppkuupäev",
  era: "ajastu",
  hour: "tund",
  minute: "minut",
  month: "kuu",
  second: "sekund",
  selectedDateDescription: (e) => `Valitud kuupäev: ${e.date}`,
  selectedRangeDescription: (e) => `Valitud vahemik: ${e.startDate} kuni ${e.endDate}`,
  selectedTimeDescription: (e) => `Valitud aeg: ${e.time}`,
  startDate: "Alguskuupäev",
  timeZoneName: "ajavöönd",
  weekday: "nädalapäev",
  year: "aasta"
};
var Kg = {};
Kg = {
  calendar: "Kalenteri",
  day: "päivä",
  dayPeriod: "vuorokaudenaika",
  endDate: "Päättymispäivä",
  era: "aikakausi",
  hour: "tunti",
  minute: "minuutti",
  month: "kuukausi",
  second: "sekunti",
  selectedDateDescription: (e) => `Valittu päivämäärä: ${e.date}`,
  selectedRangeDescription: (e) => `Valittu aikaväli: ${e.startDate} – ${e.endDate}`,
  selectedTimeDescription: (e) => `Valittu aika: ${e.time}`,
  startDate: "Alkamispäivä",
  timeZoneName: "aikavyöhyke",
  weekday: "viikonpäivä",
  year: "vuosi"
};
var Ng = {};
Ng = {
  calendar: "Calendrier",
  day: "jour",
  dayPeriod: "cadran",
  endDate: "Date de fin",
  era: "ère",
  hour: "heure",
  minute: "minute",
  month: "mois",
  second: "seconde",
  selectedDateDescription: (e) => `Date sélectionnée : ${e.date}`,
  selectedRangeDescription: (e) => `Plage sélectionnée : ${e.startDate} au ${e.endDate}`,
  selectedTimeDescription: (e) => `Heure choisie : ${e.time}`,
  startDate: "Date de début",
  timeZoneName: "fuseau horaire",
  weekday: "jour de la semaine",
  year: "année"
};
var Vg = {};
Vg = {
  calendar: "לוח שנה",
  day: "יום",
  dayPeriod: "לפנה״צ/אחה״צ",
  endDate: "תאריך סיום",
  era: "תקופה",
  hour: "שעה",
  minute: "דקה",
  month: "חודש",
  second: "שנייה",
  selectedDateDescription: (e) => `תאריך נבחר: ${e.date}`,
  selectedRangeDescription: (e) => `טווח נבחר: ${e.startDate} עד ${e.endDate}`,
  selectedTimeDescription: (e) => `זמן נבחר: ${e.time}`,
  startDate: "תאריך התחלה",
  timeZoneName: "אזור זמן",
  weekday: "יום בשבוע",
  year: "שנה"
};
var Lg = {};
Lg = {
  calendar: "Kalendar",
  day: "dan",
  dayPeriod: "AM/PM",
  endDate: "Datum završetka",
  era: "era",
  hour: "sat",
  minute: "minuta",
  month: "mjesec",
  second: "sekunda",
  selectedDateDescription: (e) => `Odabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Odabrani raspon: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Odabrano vrijeme: ${e.time}`,
  startDate: "Datum početka",
  timeZoneName: "vremenska zona",
  weekday: "dan u tjednu",
  year: "godina"
};
var zg = {};
zg = {
  calendar: "Naptár",
  day: "nap",
  dayPeriod: "napszak",
  endDate: "Befejező dátum",
  era: "éra",
  hour: "óra",
  minute: "perc",
  month: "hónap",
  second: "másodperc",
  selectedDateDescription: (e) => `Kijelölt dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Kijelölt tartomány: ${e.startDate}–${e.endDate}`,
  selectedTimeDescription: (e) => `Kijelölt idő: ${e.time}`,
  startDate: "Kezdő dátum",
  timeZoneName: "időzóna",
  weekday: "hét napja",
  year: "év"
};
var Og = {};
Og = {
  calendar: "Calendario",
  day: "giorno",
  dayPeriod: "AM/PM",
  endDate: "Data finale",
  era: "era",
  hour: "ora",
  minute: "minuto",
  month: "mese",
  second: "secondo",
  selectedDateDescription: (e) => `Data selezionata: ${e.date}`,
  selectedRangeDescription: (e) => `Intervallo selezionato: da ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Ora selezionata: ${e.time}`,
  startDate: "Data iniziale",
  timeZoneName: "fuso orario",
  weekday: "giorno della settimana",
  year: "anno"
};
var Hg = {};
Hg = {
  calendar: "カレンダー",
  day: "日",
  dayPeriod: "午前/午後",
  endDate: "終了日",
  era: "時代",
  hour: "時",
  minute: "分",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `選択した日付 : ${e.date}`,
  selectedRangeDescription: (e) => `選択範囲 : ${e.startDate} から ${e.endDate}`,
  selectedTimeDescription: (e) => `選択した時間 : ${e.time}`,
  startDate: "開始日",
  timeZoneName: "タイムゾーン",
  weekday: "曜日",
  year: "年"
};
var Ug = {};
Ug = {
  calendar: "달력",
  day: "일",
  dayPeriod: "오전/오후",
  endDate: "종료일",
  era: "연호",
  hour: "시",
  minute: "분",
  month: "월",
  second: "초",
  selectedDateDescription: (e) => `선택 일자: ${e.date}`,
  selectedRangeDescription: (e) => `선택 범위: ${e.startDate} ~ ${e.endDate}`,
  selectedTimeDescription: (e) => `선택 시간: ${e.time}`,
  startDate: "시작일",
  timeZoneName: "시간대",
  weekday: "요일",
  year: "년"
};
var jg = {};
jg = {
  calendar: "Kalendorius",
  day: "diena",
  dayPeriod: "iki pietų / po pietų",
  endDate: "Pabaigos data",
  era: "era",
  hour: "valanda",
  minute: "minutė",
  month: "mėnuo",
  second: "sekundė",
  selectedDateDescription: (e) => `Pasirinkta data: ${e.date}`,
  selectedRangeDescription: (e) => `Pasirinktas intervalas: nuo ${e.startDate} iki ${e.endDate}`,
  selectedTimeDescription: (e) => `Pasirinktas laikas: ${e.time}`,
  startDate: "Pradžios data",
  timeZoneName: "laiko juosta",
  weekday: "savaitės diena",
  year: "metai"
};
var _g = {};
_g = {
  calendar: "Kalendārs",
  day: "diena",
  dayPeriod: "priekšpusdienā/pēcpusdienā",
  endDate: "Beigu datums",
  era: "ēra",
  hour: "stundas",
  minute: "minūtes",
  month: "mēnesis",
  second: "sekundes",
  selectedDateDescription: (e) => `Atlasītais datums: ${e.date}`,
  selectedRangeDescription: (e) => `Atlasītais diapazons: no ${e.startDate} līdz ${e.endDate}`,
  selectedTimeDescription: (e) => `Atlasītais laiks: ${e.time}`,
  startDate: "Sākuma datums",
  timeZoneName: "laika josla",
  weekday: "nedēļas diena",
  year: "gads"
};
var Wg = {};
Wg = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "a.m./p.m.",
  endDate: "Sluttdato",
  era: "tidsalder",
  hour: "time",
  minute: "minutt",
  month: "måned",
  second: "sekund",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt område: ${e.startDate} til ${e.endDate}`,
  selectedTimeDescription: (e) => `Valgt tid: ${e.time}`,
  startDate: "Startdato",
  timeZoneName: "tidssone",
  weekday: "ukedag",
  year: "år"
};
var Gg = {};
Gg = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "a.m./p.m.",
  endDate: "Einddatum",
  era: "tijdperk",
  hour: "uur",
  minute: "minuut",
  month: "maand",
  second: "seconde",
  selectedDateDescription: (e) => `Geselecteerde datum: ${e.date}`,
  selectedRangeDescription: (e) => `Geselecteerd bereik: ${e.startDate} tot ${e.endDate}`,
  selectedTimeDescription: (e) => `Geselecteerde tijd: ${e.time}`,
  startDate: "Startdatum",
  timeZoneName: "tijdzone",
  weekday: "dag van de week",
  year: "jaar"
};
var qg = {};
qg = {
  calendar: "Kalendarz",
  day: "dzień",
  dayPeriod: "rano / po południu / wieczorem",
  endDate: "Data końcowa",
  era: "era",
  hour: "godzina",
  minute: "minuta",
  month: "miesiąc",
  second: "sekunda",
  selectedDateDescription: (e) => `Wybrana data: ${e.date}`,
  selectedRangeDescription: (e) => `Wybrany zakres: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Wybrany czas: ${e.time}`,
  startDate: "Data początkowa",
  timeZoneName: "strefa czasowa",
  weekday: "dzień tygodnia",
  year: "rok"
};
var Yg = {};
Yg = {
  calendar: "Calendário",
  day: "dia",
  dayPeriod: "AM/PM",
  endDate: "Data final",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mês",
  second: "segundo",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora selecionada: ${e.time}`,
  startDate: "Data inicial",
  timeZoneName: "fuso horário",
  weekday: "dia da semana",
  year: "ano"
};
var Zg = {};
Zg = {
  calendar: "Calendário",
  day: "dia",
  dayPeriod: "am/pm",
  endDate: "Data de Término",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mês",
  second: "segundo",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora selecionada: ${e.time}`,
  startDate: "Data de Início",
  timeZoneName: "fuso horário",
  weekday: "dia da semana",
  year: "ano"
};
var Xg = {};
Xg = {
  calendar: "Calendar",
  day: "zi",
  dayPeriod: "a.m/p.m.",
  endDate: "Dată final",
  era: "eră",
  hour: "oră",
  minute: "minut",
  month: "lună",
  second: "secundă",
  selectedDateDescription: (e) => `Dată selectată: ${e.date}`,
  selectedRangeDescription: (e) => `Interval selectat: de la ${e.startDate} până la ${e.endDate}`,
  selectedTimeDescription: (e) => `Ora selectată: ${e.time}`,
  startDate: "Dată început",
  timeZoneName: "fus orar",
  weekday: "ziua din săptămână",
  year: "an"
};
var Jg = {};
Jg = {
  calendar: "Календарь",
  day: "день",
  dayPeriod: "AM/PM",
  endDate: "Дата окончания",
  era: "эра",
  hour: "час",
  minute: "минута",
  month: "месяц",
  second: "секунда",
  selectedDateDescription: (e) => `Выбранная дата: ${e.date}`,
  selectedRangeDescription: (e) => `Выбранный диапазон: с ${e.startDate} по ${e.endDate}`,
  selectedTimeDescription: (e) => `Выбранное время: ${e.time}`,
  startDate: "Дата начала",
  timeZoneName: "часовой пояс",
  weekday: "день недели",
  year: "год"
};
var Qg = {};
Qg = {
  calendar: "Kalendár",
  day: "deň",
  dayPeriod: "AM/PM",
  endDate: "Dátum ukončenia",
  era: "letopočet",
  hour: "hodina",
  minute: "minúta",
  month: "mesiac",
  second: "sekunda",
  selectedDateDescription: (e) => `Vybratý dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybratý rozsah: od ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Vybratý čas: ${e.time}`,
  startDate: "Dátum začatia",
  timeZoneName: "časové pásmo",
  weekday: "deň týždňa",
  year: "rok"
};
var e0 = {};
e0 = {
  calendar: "Koledar",
  day: "dan",
  dayPeriod: "dop/pop",
  endDate: "Datum konca",
  era: "doba",
  hour: "ura",
  minute: "minuta",
  month: "mesec",
  second: "sekunda",
  selectedDateDescription: (e) => `Izbrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izbrano območje: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Izbrani čas: ${e.time}`,
  startDate: "Datum začetka",
  timeZoneName: "časovni pas",
  weekday: "dan v tednu",
  year: "leto"
};
var t0 = {};
t0 = {
  calendar: "Kalendar",
  day: "дан",
  dayPeriod: "пре подне/по подне",
  endDate: "Datum završetka",
  era: "ера",
  hour: "сат",
  minute: "минут",
  month: "месец",
  second: "секунд",
  selectedDateDescription: (e) => `Izabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izabrani opseg: od ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Izabrano vreme: ${e.time}`,
  startDate: "Datum početka",
  timeZoneName: "временска зона",
  weekday: "дан у недељи",
  year: "година"
};
var n0 = {};
n0 = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "fm/em",
  endDate: "Slutdatum",
  era: "era",
  hour: "timme",
  minute: "minut",
  month: "månad",
  second: "sekund",
  selectedDateDescription: (e) => `Valt datum: ${e.date}`,
  selectedRangeDescription: (e) => `Valt intervall: ${e.startDate} till ${e.endDate}`,
  selectedTimeDescription: (e) => `Vald tid: ${e.time}`,
  startDate: "Startdatum",
  timeZoneName: "tidszon",
  weekday: "veckodag",
  year: "år"
};
var r0 = {};
r0 = {
  calendar: "Takvim",
  day: "gün",
  dayPeriod: "ÖÖ/ÖS",
  endDate: "Bitiş Tarihi",
  era: "çağ",
  hour: "saat",
  minute: "dakika",
  month: "ay",
  second: "saniye",
  selectedDateDescription: (e) => `Seçilen Tarih: ${e.date}`,
  selectedRangeDescription: (e) => `Seçilen Aralık: ${e.startDate} - ${e.endDate}`,
  selectedTimeDescription: (e) => `Seçilen Zaman: ${e.time}`,
  startDate: "Başlangıç Tarihi",
  timeZoneName: "saat dilimi",
  weekday: "haftanın günü",
  year: "yıl"
};
var a0 = {};
a0 = {
  calendar: "Календар",
  day: "день",
  dayPeriod: "дп/пп",
  endDate: "Дата завершення",
  era: "ера",
  hour: "година",
  minute: "хвилина",
  month: "місяць",
  second: "секунда",
  selectedDateDescription: (e) => `Вибрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Вибраний діапазон: ${e.startDate} — ${e.endDate}`,
  selectedTimeDescription: (e) => `Вибраний час: ${e.time}`,
  startDate: "Дата початку",
  timeZoneName: "часовий пояс",
  weekday: "день тижня",
  year: "рік"
};
var l0 = {};
l0 = {
  calendar: "日历",
  day: "日",
  dayPeriod: "上午/下午",
  endDate: "结束日期",
  era: "纪元",
  hour: "小时",
  minute: "分钟",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `选定的日期：${e.date}`,
  selectedRangeDescription: (e) => `选定的范围：${e.startDate} 至 ${e.endDate}`,
  selectedTimeDescription: (e) => `选定的时间：${e.time}`,
  startDate: "开始日期",
  timeZoneName: "时区",
  weekday: "工作日",
  year: "年"
};
var i0 = {};
i0 = {
  calendar: "日曆",
  day: "日",
  dayPeriod: "上午/下午",
  endDate: "結束日期",
  era: "纪元",
  hour: "小时",
  minute: "分钟",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `選定的日期：${e.date}`,
  selectedRangeDescription: (e) => `選定的範圍：${e.startDate} 至 ${e.endDate}`,
  selectedTimeDescription: (e) => `選定的時間：${e.time}`,
  startDate: "開始日期",
  timeZoneName: "时区",
  weekday: "工作日",
  year: "年"
};
var Il = {};
Il = {
  "ar-AE": Sg,
  "bg-BG": kg,
  "cs-CZ": Bg,
  "da-DK": Fg,
  "de-DE": Ag,
  "el-GR": Rg,
  "en-US": Tg,
  "es-ES": Ig,
  "et-EE": Mg,
  "fi-FI": Kg,
  "fr-FR": Ng,
  "he-IL": Vg,
  "hr-HR": Lg,
  "hu-HU": zg,
  "it-IT": Og,
  "ja-JP": Hg,
  "ko-KR": Ug,
  "lt-LT": jg,
  "lv-LV": _g,
  "nb-NO": Wg,
  "nl-NL": Gg,
  "pl-PL": qg,
  "pt-BR": Yg,
  "pt-PT": Zg,
  "ro-RO": Xg,
  "ru-RU": Jg,
  "sk-SK": Qg,
  "sl-SI": e0,
  "sr-SP": t0,
  "sv-SE": n0,
  "tr-TR": r0,
  "uk-UA": a0,
  "zh-CN": l0,
  "zh-TW": i0
};
function u0(e, t, n) {
  let { direction: r } = de(), a = K(() => Fl(t), [
    t
  ]), l = (o) => {
    if (ae(o.currentTarget, W(o)) && (o.altKey && (o.key === "ArrowDown" || o.key === "ArrowUp") && "setOpen" in e && (o.preventDefault(), o.stopPropagation(), e.setOpen(!0)), !n))
      switch (o.key) {
        case "ArrowLeft":
          if (o.preventDefault(), o.stopPropagation(), r === "rtl") {
            if (t.current) {
              let d = W(o), s = $d(t.current, d.getBoundingClientRect().left, -1);
              s && s.focus();
            }
          } else a.focusPrevious();
          break;
        case "ArrowRight":
          if (o.preventDefault(), o.stopPropagation(), r === "rtl") {
            if (t.current) {
              let d = W(o), s = $d(t.current, d.getBoundingClientRect().left, 1);
              s && s.focus();
            }
          } else a.focusNext();
          break;
      }
  }, i = () => {
    if (!t.current) return;
    let o = window.event ? W(window.event) : null, d = Ie(t.current, {
      tabbable: !0
    });
    if (o && (d.currentNode = o, o = d.previousNode()), !o) {
      let s;
      do
        s = d.lastChild(), s && (o = s);
      while (s);
    }
    for (; o?.hasAttribute("data-placeholder"); ) {
      let s = d.previousNode();
      if (s && s.hasAttribute("data-placeholder")) o = s;
      else break;
    }
    o && o.focus();
  }, { pressProps: u } = Je({
    preventFocusOnPress: !0,
    allowTextSelectionOnPress: !0,
    onPressStart(o) {
      o.pointerType === "mouse" && i();
    },
    onPress(o) {
      (o.pointerType === "touch" || o.pointerType === "pen") && i();
    }
  });
  return z(u, {
    onKeyDown: l
  });
}
function $d(e, t, n) {
  let r = Ie(e, {
    tabbable: !0
  }), a = r.nextNode(), l = null, i = 1 / 0;
  for (; a; ) {
    let o = a.getBoundingClientRect().left - t, d = Math.abs(o);
    Math.sign(o) === n && d < i && (l = a, i = d), a = r.nextNode();
  }
  return l;
}
function E7(e) {
  return e && e.__esModule ? e.default : e;
}
const o0 = /* @__PURE__ */ new WeakMap(), ja = "__reactAriaDateFieldRole", C7 = "__reactAriaDateFieldFocusManager";
function P7(e, t, n) {
  let { isInvalid: r, validationErrors: a, validationDetails: l } = t.displayValidation, { labelProps: i, fieldProps: u, descriptionProps: o, errorMessageProps: d } = Pr({
    ...e,
    labelElementType: "span",
    isInvalid: r,
    errorMessage: e.errorMessage || a
  }), s = T(null), { focusWithinProps: c } = ft({
    ...e,
    onFocusWithin(F) {
      s.current = t.value, e.onFocus?.(F);
    },
    onBlurWithin: (F) => {
      t.confirmPlaceholder(), t.value !== s.current && t.commitValidation(), e.onBlur?.(F);
    },
    onFocusWithinChange: e.onFocusChange
  }), f = Ee(E7(Il), "@react-aria/datepicker"), h = t.maxGranularity === "hour" ? "selectedTimeDescription" : "selectedDateDescription", m = t.maxGranularity === "hour" ? "time" : "date", b = t.value ? f.format(h, {
    [m]: t.formatValue({
      month: "long"
    })
  }) : "", p = en(b), y = e[ja] === "presentation" ? u["aria-describedby"] : [
    p["aria-describedby"],
    u["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0, $ = e[C7], v = K(() => $ || Fl(n), [
    $,
    n
  ]), x = u0(t, n, e[ja] === "presentation");
  o0.set(t, {
    ariaLabel: e["aria-label"],
    ariaLabelledBy: [
      i.id,
      e["aria-labelledby"]
    ].filter(Boolean).join(" ") || void 0,
    ariaDescribedBy: y,
    focusManager: v
  });
  let E = T(e.autoFocus), P;
  e[ja] === "presentation" ? P = {
    role: "presentation"
  } : P = z(u, {
    role: "group",
    "aria-disabled": e.isDisabled || void 0,
    "aria-describedby": y
  }), ee(() => {
    E.current && v.focusFirst(), E.current = !1;
  }, [
    v
  ]), an(e.inputRef, t.defaultValue, t.setValue), $a({
    ...e,
    focus() {
      v.focusFirst();
    }
  }, t, e.inputRef);
  let C = {
    type: "hidden",
    name: e.name,
    form: e.form,
    value: t.value?.toString() || "",
    disabled: e.isDisabled
  };
  e.validationBehavior === "native" && (C.type = "text", C.hidden = !0, C.required = e.isRequired, C.onChange = () => {
  });
  let M = J(e);
  return {
    labelProps: {
      ...i,
      onClick: () => {
        v.focusFirst();
      }
    },
    fieldProps: z(M, P, x, c, {
      onKeyDown(F) {
        e.onKeyDown && e.onKeyDown(F);
      },
      onKeyUp(F) {
        e.onKeyUp && e.onKeyUp(F);
      },
      style: {
        unicodeBidi: "isolate"
      }
    }),
    inputProps: C,
    descriptionProps: o,
    errorMessageProps: d,
    isInvalid: r,
    validationErrors: a,
    validationDetails: l
  };
}
function w7(e) {
  return e && e.__esModule ? e.default : e;
}
function S7() {
  let { locale: e } = de(), t = Uc(w7(Il), "@react-aria/datepicker");
  return K(() => {
    try {
      return new Intl.DisplayNames(e, {
        type: "dateTimeField"
      });
    } catch {
      return new k7(e, t);
    }
  }, [
    e,
    t
  ]);
}
class k7 {
  constructor(t, n) {
    this.locale = t, this.dictionary = n;
  }
  of(t) {
    return this.dictionary.getStringForLocale(t, this.locale);
  }
}
function B7(e, t, n) {
  let r = T(""), { locale: a, direction: l } = de(), i = S7(), { ariaLabel: u, ariaLabelledBy: o, ariaDescribedBy: d, focusManager: s } = o0.get(t), c = e.isPlaceholder ? "" : e.text, f = K(() => t.dateFormatter.resolvedOptions(), [
    t.dateFormatter
  ]), h = Kt({
    month: "long",
    timeZone: f.timeZone
  }), m = Kt({
    hour: "numeric",
    hour12: f.hour12,
    timeZone: f.timeZone
  });
  if (e.type === "month" && !e.isPlaceholder) {
    let S = h.format(t.dateValue);
    c = S !== c ? `${c} – ${S}` : S;
  } else e.type === "hour" && !e.isPlaceholder && (c = m.format(t.dateValue));
  let { spinButtonProps: b } = Yu({
    // The ARIA spec says aria-valuenow is optional if there's no value, but aXe seems to require it.
    // This doesn't seem to have any negative effects with real AT since we also use aria-valuetext.
    // https://github.com/dequelabs/axe-core/issues/3505
    value: e.value ?? void 0,
    textValue: c,
    minValue: e.minValue,
    maxValue: e.maxValue,
    isDisabled: t.isDisabled,
    isReadOnly: t.isReadOnly || !e.isEditable,
    isRequired: t.isRequired,
    onIncrement: () => {
      r.current = "", t.increment(e.type);
    },
    onDecrement: () => {
      r.current = "", t.decrement(e.type);
    },
    onIncrementPage: () => {
      r.current = "", t.incrementPage(e.type);
    },
    onDecrementPage: () => {
      r.current = "", t.decrementPage(e.type);
    },
    onIncrementToMax: () => {
      r.current = "", t.incrementToMax(e.type);
    },
    onDecrementToMin: () => {
      r.current = "", t.decrementToMin(e.type);
    }
  }), p = K(() => new wu(a, {
    maximumFractionDigits: 0
  }), [
    a
  ]), y = () => {
    if (e.text === e.placeholder && s.focusPrevious(), p.isValidPartialNumber(e.text) && !t.isReadOnly && !e.isPlaceholder) {
      let S = e.text.slice(0, -1), j = p.parse(S);
      S = j === 0 ? "" : S, S.length === 0 || j === 0 ? t.clearSegment(e.type) : t.setSegment(e.type, j), r.current = S;
    } else (e.type === "dayPeriod" || e.type === "era") && t.clearSegment(e.type);
  }, $ = (S) => {
    if (S.key === "a" && (mn() ? S.metaKey : S.ctrlKey) && S.preventDefault(), !(S.ctrlKey || S.metaKey || S.shiftKey || S.altKey))
      switch (S.key) {
        case "Backspace":
        case "Delete":
          S.preventDefault(), S.stopPropagation(), y();
          break;
      }
  }, { startsWith: v } = y7({
    sensitivity: "base"
  }), x = Kt({
    hour: "numeric",
    hour12: !0
  }), E = K(() => {
    let S = /* @__PURE__ */ new Date();
    return S.setHours(0), x.formatToParts(S).find((j) => j.type === "dayPeriod").value;
  }, [
    x
  ]), P = K(() => {
    let S = /* @__PURE__ */ new Date();
    return S.setHours(12), x.formatToParts(S).find((j) => j.type === "dayPeriod").value;
  }, [
    x
  ]), C = Kt({
    year: "numeric",
    era: "narrow",
    timeZone: "UTC"
  }), M = K(() => {
    if (e.type !== "era") return [];
    let S = ke(new Te(1, 1, 1), t.calendar), j = t.calendar.getEras().map((B) => {
      let L = S.set({
        year: 1,
        month: 1,
        day: 1,
        era: B
      }).toDate("UTC"), ie = C.formatToParts(L).find((q) => q.type === "era").value;
      return {
        era: B,
        formatted: ie
      };
    }), _ = F7(j.map((B) => B.formatted));
    if (_) for (let B of j) B.formatted = B.formatted.slice(_);
    return j;
  }, [
    C,
    t.calendar,
    e.type
  ]), F = (S) => {
    if (t.isDisabled || t.isReadOnly) return;
    let j = r.current + S;
    switch (e.type) {
      case "dayPeriod":
        if (v(E, S)) t.setSegment("dayPeriod", 0);
        else if (v(P, S)) t.setSegment("dayPeriod", 1);
        else break;
        s.focusNext();
        break;
      case "era": {
        let _ = M.find((B) => v(B.formatted, S));
        _ && (t.setSegment("era", _.era), s.focusNext());
        break;
      }
      case "day":
      case "hour":
      case "minute":
      case "second":
      case "month":
      case "year": {
        if (!p.isValidPartialNumber(j)) return;
        let _ = p.parse(j), B = _;
        if (e.maxValue !== void 0 && _ > e.maxValue && (B = p.parse(S)), isNaN(_)) return;
        t.setSegment(e.type, B), e.maxValue !== void 0 && (+(_ + "0") > e.maxValue || j.length >= String(e.maxValue).length) ? (r.current = "", s.focusNext()) : r.current = j;
        break;
      }
    }
  }, V = () => {
    r.current = "", n.current && Oe(n.current, {
      containingElement: ze(n.current)
    }), window.getSelection()?.collapse(n.current);
  }, I = T(typeof document < "u" ? document : null);
  bt(I, "selectionchange", () => {
    let S = window.getSelection();
    S?.anchorNode && ae(n.current, S?.anchorNode) && S.collapse(n.current);
  });
  let A = T("");
  bt(n, "beforeinput", (S) => {
    if (n.current)
      switch (S.preventDefault(), S.inputType) {
        case "deleteContentBackward":
        case "deleteContentForward":
          p.isValidPartialNumber(e.text) && !t.isReadOnly && y();
          break;
        case "insertCompositionText":
          A.current = n.current.textContent, n.current.textContent = n.current.textContent;
          break;
        default:
          S.data != null && F(S.data);
          break;
      }
  }), bt(n, "input", (S) => {
    let { inputType: j, data: _ } = S;
    j === "insertCompositionText" && (n.current && (n.current.textContent = A.current), _ != null && (v(E, _) || v(P, _)) && F(_));
  }), ue(() => {
    let S = n.current;
    return () => {
      se() === S && (s.focusPrevious() || s.focusNext());
    };
  }, [
    n,
    s
  ]);
  let U = xt() || e.type === "timeZoneName" ? {
    role: "textbox",
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuetext": null,
    "aria-valuenow": null
  } : {}, D = K(() => t.segments.find((S) => S.isEditable), [
    t.segments
  ]);
  e !== D && !t.isInvalid && (d = void 0);
  let N = ce(), w = !t.isDisabled && !t.isReadOnly && e.isEditable, R = e.type === "literal" ? "" : i.of(e.type), H = ut({
    "aria-label": `${R}${u ? `, ${u}` : ""}${o ? ", " : ""}`,
    "aria-labelledby": o
  });
  if (e.type === "literal") return {
    segmentProps: {
      "aria-hidden": !0
    }
  };
  let k = {
    caretColor: "transparent"
  };
  if (l === "rtl") {
    k.unicodeBidi = "embed";
    let S = f[e.type];
    (S === "numeric" || S === "2-digit") && (k.direction = "ltr");
  }
  return {
    segmentProps: z(b, H, {
      id: N,
      ...U,
      "aria-invalid": t.isInvalid ? "true" : void 0,
      "aria-describedby": d,
      "aria-readonly": t.isReadOnly || !e.isEditable ? "true" : void 0,
      "data-placeholder": e.isPlaceholder || void 0,
      contentEditable: w,
      suppressContentEditableWarning: w,
      spellCheck: w ? "false" : void 0,
      autoCorrect: w ? "off" : void 0,
      // Capitalization was changed in React 17...
      [parseInt(g.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: w ? "next" : void 0,
      inputMode: t.isDisabled || e.type === "dayPeriod" || e.type === "era" || !w ? void 0 : "numeric",
      tabIndex: t.isDisabled ? void 0 : 0,
      onKeyDown: $,
      onFocus: V,
      style: k,
      // Prevent pointer events from reaching useDatePickerGroup, and allow native browser behavior to focus the segment.
      onPointerDown(S) {
        S.stopPropagation();
      },
      onMouseDown(S) {
        S.stopPropagation();
      }
    })
  };
}
function F7(e) {
  e.sort();
  let t = e[0], n = e[e.length - 1];
  for (let r = 0; r < t.length; r++)
    if (t[r] !== n[r]) return r;
  return 0;
}
var s0 = {};
s0 = {
  rangeOverflow: (e) => `يجب أن تكون القيمة ${e.maxValue} أو قبل ذلك.`,
  rangeReversed: "تاريخ البدء يجب أن يكون قبل تاريخ الانتهاء.",
  rangeUnderflow: (e) => `يجب أن تكون القيمة ${e.minValue} أو بعد ذلك.`,
  unavailableDate: "البيانات المحددة غير متاحة."
};
var d0 = {};
d0 = {
  rangeOverflow: (e) => `Стойността трябва да е ${e.maxValue} или по-ранна.`,
  rangeReversed: "Началната дата трябва да е преди крайната.",
  rangeUnderflow: (e) => `Стойността трябва да е ${e.minValue} или по-късно.`,
  unavailableDate: "Избраната дата не е налична."
};
var c0 = {};
c0 = {
  rangeOverflow: (e) => `Hodnota musí být ${e.maxValue} nebo dřívější.`,
  rangeReversed: "Datum zahájení musí předcházet datu ukončení.",
  rangeUnderflow: (e) => `Hodnota musí být ${e.minValue} nebo pozdější.`,
  unavailableDate: "Vybrané datum není k dispozici."
};
var f0 = {};
f0 = {
  rangeOverflow: (e) => `Værdien skal være ${e.maxValue} eller tidligere.`,
  rangeReversed: "Startdatoen skal være før slutdatoen.",
  rangeUnderflow: (e) => `Værdien skal være ${e.minValue} eller nyere.`,
  unavailableDate: "Den valgte dato er ikke tilgængelig."
};
var h0 = {};
h0 = {
  rangeOverflow: (e) => `Der Wert muss ${e.maxValue} oder früher sein.`,
  rangeReversed: "Das Startdatum muss vor dem Enddatum liegen.",
  rangeUnderflow: (e) => `Der Wert muss ${e.minValue} oder später sein.`,
  unavailableDate: "Das ausgewählte Datum ist nicht verfügbar."
};
var m0 = {};
m0 = {
  rangeOverflow: (e) => `Η τιμή πρέπει να είναι ${e.maxValue} ή παλαιότερη.`,
  rangeReversed: "Η ημερομηνία έναρξης πρέπει να είναι πριν από την ημερομηνία λήξης.",
  rangeUnderflow: (e) => `Η τιμή πρέπει να είναι ${e.minValue} ή μεταγενέστερη.`,
  unavailableDate: "Η επιλεγμένη ημερομηνία δεν είναι διαθέσιμη."
};
var b0 = {};
b0 = {
  rangeUnderflow: (e) => `Value must be ${e.minValue} or later.`,
  rangeOverflow: (e) => `Value must be ${e.maxValue} or earlier.`,
  rangeReversed: "Start date must be before end date.",
  unavailableDate: "Selected date unavailable."
};
var p0 = {};
p0 = {
  rangeOverflow: (e) => `El valor debe ser ${e.maxValue} o anterior.`,
  rangeReversed: "La fecha de inicio debe ser anterior a la fecha de finalización.",
  rangeUnderflow: (e) => `El valor debe ser ${e.minValue} o posterior.`,
  unavailableDate: "Fecha seleccionada no disponible."
};
var g0 = {};
g0 = {
  rangeOverflow: (e) => `Väärtus peab olema ${e.maxValue} või varasem.`,
  rangeReversed: "Alguskuupäev peab olema enne lõppkuupäeva.",
  rangeUnderflow: (e) => `Väärtus peab olema ${e.minValue} või hilisem.`,
  unavailableDate: "Valitud kuupäev pole saadaval."
};
var y0 = {};
y0 = {
  rangeOverflow: (e) => `Arvon on oltava ${e.maxValue} tai sitä aikaisempi.`,
  rangeReversed: "Aloituspäivän on oltava ennen lopetuspäivää.",
  rangeUnderflow: (e) => `Arvon on oltava ${e.minValue} tai sitä myöhäisempi.`,
  unavailableDate: "Valittu päivämäärä ei ole käytettävissä."
};
var $0 = {};
$0 = {
  rangeOverflow: (e) => `La valeur doit être ${e.maxValue} ou antérieure.`,
  rangeReversed: "La date de début doit être antérieure à la date de fin.",
  rangeUnderflow: (e) => `La valeur doit être ${e.minValue} ou ultérieure.`,
  unavailableDate: "La date sélectionnée n’est pas disponible."
};
var v0 = {};
v0 = {
  rangeOverflow: (e) => `הערך חייב להיות ${e.maxValue} או מוקדם יותר.`,
  rangeReversed: "תאריך ההתחלה חייב להיות לפני תאריך הסיום.",
  rangeUnderflow: (e) => `הערך חייב להיות ${e.minValue} או מאוחר יותר.`,
  unavailableDate: "התאריך הנבחר אינו זמין."
};
var D0 = {};
D0 = {
  rangeOverflow: (e) => `Vrijednost mora biti ${e.maxValue} ili ranije.`,
  rangeReversed: "Datum početka mora biti prije datuma završetka.",
  rangeUnderflow: (e) => `Vrijednost mora biti ${e.minValue} ili kasnije.`,
  unavailableDate: "Odabrani datum nije dostupan."
};
var x0 = {};
x0 = {
  rangeOverflow: (e) => `Az értéknek ${e.maxValue} vagy korábbinak kell lennie.`,
  rangeReversed: "A kezdő dátumnak a befejező dátumnál korábbinak kell lennie.",
  rangeUnderflow: (e) => `Az értéknek ${e.minValue} vagy későbbinek kell lennie.`,
  unavailableDate: "A kiválasztott dátum nem érhető el."
};
var E0 = {};
E0 = {
  rangeOverflow: (e) => `Il valore deve essere ${e.maxValue} o precedente.`,
  rangeReversed: "La data di inizio deve essere antecedente alla data di fine.",
  rangeUnderflow: (e) => `Il valore deve essere ${e.minValue} o successivo.`,
  unavailableDate: "Data selezionata non disponibile."
};
var C0 = {};
C0 = {
  rangeOverflow: (e) => `値は ${e.maxValue} 以下にする必要があります。`,
  rangeReversed: "開始日は終了日より前にする必要があります。",
  rangeUnderflow: (e) => `値は ${e.minValue} 以上にする必要があります。`,
  unavailableDate: "選択した日付は使用できません。"
};
var P0 = {};
P0 = {
  rangeOverflow: (e) => `값은 ${e.maxValue} 이전이어야 합니다.`,
  rangeReversed: "시작일은 종료일 이전이어야 합니다.",
  rangeUnderflow: (e) => `값은 ${e.minValue} 이후여야 합니다.`,
  unavailableDate: "선택한 날짜를 사용할 수 없습니다."
};
var w0 = {};
w0 = {
  rangeOverflow: (e) => `Reikšmė turi būti ${e.maxValue} arba ankstesnė.`,
  rangeReversed: "Pradžios data turi būti ankstesnė nei pabaigos data.",
  rangeUnderflow: (e) => `Reikšmė turi būti ${e.minValue} arba naujesnė.`,
  unavailableDate: "Pasirinkta data nepasiekiama."
};
var S0 = {};
S0 = {
  rangeOverflow: (e) => `Vērtībai ir jābūt ${e.maxValue} vai agrākai.`,
  rangeReversed: "Sākuma datumam ir jābūt pirms beigu datuma.",
  rangeUnderflow: (e) => `Vērtībai ir jābūt ${e.minValue} vai vēlākai.`,
  unavailableDate: "Atlasītais datums nav pieejams."
};
var k0 = {};
k0 = {
  rangeOverflow: (e) => `Verdien må være ${e.maxValue} eller tidligere.`,
  rangeReversed: "Startdatoen må være før sluttdatoen.",
  rangeUnderflow: (e) => `Verdien må være ${e.minValue} eller senere.`,
  unavailableDate: "Valgt dato utilgjengelig."
};
var B0 = {};
B0 = {
  rangeOverflow: (e) => `Waarde moet ${e.maxValue} of eerder zijn.`,
  rangeReversed: "De startdatum moet voor de einddatum liggen.",
  rangeUnderflow: (e) => `Waarde moet ${e.minValue} of later zijn.`,
  unavailableDate: "Geselecteerde datum niet beschikbaar."
};
var F0 = {};
F0 = {
  rangeOverflow: (e) => `Wartość musi mieć wartość ${e.maxValue} lub wcześniejszą.`,
  rangeReversed: "Data rozpoczęcia musi być wcześniejsza niż data zakończenia.",
  rangeUnderflow: (e) => `Wartość musi mieć wartość ${e.minValue} lub późniejszą.`,
  unavailableDate: "Wybrana data jest niedostępna."
};
var A0 = {};
A0 = {
  rangeOverflow: (e) => `O valor deve ser ${e.maxValue} ou anterior.`,
  rangeReversed: "A data inicial deve ser anterior à data final.",
  rangeUnderflow: (e) => `O valor deve ser ${e.minValue} ou posterior.`,
  unavailableDate: "Data selecionada indisponível."
};
var R0 = {};
R0 = {
  rangeOverflow: (e) => `O valor tem de ser ${e.maxValue} ou anterior.`,
  rangeReversed: "A data de início deve ser anterior à data de fim.",
  rangeUnderflow: (e) => `O valor tem de ser ${e.minValue} ou posterior.`,
  unavailableDate: "Data selecionada indisponível."
};
var T0 = {};
T0 = {
  rangeOverflow: (e) => `Valoarea trebuie să fie ${e.maxValue} sau anterioară.`,
  rangeReversed: "Data de început trebuie să fie anterioară datei de sfârșit.",
  rangeUnderflow: (e) => `Valoarea trebuie să fie ${e.minValue} sau ulterioară.`,
  unavailableDate: "Data selectată nu este disponibilă."
};
var I0 = {};
I0 = {
  rangeOverflow: (e) => `Значение должно быть не позже ${e.maxValue}.`,
  rangeReversed: "Дата начала должна предшествовать дате окончания.",
  rangeUnderflow: (e) => `Значение должно быть не раньше ${e.minValue}.`,
  unavailableDate: "Выбранная дата недоступна."
};
var M0 = {};
M0 = {
  rangeOverflow: (e) => `Hodnota musí byť ${e.maxValue} alebo skoršia.`,
  rangeReversed: "Dátum začiatku musí byť skorší ako dátum konca.",
  rangeUnderflow: (e) => `Hodnota musí byť ${e.minValue} alebo neskoršia.`,
  unavailableDate: "Vybratý dátum je nedostupný."
};
var K0 = {};
K0 = {
  rangeOverflow: (e) => `Vrednost mora biti ${e.maxValue} ali starejša.`,
  rangeReversed: "Začetni datum mora biti pred končnim datumom.",
  rangeUnderflow: (e) => `Vrednost mora biti ${e.minValue} ali novejša.`,
  unavailableDate: "Izbrani datum ni na voljo."
};
var N0 = {};
N0 = {
  rangeOverflow: (e) => `Vrednost mora da bude ${e.maxValue} ili starija.`,
  rangeReversed: "Datum početka mora biti pre datuma završetka.",
  rangeUnderflow: (e) => `Vrednost mora da bude ${e.minValue} ili novija.`,
  unavailableDate: "Izabrani datum nije dostupan."
};
var V0 = {};
V0 = {
  rangeOverflow: (e) => `Värdet måste vara ${e.maxValue} eller tidigare.`,
  rangeReversed: "Startdatumet måste vara före slutdatumet.",
  rangeUnderflow: (e) => `Värdet måste vara ${e.minValue} eller senare.`,
  unavailableDate: "Det valda datumet är inte tillgängligt."
};
var L0 = {};
L0 = {
  rangeOverflow: (e) => `Değer, ${e.maxValue} veya öncesi olmalıdır.`,
  rangeReversed: "Başlangıç tarihi bitiş tarihinden önce olmalıdır.",
  rangeUnderflow: (e) => `Değer, ${e.minValue} veya sonrası olmalıdır.`,
  unavailableDate: "Seçilen tarih kullanılamıyor."
};
var z0 = {};
z0 = {
  rangeOverflow: (e) => `Значення має бути не пізніше ${e.maxValue}.`,
  rangeReversed: "Дата початку має передувати даті завершення.",
  rangeUnderflow: (e) => `Значення має бути не раніше ${e.minValue}.`,
  unavailableDate: "Вибрана дата недоступна."
};
var O0 = {};
O0 = {
  rangeOverflow: (e) => `值必须是 ${e.maxValue} 或更早日期。`,
  rangeReversed: "开始日期必须早于结束日期。",
  rangeUnderflow: (e) => `值必须是 ${e.minValue} 或更晚日期。`,
  unavailableDate: "所选日期不可用。"
};
var H0 = {};
H0 = {
  rangeOverflow: (e) => `值必須是 ${e.maxValue} 或更早。`,
  rangeReversed: "開始日期必須在結束日期之前。",
  rangeUnderflow: (e) => `值必須是 ${e.minValue} 或更晚。`,
  unavailableDate: "所選日期無法使用。"
};
var U0 = {};
U0 = {
  "ar-AE": s0,
  "bg-BG": d0,
  "cs-CZ": c0,
  "da-DK": f0,
  "de-DE": h0,
  "el-GR": m0,
  "en-US": b0,
  "es-ES": p0,
  "et-EE": g0,
  "fi-FI": y0,
  "fr-FR": $0,
  "he-IL": v0,
  "hr-HR": D0,
  "hu-HU": x0,
  "it-IT": E0,
  "ja-JP": C0,
  "ko-KR": P0,
  "lt-LT": w0,
  "lv-LV": S0,
  "nb-NO": k0,
  "nl-NL": B0,
  "pl-PL": F0,
  "pt-BR": A0,
  "pt-PT": R0,
  "ro-RO": T0,
  "ru-RU": I0,
  "sk-SK": M0,
  "sl-SI": K0,
  "sr-SP": N0,
  "sv-SE": V0,
  "tr-TR": L0,
  "uk-UA": z0,
  "zh-CN": O0,
  "zh-TW": H0
};
function A7(e) {
  return e && e.__esModule ? e.default : e;
}
const R7 = new Dt(A7(U0));
function T7() {
  let e = (
    // @ts-ignore
    typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US"
  );
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return e;
}
function j0(e, t, n, r, a) {
  let l = e != null && n != null && e.compare(n) > 0, i = e != null && t != null && e.compare(t) < 0, u = e != null && r?.(e) || !1, o = l || i || u, d = [];
  if (o) {
    let s = T7(), c = Dt.getGlobalDictionaryForPackage("@react-stately/datepicker") || R7, f = new vu(s, c), h = new qt(s, br({}, a)), m = h.resolvedOptions().timeZone;
    i && t != null && d.push(f.format("rangeUnderflow", {
      minValue: h.format(t.toDate(m))
    })), l && n != null && d.push(f.format("rangeOverflow", {
      maxValue: h.format(n.toDate(m))
    })), u && d.push(f.format("unavailableDate"));
  }
  return {
    isInvalid: o,
    validationErrors: d,
    validationDetails: {
      badInput: u,
      customError: !1,
      patternMismatch: !1,
      rangeOverflow: l,
      rangeUnderflow: i,
      stepMismatch: !1,
      tooLong: !1,
      tooShort: !1,
      typeMismatch: !1,
      valueMissing: !1,
      valid: !o
    }
  };
}
const I7 = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit"
}, M7 = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
};
function br(e, t) {
  e = {
    ...t.shouldForceLeadingZeros ? M7 : I7,
    ...e
  };
  let r = t.granularity || "minute", a = Object.keys(e), l = a.indexOf(t.maxGranularity ?? "year");
  l < 0 && (l = 0);
  let i = a.indexOf(r);
  if (i < 0 && (i = 2), l > i) throw new Error("maxGranularity must be greater than granularity");
  let u = a.slice(l, i + 1).reduce((d, s) => (d[s] = e[s], d), {});
  return t.hourCycle != null && (u.hour12 = t.hourCycle === 12), u.timeZone = t.timeZone || "UTC", (r === "hour" || r === "minute" || r === "second") && t.timeZone && !t.hideTimeZone && (u.timeZoneName = "short"), t.showEra && l === 0 && (u.era = "short"), u;
}
function vd(e) {
  return e && "hour" in e ? e : new Vu();
}
function _0(e, t) {
  if (e === null) return null;
  if (e)
    return ke(e, t);
}
function K7(e, t, n, r) {
  if (e) return _0(e, n);
  let a = ke(w4(r ?? ya()).set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  }), n);
  return t === "year" || t === "month" || t === "day" ? it(a) : r ? a : Et(a);
}
function W0(e, t) {
  let n = e && "timeZone" in e ? e.timeZone : void 0, r = e && "minute" in e ? "minute" : "day";
  if (e && t && !(t in e)) throw new Error("Invalid granularity " + t + " for value " + e.toString());
  let [a, l] = Y([
    r,
    n
  ]);
  e && (a[0] !== r || a[1] !== n) && l([
    r,
    n
  ]), t || (t = e ? r : a[0]);
  let i = e ? n : a[1];
  return [
    t,
    i
  ];
}
const N7 = new Dt({
  ach: {
    year: "mwaka",
    month: "dwe",
    day: "nino"
  },
  af: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  am: {
    year: "ዓዓዓዓ",
    month: "ሚሜ",
    day: "ቀቀ"
  },
  an: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  ar: {
    year: "سنة",
    month: "شهر",
    day: "يوم"
  },
  ast: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  az: {
    year: "iiii",
    month: "aa",
    day: "gg"
  },
  be: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  bg: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  bn: {
    year: "yyyy",
    month: "মিমি",
    day: "dd"
  },
  br: {
    year: "bbbb",
    month: "mm",
    day: "dd"
  },
  bs: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  ca: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  cak: {
    year: "jjjj",
    month: "ii",
    day: "q'q'"
  },
  ckb: {
    year: "ساڵ",
    month: "مانگ",
    day: "ڕۆژ"
  },
  cs: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  cy: {
    year: "bbbb",
    month: "mm",
    day: "dd"
  },
  da: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  de: {
    year: "jjjj",
    month: "mm",
    day: "tt"
  },
  dsb: {
    year: "llll",
    month: "mm",
    day: "źź"
  },
  el: {
    year: "εεεε",
    month: "μμ",
    day: "ηη"
  },
  en: {
    year: "yyyy",
    month: "mm",
    day: "dd"
  },
  eo: {
    year: "jjjj",
    month: "mm",
    day: "tt"
  },
  es: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  et: {
    year: "aaaa",
    month: "kk",
    day: "pp"
  },
  eu: {
    year: "uuuu",
    month: "hh",
    day: "ee"
  },
  fa: {
    year: "سال",
    month: "ماه",
    day: "روز"
  },
  ff: {
    year: "hhhh",
    month: "ll",
    day: "ññ"
  },
  fi: {
    year: "vvvv",
    month: "kk",
    day: "pp"
  },
  fr: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  fy: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  ga: {
    year: "bbbb",
    month: "mm",
    day: "ll"
  },
  gd: {
    year: "bbbb",
    month: "mm",
    day: "ll"
  },
  gl: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  he: {
    year: "שנה",
    month: "חודש",
    day: "יום"
  },
  hr: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  hsb: {
    year: "llll",
    month: "mm",
    day: "dd"
  },
  hu: {
    year: "éééé",
    month: "hh",
    day: "nn"
  },
  ia: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  id: {
    year: "tttt",
    month: "bb",
    day: "hh"
  },
  is: {
    year: "áááá",
    month: "mm",
    day: "dd"
  },
  it: {
    year: "aaaa",
    month: "mm",
    day: "gg"
  },
  ja: {
    year: "年",
    month: "月",
    day: "日"
  },
  ka: {
    year: "წწწწ",
    month: "თთ",
    day: "რრ"
  },
  kk: {
    year: "жжжж",
    month: "аа",
    day: "кк"
  },
  kn: {
    year: "ವವವವ",
    month: "ಮಿಮೀ",
    day: "ದಿದಿ"
  },
  ko: {
    year: "연도",
    month: "월",
    day: "일"
  },
  lb: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  lo: {
    year: "ປປປປ",
    month: "ດດ",
    day: "ວວ"
  },
  lt: {
    year: "mmmm",
    month: "mm",
    day: "dd"
  },
  lv: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  meh: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  ml: {
    year: "വർഷം",
    month: "മാസം",
    day: "തീയതി"
  },
  ms: {
    year: "tttt",
    month: "mm",
    day: "hh"
  },
  nb: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  nl: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  nn: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  no: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  oc: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  pl: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  pt: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  rm: {
    year: "oooo",
    month: "mm",
    day: "dd"
  },
  ro: {
    year: "aaaa",
    month: "ll",
    day: "zz"
  },
  ru: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  sc: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  scn: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  sk: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  sl: {
    year: "llll",
    month: "mm",
    day: "dd"
  },
  sr: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  "sr-Latn": {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  sv: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  szl: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  tg: {
    year: "сссс",
    month: "мм",
    day: "рр"
  },
  th: {
    year: "ปปปป",
    month: "ดด",
    day: "วว"
  },
  tr: {
    year: "yyyy",
    month: "aa",
    day: "gg"
  },
  uk: {
    year: "рррр",
    month: "мм",
    day: "дд"
  },
  "zh-CN": {
    year: "年",
    month: "月",
    day: "日"
  },
  "zh-TW": {
    year: "年",
    month: "月",
    day: "日"
  }
}, "en");
function V7(e, t, n) {
  return e === "era" || e === "dayPeriod" ? t : e === "year" || e === "month" || e === "day" ? N7.getStringForLocale(e, n) : "––";
}
class It {
  constructor(t, n, r) {
    if (this.era = r?.era ?? null, this.calendar = t, this.year = r?.year ?? null, this.month = r?.month ?? null, this.day = r?.day ?? null, this.hour = r?.hour ?? null, this.hourCycle = n, this.dayPeriod = null, this.minute = r?.minute ?? null, this.second = r?.second ?? null, this.millisecond = r?.millisecond ?? null, this.offset = "offset" in (r ?? {}) ? r.offset : null, this.hour != null) {
      let [a, l] = tr(this.hour, n);
      this.dayPeriod = a, this.hour = l;
    }
  }
  copy() {
    let t = new It(this.calendar, this.hourCycle);
    return t.era = this.era, t.year = this.year, t.month = this.month, t.day = this.day, t.hour = this.hour, t.dayPeriod = this.dayPeriod, t.minute = this.minute, t.second = this.second, t.millisecond = this.millisecond, t.offset = this.offset, t;
  }
  /** Checks whether all the specified segments have a value. */
  isComplete(t) {
    return t.every((n) => this[n] != null);
  }
  /** Checks whether the given date value matches this value for the specified segments. */
  validate(t, n) {
    return n.every((r) => {
      if ((r === "hour" || r === "dayPeriod") && "hour" in t) {
        let [a, l] = tr(t.hour, this.hourCycle);
        return this.dayPeriod === a && this.hour === l;
      }
      return this[r] === t[r];
    });
  }
  /** Checks if the date is empty (i.e. all specified segments are null). */
  isCleared(t) {
    return t.every((n) => this[n] === null);
  }
  /** Sets the given field. */
  set(t, n, r) {
    let a = this.copy();
    return a[t] = n, t === "hour" && a.dayPeriod == null && "hour" in r && (a.dayPeriod = tr(r.hour, this.hourCycle)[0]), t === "year" && a.era == null && (a.era = r.era), t !== "second" && t !== "literal" && t !== "timeZoneName" && (a.offset = null), a;
  }
  /** Sets the given field to null. */
  clear(t) {
    let n = this.copy();
    return n[t] = null, t === "year" && (n.era = null), n.offset = null, n;
  }
  /**
  * Increments or decrements the given field. If it is null, then it is set to the placeholder
  * value.
  */
  cycle(t, n, r, a) {
    let l = this.copy();
    if (l[t] == null && t !== "dayPeriod" && t !== "era") {
      if (t === "hour" && "hour" in r) {
        let [i, u] = tr(r.hour, this.hourCycle);
        l.dayPeriod = i, l.hour = u;
      } else l[t] = r[t];
      return t === "year" && l.era == null && (l.era = r.era), l;
    }
    switch (t) {
      case "era": {
        let i = this.calendar.getEras(), u = i.indexOf(l.era);
        u = wn(u, n, 0, i.length - 1), l.era = i[u];
        break;
      }
      case "year": {
        let i = new Te(this.calendar, this.era ?? r.era, this.year ?? r.year, this.month ?? 1, this.day ?? 1);
        i = i.cycle(t, n, {
          round: t === "year"
        }), l.era = i.era, l.year = i.year;
        break;
      }
      case "month":
        l.month = wn(l.month ?? 1, n, 1, this.calendar.getMaximumMonthsInYear());
        break;
      case "day":
        l.day = wn(l.day ?? 1, n, 1, this.calendar.getMaximumDaysInMonth());
        break;
      case "hour": {
        let i = a.some((u) => [
          "year",
          "month",
          "day"
        ].includes(u));
        if ("timeZone" in r && (!i || l.year != null && l.month != null && l.day != null)) {
          let u = this.toValue(r);
          u = u.cycle("hour", n, {
            hourCycle: this.hourCycle === "h12" ? 12 : 24,
            round: !1
          });
          let [o, d] = tr(u.hour, this.hourCycle);
          l.hour = d, l.dayPeriod = o, l.offset = u.offset;
        } else {
          let u = l.hour ?? 0, o = this.getSegmentLimits("hour");
          l.hour = wn(u, n, o.minValue, o.maxValue), l.dayPeriod == null && "hour" in r && (l.dayPeriod = tr(r.hour, this.hourCycle)[0]);
        }
        break;
      }
      case "dayPeriod":
        l.dayPeriod = wn(l.dayPeriod ?? 0, n, 0, 1);
        break;
      case "minute":
        l.minute = wn(l.minute ?? 0, n, 0, 59, !0);
        break;
      case "second":
        l.second = wn(l.second ?? 0, n, 0, 59, !0);
        break;
    }
    return l;
  }
  /**
  * Converts the incomplete date to a full date value, using the provided value for any unset
  * fields.
  */
  toValue(t) {
    if ("hour" in t) {
      let n = this.hour;
      n != null ? n = L7(n, this.dayPeriod ?? 0, this.hourCycle) : (this.hourCycle === "h12" || this.hourCycle === "h11") && (n = this.dayPeriod === 1 ? 12 : 0);
      let r = t.set({
        era: this.era ?? t.era,
        year: this.year ?? t.year,
        month: this.month ?? t.month,
        day: this.day ?? t.day,
        hour: n ?? t.hour,
        minute: this.minute ?? t.minute,
        second: this.second ?? t.second,
        millisecond: this.millisecond ?? t.millisecond
      });
      return "offset" in r && this.offset != null && r.offset !== this.offset && (r = r.add({
        milliseconds: r.offset - this.offset
      })), r;
    } else return t.set({
      era: this.era ?? t.era,
      year: this.year ?? t.year,
      month: this.month ?? t.month,
      day: this.day ?? t.day
    });
  }
  getSegmentLimits(t) {
    switch (t) {
      case "era": {
        let n = this.calendar.getEras();
        return {
          value: this.era != null ? n.indexOf(this.era) : n.length - 1,
          minValue: 0,
          maxValue: n.length - 1
        };
      }
      case "year":
        return {
          value: this.year,
          minValue: 1,
          maxValue: 9999
        };
      case "month":
        return {
          value: this.month,
          minValue: 1,
          maxValue: this.calendar.getMaximumMonthsInYear()
        };
      case "day":
        return {
          value: this.day,
          minValue: 1,
          maxValue: this.calendar.getMaximumDaysInMonth()
        };
      case "dayPeriod":
        return {
          value: this.dayPeriod,
          minValue: 0,
          maxValue: 1
        };
      case "hour": {
        let n = 0, r = 23;
        return this.hourCycle === "h12" ? (n = 1, r = 12) : this.hourCycle === "h11" && (n = 0, r = 11), {
          value: this.hour,
          minValue: n,
          maxValue: r
        };
      }
      case "minute":
        return {
          value: this.minute,
          minValue: 0,
          maxValue: 59
        };
      case "second":
        return {
          value: this.second,
          minValue: 0,
          maxValue: 59
        };
    }
  }
}
function wn(e, t, n, r, a = !1) {
  if (a) {
    e += Math.sign(t), e < n && (e = r);
    let l = Math.abs(t);
    t > 0 ? e = Math.ceil(e / l) * l : e = Math.floor(e / l) * l, e > r && (e = n);
  } else
    e += t, e < n ? e = r - (n - e - 1) : e > r && (e = n + (e - r - 1));
  return e;
}
function tr(e, t) {
  let n = e >= 12 ? 1 : 0;
  switch (t) {
    case "h11":
      e >= 12 && (e -= 12);
      break;
    case "h12":
      e === 0 ? e = 12 : e > 12 && (e -= 12);
      break;
    case "h23":
      n = null;
      break;
    case "h24":
      e += 1, n = null;
  }
  return [
    n,
    e
  ];
}
function L7(e, t, n) {
  switch (n) {
    case "h11":
      t === 1 && (e += 12);
      break;
    case "h12":
      e === 12 && (e = 0), t === 1 && (e += 12);
      break;
    case "h24":
      e -= 1;
      break;
  }
  return e;
}
const bi = {
  year: !0,
  month: !0,
  day: !0,
  hour: !0,
  minute: !0,
  second: !0,
  dayPeriod: !0,
  era: !0
}, Dd = {
  year: 5,
  month: 2,
  day: 7,
  hour: 2,
  minute: 15,
  second: 15
}, z7 = {
  // Node seems to convert everything to lowercase...
  dayperiod: "dayPeriod",
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts#named_years
  relatedYear: "year",
  yearName: "literal",
  unknown: "literal"
};
function O7(e) {
  let { locale: t, createCalendar: n, hideTimeZone: r, isDisabled: a = !1, isReadOnly: l = !1, isRequired: i = !1, minValue: u, maxValue: o, isDateUnavailable: d } = e, s = e.value || e.defaultValue || e.placeholderValue || null, [c, f] = W0(s, e.granularity), h = f || "UTC";
  if (s && !(c in s)) throw new Error("Invalid granularity " + c + " for value " + s.toString());
  let [m, b] = K(() => {
    let re = new qt(t, {
      dateStyle: "short",
      timeStyle: "short",
      hour12: e.hourCycle != null ? e.hourCycle === 12 : void 0
    }).resolvedOptions();
    return [
      n(re.calendar),
      re.hourCycle
    ];
  }, [
    t,
    e.hourCycle,
    n
  ]), [p, y] = we(e.value, e.defaultValue ?? null, e.onChange), [$] = Y(p), v = K(() => _0(p, m) ?? null, [
    p,
    m
  ]), [x, E] = Y(() => new It(m, b, v)), P = m.identifier === "gregory" && x.era === "BC", C = K(() => ({
    granularity: c,
    maxGranularity: e.maxGranularity ?? "year",
    timeZone: f,
    hideTimeZone: r,
    hourCycle: e.hourCycle,
    showEra: P,
    shouldForceLeadingZeros: e.shouldForceLeadingZeros
  }), [
    e.maxGranularity,
    c,
    e.hourCycle,
    e.shouldForceLeadingZeros,
    f,
    r,
    P
  ]), M = K(() => br({}, C), [
    C
  ]), F = K(() => new qt(t, M), [
    t,
    M
  ]), V = K(() => F.resolvedOptions(), [
    F
  ]), I = K(() => K7(e.placeholderValue, c, m, f), [
    e.placeholderValue,
    c,
    m,
    f
  ]), A = K(() => {
    let q = b === "h11" || b === "h12", re = [
      "era",
      "year",
      "month",
      "day",
      "hour",
      ...q ? [
        "dayPeriod"
      ] : [],
      "minute",
      "second"
    ], fe = re.indexOf(e.maxGranularity || "era"), tt = re.indexOf(c === "hour" && q ? "dayPeriod" : c);
    return re.slice(fe, tt + 1);
  }, [
    e.maxGranularity,
    c,
    b
  ]), [U, D] = Y(v), [N, w] = Y(m), [R, H] = Y(b);
  (v !== U || b !== R || !Cl(m, N)) && (x = new It(m, b, v), D(v), w(m), H(b), E(x));
  let k = (q) => {
    if (!(e.isDisabled || e.isReadOnly))
      if (q == null || q instanceof It && q.isCleared(A))
        E(new It(m, b, v)), y(null);
      else if (!(q instanceof It))
        q = ke(q, s?.calendar || new _e()), E(new It(m, b, v)), y(q);
      else {
        if (q.isComplete(A)) {
          let re = q.toValue(v ?? I);
          if (q.validate(re, A)) {
            let fe = ke(re, s?.calendar || new _e());
            if (!p || fe.compare(p) !== 0) {
              E(new It(m, b, v)), y(fe);
              return;
            }
          }
        }
        E(q);
      }
  }, S = K(() => x.toValue(v ?? I).toDate(h), [
    x,
    h,
    v,
    I
  ]), j = K(() => H7(S, x, F, V, m, t, c), [
    S,
    F,
    V,
    x,
    m,
    t,
    c
  ]), _ = (q, re) => {
    k(x.cycle(q, re, I, A));
  }, B = K(() => j0(p, u, o, d, C), [
    p,
    u,
    o,
    d,
    C
  ]), L = rn({
    ...e,
    value: p,
    builtinValidation: B
  }), Z = L.displayValidation.isInvalid, ie = e.validationState || (Z ? "invalid" : null);
  return {
    ...L,
    value: v,
    defaultValue: e.defaultValue ?? $,
    dateValue: S,
    calendar: m,
    setValue: k,
    segments: j,
    dateFormatter: F,
    validationState: ie,
    isInvalid: Z,
    granularity: c,
    maxGranularity: e.maxGranularity ?? "year",
    isDisabled: a,
    isReadOnly: l,
    isRequired: i,
    increment(q) {
      _(q, 1);
    },
    decrement(q) {
      _(q, -1);
    },
    incrementPage(q) {
      _(q, Dd[q] || 1);
    },
    decrementPage(q) {
      _(q, -(Dd[q] || 1));
    },
    incrementToMax(q) {
      let re = q === "hour" && b === "h12" ? 11 : x.getSegmentLimits(q).maxValue;
      k(x.set(q, re, I));
    },
    decrementToMin(q) {
      let re = q === "hour" && b === "h12" ? 12 : x.getSegmentLimits(q).minValue;
      k(x.set(q, re, I));
    },
    setSegment(q, re) {
      k(x.set(q, re, I));
    },
    confirmPlaceholder() {
      if (!(e.isDisabled || e.isReadOnly) && x.isComplete(A)) {
        let q = x.toValue(v ?? I), re = ke(q, s?.calendar || new _e());
        (!p || re.compare(p) !== 0) && y(re), E(new It(m, b, v));
      }
    },
    clearSegment(q) {
      let re = x;
      q !== "timeZoneName" && q !== "literal" && (re = x.clear(q)), k(re);
    },
    formatValue(q) {
      if (!v) return "";
      let re = br(q, C);
      return new qt(t, re).format(S);
    },
    getDateFormatter(q, re) {
      let fe = {
        ...C,
        ...re
      }, tt = br({}, fe);
      return new qt(q, tt);
    }
  };
}
function H7(e, t, n, r, a, l, i) {
  let u = [
    "hour",
    "minute",
    "second"
  ], o = n.formatToParts(e), d = new Lt(l, {
    useGrouping: !1
  }), s = new Lt(l, {
    useGrouping: !1,
    minimumIntegerDigits: 2
  });
  for (let f of o) if (f.type === "year" || f.type === "month" || f.type === "day" || f.type === "hour") {
    let h = t[f.type] ?? 0;
    r[f.type] === "2-digit" ? f.value = s.format(h) : f.value = d.format(h);
  }
  let c = [];
  for (let f of o) {
    let h = z7[f.type] || f.type, m = bi[h];
    h === "era" && a.getEras().length === 1 && (m = !1);
    let b = bi[h] && t[f.type] == null, p = bi[h] ? V7(h, f.value, l) : null, y = {
      type: h,
      text: b ? p : f.value,
      ...t.getSegmentLimits(h),
      isPlaceholder: b,
      placeholder: p,
      isEditable: m
    };
    h === "hour" ? (c.push({
      type: "literal",
      text: "⁦",
      isPlaceholder: !1,
      placeholder: "",
      isEditable: !1
    }), c.push(y), h === i && c.push({
      type: "literal",
      text: "⁩",
      isPlaceholder: !1,
      placeholder: "",
      isEditable: !1
    })) : u.includes(h) && h === i ? (c.push(y), c.push({
      type: "literal",
      text: "⁩",
      isPlaceholder: !1,
      placeholder: "",
      isEditable: !1
    })) : c.push(y);
  }
  return c;
}
const G0 = /* @__PURE__ */ G(null), Ml = /* @__PURE__ */ G(null), mo = /* @__PURE__ */ G(null), FC = /* @__PURE__ */ te(function(t, n) {
  let r = O(Ml), a = O(mo);
  return r || a ? /* @__PURE__ */ g.createElement(q0, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(U7, {
    ...t,
    ref: n
  });
}), U7 = /* @__PURE__ */ te((e, t) => {
  let [n, r] = oe({
    slot: e.slot
  }, t, G0), { locale: a } = de(), l = O7({
    ...n,
    locale: a,
    createCalendar: Q4
  }), i = T(null), { fieldProps: u, inputProps: o } = P7({
    ...n,
    inputRef: i
  }, l, r);
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Ml,
        l
      ],
      [
        wr,
        {
          ...o,
          ref: i
        }
      ],
      [
        Dn,
        {
          ...u,
          ref: r,
          isInvalid: l.isInvalid,
          isDisabled: l.isDisabled
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(q0, e));
}), q0 = /* @__PURE__ */ te((e, t) => {
  let { className: n, children: r } = e, a = O(Ml), l = O(mo), i = a ?? l;
  return /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(PD, {
    ...e,
    ref: t,
    slot: e.slot || void 0,
    className: n ?? "react-aria-DateInput",
    isReadOnly: i.isReadOnly,
    isInvalid: i.isInvalid,
    isDisabled: i.isDisabled
  }, i.segments.map((u, o) => /* @__PURE__ */ cu(r(u), {
    key: o
  }))), /* @__PURE__ */ g.createElement(SD, {
    className: ""
  }));
}), AC = /* @__PURE__ */ te(function({ segment: t, ...n }, r) {
  let a = O(Ml), l = O(mo), i = a ?? l, u = $e(r), { segmentProps: o } = B7(t, i, u), { focusProps: d, isFocused: s, isFocusVisible: c } = ye(), { hoverProps: f, isHovered: h } = De({
    ...n,
    isDisabled: i.isDisabled || t.type === "literal"
  }), m = le({
    ...n,
    values: {
      ...t,
      isReadOnly: i.isReadOnly,
      isInvalid: i.isInvalid,
      isDisabled: i.isDisabled,
      isHovered: h,
      isFocused: s,
      isFocusVisible: c
    },
    defaultChildren: t.text,
    defaultClassName: "react-aria-DateSegment"
  });
  return /* @__PURE__ */ g.createElement(Q.span, {
    ...z(J(n, {
      global: !0
    }), o, d, f),
    ...m,
    style: o.style,
    ref: u,
    "data-placeholder": t.isPlaceholder || void 0,
    "data-invalid": i.isInvalid || void 0,
    "data-readonly": i.isReadOnly || void 0,
    "data-disabled": i.isDisabled || void 0,
    "data-type": t.type,
    "data-hovered": h || void 0,
    "data-focused": s || void 0,
    "data-focus-visible": c || void 0
  });
});
function j7(e) {
  return e && e.__esModule ? e.default : e;
}
function _7(e, t, n) {
  let r = ce(), a = ce(), l = ce(), i = Ee(j7(Il), "@react-aria/datepicker"), { isInvalid: u, validationErrors: o, validationDetails: d } = t.displayValidation, { labelProps: s, fieldProps: c, descriptionProps: f, errorMessageProps: h } = Pr({
    ...e,
    labelElementType: "span",
    isInvalid: u,
    errorMessage: e.errorMessage || o
  }), m = u0(t, n), b = c["aria-labelledby"] || c.id, { locale: p } = de(), y = t.formatValue(p, {
    month: "long"
  }), $ = y ? i.format("selectedDateDescription", {
    date: y
  }) : "", v = en($), x = [
    v["aria-describedby"],
    c["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0, E = J(e), P = K(() => Fl(n), [
    n
  ]), C = T(!1), { focusWithinProps: M } = ft({
    ...e,
    isDisabled: t.isOpen,
    onBlurWithin: (F) => {
      let V = document.getElementById(a);
      ae(V, F.relatedTarget) || (C.current = !1, e.onBlur?.(F), e.onFocusChange?.(!1));
    },
    onFocusWithin: (F) => {
      C.current || (C.current = !0, e.onFocus?.(F), e.onFocusChange?.(!0));
    }
  });
  return {
    groupProps: z(E, m, c, v, M, {
      role: "group",
      "aria-disabled": e.isDisabled || null,
      "aria-labelledby": b,
      "aria-describedby": x,
      onKeyDown(F) {
        t.isOpen || e.onKeyDown && e.onKeyDown(F);
      },
      onKeyUp(F) {
        t.isOpen || e.onKeyUp && e.onKeyUp(F);
      }
    }),
    labelProps: {
      ...s,
      onClick: () => {
        P.focusFirst();
      }
    },
    fieldProps: {
      ...c,
      id: l,
      [ja]: "presentation",
      "aria-describedby": x,
      value: t.value,
      defaultValue: t.defaultValue,
      onChange: t.setValue,
      placeholderValue: e.placeholderValue,
      hideTimeZone: e.hideTimeZone,
      hourCycle: e.hourCycle,
      shouldForceLeadingZeros: e.shouldForceLeadingZeros,
      granularity: e.granularity,
      isDisabled: e.isDisabled,
      isReadOnly: e.isReadOnly,
      isRequired: e.isRequired,
      validationBehavior: e.validationBehavior,
      // DatePicker owns the validation state for the date field.
      [Hn]: t,
      autoFocus: e.autoFocus,
      name: e.name,
      form: e.form
    },
    descriptionProps: f,
    errorMessageProps: h,
    buttonProps: {
      ...v,
      id: r,
      "aria-haspopup": "dialog",
      "aria-label": i.format("calendar"),
      "aria-labelledby": `${r} ${b}`,
      "aria-describedby": x,
      "aria-expanded": t.isOpen,
      isDisabled: e.isDisabled || e.isReadOnly,
      onPress: () => t.setOpen(!0)
    },
    dialogProps: {
      id: a,
      "aria-labelledby": `${r} ${b}`
    },
    calendarProps: {
      autoFocus: !0,
      value: t.dateValue,
      onChange: t.setDateValue,
      minValue: e.minValue,
      maxValue: e.maxValue,
      isDisabled: e.isDisabled,
      isReadOnly: e.isReadOnly,
      isDateUnavailable: e.isDateUnavailable,
      defaultFocusedValue: t.dateValue ? void 0 : e.placeholderValue,
      isInvalid: t.isInvalid,
      errorMessage: typeof e.errorMessage == "function" ? e.errorMessage(t.displayValidation) : e.errorMessage || t.displayValidation.validationErrors.join(" "),
      firstDayOfWeek: e.firstDayOfWeek,
      pageBehavior: e.pageBehavior
    },
    isInvalid: u,
    validationErrors: o,
    validationDetails: d
  };
}
function W7(e) {
  let t = Fr(e), [n, r] = we(e.value, e.defaultValue || null, e.onChange), [a] = Y(n), l = n || e.placeholderValue || null, [i, u] = W0(l, e.granularity), o = n != null ? n.toDate(u ?? "UTC") : null, d = i === "hour" || i === "minute" || i === "second", s = e.shouldCloseOnSelect ?? !0, [c, f] = Y(null), [h, m] = Y(null);
  if (n && (c = n, "hour" in n && (h = n)), l && !(i in l)) throw new Error("Invalid granularity " + i + " for value " + l.toString());
  let b = n?.calendar.identifier === "gregory" && n.era === "BC", p = K(() => ({
    granularity: i,
    timeZone: u,
    hideTimeZone: e.hideTimeZone,
    hourCycle: e.hourCycle,
    shouldForceLeadingZeros: e.shouldForceLeadingZeros,
    showEra: b
  }), [
    i,
    e.hourCycle,
    e.shouldForceLeadingZeros,
    u,
    e.hideTimeZone,
    b
  ]), { minValue: y, maxValue: $, isDateUnavailable: v } = e, x = K(() => j0(n, y, $, v, p), [
    n,
    y,
    $,
    v,
    p
  ]), E = rn({
    ...e,
    value: n,
    builtinValidation: x
  }), P = E.displayValidation.isInvalid, C = e.validationState || (P ? "invalid" : null), M = (I, A) => {
    r("timeZone" in A ? A.set(it(I)) : Et(I, A)), f(null), m(null), E.commitValidation();
  }, F = (I) => {
    let A = typeof s == "function" ? s() : s;
    d ? h || A ? M(I, h || vd(e.defaultValue || e.placeholderValue)) : f(I) : (r(I), E.commitValidation()), A && t.setOpen(!1);
  }, V = (I) => {
    c && I ? M(c, I) : m(I);
  };
  return {
    ...E,
    value: n,
    defaultValue: e.defaultValue ?? a,
    setValue: r,
    dateValue: c,
    timeValue: h,
    setDateValue: F,
    setTimeValue: V,
    granularity: i,
    hasTime: d,
    ...t,
    setOpen(I) {
      !I && !n && c && d && M(c, h || vd(e.defaultValue || e.placeholderValue)), t.setOpen(I);
    },
    validationState: C,
    isInvalid: P,
    formatValue(I, A) {
      if (!o) return "";
      let U = br(A, p);
      return new qt(I, U).format(o);
    },
    getDateFormatter(I, A) {
      let U = {
        ...p,
        ...A
      }, D = br({}, U);
      return new qt(I, D);
    }
  };
}
const G7 = /* @__PURE__ */ G(null), q7 = /* @__PURE__ */ G(null), Y7 = [
  Dn,
  Xe,
  et,
  We
], RC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, G7);
  let { validationBehavior: r } = He(_n) || {}, a = t.validationBehavior ?? r ?? "native", l = W7({
    ...t,
    validationBehavior: a
  }), i = T(null), [u, o] = Qe(!t["aria-label"] && !t["aria-labelledby"]), { groupProps: d, labelProps: s, fieldProps: c, buttonProps: f, dialogProps: h, calendarProps: m, descriptionProps: b, errorMessageProps: p, ...y } = _7({
    ...wt(t),
    label: o,
    validationBehavior: a
  }, l, i), { focusProps: $, isFocused: v, isFocusVisible: x } = ye({
    within: !0
  }), E = le({
    ...t,
    values: {
      state: l,
      isFocusWithin: v,
      isFocusVisible: x,
      isDisabled: t.isDisabled || !1,
      isInvalid: l.isInvalid,
      isOpen: l.isOpen,
      isReadOnly: t.isReadOnly || !1,
      isRequired: t.isRequired || !1
    },
    defaultClassName: "react-aria-DatePicker"
  }), P = J(t, {
    global: !0
  });
  return delete P.id, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        q7,
        l
      ],
      [
        Dn,
        {
          ...d,
          ref: i,
          isInvalid: l.isInvalid
        }
      ],
      [
        G0,
        c
      ],
      [
        Xe,
        {
          ...f,
          isPressed: l.isOpen
        }
      ],
      [
        et,
        {
          ...s,
          ref: u,
          elementType: "span"
        }
      ],
      [
        sl,
        m
      ],
      [
        Ot,
        l
      ],
      [
        Ar,
        {
          trigger: "DatePicker",
          triggerRef: i,
          placement: "bottom start",
          clearContexts: Y7
        }
      ],
      [
        ho,
        h
      ],
      [
        We,
        {
          slots: {
            description: b,
            errorMessage: p
          }
        }
      ],
      [
        nn,
        y
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(P, E, $),
    ref: n,
    slot: t.slot || void 0,
    "data-focus-within": v || void 0,
    "data-invalid": l.isInvalid || void 0,
    "data-focus-visible": x || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-readonly": t.isReadOnly || void 0,
    "data-required": t.isRequired || void 0,
    "data-open": l.isOpen || void 0
  }), /* @__PURE__ */ g.createElement(x7, {
    autoComplete: t.autoComplete,
    name: t.name,
    isDisabled: t.isDisabled,
    state: l
  }));
});
function Z7(e, t, n) {
  let { isDisabled: r } = e, a = ce(), l = ce(), i = Ct(), u = T(null), o = X(() => {
    u.current = requestAnimationFrame(() => {
      n.current && n.current.setAttribute("hidden", "until-found");
    }), lt(() => {
      t.toggle();
    });
  }, [
    n,
    t
  ]);
  bt(n, "beforematch", o);
  let d = T(null);
  return ue(() => {
    if (u.current && cancelAnimationFrame(u.current), n.current && !i) {
      let s = n.current;
      d.current == null || typeof s.getAnimations != "function" ? t.isExpanded ? (s.removeAttribute("hidden"), s.style.setProperty("--disclosure-panel-width", "auto"), s.style.setProperty("--disclosure-panel-height", "auto")) : (s.setAttribute("hidden", "until-found"), s.style.setProperty("--disclosure-panel-width", "0px"), s.style.setProperty("--disclosure-panel-height", "0px")) : t.isExpanded !== d.current && (t.isExpanded ? (s.removeAttribute("hidden"), s.style.setProperty("--disclosure-panel-width", s.scrollWidth + "px"), s.style.setProperty("--disclosure-panel-height", s.scrollHeight + "px"), Promise.all(s.getAnimations().map((c) => c.finished)).then(() => {
        s.style.setProperty("--disclosure-panel-width", "auto"), s.style.setProperty("--disclosure-panel-height", "auto");
      }).catch(() => {
      })) : (s.style.setProperty("--disclosure-panel-width", s.scrollWidth + "px"), s.style.setProperty("--disclosure-panel-height", s.scrollHeight + "px"), window.getComputedStyle(s).height, s.style.setProperty("--disclosure-panel-width", "0px"), s.style.setProperty("--disclosure-panel-height", "0px"), Promise.all(s.getAnimations().map((c) => c.finished)).then(() => s.setAttribute("hidden", "until-found")).catch(() => {
      }))), d.current = t.isExpanded;
    }
  }, [
    r,
    n,
    t.isExpanded,
    i
  ]), ee(() => () => {
    u.current && cancelAnimationFrame(u.current);
  }, []), {
    buttonProps: {
      id: a,
      "aria-expanded": t.isExpanded,
      "aria-controls": l,
      onPress: (s) => {
        !r && s.pointerType !== "keyboard" && t.toggle();
      },
      isDisabled: r,
      onPressStart(s) {
        s.pointerType === "keyboard" && !r && t.toggle();
      }
    },
    panelProps: {
      id: l,
      // This can be overridden at the panel element level.
      role: "group",
      "aria-labelledby": a,
      "aria-hidden": !t.isExpanded,
      hidden: i ? !t.isExpanded : void 0
    }
  };
}
function X7(e) {
  let { allowsMultipleExpanded: t = !1, isDisabled: n = !1 } = e, [r, a] = we(K(() => e.expandedKeys ? new Set(e.expandedKeys) : void 0, [
    e.expandedKeys
  ]), K(() => e.defaultExpandedKeys ? new Set(e.defaultExpandedKeys) : /* @__PURE__ */ new Set(), [
    e.defaultExpandedKeys
  ]), e.onExpandedChange);
  return ee(() => {
    if (!t && r.size > 1) {
      let l = r.values().next().value;
      l != null && a(/* @__PURE__ */ new Set([
        l
      ]));
    }
  }), {
    allowsMultipleExpanded: t,
    isDisabled: n,
    expandedKeys: r,
    setExpandedKeys: a,
    toggleKey(l) {
      let i;
      t ? (i = new Set(r), i.has(l) ? i.delete(l) : i.add(l)) : i = new Set(r.has(l) ? [] : [
        l
      ]), a(i);
    }
  };
}
function J7(e) {
  let [t, n] = we(e.isExpanded, e.defaultExpanded || !1, e.onExpandedChange);
  const r = X(() => {
    n(!0);
  }, [
    n
  ]), a = X(() => {
    n(!1);
  }, [
    n
  ]), l = X(() => {
    n(!t);
  }, [
    n,
    t
  ]);
  return {
    isExpanded: t,
    setExpanded: n,
    expand: r,
    collapse: a,
    toggle: l
  };
}
const Y0 = /* @__PURE__ */ G(null), TC = /* @__PURE__ */ te(function(t, n) {
  let r = X7(t), a = le({
    ...t,
    defaultClassName: "react-aria-DisclosureGroup",
    values: {
      isDisabled: r.isDisabled,
      state: r
    }
  }), l = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...l,
    ...a,
    ref: n,
    "data-disabled": t.isDisabled || void 0
  }, /* @__PURE__ */ g.createElement(Y0.Provider, {
    value: r
  }, a.children));
}), Q7 = /* @__PURE__ */ G(null), eE = /* @__PURE__ */ G(null), Z0 = /* @__PURE__ */ G(null), IC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Q7);
  let r = O(Y0), { id: a, ...l } = t, i = ce();
  a ||= i;
  let u = r ? r.expandedKeys.has(a) : t.isExpanded, o = J7({
    ...t,
    isExpanded: u,
    onExpandedChange(y) {
      r && r.toggleKey(a), t.onExpandedChange?.(y);
    }
  }), d = g.useRef(null), s = t.isDisabled || r?.isDisabled || !1, { buttonProps: c, panelProps: f } = Z7({
    ...t,
    isExpanded: u,
    isDisabled: s
  }, o, d), { isFocusVisible: h, focusProps: m } = ye({
    within: !0
  }), b = le({
    ...t,
    id: void 0,
    defaultClassName: "react-aria-Disclosure",
    values: {
      isExpanded: o.isExpanded,
      isDisabled: s,
      isFocusVisibleWithin: h,
      state: o
    }
  }), p = J(l, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Xe,
        {
          slots: {
            [$t]: {},
            trigger: c
          }
        }
      ],
      [
        Z0,
        {
          panelProps: f,
          panelRef: d
        }
      ],
      [
        eE,
        o
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(p, b, m),
    ref: n,
    "data-expanded": o.isExpanded || void 0,
    "data-disabled": s || void 0,
    "data-focus-visible-within": h || void 0
  }, b.children));
}), MC = /* @__PURE__ */ te(function(t, n) {
  let { role: r = "group" } = t, { panelProps: a, panelRef: l } = O(Z0), { isFocusVisible: i, focusProps: u } = ye({
    within: !0
  }), o = le({
    ...t,
    defaultClassName: "react-aria-DisclosurePanel",
    values: {
      isFocusVisibleWithin: i
    }
  }), d = J(t, {
    global: !0,
    labelable: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(d, o, a, u),
    ref: Pt(n, l),
    role: r,
    "data-focus-visible-within": i || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Xe,
        null
      ]
    ]
  }, t.children));
}), bo = /* @__PURE__ */ new WeakMap();
function xd(e, t) {
  let { id: n } = bo.get(e) ?? {};
  if (!n) throw new Error("Unknown list");
  return `${n}-${tE(t)}`;
}
function tE(e) {
  return typeof e == "string" ? e.replace(/\s*/g, "") : "" + e;
}
var X0 = {};
X0 = {
  deselectedItem: (e) => `${e.item} غير المحدد`,
  longPressToSelect: "اضغط مطولًا للدخول إلى وضع التحديد.",
  select: "تحديد",
  selectedAll: "جميع العناصر المحددة.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "لم يتم تحديد عناصر",
    one: () => `${t.number(e.count)} عنصر محدد`,
    other: () => `${t.number(e.count)} عنصر محدد`
  })}.`,
  selectedItem: (e) => `${e.item} المحدد`
};
var J0 = {};
J0 = {
  deselectedItem: (e) => `${e.item} не е избран.`,
  longPressToSelect: "Натиснете и задръжте за да влезете в избирателен режим.",
  select: "Изберете",
  selectedAll: "Всички елементи са избрани.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Няма избрани елементи",
    one: () => `${t.number(e.count)} избран елемент`,
    other: () => `${t.number(e.count)} избрани елементи`
  })}.`,
  selectedItem: (e) => `${e.item} избран.`
};
var Q0 = {};
Q0 = {
  deselectedItem: (e) => `Položka ${e.item} není vybrána.`,
  longPressToSelect: "Dlouhým stisknutím přejdete do režimu výběru.",
  select: "Vybrat",
  selectedAll: "Vybrány všechny položky.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nevybrány žádné položky",
    one: () => `Vybrána ${t.number(e.count)} položka`,
    other: () => `Vybráno ${t.number(e.count)} položek`
  })}.`,
  selectedItem: (e) => `Vybrána položka ${e.item}.`
};
var ey = {};
ey = {
  deselectedItem: (e) => `${e.item} ikke valgt.`,
  longPressToSelect: "Lav et langt tryk for at aktivere valgtilstand.",
  select: "Vælg",
  selectedAll: "Alle elementer valgt.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Ingen elementer valgt",
    one: () => `${t.number(e.count)} element valgt`,
    other: () => `${t.number(e.count)} elementer valgt`
  })}.`,
  selectedItem: (e) => `${e.item} valgt.`
};
var ty = {};
ty = {
  deselectedItem: (e) => `${e.item} nicht ausgewählt.`,
  longPressToSelect: "Gedrückt halten, um Auswahlmodus zu öffnen.",
  select: "Auswählen",
  selectedAll: "Alle Elemente ausgewählt.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Keine Elemente ausgewählt",
    one: () => `${t.number(e.count)} Element ausgewählt`,
    other: () => `${t.number(e.count)} Elemente ausgewählt`
  })}.`,
  selectedItem: (e) => `${e.item} ausgewählt.`
};
var ny = {};
ny = {
  deselectedItem: (e) => `Δεν επιλέχθηκε το στοιχείο ${e.item}.`,
  longPressToSelect: "Πατήστε παρατεταμένα για να μπείτε σε λειτουργία επιλογής.",
  select: "Επιλογή",
  selectedAll: "Επιλέχθηκαν όλα τα στοιχεία.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Δεν επιλέχθηκαν στοιχεία",
    one: () => `Επιλέχθηκε ${t.number(e.count)} στοιχείο`,
    other: () => `Επιλέχθηκαν ${t.number(e.count)} στοιχεία`
  })}.`,
  selectedItem: (e) => `Επιλέχθηκε το στοιχείο ${e.item}.`
};
var ry = {};
ry = {
  deselectedItem: (e) => `${e.item} not selected.`,
  select: "Select",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "No items selected",
    one: () => `${t.number(e.count)} item selected`,
    other: () => `${t.number(e.count)} items selected`
  })}.`,
  selectedAll: "All items selected.",
  selectedItem: (e) => `${e.item} selected.`,
  longPressToSelect: "Long press to enter selection mode."
};
var ay = {};
ay = {
  deselectedItem: (e) => `${e.item} no seleccionado.`,
  longPressToSelect: "Mantenga pulsado para abrir el modo de selección.",
  select: "Seleccionar",
  selectedAll: "Todos los elementos seleccionados.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Ningún elemento seleccionado",
    one: () => `${t.number(e.count)} elemento seleccionado`,
    other: () => `${t.number(e.count)} elementos seleccionados`
  })}.`,
  selectedItem: (e) => `${e.item} seleccionado.`
};
var ly = {};
ly = {
  deselectedItem: (e) => `${e.item} pole valitud.`,
  longPressToSelect: "Valikurežiimi sisenemiseks vajutage pikalt.",
  select: "Vali",
  selectedAll: "Kõik üksused valitud.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Üksusi pole valitud",
    one: () => `${t.number(e.count)} üksus valitud`,
    other: () => `${t.number(e.count)} üksust valitud`
  })}.`,
  selectedItem: (e) => `${e.item} valitud.`
};
var iy = {};
iy = {
  deselectedItem: (e) => `Kohdetta ${e.item} ei valittu.`,
  longPressToSelect: "Siirry valintatilaan painamalla pitkään.",
  select: "Valitse",
  selectedAll: "Kaikki kohteet valittu.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Ei yhtään kohdetta valittu",
    one: () => `${t.number(e.count)} kohde valittu`,
    other: () => `${t.number(e.count)} kohdetta valittu`
  })}.`,
  selectedItem: (e) => `${e.item} valittu.`
};
var uy = {};
uy = {
  deselectedItem: (e) => `${e.item} non sélectionné.`,
  longPressToSelect: "Appuyez de manière prolongée pour passer en mode de sélection.",
  select: "Sélectionner",
  selectedAll: "Tous les éléments sélectionnés.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Aucun élément sélectionné",
    one: () => `${t.number(e.count)} élément sélectionné`,
    other: () => `${t.number(e.count)} éléments sélectionnés`
  })}.`,
  selectedItem: (e) => `${e.item} sélectionné.`
};
var oy = {};
oy = {
  deselectedItem: (e) => `${e.item} לא נבחר.`,
  longPressToSelect: "הקשה ארוכה לכניסה למצב בחירה.",
  select: "בחר",
  selectedAll: "כל הפריטים נבחרו.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "לא נבחרו פריטים",
    one: () => `פריט ${t.number(e.count)} נבחר`,
    other: () => `${t.number(e.count)} פריטים נבחרו`
  })}.`,
  selectedItem: (e) => `${e.item} נבחר.`
};
var sy = {};
sy = {
  deselectedItem: (e) => `Stavka ${e.item} nije odabrana.`,
  longPressToSelect: "Dugo pritisnite za ulazak u način odabira.",
  select: "Odaberite",
  selectedAll: "Odabrane su sve stavke.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nije odabrana nijedna stavka",
    one: () => `Odabrana je ${t.number(e.count)} stavka`,
    other: () => `Odabrano je ${t.number(e.count)} stavki`
  })}.`,
  selectedItem: (e) => `Stavka ${e.item} je odabrana.`
};
var dy = {};
dy = {
  deselectedItem: (e) => `${e.item} nincs kijelölve.`,
  longPressToSelect: "Nyomja hosszan a kijelöléshez.",
  select: "Kijelölés",
  selectedAll: "Az összes elem kijelölve.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Egy elem sincs kijelölve",
    one: () => `${t.number(e.count)} elem kijelölve`,
    other: () => `${t.number(e.count)} elem kijelölve`
  })}.`,
  selectedItem: (e) => `${e.item} kijelölve.`
};
var cy = {};
cy = {
  deselectedItem: (e) => `${e.item} non selezionato.`,
  longPressToSelect: "Premi a lungo per passare alla modalità di selezione.",
  select: "Seleziona",
  selectedAll: "Tutti gli elementi selezionati.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nessun elemento selezionato",
    one: () => `${t.number(e.count)} elemento selezionato`,
    other: () => `${t.number(e.count)} elementi selezionati`
  })}.`,
  selectedItem: (e) => `${e.item} selezionato.`
};
var fy = {};
fy = {
  deselectedItem: (e) => `${e.item} が選択されていません。`,
  longPressToSelect: "長押しして選択モードを開きます。",
  select: "選択",
  selectedAll: "すべての項目を選択しました。",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "項目が選択されていません",
    one: () => `${t.number(e.count)} 項目を選択しました`,
    other: () => `${t.number(e.count)} 項目を選択しました`
  })}。`,
  selectedItem: (e) => `${e.item} を選択しました。`
};
var hy = {};
hy = {
  deselectedItem: (e) => `${e.item}이(가) 선택되지 않았습니다.`,
  longPressToSelect: "선택 모드로 들어가려면 길게 누르십시오.",
  select: "선택",
  selectedAll: "모든 항목이 선택되었습니다.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "선택된 항목이 없습니다",
    one: () => `${t.number(e.count)}개 항목이 선택되었습니다`,
    other: () => `${t.number(e.count)}개 항목이 선택되었습니다`
  })}.`,
  selectedItem: (e) => `${e.item}이(가) 선택되었습니다.`
};
var my = {};
my = {
  deselectedItem: (e) => `${e.item} nepasirinkta.`,
  longPressToSelect: "Norėdami įjungti pasirinkimo režimą, paspauskite ir palaikykite.",
  select: "Pasirinkti",
  selectedAll: "Pasirinkti visi elementai.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nepasirinktas nė vienas elementas",
    one: () => `Pasirinktas ${t.number(e.count)} elementas`,
    other: () => `Pasirinkta elementų: ${t.number(e.count)}`
  })}.`,
  selectedItem: (e) => `Pasirinkta: ${e.item}.`
};
var by = {};
by = {
  deselectedItem: (e) => `Vienums ${e.item} nav atlasīts.`,
  longPressToSelect: "Ilgi turiet nospiestu. lai ieslēgtu atlases režīmu.",
  select: "Atlasīt",
  selectedAll: "Atlasīti visi vienumi.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nav atlasīts neviens vienums",
    one: () => `Atlasīto vienumu skaits: ${t.number(e.count)}`,
    other: () => `Atlasīto vienumu skaits: ${t.number(e.count)}`
  })}.`,
  selectedItem: (e) => `Atlasīts vienums ${e.item}.`
};
var py = {};
py = {
  deselectedItem: (e) => `${e.item} er ikke valgt.`,
  longPressToSelect: "Bruk et langt trykk for å gå inn i valgmodus.",
  select: "Velg",
  selectedAll: "Alle elementer er valgt.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Ingen elementer er valgt",
    one: () => `${t.number(e.count)} element er valgt`,
    other: () => `${t.number(e.count)} elementer er valgt`
  })}.`,
  selectedItem: (e) => `${e.item} er valgt.`
};
var gy = {};
gy = {
  deselectedItem: (e) => `${e.item} niet geselecteerd.`,
  longPressToSelect: "Druk lang om de selectiemodus te openen.",
  select: "Selecteren",
  selectedAll: "Alle items geselecteerd.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Geen items geselecteerd",
    one: () => `${t.number(e.count)} item geselecteerd`,
    other: () => `${t.number(e.count)} items geselecteerd`
  })}.`,
  selectedItem: (e) => `${e.item} geselecteerd.`
};
var yy = {};
yy = {
  deselectedItem: (e) => `Nie zaznaczono ${e.item}.`,
  longPressToSelect: "Naciśnij i przytrzymaj, aby wejść do trybu wyboru.",
  select: "Zaznacz",
  selectedAll: "Wszystkie zaznaczone elementy.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nie zaznaczono żadnych elementów",
    one: () => `${t.number(e.count)} zaznaczony element`,
    other: () => `${t.number(e.count)} zaznaczonych elementów`
  })}.`,
  selectedItem: (e) => `Zaznaczono ${e.item}.`
};
var $y = {};
$y = {
  deselectedItem: (e) => `${e.item} não selecionado.`,
  longPressToSelect: "Mantenha pressionado para entrar no modo de seleção.",
  select: "Selecionar",
  selectedAll: "Todos os itens selecionados.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nenhum item selecionado",
    one: () => `${t.number(e.count)} item selecionado`,
    other: () => `${t.number(e.count)} itens selecionados`
  })}.`,
  selectedItem: (e) => `${e.item} selecionado.`
};
var vy = {};
vy = {
  deselectedItem: (e) => `${e.item} não selecionado.`,
  longPressToSelect: "Prima continuamente para entrar no modo de seleção.",
  select: "Selecionar",
  selectedAll: "Todos os itens selecionados.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nenhum item selecionado",
    one: () => `${t.number(e.count)} item selecionado`,
    other: () => `${t.number(e.count)} itens selecionados`
  })}.`,
  selectedItem: (e) => `${e.item} selecionado.`
};
var Dy = {};
Dy = {
  deselectedItem: (e) => `${e.item} neselectat.`,
  longPressToSelect: "Apăsați lung pentru a intra în modul de selectare.",
  select: "Selectare",
  selectedAll: "Toate elementele selectate.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Niciun element selectat",
    one: () => `${t.number(e.count)} element selectat`,
    other: () => `${t.number(e.count)} elemente selectate`
  })}.`,
  selectedItem: (e) => `${e.item} selectat.`
};
var xy = {};
xy = {
  deselectedItem: (e) => `${e.item} не выбрано.`,
  longPressToSelect: "Нажмите и удерживайте для входа в режим выбора.",
  select: "Выбрать",
  selectedAll: "Выбраны все элементы.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Нет выбранных элементов",
    one: () => `${t.number(e.count)} элемент выбран`,
    other: () => `${t.number(e.count)} элементов выбрано`
  })}.`,
  selectedItem: (e) => `${e.item} выбрано.`
};
var Ey = {};
Ey = {
  deselectedItem: (e) => `Nevybraté položky: ${e.item}.`,
  longPressToSelect: "Dlhším stlačením prejdite do režimu výberu.",
  select: "Vybrať",
  selectedAll: "Všetky vybraté položky.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Žiadne vybraté položky",
    one: () => `${t.number(e.count)} vybratá položka`,
    other: () => `Počet vybratých položiek:${t.number(e.count)}`
  })}.`,
  selectedItem: (e) => `Vybraté položky: ${e.item}.`
};
var Cy = {};
Cy = {
  deselectedItem: (e) => `Element ${e.item} ni izbran.`,
  longPressToSelect: "Za izbirni način pritisnite in dlje časa držite.",
  select: "Izberite",
  selectedAll: "Vsi elementi so izbrani.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Noben element ni izbran",
    one: () => `${t.number(e.count)} element je izbran`,
    other: () => `${t.number(e.count)} elementov je izbranih`
  })}.`,
  selectedItem: (e) => `Element ${e.item} je izbran.`
};
var Py = {};
Py = {
  deselectedItem: (e) => `${e.item} nije izabrano.`,
  longPressToSelect: "Dugo pritisnite za ulazak u režim biranja.",
  select: "Izaberite",
  selectedAll: "Izabrane su sve stavke.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nije izabrana nijedna stavka",
    one: () => `Izabrana je ${t.number(e.count)} stavka`,
    other: () => `Izabrano je ${t.number(e.count)} stavki`
  })}.`,
  selectedItem: (e) => `${e.item} je izabrano.`
};
var wy = {};
wy = {
  deselectedItem: (e) => `${e.item} ej markerat.`,
  longPressToSelect: "Tryck länge när du vill öppna väljarläge.",
  select: "Markera",
  selectedAll: "Alla markerade objekt.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Inga markerade objekt",
    one: () => `${t.number(e.count)} markerat objekt`,
    other: () => `${t.number(e.count)} markerade objekt`
  })}.`,
  selectedItem: (e) => `${e.item} markerat.`
};
var Sy = {};
Sy = {
  deselectedItem: (e) => `${e.item} seçilmedi.`,
  longPressToSelect: "Seçim moduna girmek için uzun basın.",
  select: "Seç",
  selectedAll: "Tüm ögeler seçildi.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Hiçbir öge seçilmedi",
    one: () => `${t.number(e.count)} öge seçildi`,
    other: () => `${t.number(e.count)} öge seçildi`
  })}.`,
  selectedItem: (e) => `${e.item} seçildi.`
};
var ky = {};
ky = {
  deselectedItem: (e) => `${e.item} не вибрано.`,
  longPressToSelect: "Виконайте довге натиснення, щоб перейти в режим вибору.",
  select: "Вибрати",
  selectedAll: "Усі елементи вибрано.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Жодних елементів не вибрано",
    one: () => `${t.number(e.count)} елемент вибрано`,
    other: () => `Вибрано елементів: ${t.number(e.count)}`
  })}.`,
  selectedItem: (e) => `${e.item} вибрано.`
};
var By = {};
By = {
  deselectedItem: (e) => `未选择 ${e.item}。`,
  longPressToSelect: "长按以进入选择模式。",
  select: "选择",
  selectedAll: "已选择所有项目。",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "未选择项目",
    one: () => `已选择 ${t.number(e.count)} 个项目`,
    other: () => `已选择 ${t.number(e.count)} 个项目`
  })}。`,
  selectedItem: (e) => `已选择 ${e.item}。`
};
var Fy = {};
Fy = {
  deselectedItem: (e) => `未選取「${e.item}」。`,
  longPressToSelect: "長按以進入選擇模式。",
  select: "選取",
  selectedAll: "已選取所有項目。",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "未選取任何項目",
    one: () => `已選取 ${t.number(e.count)} 個項目`,
    other: () => `已選取 ${t.number(e.count)} 個項目`
  })}。`,
  selectedItem: (e) => `已選取「${e.item}」。`
};
var Kl = {};
Kl = {
  "ar-AE": X0,
  "bg-BG": J0,
  "cs-CZ": Q0,
  "da-DK": ey,
  "de-DE": ty,
  "el-GR": ny,
  "en-US": ry,
  "es-ES": ay,
  "et-EE": ly,
  "fi-FI": iy,
  "fr-FR": uy,
  "he-IL": oy,
  "hr-HR": sy,
  "hu-HU": dy,
  "it-IT": cy,
  "ja-JP": fy,
  "ko-KR": hy,
  "lt-LT": my,
  "lv-LV": by,
  "nb-NO": py,
  "nl-NL": gy,
  "pl-PL": yy,
  "pt-BR": $y,
  "pt-PT": vy,
  "ro-RO": Dy,
  "ru-RU": xy,
  "sk-SK": Ey,
  "sl-SI": Cy,
  "sr-SP": Py,
  "sv-SE": wy,
  "tr-TR": Sy,
  "uk-UA": ky,
  "zh-CN": By,
  "zh-TW": Fy
};
function nE(e) {
  return e && e.__esModule ? e.default : e;
}
function Ay(e, t) {
  let { getRowText: n = (u) => t.collection.getTextValue?.(u) ?? t.collection.getItem(u)?.textValue } = e, r = Ee(nE(Kl), "@react-aria/grid"), a = t.selectionManager.rawSelection, l = T(a), i = X(() => {
    if (!t.selectionManager.isFocused || a === l.current) {
      l.current = a;
      return;
    }
    let u = Ed(a, l.current), o = Ed(l.current, a), d = t.selectionManager.selectionBehavior === "replace", s = [];
    if (t.selectionManager.selectedKeys.size === 1 && d) {
      let c = t.selectionManager.selectedKeys.keys().next().value;
      if (c != null && t.collection.getItem(c)) {
        let f = n(c);
        f && s.push(r.format("selectedItem", {
          item: f
        }));
      }
    } else if (u.size === 1 && o.size === 0) {
      let c = u.keys().next().value;
      if (c != null) {
        let f = n(c);
        f && s.push(r.format("selectedItem", {
          item: f
        }));
      }
    } else if (o.size === 1 && u.size === 0) {
      let c = o.keys().next().value;
      if (c != null && t.collection.getItem(c)) {
        let f = n(c);
        f && s.push(r.format("deselectedItem", {
          item: f
        }));
      }
    }
    t.selectionManager.selectionMode === "multiple" && (s.length === 0 || a === "all" || a.size > 1 || l.current === "all" || l.current?.size > 1) && s.push(a === "all" ? r.format("selectedAll") : r.format("selectedCount", {
      count: a.size
    })), s.length > 0 && pn(s.join(" ")), l.current = a;
  }, [
    a,
    t.selectionManager.selectedKeys,
    t.selectionManager.isFocused,
    t.selectionManager.selectionBehavior,
    t.selectionManager.selectionMode,
    t.collection,
    n,
    r
  ]);
  ol(() => {
    if (t.selectionManager.isFocused) i();
    else {
      let u = requestAnimationFrame(i);
      return () => cancelAnimationFrame(u);
    }
  }, [
    a,
    t.selectionManager.isFocused
  ]);
}
function Ed(e, t) {
  let n = /* @__PURE__ */ new Set();
  if (e === "all" || t === "all") return n;
  for (let r of e.keys()) t.has(r) || n.add(r);
  return n;
}
function po(e, t) {
  let n = t?.isDisabled, [r, a] = Y(!1);
  return ue(() => {
    if (e?.current && !n) {
      let l = () => {
        if (e.current) {
          let u = Ie(e.current, {
            tabbable: !0
          });
          a(!!u.nextNode());
        }
      };
      l();
      let i = new MutationObserver(l);
      return i.observe(e.current, {
        subtree: !0,
        childList: !0,
        attributes: !0,
        attributeFilter: [
          "tabIndex",
          "disabled"
        ]
      }), () => {
        i.disconnect();
      };
    }
  }), n ? !1 : r;
}
function rE(e) {
  return e && e.__esModule ? e.default : e;
}
function Ry(e) {
  let t = Ee(rE(Kl), "@react-aria/grid"), n = Dl(), r = (n === "pointer" || n === "virtual" || n == null) && typeof window < "u" && "ontouchstart" in window, a = K(() => {
    let i = e.selectionManager.selectionMode, u = e.selectionManager.selectionBehavior, o;
    return r && (o = t.format("longPressToSelect")), u === "replace" && i !== "none" && e.hasItemActions ? o : void 0;
  }, [
    e.selectionManager.selectionMode,
    e.selectionManager.selectionBehavior,
    e.hasItemActions,
    t,
    r
  ]);
  return en(a);
}
function aE(e, t, n) {
  let { isVirtualized: r, keyboardDelegate: a, layoutDelegate: l, onAction: i, disallowTypeAhead: u, linkBehavior: o = "action", keyboardNavigationBehavior: d = "arrow", escapeKeyBehavior: s = "clearSelection", shouldSelectOnPressUp: c } = e;
  !e["aria-label"] && !e["aria-labelledby"] && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let { listProps: f } = io({
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    ref: n,
    keyboardDelegate: a,
    layoutDelegate: l,
    isVirtualized: r,
    selectOnFocus: t.selectionManager.selectionBehavior === "replace",
    shouldFocusWrap: e.shouldFocusWrap,
    linkBehavior: o,
    disallowTypeAhead: u,
    autoFocus: e.autoFocus,
    escapeKeyBehavior: s,
    UNSTABLE_focusOnEntry: e.UNSTABLE_focusOnEntry
  }), h = ce(e.id);
  bo.set(t, {
    id: h,
    onAction: i,
    linkBehavior: o,
    keyboardNavigationBehavior: d,
    shouldSelectOnPressUp: c
  });
  let m = Ry({
    selectionManager: t.selectionManager,
    hasItemActions: !!i
  }), b = po(n, {
    isDisabled: t.collection.size !== 0
  }), p = J(e, {
    labelable: !0
  }), y = z(
    p,
    {
      role: "grid",
      id: h,
      "aria-multiselectable": t.selectionManager.selectionMode === "multiple" ? "true" : void 0
    },
    // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    t.collection.size === 0 ? {
      tabIndex: b ? -1 : 0
    } : f,
    m
  );
  return r && (y["aria-rowcount"] = t.collection.size, y["aria-colcount"] = 1), Ay({}, t), {
    gridProps: y
  };
}
const Cd = {
  expand: {
    ltr: "ArrowRight",
    rtl: "ArrowLeft"
  },
  collapse: {
    ltr: "ArrowLeft",
    rtl: "ArrowRight"
  }
};
function lE(e, t, n) {
  let { node: r, isVirtualized: a } = e, { direction: l } = de(), { onAction: i, linkBehavior: u, keyboardNavigationBehavior: o, shouldSelectOnPressUp: d } = bo.get(t), s = yt(), c = T(null), f = () => {
    n.current !== null && (c.current != null && r.key !== c.current || !Yt(n.current)) && Se(n.current);
  }, h = {}, m = e.hasChildItems, b = t.selectionManager.isLink(r.key);
  if (r != null && "expandedKeys" in t) {
    let A = t.collection.getChildren?.(r.key);
    m = m || [
      ...A ?? []
    ].length > 1, i == null && !b && t.selectionManager.selectionMode === "none" && m && (i = () => t.toggleKey(r.key));
    let U = m ? t.expandedKeys.has(r.key) : void 0, D = 1, N = r.index;
    if (r.level >= 0 && r?.parentKey != null) {
      let w = t.collection.getItem(r.parentKey);
      if (w) {
        let R = iE(w, t.collection);
        D = [
          ...R
        ].filter((H) => H.type === "item").length, N > 0 && R[0].type !== "item" && (N -= 1);
      }
    } else D = [
      ...t.collection
    ].filter((w) => w.level === 0 && w.type === "item").length;
    h = {
      "aria-expanded": U,
      "aria-level": r.level + 1,
      "aria-posinset": N + 1,
      "aria-setsize": D
    };
  }
  let { itemProps: p, ...y } = kr({
    selectionManager: t.selectionManager,
    key: r.key,
    ref: n,
    isVirtualized: a,
    shouldSelectOnPressUp: e.shouldSelectOnPressUp || d,
    onAction: i || r.props?.onAction ? st(r.props?.onAction, i ? () => i(r.key) : void 0) : void 0,
    focus: f,
    linkBehavior: u
  }), $ = (A) => {
    let U = se();
    if (!ae(A.currentTarget, W(A)) || !n.current || !U) return;
    let D = Ie(n.current);
    if (D.currentNode = U, !Pd(A, t, r, m, l, U, n.current))
      switch (A.key) {
        case "ArrowLeft":
          if (o === "arrow") {
            let N = l === "rtl" ? D.nextNode() : D.previousNode();
            if (N)
              A.preventDefault(), A.stopPropagation(), Se(N), Oe(N, {
                containingElement: ze(n.current)
              });
            else if (A.preventDefault(), A.stopPropagation(), l === "rtl")
              Se(n.current), Oe(n.current, {
                containingElement: ze(n.current)
              });
            else {
              D.currentNode = n.current;
              let w = wd(D);
              w && (Se(w), Oe(w, {
                containingElement: ze(n.current)
              }));
            }
          }
          break;
        case "ArrowRight":
          if (o === "arrow") {
            let N = l === "rtl" ? D.previousNode() : D.nextNode();
            if (N)
              A.preventDefault(), A.stopPropagation(), Se(N), Oe(N, {
                containingElement: ze(n.current)
              });
            else if (A.preventDefault(), A.stopPropagation(), l === "ltr")
              Se(n.current), Oe(n.current, {
                containingElement: ze(n.current)
              });
            else {
              D.currentNode = n.current;
              let w = wd(D);
              w && (Se(w), Oe(w, {
                containingElement: ze(n.current)
              }));
            }
          }
          break;
        case "ArrowUp":
        case "ArrowDown":
          !A.altKey && ae(n.current, W(A)) && (A.stopPropagation(), A.preventDefault(), n.current.parentElement?.dispatchEvent(new KeyboardEvent(A.nativeEvent.type, A.nativeEvent)));
          break;
      }
  }, v = (A) => {
    if (c.current = r.key, W(A) !== n.current) {
      Vt() || t.selectionManager.setFocusedKey(r.key);
      return;
    }
  }, x = (A) => {
    let U = se();
    if (!(!ae(A.currentTarget, W(A)) || !n.current || !U)) {
      if (o === "tab") {
        if (W(A) !== n.current && A.key !== "Tab") {
          A.stopPropagation();
          return;
        }
        if (Pd(A, t, r, m, l, U, n.current)) return;
      }
      switch (A.key) {
        case "Tab":
          if (o === "tab") {
            let D = Ie(n.current, {
              tabbable: !0
            });
            D.currentNode = U, (A.shiftKey ? D.previousNode() : D.nextNode()) && A.stopPropagation();
          }
      }
    }
  }, E = $u(r.props), P = y.hasAction ? E : {}, C = z(p, P, {
    role: "row",
    onKeyDownCapture: o === "arrow" ? $ : void 0,
    onFocus: v,
    // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
    "aria-label": r["aria-label"] || r.textValue || void 0,
    "aria-selected": t.selectionManager.canSelectItem(r.key) ? t.selectionManager.isSelected(r.key) : void 0,
    "aria-disabled": t.selectionManager.isDisabled(r.key) || void 0,
    "aria-labelledby": s && (r["aria-label"] || r.textValue) ? `${xd(t, r.key)} ${s}` : void 0,
    id: xd(t, r.key)
  }), M = C.onKeyDown;
  C.onKeyDown = (A) => {
    x(A), A.isPropagationStopped() || M?.(A);
  };
  let F = C.onPointerDown;
  C.onPointerDown = (A) => {
    let U = W(A);
    if (U && U !== n.current && Ga(U)) {
      A.stopPropagation();
      return;
    }
    F?.(A);
  };
  let V = C.onMouseDown;
  if (C.onMouseDown = (A) => {
    let U = W(A);
    if (U && U !== n.current && Ga(U)) {
      A.stopPropagation();
      return;
    }
    V?.(A);
  }, a) {
    let { collection: A } = t, U = [
      ...A
    ];
    C["aria-rowindex"] = U.find((D) => D.type === "section") ? [
      ...A.getKeys()
    ].filter((D) => A.getItem(D)?.type !== "section").findIndex((D) => D === r.key) + 1 : r.index + 1;
  }
  let I = {
    role: "gridcell",
    "aria-colindex": 1
  };
  return {
    rowProps: {
      ...z(C, h)
    },
    gridCellProps: I,
    descriptionProps: {
      id: s
    },
    ...y
  };
}
function Pd(e, t, n, r, a, l, i) {
  if (!("expandedKeys" in t) || l !== i) return !1;
  if (e.key === Cd.expand[a] && t.selectionManager.focusedKey === n.key && r && !t.expandedKeys.has(n.key))
    return t.toggleKey(n.key), e.stopPropagation(), !0;
  if (e.key === Cd.collapse[a] && t.selectionManager.focusedKey === n.key) {
    if (r && t.expandedKeys.has(n.key))
      return t.toggleKey(n.key), e.stopPropagation(), !0;
    if (!t.expandedKeys.has(n.key) && n.parentKey && t.collection.getItem(n.parentKey)?.type === "item")
      return t.selectionManager.setFocusedKey(n.parentKey), e.stopPropagation(), !0;
  }
  return !1;
}
function wd(e) {
  let t = null, n = null;
  do
    n = e.lastChild(), n && (t = n);
  while (n);
  return t;
}
function iE(e, t) {
  let n = t.getChildren?.(e.key), r = n ? Array.from(n) : [], a = r.length > 0 ? r[0] : null, l = [];
  for (; a; )
    l.push(a), a = a.nextKey != null ? t.getItem(a.nextKey) : null;
  return l;
}
function uE(e) {
  return e && e.__esModule ? e.default : e;
}
function oE(e, t) {
  let { key: n } = e, r = t.selectionManager, a = ce(), l = !t.selectionManager.canSelectItem(n), i = t.selectionManager.isSelected(n), u = () => r.toggleSelection(n);
  const o = Ee(uE(Kl), "@react-aria/grid");
  return {
    checkboxProps: {
      id: a,
      "aria-label": o.format("select"),
      isSelected: i,
      isDisabled: l,
      onChange: u
    }
  };
}
function sE(e, t, n) {
  let { overlayProps: r, underlayProps: a } = ep({
    ...e,
    isOpen: t.isOpen,
    onClose: t.close
  }, n);
  return tp({
    isDisabled: !t.isOpen
  }), Lp(), ee(() => {
    if (t.isOpen && n.current) return Zb([
      n.current
    ], {
      shouldUseInert: !0
    });
  }, [
    t.isOpen,
    n
  ]), {
    modalProps: z(r),
    underlayProps: a
  };
}
let qe = typeof document < "u" && window.visualViewport;
function dE() {
  let e = Ct(), [t, n] = Y(() => e ? {
    width: 0,
    height: 0
  } : pi());
  return ee(() => {
    let r = (u) => {
      n((o) => u.width === o.width && u.height === o.height ? o : u);
    }, a = () => {
      qe && qe.scale > 1 || r(pi());
    }, l, i = (u) => {
      qe && qe.scale > 1 || _r(W(u)) && (l = requestAnimationFrame(() => {
        let o = se();
        (!o || !_r(o)) && r({
          width: document.documentElement.clientWidth,
          height: document.documentElement.clientHeight
        });
      }));
    };
    return r(pi()), xt() && window.addEventListener("blur", i, !0), qe ? qe.addEventListener("resize", a) : window.addEventListener("resize", a), () => {
      cancelAnimationFrame(l), xt() && window.removeEventListener("blur", i, !0), qe ? qe.removeEventListener("resize", a) : window.removeEventListener("resize", a);
    };
  }, []), t;
}
function pi() {
  return {
    // Multiply by the visualViewport scale to get the "natural" size, unaffected by pinch zooming.
    width: qe ? (
      // the visual viewport and the document element to ensure that the scrollbar width is always excluded.
      // See: https://github.com/w3c/csswg-drafts/issues/8099
      Math.min(qe.width * qe.scale, document.documentElement.clientWidth)
    ) : document.documentElement.clientWidth,
    height: qe ? qe.height * qe.scale : document.documentElement.clientHeight
  };
}
const cE = /* @__PURE__ */ G(null), go = /* @__PURE__ */ G(null), KC = /* @__PURE__ */ te(function(t, n) {
  if (O(go)) {
    if (process.env.NODE_ENV !== "production" && (t.onOpenChange || t.defaultOpen !== void 0 || t.isOpen !== void 0)) {
      const b = /* @__PURE__ */ new Set([
        "isDismissable",
        "isKeyboardDismissDisabled",
        "isOpen",
        "defaultOpen",
        "onOpenChange",
        "isEntering",
        "isExiting",
        "UNSTABLE_portalContainer",
        "shouldCloseOnInteractOutside"
      ]), p = Object.keys(t).filter((y) => b.has(y));
      console.warn(`This modal is already wrapped in a ModalOverlay, props [${p.join(", ")}] should be placed on the ModalOverlay instead.`);
    }
    return /* @__PURE__ */ g.createElement(Sd, {
      ...t,
      modalRef: n
    }, t.children);
  }
  let { isDismissable: a, isKeyboardDismissDisabled: l, isOpen: i, defaultOpen: u, onOpenChange: o, children: d, isEntering: s, isExiting: c, UNSTABLE_portalContainer: f, shouldCloseOnInteractOutside: h, ...m } = t;
  return /* @__PURE__ */ g.createElement(hE, {
    isDismissable: a,
    isKeyboardDismissDisabled: l,
    isOpen: i,
    defaultOpen: u,
    onOpenChange: o,
    isEntering: s,
    isExiting: c,
    UNSTABLE_portalContainer: f,
    shouldCloseOnInteractOutside: h
  }, /* @__PURE__ */ g.createElement(Sd, {
    ...m,
    modalRef: n
  }, d));
});
function fE(e, t) {
  [e, t] = oe(e, t, cE);
  let n = O(Ot), r = Fr(e), a = e.isOpen != null || e.defaultOpen != null || !n ? r : n;
  a === n && process.env.NODE_ENV !== "production" && (e.onOpenChange || e.defaultOpen !== void 0 || e.isOpen !== void 0) && console.warn("This modals state is controlled by a trigger, place onOpenChange on the trigger instead.");
  let l = $e(t), i = T(null), u = da(l, a.isOpen), o = da(i, a.isOpen), d = u || o || e.isExiting || !1, s = Ct();
  return !a.isOpen && !d || s ? null : /* @__PURE__ */ g.createElement(mE, {
    ...e,
    state: a,
    isExiting: d,
    overlayRef: l,
    modalRef: i
  });
}
const hE = /* @__PURE__ */ te(fE);
function mE({ UNSTABLE_portalContainer: e, ...t }) {
  let n = t.modalRef, { state: r } = t, { modalProps: a, underlayProps: l } = sE(t, r, n), i = xa(t.overlayRef) || t.isEntering || !1, u = le({
    ...t,
    defaultClassName: "react-aria-ModalOverlay",
    values: {
      isEntering: i,
      isExiting: t.isExiting,
      state: r
    }
  }), o = dE(), d, s;
  if (typeof document < "u") {
    let f = yn(document.body) ? document.body : document.scrollingElement || document.documentElement, h = f.getBoundingClientRect().width % 1, m = f.getBoundingClientRect().height % 1;
    d = f.scrollWidth - h, s = f.scrollHeight - m;
  }
  let c = {
    ...u.style,
    "--visual-viewport-width": o.width + "px",
    "--visual-viewport-height": o.height + "px",
    "--page-width": d !== void 0 ? d + "px" : void 0,
    "--page-height": s !== void 0 ? s + "px" : void 0
  };
  return /* @__PURE__ */ g.createElement(tu, {
    isExiting: t.isExiting,
    portalContainer: e
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(J(t, {
      global: !0
    }), l),
    ...u,
    style: c,
    ref: t.overlayRef,
    "data-entering": i || void 0,
    "data-exiting": t.isExiting || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        go,
        {
          modalProps: a,
          modalRef: n,
          isExiting: t.isExiting,
          isDismissable: t.isDismissable
        }
      ],
      [
        Ot,
        r
      ]
    ]
  }, u.children)));
}
function Sd(e) {
  let { modalProps: t, modalRef: n, isExiting: r, isDismissable: a } = O(go), l = O(Ot), i = K(() => Pt(e.modalRef, n), [
    e.modalRef,
    n
  ]), u = $e(i), o = xa(u), d = le({
    ...e,
    defaultClassName: "react-aria-Modal",
    values: {
      isEntering: o,
      isExiting: r,
      state: l
    }
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(J(e, {
      global: !0
    }), t),
    ...d,
    ref: u,
    "data-entering": o || void 0,
    "data-exiting": r || void 0
  }, a && /* @__PURE__ */ g.createElement(eu, {
    onDismiss: l.close
  }), d.children);
}
const bE = /* @__PURE__ */ G(null), pE = /* @__PURE__ */ G(null), NC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, bE);
  let { validationBehavior: r } = He(_n) || {}, a = t.validationBehavior ?? r ?? "native", { locale: l } = de(), i = Gm({
    ...t,
    locale: l,
    validationBehavior: a
  }), u = T(null), [o, d] = Qe(!t["aria-label"] && !t["aria-labelledby"]), { labelProps: s, groupProps: c, inputProps: f, incrementButtonProps: h, decrementButtonProps: m, descriptionProps: b, errorMessageProps: p, ...y } = _m({
    ...wt(t),
    label: d,
    validationBehavior: a
  }, i, u), $ = le({
    ...t,
    values: {
      state: i,
      isDisabled: t.isDisabled || !1,
      isInvalid: y.isInvalid || !1,
      isRequired: t.isRequired || !1,
      isReadOnly: t.isReadOnly || !1
    },
    defaultClassName: "react-aria-NumberField"
  }), v = J(t, {
    global: !0
  });
  return delete v.id, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        pE,
        i
      ],
      [
        Dn,
        c
      ],
      [
        wr,
        {
          ...f,
          ref: u
        }
      ],
      [
        et,
        {
          ...s,
          ref: o
        }
      ],
      [
        Xe,
        {
          slots: {
            increment: h,
            decrement: m
          }
        }
      ],
      [
        We,
        {
          slots: {
            description: b,
            errorMessage: p
          }
        }
      ],
      [
        nn,
        y
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...v,
    ...$,
    ref: n,
    slot: t.slot || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-readonly": t.isReadOnly || void 0,
    "data-required": t.isRequired || void 0,
    "data-invalid": y.isInvalid || void 0
  }), t.name && /* @__PURE__ */ g.createElement("input", {
    type: "hidden",
    name: t.name,
    form: t.form,
    value: isNaN(i.numberValue) ? "" : i.numberValue,
    disabled: t.isDisabled || void 0
  }));
}), Ty = /* @__PURE__ */ new WeakMap();
function gE(e, t, n) {
  let { value: r, children: a, "aria-label": l, "aria-labelledby": i, onPressStart: u, onPressEnd: o, onPressChange: d, onPress: s, onPressUp: c, onClick: f } = e;
  const h = e.isDisabled || t.isDisabled;
  let m = a != null, b = l != null || i != null;
  !m && !b && process.env.NODE_ENV !== "production" && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let p = t.selectedValue === r, y = (w) => {
    w.stopPropagation(), t.setSelectedValue(r);
  }, { pressProps: $, isPressed: v } = Je({
    onPressStart: u,
    onPressEnd: o,
    onPressChange: d,
    onPress: s,
    onPressUp: c,
    onClick: f,
    isDisabled: h
  }), { pressProps: x, isPressed: E } = Je({
    onPressStart: u,
    onPressEnd: o,
    onPressChange: d,
    onPressUp: c,
    onClick: f,
    isDisabled: h,
    onPress(w) {
      s?.(w), t.setSelectedValue(r), n.current?.focus();
    }
  }), { focusableProps: P } = ct(z(e, {
    onFocus: () => t.setLastFocusedValue(r)
  }), n), C = z($, P), M = J(e, {
    labelable: !0
  }), F = -1;
  t.selectedValue != null ? t.selectedValue === r && (F = 0) : (t.lastFocusedValue === r || t.lastFocusedValue == null) && (F = 0), h && (F = void 0);
  let { name: V, form: I, descriptionId: A, errorMessageId: U, validationBehavior: D } = Ty.get(t);
  an(n, t.defaultSelectedValue, t.setSelectedValue), $a({
    validationBehavior: D
  }, t, n);
  let N = ji();
  return {
    labelProps: z(x, K(() => ({
      onClick: (w) => w.preventDefault(),
      // Prevent label from being focused when mouse down on it.
      // Note, this does not prevent the input from being focused in the `click` event.
      onMouseDown: (w) => w.preventDefault()
    }), [])),
    inputProps: z(M, {
      ...C,
      type: "radio",
      name: V,
      form: I,
      tabIndex: F,
      disabled: h,
      required: t.isRequired && D === "native",
      checked: p,
      value: r,
      onChange: y,
      "aria-describedby": [
        e["aria-describedby"],
        N.id,
        t.isInvalid ? U : null,
        A
      ].filter(Boolean).join(" ") || void 0
    }),
    descriptionProps: N,
    isDisabled: h,
    isSelected: p,
    isPressed: v || E
  };
}
function yE(e, t) {
  let { name: n, form: r, isReadOnly: a, isRequired: l, isDisabled: i, orientation: u = "vertical", validationBehavior: o = "aria" } = e, { direction: d } = de(), { isInvalid: s, validationErrors: c, validationDetails: f } = t.displayValidation, { labelProps: h, fieldProps: m, descriptionProps: b, errorMessageProps: p } = Pr({
    ...e,
    // Radio group is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span",
    isInvalid: t.isInvalid,
    errorMessage: e.errorMessage || c
  }), y = J(e, {
    labelable: !0
  }), { focusWithinProps: $ } = ft({
    onBlurWithin(E) {
      e.onBlur?.(E), t.selectedValue || t.setLastFocusedValue(null);
    },
    onFocusWithin: e.onFocus,
    onFocusWithinChange: e.onFocusChange
  }), v = (E) => {
    let P;
    switch (E.key) {
      case "ArrowRight":
        d === "rtl" && u !== "vertical" ? P = "prev" : P = "next";
        break;
      case "ArrowLeft":
        d === "rtl" && u !== "vertical" ? P = "next" : P = "prev";
        break;
      case "ArrowDown":
        P = "next";
        break;
      case "ArrowUp":
        P = "prev";
        break;
      default:
        return;
    }
    E.preventDefault();
    let C = Ie(E.currentTarget, {
      from: W(E),
      accept: (F) => F instanceof Be(F).HTMLInputElement && F.type === "radio"
    }), M;
    P === "next" ? (M = C.nextNode(), M || (C.currentNode = E.currentTarget, M = C.firstChild())) : (M = C.previousNode(), M || (C.currentNode = E.currentTarget, M = C.lastChild())), M && (M.focus(), t.setSelectedValue(M.value));
  }, x = ce(n);
  return Ty.set(t, {
    name: x,
    form: r,
    descriptionId: b.id,
    errorMessageId: p.id,
    validationBehavior: o
  }), {
    radioGroupProps: z(y, {
      // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
      role: "radiogroup",
      onKeyDown: v,
      "aria-invalid": t.isInvalid || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-readonly": a || void 0,
      "aria-required": l || void 0,
      "aria-disabled": i || void 0,
      "aria-orientation": u,
      ...m,
      ...$
    }),
    labelProps: h,
    descriptionProps: b,
    errorMessageProps: p,
    isInvalid: s,
    validationErrors: c,
    validationDetails: f
  };
}
let $E = Math.round(Math.random() * 1e10), vE = 0;
function DE(e) {
  let t = K(() => e.name || `radio-group-${$E}-${++vE}`, [
    e.name
  ]), [n, r] = we(e.value, e.defaultValue ?? null, e.onChange), [a] = Y(n), [l, i] = Y(null), u = rn({
    ...e,
    value: n
  }), o = (s) => {
    !e.isReadOnly && !e.isDisabled && (r(s), u.commitValidation());
  }, d = u.displayValidation.isInvalid;
  return {
    ...u,
    name: t,
    selectedValue: n,
    defaultSelectedValue: e.value !== void 0 ? a : e.defaultValue ?? null,
    setSelectedValue: o,
    lastFocusedValue: l,
    setLastFocusedValue: i,
    isDisabled: e.isDisabled || !1,
    isReadOnly: e.isReadOnly || !1,
    isRequired: e.isRequired || !1,
    validationState: e.validationState || (d ? "invalid" : null),
    isInvalid: d
  };
}
const xE = /* @__PURE__ */ G(null), EE = /* @__PURE__ */ G(null), yo = /* @__PURE__ */ G(null), VC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, xE);
  let { validationBehavior: r } = He(_n) || {}, a = t.validationBehavior ?? r ?? "native", l = DE({
    ...t,
    validationBehavior: a
  }), [i, u] = Qe(!t["aria-label"] && !t["aria-labelledby"]), { radioGroupProps: o, labelProps: d, descriptionProps: s, errorMessageProps: c, ...f } = yE({
    ...t,
    label: u,
    validationBehavior: a
  }, l), h = le({
    ...t,
    values: {
      orientation: t.orientation || "vertical",
      isDisabled: l.isDisabled,
      isReadOnly: l.isReadOnly,
      isRequired: l.isRequired,
      isInvalid: l.isInvalid,
      state: l
    },
    defaultClassName: "react-aria-RadioGroup"
  }), m = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(m, h, o),
    ref: n,
    slot: t.slot || void 0,
    "data-orientation": t.orientation || "vertical",
    "data-invalid": l.isInvalid || void 0,
    "data-disabled": l.isDisabled || void 0,
    "data-readonly": l.isReadOnly || void 0,
    "data-required": l.isRequired || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        yo,
        l
      ],
      [
        et,
        {
          ...d,
          ref: i,
          elementType: "span"
        }
      ],
      [
        We,
        {
          slots: {
            description: s,
            errorMessage: c
          }
        }
      ],
      [
        nn,
        f
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Wn, null, h.children)));
}), LC = /* @__PURE__ */ te(function(t, n) {
  let { inputRef: r = null, ...a } = t;
  [t, n] = oe(a, n, EE);
  let l = g.useContext(yo), i = $e(K(() => Pt(r, t.inputRef !== void 0 ? t.inputRef : null), [
    r,
    t.inputRef
  ])), u = gE({
    ...wt(t),
    // ReactNode type doesn't allow function children.
    children: typeof t.children == "function" ? !0 : t.children
  }, l, i);
  return /* @__PURE__ */ g.createElement(Iy.Provider, {
    value: {
      ...u,
      inputRef: i,
      defaultClassName: "react-aria-Radio"
    }
  }, /* @__PURE__ */ g.createElement(CE, {
    ...t,
    ref: n
  }));
}), Iy = /* @__PURE__ */ G(null), CE = /* @__PURE__ */ te(function(t, n) {
  let { labelProps: r, inputProps: a, isSelected: l, isDisabled: i, isPressed: u, defaultClassName: o, inputRef: d } = O(Iy), s = g.useContext(yo), { isFocused: c, isFocusVisible: f, focusProps: h } = ye(), m = i || s.isReadOnly, { hoverProps: b, isHovered: p } = De({
    ...t,
    isDisabled: m
  }), y = le({
    ...t,
    defaultClassName: o,
    values: {
      isSelected: l,
      isPressed: u,
      isHovered: p,
      isFocused: c,
      isFocusVisible: f,
      isDisabled: i,
      isReadOnly: s.isReadOnly,
      isInvalid: s.isInvalid,
      isRequired: s.isRequired
    }
  }), $ = J(t, {
    global: !0
  });
  return delete $.id, delete $.onClick, /* @__PURE__ */ g.createElement(Q.label, {
    ...z($, r, b, y),
    ref: n,
    "data-selected": l || void 0,
    "data-pressed": u || void 0,
    "data-hovered": p || void 0,
    "data-focused": c || void 0,
    "data-focus-visible": f || void 0,
    "data-disabled": i || void 0,
    "data-readonly": s.isReadOnly || void 0,
    "data-invalid": s.isInvalid || void 0,
    "data-required": s.isRequired || void 0
  }, /* @__PURE__ */ g.createElement(gr, {
    elementType: "span"
  }, /* @__PURE__ */ g.createElement("input", {
    ...z(a, h),
    ref: d
  })), y.children);
});
var My = {};
My = {
  "Clear search": "مسح البحث"
};
var Ky = {};
Ky = {
  "Clear search": "Изчистване на търсене"
};
var Ny = {};
Ny = {
  "Clear search": "Vymazat hledání"
};
var Vy = {};
Vy = {
  "Clear search": "Ryd søgning"
};
var Ly = {};
Ly = {
  "Clear search": "Suche zurücksetzen"
};
var zy = {};
zy = {
  "Clear search": "Απαλοιφή αναζήτησης"
};
var Oy = {};
Oy = {
  "Clear search": "Clear search"
};
var Hy = {};
Hy = {
  "Clear search": "Borrar búsqueda"
};
var Uy = {};
Uy = {
  "Clear search": "Tühjenda otsing"
};
var jy = {};
jy = {
  "Clear search": "Tyhjennä haku"
};
var _y = {};
_y = {
  "Clear search": "Effacer la recherche"
};
var Wy = {};
Wy = {
  "Clear search": "נקה חיפוש"
};
var Gy = {};
Gy = {
  "Clear search": "Obriši pretragu"
};
var qy = {};
qy = {
  "Clear search": "Keresés törlése"
};
var Yy = {};
Yy = {
  "Clear search": "Cancella ricerca"
};
var Zy = {};
Zy = {
  "Clear search": "検索をクリア"
};
var Xy = {};
Xy = {
  "Clear search": "검색 지우기"
};
var Jy = {};
Jy = {
  "Clear search": "Išvalyti iešką"
};
var Qy = {};
Qy = {
  "Clear search": "Notīrīt meklēšanu"
};
var e$ = {};
e$ = {
  "Clear search": "Tøm søk"
};
var t$ = {};
t$ = {
  "Clear search": "Zoekactie wissen"
};
var n$ = {};
n$ = {
  "Clear search": "Wyczyść zawartość wyszukiwania"
};
var r$ = {};
r$ = {
  "Clear search": "Limpar pesquisa"
};
var a$ = {};
a$ = {
  "Clear search": "Limpar pesquisa"
};
var l$ = {};
l$ = {
  "Clear search": "Ştergeţi căutarea"
};
var i$ = {};
i$ = {
  "Clear search": "Очистить поиск"
};
var u$ = {};
u$ = {
  "Clear search": "Vymazať vyhľadávanie"
};
var o$ = {};
o$ = {
  "Clear search": "Počisti iskanje"
};
var s$ = {};
s$ = {
  "Clear search": "Obriši pretragu"
};
var d$ = {};
d$ = {
  "Clear search": "Rensa sökning"
};
var c$ = {};
c$ = {
  "Clear search": "Aramayı temizle"
};
var f$ = {};
f$ = {
  "Clear search": "Очистити пошук"
};
var h$ = {};
h$ = {
  "Clear search": "清除搜索"
};
var m$ = {};
m$ = {
  "Clear search": "清除搜尋條件"
};
var b$ = {};
b$ = {
  "ar-AE": My,
  "bg-BG": Ky,
  "cs-CZ": Ny,
  "da-DK": Vy,
  "de-DE": Ly,
  "el-GR": zy,
  "en-US": Oy,
  "es-ES": Hy,
  "et-EE": Uy,
  "fi-FI": jy,
  "fr-FR": _y,
  "he-IL": Wy,
  "hr-HR": Gy,
  "hu-HU": qy,
  "it-IT": Yy,
  "ja-JP": Zy,
  "ko-KR": Xy,
  "lt-LT": Jy,
  "lv-LV": Qy,
  "nb-NO": e$,
  "nl-NL": t$,
  "pl-PL": n$,
  "pt-BR": r$,
  "pt-PT": a$,
  "ro-RO": l$,
  "ru-RU": i$,
  "sk-SK": u$,
  "sl-SI": o$,
  "sr-SP": s$,
  "sv-SE": d$,
  "tr-TR": c$,
  "uk-UA": f$,
  "zh-CN": h$,
  "zh-TW": m$
};
function PE(e) {
  return e && e.__esModule ? e.default : e;
}
function wE(e, t, n) {
  let r = Ee(PE(b$), "@react-aria/searchfield"), { isDisabled: a, isReadOnly: l, onSubmit: i, onClear: u, type: o = "search" } = e, d = (y) => {
    const $ = y.key;
    $ === "Enter" && (a || l) && y.preventDefault(), !(a || l) && ($ === "Enter" && i && (y.preventDefault(), i(t.value)), $ === "Escape" && (t.value === "" && (!n.current || n.current.value === "") ? y.continuePropagation() : (y.preventDefault(), t.setValue(""), u && u())));
  }, s = () => {
    t.setValue(""), u && u();
  }, c = () => {
    n.current?.focus();
  }, { labelProps: f, inputProps: h, descriptionProps: m, errorMessageProps: b, ...p } = qu({
    ...e,
    value: t.value,
    onChange: t.setValue,
    onKeyDown: l ? e.onKeyDown : st(d, e.onKeyDown),
    type: o
  }, n);
  return {
    labelProps: f,
    inputProps: {
      ...h,
      // already handled by useSearchFieldState
      defaultValue: void 0
    },
    clearButtonProps: {
      "aria-label": r.format("Clear search"),
      excludeFromTabOrder: !0,
      preventFocusOnPress: !0,
      isDisabled: a || l,
      onPress: s,
      onPressStart: c
    },
    descriptionProps: m,
    errorMessageProps: b,
    ...p
  };
}
function SE(e) {
  let [t, n] = we(kd(e.value), kd(e.defaultValue) || "", e.onChange);
  return {
    value: t,
    setValue: n
  };
}
function kd(e) {
  if (e != null)
    return e.toString();
}
const kE = /* @__PURE__ */ G(null), zC = /* @__PURE__ */ vn(function(t, n) {
  [t, n] = oe(t, n, kE);
  let { validationBehavior: r } = He(_n) || {}, a = t.validationBehavior ?? r ?? "native", l = T(null);
  [t, l] = oe(t, l, fa);
  let [i, u] = Qe(!t["aria-label"] && !t["aria-labelledby"]), o = SE({
    ...t,
    validationBehavior: a
  }), { labelProps: d, inputProps: s, clearButtonProps: c, descriptionProps: f, errorMessageProps: h, ...m } = wE({
    ...wt(t),
    label: u,
    validationBehavior: a
  }, o, l), b = le({
    ...t,
    values: {
      isEmpty: o.value === "",
      isDisabled: t.isDisabled || !1,
      isInvalid: m.isInvalid || !1,
      isReadOnly: t.isReadOnly || !1,
      isRequired: t.isRequired || !1,
      state: o
    },
    defaultClassName: "react-aria-SearchField"
  }), p = J(t, {
    global: !0
  });
  return delete p.id, /* @__PURE__ */ g.createElement(Q.div, {
    ...p,
    ...b,
    ref: n,
    slot: t.slot || void 0,
    "data-empty": o.value === "" || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-invalid": m.isInvalid || void 0,
    "data-readonly": t.isReadOnly || void 0,
    "data-required": t.isRequired || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        et,
        {
          ...d,
          ref: i
        }
      ],
      [
        wr,
        {
          ...s,
          ref: l
        }
      ],
      [
        Xe,
        c
      ],
      [
        We,
        {
          slots: {
            description: f,
            errorMessage: h
          }
        }
      ],
      [
        Dn,
        {
          isInvalid: m.isInvalid,
          isDisabled: t.isDisabled || !1
        }
      ],
      [
        nn,
        m
      ]
    ]
  }, b.children));
}), $o = /* @__PURE__ */ new WeakMap();
function BE(e, t, n) {
  let { keyboardDelegate: r, isDisabled: a, isRequired: l, name: i, form: u, validationBehavior: o = "aria" } = e, d = Sr({
    usage: "search",
    sensitivity: "base"
  }), s = K(() => r || new va(t.collection, t.disabledKeys, n, d), [
    r,
    t.collection,
    t.disabledKeys,
    d,
    n
  ]), { menuTriggerProps: c, menuProps: f } = Eg({
    isDisabled: a,
    type: "listbox"
  }, t, n), h = (F) => {
    if (t.selectionManager.selectionMode !== "multiple")
      switch (F.key) {
        case "ArrowLeft": {
          F.preventDefault();
          let V = t.selectedKey != null ? s.getKeyAbove?.(t.selectedKey) : s.getFirstKey?.();
          V != null && t.setSelectedKey(V);
          break;
        }
        case "ArrowRight": {
          F.preventDefault();
          let V = t.selectedKey != null ? s.getKeyBelow?.(t.selectedKey) : s.getFirstKey?.();
          V != null && t.setSelectedKey(V);
          break;
        }
      }
  }, { typeSelectProps: m } = Lb({
    keyboardDelegate: s,
    selectionManager: t.selectionManager,
    onTypeSelect(F) {
      t.setSelectedKey(F);
    }
  }), { isInvalid: b, validationErrors: p, validationDetails: y } = t.displayValidation, { labelProps: $, fieldProps: v, descriptionProps: x, errorMessageProps: E } = Pr({
    ...e,
    labelElementType: "span",
    isInvalid: b,
    errorMessage: e.errorMessage || p
  });
  t.selectionManager.selectionMode === "multiple" && (m = {});
  let P = J(e, {
    labelable: !0
  }), C = z(m, c, v), M = ce();
  return $o.set(t, {
    isDisabled: a,
    isRequired: l,
    name: i,
    form: u,
    validationBehavior: o
  }), {
    labelProps: {
      ...$,
      onClick: () => {
        e.isDisabled || (n.current?.focus(), Yr("keyboard"));
      }
    },
    triggerProps: z(P, {
      ...C,
      isDisabled: a,
      onKeyDown: st(C.onKeyDown, h, e.onKeyDown),
      onKeyUp: e.onKeyUp,
      "aria-labelledby": [
        M,
        C["aria-labelledby"],
        C["aria-label"] && !C["aria-labelledby"] ? C.id : null
      ].filter(Boolean).join(" "),
      onFocus(F) {
        t.isFocused || (e.onFocus && e.onFocus(F), e.onFocusChange && e.onFocusChange(!0), t.setFocused(!0));
      },
      onBlur(F) {
        t.isOpen || (e.onBlur && e.onBlur(F), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      }
    }),
    valueProps: {
      id: M
    },
    menuProps: {
      ...f,
      onAction: void 0,
      autoFocus: t.focusStrategy || !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      disallowEmptySelection: !0,
      linkBehavior: "selection",
      onBlur: (F) => {
        ae(F.currentTarget, F.relatedTarget) || (e.onBlur && e.onBlur(F), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      },
      "aria-labelledby": [
        v["aria-labelledby"],
        C["aria-label"] && !v["aria-labelledby"] ? C.id : null
      ].filter(Boolean).join(" ")
    },
    descriptionProps: x,
    errorMessageProps: E,
    isInvalid: b,
    validationErrors: p,
    validationDetails: y,
    hiddenSelectProps: {
      isDisabled: a,
      name: i,
      label: e.label,
      state: t,
      triggerRef: n,
      form: u
    }
  };
}
function FE(e, t, n) {
  let r = $o.get(t) || {}, { autoComplete: a, name: l = r.name, form: i = r.form, isDisabled: u = r.isDisabled } = e, { validationBehavior: o, isRequired: d } = r, { visuallyHiddenProps: s } = tn({
    style: {
      // Prevent page scrolling.
      position: "fixed",
      top: 0,
      left: 0
    }
  });
  an(e.selectRef, t.defaultValue, t.setValue), $a({
    validationBehavior: o,
    focus: () => n.current?.focus()
  }, t, e.selectRef);
  let c = t.setValue, f = X((h) => {
    let m = W(h);
    m.multiple ? c(Array.from(m.selectedOptions, (b) => b.value)) : c(h.currentTarget.value);
  }, [
    c
  ]);
  return {
    containerProps: {
      ...s,
      "aria-hidden": !0,
      // @ts-ignore
      "data-react-aria-prevent-focus": !0,
      // @ts-ignore
      "data-a11y-ignore": "aria-hidden-focus"
    },
    inputProps: {
      style: {
        display: "none"
      }
    },
    selectProps: {
      tabIndex: -1,
      autoComplete: a,
      disabled: u,
      multiple: t.selectionManager.selectionMode === "multiple",
      required: o === "native" && d,
      name: l,
      form: i,
      value: t.value ?? "",
      onChange: f,
      onInput: f
    }
  };
}
function AE(e) {
  let { state: t, triggerRef: n, label: r, name: a, form: l, isDisabled: i } = e, u = T(null), o = T(null), { containerProps: d, selectProps: s } = FE({
    ...e,
    selectRef: t.collection.size <= 300 ? u : o
  }, t, n), c = Array.isArray(t.value) ? t.value : [
    t.value
  ];
  if (t.collection.size <= 300) return /* @__PURE__ */ g.createElement("div", {
    ...d,
    "data-testid": "hidden-select-container"
  }, /* @__PURE__ */ g.createElement("label", null, r, /* @__PURE__ */ g.createElement("select", {
    ...s,
    ref: u
  }, /* @__PURE__ */ g.createElement("option", {
    value: "",
    label: " "
  }, " "), [
    ...t.collection.getKeys()
  ].map((f) => {
    let h = t.collection.getItem(f);
    if (h && h.type === "item") return /* @__PURE__ */ g.createElement("option", {
      key: h.key,
      value: h.key
    }, h.textValue);
  }), t.collection.size === 0 && a && c.map((f, h) => /* @__PURE__ */ g.createElement("option", {
    key: h,
    value: f ?? ""
  })))));
  if (a) {
    let f = $o.get(t) || {}, { validationBehavior: h } = f;
    c.length === 0 && (c = [
      null
    ]);
    let m = c.map((b, p) => {
      let y = {
        type: "hidden",
        autoComplete: s.autoComplete,
        name: a,
        form: l,
        disabled: i,
        value: b ?? ""
      };
      return h === "native" ? /* @__PURE__ */ g.createElement("input", {
        key: p,
        ...y,
        ref: p === 0 ? o : null,
        style: {
          display: "none"
        },
        type: "text",
        required: p === 0 ? s.required : !1,
        onChange: () => {
        }
      }) : /* @__PURE__ */ g.createElement("input", {
        key: p,
        ...y,
        ref: p === 0 ? o : null
      });
    });
    return /* @__PURE__ */ g.createElement(g.Fragment, null, m);
  }
  return null;
}
function RE(e) {
  let { selectionMode: t = "single", shouldCloseOnSelect: n = t === "single" } = e, r = Fr(e), [a, l] = Y(null), i = K(() => e.defaultValue !== void 0 ? e.defaultValue : t === "single" ? e.defaultSelectedKey ?? null : [], [
    e.defaultValue,
    e.defaultSelectedKey,
    t
  ]), u = K(() => e.value !== void 0 ? e.value : t === "single" ? e.selectedKey : void 0, [
    e.value,
    e.selectedKey,
    t
  ]), [o, d] = we(u, i, e.onChange), s = t === "single" && Array.isArray(o) ? o[0] : o, c = (v) => {
    if (t === "single") {
      let x = Array.isArray(v) ? v[0] ?? null : v;
      d(x), x !== s && e.onSelectionChange?.(x);
    } else {
      let x = [];
      Array.isArray(v) ? x = v : v != null && (x = [
        v
      ]), d(x);
    }
  }, f = Al({
    ...e,
    selectionMode: t,
    disallowEmptySelection: t === "single",
    allowDuplicateSelectionEvents: !0,
    selectedKeys: K(() => TE(s), [
      s
    ]),
    onSelectionChange: (v) => {
      if (v !== "all") {
        if (t === "single") {
          let x = v.values().next().value ?? null;
          c(x);
        } else c([
          ...v
        ]);
        n && r.close(), b.commitValidation();
      }
    }
  }), h = f.selectionManager.firstSelectedKey, m = K(() => [
    ...f.selectionManager.selectedKeys
  ].map((v) => f.collection.getItem(v)).filter((v) => v != null), [
    f.selectionManager.selectedKeys,
    f.collection
  ]), b = rn({
    ...e,
    value: Array.isArray(s) && s.length === 0 ? null : s
  }), [p, y] = Y(!1), [$] = Y(s);
  return {
    ...b,
    ...f,
    ...r,
    value: s,
    defaultValue: i ?? $,
    setValue: c,
    selectedKey: h,
    setSelectedKey: c,
    selectedItem: m[0] ?? null,
    selectedItems: m,
    defaultSelectedKey: e.defaultSelectedKey ?? (e.selectionMode === "single" ? $ : null),
    focusStrategy: a,
    open(v = null) {
      (f.collection.size !== 0 || e.allowsEmptyCollection) && (l(v), r.open());
    },
    toggle(v = null) {
      (f.collection.size !== 0 || e.allowsEmptyCollection) && (l(v), r.toggle());
    },
    isFocused: p,
    setFocused: y
  };
}
function TE(e) {
  if (e !== void 0)
    return e === null ? [] : Array.isArray(e) ? e : [
      e
    ];
}
const p$ = /* @__PURE__ */ G(null), IE = /* @__PURE__ */ G(null), OC = /* @__PURE__ */ vn(function(t, n) {
  [t, n] = oe(t, n, p$);
  let { children: r, isDisabled: a = !1, isInvalid: l = !1, isRequired: i = !1 } = t, u = K(() => typeof r == "function" ? r({
    isOpen: !1,
    isDisabled: a,
    isInvalid: l,
    isRequired: i,
    isFocused: !1,
    isFocusVisible: !1,
    defaultChildren: null
  }) : r, [
    r,
    a,
    l,
    i
  ]);
  return /* @__PURE__ */ g.createElement(jn, {
    content: u
  }, (o) => /* @__PURE__ */ g.createElement(KE, {
    props: t,
    collection: o,
    selectRef: n
  }));
}), ME = [
  et,
  Xe,
  We
];
function KE({ props: e, selectRef: t, collection: n }) {
  let { validationBehavior: r } = He(_n) || {}, a = e.validationBehavior ?? r ?? "native", l = RE({
    ...e,
    collection: n,
    children: void 0,
    validationBehavior: a
  }), { isFocusVisible: i, focusProps: u } = ye({
    within: !0
  }), o = T(null), [d, s] = Qe(!e["aria-label"] && !e["aria-labelledby"]), { labelProps: c, triggerProps: f, valueProps: h, menuProps: m, descriptionProps: b, errorMessageProps: p, hiddenSelectProps: y, ...$ } = BE({
    ...wt(e),
    label: s,
    validationBehavior: a
  }, l, o), v = K(() => ({
    isOpen: l.isOpen,
    isFocused: l.isFocused,
    isFocusVisible: i,
    isDisabled: e.isDisabled || !1,
    isInvalid: $.isInvalid || !1,
    isRequired: e.isRequired || !1
  }), [
    l.isOpen,
    l.isFocused,
    i,
    e.isDisabled,
    $.isInvalid,
    e.isRequired
  ]), x = le({
    ...e,
    values: v,
    defaultClassName: "react-aria-Select"
  }), E = J(e, {
    global: !0
  });
  delete E.id;
  let P = T(null);
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        p$,
        e
      ],
      [
        IE,
        l
      ],
      [
        NE,
        h
      ],
      [
        et,
        {
          ...c,
          ref: d,
          elementType: "span"
        }
      ],
      [
        Xe,
        {
          ...f,
          ref: o,
          isPressed: l.isOpen,
          autoFocus: e.autoFocus
        }
      ],
      [
        Ot,
        l
      ],
      [
        Ar,
        {
          trigger: "Select",
          triggerRef: o,
          scrollRef: P,
          placement: "bottom start",
          "aria-labelledby": m["aria-labelledby"],
          clearContexts: ME
        }
      ],
      [
        oo,
        {
          ...m,
          ref: P
        }
      ],
      [
        kt,
        l
      ],
      [
        We,
        {
          slots: {
            description: b,
            errorMessage: p
          }
        }
      ],
      [
        nn,
        $
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(E, x, u),
    ref: t,
    slot: e.slot || void 0,
    "data-focused": l.isFocused || void 0,
    "data-focus-visible": i || void 0,
    "data-open": l.isOpen || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": $.isInvalid || void 0,
    "data-required": e.isRequired || void 0
  }, x.children, /* @__PURE__ */ g.createElement(AE, {
    ...y,
    autoComplete: e.autoComplete
  })));
}
const NE = /* @__PURE__ */ G(null);
function VE(e, t, n) {
  let { labelProps: r, inputProps: a, isSelected: l, ...i } = ah(e, t, n);
  return {
    labelProps: r,
    inputProps: {
      ...a,
      role: "switch",
      checked: l
    },
    isSelected: l,
    ...i
  };
}
const LE = /* @__PURE__ */ G(null), g$ = /* @__PURE__ */ G(null), HC = /* @__PURE__ */ te(function(t, n) {
  let { inputRef: r = null, ...a } = t;
  [t, n] = oe(a, n, LE);
  let l = $e(Pt(r, t.inputRef !== void 0 ? t.inputRef : null)), i = kl(t), u = VE({
    ...wt(t),
    // ReactNode type doesn't allow function children.
    children: typeof t.children == "function" ? !0 : t.children
  }, i, l);
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        g$,
        i
      ],
      [
        y$,
        {
          ...u,
          inputRef: l,
          defaultClassName: "react-aria-Switch"
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(zE, {
    ...t,
    ref: n
  }));
}), y$ = /* @__PURE__ */ G(null), zE = /* @__PURE__ */ te(function(t, n) {
  let { labelProps: r, inputProps: a, isSelected: l, isDisabled: i, isReadOnly: u, isPressed: o, isInvalid: d, inputRef: s, defaultClassName: c, isRequired: f } = O(y$), { isFocused: h, isFocusVisible: m, focusProps: b } = ye(), p = i || u, y = O(g$), { hoverProps: $, isHovered: v } = De({
    ...t,
    isDisabled: p
  }), x = le({
    ...t,
    defaultClassName: c,
    values: {
      isSelected: l,
      isPressed: o,
      isHovered: v,
      isFocused: h,
      isFocusVisible: m,
      isDisabled: i,
      isReadOnly: u,
      isInvalid: d,
      isRequired: f || !1,
      state: y
    }
  }), E = J(t, {
    global: !0
  });
  return delete E.id, delete E.onClick, /* @__PURE__ */ g.createElement(Q.label, {
    ...z(E, r, $, x),
    ref: n,
    slot: t.slot || void 0,
    "data-selected": l || void 0,
    "data-pressed": o || void 0,
    "data-hovered": v || void 0,
    "data-focused": h || void 0,
    "data-focus-visible": m || void 0,
    "data-disabled": i || void 0,
    "data-readonly": u || void 0,
    "data-invalid": d || void 0,
    "data-required": f || void 0
  }, /* @__PURE__ */ g.createElement(gr, {
    elementType: "span"
  }, /* @__PURE__ */ g.createElement("input", {
    ...z(a, b),
    ref: s
  })), x.children);
}), Bd = 10, Fd = 5;
class OE {
  setup(t, n, r) {
    this.delegate = t, this.state = n, this.direction = r;
  }
  getDropTargetFromPoint(t, n, r) {
    let a = this.delegate.getDropTargetFromPoint(t, n, r);
    return !a || a.type === "root" ? a : this.resolveDropTarget(a, t, n, r);
  }
  resolveDropTarget(t, n, r, a) {
    let l = this.pointerTracking, i = r - l.lastY, u = n - l.lastX, o = l.yDirection, d = l.xDirection;
    if (Math.abs(i) > Fd && (o = i > 0 ? "down" : "up", l.yDirection = o, l.lastY = r), Math.abs(u) > Bd && (d = u > 0 ? "right" : "left", l.xDirection = d, l.lastX = n), t.dropPosition === "before") {
      let f = this.state.collection.getKeyBefore(t.key);
      for (; f != null; ) {
        let h = this.state.collection.getItem(f);
        if (h?.type === "item") break;
        f = h?.parentKey ?? null;
      }
      if (f != null) {
        let h = {
          type: "item",
          key: f,
          dropPosition: "after"
        };
        a(h) && (t = h);
      }
    }
    let s = this.getPotentialTargets(t, a);
    if (s.length === 0) return {
      type: "root"
    };
    let c;
    return s.length > 1 ? c = this.selectTarget(s, t, n, r, o, d) : (c = s[0], l.boundaryContext = null), c;
  }
  // Returns potential targets for an ambiguous drop position (e.g. after the last child of a parent, or after the parent itself)
  // Ordered by level, from innermost to outermost.
  getPotentialTargets(t, n) {
    if (t.dropPosition === "on") return [
      t
    ];
    let r = t, a = this.state.collection, l = a.getItem(r.key);
    for (; l && l?.type !== "item" && l.nextKey != null; )
      r.key = l.nextKey, l = a.getItem(l.nextKey);
    let i = [
      r
    ];
    if (l && l.hasChildNodes && this.state.expandedKeys.has(l.key) && a.getChildren && r.dropPosition === "after") {
      let d = l.firstChildKey != null ? a.getItem(l.firstChildKey) : null;
      for (; d && d.type !== "item"; ) d = d.nextKey != null ? a.getItem(d.nextKey) : null;
      if (d?.type === "item") {
        const s = {
          type: "item",
          key: d.key,
          dropPosition: "before"
        };
        return n(s) ? [
          s
        ] : [];
      }
    }
    if (l?.nextKey != null) return [
      t
    ];
    let u = l?.parentKey, o = [];
    for (; u != null; ) {
      let d = a.getItem(u), s = d?.nextKey != null ? a.getItem(d.nextKey) : null;
      if (!s || s.parentKey !== u) {
        let f = {
          type: "item",
          key: u,
          dropPosition: "after"
        };
        if (n(f) && o.push(f), s) break;
      }
      u = d?.parentKey;
    }
    if (o.length > 0 && i.push(...o), i.length === 1) {
      let d = a.getKeyAfter(r.key), s = d != null ? a.getItem(d) : null;
      if (d != null && s && l && s.level != null && l.level != null && s.level > l.level) {
        let c = {
          type: "item",
          key: d,
          dropPosition: "before"
        };
        if (n(c)) return [
          c
        ];
      }
    }
    return i.filter(n);
  }
  selectTarget(t, n, r, a, l, i) {
    if (t.length < 2) return t[0];
    let u = this.pointerTracking, d = this.state.collection.getItem(n.key)?.parentKey;
    if (d == null) return t[0];
    if (!u.boundaryContext || u.boundaryContext.parentKey !== d) {
      let m = u.yDirection === "up" ? t.length - 1 : 0;
      u.boundaryContext = {
        parentKey: d,
        preferredTargetIndex: m,
        lastSwitchY: a,
        lastSwitchX: r
      };
    }
    let s = u.boundaryContext, c = Math.abs(r - s.lastSwitchX);
    if (Math.abs(a - s.lastSwitchY) > Fd && l) {
      let m = s.preferredTargetIndex || 0;
      l === "down" && m === 0 ? s.preferredTargetIndex = t.length - 1 : l === "up" && m === t.length - 1 && (s.preferredTargetIndex = 0), u.xDirection = null;
    }
    if (c > Bd && i) {
      let m = s.preferredTargetIndex || 0;
      i === "left" ? this.direction === "ltr" ? m < t.length - 1 && (s.preferredTargetIndex = m + 1, s.lastSwitchX = r) : m > 0 && (s.preferredTargetIndex = m - 1, s.lastSwitchX = r) : i === "right" && (this.direction === "ltr" ? m > 0 && (s.preferredTargetIndex = m - 1, s.lastSwitchX = r) : m < t.length - 1 && (s.preferredTargetIndex = m + 1, s.lastSwitchX = r)), u.yDirection = null;
    }
    let h = Math.max(0, Math.min(s.preferredTargetIndex || 0, t.length - 1));
    return t[h];
  }
  constructor() {
    this.delegate = null, this.state = null, this.direction = "ltr", this.pointerTracking = {
      lastY: 0,
      lastX: 0,
      yDirection: null,
      xDirection: null,
      boundaryContext: null
    };
  }
}
class HE {
  constructor(t) {
    this.keyMap = /* @__PURE__ */ new Map(), this.keyMap = /* @__PURE__ */ new Map(), this.columnCount = t?.columnCount, this.rows = [];
    let n = (l) => {
      let i = this.keyMap.get(l.key);
      t.visitNode && (l = t.visitNode(l)), this.keyMap.set(l.key, l);
      let u = /* @__PURE__ */ new Set(), o = null, d = !1;
      if (l.type === "item") {
        for (let s of l.childNodes) if (s.props?.colSpan !== void 0) {
          d = !0;
          break;
        }
      }
      for (let s of l.childNodes)
        s.type === "cell" && d && (s.colspan = s.props?.colSpan, s.colSpan = s.props?.colSpan, s.colIndex = o ? (o.colIndex ?? o.index) + (o.colSpan ?? 1) : s.index), s.type === "cell" && s.parentKey == null && (s.parentKey = l.key), u.add(s.key), o ? (o.nextKey = s.key, s.prevKey = o.key) : s.prevKey = null, n(s), o = s;
      if (o && (o.nextKey = null), i)
        for (let s of i.childNodes) u.has(s.key) || r(s);
    }, r = (l) => {
      this.keyMap.delete(l.key);
      for (let i of l.childNodes) this.keyMap.get(i.key) === i && r(i);
    }, a = null;
    for (let [l, i] of t.items.entries()) {
      let u = {
        ...i,
        level: i.level ?? 0,
        key: i.key ?? "row-" + l,
        type: i.type ?? "row",
        value: i.value ?? null,
        hasChildNodes: !0,
        childNodes: [
          ...i.childNodes
        ],
        rendered: i.rendered,
        textValue: i.textValue ?? "",
        index: i.index ?? l
      };
      a ? (a.nextKey = u.key, u.prevKey = a.key) : u.prevKey = null, this.rows.push(u), n(u), a = u;
    }
    a && (a.nextKey = null);
  }
  *[Symbol.iterator]() {
    yield* [
      ...this.rows
    ];
  }
  get size() {
    return [
      ...this.rows
    ].length;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    return n ? n.prevKey ?? null : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    return n ? n.nextKey ?? null : null;
  }
  getFirstKey() {
    return [
      ...this.rows
    ][0]?.key;
  }
  getLastKey() {
    let t = [
      ...this.rows
    ];
    return t[t.length - 1]?.key;
  }
  getItem(t) {
    return this.keyMap.get(t) ?? null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  getChildren(t) {
    return this.keyMap.get(t)?.childNodes || [];
  }
}
const $$ = "row-header-column-" + Math.random().toString(36).slice(2);
let ru = "row-header-column-" + Math.random().toString(36).slice(2);
for (; $$ === ru; ) ru = "row-header-column-" + Math.random().toString(36).slice(2);
function v$(e, t) {
  if (t.length === 0) return [];
  let n = [], r = /* @__PURE__ */ new Map();
  for (let o of t) {
    let d = o.parentKey, s = [
      o
    ];
    for (; d != null; ) {
      let c = e.get(d);
      if (!c) break;
      if (r.has(c)) {
        c.colSpan ??= 0, c.colSpan++, c.colspan = c.colSpan;
        let { column: f, index: h } = r.get(c);
        if (h > s.length) break;
        for (let m = h; m < s.length; m++) f.splice(m, 0, null);
        for (let m = s.length; m < f.length; m++)
          f[m] && r.has(f[m]) && (r.get(f[m]).index = m);
      } else
        c.colSpan = 1, c.colspan = 1, s.push(c), r.set(c, {
          column: s,
          index: s.length - 1
        });
      d = c.parentKey;
    }
    n.push(s), o.index = n.length - 1;
  }
  let a = Math.max(...n.map((o) => o.length)), l = Array(a).fill(0).map(() => []), i = 0;
  for (let o of n) {
    let d = a - 1;
    for (let s of o) {
      if (s) {
        let c = l[d], f = c.reduce((h, m) => h + (m.colSpan ?? 1), 0);
        if (f < i) {
          let h = {
            type: "placeholder",
            key: "placeholder-" + s.key,
            colspan: i - f,
            colSpan: i - f,
            index: f,
            value: null,
            rendered: null,
            level: d,
            hasChildNodes: !1,
            childNodes: [],
            textValue: ""
          };
          c.length > 0 && (c[c.length - 1].nextKey = h.key, h.prevKey = c[c.length - 1].key), c.push(h);
        }
        c.length > 0 && (c[c.length - 1].nextKey = s.key, s.prevKey = c[c.length - 1].key), s.level = d, s.colIndex = i, c.push(s);
      }
      d--;
    }
    i++;
  }
  let u = 0;
  for (let o of l) {
    let d = o.reduce((s, c) => s + (c.colSpan ?? 1), 0);
    if (d < t.length) {
      let s = {
        type: "placeholder",
        key: "placeholder-" + o[o.length - 1].key,
        colSpan: t.length - d,
        colspan: t.length - d,
        index: d,
        value: null,
        rendered: null,
        level: u,
        hasChildNodes: !1,
        childNodes: [],
        textValue: "",
        prevKey: o[o.length - 1].key
      };
      o.push(s);
    }
    u++;
  }
  return l.map((o, d) => ({
    type: "headerrow",
    key: "headerrow-" + d,
    index: d,
    value: null,
    rendered: null,
    level: 0,
    hasChildNodes: !0,
    childNodes: o,
    textValue: ""
  }));
}
class UE extends HE {
  constructor(t, n, r) {
    let a = /* @__PURE__ */ new Set(), l = null, i = [];
    if (r?.showSelectionCheckboxes) {
      let c = {
        type: "column",
        key: $$,
        value: null,
        textValue: "",
        level: 0,
        index: r?.showDragButtons ? 1 : 0,
        hasChildNodes: !1,
        rendered: null,
        childNodes: [],
        props: {
          isSelectionCell: !0
        }
      };
      i.unshift(c);
    }
    if (r?.showDragButtons) {
      let c = {
        type: "column",
        key: ru,
        value: null,
        textValue: "",
        level: 0,
        index: 0,
        hasChildNodes: !1,
        rendered: null,
        childNodes: [],
        props: {
          isDragButtonCell: !0
        }
      };
      i.unshift(c);
    }
    let u = [], o = /* @__PURE__ */ new Map(), d = (c) => {
      switch (c.type) {
        case "body":
          l = c;
          break;
        case "column":
          o.set(c.key, c), c.hasChildNodes || (i.push(c), c.props.isRowHeader && a.add(c.key));
          break;
        case "item":
          u.push(c);
          return;
      }
      for (let f of c.childNodes) d(f);
    };
    for (let c of t) d(c);
    let s = v$(o, i);
    if (s.forEach((c, f) => u.splice(f, 0, c)), super({
      columnCount: i.length,
      items: u,
      visitNode: (c) => (c.column = i[c.index], c)
    }), this._size = 0, this.columns = i, this.rowHeaderColumnKeys = a, this.body = l, this.headerRows = s, this._size = [
      ...l.childNodes
    ].length, this.rowHeaderColumnKeys.size === 0) {
      let c = this.columns.find((f) => !f.props?.isDragButtonCell && !f.props?.isSelectionCell);
      c && this.rowHeaderColumnKeys.add(c.key);
    }
  }
  *[Symbol.iterator]() {
    yield* this.body.childNodes;
  }
  get size() {
    return this._size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    return this.keyMap.get(t)?.prevKey ?? null;
  }
  getKeyAfter(t) {
    return this.keyMap.get(t)?.nextKey ?? null;
  }
  getFirstKey() {
    return Wt(this.body.childNodes)?.key ?? null;
  }
  getLastKey() {
    return lr(this.body.childNodes)?.key ?? null;
  }
  getItem(t) {
    return t === this.body.key ? this.body : this.keyMap.get(t) ?? null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  getChildren(t) {
    if (t === this.body.key) return this.body.childNodes;
    let n = this.getItem(t);
    return n?.type === "item" ? [
      ...n.childNodes
    ].filter((r) => r.type === "cell") : super.getChildren(t);
  }
  getTextValue(t) {
    let n = this.getItem(t);
    if (!n) return "";
    if (n.textValue) return n.textValue;
    let r = this.rowHeaderColumnKeys;
    if (r) {
      let a = [];
      for (let l of n.childNodes) {
        let i = this.columns[l.index];
        if (r.has(i.key) && l.textValue && a.push(l.textValue), a.length === r.size) break;
      }
      return a.join(" ");
    }
    return "";
  }
}
function jE(e) {
  return e != null && (!isNaN(e) || String(e).match(/^(\d+)(?=%$)/) !== null);
}
function _E(e) {
  if (!e || typeof e == "number") return 1;
  let t = e.match(/^(.+)(?=fr$)/);
  return t ? parseFloat(t[0]) : (process.env.NODE_ENV !== "production" && console.warn(`width: ${e} is not a supported format, width should be a number (ex. 150), percentage (ex. '50%') or fr unit (ex. '2fr')`, "defaulting to '1fr'"), 1);
}
function vo(e, t) {
  if (typeof e == "string") {
    let n = e.match(/^(\d+)(?=%$)/);
    if (!n) throw new Error("Only percentages or numbers are supported for static column widths");
    return t * (parseFloat(n[0]) / 100);
  }
  return e;
}
function D$(e, t) {
  return e != null ? vo(e, t) : Number.MAX_SAFE_INTEGER;
}
function x$(e, t) {
  return e != null ? vo(e, t) : 0;
}
function WE(e, t, n, r, a) {
  let l = !1, i = t.map((u, o) => {
    let d = n.get(u.key) != null ? n.get(u.key) ?? "1fr" : u.width ?? u.defaultWidth ?? r?.(o) ?? "1fr", s = !1, c = 0, f = 0, h = 0;
    jE(d) ? (c = vo(d, e), s = !0) : (f = _E(d), f <= 0 && (s = !0));
    let m = x$(u.minWidth ?? a?.(o) ?? 0, e), b = D$(u.maxWidth, e), p = Math.max(m, Math.min(c, b));
    return s ? h = p : c > p && (s = !0, h = p), s || (l = !0), {
      frozen: s,
      baseSize: c,
      hypotheticalMainSize: p,
      min: m,
      max: b,
      flex: f,
      targetMainSize: h,
      violation: 0
    };
  });
  for (; l; ) {
    let u = 0, o = 0;
    i.forEach((c) => {
      c.frozen ? u += c.targetMainSize : (u += c.baseSize, o += c.flex);
    });
    let d = e - u;
    d > 0 && i.forEach((c) => {
      if (!c.frozen) {
        let f = c.flex / o;
        c.targetMainSize = c.baseSize + f * d;
      }
    });
    let s = 0;
    i.forEach((c) => {
      if (c.violation = 0, !c.frozen) {
        let { min: f, max: h, targetMainSize: m } = c;
        c.targetMainSize = Math.max(f, Math.min(m, h)), c.violation = c.targetMainSize - m, s += c.violation;
      }
    }), l = !1, i.forEach((c) => {
      s === 0 || Math.sign(s) === Math.sign(c.violation) ? c.frozen = !0 : c.frozen || (l = !0);
    });
  }
  return GE(i);
}
function GE(e) {
  let t = 0, n = 0, r = [];
  return e.forEach(function(a) {
    let l = a.targetMainSize, i = Math.round(l + t) - n;
    t += l, n += i, r.push(i);
  }), r;
}
class qE {
  constructor(t) {
    this.columnWidths = /* @__PURE__ */ new Map(), this.columnMinWidths = /* @__PURE__ */ new Map(), this.columnMaxWidths = /* @__PURE__ */ new Map(), this.getDefaultWidth = t?.getDefaultWidth ?? (() => "1fr"), this.getDefaultMinWidth = t?.getDefaultMinWidth ?? (() => 75);
  }
  /**
  * Takes an array of columns and splits it into 2 maps of columns with controlled and columns with
  * uncontrolled widths.
  */
  splitColumnsIntoControlledAndUncontrolled(t) {
    return t.reduce((n, r) => (r.props.width != null ? n[0].set(r.key, r) : n[1].set(r.key, r), n), [
      /* @__PURE__ */ new Map(),
      /* @__PURE__ */ new Map()
    ]);
  }
  /** Takes uncontrolled and controlled widths and joins them into a single Map. */
  recombineColumns(t, n, r, a) {
    return new Map(t.map((l) => r.has(l.key) ? [
      l.key,
      n.get(l.key)
    ] : [
      l.key,
      a.get(l.key).props.width
    ]));
  }
  /** Used to make an initial Map of the uncontrolled widths based on default widths. */
  getInitialUncontrolledWidths(t) {
    return new Map(Array.from(t).map(([n, r]) => [
      n,
      r.props.defaultWidth ?? this.getDefaultWidth?.(r) ?? "1fr"
    ]));
  }
  getColumnWidth(t) {
    return this.columnWidths.get(t) ?? 0;
  }
  getColumnMinWidth(t) {
    return this.columnMinWidths.get(t) ?? 0;
  }
  getColumnMaxWidth(t) {
    return this.columnMaxWidths.get(t) ?? 0;
  }
  resizeColumnWidth(t, n, r, a) {
    let l = this.columnWidths, i = !0, u = /* @__PURE__ */ new Map();
    return a = Math.max(this.getColumnMinWidth(r), Math.min(this.getColumnMaxWidth(r), Math.floor(a))), t.columns.forEach((o) => {
      o.key === r ? (u.set(o.key, a), i = !1) : i ? u.set(o.key, l.get(o.key) ?? 0) : u.set(o.key, o.props.width ?? n.get(o.key));
    }), u;
  }
  buildColumnWidths(t, n, r) {
    return this.columnWidths = /* @__PURE__ */ new Map(), this.columnMinWidths = /* @__PURE__ */ new Map(), this.columnMaxWidths = /* @__PURE__ */ new Map(), WE(t, n.columns.map((l) => ({
      ...l.props,
      key: l.key
    })), r, (l) => this.getDefaultWidth(n.columns[l]), (l) => this.getDefaultMinWidth(n.columns[l])).forEach((l, i) => {
      let u = n.columns[i].key, o = n.columns[i];
      this.columnWidths.set(u, l), this.columnMinWidths.set(u, x$(o.props.minWidth ?? this.getDefaultMinWidth(o), t)), this.columnMaxWidths.set(u, D$(o.props.maxWidth, t));
    }), this.columnWidths;
  }
}
function YE(e, t) {
  let { getDefaultWidth: n, getDefaultMinWidth: r, tableWidth: a = 0 } = e, [l, i] = Y(null), u = K(() => new qE({
    getDefaultWidth: n,
    getDefaultMinWidth: r
  }), [
    n,
    r
  ]), [o, d] = K(() => u.splitColumnsIntoControlledAndUncontrolled(t.collection.columns), [
    t.collection.columns,
    u
  ]), [s, c] = Y(() => u.getInitialUncontrolledWidths(d)), [f, h] = Y(t.collection.columns);
  if (t.collection.columns !== f) {
    if (t.collection.columns.length !== f.length || t.collection.columns.some((v, x) => v.key !== f[x].key)) {
      let v = u.getInitialUncontrolledWidths(d);
      c(v);
    }
    h(t.collection.columns);
  }
  let m = K(() => u.recombineColumns(t.collection.columns, s, d, o), [
    t.collection.columns,
    s,
    d,
    o,
    u
  ]), b = X((v) => {
    i(v);
  }, [
    i
  ]), p = X((v, x) => {
    let E = u.resizeColumnWidth(t.collection, s, v, x), P = new Map(Array.from(d).map(([C]) => [
      C,
      E.get(C)
    ]));
    return P.set(v, x), c(P), E;
  }, [
    d,
    c,
    u,
    t.collection,
    s
  ]), y = X(() => {
    i(null);
  }, [
    i
  ]), $ = K(() => u.buildColumnWidths(a, t.collection, m), [
    a,
    t.collection,
    m,
    u
  ]);
  return K(() => ({
    resizingColumn: l,
    updateResizedColumns: p,
    startResize: b,
    endResize: y,
    getColumnWidth: (v) => u.getColumnWidth(v),
    getColumnMinWidth: (v) => u.getColumnMinWidth(v),
    getColumnMaxWidth: (v) => u.getColumnMaxWidth(v),
    tableState: t,
    columnWidths: $
  }), [
    u,
    $,
    l,
    p,
    b,
    y,
    t
  ]);
}
function ZE(e) {
  let { collection: t, focusMode: n } = e, r = e.UNSAFE_selectionState || Da(e), a = K(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), l = r.setFocusedKey;
  r.setFocusedKey = (o, d) => {
    if (n === "cell" && o != null) {
      let s = t.getItem(o);
      if (s?.type === "item") {
        let c = Ke(s, t);
        d === "last" ? o = lr(c)?.key ?? null : o = Wt(c)?.key ?? null;
      }
    }
    l(o, d);
  };
  let i = K(() => new Br(t, r), [
    t,
    r
  ]);
  const u = T(null);
  return ee(() => {
    if (r.focusedKey != null && u.current && !t.getItem(r.focusedKey)) {
      const o = u.current.getItem(r.focusedKey), d = o?.parentKey != null && (o.type === "cell" || o.type === "rowheader" || o.type === "column") ? u.current.getItem(o.parentKey) : o;
      if (!d) {
        r.setFocusedKey(null);
        return;
      }
      const s = u.current.rows, c = t.rows, f = s.length - c.length;
      let h = Math.min(f > 1 ? Math.max(d.index - f + 1, 0) : d.index, c.length - 1), m = null;
      for (; h >= 0; ) {
        if (!i.isDisabled(c[h].key) && c[h].type !== "headerrow") {
          m = c[h];
          break;
        }
        h < c.length - 1 ? h++ : (h > d.index && (h = d.index), h--);
      }
      if (m) {
        const b = m.hasChildNodes ? [
          ...Ke(m, t)
        ] : [], p = m.hasChildNodes && d !== o && o && o.index < b.length ? b[o.index].key : m.key;
        r.setFocusedKey(p);
      } else r.setFocusedKey(null);
    }
    u.current = t;
  }, [
    t,
    i,
    r,
    r.focusedKey
  ]), {
    collection: t,
    disabledKeys: a,
    isKeyboardNavigationDisabled: !1,
    selectionManager: i
  };
}
const XE = {
  ascending: "descending",
  descending: "ascending"
};
function JE(e) {
  let [t, n] = Y(!1), { selectionMode: r = "none", showSelectionCheckboxes: a, showDragButtons: l, treeColumn: i = null } = e, u = K(
    () => ({
      showSelectionCheckboxes: a && r !== "none",
      showDragButtons: l,
      selectionMode: r,
      columns: []
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      e.children,
      a,
      r,
      l
    ]
  ), o = uo(e, X((h) => new UE(h, null, u), [
    u
  ]), u), { disabledKeys: d, selectionManager: s } = ZE({
    ...e,
    collection: o,
    disabledBehavior: e.disabledBehavior || "selection"
  }), [c, f] = we(e.expandedKeys ? new Set(e.expandedKeys) : void 0, e.defaultExpandedKeys ? new Set(e.defaultExpandedKeys) : /* @__PURE__ */ new Set(), e.onExpandedChange);
  return {
    collection: o,
    disabledKeys: d,
    selectionManager: s,
    showSelectionCheckboxes: e.showSelectionCheckboxes || !1,
    sortDescriptor: e.sortDescriptor ?? null,
    isKeyboardNavigationDisabled: o.size === 0 || t,
    setKeyboardNavigationDisabled: n,
    sort(h, m) {
      e.onSortChange?.({
        column: h,
        direction: m ?? (e.sortDescriptor?.column === h ? XE[e.sortDescriptor.direction] : "ascending")
      });
    },
    expandedKeys: c,
    toggleKey(h) {
      f((m) => {
        let b = new Set(m);
        return b.has(h) ? b.delete(h) : b.add(h), b;
      });
    },
    treeColumn: i
  };
}
function QE(e, t) {
  let n = K(() => t ? e.collection.filter(t) : e.collection, [
    e.collection,
    t
  ]), r = e.selectionManager.withCollection(n);
  return {
    ...e,
    collection: n,
    selectionManager: r
  };
}
class E$ {
  constructor(t) {
    if (this.collection = t.collection, this.disabledKeys = t.disabledKeys, this.disabledBehavior = t.disabledBehavior || "all", this.direction = t.direction, this.collator = t.collator, !t.layout && !t.ref) throw new Error("Either a layout or a ref must be specified.");
    this.layoutDelegate = t.layoutDelegate || (t.layout ? new e8(t.layout) : new Ji(t.ref)), this.focusMode = t.focusMode ?? "row";
  }
  isCell(t) {
    return t.type === "cell";
  }
  isRow(t) {
    return t.type === "row" || t.type === "item";
  }
  isDisabled(t) {
    return this.disabledBehavior === "all" && (t.props?.isDisabled || this.disabledKeys.has(t.key)) && t.props?.disabledBehavior !== "selection";
  }
  findPreviousKey(t, n, r = !1) {
    let a = t != null ? this.collection.getKeyBefore(t) : this.collection.getLastKey();
    for (; a != null; ) {
      let l = this.collection.getItem(a);
      if (!l) return null;
      if ((r || !this.isDisabled(l)) && (!n || n(l))) return a;
      a = this.collection.getKeyBefore(a);
    }
    return null;
  }
  findNextKey(t, n, r = !1) {
    let a = t != null ? this.collection.getKeyAfter(t) : this.collection.getFirstKey();
    for (; a != null; ) {
      let l = this.collection.getItem(a);
      if (!l) return null;
      if ((r || !this.isDisabled(l)) && (!n || n(l))) return a;
      if (a = this.collection.getKeyAfter(a), a == null) return null;
    }
    return null;
  }
  getKeyForItemInRowByIndex(t, n = 0) {
    if (n < 0) return null;
    let r = this.collection.getItem(t);
    if (!r) return null;
    let a = 0;
    for (let l of Ke(r, this.collection)) {
      if (l.colSpan && l.colSpan + a > n || (l.colSpan && (a = a + l.colSpan - 1), a === n)) return l.key ?? null;
      a++;
    }
    return null;
  }
  getKeyBelow(t, n) {
    let r = t, a = this.collection.getItem(r);
    if (!a || (this.isCell(a) && (r = a.parentKey ?? null), r == null)) return null;
    if (r = this.findNextKey(r, (l) => l.type === "item", n?.includeDisabled), r != null) {
      if (this.isCell(a)) {
        let l = a.colIndex ? a.colIndex : a.index;
        return this.getKeyForItemInRowByIndex(r, l);
      }
      if (this.focusMode === "row") return r;
    }
    return null;
  }
  getKeyAbove(t, n) {
    let r = t, a = this.collection.getItem(r);
    if (!a || (this.isCell(a) && (r = a.parentKey ?? null), r == null)) return null;
    if (r = this.findPreviousKey(r, (l) => l.type === "item", n?.includeDisabled), r != null) {
      if (this.isCell(a)) {
        let l = a.colIndex ? a.colIndex : a.index;
        return this.getKeyForItemInRowByIndex(r, l);
      }
      if (this.focusMode === "row") return r;
    }
    return null;
  }
  getKeyRightOf(t) {
    let n = this.collection.getItem(t);
    if (!n) return null;
    if (this.isRow(n)) {
      let r = Ke(n, this.collection);
      return (this.direction === "rtl" ? lr(r)?.key : Wt(r)?.key) ?? null;
    }
    if (this.isCell(n) && n.parentKey != null) {
      let r = this.collection.getItem(n.parentKey);
      if (!r) return null;
      let a = Ke(r, this.collection), l = (this.direction === "rtl" ? Ur(a, n.index - 1) : Ur(a, n.index + 1)) ?? null;
      return l ? l.key ?? null : this.focusMode === "row" ? n.parentKey ?? null : (this.direction === "rtl" ? this.getFirstKey(t) : this.getLastKey(t)) ?? null;
    }
    return null;
  }
  getKeyLeftOf(t) {
    let n = this.collection.getItem(t);
    if (!n) return null;
    if (this.isRow(n)) {
      let r = Ke(n, this.collection);
      return (this.direction === "rtl" ? Wt(r)?.key : lr(r)?.key) ?? null;
    }
    if (this.isCell(n) && n.parentKey != null) {
      let r = this.collection.getItem(n.parentKey);
      if (!r) return null;
      let a = Ke(r, this.collection), l = (this.direction === "rtl" ? Ur(a, n.index + 1) : Ur(a, n.index - 1)) ?? null;
      return l ? l.key ?? null : this.focusMode === "row" ? n.parentKey ?? null : (this.direction === "rtl" ? this.getLastKey(t) : this.getFirstKey(t)) ?? null;
    }
    return null;
  }
  getFirstKey(t, n) {
    let r = t ?? null, a;
    if (r != null) {
      if (a = this.collection.getItem(r), !a) return null;
      if (this.isCell(a) && !n && a.parentKey != null) {
        let l = this.collection.getItem(a.parentKey);
        return l ? Wt(Ke(l, this.collection))?.key ?? null : null;
      }
    }
    if (r = this.findNextKey(void 0, (l) => l.type === "item"), r != null && (a && this.isCell(a) && n || this.focusMode === "cell")) {
      let l = this.collection.getItem(r);
      if (!l) return null;
      r = Wt(Ke(l, this.collection))?.key ?? null;
    }
    return r;
  }
  getLastKey(t, n) {
    let r = t ?? null, a;
    if (r != null) {
      if (a = this.collection.getItem(r), !a) return null;
      if (this.isCell(a) && !n && a.parentKey != null) {
        let l = this.collection.getItem(a.parentKey);
        if (!l) return null;
        let i = Ke(l, this.collection);
        return lr(i)?.key ?? null;
      }
    }
    if (r = this.findPreviousKey(void 0, (l) => l.type === "item"), r != null && (a && this.isCell(a) && n || this.focusMode === "cell")) {
      let l = this.collection.getItem(r);
      if (!l) return null;
      let i = Ke(l, this.collection);
      r = lr(i)?.key ?? null;
    }
    return r;
  }
  getKeyPageAbove(t) {
    let n = t, r = this.layoutDelegate.getItemRect(n);
    if (!r) return null;
    let a = Math.max(0, r.y + r.height - this.layoutDelegate.getVisibleRect().height);
    for (; r && r.y > a && n != null && (n = this.getKeyAbove(n) ?? null, n != null); )
      r = this.layoutDelegate.getItemRect(n);
    return n;
  }
  getKeyPageBelow(t) {
    let n = t, r = this.layoutDelegate.getItemRect(n);
    if (!r) return null;
    let a = this.layoutDelegate.getVisibleRect().height, l = Math.min(this.layoutDelegate.getContentSize().height, r.y + a);
    for (; r && r.y + r.height < l; ) {
      let i = this.getKeyBelow(n);
      if (i == null) break;
      r = this.layoutDelegate.getItemRect(i), n = i;
    }
    return n;
  }
  getKeyForSearch(t, n) {
    let r = n ?? null;
    if (!this.collator) return null;
    let a = this.collection;
    if (r = n ?? this.getFirstKey(), r == null) return null;
    let l = a.getItem(r);
    if (!l) return null;
    l.type === "cell" && (r = l.parentKey ?? null);
    let i = !1;
    for (; r != null; ) {
      let u = a.getItem(r);
      if (!u) return null;
      if (u.textValue) {
        let o = u.textValue.slice(0, t.length);
        if (this.collator.compare(o, t) === 0)
          return this.isRow(u) && this.focusMode === "cell" ? Wt(Ke(u, this.collection))?.key ?? null : u.key;
      }
      r = this.findNextKey(r, (o) => o.type === "item"), r == null && !i && (r = this.getFirstKey(), i = !0);
    }
    return null;
  }
}
class e8 {
  constructor(t) {
    this.layout = t;
  }
  getContentSize() {
    return this.layout.getContentSize();
  }
  getItemRect(t) {
    return this.layout.getLayoutInfo(t)?.rect || null;
  }
  getVisibleRect() {
    return this.layout.virtualizer.visibleRect;
  }
}
const Do = /* @__PURE__ */ new WeakMap();
function t8(e, t, n) {
  let { isVirtualized: r, disallowTypeAhead: a, keyboardDelegate: l, focusMode: i, scrollRef: u, getRowText: o, onRowAction: d, onCellAction: s, escapeKeyBehavior: c = "clearSelection", shouldSelectOnPressUp: f } = e, { selectionManager: h } = t;
  !e["aria-label"] && !e["aria-labelledby"] && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let m = Sr({
    usage: "search",
    sensitivity: "base"
  }), { direction: b } = de(), p = t.selectionManager.disabledBehavior, y = K(() => l || new E$({
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    disabledBehavior: p,
    ref: n,
    direction: b,
    collator: m,
    focusMode: i
  }), [
    l,
    t.collection,
    t.disabledKeys,
    p,
    n,
    b,
    m,
    i
  ]), { collectionProps: $ } = lo({
    ref: n,
    selectionManager: h,
    keyboardDelegate: y,
    isVirtualized: r,
    scrollRef: u,
    disallowTypeAhead: a,
    escapeKeyBehavior: c
  }), v = ce(e.id);
  Do.set(t, {
    keyboardDelegate: y,
    actions: {
      onRowAction: d,
      onCellAction: s
    },
    shouldSelectOnPressUp: f
  });
  let x = Ry({
    selectionManager: h,
    hasItemActions: !!(d || s)
  }), E = J(e, {
    labelable: !0
  }), P = X((V) => {
    if (h.isFocused) {
      ae(V.currentTarget, W(V)) || h.setFocused(!1);
      return;
    }
    ae(V.currentTarget, W(V)) && h.setFocused(!0);
  }, [
    h
  ]), C = K(() => ({
    onBlur: $.onBlur,
    onFocus: P
  }), [
    P,
    $.onBlur
  ]), M = po(n, {
    isDisabled: t.collection.size !== 0
  }), F = z(
    E,
    {
      role: "grid",
      id: v,
      "aria-multiselectable": h.selectionMode === "multiple" ? "true" : void 0
    },
    t.isKeyboardNavigationDisabled ? C : $,
    // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    t.collection.size === 0 && {
      tabIndex: M ? -1 : 0
    } || void 0,
    x
  );
  return r && (F["aria-rowcount"] = t.collection.size, F["aria-colcount"] = t.collection.columnCount), Ay({
    getRowText: o
  }, t), {
    gridProps: F
  };
}
const xo = /* @__PURE__ */ new WeakMap();
function au(e) {
  return typeof e == "string" ? e.replace(/\s*/g, "") : "" + e;
}
function C$(e, t) {
  let n = xo.get(e);
  if (!n) throw new Error("Unknown grid");
  return `${n}-${au(t)}`;
}
function P$(e, t, n) {
  let r = xo.get(e);
  if (!r) throw new Error("Unknown grid");
  return `${r}-${au(t)}-${au(n)}`;
}
function lu(e, t) {
  return [
    ...e.collection.rowHeaderColumnKeys
  ].map((n) => P$(e, t, n)).join(" ");
}
var w$ = {};
w$ = {
  ascending: "تصاعدي",
  ascendingSort: (e) => `ترتيب حسب العمود ${e.columnName} بترتيب تصاعدي`,
  columnSize: (e) => `${e.value} بالبكسل`,
  descending: "تنازلي",
  descendingSort: (e) => `ترتيب حسب العمود ${e.columnName} بترتيب تنازلي`,
  resizerDescription: "اضغط على مفتاح Enter لبدء تغيير الحجم",
  select: "تحديد",
  selectAll: "تحديد الكل",
  sortable: "عمود قابل للترتيب",
  collapse: "طي",
  expand: "تمديد"
};
var S$ = {};
S$ = {
  ascending: "възходящ",
  ascendingSort: (e) => `сортирано по колона ${e.columnName} във възходящ ред`,
  columnSize: (e) => `${e.value} пиксела`,
  descending: "низходящ",
  descendingSort: (e) => `сортирано по колона ${e.columnName} в низходящ ред`,
  resizerDescription: "Натиснете „Enter“, за да започнете да преоразмерявате",
  select: "Изберете",
  selectAll: "Изберете всичко",
  sortable: "сортираща колона",
  collapse: "Свиване",
  expand: "Разширяване"
};
var k$ = {};
k$ = {
  ascending: "vzestupně",
  ascendingSort: (e) => `řazeno vzestupně podle sloupce ${e.columnName}`,
  columnSize: (e) => `${e.value} pixelů`,
  descending: "sestupně",
  descendingSort: (e) => `řazeno sestupně podle sloupce ${e.columnName}`,
  resizerDescription: "Stisknutím klávesy Enter začnete měnit velikost",
  select: "Vybrat",
  selectAll: "Vybrat vše",
  sortable: "sloupec s možností řazení",
  collapse: "Sbalit",
  expand: "Roztáhnout"
};
var B$ = {};
B$ = {
  ascending: "stigende",
  ascendingSort: (e) => `sorteret efter kolonne ${e.columnName} i stigende rækkefølge`,
  columnSize: (e) => `${e.value} pixels`,
  descending: "faldende",
  descendingSort: (e) => `sorteret efter kolonne ${e.columnName} i faldende rækkefølge`,
  resizerDescription: "Tryk på Enter for at ændre størrelse",
  select: "Vælg",
  selectAll: "Vælg alle",
  sortable: "sorterbar kolonne",
  collapse: "Skjul",
  expand: "Udvid"
};
var F$ = {};
F$ = {
  ascending: "aufsteigend",
  ascendingSort: (e) => `sortiert nach Spalte ${e.columnName} in aufsteigender Reihenfolge`,
  columnSize: (e) => `${e.value} Pixel`,
  descending: "absteigend",
  descendingSort: (e) => `sortiert nach Spalte ${e.columnName} in absteigender Reihenfolge`,
  resizerDescription: "Eingabetaste zum Starten der Größenänderung drücken",
  select: "Auswählen",
  selectAll: "Alles auswählen",
  sortable: "sortierbare Spalte",
  collapse: "Reduzieren",
  expand: "Erweitern"
};
var A$ = {};
A$ = {
  ascending: "αύξουσα",
  ascendingSort: (e) => `διαλογή ανά στήλη ${e.columnName} σε αύξουσα σειρά`,
  columnSize: (e) => `${e.value} pixel`,
  descending: "φθίνουσα",
  descendingSort: (e) => `διαλογή ανά στήλη ${e.columnName} σε φθίνουσα σειρά`,
  resizerDescription: "Πατήστε Enter για έναρξη της αλλαγής μεγέθους",
  select: "Επιλογή",
  selectAll: "Επιλογή όλων",
  sortable: "Στήλη διαλογής",
  collapse: "Σύμπτυξη",
  expand: "Ανάπτυξη"
};
var R$ = {};
R$ = {
  select: "Select",
  selectAll: "Select All",
  sortable: "sortable column",
  ascending: "ascending",
  descending: "descending",
  ascendingSort: (e) => `sorted by column ${e.columnName} in ascending order`,
  descendingSort: (e) => `sorted by column ${e.columnName} in descending order`,
  columnSize: (e) => `${e.value} pixels`,
  resizerDescription: "Press Enter to start resizing",
  expand: "Expand",
  collapse: "Collapse"
};
var T$ = {};
T$ = {
  ascending: "ascendente",
  ascendingSort: (e) => `ordenado por columna ${e.columnName} en sentido ascendente`,
  columnSize: (e) => `${e.value} píxeles`,
  descending: "descendente",
  descendingSort: (e) => `ordenado por columna ${e.columnName} en orden descendente`,
  resizerDescription: "Pulse Intro para empezar a redimensionar",
  select: "Seleccionar",
  selectAll: "Seleccionar todos",
  sortable: "columna ordenable",
  collapse: "Contraer",
  expand: "Ampliar"
};
var I$ = {};
I$ = {
  ascending: "tõusev järjestus",
  ascendingSort: (e) => `sorditud veeru järgi ${e.columnName} tõusvas järjestuses`,
  columnSize: (e) => `${e.value} pikslit`,
  descending: "laskuv järjestus",
  descendingSort: (e) => `sorditud veeru järgi ${e.columnName} laskuvas järjestuses`,
  resizerDescription: "Suuruse muutmise alustamiseks vajutage klahvi Enter",
  select: "Vali",
  selectAll: "Vali kõik",
  sortable: "sorditav veerg",
  collapse: "Ahenda",
  expand: "Laienda"
};
var M$ = {};
M$ = {
  ascending: "nouseva",
  ascendingSort: (e) => `lajiteltu sarakkeen ${e.columnName} mukaan nousevassa järjestyksessä`,
  columnSize: (e) => `${e.value} pikseliä`,
  descending: "laskeva",
  descendingSort: (e) => `lajiteltu sarakkeen ${e.columnName} mukaan laskevassa järjestyksessä`,
  resizerDescription: "Aloita koon muutos painamalla Enter-näppäintä",
  select: "Valitse",
  selectAll: "Valitse kaikki",
  sortable: "lajiteltava sarake",
  collapse: "Pienennä",
  expand: "Laajenna"
};
var K$ = {};
K$ = {
  ascending: "croissant",
  ascendingSort: (e) => `trié en fonction de la colonne ${e.columnName} par ordre croissant`,
  columnSize: (e) => `${e.value} pixels`,
  descending: "décroissant",
  descendingSort: (e) => `trié en fonction de la colonne ${e.columnName} par ordre décroissant`,
  resizerDescription: "Appuyez sur Entrée pour commencer le redimensionnement.",
  select: "Sélectionner",
  selectAll: "Sélectionner tout",
  sortable: "colonne triable",
  collapse: "Réduire",
  expand: "Développer"
};
var N$ = {};
N$ = {
  ascending: "עולה",
  ascendingSort: (e) => `מוין לפי עמודה ${e.columnName} בסדר עולה`,
  columnSize: (e) => `${e.value} פיקסלים`,
  descending: "יורד",
  descendingSort: (e) => `מוין לפי עמודה ${e.columnName} בסדר יורד`,
  resizerDescription: "הקש Enter כדי לשנות את הגודל",
  select: "בחר",
  selectAll: "בחר הכול",
  sortable: "עמודה שניתן למיין",
  collapse: "כווץ",
  expand: "הרחב"
};
var V$ = {};
V$ = {
  ascending: "rastući",
  ascendingSort: (e) => `razvrstano po stupcima ${e.columnName} rastućem redoslijedom`,
  columnSize: (e) => `${e.value} piksela`,
  descending: "padajući",
  descendingSort: (e) => `razvrstano po stupcima ${e.columnName} padajućim redoslijedom`,
  resizerDescription: "Pritisnite Enter da biste započeli promenu veličine",
  select: "Odaberite",
  selectAll: "Odaberite sve",
  sortable: "stupac koji se može razvrstati",
  collapse: "Sažmi",
  expand: "Proširi"
};
var L$ = {};
L$ = {
  ascending: "növekvő",
  ascendingSort: (e) => `rendezve a(z) ${e.columnName} oszlop szerint, növekvő sorrendben`,
  columnSize: (e) => `${e.value} képpont`,
  descending: "csökkenő",
  descendingSort: (e) => `rendezve a(z) ${e.columnName} oszlop szerint, csökkenő sorrendben`,
  resizerDescription: "Nyomja le az Enter billentyűt az átméretezés megkezdéséhez",
  select: "Kijelölés",
  selectAll: "Összes kijelölése",
  sortable: "rendezendő oszlop",
  collapse: "Összecsukás",
  expand: "Kibontás"
};
var z$ = {};
z$ = {
  ascending: "crescente",
  ascendingSort: (e) => `in ordine crescente in base alla colonna ${e.columnName}`,
  columnSize: (e) => `${e.value} pixel`,
  descending: "decrescente",
  descendingSort: (e) => `in ordine decrescente in base alla colonna ${e.columnName}`,
  resizerDescription: "Premi Invio per iniziare a ridimensionare",
  select: "Seleziona",
  selectAll: "Seleziona tutto",
  sortable: "colonna ordinabile",
  collapse: "Comprimi",
  expand: "Espandi"
};
var O$ = {};
O$ = {
  ascending: "昇順",
  ascendingSort: (e) => `列 ${e.columnName} を昇順で並べ替え`,
  columnSize: (e) => `${e.value} ピクセル`,
  descending: "降順",
  descendingSort: (e) => `列 ${e.columnName} を降順で並べ替え`,
  resizerDescription: "Enter キーを押してサイズ変更を開始",
  select: "選択",
  selectAll: "すべて選択",
  sortable: "並べ替え可能な列",
  collapse: "折りたたむ",
  expand: "展開"
};
var H$ = {};
H$ = {
  ascending: "오름차순",
  ascendingSort: (e) => `${e.columnName} 열을 기준으로 오름차순으로 정렬됨`,
  columnSize: (e) => `${e.value} 픽셀`,
  descending: "내림차순",
  descendingSort: (e) => `${e.columnName} 열을 기준으로 내림차순으로 정렬됨`,
  resizerDescription: "크기 조정을 시작하려면 Enter를 누르세요.",
  select: "선택",
  selectAll: "모두 선택",
  sortable: "정렬 가능한 열",
  collapse: "접기",
  expand: "펼치기"
};
var U$ = {};
U$ = {
  ascending: "didėjančia tvarka",
  ascendingSort: (e) => `surikiuota pagal stulpelį ${e.columnName} didėjančia tvarka`,
  columnSize: (e) => `${e.value} piks.`,
  descending: "mažėjančia tvarka",
  descendingSort: (e) => `surikiuota pagal stulpelį ${e.columnName} mažėjančia tvarka`,
  resizerDescription: "Paspauskite „Enter“, kad pradėtumėte keisti dydį",
  select: "Pasirinkti",
  selectAll: "Pasirinkti viską",
  sortable: "rikiuojamas stulpelis",
  collapse: "Sutraukti",
  expand: "Išskleisti"
};
var j$ = {};
j$ = {
  ascending: "augošā secībā",
  ascendingSort: (e) => `kārtots pēc kolonnas ${e.columnName} augošā secībā`,
  columnSize: (e) => `${e.value} pikseļi`,
  descending: "dilstošā secībā",
  descendingSort: (e) => `kārtots pēc kolonnas ${e.columnName} dilstošā secībā`,
  resizerDescription: "Nospiediet Enter, lai sāktu izmēru mainīšanu",
  select: "Atlasīt",
  selectAll: "Atlasīt visu",
  sortable: "kārtojamā kolonna",
  collapse: "Sakļaut",
  expand: "Izvērst"
};
var _$ = {};
_$ = {
  ascending: "stigende",
  ascendingSort: (e) => `sortert etter kolonne ${e.columnName} i stigende rekkefølge`,
  columnSize: (e) => `${e.value} piksler`,
  descending: "synkende",
  descendingSort: (e) => `sortert etter kolonne ${e.columnName} i synkende rekkefølge`,
  resizerDescription: "Trykk på Enter for å starte størrelsesendring",
  select: "Velg",
  selectAll: "Velg alle",
  sortable: "kolonne som kan sorteres",
  collapse: "Skjul",
  expand: "Utvid"
};
var W$ = {};
W$ = {
  ascending: "oplopend",
  ascendingSort: (e) => `gesorteerd in oplopende volgorde in kolom ${e.columnName}`,
  columnSize: (e) => `${e.value} pixels`,
  descending: "aflopend",
  descendingSort: (e) => `gesorteerd in aflopende volgorde in kolom ${e.columnName}`,
  resizerDescription: "Druk op Enter om het formaat te wijzigen",
  select: "Selecteren",
  selectAll: "Alles selecteren",
  sortable: "sorteerbare kolom",
  collapse: "Samenvouwen",
  expand: "Uitvouwen"
};
var G$ = {};
G$ = {
  ascending: "rosnąco",
  ascendingSort: (e) => `posortowano według kolumny ${e.columnName} w porządku rosnącym`,
  columnSize: (e) => `Liczba pikseli: ${e.value}`,
  descending: "malejąco",
  descendingSort: (e) => `posortowano według kolumny ${e.columnName} w porządku malejącym`,
  resizerDescription: "Naciśnij Enter, aby rozpocząć zmienianie rozmiaru",
  select: "Zaznacz",
  selectAll: "Zaznacz wszystko",
  sortable: "kolumna z możliwością sortowania",
  collapse: "Zwiń",
  expand: "Rozwiń"
};
var q$ = {};
q$ = {
  ascending: "crescente",
  ascendingSort: (e) => `classificado pela coluna ${e.columnName} em ordem crescente`,
  columnSize: (e) => `${e.value} pixels`,
  descending: "decrescente",
  descendingSort: (e) => `classificado pela coluna ${e.columnName} em ordem decrescente`,
  resizerDescription: "Pressione Enter para começar a redimensionar",
  select: "Selecionar",
  selectAll: "Selecionar tudo",
  sortable: "coluna classificável",
  collapse: "Recolher",
  expand: "Expandir"
};
var Y$ = {};
Y$ = {
  ascending: "ascendente",
  ascendingSort: (e) => `Ordenar por coluna ${e.columnName} em ordem ascendente`,
  columnSize: (e) => `${e.value} pixels`,
  descending: "descendente",
  descendingSort: (e) => `Ordenar por coluna ${e.columnName} em ordem descendente`,
  resizerDescription: "Prima Enter para iniciar o redimensionamento",
  select: "Selecionar",
  selectAll: "Selecionar tudo",
  sortable: "Coluna ordenável",
  collapse: "Colapsar",
  expand: "Expandir"
};
var Z$ = {};
Z$ = {
  ascending: "crescătoare",
  ascendingSort: (e) => `sortate după coloana ${e.columnName} în ordine crescătoare`,
  columnSize: (e) => `${e.value} pixeli`,
  descending: "descrescătoare",
  descendingSort: (e) => `sortate după coloana ${e.columnName} în ordine descrescătoare`,
  resizerDescription: "Apăsați pe Enter pentru a începe redimensionarea",
  select: "Selectare",
  selectAll: "Selectare totală",
  sortable: "coloană sortabilă",
  collapse: "Restrângeți",
  expand: "Extindeți"
};
var X$ = {};
X$ = {
  ascending: "возрастание",
  ascendingSort: (e) => `сортировать столбец ${e.columnName} в порядке возрастания`,
  columnSize: (e) => `${e.value} пикс.`,
  descending: "убывание",
  descendingSort: (e) => `сортировать столбец ${e.columnName} в порядке убывания`,
  resizerDescription: "Нажмите клавишу Enter для начала изменения размеров",
  select: "Выбрать",
  selectAll: "Выбрать все",
  sortable: "сортируемый столбец",
  collapse: "Свернуть",
  expand: "Развернуть"
};
var J$ = {};
J$ = {
  ascending: "vzostupne",
  ascendingSort: (e) => `zoradené zostupne podľa stĺpca ${e.columnName}`,
  columnSize: (e) => `Počet pixelov: ${e.value}`,
  descending: "zostupne",
  descendingSort: (e) => `zoradené zostupne podľa stĺpca ${e.columnName}`,
  resizerDescription: "Stlačením klávesu Enter začnete zmenu veľkosti",
  select: "Vybrať",
  selectAll: "Vybrať všetko",
  sortable: "zoraditeľný stĺpec",
  collapse: "Zbaliť",
  expand: "Rozbaliť"
};
var Q$ = {};
Q$ = {
  ascending: "naraščajoče",
  ascendingSort: (e) => `razvrščeno po stolpcu ${e.columnName} v naraščajočem vrstnem redu`,
  columnSize: (e) => `${e.value} slikovnih pik`,
  descending: "padajoče",
  descendingSort: (e) => `razvrščeno po stolpcu ${e.columnName} v padajočem vrstnem redu`,
  resizerDescription: "Pritisnite tipko Enter da začnete spreminjati velikost",
  select: "Izberite",
  selectAll: "Izberite vse",
  sortable: "razvrstljivi stolpec",
  collapse: "Strni",
  expand: "Razširi"
};
var e1 = {};
e1 = {
  ascending: "rastući",
  ascendingSort: (e) => `sortirano po kolonama ${e.columnName} rastućim redosledom`,
  columnSize: (e) => `${e.value} piksela`,
  descending: "padajući",
  descendingSort: (e) => `sortirano po kolonama ${e.columnName} padajućim redosledom`,
  resizerDescription: "Pritisnite Enter da biste započeli promenu veličine",
  select: "Izaberite",
  selectAll: "Izaberite sve",
  sortable: "kolona koja se može sortirati",
  collapse: " Skupi",
  expand: "Proširi"
};
var t1 = {};
t1 = {
  ascending: "stigande",
  ascendingSort: (e) => `sorterat på kolumn ${e.columnName} i stigande ordning`,
  columnSize: (e) => `${e.value} pixlar`,
  descending: "fallande",
  descendingSort: (e) => `sorterat på kolumn ${e.columnName} i fallande ordning`,
  resizerDescription: "Tryck på Retur för att börja ändra storlek",
  select: "Markera",
  selectAll: "Markera allt",
  sortable: "sorterbar kolumn",
  collapse: "Dölj",
  expand: "Expandera"
};
var n1 = {};
n1 = {
  ascending: "artan sırada",
  ascendingSort: (e) => `${e.columnName} sütuna göre artan düzende sırala`,
  columnSize: (e) => `${e.value} piksel`,
  descending: "azalan sırada",
  descendingSort: (e) => `${e.columnName} sütuna göre azalan düzende sırala`,
  resizerDescription: "Yeniden boyutlandırmak için Enter'a basın",
  select: "Seç",
  selectAll: "Tümünü Seç",
  sortable: "Sıralanabilir sütun",
  collapse: "Daralt",
  expand: "Genişlet"
};
var r1 = {};
r1 = {
  ascending: "висхідний",
  ascendingSort: (e) => `відсортовано за стовпцем ${e.columnName} у висхідному порядку`,
  columnSize: (e) => `${e.value} пікс.`,
  descending: "низхідний",
  descendingSort: (e) => `відсортовано за стовпцем ${e.columnName} у низхідному порядку`,
  resizerDescription: "Натисніть Enter, щоб почати зміну розміру",
  select: "Вибрати",
  selectAll: "Вибрати все",
  sortable: "сортувальний стовпець",
  collapse: "Згорнути",
  expand: "Розгорнути"
};
var a1 = {};
a1 = {
  ascending: "升序",
  ascendingSort: (e) => `按列 ${e.columnName} 升序排序`,
  columnSize: (e) => `${e.value} 像素`,
  descending: "降序",
  descendingSort: (e) => `按列 ${e.columnName} 降序排序`,
  resizerDescription: "按“输入”键开始调整大小。",
  select: "选择",
  selectAll: "全选",
  sortable: "可排序的列",
  collapse: "折叠",
  expand: "扩展"
};
var l1 = {};
l1 = {
  ascending: "遞增",
  ascendingSort: (e) => `已依據「${e.columnName}」欄遞增排序`,
  columnSize: (e) => `${e.value} 像素`,
  descending: "遞減",
  descendingSort: (e) => `已依據「${e.columnName}」欄遞減排序`,
  resizerDescription: "按 Enter 鍵以開始調整大小",
  select: "選取",
  selectAll: "全選",
  sortable: "可排序的欄",
  collapse: "收合",
  expand: "展開"
};
var Rr = {};
Rr = {
  "ar-AE": w$,
  "bg-BG": S$,
  "cs-CZ": k$,
  "da-DK": B$,
  "de-DE": F$,
  "el-GR": A$,
  "en-US": R$,
  "es-ES": T$,
  "et-EE": I$,
  "fi-FI": M$,
  "fr-FR": K$,
  "he-IL": N$,
  "hr-HR": V$,
  "hu-HU": L$,
  "it-IT": z$,
  "ja-JP": O$,
  "ko-KR": H$,
  "lt-LT": U$,
  "lv-LV": j$,
  "nb-NO": _$,
  "nl-NL": W$,
  "pl-PL": G$,
  "pt-BR": q$,
  "pt-PT": Y$,
  "ro-RO": Z$,
  "ru-RU": X$,
  "sk-SK": J$,
  "sl-SI": Q$,
  "sr-SP": e1,
  "sv-SE": t1,
  "tr-TR": n1,
  "uk-UA": r1,
  "zh-CN": a1,
  "zh-TW": l1
};
class n8 extends E$ {
  isCell(t) {
    return t.type === "cell" || t.type === "rowheader" || t.type === "column";
  }
  getKeyBelow(t, n) {
    let r = this.collection.getItem(t);
    if (!r) return null;
    if (r.type === "column") {
      let a = Wt(Ke(r, this.collection));
      if (a) return a.key;
      let l = this.getFirstKey();
      return l == null || !this.collection.getItem(l) ? null : super.getKeyForItemInRowByIndex(l, r.index);
    }
    return super.getKeyBelow(t, n);
  }
  getKeyAbove(t, n) {
    let r = this.collection.getItem(t);
    if (!r) return null;
    if (r.type === "column") {
      let i = r.parentKey != null ? this.collection.getItem(r.parentKey) : null;
      return i && i.type === "column" ? i.key : null;
    }
    let a = super.getKeyAbove(t, n), l = a != null ? this.collection.getItem(a) : null;
    return l && l.type !== "headerrow" ? a : this.isCell(r) ? this.collection.columns[r.index].key : this.collection.columns[0].key;
  }
  findNextColumnKey(t) {
    let n = this.findNextKey(t.key, (a) => a.type === "column");
    if (n != null) return n;
    let r = this.collection.headerRows[t.level];
    for (let a of Ke(r, this.collection))
      if (a.type === "column") return a.key;
    return null;
  }
  findPreviousColumnKey(t) {
    let n = this.findPreviousKey(t.key, (l) => l.type === "column");
    if (n != null) return n;
    let r = this.collection.headerRows[t.level], a = [
      ...Ke(r, this.collection)
    ];
    for (let l = a.length - 1; l >= 0; l--) {
      let i = a[l];
      if (i.type === "column") return i.key;
    }
    return null;
  }
  getKeyRightOf(t) {
    let n = this.collection.getItem(t);
    return n ? n.type === "column" ? this.direction === "rtl" ? this.findPreviousColumnKey(n) : this.findNextColumnKey(n) : super.getKeyRightOf(t) : null;
  }
  getKeyLeftOf(t) {
    let n = this.collection.getItem(t);
    return n ? n.type === "column" ? this.direction === "rtl" ? this.findNextColumnKey(n) : this.findPreviousColumnKey(n) : super.getKeyLeftOf(t) : null;
  }
  getKeyForSearch(t, n) {
    if (!this.collator) return null;
    let r = this.collection, a = n ?? this.getFirstKey();
    if (a == null) return null;
    let l = r.getItem(a);
    l?.type === "cell" && (a = l.parentKey ?? null);
    let i = !1;
    for (; a != null; ) {
      let u = r.getItem(a);
      if (!u) return null;
      if (u.textValue) {
        let o = u.textValue.slice(0, t.length);
        if (this.collator.compare(o, t) === 0) return u.key;
      }
      for (let o of Ke(u, this.collection)) {
        let d = r.columns[o.index];
        if (r.rowHeaderColumnKeys.has(d.key) && o.textValue) {
          let s = o.textValue.slice(0, t.length);
          if (this.collator.compare(s, t) === 0)
            return (n != null ? r.getItem(n) : l)?.type === "cell" ? o.key : u.key;
        }
      }
      a = this.getKeyBelow(a), a == null && !i && (a = this.getFirstKey(), i = !0);
    }
    return null;
  }
}
function r8(e) {
  return e && e.__esModule ? e.default : e;
}
function a8(e, t, n) {
  let { keyboardDelegate: r, isVirtualized: a, layoutDelegate: l, layout: i } = e, u = Sr({
    usage: "search",
    sensitivity: "base"
  }), { direction: o } = de(), d = t.selectionManager.disabledBehavior, s = K(() => r || new n8({
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    disabledBehavior: d,
    ref: n,
    direction: o,
    collator: u,
    layoutDelegate: l,
    layout: i
  }), [
    r,
    t.collection,
    t.disabledKeys,
    d,
    n,
    o,
    u,
    l,
    i
  ]), c = ce(e.id);
  xo.set(t, c);
  let { gridProps: f } = t8({
    ...e,
    id: c,
    keyboardDelegate: s
  }, t, n);
  a && (f["aria-rowcount"] = t.collection.size + t.collection.headerRows.length), t.treeColumn != null && (f.role = "treegrid");
  let { column: h, direction: m } = t.sortDescriptor || {}, b = Ee(r8(Rr), "@react-aria/table"), p = K(() => {
    let $ = t.collection.columns.find((v) => v.key === h)?.textValue ?? "";
    return m && h ? b.format(`${m}Sort`, {
      columnName: $
    }) : void 0;
  }, [
    m,
    h,
    t.collection.columns
  ]), y = en(p);
  return ol(() => {
    p && pn(p, "assertive", 500);
  }, [
    p
  ]), {
    gridProps: z(f, y, {
      // merge sort description with long press information
      "aria-describedby": [
        y["aria-describedby"],
        f["aria-describedby"]
      ].filter(Boolean).join(" ")
    })
  };
}
function i1(e, t, n) {
  let { node: r, isVirtualized: a, focusMode: l = "child", shouldSelectOnPressUp: i, onAction: u } = e, { direction: o } = de(), { keyboardDelegate: d, actions: { onCellAction: s } } = Do.get(t), c = T(null), f = () => {
    if (n.current) {
      let $ = Ie(n.current);
      if (l === "child") {
        if (Yt(n.current) && n.current !== se()) return;
        let v = t.selectionManager.childFocusStrategy === "last" ? gi($) : $.firstChild();
        if (v) {
          Se(v);
          return;
        }
      }
      (c.current != null && r.key !== c.current || !Yt(n.current)) && Se(n.current);
    }
  }, { itemProps: h, isPressed: m } = kr({
    selectionManager: t.selectionManager,
    key: r.key,
    ref: n,
    isVirtualized: a,
    focus: f,
    shouldSelectOnPressUp: i,
    onAction: s ? () => s(r.key) : u,
    isDisabled: t.collection.size === 0
  }), b = ($) => {
    let v = se();
    if (!ae($.currentTarget, W($)) || t.isKeyboardNavigationDisabled || !n.current || !v) return;
    let x = Ie(n.current);
    switch (x.currentNode = v, $.key) {
      case "ArrowLeft": {
        let E = o === "rtl" ? x.nextNode() : x.previousNode();
        if (l === "child" && E === n.current && (E = null), $.preventDefault(), $.stopPropagation(), E)
          Se(E), Oe(E, {
            containingElement: ze(n.current)
          });
        else {
          if (d.getKeyLeftOf?.(r.key) !== r.key) {
            n.current.parentElement?.dispatchEvent(new KeyboardEvent($.nativeEvent.type, $.nativeEvent));
            break;
          }
          l === "cell" && o === "rtl" ? (Se(n.current), Oe(n.current, {
            containingElement: ze(n.current)
          })) : (x.currentNode = n.current, E = o === "rtl" ? x.firstChild() : gi(x), E && (Se(E), Oe(E, {
            containingElement: ze(n.current)
          })));
        }
        break;
      }
      case "ArrowRight": {
        let E = o === "rtl" ? x.previousNode() : x.nextNode();
        if (l === "child" && E === n.current && (E = null), $.preventDefault(), $.stopPropagation(), E)
          Se(E), Oe(E, {
            containingElement: ze(n.current)
          });
        else {
          if (d.getKeyRightOf?.(r.key) !== r.key) {
            n.current.parentElement?.dispatchEvent(new KeyboardEvent($.nativeEvent.type, $.nativeEvent));
            break;
          }
          l === "cell" && o === "ltr" ? (Se(n.current), Oe(n.current, {
            containingElement: ze(n.current)
          })) : (x.currentNode = n.current, E = o === "rtl" ? gi(x) : x.firstChild(), E && (Se(E), Oe(E, {
            containingElement: ze(n.current)
          })));
        }
        break;
      }
      case "ArrowUp":
      case "ArrowDown":
        !$.altKey && ae(n.current, W($)) && ($.stopPropagation(), $.preventDefault(), n.current.parentElement?.dispatchEvent(new KeyboardEvent($.nativeEvent.type, $.nativeEvent)));
        break;
    }
  }, p = ($) => {
    if (c.current = r.key, W($) !== n.current) {
      Vt() || t.selectionManager.setFocusedKey(r.key);
      return;
    }
    requestAnimationFrame(() => {
      l === "child" && se() === n.current && f();
    });
  }, y = z(h, {
    role: "gridcell",
    onKeyDownCapture: b,
    "aria-colspan": r.colSpan,
    "aria-colindex": r.colIndex != null ? r.colIndex + 1 : void 0,
    colSpan: a ? void 0 : r.colSpan,
    onFocus: p
  });
  return a && (y["aria-colindex"] = (r.colIndex ?? r.index) + 1), i && y.tabIndex != null && y.onPointerDown == null && (y.onPointerDown = ($) => {
    let v = $.currentTarget, x = v.getAttribute("tabindex");
    v.removeAttribute("tabindex"), requestAnimationFrame(() => {
      x != null && v.setAttribute("tabindex", x);
    });
  }), {
    gridCellProps: y,
    isPressed: m
  };
}
function gi(e) {
  let t = null, n = null;
  do
    n = e.lastChild(), n && (t = n);
  while (n);
  return t;
}
function l8(e) {
  return e && e.__esModule ? e.default : e;
}
function i8(e, t, n) {
  let { node: r } = e, a = r.props.allowsSorting, { gridCellProps: l } = i1({
    ...e,
    focusMode: "child"
  }, t, n), i = r.props.isSelectionCell && t.selectionManager.selectionMode === "single", { pressProps: u, isPressed: o } = Je({
    isDisabled: !a || i,
    onPress() {
      t.sort(r.key);
    },
    ref: n
  }), { focusableProps: d } = ct({}, n), s, c = t.sortDescriptor?.column === r.key, f = t.sortDescriptor?.direction;
  r.props.allowsSorting && !bn() && (s = c ? f : "none");
  let h = Ee(l8(Rr), "@react-aria/table"), m;
  a && (m = `${h.format("sortable")}`, c && f && bn() && (m = `${m}, ${h.format(f)}`));
  let b = en(m), p = t.collection.size === 0;
  return ee(() => {
    p && t.selectionManager.focusedKey === r.key && t.selectionManager.setFocusedKey(null);
  }, [
    p,
    t.selectionManager,
    r.key
  ]), {
    columnHeaderProps: {
      ...z(
        d,
        l,
        u,
        b,
        // If the table is empty, make all column headers untabbable
        p ? {
          tabIndex: -1
        } : null
      ),
      role: "columnheader",
      id: C$(t, r.key),
      "aria-colspan": r.colSpan && r.colSpan > 1 ? r.colSpan : void 0,
      "aria-sort": s
    },
    isPressed: o
  };
}
function u8(e, t, n) {
  let { node: r, isVirtualized: a, shouldSelectOnPressUp: l, onAction: i } = e, { actions: u, shouldSelectOnPressUp: o } = Do.get(t), d = u.onRowAction ? () => u.onRowAction?.(r.key) : i, { itemProps: s, ...c } = kr({
    selectionManager: t.selectionManager,
    key: r.key,
    ref: n,
    isVirtualized: a,
    shouldSelectOnPressUp: o || l,
    onAction: d || r?.props?.onAction ? st(r?.props?.onAction, d) : void 0,
    isDisabled: t.collection.size === 0
  }), f = t.selectionManager.isSelected(r.key), h = {
    role: "row",
    "aria-selected": t.selectionManager.selectionMode !== "none" ? f : void 0,
    "aria-disabled": c.isDisabled || void 0,
    ...s
  };
  return a && (h["aria-rowindex"] = r.index + 1), {
    rowProps: h,
    ...c
  };
}
function o8(e) {
  return e && e.__esModule ? e.default : e;
}
const Ad = {
  expand: {
    ltr: "ArrowRight",
    rtl: "ArrowLeft"
  },
  collapse: {
    ltr: "ArrowLeft",
    rtl: "ArrowRight"
  }
};
function s8(e, t, n) {
  let { node: r, isVirtualized: a } = e, { rowProps: l, ...i } = u8(e, t, n), { direction: u } = de();
  a && t.treeColumn == null ? l["aria-rowindex"] = r.index + 1 + t.collection.headerRows.length : delete l["aria-rowindex"];
  let o = t.treeColumn != null && (t.expandedKeys === "all" || t.expandedKeys.has(r.key)), d = Ee(o8(Rr), "@react-aria/table"), s = ut({
    "aria-label": o ? d.format("collapse") : d.format("expand"),
    "aria-labelledby": lu(t, r.key)
  }), c = {}, f = {};
  if (t.treeColumn != null) {
    let b = t.collection.getItem(r.key);
    if (b != null) {
      let p = Rd(t.collection, r), y = b.props?.hasChildRows || b.props?.UNSTABLE_childItems || p?.type !== "cell", $ = t.collection.getItem(r.parentKey), v = $.type === "tablebody" || $.type === "body", x = Rd(t.collection, $);
      for (; x && x.type !== "item" && x.prevKey != null; ) x = t.collection.getItem(x.prevKey);
      c = {
        onKeyDown: (E) => {
          E.key === Ad.expand[u] && t.selectionManager.focusedKey === b.key && y && t.expandedKeys !== "all" && !t.expandedKeys.has(b.key) ? (t.toggleKey(b.key), E.stopPropagation()) : E.key === Ad.collapse[u] && t.selectionManager.focusedKey === b.key && (t.expandedKeys !== "all" ? y && t.expandedKeys.has(b.key) ? (t.toggleKey(b.key), E.stopPropagation()) : !t.expandedKeys.has(b.key) && b.parentKey != null && b.level > 0 && (t.selectionManager.setFocusedKey(b.parentKey), E.stopPropagation()) : t.expandedKeys === "all" && (t.toggleKey(b.key), E.stopPropagation()));
        },
        "aria-expanded": y ? t.expandedKeys === "all" || t.expandedKeys.has(r.key) : void 0,
        "aria-level": b.level + 1,
        "aria-posinset": b.index - (v ? 0 : t.collection.columnCount) + 1,
        "aria-setsize": x.index - (v ? 0 : t.collection.columnCount) + 1
      }, f = {
        isDisabled: i.isDisabled,
        onPress: () => {
          i.isDisabled || (t.toggleKey(r.key), t.selectionManager.setFocused(!0), t.selectionManager.setFocusedKey(r.key));
        },
        excludeFromTabOrder: !0,
        preventFocusOnPress: !0,
        // @ts-ignore
        "data-react-aria-prevent-focus": !0,
        ...s
      };
    }
  }
  let h = $u(r.props), m = i.hasAction ? h : {};
  return {
    rowProps: {
      ...z(l, c, m),
      "aria-labelledby": lu(t, r.key)
    },
    expandButtonProps: f,
    ...i
  };
}
function Rd(e, t) {
  return "lastChildKey" in t ? t.lastChildKey != null ? e.getItem(t.lastChildKey) : null : Array.from(t.childNodes).findLast((n) => n.parentKey === t.key);
}
function d8(e, t, n) {
  let { node: r, isVirtualized: a } = e, l = {
    role: "row"
  };
  return a && t.treeColumn == null && (l["aria-rowindex"] = r.index + 1), {
    rowProps: l
  };
}
function c8(e, t, n) {
  let { gridCellProps: r, isPressed: a } = i1(e, t, n), l = e.node.column?.key;
  return l != null && t.collection.rowHeaderColumnKeys.has(l) && (r.role = "rowheader", r.id = P$(t, e.node.parentKey, l)), {
    gridCellProps: r,
    isPressed: a
  };
}
function f8(e) {
  return e && e.__esModule ? e.default : e;
}
function h8(e, t) {
  let { key: n } = e;
  const { checkboxProps: r } = oE(e, t);
  return {
    checkboxProps: {
      ...r,
      "aria-labelledby": `${r.id} ${lu(t, n)}`
    }
  };
}
function m8(e) {
  let { isEmpty: t, isSelectAll: n, selectionMode: r } = e.selectionManager;
  return {
    checkboxProps: {
      "aria-label": Ee(f8(Rr), "@react-aria/table").format(r === "single" ? "select" : "selectAll"),
      isSelected: n,
      isDisabled: r !== "multiple" || e.collection.size === 0 || e.collection.rows.length === 1 && e.collection.rows[0].type === "loader",
      isIndeterminate: !t && !n,
      onChange: () => e.selectionManager.toggleSelectAll()
    }
  };
}
function b8(e) {
  return e && e.__esModule ? e.default : e;
}
function p8(e, t, n) {
  let { column: r, triggerRef: a, isDisabled: l, onResizeStart: i, onResize: u, onResizeEnd: o, "aria-label": d } = e;
  const s = Ee(b8(Rr), "@react-aria/table");
  let c = ce(), f = t.resizingColumn === r.key, h = T(f), m = T(null), b = T(!1), p = t.tableState.isKeyboardNavigationDisabled, { direction: y } = de(), $ = X((B) => {
    h.current || (m.current = t.updateResizedColumns(B.key, t.getColumnWidth(B.key)), t.startResize(B.key), t.tableState.setKeyboardNavigationDisabled(!0), i?.(m.current)), h.current = !0;
  }, [
    t,
    i
  ]), v = X((B, L) => {
    let Z = t.updateResizedColumns(B.key, L);
    u?.(Z), m.current = Z;
  }, [
    t,
    u
  ]), x = X((B) => {
    h.current && (m.current == null && (m.current = t.updateResizedColumns(B.key, t.getColumnWidth(B.key))), t.endResize(), t.tableState.setKeyboardNavigationDisabled(!1), o?.(m.current), h.current = !1, a?.current && !b.current && Se(a.current)), m.current = null;
  }, [
    t,
    a,
    o
  ]), { keyboardProps: E } = Cr({
    onKeyDown: (B) => {
      p ? (B.key === "Escape" || B.key === "Enter" || B.key === " " || B.key === "Tab") && (B.preventDefault(), x(r)) : (B.continuePropagation(), B.key === "Enter" && $(r));
    }
  });
  const P = T(0), { moveProps: C } = oa({
    onMoveStart() {
      P.current = t.getColumnWidth(r.key), $(r);
    },
    onMove(B) {
      let { deltaX: L, deltaY: Z, pointerType: ie } = B;
      y === "rtl" && (L *= -1), ie === "keyboard" && (Z !== 0 && L === 0 && (L = Z * -1), L *= 10), L !== 0 && (P.current += L, v(r, P.current));
    },
    onMoveEnd(B) {
      let { pointerType: L } = B;
      P.current = 0, (L === "mouse" || L === "touch" && b.current) && x(r);
    }
  });
  let M = X((B) => {
    p && C.onKeyDown?.(B);
  }, [
    p,
    C
  ]), F = Math.floor(t.getColumnMinWidth(r.key)), V = Math.floor(t.getColumnMaxWidth(r.key));
  V === 1 / 0 && (V = Number.MAX_SAFE_INTEGER);
  let I = Math.floor(t.getColumnWidth(r.key)), A = Dl();
  A === "virtual" && typeof window < "u" && "ontouchstart" in window && (A = "touch");
  let U = a?.current == null && (A === "keyboard" || A === "virtual") && !f ? s.format("resizerDescription") : void 0, D = en(U), N = {
    "aria-label": d,
    "aria-orientation": "horizontal",
    "aria-labelledby": `${c} ${C$(t.tableState, r.key)}`,
    "aria-valuetext": s.format("columnSize", {
      value: I
    }),
    type: "range",
    min: F,
    max: V,
    value: I,
    ...D
  };
  const w = X(() => {
    n.current && Se(n.current);
  }, [
    n
  ]);
  let R = t.resizingColumn, H = T(null), k = xe($);
  ee(() => {
    if (H.current !== R && R != null && R === r.key) {
      b.current = se() === n.current, k(r);
      let B = setTimeout(() => w(), 0), L = setTimeout(w, 400);
      return () => {
        clearTimeout(B), clearTimeout(L);
      };
    }
    H.current = R;
  }, [
    R,
    r,
    w,
    n
  ]);
  let S = (B) => {
    let L = t.getColumnWidth(r.key), Z = parseFloat(W(B).value);
    Z > L ? Z = L + 10 : Z = L - 10, v(r, Z);
  }, { pressProps: j } = Je({
    preventFocusOnPress: !0,
    onPressStart: (B) => {
      if (!(B.ctrlKey || B.altKey || B.metaKey || B.shiftKey || B.pointerType === "keyboard")) {
        if (B.pointerType === "virtual" && t.resizingColumn != null) {
          x(r);
          return;
        }
        w(), B.pointerType !== "virtual" && $(r);
      }
    },
    onPress: (B) => {
      (B.pointerType === "touch" && b.current || B.pointerType === "mouse") && t.resizingColumn != null && x(r);
    }
  }), { visuallyHiddenProps: _ } = tn();
  return {
    resizerProps: z(E, {
      ...C,
      onKeyDown: M
    }, j, {
      style: {
        touchAction: "none"
      }
    }),
    inputProps: z(_, {
      id: c,
      onBlur: () => {
        x(r);
      },
      onChange: S,
      disabled: l
    }, N),
    isResizing: f
  };
}
function g8() {
  return {
    rowGroupProps: {
      role: "rowgroup"
    }
  };
}
function u1() {
  return g8();
}
function y8(e) {
  return e && e.__esModule ? e.default : e;
}
class $8 extends jc {
  withExpandedKeys(t) {
    let n = this.clone();
    return n.expandedKeys = t, n.frozen = this.frozen, n.rows = Array.from(n.getRows()), n;
  }
  addNode(t) {
    super.addNode(t), this.columnsDirty ||= t.type === "column", t.type === "tableheader" && (this.head = t);
  }
  getRows() {
    let t = [];
    for (let n of this) (n.type === "tablebody" || n.type === "tablefooter") && t.push(...this.getChildren(n.key));
    return t;
  }
  // backward compatibility
  get body() {
    for (let t of this)
      if (t.type === "tablebody") return t;
    return new pl(-2);
  }
  commit(t, n, r = !1) {
    this.updateColumns(r), this.firstKey = t, this.lastKey = n, this.rows = [];
    for (let a of this.getRows()) {
      let l = a.lastChildKey;
      if (l != null) {
        let i = this.getItem(l);
        for (; i && i.type !== "cell"; ) i = i.prevKey != null ? this.getItem(i.prevKey) : null;
        if (i) {
          let u = (i.colIndex ?? i.index) + (i.colSpan ?? 1);
          if (u !== this.columns.length && !r) throw new Error(`Cell count must match column count. Found ${u} cells and ${this.columns.length} columns.`);
        }
      }
      this.rows.push(a);
    }
    super.commit(t, n, r);
  }
  updateColumns(t) {
    if (!this.columnsDirty) return;
    this.rowHeaderColumnKeys = /* @__PURE__ */ new Set(), this.columns = [];
    let n = /* @__PURE__ */ new Map(), r = (a) => {
      a.type === "column" && (n.set(a.key, a), a.hasChildNodes || (a.index = this.columns.length, this.columns.push(a), a.props.isRowHeader && this.rowHeaderColumnKeys.add(a.key)));
      for (let l of this.getChildren(a.key)) r(l);
    };
    for (let a of this.getChildren(this.head.key)) r(a);
    if (this.headerRows = v$(n, this.columns), this.columnsDirty = !1, this.rowHeaderColumnKeys.size === 0 && this.columns.length > 0 && !t) throw new Error("A table must have at least one Column with the isRowHeader prop set to true");
  }
  get columnCount() {
    return this.columns.length;
  }
  *[Symbol.iterator]() {
    let t = this.firstKey;
    for (; t != null; ) {
      let n = this.getItem(t);
      n && (yield n), t = n?.nextKey ?? null;
    }
  }
  getFirstKey() {
    for (let t of this)
      if (t.type === "tablebody") return t.firstChildKey ?? null;
    return null;
  }
  getLastKey() {
    let t = this.lastKey;
    if (t == null) return null;
    let n = this.getItem(t);
    for (; n?.lastChildKey != null && (n.type !== "item" || this.expandedKeys.has(n.key)); ) n = this.getItem(n.lastChildKey);
    return n?.key;
  }
  getKeyAfter(t) {
    let n = this.getItem(t);
    if (n?.type === "column") return n.nextKey ?? null;
    if (!n) return null;
    if (n.type === "item" && n.firstChildKey != null && this.expandedKeys.has(n.key)) {
      let r = this.getItem(n.firstChildKey);
      for (; r; ) {
        if (r.type === "item") return r.key;
        r = r.nextKey != null ? this.getItem(r.nextKey) : null;
      }
    }
    return super.getKeyAfter(t);
  }
  getKeyBefore(t) {
    let n = this.getItem(t);
    if (n?.type === "column") return n.prevKey ?? null;
    if (!n) return null;
    let r = null;
    if (n.prevKey != null) {
      for (n = this.getItem(n.prevKey); n && (n.type !== "item" || this.expandedKeys.has(n.key)) && n.lastChildKey != null; ) n = this.getItem(n.lastChildKey);
      r = n?.key ?? null;
    }
    return r == null && (r = n.parentKey), r != null && this.getItem(r)?.type === "tableheader" ? null : r;
  }
  getChildren(t) {
    let n = this.getItem(t);
    if (!n) {
      for (let a of this.headerRows)
        if (a.key === t) return a.childNodes;
    }
    let r = this;
    return n?.type === "tablebody" || n?.type === "tablefooter" ? {
      *[Symbol.iterator]() {
        let a = n.firstChildKey, l = a != null ? r.getItem(a) : null;
        for (; l; ) {
          yield l;
          let i = r.getKeyAfter(l.key);
          if (l = i != null ? r.getItem(i) : null, l && l.parentKey === n.parentKey) break;
        }
      }
    } : {
      *[Symbol.iterator]() {
        let a = r.getItem(t), l = a?.firstChildKey != null ? r.getItem(a.firstChildKey) : null;
        for (; l && (yield l, l = l.nextKey != null ? r.getItem(l.nextKey) : null, !(a?.type === "item" && l?.type !== "cell")); )
          ;
      }
    };
  }
  clone() {
    let t = super.clone();
    return t.headerRows = this.headerRows, t.columns = this.columns, t.rows = this.rows, t.rowHeaderColumnKeys = this.rowHeaderColumnKeys, t.head = this.head, t;
  }
  getTextValue(t) {
    let n = this.getItem(t);
    if (!n) return "";
    if (n.textValue) return n.textValue;
    let r = this.rowHeaderColumnKeys, a = [];
    for (let l of this.getChildren(t)) {
      let i = this.columns[l.index];
      if (r.has(i.key) && l.textValue && a.push(l.textValue), a.length === r.size) break;
    }
    return a.join(" ");
  }
  constructor(...t) {
    super(...t), this.headerRows = [], this.columns = [], this.rows = [], this.rowHeaderColumnKeys = /* @__PURE__ */ new Set(), this.head = new bl(-1), this.columnsDirty = !0, this.expandedKeys = /* @__PURE__ */ new Set();
  }
}
const Eo = /* @__PURE__ */ G(null), UC = /* @__PURE__ */ te(function(t, n) {
  let r = $e(n), a = T(null), l = T(null), [i, u] = Y(0);
  ue(() => {
    let d = a.current;
    for (; d && d !== r.current && !yn(d); ) d = d.parentElement;
    l.current = d;
  }, [
    r
  ]), yr({
    ref: l,
    box: "border-box",
    onResize() {
      u(l.current?.clientWidth ?? 0);
    }
  }), ue(() => {
    u(l.current?.clientWidth ?? 0);
  }, []);
  let o = K(() => ({
    tableRef: a,
    scrollRef: l,
    tableWidth: i,
    useTableColumnResizeState: YE,
    onResizeStart: t.onResizeStart,
    onResize: t.onResize,
    onResizeEnd: t.onResizeEnd
  }), [
    a,
    i,
    t.onResizeStart,
    t.onResize,
    t.onResizeEnd
  ]);
  return /* @__PURE__ */ g.createElement(Q.div, {
    render: t.render,
    ...J(t, {
      global: !0
    }),
    ref: r,
    className: t.className || "react-aria-ResizableTableContainer",
    style: t.style,
    onScroll: t.onScroll
  }, /* @__PURE__ */ g.createElement(Eo.Provider, {
    value: o
  }, t.children));
}), v8 = /* @__PURE__ */ G(null), Ht = /* @__PURE__ */ G(null), Co = /* @__PURE__ */ G(null), jC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, v8);
  let r = Da(t), { selectionBehavior: a, selectionMode: l, disallowEmptySelection: i } = r, u = !!t.dragAndDropHooks?.useDraggableCollectionState, o = K(() => ({
    selectionBehavior: l === "none" ? null : a,
    selectionMode: l,
    disallowEmptySelection: i,
    allowsDragging: u
  }), [
    a,
    l,
    i,
    u
  ]), d = /* @__PURE__ */ g.createElement(o1.Provider, {
    value: o
  }, /* @__PURE__ */ g.createElement(Jt, t));
  return /* @__PURE__ */ g.createElement(jn, {
    content: d,
    createCollection: () => new $8()
  }, (s) => /* @__PURE__ */ g.createElement(x8, {
    props: t,
    forwardedRef: n,
    selectionState: r,
    collection: s
  }));
});
let D8 = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.table, {
    ...t,
    ref: n
  });
});
const Td = {
  expand: {
    ltr: "ArrowRight",
    rtl: "ArrowLeft"
  },
  collapse: {
    ltr: "ArrowLeft",
    rtl: "ArrowRight"
  }
};
function x8({ props: e, forwardedRef: t, selectionState: n, collection: r }) {
  [e, t] = oe(e, t, Vn);
  let { shouldUseVirtualFocus: a, disallowTypeAhead: l, filter: i, ...u } = e, o = O(Eo);
  t = $e(K(() => Pt(t, o?.tableRef), [
    t,
    o?.tableRef
  ]));
  let [d, s] = we(e.expandedKeys ? new Set(e.expandedKeys) : void 0, e.defaultExpandedKeys ? new Set(e.defaultExpandedKeys) : /* @__PURE__ */ new Set(), e.onExpandedChange);
  r = K(() => r.withExpandedKeys(d), [
    r,
    d
  ]);
  let c = JE({
    ...u,
    collection: r,
    children: void 0,
    UNSAFE_selectionState: n,
    expandedKeys: d,
    onExpandedChange: s
  }), f = QE(c, i), { isVirtualized: h, layoutDelegate: m, dropTargetDelegate: b, CollectionRoot: p } = O(ge), { dragAndDropHooks: y } = e, { gridProps: $ } = a8({
    ...u,
    layoutDelegate: m,
    isVirtualized: h
  }, f, t), v = f.selectionManager, x = !!y?.useDraggableCollectionState, E = !!y?.useDroppableCollectionState, P = T(x), C = T(E);
  ee(() => {
    process.env.NODE_ENV !== "production" && (P.current !== x && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), C.current !== E && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."));
  }, [
    x,
    E
  ]);
  let M, F, V, I = !1, A = null, U = T(null), { direction: D } = de(), [N] = Y(() => new OE());
  if (x && y) {
    M = y.useDraggableCollectionState({
      collection: f.collection,
      selectionManager: v,
      preview: y.renderDragPreview ? U : void 0
    }), y.useDraggableCollection({}, M, t);
    let L = y.DragPreview;
    A = y.renderDragPreview ? /* @__PURE__ */ g.createElement(L, {
      ref: U
    }, y.renderDragPreview) : null;
  }
  if (E && y) {
    F = y.useDroppableCollectionState({
      collection: f.collection,
      selectionManager: v
    });
    let L = new va({
      collection: f.collection,
      disabledKeys: v.disabledKeys,
      disabledBehavior: v.disabledBehavior,
      ref: t,
      layoutDelegate: m
    }), Z = y.dropTargetDelegate || b || new y.ListDropTargetDelegate(r.rows, t);
    N.setup(Z, c, D), V = y.useDroppableCollection({
      keyboardDelegate: L,
      dropTargetDelegate: N,
      onDropActivate: (ie) => {
        if (ie.target.type === "item") {
          let q = ie.target.key, re = c.collection.getItem(q), fe = d.has(q);
          re && re.hasChildNodes && (!fe || y?.isVirtualDragging?.()) && c.toggleKey(q);
        }
      },
      onKeyDown: (ie) => {
        let q = F?.target;
        if (q && q.type === "item" && q.dropPosition === "on") {
          let re = c.collection.getItem(q.key);
          (ie.key === Td.expand[D] && re?.hasChildNodes && !c.expandedKeys.has(q.key) || ie.key === Td.collapse[D] && re?.hasChildNodes && c.expandedKeys.has(q.key)) && c.toggleKey(q.key);
        }
      }
    }, F, t), I = F.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: w, isFocused: R, isFocusVisible: H } = ye(), k = le({
    ...e,
    children: void 0,
    defaultClassName: "react-aria-Table",
    values: {
      isDropTarget: I,
      isFocused: R,
      isFocusVisible: H,
      state: f
    }
  }), S = !!(x && !M?.isDisabled), j = k.style, _ = null;
  o && (_ = o.useTableColumnResizeState({
    tableWidth: o.tableWidth
  }, f), h || (j = {
    ...j,
    tableLayout: "fixed",
    // due to https://bugzilla.mozilla.org/show_bug.cgi?id=1959353, we can't use "fit-content".
    // Causes the table columns to grow to fill the available space in Firefox, ignoring user set column widths
    width: "min-content"
  }));
  let B = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Ht,
        f
      ],
      [
        Co,
        _
      ],
      [
        zt,
        {
          dragAndDropHooks: y,
          dragState: M,
          dropState: F
        }
      ],
      [
        Qu,
        {
          render: k8
        }
      ],
      [
        Vn,
        null
      ],
      [
        fa,
        null
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Bl, null, /* @__PURE__ */ g.createElement(D8, {
    ...z(B, k, $, w, V?.collectionProps),
    style: j,
    ref: t,
    slot: e.slot || void 0,
    onScroll: e.onScroll,
    "data-allows-dragging": S || void 0,
    "data-drop-target": I || void 0,
    "data-focused": R || void 0,
    "data-focus-visible": H || void 0
  }, /* @__PURE__ */ g.createElement(Wn, null, /* @__PURE__ */ g.createElement(p, {
    collection: f.collection,
    scrollRef: o?.scrollRef ?? t,
    persistedKeys: Tb(v, y, F)
  })))), A);
}
const o1 = /* @__PURE__ */ G(null);
function _C() {
  return O(o1);
}
const Mo = class Mo extends dt {
};
Mo.type = "tableheader";
let bl = Mo, E8 = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.thead, {
    ...t,
    ref: n
  });
});
const WC = /* @__PURE__ */ ha(bl, (e, t) => {
  let n = O(Ht).collection, r = Du({
    items: n.headerRows,
    children: X((o) => {
      if (o.type === "headerrow")
        return /* @__PURE__ */ g.createElement(P8, {
          item: o
        });
      throw new Error("Unsupported node type in TableHeader: " + o.type);
    }, [])
  }), { rowGroupProps: a } = u1(), { hoverProps: l, isHovered: i } = De({
    onHoverStart: e.onHoverStart,
    onHoverChange: e.onHoverChange,
    onHoverEnd: e.onHoverEnd
  }), u = le({
    ...e,
    children: void 0,
    defaultClassName: "react-aria-TableHeader",
    values: {
      isHovered: i
    }
  });
  return /* @__PURE__ */ g.createElement(E8, {
    ...z(J(e, {
      global: !0
    }), a, l),
    ...u,
    ref: t,
    "data-hovered": i || void 0
  }, r);
}, (e) => /* @__PURE__ */ g.createElement(Jt, {
  dependencies: e.dependencies,
  items: e.columns
}, e.children));
let C8 = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement("div", {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement("tr", {
    ...t,
    ref: n
  });
});
function P8({ item: e }) {
  let t = T(null), n = O(Ht), { isVirtualized: r, CollectionBranch: a } = O(ge), { rowProps: l } = d8({
    node: e,
    isVirtualized: r
  }, n, t), { checkboxProps: i } = m8(n);
  return /* @__PURE__ */ g.createElement(C8, {
    ...l,
    ref: t
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        ju,
        {
          slots: {
            selection: i
          }
        }
      ],
      [
        ih,
        {
          slots: {
            selection: i
          }
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(a, {
    collection: n.collection,
    parent: e
  })));
}
const Ko = class Ko extends dt {
};
Ko.type = "column";
let iu = Ko, w8 = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.th, {
    ...t,
    ref: n
  });
});
const GC = /* @__PURE__ */ St(iu, (e, t, n) => {
  let r = $e(t), a = O(Ht), { isVirtualized: l } = O(ge), { columnHeaderProps: i, isPressed: u } = i8({
    node: n,
    isVirtualized: l
  }, a, r), { isFocused: o, isFocusVisible: d, focusProps: s } = ye(), c = O(Co), f = !1;
  if (c) f = c.resizingColumn === n.key;
  else if (process.env.NODE_ENV !== "production")
    for (let $ in [
      "width",
      "defaultWidth",
      "minWidth",
      "maxWidth"
    ]) $ in n.props && console.warn(`The ${$} prop on a <Column> only applies when a <Table> is wrapped in a <ResizableTableContainer>. If you aren't using column resizing, you can set the width of a column with CSS.`);
  let { hoverProps: h, isHovered: m } = De({
    isDisabled: !e.allowsSorting
  }), b = le({
    ...e,
    id: void 0,
    children: n.rendered,
    defaultClassName: "react-aria-Column",
    values: {
      isHovered: m,
      isPressed: u,
      isFocused: o,
      isFocusVisible: d,
      allowsSorting: n.props.allowsSorting,
      sortDirection: a.sortDescriptor?.column === n.key ? a.sortDescriptor.direction : void 0,
      isResizing: f,
      startResize: () => {
        if (c)
          c.startResize(n.key), a.setKeyboardNavigationDisabled(!0);
        else throw new Error("Wrap your <Table> in a <ResizableTableContainer> to enable column resizing");
      },
      sort: ($) => {
        a.sort(n.key, $);
      }
    }
  }), p = b.style;
  c && (p = {
    ...p,
    width: c.getColumnWidth(n.key)
  });
  let y = J(e, {
    global: !0
  });
  return delete y.id, /* @__PURE__ */ g.createElement(w8, {
    ...z(y, i, s, h),
    ...b,
    style: p,
    ref: r,
    "data-hovered": m || void 0,
    "data-pressed": u || void 0,
    "data-focused": o || void 0,
    "data-focus-visible": d || void 0,
    "data-resizing": f || void 0,
    "data-allows-sorting": n.props.allowsSorting || void 0,
    "data-sort-direction": a.sortDescriptor?.column === n.key ? a.sortDescriptor.direction : void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        s1,
        {
          column: n,
          triggerRef: r
        }
      ],
      [
        ge,
        ma
      ]
    ]
  }, b.children));
}), s1 = /* @__PURE__ */ G(null), qC = /* @__PURE__ */ te(function(t, n) {
  let r = O(Co);
  if (!r) throw new Error("Wrap your <Table> in a <ResizableTableContainer> to enable column resizing");
  let a = Ee(y8(Ju), "react-aria-components"), { onResizeStart: l, onResize: i, onResizeEnd: u } = O(Eo), { column: o, triggerRef: d } = O(s1), s = T(null), { resizerProps: c, inputProps: f, isResizing: h } = p8({
    column: o,
    "aria-label": t["aria-label"] || a.format("tableResizer"),
    onResizeStart: l,
    onResize: i,
    onResizeEnd: u,
    triggerRef: d
  }, r, s), { focusProps: m, isFocused: b, isFocusVisible: p } = ye(), { hoverProps: y, isHovered: $ } = De(t), v = r.getColumnMinWidth(o.key) >= r.getColumnWidth(o.key), x = r.getColumnMaxWidth(o.key) <= r.getColumnWidth(o.key), { direction: E } = de(), P = "both";
  v ? P = E === "rtl" ? "right" : "left" : x ? P = E === "rtl" ? "left" : "right" : P = "both";
  let C = $e(n), [M, F] = Y("");
  ee(() => {
    if (!C.current) return;
    let N = window.getComputedStyle(C.current);
    F(N.cursor);
  }, [
    C,
    P
  ]);
  let V = le({
    ...t,
    defaultClassName: "react-aria-ColumnResizer",
    values: {
      isFocused: b,
      isFocusVisible: p,
      isResizing: h,
      isHovered: $,
      resizableDirection: P
    }
  }), [I, A] = Y(!1), U = (N) => {
    N.pointerType === "mouse" && A(!0);
  };
  !h && I && A(!1);
  let D = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ref: C,
    role: "presentation",
    ...z(D, V, c, {
      onPointerDown: U
    }, y),
    "data-hovered": $ || void 0,
    "data-focused": b || void 0,
    "data-focus-visible": p || void 0,
    "data-resizing": h || void 0,
    "data-resizable-direction": P
  }, V.children, /* @__PURE__ */ g.createElement("input", {
    ref: s,
    ...z(f, m)
  }), h && I && /* @__PURE__ */ fu.createPortal(/* @__PURE__ */ g.createElement("div", {
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      cursor: M
    }
  }), document.body));
}), No = class No extends xl {
};
No.type = "tablebody";
let pl = No, S8 = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.tbody, {
    ...t,
    ref: n
  });
});
const YC = /* @__PURE__ */ ha(pl, (e, t, n) => {
  let r = O(Ht), { isVirtualized: a } = O(ge), l = r.collection, { CollectionBranch: i } = O(ge), { dragAndDropHooks: u, dropState: o } = O(zt), d = !!u?.useDroppableCollectionState && !o?.isDisabled, s = d && !!o && (o.isDropTarget({
    type: "root"
  }) ?? !1), c = l.size === 0, f = {
    isDropTarget: s,
    isEmpty: c
  }, h = le({
    ...e,
    id: void 0,
    children: void 0,
    defaultClassName: "react-aria-TableBody",
    values: f
  }), m, b = l.columnCount;
  if (c && e.renderEmptyState && r) {
    let $ = {}, v = {}, x = {};
    a ? (v["aria-colspan"] = b, x = {
      display: "contents"
    }) : v.colSpan = b, m = /* @__PURE__ */ g.createElement(vr, {
      role: "row",
      ...$,
      style: x
    }, /* @__PURE__ */ g.createElement(Dr, {
      role: "rowheader",
      ...v,
      style: x
    }, e.renderEmptyState(f)));
  }
  let { rowGroupProps: p } = u1(), y = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(S8, {
    ...z(y, h, p),
    ref: t,
    "data-empty": c || void 0
  }, d && /* @__PURE__ */ g.createElement(T8, null), /* @__PURE__ */ g.createElement(i, {
    collection: l,
    parent: n,
    renderDropIndicator: eo(u, o)
  }), m);
}), Vo = class Vo extends xl {
};
Vo.type = "tablefooter";
let Id = Vo;
const d1 = /* @__PURE__ */ G({
  isFocusVisibleWithinRow: !1
}), Lo = class Lo extends dt {
  filter(t, n, r) {
    let a = t.getChildren(this.key);
    for (let l of a) if (r(l.textValue, l)) {
      let i = this.clone();
      return n.addDescendants(i, t), i;
    }
    return null;
  }
};
Lo.type = "item";
let uu = Lo, vr = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.tr, {
    ...t,
    ref: n
  });
});
const ZC = /* @__PURE__ */ ha(uu, (e, t, n) => {
  let r = $e(t), a = O(Ht), { dragAndDropHooks: l, dragState: i, dropState: u } = O(zt), { isVirtualized: o, CollectionBranch: d } = O(ge), s = i && !(i.isDisabled || i.selectionManager.isDisabled(n.key)), { rowProps: c, expandButtonProps: f, ...h } = s8({
    node: n,
    shouldSelectOnPressUp: !!i,
    isVirtualized: o
  }, a, r), { isFocused: m, isFocusVisible: b, focusProps: p } = ye(), { isFocusVisible: y, focusProps: $ } = ye({
    within: !0
  }), { hoverProps: v, isHovered: x } = De({
    // because of https://bugs.webkit.org/show_bug.cgi?id=214609, supporting hover styles when a item is ONLY isDraggable
    // results in hover styles sticking around after a reorder/drop operation...
    isDisabled: !h.allowsSelection && !h.hasAction && !s,
    onHoverStart: e.onHoverStart,
    onHoverChange: e.onHoverChange,
    onHoverEnd: e.onHoverEnd
  }), { checkboxProps: E } = h8({
    key: n.key
  }, a), P;
  i && l && (P = l.useDraggableItem({
    key: n.key,
    hasDragButton: !0
  }, i));
  let C, M = T(null), { visuallyHiddenProps: F } = tn();
  u && l && (C = l.useDropIndicator({
    target: {
      type: "item",
      key: n.key,
      dropPosition: "on"
    }
  }, u, M));
  let V = T(null);
  ee(() => {
    i && !V.current && process.env.NODE_ENV !== "production" && console.warn('Draggable items in a Table must contain a <Button slot="drag"> element so that keyboard and screen reader users can drag them.');
  }, []);
  let I = i && i.isDragging(n.key), { children: A, ...U } = e, D = e.hasChildItems || a.collection.getItem(n.lastChildKey)?.type !== "cell", N = D && a.expandedKeys.has(n.key), w = le({
    ...U,
    id: void 0,
    defaultClassName: "react-aria-Row",
    defaultStyle: {
      // @ts-ignore
      "--table-row-level": n.level + 1
    },
    values: {
      ...h,
      state: a,
      isHovered: x,
      isFocused: m,
      isFocusVisible: b,
      selectionMode: a.selectionManager.selectionMode,
      selectionBehavior: a.selectionManager.selectionBehavior,
      isDragging: I,
      isDropTarget: C?.isDropTarget,
      isFocusVisibleWithin: y,
      id: n.key,
      hasChildItems: D,
      isExpanded: N,
      level: n.level + 1
    }
  }), R = J(e, {
    global: !0
  });
  return delete R.id, delete R.onClick, /* @__PURE__ */ g.createElement(g.Fragment, null, C && !C.isHidden && /* @__PURE__ */ g.createElement(vr, {
    role: "row",
    style: {
      height: 0
    }
  }, /* @__PURE__ */ g.createElement(Dr, {
    role: "gridcell",
    colSpan: a.collection.columnCount,
    style: {
      padding: 0
    }
  }, /* @__PURE__ */ g.createElement("div", {
    role: "button",
    ...F,
    ...C.dropIndicatorProps,
    ref: M
  }))), /* @__PURE__ */ g.createElement(vr, {
    ...z(R, w, c, p, v, P?.dragProps, $),
    ref: r,
    "data-disabled": h.isDisabled || void 0,
    "data-selected": h.isSelected || void 0,
    "data-hovered": x || void 0,
    "data-focused": h.isFocused || void 0,
    "data-focus-visible": b || void 0,
    "data-pressed": h.isPressed || void 0,
    "data-dragging": I || void 0,
    "data-drop-target": C?.isDropTarget || void 0,
    "data-selection-mode": a.selectionManager.selectionMode === "none" ? void 0 : a.selectionManager.selectionMode,
    "data-focus-visible-within": y || void 0,
    "data-expanded": N || void 0,
    "data-has-child-items": D || void 0,
    "data-level": n.level + 1
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        ju,
        {
          slots: {
            [$t]: {},
            selection: E
          }
        }
      ],
      [
        ih,
        {
          slots: {
            [$t]: {},
            selection: E
          }
        }
      ],
      [
        Xe,
        {
          slots: {
            [$t]: {},
            chevron: f,
            drag: {
              ...P?.dragButtonProps,
              ref: V,
              style: {
                pointerEvents: "none"
              }
            }
          }
        }
      ],
      [
        Gn,
        {
          isSelected: h.isSelected
        }
      ],
      [
        d1,
        {
          isFocusVisibleWithinRow: y
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(d, {
    collection: a.collection,
    parent: n
  }))));
}, (e) => {
  if (e.id == null && typeof e.children == "function") throw new Error("No id detected for the Row element. The Row element requires a id to be provided to it when the cells are rendered dynamically.");
  let t = [
    e.value
  ].concat(e.dependencies);
  return /* @__PURE__ */ g.createElement(Jt, {
    dependencies: t,
    items: e.columns,
    idScope: e.id
  }, e.children);
}), zo = class zo extends dt {
};
zo.type = "cell";
let ou = zo, Dr = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.td, {
    ...t,
    ref: n
  });
});
const XC = /* @__PURE__ */ St(ou, (e, t, n) => {
  let r = $e(t), a = O(Ht), { dragState: l } = O(zt), { isVirtualized: i } = O(ge);
  n.column = a.collection.columns[n.index];
  let { gridCellProps: u, isPressed: o } = c8({
    node: n,
    shouldSelectOnPressUp: !!l,
    isVirtualized: i
  }, a, r), { isFocused: d, isFocusVisible: s, focusProps: c } = ye(), { hoverProps: f, isHovered: h } = De({}), { isFocusVisibleWithinRow: m } = O(d1), b = n.parentKey != null ? a.selectionManager.isSelected(n.parentKey) : !1, p = n.colIndex || n.index, y = a.collection.getItem(n.parentKey), $ = y.props.hasChildItems || a.collection.getItem(y.lastChildKey)?.type !== "cell", v = $ && a.expandedKeys.has(n.parentKey), x = a.selectionManager.isDisabled(n.parentKey), E = le({
    ...e,
    id: void 0,
    defaultClassName: "react-aria-Cell",
    values: {
      isFocused: d,
      isFocusVisible: s,
      isFocusVisibleWithinRow: m,
      isPressed: o,
      isHovered: h,
      isSelected: b,
      id: n.key,
      columnIndex: p,
      hasChildItems: $,
      isExpanded: v,
      isDisabled: x,
      level: y.level + 1,
      isTreeColumn: n.column.key === a.treeColumn
    }
  }), P = J(e, {
    global: !0
  });
  return delete P.id, /* @__PURE__ */ g.createElement(Dr, {
    ...z(P, E, u, c, f),
    ref: r,
    "data-focused": d || void 0,
    "data-focus-visible": s || void 0,
    "data-focus-visible-within-row": m || void 0,
    "data-pressed": o || void 0,
    "data-selected": b || void 0,
    "data-column-index": p,
    "data-expanded": v || void 0,
    "data-has-child-items": $ || void 0,
    "data-level": y.level + 1,
    "data-tree-column": n.column.key === a.treeColumn || void 0,
    "data-disabled": x || void 0
  }, /* @__PURE__ */ g.createElement(ge.Provider, {
    value: ma
  }, E.children));
});
function k8(e, t) {
  t = $e(t);
  let { dragAndDropHooks: n, dropState: r } = O(zt), a = T(null), { dropIndicatorProps: l, isHidden: i, isDropTarget: u } = n.useDropIndicator(e, r, a);
  if (i) return null;
  let o = r && e.target.type === "item" ? (r.collection.getItem(e.target.key)?.level || 0) + 1 : 1;
  return /* @__PURE__ */ g.createElement(R8, {
    ...e,
    dropIndicatorProps: l,
    isDropTarget: u,
    buttonRef: a,
    level: o,
    ref: t
  });
}
let B8 = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.tr, {
    ...t,
    ref: n
  });
}), F8 = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.td, {
    ...t,
    ref: n
  });
});
function A8(e, t) {
  let { dropIndicatorProps: n, isDropTarget: r, buttonRef: a, level: l, ...i } = e, u = O(Ht), { visuallyHiddenProps: o } = tn(), d = le({
    ...i,
    defaultClassName: "react-aria-DropIndicator",
    defaultStyle: {
      // @ts-ignore
      "--table-row-level": l + 1
    },
    values: {
      isDropTarget: r
    }
  });
  return /* @__PURE__ */ g.createElement(B8, {
    ...J(e, {
      global: !0
    }),
    ...d,
    role: "row",
    ref: t,
    "data-drop-target": r || void 0,
    "aria-level": l
  }, /* @__PURE__ */ g.createElement(F8, {
    role: "gridcell",
    colSpan: u.collection.columnCount,
    style: {
      padding: 0
    }
  }, /* @__PURE__ */ g.createElement("div", {
    ...o,
    role: "button",
    ...n,
    ref: a
  }), d.children));
}
const R8 = /* @__PURE__ */ te(A8);
function T8() {
  let e = O(Ht), { dragAndDropHooks: t, dropState: n } = O(zt), r = T(null), { dropIndicatorProps: a } = t.useDropIndicator({
    target: {
      type: "root"
    }
  }, n, r), l = n.isDropTarget({
    type: "root"
  }), { visuallyHiddenProps: i } = tn();
  return !l && a["aria-hidden"] ? null : /* @__PURE__ */ g.createElement(vr, {
    role: "row",
    "aria-hidden": a["aria-hidden"],
    style: {
      height: 0
    }
  }, /* @__PURE__ */ g.createElement(Dr, {
    role: "gridcell",
    colSpan: e.collection.columnCount,
    style: {
      padding: 0
    }
  }, /* @__PURE__ */ g.createElement("div", {
    role: "button",
    ...i,
    ...a,
    ref: r
  })));
}
St(Xa, function(t, n, r) {
  let a = O(Ht), { isVirtualized: l } = O(ge), { isLoading: i, onLoadMore: u, scrollOffset: o, ...d } = t, s = a.collection.columns.length, c = T(null), f = K(() => ({
    onLoadMore: u,
    collection: a?.collection,
    sentinelRef: c,
    scrollOffset: o
  }), [
    u,
    o,
    a?.collection
  ]);
  jb(f, c);
  let h = le({
    ...d,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-TableLoadingIndicator",
    defaultStyle: {
      // @ts-ignore
      "--table-row-level": r.level + 1
    },
    values: void 0
  }), m = {}, b = {}, p = {};
  return l ? (b["aria-colspan"] = s, p = {
    display: "contents"
  }) : b.colSpan = s, /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(vr, {
    style: {
      height: 0
    },
    inert: fl(!0)
  }, /* @__PURE__ */ g.createElement(Dr, {
    style: {
      padding: 0,
      border: 0
    }
  }, /* @__PURE__ */ g.createElement("div", {
    "data-testid": "loadMoreSentinel",
    ref: c,
    style: {
      position: "relative",
      height: 1,
      width: 1
    }
  }))), i && h.children && /* @__PURE__ */ g.createElement(vr, {
    ...z(J(t, {
      global: !0
    }), m),
    ...h,
    role: "row",
    ref: n,
    "aria-level": r.level + 1,
    "data-level": r.level + 1
  }, /* @__PURE__ */ g.createElement(Dr, {
    role: "rowheader",
    ...b,
    style: p
  }, h.children)));
});
class gt {
  constructor(t = 0, n = 0) {
    this.x = t, this.y = n;
  }
  /**
  * Returns a copy of this point.
  */
  copy() {
    return new gt(this.x, this.y);
  }
  /**
  * Checks if two points are equal.
  */
  equals(t) {
    return this.x === t.x && this.y === t.y;
  }
  /**
  * Returns true if this point is the origin.
  */
  isOrigin() {
    return this.x === 0 && this.y === 0;
  }
}
class pe {
  constructor(t = 0, n = 0, r = 0, a = 0) {
    this.x = t, this.y = n, this.width = r, this.height = a;
  }
  /**
  * The maximum x-coordinate in the rectangle.
  */
  get maxX() {
    return this.x + this.width;
  }
  /**
  * The maximum y-coordinate in the rectangle.
  */
  get maxY() {
    return this.y + this.height;
  }
  /**
  * The area of the rectangle.
  */
  get area() {
    return this.width * this.height;
  }
  /**
  * The top left corner of the rectangle.
  */
  get topLeft() {
    return new gt(this.x, this.y);
  }
  /**
  * The top right corner of the rectangle.
  */
  get topRight() {
    return new gt(this.maxX, this.y);
  }
  /**
  * The bottom left corner of the rectangle.
  */
  get bottomLeft() {
    return new gt(this.x, this.maxY);
  }
  /**
  * The bottom right corner of the rectangle.
  */
  get bottomRight() {
    return new gt(this.maxX, this.maxY);
  }
  /**
  * Returns whether this rectangle intersects another rectangle.
  *
  * @param rect - The rectangle to check.
  */
  intersects(t) {
    return (process.env.NODE_ENV === "test" && !process.env.VIRT_ON || this.area > 0 && t.area > 0) && this.x <= t.x + t.width && t.x <= this.x + this.width && this.y <= t.y + t.height && t.y <= this.y + this.height;
  }
  /**
  * Returns whether this rectangle fully contains another rectangle.
  *
  * @param rect - The rectangle to check.
  */
  containsRect(t) {
    return this.x <= t.x && this.y <= t.y && this.maxX >= t.maxX && this.maxY >= t.maxY;
  }
  /**
  * Returns whether the rectangle contains the given point.
  *
  * @param point - The point to check.
  */
  containsPoint(t) {
    return this.x <= t.x && this.y <= t.y && this.maxX >= t.x && this.maxY >= t.y;
  }
  /**
  * Returns the first corner of this rectangle (from top to bottom, left to right)
  * that is contained in the given rectangle, or null of the rectangles do not intersect.
  *
  * @param rect - The rectangle to check.
  */
  getCornerInRect(t) {
    for (let n of [
      "topLeft",
      "topRight",
      "bottomLeft",
      "bottomRight"
    ])
      if (t.containsPoint(this[n])) return n;
    return null;
  }
  equals(t) {
    return t.x === this.x && t.y === this.y && t.width === this.width && t.height === this.height;
  }
  pointEquals(t) {
    return this.x === t.x && this.y === t.y;
  }
  sizeEquals(t) {
    return this.width === t.width && this.height === t.height;
  }
  /**
  * Returns the union of this Rect and another.
  */
  union(t) {
    let n = Math.min(this.x, t.x), r = Math.min(this.y, t.y), a = Math.max(this.maxX, t.maxX) - n, l = Math.max(this.maxY, t.maxY) - r;
    return new pe(n, r, a, l);
  }
  /**
  * Returns the intersection of this Rect with another.
  * If the rectangles do not intersect, an all zero Rect is returned.
  */
  intersection(t) {
    if (!this.intersects(t)) return new pe(0, 0, 0, 0);
    let n = Math.max(this.x, t.x), r = Math.max(this.y, t.y);
    return new pe(n, r, Math.min(this.maxX, t.maxX) - n, Math.min(this.maxY, t.maxY) - r);
  }
  /**
  * Returns a copy of this rectangle.
  */
  copy() {
    return new pe(this.x, this.y, this.width, this.height);
  }
}
class je {
  constructor(t = 0, n = 0) {
    this.width = Math.max(t, 0), this.height = Math.max(n, 0);
  }
  /**
  * Returns a copy of this size.
  */
  copy() {
    return new je(this.width, this.height);
  }
  /**
  * Returns whether this size is equal to another one.
  */
  equals(t) {
    return this.width === t.width && this.height === t.height;
  }
  /**
  * The total area of the Size.
  */
  get area() {
    return this.width * this.height;
  }
}
let I8 = 0;
class c1 {
  constructor(t, n) {
    this.virtualizer = t, this.key = ++I8, this.viewType = n, this.children = /* @__PURE__ */ new Set(), this.reusableViews = /* @__PURE__ */ new Map(), this.layoutInfo = null, this.content = null, this.rendered = null;
  }
  /**
  * Prepares the view for reuse. Called just before the view is removed from the DOM.
  */
  prepareForReuse() {
    this.content = null, this.rendered = null, this.layoutInfo = null;
  }
  getReusableView(t) {
    let n = this.reusableViews.get(t);
    return n && n.length > 0 ? n.shift() : new K8(this.virtualizer, this, t);
  }
  reuseChild(t) {
    t.prepareForReuse();
    let n = this.reusableViews.get(t.viewType);
    n || (n = [], this.reusableViews.set(t.viewType, n)), n.push(t);
  }
}
class M8 extends c1 {
  constructor(t) {
    super(t, "root");
  }
}
class K8 extends c1 {
  constructor(t, n, r) {
    super(t, r), this.parent = n;
  }
}
function N8(e, t) {
  if (e === t) return !0;
  if (e.size !== t.size) return !1;
  for (let n of e)
    if (!t.has(n)) return !1;
  return !0;
}
class V8 {
  setVisibleRect(t) {
    let n = performance.now() - this.startTime;
    n < 500 && (t.x !== this.visibleRect.x && n > 0 && (this.velocity.x = (t.x - this.visibleRect.x) / n), t.y !== this.visibleRect.y && n > 0 && (this.velocity.y = (t.y - this.visibleRect.y) / n)), this.startTime = performance.now(), this.visibleRect = t;
  }
  getOverscannedRect() {
    let t = this.visibleRect.copy(), n = this.visibleRect.height / 3;
    t.height += n, this.velocity.y < 0 && (t.y -= n);
    let r = this.visibleRect.width / 3;
    return t.width += r, this.velocity.x < 0 && (t.x -= r), t;
  }
  constructor() {
    this.startTime = 0, this.velocity = new gt(0, 0), this.visibleRect = new pe();
  }
}
class L8 {
  constructor(t) {
    this.delegate = t.delegate, this.collection = t.collection, this.layout = t.layout, this.contentSize = new je(), this.visibleRect = new pe(), this.size = new je(), this.persistedKeys = /* @__PURE__ */ new Set(), this._visibleViews = /* @__PURE__ */ new Map(), this._renderedContent = /* @__PURE__ */ new WeakMap(), this._rootView = new M8(this), this._isScrolling = !1, this._invalidationContext = {}, this._overscanManager = new V8();
  }
  /** Returns whether the given key, or an ancestor, is persisted. */
  isPersistedKey(t) {
    if (this.persistedKeys.has(t)) return !0;
    for (let n of this.persistedKeys) for (; n != null; ) {
      let r = this.layout.getLayoutInfo(n);
      if (!r || r.parentKey == null) break;
      if (n = r.parentKey, n === t) return !0;
    }
    return !1;
  }
  getParentView(t) {
    return t.parentKey != null ? this._visibleViews.get(t.parentKey) : this._rootView;
  }
  getReusableView(t) {
    let r = this.getParentView(t).getReusableView(t.type);
    return r.layoutInfo = t, this._renderView(r), r;
  }
  _renderView(t) {
    if (t.layoutInfo) {
      let { type: n, key: r, content: a } = t.layoutInfo;
      t.content = a || this.collection.getItem(r), t.rendered = this._renderContent(n, t.content);
    }
  }
  _renderContent(t, n) {
    let r = n != null ? this._renderedContent.get(n) : null;
    if (r != null) return r;
    let a = this.delegate.renderView(t, n);
    return n && this._renderedContent.set(n, a), a;
  }
  /**
  * Returns the key for the item view currently at the given point.
  */
  keyAtPoint(t) {
    let n = new pe(t.x, t.y, 1, 1), r = n.area === 0 ? [] : this.layout.getVisibleLayoutInfos(n);
    for (let a of r)
      if (a.rect.intersects(n)) return a.key;
    return null;
  }
  relayout(t = {}) {
    this.layout.update(t), this.contentSize = this.layout.getContentSize();
    let n = this.visibleRect, r = t.contentChanged ? 0 : n.x, a = t.contentChanged ? 0 : n.y;
    if (r = Math.max(0, Math.min(this.contentSize.width - n.width, r)), a = Math.max(0, Math.min(this.contentSize.height - n.height, a)), r !== n.x || a !== n.y) {
      let l = new pe(r, a, n.width, n.height);
      this.delegate.setVisibleRect(l);
    } else this.updateSubviews();
  }
  getVisibleLayoutInfos() {
    let t = process.env.NODE_ENV === "test" && !process.env.VIRT_ON, n = t && typeof HTMLElement < "u" && Object.getOwnPropertyNames(HTMLElement.prototype).includes("clientWidth"), r = t && typeof HTMLElement < "u" && Object.getOwnPropertyNames(HTMLElement.prototype).includes("clientHeight"), a;
    t && !(n && r) ? a = new pe(0, 0, this.contentSize.width, this.contentSize.height) : a = this._overscanManager.getOverscannedRect();
    let l = this.layout.getVisibleLayoutInfos(a), i = /* @__PURE__ */ new Map();
    for (let u of l) i.set(u.key, u);
    return i;
  }
  updateSubviews() {
    let t = this.getVisibleLayoutInfos(), n = /* @__PURE__ */ new Set();
    for (let [r, a] of this._visibleViews) {
      let l = t.get(r);
      (!l || a.parent !== this.getParentView(l)) && (this._visibleViews.delete(r), a.parent.reuseChild(a), n.add(a));
    }
    for (let [r, a] of t) {
      let l = this._visibleViews.get(r);
      if (!l)
        l = this.getReusableView(a), l.parent.children.add(l), this._visibleViews.set(r, l), n.delete(l);
      else {
        l.layoutInfo = a;
        let i = this.collection.getItem(a.key);
        l.content !== i && (l.content != null && this._renderedContent.delete(l.content), this._renderView(l));
      }
    }
    for (let r of n)
      r.parent.children.delete(r), r.parent.reusableViews.clear();
    if (!this._isScrolling)
      for (let r of t.keys()) {
        let a = this._visibleViews.get(r);
        a.parent.children.delete(a), a.parent.children.add(a);
      }
  }
  /** Performs layout and updates visible views as needed. */
  render(t) {
    let n = this, r = !1, a = !1, l = !1, i = !1, u = !1, o = !1;
    if (t.collection !== this.collection && (n.collection = t.collection, r = !0), (t.layout !== this.layout || this.layout.virtualizer !== this) && (this.layout && (this.layout.virtualizer = null), t.layout.virtualizer = this, n.layout = t.layout, r = !0), t.persistedKeys && !N8(t.persistedKeys, this.persistedKeys) && (n.persistedKeys = t.persistedKeys, o = !0), !this.visibleRect.equals(t.visibleRect) || !this.size.equals(t.size)) {
      this._overscanManager.setVisibleRect(t.visibleRect);
      let d = new pe(this.visibleRect.x, this.visibleRect.y, this.size.width, this.size.height), s = new pe(t.visibleRect.x, t.visibleRect.y, t.size.width, t.size.height);
      this.layout.shouldInvalidate(s, d) ? (a = !t.visibleRect.pointEquals(this.visibleRect), l = !this.size.equals(t.size), r = !0) : o = !0, n.visibleRect = t.visibleRect, n.size = t.size;
    }
    return t.invalidationContext !== this._invalidationContext && (t.invalidationContext && (l ||= t.invalidationContext.sizeChanged || !1, a ||= t.invalidationContext.offsetChanged || !1, i ||= t.invalidationContext.itemSizeChanged || !1, u ||= t.invalidationContext.layoutOptions != null && this._invalidationContext.layoutOptions != null && t.invalidationContext.layoutOptions !== this._invalidationContext.layoutOptions && this.layout.shouldInvalidateLayoutOptions(t.invalidationContext.layoutOptions, this._invalidationContext.layoutOptions), r ||= i || l || a || u), this._invalidationContext = t.invalidationContext), t.isScrolling !== this._isScrolling && (this._isScrolling = t.isScrolling, t.isScrolling || (o = !0)), r ? this.relayout({
      offsetChanged: a,
      sizeChanged: l,
      itemSizeChanged: i,
      layoutOptionsChanged: u,
      layoutOptions: this._invalidationContext.layoutOptions
    }) : o && this.updateSubviews(), Array.from(this._rootView.children);
  }
  getVisibleView(t) {
    return this._visibleViews.get(t);
  }
  invalidate(t) {
    this.delegate.invalidate(t);
  }
  updateItemSize(t, n) {
    if (!this.layout.updateItemSize) return;
    this.layout.updateItemSize(t, n) && this.invalidate({
      itemSizeChanged: !0
    });
  }
}
const z8 = typeof document < "u" ? g.useLayoutEffect : () => {
};
function O8(e) {
  let [t, n] = Y(new pe(0, 0, 0, 0)), [r, a] = Y(new je()), [l, i] = Y(!1), [u, o] = Y({}), d = T(!1), [s] = Y(() => new L8({
    collection: e.collection,
    layout: e.layout,
    delegate: {
      setVisibleRect(y) {
        n(y), d.current = !0;
      },
      // TODO: should changing these invalidate the entire cache?
      renderView: e.renderView,
      invalidate: o
    }
  }));
  z8(() => {
    d.current && (d.current = !1, e.onVisibleRectChange(t));
  });
  let c = K(() => e.layoutOptions != null ? {
    ...u,
    layoutOptions: e.layoutOptions
  } : u, [
    u,
    e.layoutOptions
  ]), f = s.render({
    layout: e.layout,
    collection: e.collection,
    persistedKeys: e.persistedKeys,
    layoutOptions: e.layoutOptions,
    visibleRect: t,
    size: e.allowsWindowScrolling ? r : t,
    invalidationContext: c,
    isScrolling: l
  }), h = s.contentSize, m = X(() => {
    i(!0);
  }, []), b = X(() => {
    i(!1);
  }, []);
  return K(() => ({
    virtualizer: s,
    visibleViews: f,
    setVisibleRect: n,
    size: r,
    setSize: a,
    contentSize: h,
    isScrolling: l,
    startScrolling: m,
    endScrolling: b
  }), [
    s,
    f,
    n,
    r,
    a,
    h,
    l,
    m,
    b
  ]);
}
class H8 {
  /**
  * Returns whether the layout should invalidate in response to
  * visible rectangle changes. By default, it only invalidates
  * when the virtualizer's size changes. Return true always
  * to make the layout invalidate while scrolling (e.g. sticky headers).
  */
  shouldInvalidate(t, n) {
    return t.width !== n.width || t.height !== n.height;
  }
  /**
  * Returns whether the layout should invalidate when the layout options change.
  * By default it invalidates when the object identity changes. Override this
  * method to optimize layout updates based on specific option changes.
  */
  shouldInvalidateLayoutOptions(t, n) {
    return t !== n;
  }
  /**
  * This method allows the layout to perform any pre-computation
  * it needs to in order to prepare LayoutInfos for retrieval.
  * Called by the virtualizer before `getVisibleLayoutInfos`
  * or `getLayoutInfo` are called.
  */
  update(t) {
  }
  /** @private */
  getItemRect(t) {
    return this.getLayoutInfo(t)?.rect ?? null;
  }
  /** @private */
  getVisibleRect() {
    return this.virtualizer.visibleRect;
  }
  constructor() {
    this.virtualizer = null;
  }
}
class Rn {
  /**
  * @param type The type of element represented by this LayoutInfo. Should match the `type` of the
  *   corresponding collection node.
  * @param key A unique key for this LayoutInfo. Should match the `key` of the corresponding
  *   collection node.
  * @param rect The rectangle describing the size and position of this element.
  */
  constructor(t, n, r) {
    this.type = t, this.key = n, this.parentKey = null, this.content = null, this.rect = r, this.estimatedSize = !1, this.isSticky = !1, this.opacity = 1, this.transform = null, this.zIndex = 0, this.allowOverflow = !1;
  }
  /**
  * Returns a copy of the LayoutInfo.
  */
  copy() {
    let t = new Rn(this.type, this.key, this.rect.copy());
    return t.estimatedSize = this.estimatedSize, t.opacity = this.opacity, t.transform = this.transform, t.parentKey = this.parentKey, t.content = this.content, t.isSticky = this.isSticky, t.zIndex = this.zIndex, t.allowOverflow = this.allowOverflow, t;
  }
}
const Sn = 48;
class JC extends H8 {
  /**
  * Creates a new ListLayout with options. See the list of properties below for a description
  * of the options that can be provided.
  */
  constructor(t = {}) {
    super(), this.rowSize = t?.rowSize ?? t?.rowHeight ?? null, this.orientation = t.orientation ?? "vertical", this.estimatedRowSize = t?.estimatedRowSize ?? t?.estimatedRowHeight ?? null, this.headingSize = t?.headingSize ?? t?.headingHeight ?? null, this.estimatedHeadingSize = t?.estimatedHeadingSize ?? t?.estimatedHeadingHeight ?? null, this.loaderSize = t?.loaderSize ?? t?.loaderHeight ?? null, this.dropIndicatorThickness = t.dropIndicatorThickness || 2, this.gap = t.gap || 0, this.padding = t.padding || 0, this.layoutNodes = /* @__PURE__ */ new Map(), this.rootNodes = [], this.lastCollection = null, this.invalidateEverything = !1, this.validRect = new pe(), this.requestedRect = new pe(), this.contentSize = new je();
  }
  // Backward compatibility for subclassing.
  get collection() {
    return this.virtualizer.collection;
  }
  /** @deprecated Use `rowSize` instead. */
  get rowHeight() {
    return this.rowSize;
  }
  /** @deprecated Use `estimatedRowSize` instead. */
  get estimatedRowHeight() {
    return this.estimatedRowSize;
  }
  /** @deprecated Use `headingSize` instead. */
  get headingHeight() {
    return this.headingSize;
  }
  /** @deprecated Use `estimatedHeadingSize` instead. */
  get estimatedHeadingHeight() {
    return this.estimatedHeadingSize;
  }
  /** @deprecated Use `loaderSize` instead. */
  get loaderHeight() {
    return this.loaderSize;
  }
  getLayoutInfo(t) {
    return this.ensureLayoutInfo(t), this.layoutNodes.get(t)?.layoutInfo || null;
  }
  getVisibleLayoutInfos(t) {
    let n = this.orientation === "horizontal" ? "x" : "y", r = this.orientation === "horizontal" ? "width" : "height";
    if (t[r] > 1) {
      let i = (this.rowSize ?? this.estimatedRowSize ?? Sn) + this.gap;
      t = t.copy();
      let u = Math.floor(t[n] / i) * i, o = t[r] + t[n] - u;
      t[n] = u, t[r] = Math.ceil(o / i) * i;
    }
    this.layoutIfNeeded(t);
    let a = [], l = (i) => {
      for (let u of i) this.isVisible(u, t) && (a.push(u.layoutInfo), u.children && l(u.children));
    };
    return l(this.rootNodes), a;
  }
  layoutIfNeeded(t) {
    if (this.lastCollection) {
      this.requestedRect.containsRect(t) || (this.requestedRect = this.requestedRect.union(t), this.rootNodes = this.buildCollection());
      for (let n of this.virtualizer.persistedKeys)
        if (this.ensureLayoutInfo(n)) return;
    }
  }
  ensureLayoutInfo(t) {
    return !this.layoutNodes.has(t) && this.requestedRect.area < this.contentSize.area && this.lastCollection ? (this.requestedRect = new pe(0, 0, 1 / 0, 1 / 0), this.rootNodes = this.buildCollection(), this.requestedRect = new pe(0, 0, this.contentSize.width, this.contentSize.height), !0) : !1;
  }
  isVisible(t, n) {
    return t.layoutInfo.rect.intersects(n) || t.layoutInfo.isSticky || t.layoutInfo.type === "header" || t.layoutInfo.type === "loader" || this.virtualizer.isPersistedKey(t.layoutInfo.key);
  }
  shouldInvalidateEverything(t) {
    let n = t.layoutOptions;
    return t.sizeChanged || this.rowSize !== (n?.rowSize ?? n?.rowHeight ?? this.rowSize) || this.orientation !== (n?.orientation ?? this.orientation) || this.headingSize !== (n?.headingSize ?? n?.headingHeight ?? this.headingSize) || this.loaderSize !== (n?.loaderSize ?? n?.loaderHeight ?? this.loaderSize) || this.gap !== (n?.gap ?? this.gap) || this.padding !== (n?.padding ?? this.padding);
  }
  shouldInvalidateLayoutOptions(t, n) {
    return (t?.rowSize ?? t?.rowHeight) !== (n?.rowSize ?? n?.rowHeight) || t.orientation !== n.orientation || (t?.estimatedRowSize ?? t?.estimatedRowHeight) !== (n?.estimatedRowSize ?? n?.estimatedRowHeight) || (t?.headingSize ?? t?.headingHeight) !== (n?.headingSize ?? n?.headingHeight) || (t?.estimatedHeadingSize ?? t?.estimatedHeadingHeight) !== (n?.estimatedHeadingSize ?? n?.estimatedHeadingHeight) || (t?.loaderSize ?? t?.loaderHeight) !== (n?.loaderSize ?? n?.loaderHeight) || t.dropIndicatorThickness !== n.dropIndicatorThickness || t.gap !== n.gap || t.padding !== n.padding;
  }
  update(t) {
    let n = this.virtualizer.collection;
    this.invalidateEverything = this.shouldInvalidateEverything(t), this.invalidateEverything && (this.requestedRect = this.virtualizer.visibleRect.copy(), this.layoutNodes.clear());
    let r = t.layoutOptions;
    if (this.rowSize = r?.rowSize ?? r?.rowHeight ?? this.rowSize, this.orientation = r?.orientation ?? this.orientation, this.estimatedRowSize = r?.estimatedRowSize ?? r?.estimatedRowHeight ?? this.estimatedRowSize, this.headingSize = r?.headingSize ?? r?.headingHeight ?? this.headingSize, this.estimatedHeadingSize = r?.estimatedHeadingSize ?? r?.estimatedHeadingHeight ?? this.estimatedHeadingSize, this.loaderSize = r?.loaderSize ?? r?.loaderHeight ?? this.loaderSize, this.dropIndicatorThickness = r?.dropIndicatorThickness ?? this.dropIndicatorThickness, this.gap = r?.gap ?? this.gap, this.padding = r?.padding ?? this.padding, this.rootNodes = this.buildCollection(), this.lastCollection && n !== this.lastCollection)
      for (let a of this.lastCollection.getKeys()) n.getItem(a) || this.layoutNodes.get(a) && this.layoutNodes.delete(a);
    this.lastCollection = n, this.invalidateEverything = !1, this.validRect = this.requestedRect.copy();
  }
  buildCollection(t = this.padding) {
    let n = this.virtualizer.collection, r = this.orientation === "horizontal" ? "x" : "y", a = this.orientation === "horizontal" ? "maxX" : "maxY", l = U8(n, (d) => d.type !== "content"), i = l.filter((d) => d.type === "loader"), u = [], o = n?.size === 0;
    o && (t = 0);
    for (let d of l) {
      let s = (this.rowSize ?? this.estimatedRowSize ?? Sn) + this.gap;
      if (d.type === "item" && t + s < this.requestedRect[r] && !this.isValid(d, t)) {
        t += s;
        continue;
      }
      let c = this.orientation === "horizontal" ? this.buildChild(d, t, this.padding, null) : this.buildChild(d, this.padding, t, null);
      if (t = c.layoutInfo.rect[a] + this.gap, u.push(c), d.type === "loader") {
        let f = i.indexOf(d);
        i.splice(f, 1);
      }
      if ((d.type === "item" || d.type === "loader") && t > this.requestedRect[a]) {
        let f = l.indexOf(d);
        for (let h of i) {
          let m = l.indexOf(h);
          t += (m - f - 1) * s;
          let b = this.orientation === "horizontal" ? this.buildChild(h, t, this.padding, null) : this.buildChild(h, this.padding, t, null);
          u.push(b), t = b.layoutInfo.rect[a], f = m;
        }
        t += (l.length - f - 1) * s;
        break;
      }
    }
    return t = Math.max(t - this.gap, 0), t += o ? 0 : this.padding, this.contentSize = this.orientation === "horizontal" ? new je(t, this.virtualizer.size.height) : new je(this.virtualizer.size.width, t), u;
  }
  isValid(t, n) {
    let r = this.layoutNodes.get(t.key), a = this.orientation === "horizontal" ? "x" : "y";
    return !this.invalidateEverything && !!r && r.node === t && n === r.layoutInfo.rect[a] && r.layoutInfo.rect.intersects(this.validRect) && r.validRect.containsRect(r.layoutInfo.rect.intersection(this.requestedRect));
  }
  buildChild(t, n, r, a) {
    if (this.isValid(t, this.orientation === "horizontal" ? n : r)) return this.layoutNodes.get(t.key);
    let l = this.buildNode(t, n, r);
    return l.layoutInfo.parentKey = a ?? null, l.layoutInfo.allowOverflow = !0, this.layoutNodes.set(t.key, l), l;
  }
  buildNode(t, n, r) {
    switch (t.type) {
      case "section":
        return this.buildSection(t, n, r);
      case "item":
        return this.buildItem(t, n, r);
      case "header":
        return this.buildSectionHeader(t, n, r);
      case "loader":
        return this.buildLoader(t, n, r);
      case "separator":
        return this.buildItem(t, n, r);
      default:
        throw new Error("Unsupported node type: " + t.type);
    }
  }
  buildLoader(t, n, r) {
    let a = new pe(n, r, this.padding, 0), l = new Rn(t.type, t.key, a);
    return this.orientation === "horizontal" ? (a.height = this.virtualizer.contentSize.height - this.padding - r, a.width = t.props.isLoading ? this.loaderSize ?? this.rowSize ?? this.estimatedRowSize ?? Sn : 0) : (a.width = this.virtualizer.contentSize.width - this.padding - n, a.height = t.props.isLoading ? this.loaderSize ?? this.rowSize ?? this.estimatedRowSize ?? Sn : 0), {
      layoutInfo: l,
      validRect: a.intersection(this.requestedRect)
    };
  }
  buildSection(t, n, r) {
    let a = this.virtualizer.collection, l = this.virtualizer.size.width - this.padding - n, i = this.virtualizer.size.height - this.padding - r, u = this.orientation === "horizontal" ? new pe(n, r, 0, i) : new pe(n, r, l, 0), o = new Rn(t.type, t.key, u), d = this.orientation === "horizontal" ? n : r, s = this.orientation === "horizontal" ? "x" : "y", c = this.orientation === "horizontal" ? "maxX" : "maxY", f = this.orientation === "horizontal" ? "width" : "height", h = 0, m = [];
    for (let b of Ke(t, a)) {
      if (b.type === "content") continue;
      let p = (this.rowSize ?? this.estimatedRowSize ?? Sn) + this.gap;
      if (d + p < this.requestedRect[s] && !this.isValid(t, d)) {
        d += p, h++;
        continue;
      }
      let y = this.orientation === "horizontal" ? this.buildChild(b, d, r, o.key) : this.buildChild(b, n, d, o.key);
      if (d = y.layoutInfo.rect[c] + this.gap, m.push(y), d > this.requestedRect[c]) {
        d += ([
          ...Ke(t, a)
        ].length - (m.length + h)) * p;
        break;
      }
    }
    return d -= this.gap, u[f] = d - (this.orientation === "horizontal" ? n : r), {
      layoutInfo: o,
      children: m,
      validRect: o.rect.intersection(this.requestedRect),
      node: t
    };
  }
  buildSectionHeader(t, n, r) {
    let a = this.orientation === "horizontal" ? "height" : "width", l = this.orientation === "horizontal" ? "width" : "height", i = this.virtualizer.size[a] - this.padding - (this.orientation === "horizontal" ? r : n), u = this.headingSize, o = !1;
    if (u == null) {
      let c = this.layoutNodes.get(t.key), f = c?.layoutInfo;
      if (f) {
        let h = this.virtualizer.collection.getItem(t.key), m = this.lastCollection ? this.lastCollection.getItem(t.key) : null;
        u = c.layoutInfo.rect[l], o = i !== f.rect[a] || h !== m || f.estimatedSize;
      } else
        u = t.rendered ? this.estimatedHeadingSize : 0, o = !0;
    }
    u == null && (u = Sn);
    let d = this.orientation === "horizontal" ? new pe(n, r, u, i - r) : new pe(n, r, i - n, u), s = new Rn("header", t.key, d);
    return s.estimatedSize = o, {
      layoutInfo: s,
      children: [],
      validRect: s.rect.intersection(this.requestedRect),
      node: t
    };
  }
  buildItem(t, n, r) {
    let a = this.orientation === "horizontal" ? "height" : "width", l = this.orientation === "horizontal" ? "width" : "height", i = this.virtualizer.size[a] - this.padding - (this.orientation === "horizontal" ? r : n), u = this.rowSize, o = !1;
    if (u == null) {
      let c = this.layoutNodes.get(t.key);
      c ? (u = c.layoutInfo.rect[l], o = i !== c.layoutInfo.rect[a] || t !== c.node || c.layoutInfo.estimatedSize) : (u = this.estimatedRowSize, o = !0);
    }
    u == null && (u = Sn);
    let d = this.orientation === "horizontal" ? new pe(n, r, u, i) : new pe(n, r, i, u), s = new Rn(t.type, t.key, d);
    return s.estimatedSize = o, {
      layoutInfo: s,
      children: [],
      validRect: s.rect.intersection(this.requestedRect),
      node: t
    };
  }
  updateItemSize(t, n) {
    let r = this.layoutNodes.get(t);
    if (!r) return !1;
    let a = this.virtualizer.collection, l = r.layoutInfo, i = this.orientation === "horizontal" ? "x" : "y", u = this.orientation === "horizontal" ? "width" : "height";
    if (l.estimatedSize = !1, l.rect[u] !== n[u]) {
      let o = l.copy();
      o.rect[u] = n[u], r.layoutInfo = o, this.validRect[u] = Math.min(this.validRect[u], l.rect[i] - this.validRect[i]), r.node?.type === "item" && (this.requestedRect[u] += o.rect[u] - l.rect[u]), this.updateLayoutNode(t, l, o);
      let d = l.parentKey != null ? a.getItem(l.parentKey) : null;
      for (; d; )
        this.updateLayoutNode(d.key, l, o), d = d.parentKey != null ? a.getItem(d.parentKey) : null;
      return !0;
    }
    return !1;
  }
  updateLayoutNode(t, n, r) {
    let a = this.layoutNodes.get(t);
    a && (a.validRect = a.validRect.intersection(this.validRect), a.layoutInfo === n && (a.layoutInfo = r));
  }
  getContentSize() {
    return this.contentSize;
  }
  getDropTargetFromPoint(t, n, r) {
    t += this.virtualizer.visibleRect.x, n += this.virtualizer.visibleRect.y;
    let a = new pe(t, Math.max(0, n - this.gap), 1, Math.max(1, this.gap * 2)), l = this.getVisibleLayoutInfos(a), i = null, u = 1 / 0;
    for (let c of l) {
      if (!c.rect.intersects(a)) continue;
      let f = Math.abs(c.rect.y - n), h = Math.abs(c.rect.maxY - n), m = Math.min(f, h);
      m < u && (u = m, i = c.key);
    }
    if (i == null || this.virtualizer.collection.size === 0) return {
      type: "root"
    };
    let o = this.getLayoutInfo(i);
    if (!o) return null;
    let d = o.rect, s = {
      type: "item",
      key: o.key,
      dropPosition: "on"
    };
    return r(s) ? n <= d.y + 10 && r({
      ...s,
      dropPosition: "before"
    }) ? s.dropPosition = "before" : n >= d.maxY - 10 && r({
      ...s,
      dropPosition: "after"
    }) && (s.dropPosition = "after") : n <= d.y + d.height / 2 && r({
      ...s,
      dropPosition: "before"
    }) ? s.dropPosition = "before" : r({
      ...s,
      dropPosition: "after"
    }) && (s.dropPosition = "after"), s;
  }
  getDropTargetLayoutInfo(t) {
    let n = this.getLayoutInfo(t.key), r;
    if (t.dropPosition === "before") r = this.orientation === "horizontal" ? new pe(Math.max(0, n.rect.x - this.dropIndicatorThickness / 2), n.rect.y, this.dropIndicatorThickness, n.rect.height) : new pe(n.rect.x, Math.max(0, n.rect.y - this.dropIndicatorThickness / 2), n.rect.width, this.dropIndicatorThickness);
    else if (t.dropPosition === "after") {
      let a = this.collection.getItem(t.key);
      if (a) {
        let l = a.level ?? 0, i = this.collection.getKeyAfter(t.key);
        for (; i != null; ) {
          let u = this.collection.getItem(i);
          if (!u || u.level <= l) break;
          n = this.getLayoutInfo(i) || n, i = this.collection.getKeyAfter(i);
        }
      }
      r = this.orientation === "horizontal" ? new pe(n.rect.maxX - this.dropIndicatorThickness / 2, n.rect.y, this.dropIndicatorThickness, n.rect.height) : new pe(n.rect.x, n.rect.maxY - this.dropIndicatorThickness / 2, n.rect.width, this.dropIndicatorThickness);
    } else r = n.rect;
    return new Rn("dropIndicator", t.key + ":" + t.dropPosition, r);
  }
}
function U8(e, t) {
  const n = [];
  for (const r of e) t(r) && n.push(r);
  return n;
}
const f1 = /* @__PURE__ */ new WeakMap();
function gl(e, t, n) {
  if (!e)
    return "";
  typeof t == "string" && (t = t.replace(/\s+/g, ""));
  let r = f1.get(e);
  return process.env.NODE_ENV !== "production" && !r && console.error("There is no tab id, please check if you have rendered the tab panel before the tab list."), `${r}-${n}-${t}`;
}
function j8(e, t, n) {
  let { key: r, isDisabled: a, shouldSelectOnPressUp: l } = e, { selectionManager: i, selectedKey: u } = t, o = r === u, d = a || t.isDisabled || t.selectionManager.isDisabled(r), s = t.collection.getItem(r), { itemProps: c, isPressed: f } = kr({
    selectionManager: i,
    key: r,
    ref: n,
    isDisabled: d,
    // Link tabs should behave like native anchors (navigate on press up)
    // This avoids reopening beforeunload dialogs when browsers replay
    // queued pointer enter/leave events after cancellation.
    shouldSelectOnPressUp: l ?? s?.props.href != null,
    linkBehavior: "selection"
  }), h = gl(t, r, "tab"), m = gl(t, r, "tabpanel"), { tabIndex: b } = c, p = J(s?.props, {
    labelable: !0
  });
  delete p.id;
  let y = $l(s?.props), { focusableProps: $ } = ct({
    ...s?.props,
    isDisabled: d
  }, n);
  return {
    tabProps: z(p, $, y, c, {
      id: h,
      "aria-selected": o,
      "aria-disabled": d || void 0,
      "aria-controls": o ? m : void 0,
      tabIndex: d ? void 0 : b,
      role: "tab"
    }),
    isSelected: o,
    isDisabled: d,
    isPressed: f
  };
}
function _8(e, t, n) {
  let r = po(n) ? void 0 : 0;
  const a = gl(t, e.id ?? t?.selectedKey, "tabpanel"), l = ut({
    ...e,
    id: a,
    "aria-labelledby": gl(t, t?.selectedKey, "tab")
  });
  return {
    tabPanelProps: z(l, {
      tabIndex: r,
      role: "tabpanel",
      "aria-describedby": e["aria-describedby"],
      "aria-details": e["aria-details"]
    })
  };
}
class W8 {
  constructor(t, n, r, a = /* @__PURE__ */ new Set()) {
    this.collection = t, this.flipDirection = n === "rtl" && r === "horizontal", this.disabledKeys = a, this.tabDirection = r === "horizontal";
  }
  getKeyLeftOf(t) {
    return this.flipDirection ? this.getNextKey(t) : this.getPreviousKey(t);
  }
  getKeyRightOf(t) {
    return this.flipDirection ? this.getPreviousKey(t) : this.getNextKey(t);
  }
  isDisabled(t) {
    return this.disabledKeys.has(t) || !!this.collection.getItem(t)?.props?.isDisabled;
  }
  getFirstKey() {
    let t = this.collection.getFirstKey();
    return t != null && this.isDisabled(t) && (t = this.getNextKey(t)), t;
  }
  getLastKey() {
    let t = this.collection.getLastKey();
    return t != null && this.isDisabled(t) && (t = this.getPreviousKey(t)), t;
  }
  getKeyAbove(t) {
    return this.tabDirection ? null : this.getPreviousKey(t);
  }
  getKeyBelow(t) {
    return this.tabDirection ? null : this.getNextKey(t);
  }
  getNextKey(t) {
    let n = t;
    do
      n = this.collection.getKeyAfter(n), n == null && (n = this.collection.getFirstKey());
    while (n != null && this.isDisabled(n) && n !== t);
    return n;
  }
  getPreviousKey(t) {
    let n = t;
    do
      n = this.collection.getKeyBefore(n), n == null && (n = this.collection.getLastKey());
    while (n != null && this.isDisabled(n) && n !== t);
    return n;
  }
}
function G8(e, t, n) {
  let { orientation: r = "horizontal", keyboardActivation: a = "automatic" } = e, { collection: l, selectionManager: i, disabledKeys: u } = t, { direction: o } = de(), d = K(() => new W8(l, o, r, u), [
    l,
    u,
    r,
    o
  ]), { collectionProps: s } = lo({
    ref: n,
    selectionManager: i,
    keyboardDelegate: d,
    selectOnFocus: a === "automatic",
    disallowEmptySelection: !0,
    scrollRef: n,
    linkBehavior: "selection"
  }), c = ce();
  f1.set(t, c);
  let f = ut({
    ...e,
    id: c
  });
  return {
    tabListProps: {
      ...z(s, f),
      role: "tablist",
      "aria-orientation": r,
      tabIndex: void 0
    }
  };
}
function q8(e) {
  let [t, n] = we(e.selectedKey, e.defaultSelectedKey ?? null, e.onSelectionChange), r = K(() => t != null ? [
    t
  ] : [], [
    t
  ]), { collection: a, disabledKeys: l, selectionManager: i } = Al({
    ...e,
    selectionMode: "single",
    disallowEmptySelection: !0,
    allowDuplicateSelectionEvents: !0,
    selectedKeys: r,
    onSelectionChange: (o) => {
      if (o === "all") return;
      let d = o.values().next().value ?? null;
      d === t && e.onSelectionChange && e.onSelectionChange(d), n(d);
    }
  }), u = t != null ? a.getItem(t) : null;
  return {
    collection: a,
    disabledKeys: l,
    selectionManager: i,
    selectedKey: t,
    setSelectedKey: n,
    selectedItem: u
  };
}
function Y8(e) {
  let t = q8({
    ...e,
    onSelectionChange: e.onSelectionChange ? (i) => {
      i != null && e.onSelectionChange?.(i);
    } : void 0,
    suppressTextValueWarning: !0,
    defaultSelectedKey: e.defaultSelectedKey ?? Md(e.collection, e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set()) ?? void 0
  }), { selectionManager: n, collection: r, selectedKey: a } = t, l = T(a);
  return ee(() => {
    let i = a;
    e.selectedKey == null && (n.isEmpty || i == null || !r.getItem(i)) && (i = Md(r, t.disabledKeys), i != null && n.setSelectedKeys([
      i
    ])), (i != null && n.focusedKey == null || !n.isFocused && i !== l.current) && n.setFocusedKey(i), l.current = i;
  }), {
    ...t,
    isDisabled: e.isDisabled || !1
  };
}
function Md(e, t) {
  let n = null;
  if (e) {
    for (n = e.getFirstKey(); n != null && (t.has(n) || e.getItem(n)?.props?.isDisabled) && n !== e.getLastKey(); ) n = e.getKeyAfter(n);
    n != null && (t.has(n) || e.getItem(n)?.props?.isDisabled) && n === e.getLastKey() && (n = e.getFirstKey());
  }
  return n;
}
const Nl = /* @__PURE__ */ G(null), $n = /* @__PURE__ */ G(null), QC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Nl);
  let { children: r, orientation: a = "horizontal" } = t;
  return r = K(() => typeof r == "function" ? r({
    orientation: a,
    defaultChildren: null
  }) : r, [
    r,
    a
  ]), /* @__PURE__ */ g.createElement(jn, {
    content: r
  }, (l) => /* @__PURE__ */ g.createElement(Z8, {
    props: t,
    collection: l,
    tabsRef: n
  }));
});
function Z8({ props: e, tabsRef: t, collection: n }) {
  let { orientation: r = "horizontal" } = e, a = Y8({
    ...e,
    collection: n,
    children: void 0
  }), { focusProps: l, isFocused: i, isFocusVisible: u } = ye({
    within: !0
  }), o = K(() => ({
    orientation: r,
    isFocusWithin: i,
    isFocusVisible: u
  }), [
    r,
    i,
    u
  ]), d = le({
    ...e,
    defaultClassName: "react-aria-Tabs",
    values: o
  }), s = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(s, d, l),
    ref: t,
    slot: e.slot || void 0,
    "data-focused": i || void 0,
    "data-orientation": r,
    "data-focus-visible": u || void 0,
    "data-disabled": a.isDisabled || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Nl,
        e
      ],
      [
        $n,
        a
      ]
    ]
  }, d.children));
}
const eP = /* @__PURE__ */ te(function(t, n) {
  return O($n) ? /* @__PURE__ */ g.createElement(X8, {
    props: t,
    forwardedRef: n
  }) : /* @__PURE__ */ g.createElement(Jt, t);
});
function X8({ props: e, forwardedRef: t }) {
  let n = O($n), { CollectionRoot: r } = O(ge), { orientation: a = "horizontal", keyboardActivation: l = "automatic" } = He(Nl), i = $e(t), { tabListProps: u } = G8({
    ...e,
    orientation: a,
    keyboardActivation: l
  }, n, i), o = le({
    ...e,
    children: null,
    defaultClassName: "react-aria-TabList",
    values: {
      orientation: a,
      state: n
    }
  }), d = J(e, {
    global: !0
  });
  return delete d.id, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(d, o, u),
    ref: i,
    "data-orientation": a || void 0
  }, /* @__PURE__ */ g.createElement(Wn, null, /* @__PURE__ */ g.createElement(r, {
    collection: n.collection,
    persistedKeys: Cu(n.selectionManager.focusedKey)
  })));
}
const Oo = class Oo extends dt {
};
Oo.type = "item";
let su = Oo;
const tP = /* @__PURE__ */ St(su, (e, t, n) => {
  let r = O($n), a = $e(t), { tabProps: l, isSelected: i, isDisabled: u, isPressed: o } = j8({
    key: n.key,
    ...e
  }, r, a), { focusProps: d, isFocused: s, isFocusVisible: c } = ye(), { hoverProps: f, isHovered: h } = De({
    isDisabled: u,
    onHoverStart: e.onHoverStart,
    onHoverEnd: e.onHoverEnd,
    onHoverChange: e.onHoverChange
  }), m = le({
    ...e,
    id: void 0,
    children: n.rendered,
    defaultClassName: "react-aria-Tab",
    values: {
      isSelected: i,
      isDisabled: u,
      isFocused: s,
      isFocusVisible: c,
      isPressed: o,
      isHovered: h
    }
  }), b = n.props.href ? Q.a : Q.div, p = J(e, {
    global: !0
  });
  return delete p.id, delete p.onClick, /* @__PURE__ */ g.createElement(b, {
    ...z(p, m, l, d, f),
    ref: a,
    "data-selected": i || void 0,
    "data-disabled": u || void 0,
    "data-focused": s || void 0,
    "data-focus-visible": c || void 0,
    "data-pressed": o || void 0,
    "data-hovered": h || void 0
  }, /* @__PURE__ */ g.createElement(Gn.Provider, {
    value: {
      isSelected: i
    }
  }, m.children));
}), nP = /* @__PURE__ */ vn(function(t, n) {
  let r = O($n), a = $e(n), l = T(r.selectedKey), i = T(null), u = T(null);
  ue(() => {
    let d = a.current;
    if (d) {
      if (u.current == null && (u.current = /width|height|block-size|inline-size|all/.test(window.getComputedStyle(d).transition)), u.current && l.current != null && l.current !== r.selectedKey) {
        d.style.setProperty("--tab-panel-width", "auto"), d.style.setProperty("--tab-panel-height", "auto");
        let { width: s, height: c } = d.getBoundingClientRect();
        i.current && (i.current.width !== s || i.current.height !== c) && (d.style.setProperty("--tab-panel-width", i.current.width + "px"), d.style.setProperty("--tab-panel-height", i.current.height + "px"), window.getComputedStyle(d).height, d.style.setProperty("--tab-panel-width", s + "px"), d.style.setProperty("--tab-panel-height", c + "px"), Promise.all(d.getAnimations().map((f) => f.finished)).then(() => {
          d.style.setProperty("--tab-panel-width", "auto"), d.style.setProperty("--tab-panel-height", "auto");
        }).catch(() => {
        }));
      }
      l.current = r.selectedKey;
    }
  }, [
    a,
    r.selectedKey
  ]), r.selectedKey != null && // eslint-disable-next-line rsp-rules/pure-render
  r.selectedKey !== l.current && a.current && // eslint-disable-next-line rsp-rules/pure-render
  u.current && (i.current = a.current.getBoundingClientRect());
  let o = J(t, {
    labelable: !0,
    global: !0
  });
  return delete o.id, /* @__PURE__ */ g.createElement(Q.div, {
    render: t.render,
    ...o,
    ref: a,
    style: t.style,
    className: t.className || "react-aria-TabPanels"
  }, /* @__PURE__ */ g.createElement(Jt, t));
}), rP = /* @__PURE__ */ vn(function(t, n) {
  const r = O($n);
  let a = $e(n), l = r.selectedKey === t.id, [i, u] = Y(r.selectedKey != null ? l : null);
  i == null && r.selectedKey != null ? u(l) : !l && i && u(!1);
  let o = da(a, l);
  return !l && !t.shouldForceMount && !o ? null : /* @__PURE__ */ g.createElement(J8, {
    ...t,
    tabPanelRef: a,
    isInitiallySelected: i || !1,
    isExiting: o
  });
});
function J8(e) {
  let t = O($n), { id: n, tabPanelRef: r, isInitiallySelected: a, isExiting: l, ...i } = e, { tabPanelProps: u } = _8(e, t, r), { focusProps: o, isFocused: d, isFocusVisible: s } = ye(), c = t.selectedKey === e.id, f = xa(r) && !a, h = le({
    ...e,
    defaultClassName: "react-aria-TabPanel",
    values: {
      isFocused: d,
      isFocusVisible: s,
      // @ts-ignore - compatibility with React < 19
      isInert: fl(!c),
      isEntering: f,
      isExiting: l,
      state: t
    }
  }), m = J(i, {
    global: !0
  });
  delete m.id;
  let b = c ? z(m, u, o, h) : z(m, h);
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...b,
    ref: r,
    "data-focused": d || void 0,
    "data-focus-visible": s || void 0,
    // @ts-ignore
    inert: fl(!c || e.inert),
    "data-inert": c ? void 0 : "true",
    "data-entering": f || void 0,
    "data-exiting": l || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Nl,
        null
      ],
      [
        $n,
        null
      ]
    ]
  }, /* @__PURE__ */ g.createElement(ge.Provider, {
    value: ma
  }, h.children)));
}
const h1 = /* @__PURE__ */ new WeakMap();
function Q8(e, t, n) {
  let { direction: r } = de(), a = e.keyboardDelegate || new va({
    collection: t.collection,
    ref: n,
    orientation: "horizontal",
    direction: r,
    disabledKeys: t.disabledKeys,
    disabledBehavior: t.selectionManager.disabledBehavior
  }), { labelProps: l, fieldProps: i, descriptionProps: u, errorMessageProps: o } = Pr({
    ...e,
    labelElementType: "span"
  }), { gridProps: d } = aE({
    ...e,
    ...i,
    keyboardDelegate: a,
    shouldFocusWrap: !0,
    linkBehavior: "override",
    keyboardNavigationBehavior: "tab"
  }, t, n), [s, c] = Y(!1), { focusWithinProps: f } = ft({
    onFocusWithinChange: c
  }), h = J(e), m = T(t.collection.size);
  return ee(() => {
    n.current && m.current > 0 && t.collection.size === 0 && s && n.current.focus(), m.current = t.collection.size;
  }, [
    t.collection.size,
    s,
    n
  ]), h1.set(t, {
    onRemove: e.onRemove
  }), {
    gridProps: z(d, h, {
      role: t.collection.size ? "grid" : "group",
      "aria-atomic": !1,
      "aria-relevant": "additions",
      "aria-live": s ? "polite" : "off",
      ...f,
      ...i
    }),
    labelProps: l,
    descriptionProps: u,
    errorMessageProps: o
  };
}
var m1 = {};
m1 = {
  removeButtonLabel: "إزالة",
  removeDescription: "اضغط على مفتاح DELETE لإزالة علامة."
};
var b1 = {};
b1 = {
  removeButtonLabel: "Премахване",
  removeDescription: "Натиснете Delete, за да премахнете маркера."
};
var p1 = {};
p1 = {
  removeButtonLabel: "Odebrat",
  removeDescription: "Stisknutím klávesy Delete odeberete značku."
};
var g1 = {};
g1 = {
  removeButtonLabel: "Fjern",
  removeDescription: "Tryk på Slet for at fjerne tag."
};
var y1 = {};
y1 = {
  removeButtonLabel: "Entfernen",
  removeDescription: "Auf „Löschen“ drücken, um das Tag zu entfernen."
};
var $1 = {};
$1 = {
  removeButtonLabel: "Κατάργηση",
  removeDescription: "Πατήστε Διαγραφή για να καταργήσετε την ετικέτα."
};
var v1 = {};
v1 = {
  removeDescription: "Press Delete to remove tag.",
  removeButtonLabel: "Remove"
};
var D1 = {};
D1 = {
  removeButtonLabel: "Quitar",
  removeDescription: "Pulse Eliminar para quitar la etiqueta."
};
var x1 = {};
x1 = {
  removeButtonLabel: "Eemalda",
  removeDescription: "Sildi eemaldamiseks vajutage kustutusklahvi Delete."
};
var E1 = {};
E1 = {
  removeButtonLabel: "Poista",
  removeDescription: "Poista tunniste painamalla Poista-painiketta."
};
var C1 = {};
C1 = {
  removeButtonLabel: "Supprimer",
  removeDescription: "Appuyez sur Supprimer pour supprimer l’étiquette."
};
var P1 = {};
P1 = {
  removeButtonLabel: "הסר",
  removeDescription: "לחץ על מחק כדי להסיר תג."
};
var w1 = {};
w1 = {
  removeButtonLabel: "Ukloni",
  removeDescription: "Pritisnite Delete za uklanjanje oznake."
};
var S1 = {};
S1 = {
  removeButtonLabel: "Eltávolítás",
  removeDescription: "Nyomja meg a Delete billentyűt a címke eltávolításához."
};
var k1 = {};
k1 = {
  removeButtonLabel: "Rimuovi",
  removeDescription: "Premi Elimina per rimuovere il tag."
};
var B1 = {};
B1 = {
  removeButtonLabel: "削除",
  removeDescription: "タグを削除するには、Delete キーを押します。"
};
var F1 = {};
F1 = {
  removeButtonLabel: "제거",
  removeDescription: "태그를 제거하려면 Delete 키를 누르십시오."
};
var A1 = {};
A1 = {
  removeButtonLabel: "Pašalinti",
  removeDescription: "Norėdami pašalinti žymą, paspauskite „Delete“ klavišą."
};
var R1 = {};
R1 = {
  removeButtonLabel: "Noņemt",
  removeDescription: "Nospiediet Delete [Dzēst], lai noņemtu tagu."
};
var T1 = {};
T1 = {
  removeButtonLabel: "Fjern",
  removeDescription: "Trykk på Slett for å fjerne taggen."
};
var I1 = {};
I1 = {
  removeButtonLabel: "Verwijderen",
  removeDescription: "Druk op Verwijderen om de tag te verwijderen."
};
var M1 = {};
M1 = {
  removeButtonLabel: "Usuń",
  removeDescription: "Naciśnij Usuń, aby usunąć znacznik."
};
var K1 = {};
K1 = {
  removeButtonLabel: "Remover",
  removeDescription: "Pressione Delete para remover a tag."
};
var N1 = {};
N1 = {
  removeButtonLabel: "Eliminar",
  removeDescription: "Prima Delete para eliminar a tag."
};
var V1 = {};
V1 = {
  removeButtonLabel: "Îndepărtaţi",
  removeDescription: "Apăsați pe Delete (Ștergere) pentru a elimina eticheta."
};
var L1 = {};
L1 = {
  removeButtonLabel: "Удалить",
  removeDescription: "Нажмите DELETE, чтобы удалить тег."
};
var z1 = {};
z1 = {
  removeButtonLabel: "Odstrániť",
  removeDescription: "Ak chcete odstrániť značku, stlačte kláves Delete."
};
var O1 = {};
O1 = {
  removeButtonLabel: "Odstrani",
  removeDescription: "Pritisnite Delete, da odstranite oznako."
};
var H1 = {};
H1 = {
  removeButtonLabel: "Ukloni",
  removeDescription: "Pritisnite Obriši da biste uklonili oznaku."
};
var U1 = {};
U1 = {
  removeButtonLabel: "Ta bort",
  removeDescription: "Tryck på Radera för att ta bort taggen."
};
var j1 = {};
j1 = {
  removeButtonLabel: "Kaldır",
  removeDescription: "Etiketi kaldırmak için Sil tuşuna basın."
};
var _1 = {};
_1 = {
  removeButtonLabel: "Вилучити",
  removeDescription: "Натисніть Delete, щоб вилучити тег."
};
var W1 = {};
W1 = {
  removeButtonLabel: "删除",
  removeDescription: "按下“删除”以删除标记。"
};
var G1 = {};
G1 = {
  removeButtonLabel: "移除",
  removeDescription: "按 Delete 鍵以移除標記。"
};
var q1 = {};
q1 = {
  "ar-AE": m1,
  "bg-BG": b1,
  "cs-CZ": p1,
  "da-DK": g1,
  "de-DE": y1,
  "el-GR": $1,
  "en-US": v1,
  "es-ES": D1,
  "et-EE": x1,
  "fi-FI": E1,
  "fr-FR": C1,
  "he-IL": P1,
  "hr-HR": w1,
  "hu-HU": S1,
  "it-IT": k1,
  "ja-JP": B1,
  "ko-KR": F1,
  "lt-LT": A1,
  "lv-LV": R1,
  "nb-NO": T1,
  "nl-NL": I1,
  "pl-PL": M1,
  "pt-BR": K1,
  "pt-PT": N1,
  "ro-RO": V1,
  "ru-RU": L1,
  "sk-SK": z1,
  "sl-SI": O1,
  "sr-SP": H1,
  "sv-SE": U1,
  "tr-TR": j1,
  "uk-UA": _1,
  "zh-CN": W1,
  "zh-TW": G1
};
function e9(e) {
  return e && e.__esModule ? e.default : e;
}
function t9(e, t, n) {
  let { item: r } = e, a = Ee(e9(q1), "@react-aria/tag"), l = ce(), { onRemove: i } = h1.get(t) || {}, { rowProps: u, gridCellProps: o, ...d } = lE({
    node: r
  }, t, n), { descriptionProps: s, ...c } = d, f = t.disabledKeys.has(r.key) || r.props.isDisabled, h = (C) => {
    if (C.key === "Delete" || C.key === "Backspace") {
      if (f) return;
      C.preventDefault(), t.selectionManager.isSelected(r.key) ? i?.(new Set(t.selectionManager.selectedKeys)) : i?.(/* @__PURE__ */ new Set([
        r.key
      ]));
    }
  }, m = Dl();
  m === "virtual" && typeof window < "u" && "ontouchstart" in window && (m = "pointer");
  let b = i && (m === "keyboard" || m === "virtual") ? a.format("removeDescription") : "", p = en(b), y = r.key === t.selectionManager.focusedKey, $ = t.selectionManager.focusedKey != null, v = -1;
  !f && (y || !$) && (v = 0);
  let x = J(r.props), E = $u(r.props), { focusableProps: P } = ct({
    ...r.props,
    isDisabled: f
  }, n);
  return {
    removeButtonProps: {
      "aria-label": a.format("removeButtonLabel"),
      "aria-labelledby": `${l} ${u.id}`,
      isDisabled: f,
      id: l,
      onPress: () => i ? i(/* @__PURE__ */ new Set([
        r.key
      ])) : null
    },
    rowProps: z(P, u, x, E, {
      tabIndex: v,
      onKeyDown: i ? h : void 0,
      "aria-describedby": p["aria-describedby"]
    }),
    gridCellProps: z(o, {
      "aria-errormessage": e["aria-errormessage"],
      "aria-label": e["aria-label"]
    }),
    ...c,
    allowsRemoving: !!i
  };
}
const n9 = /* @__PURE__ */ G(null), Y1 = /* @__PURE__ */ G(null), aP = /* @__PURE__ */ te(function(t, n) {
  return [t, n] = oe(t, n, n9), /* @__PURE__ */ g.createElement(kt.Provider, {
    value: null
  }, /* @__PURE__ */ g.createElement(jn, {
    content: t.children
  }, (r) => /* @__PURE__ */ g.createElement(r9, {
    props: t,
    forwardedRef: n,
    collection: r
  })));
});
function r9({ props: e, forwardedRef: t, collection: n }) {
  let r = T(null), { id: a, ...l } = e;
  [l, r] = oe(l, r, Vn);
  let { filter: i, shouldUseVirtualFocus: u, ...o } = l, [d, s] = Qe(!e["aria-label"] && !e["aria-labelledby"]), c = Al({
    ...o,
    children: void 0,
    collection: n
  }), f = Hb(c, i), h = J(l, {
    global: !0
  }), m = Object.fromEntries(Object.entries(h).map(([v, x]) => [
    v,
    v === "id" ? x : void 0
  ])), { gridProps: b, labelProps: p, descriptionProps: y, errorMessageProps: $ } = Q8({
    ...o,
    ...m,
    label: s
  }, f, r);
  return /* @__PURE__ */ g.createElement(Q.div, {
    render: e.render,
    ...h,
    id: a,
    ref: t,
    slot: e.slot || void 0,
    className: e.className ?? "react-aria-TagGroup",
    style: e.style
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        et,
        {
          ...p,
          elementType: "span",
          ref: d
        }
      ],
      [
        Y1,
        {
          ...b,
          ref: r
        }
      ],
      [
        kt,
        f
      ],
      [
        We,
        {
          slots: {
            description: y,
            errorMessage: $
          }
        }
      ]
    ]
  }, e.children));
}
const lP = /* @__PURE__ */ te(function(t, n) {
  return O(kt) ? /* @__PURE__ */ g.createElement(a9, {
    props: t,
    forwardedRef: n
  }) : /* @__PURE__ */ g.createElement(Jt, t);
});
function a9({ props: e, forwardedRef: t }) {
  let n = O(kt), { CollectionRoot: r } = O(ge), [a, l] = oe({}, t, Y1), { focusProps: i, isFocused: u, isFocusVisible: o } = ye(), d = {
    isEmpty: n.collection.size === 0,
    isFocused: u,
    isFocusVisible: o,
    state: n
  }, s = le({
    ...e,
    children: void 0,
    defaultClassName: "react-aria-TagList",
    values: d
  }), c = Cu(n.selectionManager.focusedKey), f = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(f, s, a, i),
    ref: l,
    "data-empty": n.collection.size === 0 || void 0,
    "data-focused": u || void 0,
    "data-focus-visible": o || void 0
  }, /* @__PURE__ */ g.createElement(Wn, null, n.collection.size === 0 && e.renderEmptyState ? e.renderEmptyState(d) : /* @__PURE__ */ g.createElement(r, {
    collection: n.collection,
    persistedKeys: c
  })));
}
const iP = /* @__PURE__ */ St(Zr, (e, t, n) => {
  let r = O(kt), a = $e(t), { focusProps: l, isFocusVisible: i } = ye({
    within: !1
  }), { rowProps: u, gridCellProps: o, removeButtonProps: d, ...s } = t9({
    item: n
  }, r, a), { hoverProps: c, isHovered: f } = De({
    isDisabled: !s.allowsSelection && !s.hasAction,
    onHoverStart: n.props.onHoverStart,
    onHoverChange: n.props.onHoverChange,
    onHoverEnd: n.props.onHoverEnd
  }), h = le({
    ...e,
    id: void 0,
    children: n.rendered,
    defaultClassName: "react-aria-Tag",
    values: {
      ...s,
      isFocusVisible: i,
      isHovered: f,
      selectionMode: r.selectionManager.selectionMode,
      selectionBehavior: r.selectionManager.selectionBehavior
    }
  });
  ee(() => {
    !n.textValue && process.env.NODE_ENV !== "production" && console.warn("A `textValue` prop is required for <Tag> elements with non-plain text children for accessibility.");
  }, [
    n.textValue
  ]);
  let m = J(e, {
    global: !0
  });
  return delete m.id, delete m.onClick, /* @__PURE__ */ g.createElement(Q.div, {
    ref: a,
    ...z(m, h, u, l, c),
    "data-selected": s.isSelected || void 0,
    "data-disabled": s.isDisabled || void 0,
    "data-hovered": f || void 0,
    "data-focused": s.isFocused || void 0,
    "data-focus-visible": i || void 0,
    "data-pressed": s.isPressed || void 0,
    "data-allows-removing": s.allowsRemoving || void 0,
    "data-selection-mode": r.selectionManager.selectionMode === "none" ? void 0 : r.selectionManager.selectionMode
  }, /* @__PURE__ */ g.createElement("div", {
    ...o,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Xe,
        {
          slots: {
            remove: d
          }
        }
      ],
      [
        ge,
        ma
      ],
      [
        Gn,
        {
          isSelected: s.isSelected
        }
      ]
    ]
  }, h.children)));
}), Z1 = /* @__PURE__ */ G({});
let l9 = (e) => {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, ...a } = e;
  return a;
};
const uP = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Z1);
  let { hoverProps: r, isHovered: a } = De(t), { isFocused: l, isFocusVisible: i, focusProps: u } = ye({
    isTextInput: !0,
    autoFocus: t.autoFocus
  }), o = !!t["aria-invalid"] && t["aria-invalid"] !== "false", d = le({
    ...t,
    values: {
      isHovered: a,
      isFocused: l,
      isFocusVisible: i,
      isDisabled: t.disabled || !1,
      isInvalid: o
    },
    defaultClassName: "react-aria-TextArea"
  });
  return /* @__PURE__ */ g.createElement(Q.textarea, {
    ...z(l9(t), u, r),
    ...d,
    ref: n,
    "data-focused": l || void 0,
    "data-disabled": t.disabled || void 0,
    "data-hovered": a || void 0,
    "data-focus-visible": i || void 0,
    "data-invalid": o || void 0
  });
}), i9 = /* @__PURE__ */ G(null), oP = /* @__PURE__ */ vn(function(t, n) {
  [t, n] = oe(t, n, i9);
  let { validationBehavior: r } = He(_n) || {}, a = t.validationBehavior ?? r ?? "native", l = T(null);
  [t, l] = oe(t, l, fa);
  let [i, u] = Qe(!t["aria-label"] && !t["aria-labelledby"]), [o, d] = Y("input"), { labelProps: s, inputProps: c, descriptionProps: f, errorMessageProps: h, ...m } = qu({
    ...wt(t),
    inputElementType: o,
    label: u,
    validationBehavior: a
  }, l), b = X(($) => {
    l.current = $, $ && d($ instanceof HTMLTextAreaElement ? "textarea" : "input");
  }, [
    l
  ]), p = le({
    ...t,
    values: {
      isDisabled: t.isDisabled || !1,
      isInvalid: m.isInvalid,
      isReadOnly: t.isReadOnly || !1,
      isRequired: t.isRequired || !1
    },
    defaultClassName: "react-aria-TextField"
  }), y = J(t, {
    global: !0
  });
  return delete y.id, /* @__PURE__ */ g.createElement(Q.div, {
    ...y,
    ...p,
    ref: n,
    slot: t.slot || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-invalid": m.isInvalid || void 0,
    "data-readonly": t.isReadOnly || void 0,
    "data-required": t.isRequired || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        et,
        {
          ...s,
          ref: i
        }
      ],
      [
        wr,
        {
          ...c,
          ref: b
        }
      ],
      [
        Z1,
        {
          ...c,
          ref: b
        }
      ],
      [
        Dn,
        {
          role: "presentation",
          isInvalid: m.isInvalid,
          isDisabled: t.isDisabled || !1
        }
      ],
      [
        We,
        {
          slots: {
            description: f,
            errorMessage: h
          }
        }
      ],
      [
        nn,
        m
      ]
    ]
  }, p.children));
});
var X1 = {};
X1 = {
  close: "إغلاق",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} إشعار`,
    other: () => `${t.number(e.count)} إشعارات`
  })}.`
};
var J1 = {};
J1 = {
  close: "Затвори",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} известие`,
    other: () => `${t.number(e.count)} известия`
  })}.`
};
var Q1 = {};
Q1 = {
  close: "Zavřít",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} oznámení`,
    other: () => `${t.number(e.count)} oznámení`
  })}.`
};
var ev = {};
ev = {
  close: "Luk",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} besked`,
    other: () => `${t.number(e.count)} beskeder`
  })}.`
};
var tv = {};
tv = {
  close: "Schließen",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} Benachrichtigung`,
    other: () => `${t.number(e.count)} Benachrichtigungen`
  })}.`
};
var nv = {};
nv = {
  close: "Κλείσιμο",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} ειδοποίηση`,
    other: () => `${t.number(e.count)} ειδοποιήσεις`
  })}.`
};
var rv = {};
rv = {
  close: "Close",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} notification`,
    other: () => `${t.number(e.count)} notifications`
  })}.`
};
var av = {};
av = {
  close: "Cerrar",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} notificación`,
    other: () => `${t.number(e.count)} notificaciones`
  })}.`
};
var lv = {};
lv = {
  close: "Sule",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} teatis`,
    other: () => `${t.number(e.count)} teatist`
  })}.`
};
var iv = {};
iv = {
  close: "Sulje",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} ilmoitus`,
    other: () => `${t.number(e.count)} ilmoitusta`
  })}.`
};
var uv = {};
uv = {
  close: "Fermer",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} notification`,
    other: () => `${t.number(e.count)} notifications`
  })}.`
};
var ov = {};
ov = {
  close: "סגור",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} התראה`,
    other: () => `${t.number(e.count)} התראות`
  })}.`
};
var sv = {};
sv = {
  close: "Zatvori",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} obavijest`,
    other: () => `${t.number(e.count)} obavijesti`
  })}.`
};
var dv = {};
dv = {
  close: "Bezárás",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} értesítés`,
    other: () => `${t.number(e.count)} értesítés`
  })}.`
};
var cv = {};
cv = {
  close: "Chiudi",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} notifica`,
    other: () => `${t.number(e.count)} notifiche`
  })}.`
};
var fv = {};
fv = {
  close: "閉じる",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} 個の通知`,
    other: () => `${t.number(e.count)} 個の通知`
  })}。`
};
var hv = {};
hv = {
  close: "닫기",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)}개 알림`,
    other: () => `${t.number(e.count)}개 알림`
  })}.`
};
var mv = {};
mv = {
  close: "Uždaryti",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} pranešimas`,
    other: () => `${t.number(e.count)} pranešimai`
  })}.`
};
var bv = {};
bv = {
  close: "Aizvērt",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} paziņojums`,
    other: () => `${t.number(e.count)} paziņojumi`
  })}.`
};
var pv = {};
pv = {
  close: "Lukk",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} varsling`,
    other: () => `${t.number(e.count)} varsler`
  })}.`
};
var gv = {};
gv = {
  close: "Sluiten",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} melding`,
    other: () => `${t.number(e.count)} meldingen`
  })}.`
};
var yv = {};
yv = {
  close: "Zamknij",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} powiadomienie`,
    few: () => `${t.number(e.count)} powiadomienia`,
    many: () => `${t.number(e.count)} powiadomień`,
    other: () => `${t.number(e.count)} powiadomienia`
  })}.`
};
var $v = {};
$v = {
  close: "Fechar",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} notificação`,
    other: () => `${t.number(e.count)} notificações`
  })}.`
};
var vv = {};
vv = {
  close: "Fechar",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} notificação`,
    other: () => `${t.number(e.count)} notificações`
  })}.`
};
var Dv = {};
Dv = {
  close: "Închideţi",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} notificare`,
    other: () => `${t.number(e.count)} notificări`
  })}.`
};
var xv = {};
xv = {
  close: "Закрыть",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} уведомление`,
    other: () => `${t.number(e.count)} уведомления`
  })}.`
};
var Ev = {};
Ev = {
  close: "Zatvoriť",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} oznámenie`,
    few: () => `${t.number(e.count)} oznámenia`,
    other: () => `${t.number(e.count)} oznámení`
  })}.`
};
var Cv = {};
Cv = {
  close: "Zapri",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} obvestilo`,
    two: () => `${t.number(e.count)} obvestili`,
    few: () => `${t.number(e.count)} obvestila`,
    other: () => `${t.number(e.count)} obvestil`
  })}.`
};
var Pv = {};
Pv = {
  close: "Zatvori",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} obaveštenje`,
    other: () => `${t.number(e.count)} obaveštenja`
  })}.`
};
var wv = {};
wv = {
  close: "Stäng",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} meddelande`,
    other: () => `${t.number(e.count)} meddelanden`
  })}.`
};
var Sv = {};
Sv = {
  close: "Kapat",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} bildirim`,
    other: () => `${t.number(e.count)} bildirim`
  })}.`
};
var kv = {};
kv = {
  close: "Закрити",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} сповіщення`,
    other: () => `${t.number(e.count)} сповіщення`
  })}.`
};
var Bv = {};
Bv = {
  close: "关闭",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} 个通知`,
    other: () => `${t.number(e.count)} 个通知`
  })}。`
};
var Fv = {};
Fv = {
  close: "關閉",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} 個通知`,
    other: () => `${t.number(e.count)} 個通知`
  })}。`
};
var Po = {};
Po = {
  "ar-AE": X1,
  "bg-BG": J1,
  "cs-CZ": Q1,
  "da-DK": ev,
  "de-DE": tv,
  "el-GR": nv,
  "en-US": rv,
  "es-ES": av,
  "et-EE": lv,
  "fi-FI": iv,
  "fr-FR": uv,
  "he-IL": ov,
  "hr-HR": sv,
  "hu-HU": dv,
  "it-IT": cv,
  "ja-JP": fv,
  "ko-KR": hv,
  "lt-LT": mv,
  "lv-LV": bv,
  "nb-NO": pv,
  "nl-NL": gv,
  "pl-PL": yv,
  "pt-BR": $v,
  "pt-PT": vv,
  "ro-RO": Dv,
  "ru-RU": xv,
  "sk-SK": Ev,
  "sl-SI": Cv,
  "sr-SP": Pv,
  "sv-SE": wv,
  "tr-TR": Sv,
  "uk-UA": kv,
  "zh-CN": Bv,
  "zh-TW": Fv
};
function u9(e) {
  return e && e.__esModule ? e.default : e;
}
function o9(e, t, n) {
  let { key: r, timer: a, timeout: l } = e.toast;
  ee(() => {
    if (!(a == null || l == null))
      return a.reset(l), () => {
        a.pause();
      };
  }, [
    a,
    l
  ]);
  let i = ce(), u = yt(), o = Ee(u9(Po), "@react-aria/toast"), [d, s] = Y(!1);
  return ue(() => {
    s(!0);
  }, []), {
    toastProps: {
      ...J(e, {
        labelable: !0
      }),
      role: "alertdialog",
      "aria-modal": "false",
      "aria-labelledby": e["aria-labelledby"] || i,
      "aria-describedby": e["aria-describedby"] || u,
      tabIndex: 0
    },
    contentProps: {
      role: "alert",
      "aria-atomic": "true",
      "aria-hidden": d ? void 0 : "true"
    },
    titleProps: {
      id: i
    },
    descriptionProps: {
      id: u
    },
    closeButtonProps: {
      "aria-label": o.format("close"),
      onPress: () => t.close(r)
    }
  };
}
const Av = 1, yi = /* @__PURE__ */ Symbol.for("react-aria-landmark-manager");
function s9(e) {
  return document.addEventListener("react-aria-landmark-manager-change", e), () => document.removeEventListener("react-aria-landmark-manager-change", e);
}
function Kd() {
  if (typeof document > "u") return null;
  let e = document[yi];
  return e && e.version >= Av ? e : (document[yi] = new c9(), document.dispatchEvent(new CustomEvent("react-aria-landmark-manager-change")), document[yi]);
}
function d9() {
  return Eu.useSyncExternalStore(s9, Kd, Kd);
}
class c9 {
  constructor() {
    this.landmarks = [], this.isListening = !1, this.refCount = 0, this.version = Av, this.f6Handler = this.f6Handler.bind(this), this.focusinHandler = this.focusinHandler.bind(this), this.focusoutHandler = this.focusoutHandler.bind(this);
  }
  setupIfNeeded() {
    this.isListening || (document.addEventListener("keydown", this.f6Handler, {
      capture: !0
    }), document.addEventListener("focusin", this.focusinHandler, {
      capture: !0
    }), document.addEventListener("focusout", this.focusoutHandler, {
      capture: !0
    }), this.isListening = !0);
  }
  teardownIfNeeded() {
    !this.isListening || this.landmarks.length > 0 || this.refCount > 0 || (document.removeEventListener("keydown", this.f6Handler, {
      capture: !0
    }), document.removeEventListener("focusin", this.focusinHandler, {
      capture: !0
    }), document.removeEventListener("focusout", this.focusoutHandler, {
      capture: !0
    }), this.isListening = !1);
  }
  focusLandmark(t, n) {
    this.landmarks.find((r) => r.ref.current === t)?.focus?.(n);
  }
  /**
  * Return set of landmarks with a specific role.
  */
  getLandmarksByRole(t) {
    return new Set(this.landmarks.filter((n) => n.role === t));
  }
  /**
  * Return first landmark with a specific role.
  */
  getLandmarkByRole(t) {
    return this.landmarks.find((n) => n.role === t);
  }
  addLandmark(t) {
    if (this.setupIfNeeded(), this.landmarks.find((a) => a.ref === t.ref) || !t.ref.current) return;
    if (this.landmarks.filter((a) => a.role === "main").length > 1 && process.env.NODE_ENV !== "production" && console.error('Page can contain no more than one landmark with the role "main".'), this.landmarks.length === 0) {
      this.landmarks = [
        t
      ], this.checkLabels(t.role);
      return;
    }
    let n = 0, r = this.landmarks.length - 1;
    for (; n <= r; ) {
      let a = Math.floor((n + r) / 2), l = t.ref.current.compareDocumentPosition(this.landmarks[a].ref.current);
      !!(l & Node.DOCUMENT_POSITION_PRECEDING || l & Node.DOCUMENT_POSITION_CONTAINS) ? n = a + 1 : r = a - 1;
    }
    this.landmarks.splice(n, 0, t), this.checkLabels(t.role);
  }
  updateLandmark(t) {
    let n = this.landmarks.findIndex((r) => r.ref === t.ref);
    n >= 0 && (this.landmarks[n] = {
      ...this.landmarks[n],
      ...t
    }, this.checkLabels(this.landmarks[n].role));
  }
  removeLandmark(t) {
    this.landmarks = this.landmarks.filter((n) => n.ref !== t), this.teardownIfNeeded();
  }
  /**
  * Warn if there are 2+ landmarks with the same role but no label.
  * Labels for landmarks with the same role must also be unique.
  *
  * See https://www.w3.org/WAI/ARIA/apg/practices/landmark-regions/.
  */
  checkLabels(t) {
    let n = this.getLandmarksByRole(t);
    if (n.size > 1) {
      let r = [
        ...n
      ].filter((a) => !a.label);
      if (r.length > 0 && process.env.NODE_ENV !== "production") console.warn(`Page contains more than one landmark with the '${t}' role. If two or more landmarks on a page share the same role, all must be labeled with an aria-label or aria-labelledby attribute: `, r.map((a) => a.ref.current));
      else if (process.env.NODE_ENV !== "production") {
        let a = [
          ...n
        ].map((i) => i.label);
        a.filter((i, u) => a.indexOf(i) !== u).forEach((i) => {
          console.warn(`Page contains more than one landmark with the '${t}' role and '${i}' label. If two or more landmarks on a page share the same role, they must have unique labels: `, [
            ...n
          ].filter((u) => u.label === i).map((u) => u.ref.current));
        });
      }
    }
  }
  /**
  * Get the landmark that is the closest parent in the DOM.
  * Returns undefined if no parent is a landmark.
  */
  closestLandmark(t) {
    let n = new Map(this.landmarks.map((a) => [
      a.ref.current,
      a
    ])), r = t;
    for (; r && !n.has(r) && r !== document.body && r.parentElement; ) r = r.parentElement;
    return n.get(r);
  }
  /**
  * Gets the next landmark, in DOM focus order, or previous if backwards is specified.
  * If last landmark, next should be the first landmark.
  * If not inside a landmark, will return first landmark.
  * Returns undefined if there are no landmarks.
  */
  getNextLandmark(t, { backward: n }) {
    let r = this.closestLandmark(t), a = n ? this.landmarks.length - 1 : 0;
    r && (a = this.landmarks.indexOf(r) + (n ? -1 : 1));
    let l = () => {
      if (a < 0) {
        if (!t.dispatchEvent(new CustomEvent("react-aria-landmark-navigation", {
          detail: {
            direction: "backward"
          },
          bubbles: !0,
          cancelable: !0
        }))) return !0;
        a = this.landmarks.length - 1;
      } else if (a >= this.landmarks.length) {
        if (!t.dispatchEvent(new CustomEvent("react-aria-landmark-navigation", {
          detail: {
            direction: "forward"
          },
          bubbles: !0,
          cancelable: !0
        }))) return !0;
        a = 0;
      }
      return a < 0 || a >= this.landmarks.length;
    };
    if (l()) return;
    let i = a;
    for (; this.landmarks[a].ref.current?.closest("[aria-hidden=true]"); ) {
      if (a += n ? -1 : 1, l()) return;
      if (a === i) break;
    }
    return this.landmarks[a];
  }
  /**
  * Look at next landmark. If an element was previously focused inside, restore focus there.
  * If not, focus the landmark itself.
  * If no landmarks at all, or none with focusable elements, don't move focus.
  */
  f6Handler(t) {
    t.key === "F6" && (t.altKey ? this.focusMain() : this.navigate(W(t), t.shiftKey)) && (t.preventDefault(), t.stopPropagation());
  }
  focusMain() {
    let t = this.getLandmarkByRole("main");
    return t && t.ref.current && t.ref.current.isConnected ? (this.focusLandmark(t.ref.current, "forward"), !0) : !1;
  }
  navigate(t, n) {
    let r = this.getNextLandmark(t, {
      backward: n
    });
    if (!r) return !1;
    if (r.lastFocused) {
      let a = r.lastFocused;
      if (ae(document.body, a))
        return a.focus(), !0;
    }
    return r.ref.current && r.ref.current.isConnected ? (this.focusLandmark(r.ref.current, n ? "backward" : "forward"), !0) : !1;
  }
  /**
  * Sets lastFocused for a landmark, if focus is moved within that landmark.
  * Lets the last focused landmark know it was blurred if something else is focused.
  */
  focusinHandler(t) {
    let n = this.closestLandmark(W(t));
    n && n.ref.current !== W(t) && this.updateLandmark({
      ref: n.ref,
      lastFocused: W(t)
    });
    let r = t.relatedTarget;
    if (r) {
      let a = this.closestLandmark(r);
      a && a.ref.current === r && a.blur();
    }
  }
  /**
  * Track if the focus is lost to the body. If it is, do cleanup on the landmark that last had
  * focus.
  */
  focusoutHandler(t) {
    let n = W(t), r = t.relatedTarget;
    if (!r || r === document) {
      let a = this.closestLandmark(n);
      a && a.ref.current === n && a.blur();
    }
  }
  createLandmarkController() {
    let t = this;
    return t.refCount++, t.setupIfNeeded(), {
      navigate(n, r) {
        let a = r?.from || document.activeElement;
        return t.navigate(a, n === "backward");
      },
      focusNext(n) {
        let r = n?.from || document.activeElement;
        return t.navigate(r, !1);
      },
      focusPrevious(n) {
        let r = n?.from || document.activeElement;
        return t.navigate(r, !0);
      },
      focusMain() {
        return t.focusMain();
      },
      dispose() {
        t && (t.refCount--, t.teardownIfNeeded(), t = null);
      }
    };
  }
  registerLandmark(t) {
    return this.landmarks.find((n) => n.ref === t.ref) ? this.updateLandmark(t) : this.addLandmark(t), () => this.removeLandmark(t.ref);
  }
}
function f9(e, t) {
  const { role: n, "aria-label": r, "aria-labelledby": a, focus: l } = e;
  let i = d9(), u = r || a, [o, d] = Y(!1), s = X(() => {
    d(!0);
  }, [
    d
  ]), c = X(() => {
    d(!1);
  }, [
    d
  ]);
  return ue(() => {
    if (i) return i.registerLandmark({
      ref: t,
      label: u,
      role: n,
      focus: l || s,
      blur: c
    });
  }, [
    i,
    u,
    t,
    n,
    l,
    s,
    c
  ]), ee(() => {
    o && t.current?.focus();
  }, [
    o,
    t
  ]), {
    landmarkProps: {
      role: n,
      tabIndex: o ? -1 : void 0,
      "aria-label": r,
      "aria-labelledby": a
    }
  };
}
function h9(e) {
  return e && e.__esModule ? e.default : e;
}
function m9(e, t, n) {
  let r = Ee(h9(Po), "@react-aria/toast"), { landmarkProps: a } = f9({
    role: "region",
    "aria-label": e["aria-label"] || r.format("notifications", {
      count: t.visibleToasts.length
    })
  }, n), l = T(!1), i = T(!1), u = X(() => {
    l.current || i.current ? t.pauseAll() : t.resumeAll();
  }, [
    t
  ]), { hoverProps: o } = De({
    onHoverStart: () => {
      l.current = !0, u();
    },
    onHoverEnd: () => {
      l.current = !1, u();
    }
  }), d = T([]), s = T(t.visibleToasts), c = T(null);
  ue(() => {
    if (c.current === -1 || t.visibleToasts.length === 0 || !n.current) {
      d.current = [], s.current = t.visibleToasts;
      return;
    }
    if (d.current = [
      ...n.current.querySelectorAll('[role="alertdialog"]')
    ], s.current.length === t.visibleToasts.length && t.visibleToasts.every((p, y) => p.key === s.current[y].key)) {
      s.current = t.visibleToasts;
      return;
    }
    let m = s.current.map((p, y) => ({
      ...p,
      i: y,
      isRemoved: !t.visibleToasts.some(($) => p.key === $.key)
    })), b = m.findIndex((p) => p.i === c.current && p.isRemoved);
    if (b > -1)
      if (vt() === "pointer" && f.current?.isConnected) Ae(f.current);
      else {
        let p = 0, y, $;
        for (; p <= b; )
          m[p].isRemoved || ($ = Math.max(0, p - 1)), p++;
        for (; p < m.length; ) {
          if (!m[p].isRemoved) {
            y = p - 1;
            break;
          }
          p++;
        }
        $ === void 0 && y === void 0 && ($ = 0), $ >= 0 && $ < d.current.length ? Ae(d.current[$]) : y >= 0 && y < d.current.length && Ae(d.current[y]);
      }
    s.current = t.visibleToasts;
  }, [
    t.visibleToasts,
    n
  ]);
  let f = T(null), { focusWithinProps: h } = ft({
    onFocusWithin: (m) => {
      i.current = !0, f.current = m.relatedTarget, u();
    },
    onBlurWithin: () => {
      i.current = !1, f.current = null, u();
    }
  });
  return ee(() => {
    t.visibleToasts.length === 0 && f.current?.isConnected && (vt() === "pointer" ? Ae(f.current) : f.current.focus(), f.current = null);
  }, [
    n,
    t.visibleToasts.length
  ]), ee(() => () => {
    f.current?.isConnected && (vt() === "pointer" ? Ae(f.current) : f.current.focus(), f.current = null);
  }, [
    n
  ]), {
    regionProps: z(a, o, h, {
      tabIndex: -1,
      // Mark the toast region as a "top layer", so that it:
      //   - is not aria-hidden when opening an overlay
      //   - allows focus even outside a containing focus scope
      //   - doesn’t dismiss overlays when clicking on it, even though it is outside
      // @ts-ignore
      "data-react-aria-top-layer": !0,
      // listen to focus events separate from focuswithin because that will only fire once
      // and we need to follow all focus changes
      onFocus: (m) => {
        let b = W(m).closest('[role="alertdialog"]');
        c.current = d.current.findIndex((p) => p === b);
      },
      onBlur: () => {
        c.current = -1;
      }
    })
  };
}
function b9(e) {
  let t = X((a) => e.subscribe(a), [
    e
  ]), n = X(() => e.visibleToasts, [
    e
  ]);
  return {
    visibleToasts: Eu.useSyncExternalStore(t, n, n),
    add: (a, l) => e.add(a, l),
    close: (a) => e.close(a),
    pauseAll: () => e.pauseAll(),
    resumeAll: () => e.resumeAll()
  };
}
class sP {
  constructor(t) {
    this.queue = [], this.subscriptions = /* @__PURE__ */ new Set(), this.visibleToasts = [], this.maxVisibleToasts = t?.maxVisibleToasts ?? 1 / 0, this.wrapUpdate = t?.wrapUpdate;
  }
  runWithWrapUpdate(t, n) {
    this.wrapUpdate ? this.wrapUpdate(t, n) : t();
  }
  /** Subscribes to updates to the visible toasts. */
  subscribe(t) {
    return this.subscriptions.add(t), () => this.subscriptions.delete(t);
  }
  /** Adds a new toast to the queue. */
  add(t, n = {}) {
    let r = "_" + Math.random().toString(36).slice(2), a = {
      ...n,
      content: t,
      key: r,
      timer: n.timeout ? new p9(() => this.close(r), n.timeout) : void 0
    };
    return this.queue.unshift(a), this.updateVisibleToasts("add"), r;
  }
  /**
  * Closes a toast.
  */
  close(t) {
    let n = this.queue.findIndex((r) => r.key === t);
    n >= 0 && (this.queue[n].onClose?.(), this.queue.splice(n, 1)), this.updateVisibleToasts("remove");
  }
  updateVisibleToasts(t) {
    this.visibleToasts = this.queue.slice(0, this.maxVisibleToasts), this.runWithWrapUpdate(() => {
      for (let n of this.subscriptions) n();
    }, t);
  }
  /** Pauses the timers for all visible toasts. */
  pauseAll() {
    for (let t of this.visibleToasts) t.timer && t.timer.pause();
  }
  /** Resumes the timers for all visible toasts. */
  resumeAll() {
    for (let t of this.visibleToasts) t.timer && t.timer.resume();
  }
  clear() {
    this.queue = [], this.updateVisibleToasts("clear");
  }
}
class p9 {
  constructor(t, n) {
    this.startTime = null, this.remaining = n, this.callback = t;
  }
  reset(t) {
    this.remaining = t, this.resume();
  }
  pause() {
    this.timerId != null && (clearTimeout(this.timerId), this.timerId = null, this.remaining -= Date.now() - this.startTime);
  }
  resume() {
    this.remaining <= 0 || (this.startTime = Date.now(), this.timerId = setTimeout(() => {
      this.timerId = null, this.remaining = 0, this.callback();
    }, this.remaining));
  }
}
const wo = /* @__PURE__ */ G(null), dP = /* @__PURE__ */ te(function(t, n) {
  let r = Ct(), a = b9(t.queue), l = $e(n), { regionProps: i } = m9(t, a, l), { focusProps: u, isFocused: o, isFocusVisible: d } = ye(), { hoverProps: s, isHovered: c } = De({}), f = le({
    ...t,
    children: void 0,
    defaultClassName: "react-aria-ToastRegion",
    values: {
      visibleToasts: a.visibleToasts,
      isHovered: c,
      isFocused: o,
      isFocusVisible: d
    }
  }), { direction: h } = de(), m, { getContainer: b } = so();
  r || (m = document.body, b && (m = b()));
  let p = J(t, {
    global: !0
  }), y = /* @__PURE__ */ g.createElement(wo.Provider, {
    value: a
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(p, f, i, u, s),
    dir: h,
    ref: l,
    "data-hovered": c || void 0,
    "data-focused": o || void 0,
    "data-focus-visible": d || void 0
  }, typeof t.children == "function" ? /* @__PURE__ */ g.createElement(g9, {
    ...t,
    render: void 0,
    className: void 0,
    style: {
      display: "contents"
    }
  }, t.children) : t.children));
  return a.visibleToasts.length > 0 && m ? /* @__PURE__ */ zd(y, m) : null;
}), g9 = /* @__PURE__ */ te(function(t, n) {
  let r = O(wo), { hoverProps: a, isHovered: l } = De({}), i = le({
    ...t,
    children: void 0,
    defaultClassName: "react-aria-ToastList",
    values: {
      visibleToasts: r.visibleToasts,
      isFocused: !1,
      isFocusVisible: !1,
      isHovered: l
    }
  });
  return /* @__PURE__ */ g.createElement(Q.ol, {
    ...a,
    ...i,
    ref: n
  }, r.visibleToasts.map((u) => /* @__PURE__ */ g.createElement("li", {
    key: u.key,
    style: {
      display: "contents"
    }
  }, t.children({
    toast: u
  }))));
}), cP = /* @__PURE__ */ te(function(t, n) {
  let r = O(wo), a = $e(n), { toastProps: l, contentProps: i, titleProps: u, descriptionProps: o, closeButtonProps: d } = o9(t, r, a), { focusProps: s, isFocused: c, isFocusVisible: f } = ye(), h = le({
    ...t,
    defaultClassName: "react-aria-Toast",
    values: {
      toast: t.toast,
      isFocused: c,
      isFocusVisible: f
    }
  }), m = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(m, h, l, s),
    ref: a,
    "data-focused": c || void 0,
    "data-focus-visible": f || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Rv,
        i
      ],
      [
        We,
        {
          slots: {
            [$t]: {},
            title: u,
            description: o
          }
        }
      ],
      [
        Xe,
        {
          slots: {
            [$t]: {},
            close: d
          }
        }
      ]
    ]
  }, h.children));
}), Rv = /* @__PURE__ */ G({}), fP = /* @__PURE__ */ te(function(t, n) {
  return [t, n] = oe(t, n, Rv), /* @__PURE__ */ g.createElement(Q.div, {
    render: t.render,
    className: "react-aria-ToastContent",
    ...t,
    ref: n
  }, t.children);
});
function Tv(e, t, n) {
  const { isSelected: r } = t, { isPressed: a, buttonProps: l } = Hf({
    ...e,
    onPress: st(t.toggle, e.onPress)
  }, n);
  return {
    isPressed: a,
    isSelected: r,
    isDisabled: e.isDisabled || !1,
    buttonProps: z(l, {
      "aria-pressed": r
    })
  };
}
function Iv(e, t) {
  const { "aria-label": n, "aria-labelledby": r, orientation: a = "horizontal" } = e;
  let [l, i] = Y(!1);
  ue(() => {
    i(!!(t.current && t.current.parentElement?.closest('[role="toolbar"]')));
  });
  const { direction: u } = de(), o = u === "rtl" && a === "horizontal";
  let d = Fl(t);
  const s = (m) => {
    if (ae(m.currentTarget, W(m))) {
      if (a === "horizontal" && m.key === "ArrowRight" || a === "vertical" && m.key === "ArrowDown")
        o ? d.focusPrevious() : d.focusNext();
      else if (a === "horizontal" && m.key === "ArrowLeft" || a === "vertical" && m.key === "ArrowUp")
        o ? d.focusNext() : d.focusPrevious();
      else if (m.key === "Tab") {
        c.current = se(), m.shiftKey ? d.focusFirst() : d.focusLast();
        return;
      } else
        return;
      m.stopPropagation(), m.preventDefault();
    }
  }, c = T(null), f = (m) => {
    !ae(m.currentTarget, m.relatedTarget) && !c.current && (c.current = W(m));
  }, h = (m) => {
    c.current && !ae(m.currentTarget, m.relatedTarget) && ae(t.current, W(m)) && (c.current?.focus(), c.current = null);
  };
  return {
    toolbarProps: {
      ...J(e, {
        labelable: !0
      }),
      role: l ? "group" : "toolbar",
      "aria-orientation": a,
      "aria-label": n,
      "aria-labelledby": n == null ? r : void 0,
      onKeyDownCapture: l ? void 0 : s,
      onFocusCapture: l ? void 0 : h,
      onBlurCapture: l ? void 0 : f
    }
  };
}
function y9(e, t, n) {
  let { isDisabled: r } = e, { toolbarProps: a } = Iv(e, n);
  return {
    groupProps: {
      ...a,
      role: t.selectionMode === "single" ? "radiogroup" : a.role,
      "aria-disabled": r
    }
  };
}
function $9(e, t, n) {
  let r = {
    isSelected: t.selectedKeys.has(e.id),
    defaultSelected: !1,
    setSelected(o) {
      t.setSelected(e.id, o);
    },
    toggle() {
      t.toggleKey(e.id);
    }
  }, { isPressed: a, isSelected: l, isDisabled: i, buttonProps: u } = Tv({
    ...e,
    id: void 0,
    isDisabled: e.isDisabled || t.isDisabled
  }, r, n);
  return t.selectionMode === "single" && (u.role = "radio", u["aria-checked"] = r.isSelected, delete u["aria-pressed"]), {
    isPressed: a,
    isSelected: l,
    isDisabled: i,
    buttonProps: u
  };
}
function v9(e) {
  let { selectionMode: t = "single", disallowEmptySelection: n, isDisabled: r = !1 } = e, [a, l] = we(K(() => e.selectedKeys ? new Set(e.selectedKeys) : void 0, [
    e.selectedKeys
  ]), K(() => e.defaultSelectedKeys ? new Set(e.defaultSelectedKeys) : /* @__PURE__ */ new Set(), [
    e.defaultSelectedKeys
  ]), e.onSelectionChange);
  return {
    selectionMode: t,
    isDisabled: r,
    selectedKeys: a,
    setSelectedKeys: l,
    toggleKey(i) {
      let u;
      t === "multiple" ? (u = new Set(a), u.has(i) && (!n || u.size > 1) ? u.delete(i) : u.add(i)) : u = new Set(a.has(i) && !n ? [] : [
        i
      ]), l(u);
    },
    setSelected(i, u) {
      u !== a.has(i) && this.toggleKey(i);
    }
  };
}
const D9 = /* @__PURE__ */ G({}), Mv = /* @__PURE__ */ G(null), hP = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, D9);
  let r = v9(t), { groupProps: a } = y9(t, r, n), l = le({
    ...t,
    values: {
      orientation: t.orientation || "horizontal",
      isDisabled: r.isDisabled,
      state: r
    },
    defaultClassName: "react-aria-ToggleButtonGroup"
  }), i = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(i, l, a),
    ref: n,
    slot: t.slot || void 0,
    "data-orientation": t.orientation || "horizontal",
    "data-disabled": t.isDisabled || void 0
  }, /* @__PURE__ */ g.createElement(Mv.Provider, {
    value: r
  }, /* @__PURE__ */ g.createElement(Wn, null, l.children)));
}), x9 = /* @__PURE__ */ G({}), mP = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, x9);
  let r = O(Mv), a = kl(r && t.id != null ? {
    isSelected: r.selectedKeys.has(t.id),
    onChange(p) {
      r.setSelected(t.id, p);
    }
  } : t), { buttonProps: l, isPressed: i, isSelected: u, isDisabled: o } = r && t.id != null ? $9({
    ...t,
    id: t.id
  }, r, n) : Tv({
    ...t,
    id: t.id != null ? String(t.id) : void 0
  }, a, n), { focusProps: d, isFocused: s, isFocusVisible: c } = ye(t), { hoverProps: f, isHovered: h } = De({
    ...t,
    isDisabled: o
  }), m = le({
    ...t,
    id: void 0,
    values: {
      isHovered: h,
      isPressed: i,
      isFocused: s,
      isSelected: a.isSelected,
      isFocusVisible: c,
      isDisabled: o,
      state: a
    },
    defaultClassName: "react-aria-ToggleButton"
  }), b = J(t, {
    global: !0
  });
  return delete b.id, delete b.onClick, /* @__PURE__ */ g.createElement(Q.button, {
    ...z(b, m, l, d, f),
    ref: n,
    slot: t.slot || void 0,
    "data-focused": s || void 0,
    "data-disabled": o || void 0,
    "data-pressed": i || void 0,
    "data-selected": u || void 0,
    "data-hovered": h || void 0,
    "data-focus-visible": c || void 0
  }, /* @__PURE__ */ g.createElement(Gn.Provider, {
    value: {
      isSelected: u
    }
  }, m.children));
}), E9 = /* @__PURE__ */ G({}), bP = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, E9);
  let { toolbarProps: r } = Iv(t, n), a = le({
    ...t,
    values: {
      orientation: t.orientation || "horizontal"
    },
    defaultClassName: "react-aria-Toolbar"
  }), l = J(t, {
    global: !0
  });
  return delete l.id, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(l, a, r),
    ref: n,
    slot: t.slot || void 0,
    "data-orientation": t.orientation || "horizontal"
  }, a.children);
}), du = /* @__PURE__ */ g.createContext(null);
function C9(e) {
  let { children: t } = e, n = O(du), [r, a] = Y(0), l = K(() => ({
    parent: n,
    modalCount: r,
    addModal() {
      a((i) => i + 1), n && n.addModal();
    },
    removeModal() {
      a((i) => i - 1), n && n.removeModal();
    }
  }), [
    n,
    r
  ]);
  return /* @__PURE__ */ g.createElement(du.Provider, {
    value: l
  }, t);
}
function P9() {
  let e = O(du);
  return {
    modalProviderProps: {
      "aria-hidden": e && e.modalCount > 0 ? !0 : void 0
    }
  };
}
function w9(e) {
  let { modalProviderProps: t } = P9();
  return /* @__PURE__ */ g.createElement("div", {
    "data-overlay-container": !0,
    ...e,
    ...t
  });
}
function S9(e) {
  return /* @__PURE__ */ g.createElement(C9, null, /* @__PURE__ */ g.createElement(w9, e));
}
function k9(e) {
  let t = Ct(), { portalContainer: n = t ? null : document.body, ...r } = e, { getContainer: a } = so();
  if (!e.portalContainer && a && (n = a()), g.useEffect(() => {
    if (n?.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
  }, [
    n
  ]), !n) return null;
  let l = /* @__PURE__ */ g.createElement(S9, r);
  return /* @__PURE__ */ fu.createPortal(l, n);
}
const B9 = 1500, Nd = 500;
let kn = {}, F9 = 0, Vr = !1, Tt = null, Bn = null;
function Kv(e = {}) {
  let { delay: t = B9, closeDelay: n = Nd } = e, { isOpen: r, open: a, close: l } = Fr(e), i = K(() => `${++F9}`, []), u = T(null), o = T(l), d = () => {
    kn[i] = f;
  }, s = () => {
    for (let m in kn) m !== i && (kn[m](!0), delete kn[m]);
  }, c = () => {
    u.current && clearTimeout(u.current), u.current = null, s(), d(), Vr = !0, a(), Tt && (clearTimeout(Tt), Tt = null), Bn && (clearTimeout(Bn), Bn = null);
  }, f = (m) => {
    m || n <= 0 ? (u.current && clearTimeout(u.current), u.current = null, o.current()) : u.current || (u.current = setTimeout(() => {
      u.current = null, o.current();
    }, n)), Tt && (clearTimeout(Tt), Tt = null), Vr && (Bn && clearTimeout(Bn), Bn = setTimeout(() => {
      delete kn[i], Bn = null, Vr = !1;
    }, Math.max(Nd, n)));
  }, h = () => {
    s(), d(), !r && !Vr ? (Tt && clearTimeout(Tt), Tt = setTimeout(() => {
      Tt = null, Vr = !0, c();
    }, t)) : r || c();
  };
  return ee(() => {
    o.current = l;
  }, [
    l
  ]), ee(() => () => {
    u.current && clearTimeout(u.current), kn[i] && delete kn[i];
  }, [
    i
  ]), {
    isOpen: r,
    open: (m) => {
      !m && t > 0 && !u.current ? h() : c();
    },
    close: f
  };
}
function A9(e, t) {
  let n = J(e, {
    labelable: !0
  }), { hoverProps: r } = De({
    onHoverStart: () => t?.open(!0),
    onHoverEnd: () => t?.close()
  });
  return {
    tooltipProps: z(n, r, {
      role: "tooltip"
    })
  };
}
function R9(e, t, n) {
  let { isDisabled: r, trigger: a, shouldCloseOnPress: l = !0 } = e, i = ce(), u = T(!1), o = T(!1), d = () => {
    (u.current || o.current) && t.open(o.current);
  }, s = ($) => {
    !u.current && !o.current && t.close($);
  };
  ee(() => {
    let $ = (v) => {
      n && n.current && v.key === "Escape" && (v.stopPropagation(), t.close(!0));
    };
    if (t.isOpen)
      return document.addEventListener("keydown", $, !0), () => {
        document.removeEventListener("keydown", $, !0);
      };
  }, [
    n,
    t
  ]);
  let c = () => {
    a !== "focus" && (vt() === "pointer" ? u.current = !0 : u.current = !1, d());
  }, f = () => {
    a !== "focus" && (o.current = !1, u.current = !1, s());
  }, h = () => {
    l && (o.current = !1, u.current = !1, s(!0));
  }, m = () => {
    Vt() && (o.current = !0, d());
  }, b = () => {
    o.current = !1, u.current = !1, s(!0);
  }, { hoverProps: p } = De({
    isDisabled: r,
    onHoverStart: c,
    onHoverEnd: f
  }), { focusableProps: y } = ct({
    isDisabled: r,
    onFocus: m,
    onBlur: b
  }, n);
  return {
    triggerProps: {
      "aria-describedby": t.isOpen ? i : void 0,
      ...z(y, p, {
        onPointerDown: h,
        onKeyDown: h
      }),
      tabIndex: void 0
    },
    tooltipProps: {
      id: i
    }
  };
}
const So = /* @__PURE__ */ G(null), Nv = /* @__PURE__ */ G(null);
function pP(e) {
  let t = Kv(e), n = T(null), { triggerProps: r, tooltipProps: a } = R9(e, t, n);
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        So,
        t
      ],
      [
        Nv,
        {
          ...a,
          triggerRef: n
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Z5, {
    ...r,
    ref: n
  }, e.children));
}
const gP = /* @__PURE__ */ te(function({ UNSTABLE_portalContainer: t, ...n }, r) {
  [n, r] = oe(n, r, Nv);
  let a = O(So), l = Kv(n), i = n.isOpen != null || n.defaultOpen != null || !a ? l : a, u = da(r, i.isOpen) || n.isExiting || !1;
  return !i.isOpen && !u ? null : /* @__PURE__ */ g.createElement(k9, {
    portalContainer: t
  }, /* @__PURE__ */ g.createElement(T9, {
    ...n,
    tooltipRef: r,
    isExiting: u
  }));
});
function T9(e) {
  let t = O(So), n = T(null), { overlayProps: r, arrowProps: a, placement: l, triggerAnchorPoint: i } = Qb({
    placement: e.placement || "top",
    targetRef: e.triggerRef,
    overlayRef: e.tooltipRef,
    arrowRef: n,
    offset: e.offset,
    crossOffset: e.crossOffset,
    isOpen: t.isOpen,
    arrowBoundaryOffset: e.arrowBoundaryOffset,
    shouldFlip: e.shouldFlip,
    containerPadding: e.containerPadding,
    onClose: () => t.close(!0)
  }), u = xa(e.tooltipRef, !!l) || e.isEntering || !1, o = le({
    ...e,
    defaultClassName: "react-aria-Tooltip",
    values: {
      placement: l,
      isEntering: u,
      isExiting: e.isExiting,
      state: t
    }
  });
  e = z(e, r);
  let { tooltipProps: d } = A9(e, t), s = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(s, o, d),
    ref: e.tooltipRef,
    style: {
      ...r.style,
      "--trigger-anchor-point": i ? `${i.x}px ${i.y}px` : void 0,
      ...o.style
    },
    "data-placement": l ?? void 0,
    "data-entering": u || void 0,
    "data-exiting": e.isExiting || void 0
  }, /* @__PURE__ */ g.createElement(Yb.Provider, {
    value: {
      ...a,
      placement: l,
      ref: n
    }
  }, o.children));
}
let nr = null;
function I9(e = !1) {
  if (nr === null || e) {
    const t = document.createElement("div"), n = t.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", n.direction = "rtl";
    const r = document.createElement("div"), a = r.style;
    return a.width = "100px", a.height = "100px", t.appendChild(r), document.body.appendChild(t), t.scrollLeft > 0 ? nr = "positive-descending" : (t.scrollLeft = 1, t.scrollLeft === 0 ? nr = "negative" : nr = "positive-ascending"), document.body.removeChild(t), nr;
  }
  return nr;
}
function M9(e, t) {
  let { scrollLeft: n } = e;
  if (t === "rtl") {
    let { scrollWidth: r, clientWidth: a } = e;
    switch (I9()) {
      case "negative":
        n = -n;
        break;
      case "positive-descending":
        n = r - a - n;
        break;
    }
  }
  return n;
}
function K9(e, t) {
  let { contentSize: n, onVisibleRectChange: r, onSizeChange: a, innerStyle: l, onScrollStart: i, onScrollEnd: u, scrollDirection: o = "both", onScroll: d, allowsWindowScrolling: s, ...c } = e, f = T({
    // Internal scroll position of the scroll view.
    scrollPosition: new gt(),
    // Size of the scroll view.
    size: new je(),
    // Offset of the scroll view relative to the window viewport.
    viewportOffset: new gt(),
    // Size of the window viewport.
    viewportSize: new je(),
    scrollEndTime: 0,
    scrollTimeout: null,
    isScrolling: !1,
    lastVisibleRect: new pe()
  }).current, { direction: h } = de(), m = X(() => {
    let V = s ? new pe(f.viewportOffset.x + f.scrollPosition.x, f.viewportOffset.y + f.scrollPosition.y, Math.max(0, Math.min(f.size.width - f.viewportOffset.x, f.viewportSize.width)), Math.max(0, Math.min(f.size.height - f.viewportOffset.y, f.viewportSize.height))) : new pe(f.scrollPosition.x, f.scrollPosition.y, f.size.width, f.size.height);
    (V.area > 0 || f.lastVisibleRect.area > 0) && (r(V), f.lastVisibleRect = V);
  }, [
    f,
    s,
    r
  ]), [b, p] = Y(!1), y = X((V) => {
    let I = W(V);
    if (ae(I, t.current)) {
      if (d && I === t.current && d(V), I !== t.current) {
        let A = t.current.getBoundingClientRect(), U = A.x < 0 ? -A.x : 0, D = A.y < 0 ? -A.y : 0;
        if (U === f.viewportOffset.x && D === f.viewportOffset.y) return;
        f.viewportOffset = new gt(U, D);
      } else {
        let A = I.scrollTop, U = M9(I, h);
        f.scrollPosition = new gt(Math.max(0, Math.min(U, n.width - f.size.width)), Math.max(0, Math.min(A, n.height - f.size.height)));
      }
      lt(() => {
        m(), f.isScrolling || (f.isScrolling = !0, p(!0), window.dispatchEvent(new Event("tk.disconnect-observer")), i && i());
        let A = Date.now();
        f.scrollEndTime <= A + 50 && (f.scrollEndTime = A + 300, f.scrollTimeout != null && clearTimeout(f.scrollTimeout), f.scrollTimeout = setTimeout(() => {
          f.isScrolling = !1, p(!1), f.scrollTimeout = null, window.dispatchEvent(new Event("tk.connect-observer")), u && u();
        }, 300));
      });
    }
  }, [
    d,
    t,
    h,
    f,
    n,
    m,
    i,
    u
  ]);
  ee(() => (document.addEventListener("scroll", y, !0), () => document.removeEventListener("scroll", y, !0)), [
    y
  ]), ee(() => () => {
    f.scrollTimeout != null && clearTimeout(f.scrollTimeout), f.isScrolling && window.dispatchEvent(new Event("tk.connect-observer"));
  }, []);
  let $ = T(!1), v = X((V) => {
    let I = t.current;
    if (!I || $.current) return;
    $.current = !0;
    let A = process.env.NODE_ENV === "test" && !process.env.VIRT_ON, U = Object.getOwnPropertyNames(window.HTMLElement.prototype).includes("clientWidth"), D = Object.getOwnPropertyNames(window.HTMLElement.prototype).includes("clientHeight"), N = I.clientWidth, w = I.clientHeight, R = A && !U ? 1 / 0 : N, H = A && !D ? 1 / 0 : w, k = window.innerWidth, S = window.innerHeight, j = f.viewportSize.width !== k || f.viewportSize.height !== S;
    j && (f.viewportSize = new je(k, S)), (f.size.width !== R || f.size.height !== H || j) && (f.size = new je(R, H), V(() => {
      m(), a?.(f.size);
    }), (!A && N !== I.clientWidth || w !== I.clientHeight) && (f.size = new je(I.clientWidth, I.clientHeight), V(() => {
      m(), a?.(f.size);
    }))), $.current = !1;
  }, [
    t,
    f,
    m,
    a
  ]), x = xe(v);
  ue(() => {
    f.viewportSize = new je(window.innerWidth, window.innerHeight);
    let V = () => {
      x(lt);
    };
    return window.addEventListener("resize", V), () => window.removeEventListener("resize", V);
  }, [
    f
  ]);
  let E = T(null), [P, C] = Y({});
  ue(() => {
    if (!$.current && (E.current == null || !n.equals(E.current)))
      if (
        // @ts-ignore
        typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u"
      ) {
        C({}), E.current = n;
        return;
      } else queueMicrotask(() => x(lt));
    E.current = n;
  }), ue(() => {
    x((V) => V());
  }, [
    P
  ]);
  let M = X(() => {
    v(lt);
  }, [
    v
  ]);
  yr({
    ref: t,
    box: "border-box",
    onResize: M
  });
  let F = {
    // Reset padding so that relative positioning works correctly. Padding will be done in JS layout.
    padding: 0,
    ...c.style
  };
  return o === "horizontal" ? (F.overflowX = "auto", F.overflowY = "hidden") : o === "vertical" || n.width === f.size.width ? (F.overflowY = "auto", F.overflowX = "hidden") : F.overflow = "auto", l = {
    width: Number.isFinite(n.width) ? n.width : void 0,
    height: Number.isFinite(n.height) ? n.height : void 0,
    pointerEvents: b ? "none" : "auto",
    position: "relative",
    ...l
  }, {
    isScrolling: b,
    scrollViewProps: {
      ...c,
      style: F
    },
    contentProps: {
      role: "presentation",
      style: l
    }
  };
}
function N9(e) {
  let { layoutInfo: t, virtualizer: n, ref: r } = e, a = t?.key, l = X(() => {
    if (a != null && r.current) {
      let i = V9(r.current);
      n.updateItemSize(a, i);
    }
  }, [
    n,
    a,
    r
  ]);
  return ue(() => {
    t?.estimatedSize && l();
  }), {
    updateSize: l
  };
}
function V9(e) {
  let t = e.style.height;
  e.style.height = "";
  let n = new je(e.scrollWidth, e.scrollHeight);
  return e.style.height = t, n;
}
function Vv(e) {
  let { style: t, className: n, layoutInfo: r, virtualizer: a, parent: l, children: i } = e, { direction: u } = de(), o = T(null);
  return N9({
    layoutInfo: r,
    virtualizer: a,
    ref: o
  }), /* @__PURE__ */ g.createElement("div", {
    role: "presentation",
    ref: o,
    className: n,
    style: {
      ...L9(r, u, l),
      ...t
    }
  }, i);
}
let Vd = /* @__PURE__ */ new WeakMap();
function L9(e, t, n) {
  let r = t === "rtl" ? "right" : "left", a = Vd.get(e);
  if (a && a[r] != null) {
    if (!n) return a;
    let u = e.rect.y - n.rect.y, o = e.rect.x - n.rect.x;
    if (a.top === u && a[r] === o) return a;
  }
  let l = {
    // TODO: For layoutInfos that are sticky that have parents with overflow visible, their "top" will be relative to the to the nearest scrolling container
    // which WON'T be the parent since the parent has overflow visible. This means we shouldn't offset the height by the parent's position
    // Not 100% about this change here since it is quite ambigious what the scrolling container maybe and how its top is positioned with respect to the
    // calculated layoutInfo.y here
    top: e.rect.y - (n && !(n.allowOverflow && e.isSticky) ? n.rect.y : 0),
    [r]: e.rect.x - (n && !(n.allowOverflow && e.isSticky) ? n.rect.x : 0),
    width: e.rect.width,
    height: e.rect.height
  };
  Object.entries(l).forEach(([u, o]) => {
    Number.isFinite(o) || (l[u] = void 0);
  });
  let i = {
    position: e.isSticky ? "sticky" : "absolute",
    // Sticky elements are positioned in normal document flow. Display inline-block so that they don't push other sticky columns onto the following rows.
    display: e.isSticky ? "inline-block" : void 0,
    overflow: e.allowOverflow ? "visible" : "hidden",
    opacity: e.opacity,
    zIndex: e.zIndex,
    transform: e.transform ?? void 0,
    contain: "size layout style",
    ...l
  };
  return Vd.set(e, i), i;
}
const Lv = /* @__PURE__ */ G(null), zv = /* @__PURE__ */ G(null);
function yP(e) {
  let { children: t, layout: n, layoutOptions: r } = e, a = K(() => typeof n == "function" ? new n() : n, [
    n
  ]), l = K(() => ({
    isVirtualized: !0,
    layoutDelegate: a,
    dropTargetDelegate: a.getDropTargetFromPoint ? a : void 0,
    CollectionRoot: z9,
    CollectionBranch: O9
  }), [
    a
  ]);
  return /* @__PURE__ */ g.createElement(ge.Provider, {
    value: l
  }, /* @__PURE__ */ g.createElement(zv.Provider, {
    value: {
      layout: a,
      layoutOptions: r
    }
  }, t));
}
function z9({ collection: e, persistedKeys: t, scrollRef: n, renderDropIndicator: r }) {
  let { layout: a, layoutOptions: l } = O(zv), i = a.useLayoutOptions?.(), u = O8({
    allowsWindowScrolling: !0,
    layout: a,
    collection: e,
    renderView: (d, s) => s?.render?.(s),
    onVisibleRectChange(d) {
      let s = n?.current;
      s && (s.scrollLeft = d.x, s.scrollTop = d.y);
    },
    persistedKeys: t,
    layoutOptions: K(() => l && i ? {
      ...l,
      ...i
    } : l || i, [
      l,
      i
    ])
  }), { contentProps: o } = K9({
    onVisibleRectChange: u.setVisibleRect,
    onSizeChange: u.setSize,
    contentSize: u.contentSize,
    onScrollStart: u.startScrolling,
    onScrollEnd: u.endScrolling,
    allowsWindowScrolling: !0
  }, n);
  return /* @__PURE__ */ g.createElement("div", o, /* @__PURE__ */ g.createElement(Lv.Provider, {
    value: u
  }, Ov(null, u.visibleViews, r)));
}
function O9({ parent: e, renderDropIndicator: t }) {
  let r = O(Lv).virtualizer.getVisibleView(e.key);
  return Ov(r, Array.from(r.children), t);
}
function Ov(e, t, n) {
  return t.map((r) => H9(e, r, n));
}
function H9(e, t, n) {
  let r = /* @__PURE__ */ g.createElement(Vv, {
    key: t.key,
    layoutInfo: t.layoutInfo,
    virtualizer: t.virtualizer,
    parent: e?.layoutInfo
  }, t.rendered), { collection: a, layout: l } = t.virtualizer, i = t.content;
  return i?.type === "item" && n && l.getDropTargetLayoutInfo && (r = /* @__PURE__ */ g.createElement(g.Fragment, {
    key: t.key
  }, Ld(e, t, {
    type: "item",
    key: t.content.key,
    dropPosition: "before"
  }, n), r, Qc(a, i, (u) => Ld(e, t, u, n)))), r;
}
function Ld(e, t, n, r) {
  let a = r(n);
  if (a) {
    let l = t.virtualizer.layout.getDropTargetLayoutInfo(n);
    a = /* @__PURE__ */ g.createElement(Vv, {
      layoutInfo: l,
      virtualizer: t.virtualizer,
      parent: e?.layoutInfo
    }, a);
  }
  return a;
}
export {
  tn as $,
  _6 as A,
  G6 as B,
  Y6 as C,
  iC as D,
  SC as E,
  g5 as F,
  EC as G,
  CC as H,
  IE as I,
  De as J,
  Je as K,
  aP as L,
  lP as M,
  YC as N,
  XC as O,
  GC as P,
  qC as Q,
  _C as R,
  WC as S,
  Jt as T,
  Ii as U,
  ZC as V,
  UC as W,
  jC as X,
  bP as Y,
  ue as Z,
  yr as _,
  we as a,
  nP as a$,
  E4 as a0,
  de as a1,
  Te as a2,
  na as a3,
  On as a4,
  tC as a5,
  ya as a6,
  w4 as a7,
  u6 as a8,
  rC as a9,
  T2 as aA,
  uC as aB,
  oe as aC,
  et as aD,
  IC as aE,
  MC as aF,
  TC as aG,
  PC as aH,
  bC as aI,
  wC as aJ,
  gC as aK,
  NC as aL,
  VC as aM,
  LC as aN,
  zC as aO,
  yC as aP,
  W9 as aQ,
  wx as aR,
  Ex as aS,
  yP as aT,
  JC as aU,
  OC as aV,
  HC as aW,
  QC as aX,
  eP as aY,
  tP as aZ,
  a5 as a_,
  l6 as aa,
  i6 as ab,
  nC as ac,
  it as ad,
  Et as ae,
  G2 as af,
  Bu as ag,
  iP as ah,
  ce as ai,
  G9 as aj,
  Pt as ak,
  q9 as al,
  J9 as am,
  Y9 as an,
  Z9 as ao,
  _9 as ap,
  gP as aq,
  pP as ar,
  $e as as,
  oC as at,
  SD as au,
  hE as av,
  KC as aw,
  eC as ax,
  wl as ay,
  ke as az,
  cC as b,
  rP as b0,
  pC as b1,
  Z1 as b2,
  uP as b3,
  oP as b4,
  dP as b5,
  sP as b6,
  cP as b7,
  fP as b8,
  mP as b9,
  hP as ba,
  y7 as bb,
  Sr as bc,
  X9 as c,
  r5 as d,
  $C as e,
  vC as f,
  mC as g,
  sC as h,
  Ze as i,
  Q9 as j,
  DC as k,
  dC as l,
  hC as m,
  fC as n,
  kC as o,
  ye as p,
  oa as q,
  z as r,
  RC as s,
  PD as t,
  FC as u,
  AC as v,
  xC as w,
  BC as x,
  aC as y,
  lC as z
};
